/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 202);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return epsilon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return quarterPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return tau; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return degrees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return radians; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return atan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ceil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return exp; });
/* unused harmony export floor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return log; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return pow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return sign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return tan; });
/* harmony export (immutable) */ __webpack_exports__["b"] = acos;
/* harmony export (immutable) */ __webpack_exports__["c"] = asin;
/* harmony export (immutable) */ __webpack_exports__["m"] = haversin;
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;

var degrees = 180 / pi;
var radians = pi / 180;

var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var floor = Math.floor;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sqrt = Math.sqrt;
var tan = Math.tan;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}

function haversin(x) {
  return (x = sin(x / 2)) * x;
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(209);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_create__ = __webpack_require__(334);
/* unused harmony reexport create */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_creator__ = __webpack_require__(41);
/* unused harmony reexport creator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_local__ = __webpack_require__(363);
/* unused harmony reexport local */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_matcher__ = __webpack_require__(131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__src_matcher__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_mouse__ = __webpack_require__(364);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__src_mouse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_namespace__ = __webpack_require__(67);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__src_namespace__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_namespaces__ = __webpack_require__(68);
/* unused harmony reexport namespaces */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_point__ = __webpack_require__(42);
/* unused harmony reexport clientPoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_select__ = __webpack_require__(129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__src_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_selectAll__ = __webpack_require__(365);
/* unused harmony reexport selectAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_selection_index__ = __webpack_require__(6);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_10__src_selection_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_selector__ = __webpack_require__(69);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_11__src_selector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_selectorAll__ = __webpack_require__(130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_12__src_selectorAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_selection_style__ = __webpack_require__(134);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_13__src_selection_style__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_touch__ = __webpack_require__(366);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_14__src_touch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_touches__ = __webpack_require__(367);
/* unused harmony reexport touches */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_window__ = __webpack_require__(70);
/* unused harmony reexport window */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_selection_on__ = __webpack_require__(71);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_17__src_selection_on__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_17__src_selection_on__["a"]; });




















/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_bisect__ = __webpack_require__(117);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["a"]; });
/* unused harmony reexport bisectRight */
/* unused harmony reexport bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ascending__ = __webpack_require__(23);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_bisector__ = __webpack_require__(118);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_cross__ = __webpack_require__(310);
/* unused harmony reexport cross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_descending__ = __webpack_require__(311);
/* unused harmony reexport descending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_deviation__ = __webpack_require__(120);
/* unused harmony reexport deviation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_extent__ = __webpack_require__(122);
/* unused harmony reexport extent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_histogram__ = __webpack_require__(312);
/* unused harmony reexport histogram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__ = __webpack_require__(315);
/* unused harmony reexport thresholdFreedmanDiaconis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__ = __webpack_require__(316);
/* unused harmony reexport thresholdScott */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__ = __webpack_require__(126);
/* unused harmony reexport thresholdSturges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_max__ = __webpack_require__(317);
/* unused harmony reexport max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_mean__ = __webpack_require__(318);
/* unused harmony reexport mean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_median__ = __webpack_require__(319);
/* unused harmony reexport median */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_merge__ = __webpack_require__(320);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_14__src_merge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_min__ = __webpack_require__(127);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_pairs__ = __webpack_require__(119);
/* unused harmony reexport pairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_permute__ = __webpack_require__(321);
/* unused harmony reexport permute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_quantile__ = __webpack_require__(65);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_18__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_range__ = __webpack_require__(124);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_19__src_range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_scan__ = __webpack_require__(322);
/* unused harmony reexport scan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_shuffle__ = __webpack_require__(323);
/* unused harmony reexport shuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_sum__ = __webpack_require__(324);
/* unused harmony reexport sum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_ticks__ = __webpack_require__(125);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_transpose__ = __webpack_require__(128);
/* unused harmony reexport transpose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_variance__ = __webpack_require__(121);
/* unused harmony reexport variance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_zip__ = __webpack_require__(325);
/* unused harmony reexport zip */





























/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = whitespace

var fromCode = String.fromCharCode
var re = /\s/

// Check if the given character code, or the character code at the first
// character, is a whitespace character.
function whitespace(character) {
  return re.test(
    typeof character === 'number' ? fromCode(character) : character.charAt(0)
  )
}


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return root; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Selection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__select__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectAll__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enter__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exit__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__merge__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__order__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sort__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__call__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__nodes__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__node__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__size__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__empty__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__each__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__attr__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__property__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__classed__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__text__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__html__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__raise__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lower__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__append__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__insert__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__remove__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__clone__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__datum__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__on__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__dispatch__ = __webpack_require__(362);































var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection([[document.documentElement]], root);
}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: __WEBPACK_IMPORTED_MODULE_0__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_1__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_2__filter__["a" /* default */],
  data: __WEBPACK_IMPORTED_MODULE_3__data__["a" /* default */],
  enter: __WEBPACK_IMPORTED_MODULE_4__enter__["b" /* default */],
  exit: __WEBPACK_IMPORTED_MODULE_5__exit__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_6__merge__["a" /* default */],
  order: __WEBPACK_IMPORTED_MODULE_7__order__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_8__sort__["a" /* default */],
  call: __WEBPACK_IMPORTED_MODULE_9__call__["a" /* default */],
  nodes: __WEBPACK_IMPORTED_MODULE_10__nodes__["a" /* default */],
  node: __WEBPACK_IMPORTED_MODULE_11__node__["a" /* default */],
  size: __WEBPACK_IMPORTED_MODULE_12__size__["a" /* default */],
  empty: __WEBPACK_IMPORTED_MODULE_13__empty__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_14__each__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_15__attr__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_16__style__["a" /* default */],
  property: __WEBPACK_IMPORTED_MODULE_17__property__["a" /* default */],
  classed: __WEBPACK_IMPORTED_MODULE_18__classed__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_19__text__["a" /* default */],
  html: __WEBPACK_IMPORTED_MODULE_20__html__["a" /* default */],
  raise: __WEBPACK_IMPORTED_MODULE_21__raise__["a" /* default */],
  lower: __WEBPACK_IMPORTED_MODULE_22__lower__["a" /* default */],
  append: __WEBPACK_IMPORTED_MODULE_23__append__["a" /* default */],
  insert: __WEBPACK_IMPORTED_MODULE_24__insert__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_25__remove__["a" /* default */],
  clone: __WEBPACK_IMPORTED_MODULE_26__clone__["a" /* default */],
  datum: __WEBPACK_IMPORTED_MODULE_27__datum__["a" /* default */],
  on: __WEBPACK_IMPORTED_MODULE_28__on__["b" /* default */],
  dispatch: __WEBPACK_IMPORTED_MODULE_29__dispatch__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["b"] = (selection);


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_value__ = __webpack_require__(73);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_array__ = __webpack_require__(141);
/* unused harmony reexport interpolateArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_basis__ = __webpack_require__(76);
/* unused harmony reexport interpolateBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__ = __webpack_require__(139);
/* unused harmony reexport interpolateBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_date__ = __webpack_require__(142);
/* unused harmony reexport interpolateDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_number__ = __webpack_require__(43);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__src_number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_object__ = __webpack_require__(143);
/* unused harmony reexport interpolateObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_round__ = __webpack_require__(372);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__src_round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_string__ = __webpack_require__(144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__src_string__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_transform_index__ = __webpack_require__(373);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_zoom__ = __webpack_require__(376);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_10__src_zoom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_rgb__ = __webpack_require__(138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["a"]; });
/* unused harmony reexport interpolateRgbBasis */
/* unused harmony reexport interpolateRgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_hsl__ = __webpack_require__(377);
/* unused harmony reexport interpolateHsl */
/* unused harmony reexport interpolateHslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_lab__ = __webpack_require__(378);
/* unused harmony reexport interpolateLab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_hcl__ = __webpack_require__(379);
/* unused harmony reexport interpolateHcl */
/* unused harmony reexport interpolateHclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(380);
/* unused harmony reexport interpolateCubehelix */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_quantize__ = __webpack_require__(381);
/* unused harmony reexport quantize */



















/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CREATED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SCHEDULED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STARTING; });
/* unused harmony export STARTED */
/* unused harmony export RUNNING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENDED; });
/* harmony export (immutable) */ __webpack_exports__["g"] = init;
/* harmony export (immutable) */ __webpack_exports__["h"] = set;
/* harmony export (immutable) */ __webpack_exports__["f"] = get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_timer__ = __webpack_require__(44);



var emptyOn = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "end", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

/* harmony default export */ __webpack_exports__["e"] = (function(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
});

function init(node, id) {
  var schedule = get(node, id);
  if (schedule.state > CREATED) throw new Error("too late; already scheduled");
  return schedule;
}

function set(node, id) {
  var schedule = get(node, id);
  if (schedule.state > STARTING) throw new Error("too late; already started");
  return schedule;
}

function get(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["c" /* timer */])(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["b" /* timeout */])(start);

      // Interrupt the active transition, if any.
      // Dispatch the interrupt event.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions. No interrupt event is dispatched
      // because the cancelled transitions never started. Note that this also
      // removes this transition from the pending list!
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["b" /* timeout */])(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(null, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_package__ = __webpack_require__(309);
/* unused harmony reexport version */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_array__ = __webpack_require__(4);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_axis__ = __webpack_require__(326);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_brush__ = __webpack_require__(330);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_chord__ = __webpack_require__(417);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3_collection__ = __webpack_require__(29);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_d3_color__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_d3_dispatch__ = __webpack_require__(17);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_d3_drag__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_d3_dsv__ = __webpack_require__(80);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_d3_ease__ = __webpack_require__(147);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10_d3_ease__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_d3_force__ = __webpack_require__(430);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_d3_format__ = __webpack_require__(85);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_d3_geo__ = __webpack_require__(460);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__ = __webpack_require__(488);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_d3_path__ = __webpack_require__(18);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_d3_polygon__ = __webpack_require__(510);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_d3_quadtree__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_d3_queue__ = __webpack_require__(517);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_d3_random__ = __webpack_require__(520);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_d3_request__ = __webpack_require__(525);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_d3_scale__ = __webpack_require__(532);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_22_d3_scale__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_d3_selection__ = __webpack_require__(2);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_23_d3_selection__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_d3_shape__ = __webpack_require__(565);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_d3_time__ = __webpack_require__(53);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_d3_time_format__ = __webpack_require__(97);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_d3_timer__ = __webpack_require__(44);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_d3_transition__ = __webpack_require__(77);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_d3_voronoi__ = __webpack_require__(590);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_d3_zoom__ = __webpack_require__(595);
/* unused harmony namespace reexport */

































/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_color__ = __webpack_require__(74);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_lab__ = __webpack_require__(370);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__ = __webpack_require__(371);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__["a"]; });





/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projection;
/* harmony export (immutable) */ __webpack_exports__["b"] = projectionMutator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clip_circle__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clip_rectangle__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compose__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rotation__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transform__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fit__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resample__ = __webpack_require__(475);











var transformRadians = Object(__WEBPACK_IMPORTED_MODULE_7__transform__["a" /* transformer */])({
  point: function(x, y) {
    this.stream.point(x * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], y * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */]);
  }
});

function transformRotate(rotate) {
  return Object(__WEBPACK_IMPORTED_MODULE_7__transform__["a" /* transformer */])({
    point: function(x, y) {
      var r = rotate(x, y);
      return this.stream.point(r[0], r[1]);
    }
  });
}

function projection(project) {
  return projectionMutator(function() { return project; })();
}

function projectionMutator(projectAt) {
  var project,
      k = 150, // scale
      x = 480, y = 250, // translate
      dx, dy, lambda = 0, phi = 0, // center
      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
      theta = null, preclip = __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__["a" /* default */], // clip angle
      x0 = null, y0, x1, y1, postclip = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */], // clip extent
      delta2 = 0.5, projectResample = Object(__WEBPACK_IMPORTED_MODULE_9__resample__["a" /* default */])(projectTransform, delta2), // precision
      cache,
      cacheStream;

  function projection(point) {
    point = projectRotate(point[0] * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], point[1] * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */]);
    return [point[0] * k + dx, dy - point[1] * k];
  }

  function invert(point) {
    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
    return point && [point[0] * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], point[1] * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  }

  function projectTransform(x, y) {
    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
  }

  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
  };

  projection.preclip = function(_) {
    return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
  };

  projection.postclip = function(_) {
    return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
  };

  projection.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? Object(__WEBPACK_IMPORTED_MODULE_1__clip_circle__["a" /* default */])(theta = _ * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */]) : (theta = null, __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__["a" /* default */]), reset()) : theta * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */];
  };

  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */]) : Object(__WEBPACK_IMPORTED_MODULE_2__clip_rectangle__["a" /* default */])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  projection.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };

  projection.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };

  projection.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], phi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], recenter()) : [lambda * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], phi * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  };

  projection.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], deltaPhi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], deltaGamma = _.length > 2 ? _[2] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */] : 0, recenter()) : [deltaLambda * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], deltaPhi * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], deltaGamma * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  };

  projection.precision = function(_) {
    return arguments.length ? (projectResample = Object(__WEBPACK_IMPORTED_MODULE_9__resample__["a" /* default */])(projectTransform, delta2 = _ * _), reset()) : Object(__WEBPACK_IMPORTED_MODULE_5__math__["u" /* sqrt */])(delta2);
  };

  projection.fitExtent = function(extent, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["a" /* fitExtent */])(projection, extent, object);
  };

  projection.fitSize = function(size, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["c" /* fitSize */])(projection, size, object);
  };

  projection.fitWidth = function(width, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["d" /* fitWidth */])(projection, width, object);
  };

  projection.fitHeight = function(height, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["b" /* fitHeight */])(projection, height, object);
  };

  function recenter() {
    projectRotate = Object(__WEBPACK_IMPORTED_MODULE_3__compose__["a" /* default */])(rotate = Object(__WEBPACK_IMPORTED_MODULE_6__rotation__["b" /* rotateRadians */])(deltaLambda, deltaPhi, deltaGamma), project);
    var center = project(lambda, phi);
    dx = x - center[0] * k;
    dy = y + center[1] * k;
    return reset();
  }

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return function() {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Transition;
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["b"] = newId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attr__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__attrTween__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__delay__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__duration__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ease__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filter__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__merge__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__on__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__remove__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__select__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectAll__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selection__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styleTween__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__text__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__transition__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tween__ = __webpack_require__(45);



















var id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function transition(name) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* selection */])().transition(name);
}

function newId() {
  return ++id;
}

var selection_prototype = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* selection */].prototype;

Transition.prototype = transition.prototype = {
  constructor: Transition,
  select: __WEBPACK_IMPORTED_MODULE_10__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_11__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_6__filter__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_7__merge__["a" /* default */],
  selection: __WEBPACK_IMPORTED_MODULE_12__selection__["a" /* default */],
  transition: __WEBPACK_IMPORTED_MODULE_16__transition__["a" /* default */],
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: __WEBPACK_IMPORTED_MODULE_8__on__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_1__attr__["a" /* default */],
  attrTween: __WEBPACK_IMPORTED_MODULE_2__attrTween__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_13__style__["a" /* default */],
  styleTween: __WEBPACK_IMPORTED_MODULE_14__styleTween__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_15__text__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_9__remove__["a" /* default */],
  tween: __WEBPACK_IMPORTED_MODULE_17__tween__["a" /* default */],
  delay: __WEBPACK_IMPORTED_MODULE_3__delay__["a" /* default */],
  duration: __WEBPACK_IMPORTED_MODULE_4__duration__["a" /* default */],
  ease: __WEBPACK_IMPORTED_MODULE_5__ease__["a" /* default */]
};


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
function noop() {}


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = prepareMarkDown;
/* harmony export (immutable) */ __webpack_exports__["a"] = createAbstract;
/* harmony export (immutable) */ __webpack_exports__["b"] = formatDate;
/* harmony export (immutable) */ __webpack_exports__["c"] = formatNumber;
function prepareMarkDown(text){return text?text.replace(/\\n\\n/ig,"\n\n").replace(/\\n/ig,"  \n"):"";}function createAbstract(t){var output=t.replace(/\r?\n|\r/g,' ').replace(/^(.{75}[^\s]*).*/,"$1")+'…';return output;}function formatDate(timestamp){var d=new Date(parseFloat(timestamp)*1000);var gg="00"+d.getDate();var mm="00"+(d.getMonth()+1);return gg.substr(gg.length-2)+'/'+mm.substr(mm.length-2);}function formatNumber(n){n=Math.round(n*100)/100;return new Intl.NumberFormat('it-IT',{style:'decimal'}).format(n);}

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_dispatch__ = __webpack_require__(332);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_dispatch__["a"]; });



/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_path__ = __webpack_require__(422);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_path__["a"]; });



/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}

var streamObjectType = {
  Feature: function(object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function(object, stream) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};

var streamGeometryType = {
  Sphere: function(object, stream) {
    stream.sphere();
  },
  Point: function(object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function(object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function(object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function(object, stream) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};

function streamLine(coordinates, stream, closed) {
  var i = -1, n = coordinates.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}

function streamPolygon(coordinates, stream) {
  var i = -1, n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}

/* harmony default export */ __webpack_exports__["a"] = (function(object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
});


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function constant() {
    return x;
  };
});


/***/ }),
/* 22 */
/***/ (function(module, exports) {


exports = module.exports = trim;

function trim(str){
  return str.replace(/^\s*|\s*$/g, '');
}

exports.left = function(str){
  return str.replace(/^\s*/, '');
};

exports.right = function(str){
  return str.replace(/\s*$/, '');
};


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new Adder;
});

function Adder() {
  this.reset();
}

Adder.prototype = {
  constructor: Adder,
  reset: function() {
    this.s = // rounded value
    this.t = 0; // exact error
  },
  add: function(y) {
    add(temp, y, this.t);
    add(this, temp.s, this.s);
    if (this.s) this.t += temp.t;
    else this.s = temp.t;
  },
  valueOf: function() {
    return this.s;
  }
};

var temp = new Adder;

function add(adder, a, b) {
  var x = adder.s = a + b,
      bv = x - a,
      av = x - bv;
  adder.t = (a - av) + (b - bv);
}


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Math.random();
});


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hue;
/* harmony export (immutable) */ __webpack_exports__["b"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(140);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_nest__ = __webpack_require__(423);
/* unused harmony reexport nest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_set__ = __webpack_require__(424);
/* unused harmony reexport set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_map__ = __webpack_require__(79);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_keys__ = __webpack_require__(425);
/* unused harmony reexport keys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_values__ = __webpack_require__(426);
/* unused harmony reexport values */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_entries__ = __webpack_require__(427);
/* unused harmony reexport entries */








/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = spherical;
/* harmony export (immutable) */ __webpack_exports__["a"] = cartesian;
/* harmony export (immutable) */ __webpack_exports__["d"] = cartesianDot;
/* harmony export (immutable) */ __webpack_exports__["c"] = cartesianCross;
/* harmony export (immutable) */ __webpack_exports__["b"] = cartesianAddInPlace;
/* harmony export (immutable) */ __webpack_exports__["f"] = cartesianScale;
/* harmony export (immutable) */ __webpack_exports__["e"] = cartesianNormalizeInPlace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);


function spherical(cartesian) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(cartesian[1], cartesian[0]), Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(cartesian[2])];
}

function cartesian(spherical) {
  var lambda = spherical[0], phi = spherical[1], cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  return [cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda), cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi)];
}

function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// TODO return a
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}

function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}

// TODO return d
function cartesianNormalizeInPlace(d) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = azimuthalRaw;
/* harmony export (immutable) */ __webpack_exports__["a"] = azimuthalInvert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);


function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x),
        cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y),
        k = scale(cx * cy);
    return [
      k * cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x),
      k * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y)
    ];
  }
}

function azimuthalInvert(angle) {
  return function(x, y) {
    var z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + y * y),
        c = angle(z),
        sc = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(c),
        cc = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(c);
    return [
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x * sc, z * cc),
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(z && y * sc / z)
    ];
  }
}


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
});


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = linearish;
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(535);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* ticks */])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* tickIncrement */])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* tickIncrement */])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* tickIncrement */])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateNumber */]);

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, linear());
  };

  return linearish(scale);
}


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
});


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return tau; });
/* harmony export (immutable) */ __webpack_exports__["b"] = acos;
/* harmony export (immutable) */ __webpack_exports__["c"] = asin;
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
});


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return epsilon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return beaches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cells; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return circles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return edges; });
/* harmony export (immutable) */ __webpack_exports__["d"] = Diagram;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Beach__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edge__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__ = __webpack_require__(103);






var epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;

function triangleArea(a, b, c) {
  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}

function lexicographic(a, b) {
  return b[1] - a[1]
      || b[0] - a[0];
}

function Diagram(sites, extent) {
  var site = sites.sort(lexicographic).pop(),
      x,
      y,
      circle;

  edges = [];
  cells = new Array(sites.length);
  beaches = new __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__["b" /* default */];
  circles = new __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__["b" /* default */];

  while (true) {
    circle = __WEBPACK_IMPORTED_MODULE_2__Circle__["c" /* firstCircle */];
    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
      if (site[0] !== x || site[1] !== y) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Beach__["a" /* addBeach */])(site);
        x = site[0], y = site[1];
      }
      site = sites.pop();
    } else if (circle) {
      Object(__WEBPACK_IMPORTED_MODULE_0__Beach__["b" /* removeBeach */])(circle.arc);
    } else {
      break;
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["d" /* sortCellHalfedges */])();

  if (extent) {
    var x0 = +extent[0][0],
        y0 = +extent[0][1],
        x1 = +extent[1][0],
        y1 = +extent[1][1];
    Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["a" /* clipEdges */])(x0, y0, x1, y1);
    Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["b" /* clipCells */])(x0, y0, x1, y1);
  }

  this.edges = edges;
  this.cells = cells;

  beaches =
  circles =
  edges =
  cells = null;
}

Diagram.prototype = {
  constructor: Diagram,

  polygons: function() {
    var edges = this.edges;

    return this.cells.map(function(cell) {
      var polygon = cell.halfedges.map(function(i) { return Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["a" /* cellHalfedgeStart */])(cell, edges[i]); });
      polygon.data = cell.site.data;
      return polygon;
    });
  },

  triangles: function() {
    var triangles = [],
        edges = this.edges;

    this.cells.forEach(function(cell, i) {
      if (!(m = (halfedges = cell.halfedges).length)) return;
      var site = cell.site,
          halfedges,
          j = -1,
          m,
          s0,
          e1 = edges[halfedges[m - 1]],
          s1 = e1.left === site ? e1.right : e1.left;

      while (++j < m) {
        s0 = s1;
        e1 = edges[halfedges[j]];
        s1 = e1.left === site ? e1.right : e1.left;
        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
          triangles.push([site.data, s0.data, s1.data]);
        }
      }
    });

    return triangles;
  },

  links: function() {
    return this.edges.filter(function(edge) {
      return edge.right;
    }).map(function(edge) {
      return {
        source: edge.left.data,
        target: edge.right.data
      };
    });
  },

  find: function(x, y, radius) {
    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;

    // Use the previously-found cell, or start with an arbitrary one.
    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;

    // Traverse the half-edges to find a closer cell, if any.
    do {
      cell = that.cells[i0 = i1], i1 = null;
      cell.halfedges.forEach(function(e) {
        var edge = that.edges[e], v = edge.left;
        if ((v === cell.site || !v) && !(v = edge.right)) return;
        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
        if (v2 < d2) d2 = v2, i1 = v.index;
      });
    } while (i1 !== null);

    that._found = i0;

    return radius == null || d2 <= radius * radius ? cell.site : null;
  }
}


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = decimal

// Check if the given character code, or the character code at the first
// character, is decimal.
function decimal(character) {
  var code = typeof character === 'string' ? character.charCodeAt(0) : character

  return code >= 48 && code <= 57 /* 0-9 */
}


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = visit

var visitParents = __webpack_require__(263)

var CONTINUE = visitParents.CONTINUE
var SKIP = visitParents.SKIP
var EXIT = visitParents.EXIT

visit.CONTINUE = CONTINUE
visit.SKIP = SKIP
visit.EXIT = EXIT

function visit(tree, test, visitor, reverse) {
  if (typeof test === 'function' && typeof visitor !== 'function') {
    reverse = visitor
    visitor = test
    test = null
  }

  visitParents(tree, test, overload, reverse)

  function overload(node, parents) {
    var parent = parents[parents.length - 1]
    var index = parent ? parent.children.indexOf(node) : null
    return visitor(node, index, parent)
  }
}


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__namespaces__ = __webpack_require__(68);



function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" /* xhtml */] && document.documentElement.namespaceURI === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" /* xhtml */]
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
});


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint) {
    var point = svg.createSVGPoint();
    point.x = event.clientX, point.y = event.clientY;
    point = point.matrixTransform(node.getScreenCTM().inverse());
    return [point.x, point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
});


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_timer__ = __webpack_require__(78);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["c"]; });
/* unused harmony reexport timerFlush */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_timeout__ = __webpack_require__(384);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_timeout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_interval__ = __webpack_require__(385);
/* unused harmony reexport interval */







/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tweenValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(8);


function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
});

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(node, id).value[name];
  };
}


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(86);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = rotateRadians;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);



function rotationIdentity(lambda, phi) {
  return [lambda > __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda - __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda + __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda, phi];
}

rotationIdentity.invert = rotationIdentity;

function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */]) ? (deltaPhi || deltaGamma ? Object(__WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */])(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
    : rotationLambda(deltaLambda))
    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
    : rotationIdentity);
}

function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda - __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda + __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda, phi];
  };
}

function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}

function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(deltaPhi),
      sinDeltaPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(deltaPhi),
      cosDeltaGamma = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(deltaGamma),
      sinDeltaGamma = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(deltaGamma);

  function rotation(lambda, phi) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
        x = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(lambda) * cosPhi,
        y = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda) * cosPhi,
        z = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
        k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* asin */])(k * cosDeltaGamma + y * sinDeltaGamma)
    ];
  }

  rotation.invert = function(lambda, phi) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
        x = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(lambda) * cosPhi,
        y = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda) * cosPhi,
        z = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
        k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* asin */])(k * cosDeltaPhi - x * sinDeltaPhi)
    ];
  };

  return rotation;
}

/* harmony default export */ __webpack_exports__["a"] = (function(rotate) {
  rotate = rotateRadians(rotate[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], rotate[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], rotate.length > 2 ? rotate[2] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */] : 0);

  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates;
  }

  forward.invert = function(coordinates) {
    coordinates = rotate.invert(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates;
  };

  return forward;
});


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clipRectangle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffer__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__line__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rejoin__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__(4);






var clipMax = 1e9, clipMin = -clipMax;

// TODO Use d3-polygon’s polygonContains here for the ring check?
// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

function clipRectangle(x0, y0, x1, y1) {

  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }

  function interpolate(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null
        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
        || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }

  function corner(p, direction) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(p[0] - x0) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] ? direction > 0 ? 0 : 3
        : Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(p[0] - x1) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] ? direction > 0 ? 2 : 1
        : Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(p[1] - y0) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] ? direction > 0 ? 1 : 0
        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
  }

  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }

  function comparePoint(a, b) {
    var ca = corner(a, 1),
        cb = corner(b, 1);
    return ca !== cb ? ca - cb
        : ca === 0 ? b[1] - a[1]
        : ca === 1 ? a[0] - b[0]
        : ca === 2 ? a[1] - b[1]
        : b[0] - a[0];
  }

  return function(stream) {
    var activeStream = stream,
        bufferStream = Object(__WEBPACK_IMPORTED_MODULE_1__buffer__["a" /* default */])(),
        segments,
        polygon,
        ring,
        x__, y__, v__, // first point
        x_, y_, v_, // previous point
        first,
        clean;

    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };

    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }

    function polygonInside() {
      var winding = 0;

      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
        }
      }

      return winding;
    }

    // Buffer geometry within a polygon and then clip it en masse.
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }

    function polygonEnd() {
      var startInside = polygonInside(),
          cleanInside = clean && startInside,
          visible = (segments = Object(__WEBPACK_IMPORTED_MODULE_4_d3_array__["d" /* merge */])(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          Object(__WEBPACK_IMPORTED_MODULE_3__rejoin__["a" /* default */])(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }

    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }

    // TODO rather than special-case polygons, simply handle them separately.
    // Ideally, coincident intersection points should be jittered to avoid
    // clipping issues.
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }

    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (Object(__WEBPACK_IMPORTED_MODULE_2__line__["a" /* default */])(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }

    return clipStream;
  };
}


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transformer;
/* unused harmony default export */ var _unused_webpack_default_export = (function(methods) {
  return {
    stream: transformer(methods)
  };
});

function transformer(methods) {
  return function(stream) {
    var s = new TransformStream;
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}

function TransformStream() {}

TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) { this.stream.point(x, y); },
  sphere: function() { this.stream.sphere(); },
  lineStart: function() { this.stream.lineStart(); },
  lineEnd: function() { this.stream.lineEnd(); },
  polygonStart: function() { this.stream.polygonStart(); },
  polygonEnd: function() { this.stream.polygonEnd(); }
};


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
});


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = (function(defaultMimeType, response) {
  return function(url, callback) {
    var r = Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(url).mimeType(defaultMimeType).response(response);
    if (callback != null) {
      if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
      return r.get(callback);
    }
    return r;
  };
});


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["b"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(177);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolate */],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["e" /* interpolateRound */], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_interval__ = __webpack_require__(3);
/* unused harmony reexport timeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_millisecond__ = __webpack_require__(541);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport timeMilliseconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport utcMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_second__ = __webpack_require__(542);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport timeSeconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport utcSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_minute__ = __webpack_require__(543);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__src_minute__["a"]; });
/* unused harmony reexport timeMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_hour__ = __webpack_require__(544);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__src_hour__["a"]; });
/* unused harmony reexport timeHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_day__ = __webpack_require__(545);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__src_day__["a"]; });
/* unused harmony reexport timeDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_week__ = __webpack_require__(546);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["b"]; });
/* unused harmony reexport timeWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["b"]; });
/* unused harmony reexport timeSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
/* unused harmony reexport timeMondays */
/* unused harmony reexport timeTuesday */
/* unused harmony reexport timeTuesdays */
/* unused harmony reexport timeWednesday */
/* unused harmony reexport timeWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["c"]; });
/* unused harmony reexport timeThursdays */
/* unused harmony reexport timeFriday */
/* unused harmony reexport timeFridays */
/* unused harmony reexport timeSaturday */
/* unused harmony reexport timeSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_month__ = __webpack_require__(547);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__src_month__["a"]; });
/* unused harmony reexport timeMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_year__ = __webpack_require__(548);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_8__src_year__["a"]; });
/* unused harmony reexport timeYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__ = __webpack_require__(549);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__["a"]; });
/* unused harmony reexport utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcHour__ = __webpack_require__(550);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcHour__["a"]; });
/* unused harmony reexport utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_utcDay__ = __webpack_require__(551);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__src_utcDay__["a"]; });
/* unused harmony reexport utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__ = __webpack_require__(552);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["b"]; });
/* unused harmony reexport utcWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["b"]; });
/* unused harmony reexport utcSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
/* unused harmony reexport utcMondays */
/* unused harmony reexport utcTuesday */
/* unused harmony reexport utcTuesdays */
/* unused harmony reexport utcWednesday */
/* unused harmony reexport utcWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["c"]; });
/* unused harmony reexport utcThursdays */
/* unused harmony reexport utcFriday */
/* unused harmony reexport utcFridays */
/* unused harmony reexport utcSaturday */
/* unused harmony reexport utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__ = __webpack_require__(553);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__["a"]; });
/* unused harmony reexport utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_utcYear__ = __webpack_require__(554);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_14__src_utcYear__["a"]; });
/* unused harmony reexport utcYears */































/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Linear(context);
});


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Basis;
function point(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = (function(context) {
  return new Basis(context);
});


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Cardinal;
function point(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var xtend = __webpack_require__(12);
var unified = __webpack_require__(231);
var parse = __webpack_require__(244);
var PropTypes = __webpack_require__(108);
var addListMetadata = __webpack_require__(300);
var naiveHtml = __webpack_require__(302);
var disallowNode = __webpack_require__(303);
var astToReact = __webpack_require__(304);
var wrapTableRows = __webpack_require__(305);
var getDefinitions = __webpack_require__(306);
var uriTransformer = __webpack_require__(307);
var defaultRenderers = __webpack_require__(308);

var allTypes = Object.keys(defaultRenderers);

var ReactMarkdown = function ReactMarkdown(props) {
  var src = props.source || props.children || '';

  if (props.allowedTypes && props.disallowedTypes) {
    throw new Error('Only one of `allowedTypes` and `disallowedTypes` should be defined');
  }

  var renderers = xtend(defaultRenderers, props.renderers);

  var plugins = [parse].concat(props.plugins || []);
  var parser = plugins.reduce(applyParserPlugin, unified());

  var rawAst = parser.parse(src);
  var renderProps = xtend(props, {
    renderers: renderers,
    definitions: getDefinitions(rawAst)
  });

  var astPlugins = determineAstPlugins(props);
  var ast = astPlugins.reduce(function (node, plugin) {
    return plugin(node, renderProps);
  }, rawAst);

  return astToReact(ast, renderProps);
};

function applyParserPlugin(parser, plugin) {
  return Array.isArray(plugin) ? parser.use.apply(parser, _toConsumableArray(plugin)) : parser.use(plugin);
}

function determineAstPlugins(props) {
  var plugins = [wrapTableRows, addListMetadata()];

  var disallowedTypes = props.disallowedTypes;
  if (props.allowedTypes) {
    disallowedTypes = allTypes.filter(function (type) {
      return type !== 'root' && props.allowedTypes.indexOf(type) === -1;
    });
  }

  var removalMethod = props.unwrapDisallowed ? 'unwrap' : 'remove';
  if (disallowedTypes && disallowedTypes.length > 0) {
    plugins.push(disallowNode.ofType(disallowedTypes, removalMethod));
  }

  if (props.allowNode) {
    plugins.push(disallowNode.ifNotMatch(props.allowNode, removalMethod));
  }

  var renderHtml = !props.escapeHtml && !props.skipHtml;
  if (renderHtml) {
    plugins.push(naiveHtml);
  }

  return props.astPlugins ? plugins.concat(props.astPlugins) : plugins;
}

ReactMarkdown.defaultProps = {
  renderers: {},
  escapeHtml: true,
  skipHtml: false,
  sourcePos: false,
  rawSourcePos: false,
  transformLinkUri: uriTransformer,
  astPlugins: [],
  plugins: []
};

ReactMarkdown.propTypes = {
  className: PropTypes.string,
  source: PropTypes.string,
  children: PropTypes.string,
  sourcePos: PropTypes.bool,
  rawSourcePos: PropTypes.bool,
  escapeHtml: PropTypes.bool,
  skipHtml: PropTypes.bool,
  allowNode: PropTypes.func,
  allowedTypes: PropTypes.arrayOf(PropTypes.oneOf(allTypes)),
  disallowedTypes: PropTypes.arrayOf(PropTypes.oneOf(allTypes)),
  transformLinkUri: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  linkTarget: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  transformImageUri: PropTypes.func,
  astPlugins: PropTypes.arrayOf(PropTypes.func),
  unwrapDisallowed: PropTypes.bool,
  renderers: PropTypes.object,
  plugins: PropTypes.array
};

ReactMarkdown.types = allTypes;
ReactMarkdown.renderers = defaultRenderers;
ReactMarkdown.uriTransformer = uriTransformer;

module.exports = ReactMarkdown;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var legacy = __webpack_require__(252)
var invalid = __webpack_require__(253)
var decimal = __webpack_require__(39)
var hexadecimal = __webpack_require__(254)
var alphanumerical = __webpack_require__(255)
var decodeEntity = __webpack_require__(256)

module.exports = parseEntities

var own = {}.hasOwnProperty
var fromCharCode = String.fromCharCode
var noop = Function.prototype

// Default settings.
var defaults = {
  warning: null,
  reference: null,
  text: null,
  warningContext: null,
  referenceContext: null,
  textContext: null,
  position: {},
  additional: null,
  attribute: false,
  nonTerminated: true
}

// Characters.
var tab = 9 // '\t'
var lineFeed = 10 // '\n'
var formFeed = 12 //  '\f'
var space = 32 // ' '
var ampersand = 38 //  '&'
var semicolon = 59 //  ';'
var lessThan = 60 //  '<'
var equalsTo = 61 //  '='
var numberSign = 35 //  '#'
var uppercaseX = 88 //  'X'
var lowercaseX = 120 //  'x'
var replacementCharacter = 65533 // '�'

// Reference types.
var name = 'named'
var hexa = 'hexadecimal'
var deci = 'decimal'

// Map of bases.
var bases = {}

bases[hexa] = 16
bases[deci] = 10

// Map of types to tests.
// Each type of character reference accepts different characters.
// This test is used to detect whether a reference has ended (as the semicolon
// is not strictly needed).
var tests = {}

tests[name] = alphanumerical
tests[deci] = decimal
tests[hexa] = hexadecimal

// Warning types.
var namedNotTerminated = 1
var numericNotTerminated = 2
var namedEmpty = 3
var numericEmpty = 4
var namedUnknown = 5
var numericDisallowed = 6
var numericProhibited = 7

// Warning messages.
var messages = {}

messages[namedNotTerminated] =
  'Named character references must be terminated by a semicolon'
messages[numericNotTerminated] =
  'Numeric character references must be terminated by a semicolon'
messages[namedEmpty] = 'Named character references cannot be empty'
messages[numericEmpty] = 'Numeric character references cannot be empty'
messages[namedUnknown] = 'Named character references must be known'
messages[numericDisallowed] =
  'Numeric character references cannot be disallowed'
messages[numericProhibited] =
  'Numeric character references cannot be outside the permissible Unicode range'

// Wrap to ensure clean parameters are given to `parse`.
function parseEntities(value, options) {
  var settings = {}
  var option
  var key

  if (!options) {
    options = {}
  }

  for (key in defaults) {
    option = options[key]
    settings[key] =
      option === null || option === undefined ? defaults[key] : option
  }

  if (settings.position.indent || settings.position.start) {
    settings.indent = settings.position.indent || []
    settings.position = settings.position.start
  }

  return parse(value, settings)
}

// Parse entities.
// eslint-disable-next-line complexity
function parse(value, settings) {
  var additional = settings.additional
  var nonTerminated = settings.nonTerminated
  var handleText = settings.text
  var handleReference = settings.reference
  var handleWarning = settings.warning
  var textContext = settings.textContext
  var referenceContext = settings.referenceContext
  var warningContext = settings.warningContext
  var pos = settings.position
  var indent = settings.indent || []
  var length = value.length
  var index = 0
  var lines = -1
  var column = pos.column || 1
  var line = pos.line || 1
  var queue = ''
  var result = []
  var entityCharacters
  var namedEntity
  var terminated
  var characters
  var character
  var reference
  var following
  var warning
  var reason
  var output
  var entity
  var begin
  var start
  var type
  var test
  var prev
  var next
  var diff
  var end

  if (typeof additional === 'string') {
    additional = additional.charCodeAt(0)
  }

  // Cache the current point.
  prev = now()

  // Wrap `handleWarning`.
  warning = handleWarning ? parseError : noop

  // Ensure the algorithm walks over the first character and the end (inclusive).
  index--
  length++

  while (++index < length) {
    // If the previous character was a newline.
    if (character === lineFeed) {
      column = indent[lines] || 1
    }

    character = value.charCodeAt(index)

    if (character === ampersand) {
      following = value.charCodeAt(index + 1)

      // The behaviour depends on the identity of the next character.
      if (
        following === tab ||
        following === lineFeed ||
        following === formFeed ||
        following === space ||
        following === ampersand ||
        following === lessThan ||
        following !== following ||
        (additional && following === additional)
      ) {
        // Not a character reference.
        // No characters are consumed, and nothing is returned.
        // This is not an error, either.
        queue += fromCharCode(character)
        column++

        continue
      }

      start = index + 1
      begin = start
      end = start

      if (following === numberSign) {
        // Numerical entity.
        end = ++begin

        // The behaviour further depends on the next character.
        following = value.charCodeAt(end)

        if (following === uppercaseX || following === lowercaseX) {
          // ASCII hex digits.
          type = hexa
          end = ++begin
        } else {
          // ASCII digits.
          type = deci
        }
      } else {
        // Named entity.
        type = name
      }

      entityCharacters = ''
      entity = ''
      characters = ''
      test = tests[type]
      end--

      while (++end < length) {
        following = value.charCodeAt(end)

        if (!test(following)) {
          break
        }

        characters += fromCharCode(following)

        // Check if we can match a legacy named reference.
        // If so, we cache that as the last viable named reference.
        // This ensures we do not need to walk backwards later.
        if (type === name && own.call(legacy, characters)) {
          entityCharacters = characters
          entity = legacy[characters]
        }
      }

      terminated = value.charCodeAt(end) === semicolon

      if (terminated) {
        end++

        namedEntity = type === name ? decodeEntity(characters) : false

        if (namedEntity) {
          entityCharacters = characters
          entity = namedEntity
        }
      }

      diff = 1 + end - start

      if (!terminated && !nonTerminated) {
        // Empty.
      } else if (!characters) {
        // An empty (possible) entity is valid, unless it’s numeric (thus an
        // ampersand followed by an octothorp).
        if (type !== name) {
          warning(numericEmpty, diff)
        }
      } else if (type === name) {
        // An ampersand followed by anything unknown, and not terminated, is
        // invalid.
        if (terminated && !entity) {
          warning(namedUnknown, 1)
        } else {
          // If theres something after an entity name which is not known, cap
          // the reference.
          if (entityCharacters !== characters) {
            end = begin + entityCharacters.length
            diff = 1 + end - begin
            terminated = false
          }

          // If the reference is not terminated, warn.
          if (!terminated) {
            reason = entityCharacters ? namedNotTerminated : namedEmpty

            if (settings.attribute) {
              following = value.charCodeAt(end)

              if (following === equalsTo) {
                warning(reason, diff)
                entity = null
              } else if (alphanumerical(following)) {
                entity = null
              } else {
                warning(reason, diff)
              }
            } else {
              warning(reason, diff)
            }
          }
        }

        reference = entity
      } else {
        if (!terminated) {
          // All non-terminated numeric entities are not rendered, and trigger a
          // warning.
          warning(numericNotTerminated, diff)
        }

        // When terminated and number, parse as either hexadecimal or decimal.
        reference = parseInt(characters, bases[type])

        // Trigger a warning when the parsed number is prohibited, and replace
        // with replacement character.
        if (prohibited(reference)) {
          warning(numericProhibited, diff)
          reference = fromCharCode(replacementCharacter)
        } else if (reference in invalid) {
          // Trigger a warning when the parsed number is disallowed, and replace
          // by an alternative.
          warning(numericDisallowed, diff)
          reference = invalid[reference]
        } else {
          // Parse the number.
          output = ''

          // Trigger a warning when the parsed number should not be used.
          if (disallowed(reference)) {
            warning(numericDisallowed, diff)
          }

          // Stringify the number.
          if (reference > 0xffff) {
            reference -= 0x10000
            output += fromCharCode((reference >>> (10 & 0x3ff)) | 0xd800)
            reference = 0xdc00 | (reference & 0x3ff)
          }

          reference = output + fromCharCode(reference)
        }
      }

      // Found it!
      // First eat the queued characters as normal text, then eat an entity.
      if (reference) {
        flush()

        prev = now()
        index = end - 1
        column += end - start + 1
        result.push(reference)
        next = now()
        next.offset++

        if (handleReference) {
          handleReference.call(
            referenceContext,
            reference,
            {start: prev, end: next},
            value.slice(start - 1, end)
          )
        }

        prev = next
      } else {
        // If we could not find a reference, queue the checked characters (as
        // normal characters), and move the pointer to their end.
        // This is possible because we can be certain neither newlines nor
        // ampersands are included.
        characters = value.slice(start - 1, end)
        queue += characters
        column += characters.length
        index = end - 1
      }
    } else {
      // Handle anything other than an ampersand, including newlines and EOF.
      if (
        character === 10 // Line feed
      ) {
        line++
        lines++
        column = 0
      }

      if (character === character) {
        queue += fromCharCode(character)
        column++
      } else {
        flush()
      }
    }
  }

  // Return the reduced nodes, and any possible warnings.
  return result.join('')

  // Get current position.
  function now() {
    return {
      line: line,
      column: column,
      offset: index + (pos.offset || 0)
    }
  }

  // “Throw” a parse-error: a warning.
  function parseError(code, offset) {
    var position = now()

    position.column += offset
    position.offset += offset

    handleWarning.call(warningContext, messages[code], position, code)
  }

  // Flush `queue` (normal text).
  // Macro invoked before each entity and at the end of `value`.
  // Does nothing when `queue` is empty.
  function flush() {
    if (queue) {
      result.push(queue)

      if (handleText) {
        handleText.call(textContext, queue, {start: prev, end: now()})
      }

      queue = ''
    }
  }
}

// Check if `character` is outside the permissible unicode range.
function prohibited(code) {
  return (code >= 0xd800 && code <= 0xdfff) || code > 0x10ffff
}

// Check if `character` is disallowed.
function disallowed(code) {
  return (
    (code >= 0x0001 && code <= 0x0008) ||
    code === 0x000b ||
    (code >= 0x000d && code <= 0x001f) ||
    (code >= 0x007f && code <= 0x009f) ||
    (code >= 0xfdd0 && code <= 0xfdef) ||
    (code & 0xffff) === 0xffff ||
    (code & 0xffff) === 0xfffe
  )
}


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */



/**
 * Results cache
 */

var res = '';
var cache;

/**
 * Expose `repeat`
 */

module.exports = repeat;

/**
 * Repeat the given `string` the specified `number`
 * of times.
 *
 * **Example:**
 *
 * ```js
 * var repeat = require('repeat-string');
 * repeat('A', 5);
 * //=> AAAAA
 * ```
 *
 * @param {String} `string` The string to repeat
 * @param {Number} `number` The number of times to repeat the string
 * @return {String} Repeated string
 * @api public
 */

function repeat(str, num) {
  if (typeof str !== 'string') {
    throw new TypeError('expected a string');
  }

  // cover common, quick use cases
  if (num === 1) return str;
  if (num === 2) return str + str;

  var max = str.length * num;
  if (cache !== str || typeof cache === 'undefined') {
    cache = str;
    res = '';
  } else if (res.length >= max) {
    return res.substr(0, max);
  }

  while (max > res.length && num > 1) {
    if (num & 1) {
      res += str;
    }

    num >>= 1;
    str += str;
  }

  res += str;
  res = res.substr(0, max);
  return res;
}


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = trimTrailingLines

// Remove final newline characters from `value`.
function trimTrailingLines(value) {
  return String(value).replace(/\n+$/, '')
}


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = interrupt;

function interrupt(interruptors, tokenizers, ctx, params) {
  var bools = ['pedantic', 'commonmark'];
  var count = bools.length;
  var length = interruptors.length;
  var index = -1;
  var interruptor;
  var config;
  var fn;
  var offset;
  var bool;
  var ignore;

  while (++index < length) {
    interruptor = interruptors[index];
    config = interruptor[1] || {};
    fn = interruptor[0];
    offset = -1;
    ignore = false;

    while (++offset < count) {
      bool = bools[offset];

      if (config[bool] !== undefined && config[bool] !== ctx.options[bool]) {
        ignore = true;
        break;
      }
    }

    if (ignore) {
      continue;
    }

    if (tokenizers[fn].apply(ctx, params)) {
      return true;
    }
  }

  return false;
}


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var collapseWhiteSpace = __webpack_require__(276);

module.exports = normalize;

/* Normalize an identifier.  Collapses multiple white space
 * characters into a single space, and removes casing. */
function normalize(value) {
  return collapseWhiteSpace(value).toLowerCase();
}


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_drag__ = __webpack_require__(333);
/* unused harmony reexport drag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_nodrag__ = __webpack_require__(135);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_nodrag__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_nodrag__["b"]; });




/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespaces__ = __webpack_require__(68);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" /* default */].hasOwnProperty(prefix) ? {space: __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" /* default */][prefix], local: name} : name;
});


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return xhtml; });
var xhtml = "http://www.w3.org/1999/xhtml";

/* harmony default export */ __webpack_exports__["a"] = ({
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
});


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function none() {}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
});


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
});


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return event; });
/* harmony export (immutable) */ __webpack_exports__["a"] = customEvent;
var filterEvents = {};

var event = null;

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!("onmouseenter" in element)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = event; // Events can be reentrant (e.g., focus).
    event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      event = event0;
    }
  };
}

function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

/* harmony default export */ __webpack_exports__["b"] = (function(typename, value, capture) {
  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
});

function customEvent(event1, listener, that, args) {
  var event0 = event;
  event1.sourceEvent = event;
  event = event1;
  try {
    return listener.apply(that, args);
  } finally {
    event = event0;
  }
}


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_on__ = __webpack_require__(71);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var current = __WEBPACK_IMPORTED_MODULE_0__selection_on__["c" /* event */], source;
  while (source = current.sourceEvent) current = source;
  return current;
});


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(140);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? Object(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["e"] = color;
/* harmony export (immutable) */ __webpack_exports__["h"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["b"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(75);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["b"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_selection_index__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_transition_index__ = __webpack_require__(14);
/* unused harmony reexport transition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_active__ = __webpack_require__(413);
/* unused harmony reexport active */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_interrupt__ = __webpack_require__(145);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__src_interrupt__["a"]; });






/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = now;
/* harmony export (immutable) */ __webpack_exports__["a"] = Timer;
/* harmony export (immutable) */ __webpack_exports__["c"] = timer;
/* unused harmony export timerFlush */
var frame = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_dsv__ = __webpack_require__(81);
/* unused harmony reexport dsvFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_csv__ = __webpack_require__(428);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_csv__["a"]; });
/* unused harmony reexport csvParseRows */
/* unused harmony reexport csvFormat */
/* unused harmony reexport csvFormatRows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_tsv__ = __webpack_require__(429);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__src_tsv__["a"]; });
/* unused harmony reexport tsvParseRows */
/* unused harmony reexport tsvFormat */
/* unused harmony reexport tsvFormatRows */





/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var EOL = {},
    EOF = {},
    QUOTE = 34,
    NEWLINE = 10,
    RETURN = 13;

function objectConverter(columns) {
  return new Function("d", "return {" + columns.map(function(name, i) {
    return JSON.stringify(name) + ": d[" + i + "]";
  }).join(",") + "}");
}

function customConverter(columns, f) {
  var object = objectConverter(columns);
  return function(row, i) {
    return f(object(row), i, columns);
  };
}

// Compute unique columns in order of discovery.
function inferColumns(rows) {
  var columnSet = Object.create(null),
      columns = [];

  rows.forEach(function(row) {
    for (var column in row) {
      if (!(column in columnSet)) {
        columns.push(columnSet[column] = column);
      }
    }
  });

  return columns;
}

/* harmony default export */ __webpack_exports__["a"] = (function(delimiter) {
  var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
      DELIMITER = delimiter.charCodeAt(0);

  function parse(text, f) {
    var convert, columns, rows = parseRows(text, function(row, i) {
      if (convert) return convert(row, i - 1);
      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
    });
    rows.columns = columns || [];
    return rows;
  }

  function parseRows(text, f) {
    var rows = [], // output rows
        N = text.length,
        I = 0, // current character index
        n = 0, // current line number
        t, // current token
        eof = N <= 0, // current token followed by EOF?
        eol = false; // current token followed by EOL?

    // Strip the trailing newline.
    if (text.charCodeAt(N - 1) === NEWLINE) --N;
    if (text.charCodeAt(N - 1) === RETURN) --N;

    function token() {
      if (eof) return EOF;
      if (eol) return eol = false, EOL;

      // Unescape quotes.
      var i, j = I, c;
      if (text.charCodeAt(j) === QUOTE) {
        while (I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
        if ((i = I) >= N) eof = true;
        else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
        return text.slice(j + 1, i - 1).replace(/""/g, "\"");
      }

      // Find next delimiter or newline.
      while (I < N) {
        if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
        else if (c !== DELIMITER) continue;
        return text.slice(j, i);
      }

      // Return last token before EOF.
      return eof = true, text.slice(j, N);
    }

    while ((t = token()) !== EOF) {
      var row = [];
      while (t !== EOL && t !== EOF) row.push(t), t = token();
      if (f && (row = f(row, n++)) == null) continue;
      rows.push(row);
    }

    return rows;
  }

  function format(rows, columns) {
    if (columns == null) columns = inferColumns(rows);
    return [columns.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
      return columns.map(function(column) {
        return formatValue(row[column]);
      }).join(delimiter);
    })).join("\n");
  }

  function formatRows(rows) {
    return rows.map(formatRow).join("\n");
  }

  function formatRow(row) {
    return row.map(formatValue).join(delimiter);
  }

  function formatValue(text) {
    return text == null ? ""
        : reFormat.test(text += "") ? "\"" + text.replace(/"/g, "\"\"") + "\""
        : text;
  }

  return {
    parse: parse,
    parseRows: parseRows,
    format: format,
    formatRows: formatRows
  };
});


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return (Math.random() - 0.5) * 1e-6;
});


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_quadtree__ = __webpack_require__(433);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_quadtree__["a"]; });



/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node, x0, y0, x1, y1) {
  this.node = node;
  this.x0 = x0;
  this.y0 = y0;
  this.x1 = x1;
  this.y1 = y1;
});


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(451);
/* unused harmony reexport formatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(150);
/* unused harmony reexport formatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__ = __webpack_require__(151);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__ = __webpack_require__(457);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__ = __webpack_require__(458);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__ = __webpack_require__(459);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__["a"]; });








/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
});


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea__ = __webpack_require__(476);




function conicEqualAreaRaw(y0, y1) {
  var sy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0), n = (sy0 + Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y1)) / 2;

  // Are the parallels symmetrical around the Equator?
  if (Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(n) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) return Object(__WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea__["a" /* cylindricalEqualAreaRaw */])(y0);

  var c = 1 + sy0 * (2 * n - sy0), r0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(c) / n;

  function project(x, y) {
    var r = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(c - 2 * n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y)) / n;
    return [r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x *= n), r0 - r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x)];
  }

  project.invert = function(x, y) {
    var r0y = r0 - y;
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(r0y)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(r0y), Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };

  return project;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicEqualAreaRaw)
      .scale(155.424)
      .center([0, 33.6442]);
});


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conicProjection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(11);



function conicProjection(projectAt) {
  var phi0 = 0,
      phi1 = __WEBPACK_IMPORTED_MODULE_0__math__["o" /* pi */] / 3,
      m = Object(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* projectionMutator */])(projectAt),
      p = m(phi0, phi1);

  p.parallels = function(_) {
    return arguments.length ? m(phi0 = _[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi1 = _[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */]) : [phi0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], phi1 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
  };

  return p;
}


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fitExtent;
/* harmony export (immutable) */ __webpack_exports__["c"] = fitSize;
/* harmony export (immutable) */ __webpack_exports__["d"] = fitWidth;
/* harmony export (immutable) */ __webpack_exports__["b"] = fitHeight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stream__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__path_bounds__ = __webpack_require__(166);



function fit(projection, fitBounds, object) {
  var clip = projection.clipExtent && projection.clipExtent();
  projection.scale(150).translate([0, 0]);
  if (clip != null) projection.clipExtent(null);
  Object(__WEBPACK_IMPORTED_MODULE_0__stream__["a" /* default */])(object, projection.stream(__WEBPACK_IMPORTED_MODULE_1__path_bounds__["a" /* default */]));
  fitBounds(__WEBPACK_IMPORTED_MODULE_1__path_bounds__["a" /* default */].result());
  if (clip != null) projection.clipExtent(clip);
  return projection;
}

function fitExtent(projection, extent, object) {
  return fit(projection, function(b) {
    var w = extent[1][0] - extent[0][0],
        h = extent[1][1] - extent[0][1],
        k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
        x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
        y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}

function fitWidth(projection, width, object) {
  return fit(projection, function(b) {
    var w = +width,
        k = w / (b[1][0] - b[0][0]),
        x = (w - k * (b[1][0] + b[0][0])) / 2,
        y = -k * b[0][1];
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

function fitHeight(projection, height, object) {
  return fit(projection, function(b) {
    var h = +height,
        k = h / (b[1][1] - b[0][1]),
        x = -k * b[0][0],
        y = (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = mercatorRaw;
/* harmony export (immutable) */ __webpack_exports__["a"] = mercatorProjection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rotation__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(11);




function mercatorRaw(lambda, phi) {
  return [lambda, Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + phi) / 2))];
}

mercatorRaw.invert = function(x, y) {
  return [x, 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["k" /* exp */])(y)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */]];
};

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return mercatorProjection(mercatorRaw)
      .scale(961 / __WEBPACK_IMPORTED_MODULE_0__math__["w" /* tau */]);
});

function mercatorProjection(project) {
  var m = Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(project),
      center = m.center,
      scale = m.scale,
      translate = m.translate,
      clipExtent = m.clipExtent,
      x0 = null, y0, x1, y1; // clip extent

  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };

  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };

  m.center = function(_) {
    return arguments.length ? (center(_), reclip()) : center();
  };

  m.clipExtent = function(_) {
    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  function reclip() {
    var k = __WEBPACK_IMPORTED_MODULE_0__math__["o" /* pi */] * scale(),
        t = m(Object(__WEBPACK_IMPORTED_MODULE_1__rotation__["a" /* default */])(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null
        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }

  return reclip();
}


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["b"] = computeHeight;
/* harmony export (immutable) */ __webpack_exports__["a"] = Node;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__count__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eachBefore__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eachAfter__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sum__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sort__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__path__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ancestors__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__descendants__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__leaves__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__links__ = __webpack_require__(500);












function hierarchy(data, children) {
  var root = new Node(data),
      valued = +data.value && (root.value = data.value),
      node,
      nodes = [root],
      child,
      childs,
      i,
      n;

  if (children == null) children = defaultChildren;

  while (node = nodes.pop()) {
    if (valued) node.value = +node.data.value;
    if ((childs = children(node.data)) && (n = childs.length)) {
      node.children = new Array(n);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }

  return root.eachBefore(computeHeight);
}

function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}

function defaultChildren(d) {
  return d.children;
}

function copyData(node) {
  node.data = node.data.data;
}

function computeHeight(node) {
  var height = 0;
  do node.height = height;
  while ((node = node.parent) && (node.height < ++height));
}

function Node(data) {
  this.data = data;
  this.depth =
  this.height = 0;
  this.parent = null;
}

Node.prototype = hierarchy.prototype = {
  constructor: Node,
  count: __WEBPACK_IMPORTED_MODULE_0__count__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_1__each__["a" /* default */],
  eachAfter: __WEBPACK_IMPORTED_MODULE_3__eachAfter__["a" /* default */],
  eachBefore: __WEBPACK_IMPORTED_MODULE_2__eachBefore__["a" /* default */],
  sum: __WEBPACK_IMPORTED_MODULE_4__sum__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_5__sort__["a" /* default */],
  path: __WEBPACK_IMPORTED_MODULE_6__path__["a" /* default */],
  ancestors: __WEBPACK_IMPORTED_MODULE_7__ancestors__["a" /* default */],
  descendants: __WEBPACK_IMPORTED_MODULE_8__descendants__["a" /* default */],
  leaves: __WEBPACK_IMPORTED_MODULE_9__leaves__["a" /* default */],
  links: __WEBPACK_IMPORTED_MODULE_10__links__["a" /* default */],
  copy: node_copy
};


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = optional;
/* harmony export (immutable) */ __webpack_exports__["b"] = required;
function optional(f) {
  return f == null ? null : required(f);
}

function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return phi; });
/* harmony export (immutable) */ __webpack_exports__["c"] = squarifyRatio;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(50);



var phi = (1 + Math.sqrt(5)) / 2;

function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx, dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
    if (row.dice) Object(__WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else Object(__WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */])(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}

/* harmony default export */ __webpack_exports__["a"] = ((function custom(ratio) {

  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
})(phi));


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_dispatch__ = __webpack_require__(17);



/* harmony default export */ __webpack_exports__["a"] = (function(url, callback) {
  var request,
      event = Object(__WEBPACK_IMPORTED_MODULE_1_d3_dispatch__["a" /* dispatch */])("beforesend", "progress", "load", "error"),
      mimeType,
      headers = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])(),
      xhr = new XMLHttpRequest,
      user = null,
      password = null,
      response,
      responseType,
      timeout = 0;

  // If IE does not support CORS, use XDomainRequest.
  if (typeof XDomainRequest !== "undefined"
      && !("withCredentials" in xhr)
      && /^(http(s)?:)?\/\//.test(url)) xhr = new XDomainRequest;

  "onload" in xhr
      ? xhr.onload = xhr.onerror = xhr.ontimeout = respond
      : xhr.onreadystatechange = function(o) { xhr.readyState > 3 && respond(o); };

  function respond(o) {
    var status = xhr.status, result;
    if (!status && hasResponse(xhr)
        || status >= 200 && status < 300
        || status === 304) {
      if (response) {
        try {
          result = response.call(request, xhr);
        } catch (e) {
          event.call("error", request, e);
          return;
        }
      } else {
        result = xhr;
      }
      event.call("load", request, result);
    } else {
      event.call("error", request, o);
    }
  }

  xhr.onprogress = function(e) {
    event.call("progress", request, e);
  };

  request = {
    header: function(name, value) {
      name = (name + "").toLowerCase();
      if (arguments.length < 2) return headers.get(name);
      if (value == null) headers.remove(name);
      else headers.set(name, value + "");
      return request;
    },

    // If mimeType is non-null and no Accept header is set, a default is used.
    mimeType: function(value) {
      if (!arguments.length) return mimeType;
      mimeType = value == null ? null : value + "";
      return request;
    },

    // Specifies what type the response value should take;
    // for instance, arraybuffer, blob, document, or text.
    responseType: function(value) {
      if (!arguments.length) return responseType;
      responseType = value;
      return request;
    },

    timeout: function(value) {
      if (!arguments.length) return timeout;
      timeout = +value;
      return request;
    },

    user: function(value) {
      return arguments.length < 1 ? user : (user = value == null ? null : value + "", request);
    },

    password: function(value) {
      return arguments.length < 1 ? password : (password = value == null ? null : value + "", request);
    },

    // Specify how to convert the response content to a specific type;
    // changes the callback value on "load" events.
    response: function(value) {
      response = value;
      return request;
    },

    // Alias for send("GET", …).
    get: function(data, callback) {
      return request.send("GET", data, callback);
    },

    // Alias for send("POST", …).
    post: function(data, callback) {
      return request.send("POST", data, callback);
    },

    // If callback is non-null, it will be used for error and load events.
    send: function(method, data, callback) {
      xhr.open(method, url, true, user, password);
      if (mimeType != null && !headers.has("accept")) headers.set("accept", mimeType + ",*/*");
      if (xhr.setRequestHeader) headers.each(function(value, name) { xhr.setRequestHeader(name, value); });
      if (mimeType != null && xhr.overrideMimeType) xhr.overrideMimeType(mimeType);
      if (responseType != null) xhr.responseType = responseType;
      if (timeout > 0) xhr.timeout = timeout;
      if (callback == null && typeof data === "function") callback = data, data = null;
      if (callback != null && callback.length === 1) callback = fixCallback(callback);
      if (callback != null) request.on("error", callback).on("load", function(xhr) { callback(null, xhr); });
      event.call("beforesend", request, xhr);
      xhr.send(data == null ? null : data);
      return request;
    },

    abort: function() {
      xhr.abort();
      return request;
    },

    on: function() {
      var value = event.on.apply(event, arguments);
      return value === event ? request : value;
    }
  };

  if (callback != null) {
    if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
    return request.get(callback);
  }

  return request;
});

function fixCallback(callback) {
  return function(error, xhr) {
    callback(error == null ? xhr : null);
  };
}

function hasResponse(xhr) {
  var type = xhr.responseType;
  return type && type !== "text"
      ? xhr.response // null on error
      : xhr.responseText; // "" on error
}


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(98);
/* unused harmony reexport timeFormatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* unused harmony reexport timeParse */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* unused harmony reexport utcParse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(180);
/* unused harmony reexport timeFormatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_isoFormat__ = __webpack_require__(181);
/* unused harmony reexport isoFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_isoParse__ = __webpack_require__(555);
/* unused harmony reexport isoParse */






/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return timeFormat; });
/* unused harmony export timeParse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcParse; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(180);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(100);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(57);



function point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > __WEBPACK_IMPORTED_MODULE_0__math__["f" /* epsilon */]) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > __WEBPACK_IMPORTED_MODULE_0__math__["f" /* epsilon */]) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new __WEBPACK_IMPORTED_MODULE_1__cardinal__["a" /* Cardinal */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = sum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var sums = series.map(sum);
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[a] - sums[b]; });
});

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RedBlackNode;
function RedBlackTree() {
  this._ = null; // root node
}

function RedBlackNode(node) {
  node.U = // parent node
  node.C = // color - true for red, false for black
  node.L = // left node
  node.R = // right node
  node.P = // previous node
  node.N = null; // next node
}

RedBlackTree.prototype = {
  constructor: RedBlackTree,

  insert: function(after, node) {
    var parent, grandpa, uncle;

    if (after) {
      node.P = after;
      node.N = after.N;
      if (after.N) after.N.P = node;
      after.N = node;
      if (after.R) {
        after = after.R;
        while (after.L) after = after.L;
        after.L = node;
      } else {
        after.R = node;
      }
      parent = after;
    } else if (this._) {
      after = RedBlackFirst(this._);
      node.P = null;
      node.N = after;
      after.P = after.L = node;
      parent = after;
    } else {
      node.P = node.N = null;
      this._ = node;
      parent = null;
    }
    node.L = node.R = null;
    node.U = parent;
    node.C = true;

    after = node;
    while (parent && parent.C) {
      grandpa = parent.U;
      if (parent === grandpa.L) {
        uncle = grandpa.R;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.R) {
            RedBlackRotateLeft(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateRight(this, grandpa);
        }
      } else {
        uncle = grandpa.L;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.L) {
            RedBlackRotateRight(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateLeft(this, grandpa);
        }
      }
      parent = after.U;
    }
    this._.C = false;
  },

  remove: function(node) {
    if (node.N) node.N.P = node.P;
    if (node.P) node.P.N = node.N;
    node.N = node.P = null;

    var parent = node.U,
        sibling,
        left = node.L,
        right = node.R,
        next,
        red;

    if (!left) next = right;
    else if (!right) next = left;
    else next = RedBlackFirst(right);

    if (parent) {
      if (parent.L === node) parent.L = next;
      else parent.R = next;
    } else {
      this._ = next;
    }

    if (left && right) {
      red = next.C;
      next.C = node.C;
      next.L = left;
      left.U = next;
      if (next !== right) {
        parent = next.U;
        next.U = node.U;
        node = next.R;
        parent.L = node;
        next.R = right;
        right.U = next;
      } else {
        next.U = parent;
        parent = next;
        node = next.R;
      }
    } else {
      red = node.C;
      node = next;
    }

    if (node) node.U = parent;
    if (red) return;
    if (node && node.C) { node.C = false; return; }

    do {
      if (node === this._) break;
      if (node === parent.L) {
        sibling = parent.R;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateLeft(this, parent);
          sibling = parent.R;
        }
        if ((sibling.L && sibling.L.C)
            || (sibling.R && sibling.R.C)) {
          if (!sibling.R || !sibling.R.C) {
            sibling.L.C = false;
            sibling.C = true;
            RedBlackRotateRight(this, sibling);
            sibling = parent.R;
          }
          sibling.C = parent.C;
          parent.C = sibling.R.C = false;
          RedBlackRotateLeft(this, parent);
          node = this._;
          break;
        }
      } else {
        sibling = parent.L;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateRight(this, parent);
          sibling = parent.L;
        }
        if ((sibling.L && sibling.L.C)
          || (sibling.R && sibling.R.C)) {
          if (!sibling.L || !sibling.L.C) {
            sibling.R.C = false;
            sibling.C = true;
            RedBlackRotateLeft(this, sibling);
            sibling = parent.L;
          }
          sibling.C = parent.C;
          parent.C = sibling.L.C = false;
          RedBlackRotateRight(this, parent);
          node = this._;
          break;
        }
      }
      sibling.C = true;
      node = parent;
      parent = parent.U;
    } while (!node.C);

    if (node) node.C = false;
  }
};

function RedBlackRotateLeft(tree, node) {
  var p = node,
      q = node.R,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.R = q.L;
  if (p.R) p.R.U = p;
  q.L = p;
}

function RedBlackRotateRight(tree, node) {
  var p = node,
      q = node.L,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.L = q.R;
  if (p.L) p.L.U = p;
  q.R = p;
}

function RedBlackFirst(node) {
  while (node.L) node = node.L;
  return node;
}

/* harmony default export */ __webpack_exports__["b"] = (RedBlackTree);


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = createEdge;
/* harmony export (immutable) */ __webpack_exports__["b"] = createBorderEdge;
/* harmony export (immutable) */ __webpack_exports__["d"] = setEdgeEnd;
/* harmony export (immutable) */ __webpack_exports__["a"] = clipEdges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Diagram__ = __webpack_require__(38);


function createEdge(left, right, v0, v1) {
  var edge = [null, null],
      index = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */].push(edge) - 1;
  edge.left = left;
  edge.right = right;
  if (v0) setEdgeEnd(edge, left, right, v0);
  if (v1) setEdgeEnd(edge, right, left, v1);
  __WEBPACK_IMPORTED_MODULE_0__Diagram__["b" /* cells */][left.index].halfedges.push(index);
  __WEBPACK_IMPORTED_MODULE_0__Diagram__["b" /* cells */][right.index].halfedges.push(index);
  return edge;
}

function createBorderEdge(left, v0, v1) {
  var edge = [v0, v1];
  edge.left = left;
  return edge;
}

function setEdgeEnd(edge, left, right, vertex) {
  if (!edge[0] && !edge[1]) {
    edge[0] = vertex;
    edge.left = left;
    edge.right = right;
  } else if (edge.left === right) {
    edge[1] = vertex;
  } else {
    edge[0] = vertex;
  }
}

// Liang–Barsky line clipping.
function clipEdge(edge, x0, y0, x1, y1) {
  var a = edge[0],
      b = edge[1],
      ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?

  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
  return true;
}

function connectEdge(edge, x0, y0, x1, y1) {
  var v1 = edge[1];
  if (v1) return true;

  var v0 = edge[0],
      left = edge.left,
      right = edge.right,
      lx = left[0],
      ly = left[1],
      rx = right[0],
      ry = right[1],
      fx = (lx + rx) / 2,
      fy = (ly + ry) / 2,
      fm,
      fb;

  if (ry === ly) {
    if (fx < x0 || fx >= x1) return;
    if (lx > rx) {
      if (!v0) v0 = [fx, y0];
      else if (v0[1] >= y1) return;
      v1 = [fx, y1];
    } else {
      if (!v0) v0 = [fx, y1];
      else if (v0[1] < y0) return;
      v1 = [fx, y0];
    }
  } else {
    fm = (lx - rx) / (ry - ly);
    fb = fy - fm * fx;
    if (fm < -1 || fm > 1) {
      if (lx > rx) {
        if (!v0) v0 = [(y0 - fb) / fm, y0];
        else if (v0[1] >= y1) return;
        v1 = [(y1 - fb) / fm, y1];
      } else {
        if (!v0) v0 = [(y1 - fb) / fm, y1];
        else if (v0[1] < y0) return;
        v1 = [(y0 - fb) / fm, y0];
      }
    } else {
      if (ly < ry) {
        if (!v0) v0 = [x0, fm * x0 + fb];
        else if (v0[0] >= x1) return;
        v1 = [x1, fm * x1 + fb];
      } else {
        if (!v0) v0 = [x1, fm * x1 + fb];
        else if (v0[0] < x0) return;
        v1 = [x0, fm * x0 + fb];
      }
    }
  }

  edge[0] = v0;
  edge[1] = v1;
  return true;
}

function clipEdges(x0, y0, x1, y1) {
  var i = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */].length,
      edge;

  while (i--) {
    if (!connectEdge(edge = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */][i], x0, y0, x1, y1)
        || !clipEdge(edge, x0, y0, x1, y1)
        || !(Math.abs(edge[0][0] - edge[1][0]) > __WEBPACK_IMPORTED_MODULE_0__Diagram__["f" /* epsilon */]
            || Math.abs(edge[0][1] - edge[1][1]) > __WEBPACK_IMPORTED_MODULE_0__Diagram__["f" /* epsilon */])) {
      delete __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */][i];
    }
  }
}


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(205);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 106 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_consolidated_events__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);





/**
 * Attempts to parse the offset provided as a prop as a percentage. For
 * instance, if the component has been provided with the string "20%" as
 * a value of one of the offset props. If the value matches, then it returns
 * a numeric version of the prop. For instance, "20%" would become `0.2`.
 * If `str` isn't a percentage, then `undefined` will be returned.
 *
 * @param {string} str The value of an offset prop to be converted to a
 *   number.
 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
 *   was not a percentage.
 */
function parseOffsetAsPercentage(str) {
  if (str.slice(-1) === '%') {
    return parseFloat(str.slice(0, -1)) / 100;
  }
}

/**
 * Attempts to parse the offset provided as a prop as a pixel value. If
 * parsing fails, then `undefined` is returned. Three examples of values that
 * will be successfully parsed are:
 * `20`
 * "20px"
 * "20"
 *
 * @param {string|number} str A string of the form "{number}" or "{number}px",
 *   or just a number.
 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
 *   was neither a number nor string ending in "px".
 */
function parseOffsetAsPixels(str) {
  if (!isNaN(parseFloat(str)) && isFinite(str)) {
    return parseFloat(str);
  } else if (str.slice(-2) === 'px') {
    return parseFloat(str.slice(0, -2));
  }
}

/**
 * @param {string|number} offset
 * @param {number} contextHeight
 * @return {number} A number representing `offset` converted into pixels.
 */
function computeOffsetPixels(offset, contextHeight) {
  var pixelOffset = parseOffsetAsPixels(offset);

  if (typeof pixelOffset === 'number') {
    return pixelOffset;
  }

  var percentOffset = parseOffsetAsPercentage(offset);
  if (typeof percentOffset === 'number') {
    return percentOffset * contextHeight;
  }
}

var constants = {
  above: 'above',
  inside: 'inside',
  below: 'below',
  invisible: 'invisible'
};

function debugLog() {
  if (false) {
    console.log(arguments); // eslint-disable-line no-console
  }
}

var errorMessage = '<Waypoint> expected to receive a single React element child.\n\n' + 'See https://goo.gl/LrBNgw for more info.';

/**
 * Raise an error if more that one child was provided to "children"
 *
 * @param {?React.element} children
 * @return {undefined}
 */
function ensureChildrenIsValid(children) {
  if (children) {
    try {
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children);
    } catch (e) {
      throw new Error(errorMessage);
    }
  }
}

/**
 * When an element's type is a string, it represents a DOM node with that tag name
 * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
 *
 * @param {React.element} Component
 * @return {bool} Whether the component is a DOM Element
 */
function isDOMElement(Component) {
  return typeof Component.type === 'string';
}

var errorMessage$1 = '<Waypoint> needs a DOM element to compute boundaries. The child you passed is neither a ' + 'DOM element (e.g. <div>) nor does it use the innerRef prop.\n\n' + 'See https://goo.gl/LrBNgw for more info.';

/**
 * Raise an error if "children" is not a DOM Element and there is no ref provided to Waypoint
 *
 * @param {?React.element} children
 * @param {?HTMLElement} ref
 * @return {undefined}
 */
function ensureRefIsProvidedByChild(children, ref) {
  if (children && !isDOMElement(children) && !ref) {
    throw new Error(errorMessage$1);
  }
}

/**
 * @param {object} bounds An object with bounds data for the waypoint and
 *   scrollable parent
 * @return {string} The current position of the waypoint in relation to the
 *   visible portion of the scrollable parent. One of `constants.above`,
 *   `constants.below`, or `constants.inside`.
 */
function getCurrentPosition(bounds) {
  if (bounds.viewportBottom - bounds.viewportTop === 0) {
    return constants.invisible;
  }

  // top is within the viewport
  if (bounds.viewportTop <= bounds.waypointTop && bounds.waypointTop <= bounds.viewportBottom) {
    return constants.inside;
  }

  // bottom is within the viewport
  if (bounds.viewportTop <= bounds.waypointBottom && bounds.waypointBottom <= bounds.viewportBottom) {
    return constants.inside;
  }

  // top is above the viewport and bottom is below the viewport
  if (bounds.waypointTop <= bounds.viewportTop && bounds.viewportBottom <= bounds.waypointBottom) {
    return constants.inside;
  }

  if (bounds.viewportBottom < bounds.waypointTop) {
    return constants.below;
  }

  if (bounds.waypointTop < bounds.viewportTop) {
    return constants.above;
  }

  return constants.invisible;
}

var timeout = void 0;
var timeoutQueue = [];

function onNextTick(cb) {
  timeoutQueue.push(cb);

  if (!timeout) {
    timeout = setTimeout(function () {
      timeout = null;

      // Drain the timeoutQueue
      var item = void 0;
      // eslint-disable-next-line no-cond-assign
      while (item = timeoutQueue.shift()) {
        item();
      }
    }, 0);
  }

  var isSubscribed = true;

  return function () {
    function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      var index = timeoutQueue.indexOf(cb);
      if (index === -1) {
        return;
      }

      timeoutQueue.splice(index, 1);

      if (!timeoutQueue.length && timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
    }

    return unsubscribe;
  }();
}

function resolveScrollableAncestorProp(scrollableAncestor) {
  // When Waypoint is rendered on the server, `window` is not available.
  // To make Waypoint easier to work with, we allow this to be specified in
  // string form and safely convert to `window` here.
  if (scrollableAncestor === 'window') {
    return global.window;
  }

  return scrollableAncestor;
}

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultProps = {
  topOffset: '0px',
  bottomOffset: '0px',
  horizontal: false,
  onEnter: function () {
    function onEnter() {}

    return onEnter;
  }(),
  onLeave: function () {
    function onLeave() {}

    return onLeave;
  }(),
  onPositionChange: function () {
    function onPositionChange() {}

    return onPositionChange;
  }(),

  fireOnRapidScroll: true
};

// React.PureComponent was added in React 15.3.0
var BaseClass = typeof __WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent : __WEBPACK_IMPORTED_MODULE_0_react___default.a.Component;

// Calls a function when you scroll to the element.

var Waypoint = function (_BaseClass) {
  _inherits(Waypoint, _BaseClass);

  function Waypoint(props) {
    _classCallCheck(this, Waypoint);

    var _this = _possibleConstructorReturn(this, (Waypoint.__proto__ || Object.getPrototypeOf(Waypoint)).call(this, props));

    _this.refElement = function (e) {
      return _this._ref = e;
    };
    return _this;
  }

  _createClass(Waypoint, [{
    key: 'componentWillMount',
    value: function () {
      function componentWillMount() {
        ensureChildrenIsValid(this.props.children);
      }

      return componentWillMount;
    }()
  }, {
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _this2 = this;

        if (!Waypoint.getWindow()) {
          return;
        }

        // this._ref may occasionally not be set at this time. To help ensure that
        // this works smoothly and to avoid layout thrashing, we want to delay the
        // initial execution until the next tick.
        this.cancelOnNextTick = onNextTick(function () {
          _this2.cancelOnNextTick = null;

          // Berofe doing anything, we want to check that this._ref is avaliable in Waypoint
          ensureRefIsProvidedByChild(_this2.props.children, _this2._ref);

          _this2._handleScroll = _this2._handleScroll.bind(_this2);
          _this2.scrollableAncestor = _this2._findScrollableAncestor();

          if (false) {
            debugLog('scrollableAncestor', _this2.scrollableAncestor);
          }

          _this2.scrollEventListenerUnsubscribe = Object(__WEBPACK_IMPORTED_MODULE_1_consolidated_events__["a" /* addEventListener */])(_this2.scrollableAncestor, 'scroll', _this2._handleScroll, { passive: true });

          _this2.resizeEventListenerUnsubscribe = Object(__WEBPACK_IMPORTED_MODULE_1_consolidated_events__["a" /* addEventListener */])(window, 'resize', _this2._handleScroll, { passive: true });

          _this2._handleScroll(null);
        });
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(newProps) {
        ensureChildrenIsValid(newProps.children);
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate() {
        var _this3 = this;

        if (!Waypoint.getWindow()) {
          return;
        }

        if (!this.scrollableAncestor) {
          // The Waypoint has not yet initialized.
          return;
        }

        // The element may have moved, so we need to recompute its position on the
        // page. This happens via handleScroll in a way that forces layout to be
        // computed.
        //
        // We want this to be deferred to avoid forcing layout during render, which
        // causes layout thrashing. And, if we already have this work enqueued, we
        // can just wait for that to happen instead of enqueueing again.
        if (this.cancelOnNextTick) {
          return;
        }

        this.cancelOnNextTick = onNextTick(function () {
          _this3.cancelOnNextTick = null;
          _this3._handleScroll(null);
        });
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        if (!Waypoint.getWindow()) {
          return;
        }

        if (this.scrollEventListenerUnsubscribe) {
          this.scrollEventListenerUnsubscribe();
        }
        if (this.resizeEventListenerUnsubscribe) {
          this.resizeEventListenerUnsubscribe();
        }

        if (this.cancelOnNextTick) {
          this.cancelOnNextTick();
        }
      }

      return componentWillUnmount;
    }()

    /**
     * Traverses up the DOM to find an ancestor container which has an overflow
     * style that allows for scrolling.
     *
     * @return {Object} the closest ancestor element with an overflow style that
     *   allows for scrolling. If none is found, the `window` object is returned
     *   as a fallback.
     */

  }, {
    key: '_findScrollableAncestor',
    value: function () {
      function _findScrollableAncestor() {
        var _props = this.props,
            horizontal = _props.horizontal,
            scrollableAncestor = _props.scrollableAncestor;


        if (scrollableAncestor) {
          return resolveScrollableAncestorProp(scrollableAncestor);
        }

        var node = this._ref;

        while (node.parentNode) {
          node = node.parentNode;

          if (node === document.body) {
            // We've reached all the way to the root node.
            return window;
          }

          var style = window.getComputedStyle(node);
          var overflowDirec = horizontal ? style.getPropertyValue('overflow-x') : style.getPropertyValue('overflow-y');
          var overflow = overflowDirec || style.getPropertyValue('overflow');

          if (overflow === 'auto' || overflow === 'scroll') {
            return node;
          }
        }

        // A scrollable ancestor element was not found, which means that we need to
        // do stuff on window.
        return window;
      }

      return _findScrollableAncestor;
    }()

    /**
     * @param {Object} event the native scroll event coming from the scrollable
     *   ancestor, or resize event coming from the window. Will be undefined if
     *   called by a React lifecyle method
     */

  }, {
    key: '_handleScroll',
    value: function () {
      function _handleScroll(event) {
        if (!this._ref) {
          // There's a chance we end up here after the component has been unmounted.
          return;
        }

        var bounds = this._getBounds();
        var currentPosition = getCurrentPosition(bounds);
        var previousPosition = this._previousPosition;

        if (false) {
          debugLog('currentPosition', currentPosition);
          debugLog('previousPosition', previousPosition);
        }

        // Save previous position as early as possible to prevent cycles
        this._previousPosition = currentPosition;

        if (previousPosition === currentPosition) {
          // No change since last trigger
          return;
        }

        var callbackArg = {
          currentPosition: currentPosition,
          previousPosition: previousPosition,
          event: event,
          waypointTop: bounds.waypointTop,
          waypointBottom: bounds.waypointBottom,
          viewportTop: bounds.viewportTop,
          viewportBottom: bounds.viewportBottom
        };
        this.props.onPositionChange.call(this, callbackArg);

        if (currentPosition === constants.inside) {
          this.props.onEnter.call(this, callbackArg);
        } else if (previousPosition === constants.inside) {
          this.props.onLeave.call(this, callbackArg);
        }

        var isRapidScrollDown = previousPosition === constants.below && currentPosition === constants.above;
        var isRapidScrollUp = previousPosition === constants.above && currentPosition === constants.below;

        if (this.props.fireOnRapidScroll && (isRapidScrollDown || isRapidScrollUp)) {
          // If the scroll event isn't fired often enough to occur while the
          // waypoint was visible, we trigger both callbacks anyway.
          this.props.onEnter.call(this, {
            currentPosition: constants.inside,
            previousPosition: previousPosition,
            event: event,
            waypointTop: bounds.waypointTop,
            waypointBottom: bounds.waypointBottom,
            viewportTop: bounds.viewportTop,
            viewportBottom: bounds.viewportBottom
          });
          this.props.onLeave.call(this, {
            currentPosition: currentPosition,
            previousPosition: constants.inside,
            event: event,
            waypointTop: bounds.waypointTop,
            waypointBottom: bounds.waypointBottom,
            viewportTop: bounds.viewportTop,
            viewportBottom: bounds.viewportBottom
          });
        }
      }

      return _handleScroll;
    }()
  }, {
    key: '_getBounds',
    value: function () {
      function _getBounds() {
        var horizontal = this.props.horizontal;

        var _ref$getBoundingClien = this._ref.getBoundingClientRect(),
            left = _ref$getBoundingClien.left,
            top = _ref$getBoundingClien.top,
            right = _ref$getBoundingClien.right,
            bottom = _ref$getBoundingClien.bottom;

        var waypointTop = horizontal ? left : top;
        var waypointBottom = horizontal ? right : bottom;

        var contextHeight = void 0;
        var contextScrollTop = void 0;
        if (this.scrollableAncestor === window) {
          contextHeight = horizontal ? window.innerWidth : window.innerHeight;
          contextScrollTop = 0;
        } else {
          contextHeight = horizontal ? this.scrollableAncestor.offsetWidth : this.scrollableAncestor.offsetHeight;
          contextScrollTop = horizontal ? this.scrollableAncestor.getBoundingClientRect().left : this.scrollableAncestor.getBoundingClientRect().top;
        }

        if (false) {
          debugLog('waypoint top', waypointTop);
          debugLog('waypoint bottom', waypointBottom);
          debugLog('scrollableAncestor height', contextHeight);
          debugLog('scrollableAncestor scrollTop', contextScrollTop);
        }

        var _props2 = this.props,
            bottomOffset = _props2.bottomOffset,
            topOffset = _props2.topOffset;

        var topOffsetPx = computeOffsetPixels(topOffset, contextHeight);
        var bottomOffsetPx = computeOffsetPixels(bottomOffset, contextHeight);
        var contextBottom = contextScrollTop + contextHeight;

        return {
          waypointTop: waypointTop,
          waypointBottom: waypointBottom,
          viewportTop: contextScrollTop + topOffsetPx,
          viewportBottom: contextBottom - bottomOffsetPx
        };
      }

      return _getBounds;
    }()

    /**
     * @return {Object}
     */

  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this4 = this;

        var children = this.props.children;


        if (!children) {
          // We need an element that we can locate in the DOM to determine where it is
          // rendered relative to the top of its context.
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { ref: this.refElement, style: { fontSize: 0 } });
        }

        if (isDOMElement(children) || Object(__WEBPACK_IMPORTED_MODULE_3_react_is__["isForwardRef"])(children.type)) {
          var ref = function () {
            function ref(node) {
              _this4.refElement(node);
              if (children.ref) {
                if (typeof children.ref === 'function') {
                  children.ref(node);
                } else {
                  children.ref.current = node;
                }
              }
            }

            return ref;
          }();

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, { ref: ref });
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, { innerRef: this.refElement });
      }

      return render;
    }()
  }]);

  return Waypoint;
}(BaseClass);


Waypoint.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
  debug: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  onEnter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onPositionChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  fireOnRapidScroll: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  scrollableAncestor: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  horizontal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

  // `topOffset` can either be a number, in which case its a distance from the
  // top of the container in pixels, or a string value. Valid string values are
  // of the form "20px", which is parsed as pixels, or "20%", which is parsed
  // as a percentage of the height of the containing element.
  // For instance, if you pass "-20%", and the containing element is 100px tall,
  // then the waypoint will be triggered when it has been scrolled 20px beyond
  // the top of the containing element.
  topOffset: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),

  // `bottomOffset` is like `topOffset`, but for the bottom of the container.
  bottomOffset: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number])
};

Waypoint.above = constants.above;
Waypoint.below = constants.below;
Waypoint.inside = constants.inside;
Waypoint.invisible = constants.invisible;
Waypoint.getWindow = function () {
  if (typeof window !== 'undefined') {
    return window;
  }
};
Waypoint.defaultProps = defaultProps;
Waypoint.displayName = 'Waypoint';

/* harmony default export */ __webpack_exports__["a"] = (Waypoint);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(106)))

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(227)();
}


/***/ }),
/* 109 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(109)))

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = alphabetical

// Check if the given character code, or the character code at the first
// character, is alphabetical.
function alphabetical(character) {
  var code = typeof character === 'string' ? character.charCodeAt(0) : character

  return (
    (code >= 97 && code <= 122) /* a-z */ ||
    (code >= 65 && code <= 90) /* A-Z */
  )
}


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  position: true,
  gfm: true,
  commonmark: false,
  footnotes: false,
  pedantic: false,
  blocks: __webpack_require__(260)
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = indentation;

/* Map of characters, and their column length,
 * which can be used as indentation. */
var characters = {' ': 1, '\t': 4};

/* Gets indentation information for a line. */
function indentation(value) {
  var index = 0;
  var indent = 0;
  var character = value.charAt(index);
  var stops = {};
  var size;

  while (character in characters) {
    size = characters[character];

    indent += size;

    if (size > 1) {
      indent = Math.floor(indent / size) * size;
    }

    stops[indent] = index;

    character = value.charAt(++index);
  }

  return {indent: indent, stops: stops};
}


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var attributeName = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
var unquoted = '[^"\'=<>`\\u0000-\\u0020]+';
var singleQuoted = '\'[^\']*\'';
var doubleQuoted = '"[^"]*"';
var attributeValue = '(?:' + unquoted + '|' + singleQuoted + '|' + doubleQuoted + ')';
var attribute = '(?:\\s+' + attributeName + '(?:\\s*=\\s*' + attributeValue + ')?)';
var openTag = '<[A-Za-z][A-Za-z0-9\\-]*' + attribute + '*\\s*\\/?>';
var closeTag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var processing = '<[?].*?[?]>';
var declaration = '<![A-Za-z]+\\s+[^>]*>';
var cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';

exports.openCloseTag = new RegExp('^(?:' + openTag + '|' + closeTag + ')');

exports.tag = new RegExp('^(?:' +
  openTag + '|' +
  closeTag + '|' +
  comment + '|' +
  processing + '|' +
  declaration + '|' +
  cdata +
')');


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('<', fromIndex);
}


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = locate;

function locate(value, fromIndex) {
  var link = value.indexOf('[', fromIndex);
  var image = value.indexOf('![', fromIndex);

  if (image === -1) {
    return link;
  }

  /* Link can never be `-1` if an image is found, so we don’t need
   * to check for that :) */
  return link < image ? link : image;
}


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bisectRight */
/* unused harmony export bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(118);



var ascendingBisect = Object(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["a"] = (bisectRight);


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(23);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pair;
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(121);


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = Object(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["c"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(127);


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = Object(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[document.querySelector(selector)]], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[selector]], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" /* root */]);
});


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function empty() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
});


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var matcher = function(selector) {
  return function() {
    return this.matches(selector);
  };
};

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!element.matches) {
    var vendorMatches = element.webkitMatchesSelector
        || element.msMatchesSelector
        || element.mozMatchesSelector
        || element.oMatchesSelector;
    matcher = function(selector) {
      return function() {
        return vendorMatches.call(this, selector);
      };
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (matcher);


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = EnterNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["b"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._enter || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(update) {
  return new Array(update.length);
});


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = styleValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(70);


function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
});

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || Object(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node).getComputedStyle(node, null).getPropertyValue(name);
}


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = yesdrag;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noevent__ = __webpack_require__(136);



/* harmony default export */ __webpack_exports__["a"] = (function(view) {
  var root = view.document.documentElement,
      selection = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["f" /* select */])(view).on("dragstart.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
  } else {
    root.__noselect = root.style.MozUserSelect;
    root.style.MozUserSelect = "none";
  }
});

function yesdrag(view, noclick) {
  var root = view.document.documentElement,
      selection = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["f" /* select */])(view).on("dragstart.drag", null);
  if (noclick) {
    selection.on("click.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
    setTimeout(function() { selection.on("click.drag", null); }, 0);
  }
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", null);
  } else {
    root.style.MozUserSelect = root.__noselect;
    delete root.__noselect;
  }
}


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nopropagation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(2);


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
});


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rgbBasis */
/* unused harmony export rgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(28);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = Object(__WEBPACK_IMPORTED_MODULE_3__color__["b" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(start)).r, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(76);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return Object(__WEBPACK_IMPORTED_MODULE_0__basis__["a" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(43);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_schedule__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["a"] = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["d" /* STARTING */] && schedule.state < __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["b" /* ENDING */];
    schedule.state = __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["a" /* ENDED */];
    schedule.timer.stop();
    if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
});


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var c;
  return (typeof b === "number" ? __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateNumber */]
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateRgb */]
      : (c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateRgb */])
      : __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["f" /* interpolateString */])(a, b);
});


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_linear__ = __webpack_require__(403);
/* unused harmony reexport easeLinear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_quad__ = __webpack_require__(404);
/* unused harmony reexport easeQuad */
/* unused harmony reexport easeQuadIn */
/* unused harmony reexport easeQuadOut */
/* unused harmony reexport easeQuadInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubic__ = __webpack_require__(405);
/* unused harmony reexport easeCubic */
/* unused harmony reexport easeCubicIn */
/* unused harmony reexport easeCubicOut */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_poly__ = __webpack_require__(406);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__src_poly__["a"]; });
/* unused harmony reexport easePolyIn */
/* unused harmony reexport easePolyOut */
/* unused harmony reexport easePolyInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_sin__ = __webpack_require__(407);
/* unused harmony reexport easeSin */
/* unused harmony reexport easeSinIn */
/* unused harmony reexport easeSinOut */
/* unused harmony reexport easeSinInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_exp__ = __webpack_require__(408);
/* unused harmony reexport easeExp */
/* unused harmony reexport easeExpIn */
/* unused harmony reexport easeExpOut */
/* unused harmony reexport easeExpInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_circle__ = __webpack_require__(409);
/* unused harmony reexport easeCircle */
/* unused harmony reexport easeCircleIn */
/* unused harmony reexport easeCircleOut */
/* unused harmony reexport easeCircleInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_bounce__ = __webpack_require__(410);
/* unused harmony reexport easeBounce */
/* unused harmony reexport easeBounceIn */
/* unused harmony reexport easeBounceOut */
/* unused harmony reexport easeBounceInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_back__ = __webpack_require__(411);
/* unused harmony reexport easeBack */
/* unused harmony reexport easeBackIn */
/* unused harmony reexport easeBackOut */
/* unused harmony reexport easeBackInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_elastic__ = __webpack_require__(412);
/* unused harmony reexport easeElastic */
/* unused harmony reexport easeElasticIn */
/* unused harmony reexport easeElasticOut */
/* unused harmony reexport easeElasticInOut */





















/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sin; });
/* unused harmony export pi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return tau; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return max; });
var cos = Math.cos;
var sin = Math.sin;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = pi * 2;
var max = Math.max;


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_collection__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_timer__ = __webpack_require__(44);




function x(d) {
  return d.x;
}

function y(d) {
  return d.y;
}

var initialRadius = 10,
    initialAngle = Math.PI * (3 - Math.sqrt(5));

/* unused harmony default export */ var _unused_webpack_default_export = (function(nodes) {
  var simulation,
      alpha = 1,
      alphaMin = 0.001,
      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
      alphaTarget = 0,
      velocityDecay = 0.6,
      forces = Object(__WEBPACK_IMPORTED_MODULE_1_d3_collection__["a" /* map */])(),
      stepper = Object(__WEBPACK_IMPORTED_MODULE_2_d3_timer__["c" /* timer */])(step),
      event = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("tick", "end");

  if (nodes == null) nodes = [];

  function step() {
    tick();
    event.call("tick", simulation);
    if (alpha < alphaMin) {
      stepper.stop();
      event.call("end", simulation);
    }
  }

  function tick() {
    var i, n = nodes.length, node;

    alpha += (alphaTarget - alpha) * alphaDecay;

    forces.each(function(force) {
      force(alpha);
    });

    for (i = 0; i < n; ++i) {
      node = nodes[i];
      if (node.fx == null) node.x += node.vx *= velocityDecay;
      else node.x = node.fx, node.vx = 0;
      if (node.fy == null) node.y += node.vy *= velocityDecay;
      else node.y = node.fy, node.vy = 0;
    }
  }

  function initializeNodes() {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.index = i;
      if (isNaN(node.x) || isNaN(node.y)) {
        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
        node.x = radius * Math.cos(angle);
        node.y = radius * Math.sin(angle);
      }
      if (isNaN(node.vx) || isNaN(node.vy)) {
        node.vx = node.vy = 0;
      }
    }
  }

  function initializeForce(force) {
    if (force.initialize) force.initialize(nodes);
    return force;
  }

  initializeNodes();

  return simulation = {
    tick: tick,

    restart: function() {
      return stepper.restart(step), simulation;
    },

    stop: function() {
      return stepper.stop(), simulation;
    },

    nodes: function(_) {
      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
    },

    alpha: function(_) {
      return arguments.length ? (alpha = +_, simulation) : alpha;
    },

    alphaMin: function(_) {
      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
    },

    alphaDecay: function(_) {
      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
    },

    alphaTarget: function(_) {
      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
    },

    velocityDecay: function(_) {
      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
    },

    force: function(name, _) {
      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
    },

    find: function(x, y, radius) {
      var i = 0,
          n = nodes.length,
          dx,
          dy,
          d2,
          node,
          closest;

      if (radius == null) radius = Infinity;
      else radius *= radius;

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        dx = x - node.x;
        dy = y - node.y;
        d2 = dx * dx + dy * dy;
        if (d2 < radius) closest = node, radius = d2;
      }

      return closest;
    },

    on: function(name, _) {
      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
    }
  };
});


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTypes__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__identity__ = __webpack_require__(456);








var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping && locale.thousands ? Object(__WEBPACK_IMPORTED_MODULE_1__formatGroup__["a" /* default */])(locale.grouping, locale.thousands) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? Object(__WEBPACK_IMPORTED_MODULE_2__formatNumerals__["a" /* default */])(locale.numerals) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        type = specifier.type;

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_4__formatTypes__["a" /* default */][type],
        maybeSuffix = !type || /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? (type ? 6 : 12)
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__["b" /* prefixExponent */] / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatTypes__ = __webpack_require__(152);


// [[fill]align][sign][symbol][0][width][,][.precision][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

  var match,
      fill = match[1] || " ",
      align = match[2] || ">",
      sign = match[3] || "-",
      symbol = match[4] || "",
      zero = !!match[5],
      width = match[6] && +match[6],
      comma = !!match[7],
      precision = match[8] && +match[8].slice(1),
      type = match[9] || "";

  // The "n" type is an alias for ",g".
  if (type === "n") comma = true, type = "g";

  // Map invalid types to the default format.
  else if (!__WEBPACK_IMPORTED_MODULE_0__formatTypes__["a" /* default */][type]) type = "";

  // If zero fill is specified, padding goes after sign and before digits.
  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

  this.fill = fill;
  this.align = align;
  this.sign = sign;
  this.symbol = symbol;
  this.zero = zero;
  this.width = width;
  this.comma = comma;
  this.precision = precision;
  this.type = type;
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + this.type;
};


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDefault__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatRounded__ = __webpack_require__(455);




/* harmony default export */ __webpack_exports__["a"] = ({
  "": __WEBPACK_IMPORTED_MODULE_0__formatDefault__["a" /* default */],
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return Object(__WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__["a" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(86);


var prefixExponent;

/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return areaRingSum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return areaStream; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stream__ = __webpack_require__(19);





var areaRingSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])();

var areaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lambda00,
    phi00,
    lambda0,
    cosPhi0,
    sinPhi0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: function() {
    areaRingSum.reset();
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum;
    areaSum.add(areaRing < 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
  },
  sphere: function() {
    areaSum.add(__WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */]);
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaRingEnd() {
  areaPoint(lambda00, phi00);
}

function areaPointFirst(lambda, phi) {
  areaStream.point = areaPoint;
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  lambda0 = lambda, cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math__["q" /* quarterPi */]), sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi);
}

function areaPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math__["q" /* quarterPi */]; // half the angular distance from south pole

  // Spherical excess E for a spherical triangle with vertices: south pole,
  // previous point, current point.  Uses a formula derived from Cagnoli’s
  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
  var dLambda = lambda - lambda0,
      sdLambda = dLambda >= 0 ? 1 : -1,
      adLambda = sdLambda * dLambda,
      cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
      sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
      k = sinPhi0 * sinPhi,
      u = cosPhi0 * cosPhi + k * Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(adLambda),
      v = k * sdLambda * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(adLambda);
  areaRingSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(v, u));

  // Advance the previous points.
  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(object) {
  areaSum.reset();
  Object(__WEBPACK_IMPORTED_MODULE_3__stream__["a" /* default */])(object, areaStream);
  return areaSum * 2;
});


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = circleStream;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rotation__ = __webpack_require__(47);





// Generates a circle centered at [0°, 0°], with a given radius and precision.
function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(radius),
      sinRadius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(radius),
      step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */];
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */];
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* spherical */])([cosRadius, -sinRadius * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(t), -sinRadius * Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(t)]);
    stream.point(point[0], point[1]);
  }
}

// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
  point = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(point), point[0] -= cosRadius;
  Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["e" /* cartesianNormalizeInPlace */])(point);
  var radius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["b" /* acos */])(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */]) % __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var center = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([0, 0]),
      radius = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(90),
      precision = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(6),
      ring,
      rotate,
      stream = {point: point};

  function point(x, y) {
    ring.push(x = rotate(x, y));
    x[0] *= __WEBPACK_IMPORTED_MODULE_2__math__["h" /* degrees */], x[1] *= __WEBPACK_IMPORTED_MODULE_2__math__["h" /* degrees */];
  }

  function circle() {
    var c = center.apply(this, arguments),
        r = radius.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */],
        p = precision.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */];
    ring = [];
    rotate = Object(__WEBPACK_IMPORTED_MODULE_3__rotation__["b" /* rotateRadians */])(-c[0] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */], -c[1] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */], 0).invert;
    circleStream(stream, r, p, 1);
    c = {type: "Polygon", coordinates: [ring]};
    ring = rotate = null;
    return c;
  }

  circle.center = function(_) {
    return arguments.length ? (center = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([+_[0], +_[1]]), circle) : center;
  };

  circle.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), circle) : radius;
  };

  circle.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), circle) : precision;
  };

  return circle;
});


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {

  function compose(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }

  if (a.invert && b.invert) compose.invert = function(x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };

  return compose;
});


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(
  function() { return true; },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], -__WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */]]
));

// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
      phi0 = NaN,
      sign0 = NaN,
      clean; // no intersections

  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */],
          delta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda1 - lambda0);
      if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta - __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */]) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) { // line crosses a pole
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */]);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */]) { // line crosses antimeridian
        if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda0 - sign0) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) lambda0 -= sign0 * __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]; // handle degeneracies
        if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda1 - sign1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) lambda1 -= sign1 * __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */];
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function() {
      return 2 - clean; // if intersections, rejoin first and last segments
    }
  };
}

function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
      cosPhi1,
      sinLambda0Lambda1 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda0 - lambda1);
  return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(sinLambda0Lambda1) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]
      ? Object(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* atan */])((Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi0) * (cosPhi1 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi1)) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda1)
          - Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi1) * (cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi0)) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda0))
          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
      : (phi0 + phi1) / 2;
}

function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * __WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */];
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], phi);
    stream.point(0, phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], 0);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], -phi);
    stream.point(0, -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], 0);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], phi);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(from[0] - to[0]) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) {
    var lambda = from[0] < to[0] ? __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */];
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buffer__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rejoin__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polygonContains__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["a"] = (function(pointVisible, clipLine, interpolate, start) {
  return function(sink) {
    var line = clipLine(sink),
        ringBuffer = Object(__WEBPACK_IMPORTED_MODULE_0__buffer__["a" /* default */])(),
        ringSink = clipLine(ringBuffer),
        polygonStarted = false,
        polygon,
        segments,
        ring;

    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = Object(__WEBPACK_IMPORTED_MODULE_4_d3_array__["d" /* merge */])(segments);
        var startInside = Object(__WEBPACK_IMPORTED_MODULE_3__polygonContains__["a" /* default */])(polygon, start);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          Object(__WEBPACK_IMPORTED_MODULE_1__rejoin__["a" /* default */])(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };

    function point(lambda, phi) {
      if (pointVisible(lambda, phi)) sink.point(lambda, phi);
    }

    function pointLine(lambda, phi) {
      line.point(lambda, phi);
    }

    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }

    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }

    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      ringSink.point(lambda, phi);
    }

    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }

    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();

      var clean = ringSink.clean(),
          ringSegments = ringBuffer.result(),
          i, n = ringSegments.length, m,
          segment,
          point;

      ring.pop();
      polygon.push(ring);
      ring = null;

      if (!n) return;

      // No intersections.
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }

      // Rejoin connected segments.
      // TODO reuse ringBuffer.rejoin()?
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));

      segments.push(ringSegments.filter(validSegment));
    }

    return clip;
  };
});

function validSegment(segment) {
  return segment.length > 1;
}

// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] : __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - a[1])
       - ((b = b.x)[0] < 0 ? b[1] - __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] : __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - b[1]);
}


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(15);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var lines = [],
      line;
  return {
    point: function(x, y) {
      line.push([x, y]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
});


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pointEqual__ = __webpack_require__(161);


function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other; // another intersection
  this.e = entry; // is an entry?
  this.v = false; // visited
  this.n = this.p = null; // next & previous
}

// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
/* harmony default export */ __webpack_exports__["a"] = (function(segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
      clip = [],
      i,
      n;

  segments.forEach(function(segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n, p0 = segment[0], p1 = segment[n], x;

    // If the first and last points of a segment are coincident, then treat as a
    // closed ring. TODO if all rings are closed, then the winding order of the
    // exterior ring should be checked.
    if (Object(__WEBPACK_IMPORTED_MODULE_0__pointEqual__["a" /* default */])(p0, p1)) {
      stream.lineStart();
      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
      stream.lineEnd();
      return;
    }

    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });

  if (!subject.length) return;

  clip.sort(compareIntersection);
  link(subject);
  link(clip);

  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }

  var start = subject[0],
      points,
      point;

  while (1) {
    // Find first unvisited intersection.
    var current = start,
        isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
});

function link(array) {
  if (!(n = array.length)) return;
  var n,
      i = 0,
      a = array[0],
      b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(a[0] - b[0]) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] && Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(a[1] - b[1]) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */];
});


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(0);




var sum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (function(polygon, point) {
  var lambda = point[0],
      phi = point[1],
      normal = [Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(lambda), -Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(lambda), 0],
      angle = 0,
      winding = 0;

  sum.reset();

  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
        m,
        point0 = ring[m - 1],
        lambda0 = point0[0],
        phi0 = point0[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math__["q" /* quarterPi */],
        sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(phi0),
        cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(phi0);

    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
          lambda1 = point1[0],
          phi1 = point1[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math__["q" /* quarterPi */],
          sinPhi1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(phi1),
          cosPhi1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(phi1),
          delta = lambda1 - lambda0,
          sign = delta >= 0 ? 1 : -1,
          absDelta = sign * delta,
          antimeridian = absDelta > __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */],
          k = sinPhi0 * sinPhi1;

      sum.add(Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* atan2 */])(k * sign * Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(absDelta), cosPhi0 * cosPhi1 + k * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(absDelta)));
      angle += antimeridian ? delta + sign * __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */] : delta;

      // Are the longitudes either side of the point’s meridian (lambda),
      // and are the latitudes smaller than the parallel (phi)?
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["c" /* cartesianCross */])(Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["a" /* cartesian */])(point0), Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["a" /* cartesian */])(point1));
        Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["e" /* cartesianNormalizeInPlace */])(arc);
        var intersection = Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["c" /* cartesianCross */])(normal, arc);
        Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["e" /* cartesianNormalizeInPlace */])(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }

  // First, determine whether the South pole is inside or outside:
  //
  // It is inside if:
  // * the polygon winds around it in a clockwise direction.
  // * the polygon does not (cumulatively) wind around it, but has a negative
  //   (counter-clockwise) area.
  //
  // Second, count the (signed) number of times a segment crosses a lambda
  // from the point to the South pole.  If it is zero, then the point is the
  // same side as the South pole.

  return (angle < -__WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] || angle < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] && sum < -__WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */]) ^ (winding & 1);
});


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__circle__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pointEqual__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(158);






/* harmony default export */ __webpack_exports__["a"] = (function(radius) {
  var cr = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(radius),
      delta = 6 * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */],
      smallRadius = cr > 0,
      notHemisphere = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(cr) > __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */]; // TODO optimise for this common case

  function interpolate(from, to, direction, stream) {
    Object(__WEBPACK_IMPORTED_MODULE_1__circle__["a" /* circleStream */])(stream, radius, delta, direction, from, to);
  }

  function visible(lambda, phi) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(lambda) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(phi) > cr;
  }

  // Takes a line and cuts into visible segments. Return values used for polygon
  // clipping: 0 - there were intersections or the line was empty; 1 - no
  // intersections 2 - there were intersections, and the first and last segments
  // should be rejoined.
  function clipLine(stream) {
    var point0, // previous point
        c0, // code for previous point
        v0, // visibility of previous point
        v00, // visibility of first point
        clean; // no intersections
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi],
            point2,
            v = visible(lambda, phi),
            c = smallRadius
              ? v ? 0 : code(lambda, phi)
              : v ? code(lambda + (lambda < 0 ? __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */]), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        // Handle degeneracies.
        // TODO ignore if not clipping polygons.
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (!point2 || Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point0, point2) || Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point1, point2)) {
            point1[0] += __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];
            point1[1] += __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];
            v = visible(point1[0], point1[1]);
          }
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            // outside going in
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            // inside going out
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1]);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          // If the codes for two points are different, or are both zero,
          // and there this segment intersects with the small circle.
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
            }
          }
        }
        if (v && (!point0 || !Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | ((v00 && v0) << 1);
      }
    };
  }

  // Intersects the great circle between a and b with the clip circle.
  function intersect(a, b, two) {
    var pa = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(a),
        pb = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(b);

    // We have two planes, n1.p = d1 and n2.p = d2.
    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
    var n1 = [1, 0, 0], // normal
        n2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianCross */])(pa, pb),
        n2n2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(n2, n2),
        n1n2 = n2[0], // cartesianDot(n1, n2),
        determinant = n2n2 - n1n2 * n1n2;

    // Two polar points.
    if (!determinant) return !two && a;

    var c1 =  cr * n2n2 / determinant,
        c2 = -cr * n1n2 / determinant,
        n1xn2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianCross */])(n1, n2),
        A = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(n1, c1),
        B = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(n2, c2);
    Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianAddInPlace */])(A, B);

    // Solve |p(t)|^2 = 1.
    var u = n1xn2,
        w = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(A, u),
        uu = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(u, u),
        t2 = w * w - uu * (Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(A, A) - 1);

    if (t2 < 0) return;

    var t = Object(__WEBPACK_IMPORTED_MODULE_2__math__["u" /* sqrt */])(t2),
        q = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(u, (-w - t) / uu);
    Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianAddInPlace */])(q, A);
    q = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* spherical */])(q);

    if (!two) return q;

    // Two intersection points.
    var lambda0 = a[0],
        lambda1 = b[0],
        phi0 = a[1],
        phi1 = b[1],
        z;

    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;

    var delta = lambda1 - lambda0,
        polar = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(delta - __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */]) < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */],
        meridian = polar || delta < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];

    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;

    // Check that the first point is between a and b.
    if (meridian
        ? polar
          ? phi0 + phi1 > 0 ^ q[1] < (Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(q[0] - lambda0) < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] ? phi0 : phi1)
          : phi0 <= q[1] && q[1] <= phi1
        : delta > __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */] ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(u, (-w + t) / uu);
      Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianAddInPlace */])(q1, A);
      return [q, Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* spherical */])(q1)];
    }
  }

  // Generates a 4-bit vector representing the location of a point relative to
  // the small circle's bounding box.
  function code(lambda, phi) {
    var r = smallRadius ? radius : __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */] - radius,
        code = 0;
    if (lambda < -r) code |= 1; // left
    else if (lambda > r) code |= 2; // right
    if (phi < -r) code |= 4; // below
    else if (phi > r) code |= 8; // above
    return code;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */])(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-__WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */], radius - __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */]]);
});


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__length__ = __webpack_require__(165);


var coordinates = [null, null],
    object = {type: "LineString", coordinates: coordinates};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return Object(__WEBPACK_IMPORTED_MODULE_0__length__["a" /* default */])(object);
});


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stream__ = __webpack_require__(19);





var lengthSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lambda0,
    sinPhi0,
    cosPhi0;

var lengthStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: lengthLineStart,
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */]
};

function lengthLineStart() {
  lengthStream.point = lengthPointFirst;
  lengthStream.lineEnd = lengthLineEnd;
}

function lengthLineEnd() {
  lengthStream.point = lengthStream.lineEnd = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
}

function lengthPointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  lambda0 = lambda, sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi), cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi);
  lengthStream.point = lengthPoint;
}

function lengthPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  var sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
      cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
      delta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda - lambda0),
      cosDelta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(delta),
      sinDelta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(delta),
      x = cosPhi * sinDelta,
      y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta,
      z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
  lengthSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* sqrt */])(x * x + y * y), z));
  lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
}

/* harmony default export */ __webpack_exports__["a"] = (function(object) {
  lengthSum.reset();
  Object(__WEBPACK_IMPORTED_MODULE_3__stream__["a" /* default */])(object, lengthStream);
  return +lengthSum;
});


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(15);


var x0 = Infinity,
    y0 = x0,
    x1 = -x0,
    y1 = x1;

var boundsStream = {
  point: boundsPoint,
  lineStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  polygonStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  result: function() {
    var bounds = [[x0, y0], [x1, y1]];
    x1 = y1 = -(y0 = x0 = Infinity);
    return bounds;
  }
};

function boundsPoint(x, y) {
  if (x < x0) x0 = x;
  if (x > x1) x1 = x;
  if (y < y0) y0 = y;
  if (y > y1) y1 = y;
}

/* harmony default export */ __webpack_exports__["a"] = (boundsStream);


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conicEqualArea__ = __webpack_require__(88);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__conicEqualArea__["a" /* default */])()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
});


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = equirectangularRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(11);


function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}

equirectangularRaw.invert = equirectangularRaw;

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(equirectangularRaw)
      .scale(152.63);
});


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = packEnclose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enclose__ = __webpack_require__(170);


function place(a, b, c) {
  var ax = a.x,
      ay = a.y,
      da = b.r + c.r,
      db = a.r + c.r,
      dx = b.x - ax,
      dy = b.y - ay,
      dc = dx * dx + dy * dy;
  if (dc) {
    var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc),
        y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
    c.x = ax + x * dx + y * dy;
    c.y = ay + x * dy - y * dx;
  } else {
    c.x = ax + db;
    c.y = ay;
  }
}

function intersects(a, b) {
  var dx = b.x - a.x,
      dy = b.y - a.y,
      dr = a.r + b.r;
  return dr * dr - 1e-6 > dx * dx + dy * dy;
}

function score(node) {
  var a = node._,
      b = node.next._,
      ab = a.r + b.r,
      dx = (a.x * b.r + b.x * a.r) / ab,
      dy = (a.y * b.r + b.y * a.r) / ab;
  return dx * dx + dy * dy;
}

function Node(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}

function packEnclose(circles) {
  if (!(n = circles.length)) return 0;

  var a, b, c, n, aa, ca, i, j, k, sj, sk;

  // Place the first circle.
  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r;

  // Place the second circle.
  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r;

  // Place the third circle.
  place(b, a, c = circles[2]);

  // Initialize the front-chain using the first three circles a, b and c.
  a = new Node(a), b = new Node(b), c = new Node(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a;

  // Attempt to place each remaining circle…
  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new Node(c);

    // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.
    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          b = j, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          a = k, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next);

    // Success! Insert the new circle c between a and b.
    c.previous = a, c.next = b, a.next = b.previous = b = c;

    // Compute the new closest circle pair to the centroid.
    aa = score(a);
    while ((c = c.next) !== b) {
      if ((ca = score(c)) < aa) {
        a = c, aa = ca;
      }
    }
    b = a.next;
  }

  // Compute the enclosing circle of the front chain.
  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = Object(__WEBPACK_IMPORTED_MODULE_0__enclose__["a" /* default */])(a);

  // Translate the circles to put the enclosing circle around the origin.
  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;

  return c.r;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(circles) {
  packEnclose(circles);
  return circles;
});


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(502);


/* harmony default export */ __webpack_exports__["a"] = (function(circles) {
  var i = 0, n = (circles = Object(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* shuffle */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(circles))).length, B = [], p, e;

  while (i < n) {
    p = circles[i];
    if (e && enclosesWeak(e, p)) ++i;
    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
  }

  return e;
});

function extendBasis(B, p) {
  var i, j;

  if (enclosesWeakAll(p, B)) return [p];

  // If we get here then B must have at least one element.
  for (i = 0; i < B.length; ++i) {
    if (enclosesNot(p, B[i])
        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
      return [B[i], p];
    }
  }

  // If we get here then B must have at least two elements.
  for (i = 0; i < B.length - 1; ++i) {
    for (j = i + 1; j < B.length; ++j) {
      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
          && enclosesNot(encloseBasis2(B[i], p), B[j])
          && enclosesNot(encloseBasis2(B[j], p), B[i])
          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
        return [B[i], B[j], p];
      }
    }
  }

  // If we get here then something is very wrong.
  throw new Error;
}

function enclosesNot(a, b) {
  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
  return dr < 0 || dr * dr < dx * dx + dy * dy;
}

function enclosesWeak(a, b) {
  var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function enclosesWeakAll(a, B) {
  for (var i = 0; i < B.length; ++i) {
    if (!enclosesWeak(a, B[i])) {
      return false;
    }
  }
  return true;
}

function encloseBasis(B) {
  switch (B.length) {
    case 1: return encloseBasis1(B[0]);
    case 2: return encloseBasis2(B[0], B[1]);
    case 3: return encloseBasis3(B[0], B[1], B[2]);
  }
}

function encloseBasis1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}

function encloseBasis2(a, b) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
      l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}

function encloseBasis3(a, b, c) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x3 = c.x, y3 = c.y, r3 = c.r,
      a2 = x1 - x2,
      a3 = x1 - x3,
      b2 = y1 - y2,
      b3 = y1 - y3,
      c2 = r2 - r1,
      c3 = r3 - r1,
      d1 = x1 * x1 + y1 * y1 - r1 * r1,
      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
      ab = a3 * b2 - a2 * b3,
      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
      xb = (b3 * c2 - b2 * c3) / ab,
      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
      yb = (a2 * c3 - a3 * c2) / ab,
      A = xb * xb + yb * yb - 1,
      B = 2 * (r1 + xa * xb + ya * yb),
      C = xa * xa + ya * ya - r1 * r1,
      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
  return {
    x: x1 + xa + xb * r,
    y: y1 + ya + yb * r,
    r: r
  };
}


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = constantZero;
function constantZero() {
  return 0;
}

/* harmony default export */ __webpack_exports__["b"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
});


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(26);


/* harmony default export */ __webpack_exports__["a"] = ((function sourceRandomNormal(source) {
  function randomNormal(mu, sigma) {
    var x, r;
    mu = mu == null ? 0 : +mu;
    sigma = sigma == null ? 1 : +sigma;
    return function() {
      var y;

      // If available, use the second previously-generated uniform random.
      if (x != null) y = x, x = null;

      // Otherwise, generate a new x and y.
      else do {
        x = source() * 2 - 1;
        y = source() * 2 - 1;
        r = x * x + y * y;
      } while (!r || r > 1);

      return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
    };
  }

  randomNormal.source = sourceRandomNormal;

  return randomNormal;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(26);


/* harmony default export */ __webpack_exports__["a"] = ((function sourceRandomIrwinHall(source) {
  function randomIrwinHall(n) {
    return function() {
      for (var sum = 0, i = 0; i < n; ++i) sum += source();
      return sum;
    };
  }

  randomIrwinHall.source = sourceRandomIrwinHall;

  return randomIrwinHall;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = (function(defaultMimeType, parse) {
  return function(url, row, callback) {
    if (arguments.length < 3) callback = row, row = null;
    var r = Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(url).mimeType(defaultMimeType);
    r.row = function(_) { return arguments.length ? r.response(responseOf(parse, row = _)) : row; };
    r.row(row);
    return callback ? r.get(callback) : r;
  };
});

function responseOf(parse, row) {
  return function(request) {
    return parse(request.responseText, row);
  };
}


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export implicit */
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(20);



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(178);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateNumber */]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisector */])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* tickStep */])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Math.max(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* tickStep */])(start, stop, interval), 1);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(Object(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["k" /* timeYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["f" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["j" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["a" /* timeDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["b" /* timeHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["d" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["g" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["c" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["a" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(53);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newYear(d.y)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* utcDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = newDate(newYear(d.y)), day = week.getDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["h" /* timeSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d), p, 2);
}

function formatWeekNumberISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* utcDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["s" /* utcSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d), p, 2);
}

function formatUTCWeekNumberISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(98);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__["b" /* utcFormat */])(isoSpecifier);

/* unused harmony default export */ var _unused_webpack_default_export = (formatIso);


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point__ = __webpack_require__(100);






/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = __WEBPACK_IMPORTED_MODULE_4__point__["a" /* x */],
      x1 = null,
      y0 = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      y1 = __WEBPACK_IMPORTED_MODULE_4__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__line__["a" /* default */])().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return curveRadialLinear; });
/* harmony export (immutable) */ __webpack_exports__["b"] = curveRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(54);


var curveRadialLinear = curveRadial(__WEBPACK_IMPORTED_MODULE_0__linear__["a" /* default */]);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lineRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line__ = __webpack_require__(99);



function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return l;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return lineRadial(Object(__WEBPACK_IMPORTED_MODULE_1__line__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]));
});


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
});


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(35);


/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / __WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */]);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, __WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */]);
  }
});


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(35);


var ka = 0.89081309152928522810,
    kr = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */] / 10) / Math.sin(7 * __WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */] / 10),
    kx = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] / 10) * kr,
    ky = -Math.cos(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] / 10) * kr;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = __WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sqrt3 = Math.sqrt(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var c = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
});


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalClosed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(57);



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__cardinal__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinal__ = __webpack_require__(57);


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__cardinal__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = createCell;
/* harmony export (immutable) */ __webpack_exports__["a"] = cellHalfedgeStart;
/* unused harmony export cellHalfedgeEnd */
/* harmony export (immutable) */ __webpack_exports__["d"] = sortCellHalfedges;
/* harmony export (immutable) */ __webpack_exports__["b"] = clipCells;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Edge__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Diagram__ = __webpack_require__(38);



function createCell(site) {
  return __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][site.index] = {
    site: site,
    halfedges: []
  };
}

function cellHalfedgeAngle(cell, edge) {
  var site = cell.site,
      va = edge.left,
      vb = edge.right;
  if (site === vb) vb = va, va = site;
  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
  if (site === va) va = edge[1], vb = edge[0];
  else va = edge[0], vb = edge[1];
  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}

function cellHalfedgeStart(cell, edge) {
  return edge[+(edge.left !== cell.site)];
}

function cellHalfedgeEnd(cell, edge) {
  return edge[+(edge.left === cell.site)];
}

function sortCellHalfedges() {
  for (var i = 0, n = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */].length, cell, halfedges, j, m; i < n; ++i) {
    if ((cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][i]) && (m = (halfedges = cell.halfedges).length)) {
      var index = new Array(m),
          array = new Array(m);
      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[j]]);
      index.sort(function(i, j) { return array[j] - array[i]; });
      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
      for (j = 0; j < m; ++j) halfedges[j] = array[j];
    }
  }
}

function clipCells(x0, y0, x1, y1) {
  var nCells = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */].length,
      iCell,
      cell,
      site,
      iHalfedge,
      halfedges,
      nHalfedges,
      start,
      startX,
      startY,
      end,
      endX,
      endY,
      cover = true;

  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
      site = cell.site;
      halfedges = cell.halfedges;
      iHalfedge = halfedges.length;

      // Remove any dangling clipped edges.
      while (iHalfedge--) {
        if (!__WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[iHalfedge]]) {
          halfedges.splice(iHalfedge, 1);
        }
      }

      // Insert any border edges as necessary.
      iHalfedge = 0, nHalfedges = halfedges.length;
      while (iHalfedge < nHalfedges) {
        end = cellHalfedgeEnd(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[iHalfedge]]), endX = end[0], endY = end[1];
        start = cellHalfedgeStart(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
        if (Math.abs(endX - startX) > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] || Math.abs(endY - startY) > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */]) {
          halfedges.splice(iHalfedge, 0, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, end,
              Math.abs(endX - x0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && y1 - endY > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [x0, Math.abs(startX - x0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startY : y1]
              : Math.abs(endY - y1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && x1 - endX > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [Math.abs(startY - y1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startX : x1, y1]
              : Math.abs(endX - x1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && endY - y0 > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [x1, Math.abs(startX - x1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startY : y0]
              : Math.abs(endY - y0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && endX - x0 > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [Math.abs(startY - y0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startX : x0, y0]
              : null)) - 1);
          ++nHalfedges;
        }
      }

      if (nHalfedges) cover = false;
    }
  }

  // If there weren’t any edges, have the closest site cover the extent.
  // It doesn’t matter which corner of the extent we measure!
  if (cover) {
    var dx, dy, d2, dc = Infinity;

    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
      if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
        site = cell.site;
        dx = site[0] - x0;
        dy = site[1] - y0;
        d2 = dx * dx + dy * dy;
        if (d2 < dc) dc = d2, cover = cell;
      }
    }

    if (cover) {
      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
      cover.halfedges.push(
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site = cover.site, v00, v01)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v01, v11)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v11, v10)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v10, v00)) - 1
      );
    }
  }

  // Lastly delete any cells with no edges; these were entirely clipped.
  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
      if (!cell.halfedges.length) {
        delete __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell];
      }
    }
  }
}


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return firstCircle; });
/* harmony export (immutable) */ __webpack_exports__["a"] = attachCircle;
/* harmony export (immutable) */ __webpack_exports__["b"] = detachCircle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedBlackTree__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Diagram__ = __webpack_require__(38);



var circlePool = [];

var firstCircle;

function Circle() {
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(this);
  this.x =
  this.y =
  this.arc =
  this.site =
  this.cy = null;
}

function attachCircle(arc) {
  var lArc = arc.P,
      rArc = arc.N;

  if (!lArc || !rArc) return;

  var lSite = lArc.site,
      cSite = arc.site,
      rSite = rArc.site;

  if (lSite === rSite) return;

  var bx = cSite[0],
      by = cSite[1],
      ax = lSite[0] - bx,
      ay = lSite[1] - by,
      cx = rSite[0] - bx,
      cy = rSite[1] - by;

  var d = 2 * (ax * cy - ay * cx);
  if (d >= -__WEBPACK_IMPORTED_MODULE_1__Diagram__["g" /* epsilon2 */]) return;

  var ha = ax * ax + ay * ay,
      hc = cx * cx + cy * cy,
      x = (cy * ha - ay * hc) / d,
      y = (ax * hc - cx * ha) / d;

  var circle = circlePool.pop() || new Circle;
  circle.arc = arc;
  circle.site = cSite;
  circle.x = x + bx;
  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom

  arc.circle = circle;

  var before = null,
      node = __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */]._;

  while (node) {
    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
      if (node.L) node = node.L;
      else { before = node.P; break; }
    } else {
      if (node.R) node = node.R;
      else { before = node; break; }
    }
  }

  __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */].insert(before, circle);
  if (!before) firstCircle = circle;
}

function detachCircle(arc) {
  var circle = arc.circle;
  if (circle) {
    if (!circle.P) firstCircle = circle.N;
    __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */].remove(circle);
    circlePool.push(circle);
    Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(circle);
    arc.circle = null;
  }
}


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Transform;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
/* unused harmony export default */
function Transform(k, x, y) {
  this.k = k;
  this.x = x;
  this.y = y;
}

Transform.prototype = {
  constructor: Transform,
  scale: function(k) {
    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
  },
  translate: function(x, y) {
    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
  },
  apply: function(point) {
    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
  },
  applyX: function(x) {
    return x * this.k + this.x;
  },
  applyY: function(y) {
    return y * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x) {
    return (x - this.x) / this.k;
  },
  invertY: function(y) {
    return (y - this.y) / this.k;
  },
  rescaleX: function(x) {
    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
  },
  rescaleY: function(y) {
    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};

var identity = new Transform(1, 0, 0);

transform.prototype = Transform.prototype;

function transform(node) {
  return node.__zoom || identity;
}


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_helpers_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line_css__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__line_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Line=function(_Component){_inherits(Line,_Component);function Line(props){_classCallCheck(this,Line);var _this=_possibleConstructorReturn(this,(Line.__proto__||Object.getPrototypeOf(Line)).call(this,props));_this.chart=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.draw=_this.draw.bind(_this);_this.outputSVG=_this.outputSVG.bind(_this);_this.viewbox=_this.viewbox.bind(_this);_this.state={"paths":{"axis":{},"series":[]},"ready":false,"size":{"h":0,"w":0}};return _this;}_createClass(Line,[{key:'componentDidMount',value:function componentDidMount(){this.viewbox();window.addEventListener('resize',this.viewbox,false);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.viewbox,false);}},{key:'draw',value:function draw(){var xBoundaries=this.props.xBoundaries;var yBoundaries=this.props.yBoundaries;if(!xBoundaries||!xBoundaries instanceof Array){var days=[];this.props.series.forEach(function(serie){days.push(new Date(serie[0].date_short).getTime());days.push(new Date(serie[serie.length-1].date_short).getTime());});xBoundaries=[Math.min.apply(Math,days),Math.max.apply(Math,days)];}if(!yBoundaries||!yBoundaries instanceof Array){var quantities=[];this.props.series.forEach(function(serie){serie.forEach(function(point){quantities.push(parseInt(point.number,10));});});yBoundaries=[Math.min(0,Math.min.apply(Math,quantities)),Math.max.apply(Math,quantities)];}var topBaseY=30;var bottomBaseY=this.state.size.h-topBaseY*2;var leftBaseX=0;var rightBaseX=this.state.size.w-leftBaseX;var scaleY=__WEBPACK_IMPORTED_MODULE_1_d3__["f" /* scaleLinear */]().domain(yBoundaries).range([bottomBaseY,topBaseY]);var scaleX=__WEBPACK_IMPORTED_MODULE_1_d3__["f" /* scaleLinear */]().domain(xBoundaries).range([leftBaseX,rightBaseX]);var electionDay=new Date('2018-03-04T07:00:00').getTime();var electionDayX=scaleX(electionDay);var electionDayEnd=new Date('2018-03-04T23:00:00').getTime();var electionDayEndX=scaleX(electionDayEnd);var calendar=[];var startDay=xBoundaries[0];var lastDay=xBoundaries[1];while(startDay<lastDay){calendar.push({"x":scaleX(startDay),"y":bottomBaseY+18,"y1":bottomBaseY,"y2":bottomBaseY+5,"label":Object(__WEBPACK_IMPORTED_MODULE_2__helpers_helpers_js__["b" /* formatDate */])(startDay/1000)});startDay+=1000*60*60*24*14;}calendar.push({"x":scaleX(lastDay)-1,"y":bottomBaseY+30,"y1":bottomBaseY,"y2":bottomBaseY+15,"label":Object(__WEBPACK_IMPORTED_MODULE_2__helpers_helpers_js__["b" /* formatDate */])(lastDay/1000)});calendar[0]={"x":calendar[0].x+1,"y":bottomBaseY+30,"y1":calendar[0].y1,"y2":bottomBaseY+15,"label":calendar[0].label};var axis={x:{x1:leftBaseX,y1:bottomBaseY,x2:rightBaseX,y2:bottomBaseY,calendar:calendar}};var overlay={area:{d:"M"+electionDayX+","+bottomBaseY+" L"+electionDayEndX+","+bottomBaseY+" L"+electionDayEndX+","+topBaseY+" L"+electionDayX+","+topBaseY+"Z"},end:{x1:electionDayEndX,y1:bottomBaseY,x2:electionDayEndX,y2:topBaseY},start:{x1:electionDayX,y1:bottomBaseY,x2:electionDayX,y2:topBaseY},markers:{end:{x1:electionDayEndX,y1:bottomBaseY,x2:electionDayEndX,y2:bottomBaseY+15},start:{x1:electionDayX,y1:bottomBaseY,x2:electionDayX,y2:bottomBaseY+15}},labels:{date:{text:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_helpers_js__["b" /* formatDate */])(electionDay/1000),x:electionDayX+(electionDayEndX-electionDayX),y:bottomBaseY+30},description:{text:'Seggi aperti 7 - 23',x:electionDayX+(electionDayEndX-electionDayX),y:bottomBaseY+47}},legend:{pre:{arrow:{d:"M"+(electionDayX-5)+","+(topBaseY+15)+" L"+(electionDayX-10)+","+(topBaseY+12)+" L"+(electionDayX-10)+","+(topBaseY+18)+"Z"},label:{text:"Prima",x:2+(electionDayX-5-2)/2,y:topBaseY+10},line:{x1:2,y1:topBaseY+15,x2:electionDayX-5,y2:topBaseY+15},stopper:{x1:2,y1:topBaseY+12,x2:2,y2:topBaseY+18}},post:{arrow:{d:"M"+(electionDayEndX+3)+","+(topBaseY+15)+" L"+(electionDayEndX+8)+","+(topBaseY+12)+" L"+(electionDayEndX+8)+","+(topBaseY+18)+"Z"},label:{text:"Dopo",x:electionDayEndX+3+(this.state.size.w-2-(electionDayEndX+3))/2,y:topBaseY+10},line:{x1:this.state.size.w-2,y1:topBaseY+15,x2:electionDayEndX+5,y2:topBaseY+15},stopper:{x1:this.state.size.w-2,y1:topBaseY+12,x2:this.state.size.w-2,y2:topBaseY+18}}}};var series=[];var keywordLine=__WEBPACK_IMPORTED_MODULE_1_d3__["e" /* line */]().x(function(point){return point.x;}).y(function(point){return point.y;}).curve(__WEBPACK_IMPORTED_MODULE_1_d3__["c" /* curveBasis */]);this.props.series.forEach(function(serie){var points=[];serie.forEach(function(point){points.push({x:scaleX(new Date(point.date_short).getTime()),y:scaleY(point.number)});});series.push({points:points,path:{d:keywordLine(points)}});});this.setState({paths:{axis:axis,overlay:overlay,series:series},ready:true});}},{key:'outputSVG',value:function outputSVG(){if(this.state.ready){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{viewport:"0 0 "+this.state.size.w+' '+this.state.size.h,preserveAspectRatio:'xMidYMid meet',width:this.state.size.w,height:this.state.size.h},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'axis'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'x-axis'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.axis.x.x1,y1:this.state.paths.axis.x.y1,x2:this.state.paths.axis.x.x2,y2:this.state.paths.axis.x.y2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'x-axis--calendar'},this.state.paths.axis.x.calendar.map(function(day,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{key:day.label+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:day.x,y1:day.y1,x2:day.x,y2:day.y2,className:'calendar-marker'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:day.x,y:day.y,className:'calendar-label'},day.label));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'series'},this.state.paths.series.map(function(serie,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{key:"serie-"+index,className:"series--serie serie-"+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:serie.path.d}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'election-day overlay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:this.state.paths.overlay.area.d}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.overlay.start.x1,y1:this.state.paths.overlay.start.y1,x2:this.state.paths.overlay.start.x2,y2:this.state.paths.overlay.start.y2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.overlay.end.x1,y1:this.state.paths.overlay.end.y1,x2:this.state.paths.overlay.end.x2,y2:this.state.paths.overlay.end.y2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'election-day--marker',x1:this.state.paths.overlay.markers.start.x1,y1:this.state.paths.overlay.markers.start.y1,x2:this.state.paths.overlay.markers.start.x2,y2:this.state.paths.overlay.markers.start.y2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'election-day--marker',x1:this.state.paths.overlay.markers.end.x1,y1:this.state.paths.overlay.markers.end.y1,x2:this.state.paths.overlay.markers.end.x2,y2:this.state.paths.overlay.markers.end.y2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{className:'election-day--label',x:this.state.paths.overlay.labels.date.x,y:this.state.paths.overlay.labels.date.y},this.state.paths.overlay.labels.date.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{className:'election-day--label',x:this.state.paths.overlay.labels.description.x,y:this.state.paths.overlay.labels.description.y},this.state.paths.overlay.labels.description.text)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'time-markers overlay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'time-markers--pre'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'time-markers--arrow',d:this.state.paths.overlay.legend.pre.arrow.d}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'time-markers--stopper',x1:this.state.paths.overlay.legend.pre.stopper.x1,y1:this.state.paths.overlay.legend.pre.stopper.y1,x2:this.state.paths.overlay.legend.pre.stopper.x2,y2:this.state.paths.overlay.legend.pre.stopper.y2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'time-markers--line',x1:this.state.paths.overlay.legend.pre.line.x1,y1:this.state.paths.overlay.legend.pre.line.y1,x2:this.state.paths.overlay.legend.pre.line.x2,y2:this.state.paths.overlay.legend.pre.line.y2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{className:'time-markers--label',x:this.state.paths.overlay.legend.pre.label.x,y:this.state.paths.overlay.legend.pre.label.y},this.state.paths.overlay.legend.pre.label.text)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'time-markers--post'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'time-markers--arrow',d:this.state.paths.overlay.legend.post.arrow.d}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'time-markers--stopper',x1:this.state.paths.overlay.legend.post.stopper.x1,y1:this.state.paths.overlay.legend.post.stopper.y1,x2:this.state.paths.overlay.legend.post.stopper.x2,y2:this.state.paths.overlay.legend.post.stopper.y2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'time-markers--line',x1:this.state.paths.overlay.legend.post.line.x1,y1:this.state.paths.overlay.legend.post.line.y1,x2:this.state.paths.overlay.legend.post.line.x2,y2:this.state.paths.overlay.legend.post.line.y2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{className:'time-markers--label',x:this.state.paths.overlay.legend.post.label.x,y:this.state.paths.overlay.legend.post.label.y},this.state.paths.overlay.legend.post.label.text))));}return null;}},{key:'viewbox',value:function viewbox(){var _this2=this;var svgWrapper=this.chart.current;var size={"h":svgWrapper.offsetHeight,"w":svgWrapper.offsetWidth};this.setState({size:size},function(){_this2.draw();});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line',ref:this.chart},this.outputSVG());}}]);return Line;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Line);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matrix_css__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matrix_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__matrix_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChartMatrix=function(_Component){_inherits(ChartMatrix,_Component);function ChartMatrix(props){_classCallCheck(this,ChartMatrix);var _this=_possibleConstructorReturn(this,(ChartMatrix.__proto__||Object.getPrototypeOf(ChartMatrix)).call(this,props));_this.draw=_this.draw.bind(_this);_this.state={"classes":["empty","lowest","low","medium","high","highest"],"loading":true,"levels":{}};return _this;}_createClass(ChartMatrix,[{key:'componentDidMount',value:function componentDidMount(){this.draw();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.Matrix!==this.props.Matrix){this.draw();}}},{key:'draw',value:function draw(){var levels={};var classes=this.state.classes;var min=this.props.Min;var range=Math.round((this.props.Max-this.props.Min)/(this.state.classes.length-1));var matrix=this.props.Matrix;var axis=this.props.Axis;axis.forEach(function(row){levels[row.slug]={};axis.forEach(function(col){if(col.slug===row.slug){levels[row.slug][col.slug]="self";}else{levels[row.slug][col.slug]=classes[Math.ceil((matrix[row.slug][col.slug]-min)/range)-1];}});});this.setState({"levels":levels,"ready":true});}},{key:'render',value:function render(){if(this.state.ready){var Axis=this.props.Axis;var Levels=this.state.levels;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-matrix',id:"chart-matrix-"+this.props.ChartId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-matrix-table-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),Axis.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:"header-"+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,item.name));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,Axis.map(function(row,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:"row-"+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,row.name),Axis.map(function(cell,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:"cell-"+index,className:"cell cell-level-"+Levels[row.slug][cell.slug]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null));}));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'chart-matrix-legend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'cell cell-level-empty'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'cell cell-level-lowest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'cell cell-level-low'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'cell cell-level-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'cell cell-level-high'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'cell cell-level-highest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'+'))))));}else{return null;}}}]);return ChartMatrix;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ChartMatrix);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__milestones_css__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__milestones_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__milestones_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChartMilestones=function(_Component){_inherits(ChartMilestones,_Component);function ChartMilestones(props){_classCallCheck(this,ChartMilestones);var _this=_possibleConstructorReturn(this,(ChartMilestones.__proto__||Object.getPrototypeOf(ChartMilestones)).call(this,props));_this.findMin=_this.findMin.bind(_this);_this.findMax=_this.findMax.bind(_this);_this.load=_this.load.bind(_this);_this.draw=_this.draw.bind(_this);_this.viewbox=_this.viewbox.bind(_this);_this.dateFormat=_this.dateFormat.bind(_this);_this.state={"dayminus2":0,"dayplus2":0,"loading":true,"log":[],"milestone":{},"paths":{"activity":null,"arrow":{"bottom":null,"top":null},"floor":{"x1":0,"y1":0,"x2":0,"y2":0},"labels":{"dayminus2":{"textAnchor":"end","x":0,"y":0,"y1":0,"y2":0},"dayplus2":{"textAnchor":"start","x":0,"y":0,"y1":0,"y2":0},"first":{"textAnchor":"start","x":0,"y":0,"y1":0,"y2":0},"last":{"textAnchor":"start","x":0,"y":0,"y1":0,"y2":0},"milestone":{"textAnchor":"middle","x":0,"y":0}},"milestone":{"x1":0,"y1":0,"x2":0,"y2":0},"popularity":null},"ready":false,"size":{"h":200,"w":400}};return _this;}_createClass(ChartMilestones,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.CollectionSlug){this.load();}this.viewbox();window.addEventListener('resize',this.viewbox,false);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.CollectionSlug!==this.props.CollectionSlug){this.load();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.viewbox,false);}},{key:'dateFormat',value:function dateFormat(timestamp){var d=new Date(parseFloat(timestamp)*1000);var gg="00"+d.getDate();var mm="00"+(d.getMonth()+1);return gg.substr(gg.length-2)+'/'+mm.substr(mm.length-2);}},{key:'load',value:function load(){var _this2=this;this.props.FetchContent(this.props.BaseUrl+this.props.VizUrl+'/articles/number-and-popularity-by-day-by-collection?collection_slug='+escape(this.props.CollectionSlug)+"&milestone_id="+(this.props.MilestoneId||''),{},function(response){if(typeof _this2.props.SetDate==='function'){_this2.props.SetDate(response.generated);}_this2.setState({"milestone":response.data.milestone||null,"log":response.data.log,"updated":_this2.dateFormat(response.generated)},function(){_this2.draw();});},function(error){console.log(error);});}},{key:'viewbox',value:function viewbox(){var _this3=this;if(document.querySelector('#chart-milestone-'+this.props.ChartId)!==null){var size={"w":document.querySelector('#chart-milestone-container-'+this.props.ChartId).offsetWidth,"h":document.querySelector('#chart-milestone-container-'+this.props.ChartId).offsetHeight};this.setState({'size':size},function(){if(_this3.state.log&&_this3.state.log.length>0){_this3.draw();}});}}},{key:'findMax',value:function findMax(list,key){var output=Number.MIN_VALUE;list.forEach(function(l){if(parseFloat(l[key])>output){output=parseFloat(l[key]);}});return output;}},{key:'findMin',value:function findMin(list,key){var output=Number.MAX_VALUE;list.forEach(function(l){if(parseFloat(l[key])<output){output=parseFloat(l[key]);}});return output;}},{key:'draw',value:function draw(){var topBaseY=10;var bottomBaseY=this.state.size.h-30;var scaleX=__WEBPACK_IMPORTED_MODULE_1_d3__["f" /* scaleLinear */]().domain([this.findMin(this.state.log,'timestamp'),this.findMax(this.state.log,'timestamp')]).range([0,this.state.size.w]);var scaleYAct=__WEBPACK_IMPORTED_MODULE_1_d3__["f" /* scaleLinear */]().domain([this.findMin(this.state.log,'activity'),this.findMax(this.state.log,'activity')]).range([bottomBaseY,topBaseY]);var scaleYPop=__WEBPACK_IMPORTED_MODULE_1_d3__["f" /* scaleLinear */]().domain([this.findMin(this.state.log,'popularity'),this.findMax(this.state.log,'popularity')]).range([bottomBaseY,topBaseY]);var points=[];this.state.log.forEach(function(l){points.push({"x":scaleX(parseFloat(l.timestamp)),"yAct":scaleYAct(parseFloat(l.activity)),"yPop":scaleYPop(parseFloat(l.popularity))});});var activityArea=__WEBPACK_IMPORTED_MODULE_1_d3__["b" /* area */]().x(function(points){return points.x;}).y1(function(points){return points.yAct;}).y0(function(points){return bottomBaseY;}).curve(__WEBPACK_IMPORTED_MODULE_1_d3__["c" /* curveBasis */]);var popularityArea=__WEBPACK_IMPORTED_MODULE_1_d3__["b" /* area */]().x(function(points){return points.x;}).y1(function(points){return points.yPop;}).y0(function(points){return bottomBaseY;}).curve(__WEBPACK_IMPORTED_MODULE_1_d3__["c" /* curveBasis */]);var arrowBottom=null,arrowTop=null,dayminus2=null,dayplus2=null,first=this.findMin(this.state.log,"timestamp"),last=this.findMax(this.state.log,"timestamp");if(this.state.milestone){arrowTop="M"+scaleX(this.state.milestone.timestamp)+",10 L"+(scaleX(this.state.milestone.timestamp)-5)+",0 L"+(scaleX(this.state.milestone.timestamp)+5)+",0Z";arrowBottom="M"+scaleX(this.state.milestone.timestamp)+","+(bottomBaseY-10)+" L"+(scaleX(this.state.milestone.timestamp)-5)+","+bottomBaseY+" L"+(scaleX(this.state.milestone.timestamp)+5)+","+bottomBaseY+"Z";dayminus2=parseInt(this.state.milestone.timestamp,10)-60*60*24*2;dayplus2=parseInt(this.state.milestone.timestamp,10)+60*60*24*2;}else{var range=parseInt((parseInt(last,10)-parseInt(first,10))/3,10);dayminus2=first+range;dayplus2=last-range;}var paths={"activity":activityArea(points),"arrow":{"bottom":arrowBottom,"top":arrowTop},"floor":{"x1":0,"y1":bottomBaseY,"x2":this.state.size.w,"y2":bottomBaseY},"labels":{"dayminus2":{"textAnchor":this.state.milestone?"end":"middle","x":scaleX(dayminus2),"y":this.state.size.h-16,"y1":bottomBaseY,"y2":topBaseY},"dayplus2":{"textAnchor":this.state.milestone?"start":"middle","x":scaleX(dayplus2),"y":this.state.size.h-16,"y1":bottomBaseY,"y2":topBaseY},"first":{"textAnchor":"start","timestamp":first,"x":scaleX(first)+1,"y":this.state.size.h-4,"y1":bottomBaseY,"y2":topBaseY},"last":{"textAnchor":"end","timestamp":last,"x":scaleX(last)-1,"y":this.state.size.h-4,"y1":bottomBaseY,"y2":topBaseY},"milestone":{"textAnchor":"middle","x":this.state.milestone?scaleX(this.state.milestone.timestamp):0,"y":this.state.milestone?this.state.size.h-16:0}},"milestone":{"x1":this.state.milestone?scaleX(this.state.milestone.timestamp):0,"y1":0,"x2":this.state.milestone?scaleX(this.state.milestone.timestamp):0,"y2":this.state.milestone?bottomBaseY:0},"popularity":popularityArea(points)};this.setState({"dayminus2":dayminus2,"dayplus2":dayplus2,"first":this.findMin(this.state.log,'timestamp'),"last":this.findMax(this.state.log,'timestamp'),"ready":true,"paths":paths});if(typeof this.props.SetLoading==='function'){this.props.SetLoading(false);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-milestone',id:"chart-milestone-"+this.props.ChartId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',{className:'chart-milestone-detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartMilestonesTitle,{Milestone:this.state.milestone?this.state.milestone:null}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-milestone-container',id:"chart-milestone-container-"+this.props.ChartId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:"chart-milestone-viz "+this.props.CollectionSlug,preserveAspectRatio:'xMidYMid meet',viewBox:"0 0 "+this.state.size.w+" "+this.state.size.h},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:'10',y:'18',textAnchor:'start',className:'chart-milestone-viz-label'},this.props.AddLabel?"Storico attività per ":"",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tspan',null,this.props.Collection)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'10',y:'25',width:'10',height:'10',className:'chart-milestone-viz-legend-popularity'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:'25',y:'33',textAnchor:'start',className:'chart-milestone-viz-label'},'Popolarit\xE0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'10',y:'40',width:'10',height:'10',className:'chart-milestone-viz-legend-activity'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:'25',y:'48',textAnchor:'start',className:'chart-milestone-viz-label'},'Attivit\xE0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.labels.dayminus2.x,y1:this.state.paths.labels.dayminus2.y1,x2:this.state.paths.labels.dayminus2.x,y2:this.state.paths.labels.dayminus2.y2,className:'chart-milestone-viz-line-date'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.labels.dayminus2.x,y1:this.state.paths.labels.dayminus2.y1,x2:this.state.paths.labels.dayminus2.x,y2:this.state.paths.labels.dayminus2.y1+4,className:'chart-milestone-viz-line-date chart-milestone-viz-line-date-solid'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.state.paths.labels.dayminus2.x,y:this.state.paths.labels.dayminus2.y,textAnchor:this.state.paths.labels.dayminus2.textAnchor,className:'chart-milestone-viz-label'},this.dateFormat(this.state.dayminus2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.labels.dayplus2.x,y1:this.state.paths.labels.dayplus2.y1,x2:this.state.paths.labels.dayplus2.x,y2:this.state.paths.labels.dayplus2.y2,className:'chart-milestone-viz-line-date'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.labels.dayplus2.x,y1:this.state.paths.labels.dayplus2.y1,x2:this.state.paths.labels.dayplus2.x,y2:this.state.paths.labels.dayplus2.y1+4,className:'chart-milestone-viz-line-date chart-milestone-viz-line-date-solid'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.state.paths.labels.dayplus2.x,y:this.state.paths.labels.dayplus2.y,textAnchor:this.state.paths.labels.dayplus2.textAnchor,className:'chart-milestone-viz-label'},this.dateFormat(this.state.dayplus2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.labels.first.x,y1:this.state.paths.labels.first.y1,x2:this.state.paths.labels.first.x,y2:this.state.paths.labels.first.y2,className:'chart-milestone-viz-line-date'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.labels.first.x,y1:this.state.paths.labels.first.y1,x2:this.state.paths.labels.first.x,y2:this.state.paths.labels.first.y1+16,className:'chart-milestone-viz-line-date chart-milestone-viz-line-date-solid'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.state.paths.labels.first.x,y:this.state.paths.labels.first.y,textAnchor:this.state.paths.labels.first.textAnchor,className:'chart-milestone-viz-label'},this.dateFormat(this.state.paths.labels.first.timestamp)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.labels.last.x,y1:this.state.paths.labels.last.y1,x2:this.state.paths.labels.last.x,y2:this.state.paths.labels.last.y2,className:'chart-milestone-viz-line-date'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.labels.last.x,y1:this.state.paths.labels.last.y1,x2:this.state.paths.labels.last.x,y2:this.state.paths.labels.last.y1+16,className:'chart-milestone-viz-line-date chart-milestone-viz-line-date-solid'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.state.paths.labels.last.x,y:this.state.paths.labels.last.y,textAnchor:this.state.paths.labels.last.textAnchor,className:'chart-milestone-viz-label'},this.dateFormat(this.state.paths.labels.last.timestamp))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:this.state.paths.popularity,className:'chart-milestone-viz-popularity'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:this.state.paths.activity,className:'chart-milestone-viz-activity'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.floor.x1,y1:this.state.paths.floor.y1,x2:this.state.paths.floor.x2,y2:this.state.paths.floor.y2,className:'chart-milestone-viz-floor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartMilestonesMarker,{Milestone:this.state.milestone,MilestonePath:this.state.paths.milestone,Arrow:this.state.paths.arrow,Labels:this.state.paths.labels,DateFormat:this.dateFormat})))));}}]);return ChartMilestones;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ChartMilestones);var ChartMilestonesTitle=function(_Component2){_inherits(ChartMilestonesTitle,_Component2);function ChartMilestonesTitle(){_classCallCheck(this,ChartMilestonesTitle);return _possibleConstructorReturn(this,(ChartMilestonesTitle.__proto__||Object.getPrototypeOf(ChartMilestonesTitle)).apply(this,arguments));}_createClass(ChartMilestonesTitle,[{key:'render',value:function render(){if(this.props.Milestone&&this.props.Milestone.title){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,this.props.Milestone.title));}else{return null;}}}]);return ChartMilestonesTitle;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ChartMilestonesMarker=function(_Component3){_inherits(ChartMilestonesMarker,_Component3);function ChartMilestonesMarker(){_classCallCheck(this,ChartMilestonesMarker);return _possibleConstructorReturn(this,(ChartMilestonesMarker.__proto__||Object.getPrototypeOf(ChartMilestonesMarker)).apply(this,arguments));}_createClass(ChartMilestonesMarker,[{key:'render',value:function render(){if(this.props.Milestone){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.props.MilestonePath.x1,y1:this.props.MilestonePath.y1,x2:this.props.MilestonePath.x2,y2:this.props.MilestonePath.y2,className:'chart-milestone-viz-milestone'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:this.props.Arrow.top,className:'chart-milestone-viz-arrow chart-milestone-viz-arrow-top'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:this.props.Arrow.bottom,className:'chart-milestone-viz-arrow chart-milestone-viz-arrow-bottom'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.props.Labels.milestone.x,y:this.props.Labels.milestone.y,textAnchor:this.props.Labels.milestone.textAnchor,className:'chart-milestone-viz-label chart-milestone-viz-milestone-label'},this.props.DateFormat(this.props.Milestone.timestamp)));}else{return null;}}}]);return ChartMilestonesMarker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(203);
module.exports = __webpack_require__(208);


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(204).enable();
  window.Promise = __webpack_require__(206);
}

// fetch() polyfill for making API calls.
__webpack_require__(207);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(58);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(105);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(106)))

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(105);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 207 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Elezioni__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__ = __webpack_require__(644);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elezioni__["a" /* default */],null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(58),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(211);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(1),n=__webpack_require__(58),r=__webpack_require__(212);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(213);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_js__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nav_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_js__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__footer_js__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loading_js__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_global_json__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_global_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__data_global_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.hashChanged=_this.hashChanged.bind(_this);_this.fetchContent=_this.fetchContent.bind(_this);_this.showLoading=_this.showLoading.bind(_this);_this.setTitle=_this.setTitle.bind(_this);_this.toggleNav=_this.toggleNav.bind(_this);_this.state={"animation_duration":250,"base_url":"https://api.elezioni.io","browse_url":"/browse","filter_url":"/filter","summary_url":"/summary","stats_url":"/collection","popularity_url":"/popularity/log","nav_url":"/browse/nav","topics_url":"/topics","viz_url":"/stats","loading":true,"location":null,"nav":false,"title":null,"isHome":false};return _this;}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('hashchange',this.hashChanged,false);this.hashChanged();}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('hashchange',this.hashChanged,false);}},{key:'hashChanged',value:function hashChanged(){this.showLoading(true);if(!window.location.hash){window.location.hash='/';}this.setState({"location":window.location.hash,"isHome":window.location.hash==='#/'?true:false,"nav":false},function(){document.querySelector('[property="og:url"]').setAttribute('content',window.public_url+window.location.hash);});}},{key:'toggleNav',value:function toggleNav(){this.setState({"nav":!this.state.nav});}},{key:'showLoading',value:function showLoading(show){//console.log( 'switch: ', show );
this.setState({"loading":show});}},{key:'setTitle',value:function setTitle(title){this.setState({"title":title},function(){document.querySelector('title').innerText=title?title+' - '+window.base_title:window.base_title;});}},{key:'fetchContent',value:function fetchContent(url,options,callback,error){if(url){var headers=new Headers();options.headers=headers;fetch(url,options).then(function(response){if(response.ok&&response.status===200){var contentType=response.headers.get("content-type");if(contentType&&(contentType.indexOf("application/json")>-1||contentType.indexOf("text/json")>-1||contentType.indexOf("text/plain")>-1)){return response.json().then(function(json){if(typeof callback==='function'){callback(json);}}).catch(function(error){if(typeof error==='function'){error(error);}});}else{if(typeof error==='function'){error('Wrong answer');}}}else{if(typeof error==='function'){error(error);}}}).catch(function(err){if(typeof error==='function'){error(err);}});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'elezioni'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__header_js__["a" /* default */],{Title:this.state.title,ToggleNav:this.toggleNav}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__nav_js__["a" /* default */],{BaseUrl:this.state.base_url,NavUrl:this.state.nav_url,Location:this.state.location,FetchContent:this.fetchContent,Show:this.state.nav,AnimationDuration:this.state.animation_duration}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__page_js__["a" /* default */],{IsHome:this.state.isHome,BaseUrl:this.state.base_url,BrowseUrl:this.state.browse_url,FilterUrl:this.state.filter_url,StatsUrl:this.state.stats_url,PopularityUrl:this.state.popularity_url,VizUrl:this.state.viz_url,SummaryUrl:this.state.summary_url,TopicsUrl:this.state.topics_url,Location:this.state.location,FetchContent:this.fetchContent,ShowLoading:this.showLoading,AnimationDuration:this.state.animation_duration,SetTitle:this.setTitle,Data:__WEBPACK_IMPORTED_MODULE_7__data_global_json___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__footer_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__loading_js__["a" /* default */],{Show:this.state.loading,AnimationDuration:this.state.animation_duration}));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_css__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__header_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header=function(_Component){_inherits(Header,_Component);function Header(){_classCallCheck(this,Header);return _possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).apply(this,arguments));}_createClass(Header,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'main-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{id:'header-logo-small',preserveAspectRatio:'xMidYMid meet',width:'426px',height:'426px',viewBox:'0 0 426 426'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'header-logo-small-group',transform:'translate(0.000000, 84.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{id:'header-logo-small-red',transform:'translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) ',x:'205.693434',y:'37.6934342',width:'182',height:'182'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{id:'header-logo-small-green',transform:'translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) ',x:'38',y:'38',width:'182',height:'182'}))),' Politiche 2018'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.Title?" / "+this.props.Title:"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/nav',id:'nav-toggle',onClick:function onClick(e){e.preventDefault();_this2.props.ToggleNav();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'middle'})))));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nav_css__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nav_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__nav_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Nav=function(_Component){_inherits(Nav,_Component);function Nav(props){_classCallCheck(this,Nav);var _this=_possibleConstructorReturn(this,(Nav.__proto__||Object.getPrototypeOf(Nav)).call(this,props));_this.load=_this.load.bind(_this);_this.startSearch=_this.startSearch.bind(_this);_this.showNav=_this.showNav.bind(_this);_this.hideNav=_this.hideNav.bind(_this);_this.state={$html:null,"items":[],"visible":false};return _this;}_createClass(Nav,[{key:'componentDidMount',value:function componentDidMount(){this.load();this.setState({"$html":document.documentElement});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){//console.log( prevProps, this.props.Show );
if(prevProps.Show!==this.props.Show){if(this.props.Show){this.setState({"visible":true},this.showNav);}else{this.hideNav();}}}},{key:'componentWillUnmout',value:function componentWillUnmout(){clearTimeout(this.timeout);}},{key:'showNav',value:function showNav(){var _this2=this;this.state.$html.classList.add("nav-visible");this.timeout=setTimeout(function(){_this2.state.$html.classList.add("nav-in");_this2.state.$html.classList.remove("search-in");_this2.state.$html.classList.remove("search-visible");},1);}},{key:'hideNav',value:function hideNav(){var _this3=this;this.state.$html.classList.remove("nav-in");this.timeout=setTimeout(function(){_this3.state.$html.classList.remove("nav-visible");_this3.setState({"visible":false});},this.props.AnimationDuration);}},{key:'startSearch',value:function startSearch(e){e.preventDefault();var keyword=document.querySelector('#search-keyword').value;if(keyword&&keyword.length>2){window.location.hash='/filtra/'+escape(keyword);document.querySelector('#search-keyword').value='';}}},{key:'load',value:function load(){var _this4=this;this.props.FetchContent(this.props.BaseUrl+this.props.NavUrl,{},function(data){_this4.setState({"items":data.collections});},function(error){console.log(error);});}},{key:'render',value:function render(){var Location=this.props.Location;// if ( this.state.visible  ) {
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'main-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav-items'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'nav-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Archivio News')),this.state.items.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:item.id,className:"nav-item "+(Location==="#/categoria/"+item.slug?"active ":"")+item.slug},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"#/categoria/"+item.slug},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.name)));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'nav-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Cerca nell\'archivio')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'nav-item search'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.startSearch},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'search',id:'search-keyword',name:'search-keyword',placeholder:'Premi invio per cercare \u21B2'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'nav-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Scopri di pi\xF9')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'nav-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://facciafaccia.elezioni.io/',rel:'noopener',target:'_faccia'},'Faccia a Faccia')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'nav-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/leggi/come-funziona'},'Come funziona')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'nav-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/leggi/chi-siamo'},'Chi siamo')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'nav-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.facebook.com/elezioni.io/'},'Facebook')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'nav-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://twitter.com/elezioni_io'},'Twitter')))));// } else {
//	return null;
// }
}}]);return Nav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Nav);

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__page_css__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__page_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__page_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intro_js__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__items_js__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__text_js__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stats_js__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__timeline_js__ = __webpack_require__(637);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Page=function(_Component){_inherits(Page,_Component);function Page(props){_classCallCheck(this,Page);var _this=_possibleConstructorReturn(this,(Page.__proto__||Object.getPrototypeOf(Page)).call(this,props));_this.choose=_this.choose.bind(_this);_this.returnComponent=_this.returnComponent.bind(_this);_this.state={"show":null};return _this;}_createClass(Page,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.Location&&prevProps.Location!==this.props.Location){this.choose();}if(prevProps.IsHome!==this.props.IsHome){if(this.props.IsHome){document.documentElement.classList.add('home');}else{document.documentElement.classList.remove('home');}}}},{key:'choose',value:function choose(){if(this.props.Location){if(this.props.Location.indexOf('#/leggi')>-1){this.setState({"show":"page"});}else if(this.props.Location.indexOf('#/analisi')>-1){this.setState({"show":"stats"});}else if(this.props.Location.indexOf('#/timeline')>-1){this.setState({"show":"timeline"});}else if(this.props.Location.indexOf('#/categoria')>-1){this.setState({"show":"items"});}else if(this.props.Location.indexOf('#/filtra')>-1){this.setState({"show":"items"});}else{this.setState({"show":"home"});}}}},{key:'returnComponent',value:function returnComponent(){switch(this.state.show){case"home":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__intro_js__["a" /* default */],{IsHome:this.props.IsHome,BaseUrl:this.props.BaseUrl,SummaryUrl:this.props.SummaryUrl,FetchContent:this.props.FetchContent,ShowLoading:this.props.ShowLoading,Data:this.props.Data,SetTitle:this.props.SetTitle});case"items":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__items_js__["a" /* default */],{BaseUrl:this.props.BaseUrl,BrowseUrl:this.props.BrowseUrl,FilterUrl:this.props.FilterUrl,StatsUrl:this.props.StatsUrl,PopularityUrl:this.props.PopularityUrl,TopicsUrl:this.props.TopicsUrl,Location:this.props.Location,FetchContent:this.props.FetchContent,ShowLoading:this.props.ShowLoading,AnimationDuration:this.props.AnimationDuration,SetTitle:this.props.SetTitle,VizUrl:this.props.VizUrl});case"stats":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__stats_js__["a" /* default */],{FetchContent:this.props.FetchContent,ShowLoading:this.props.ShowLoading,BaseUrl:this.props.BaseUrl,VizUrl:this.props.VizUrl,AnimationDuration:this.props.AnimationDuration,SetTitle:this.props.SetTitle});case"timeline":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__timeline_js__["a" /* default */],{FetchContent:this.props.FetchContent,ShowLoading:this.props.ShowLoading,BaseUrl:this.props.BaseUrl,VizUrl:this.props.VizUrl,AnimationDuration:this.props.AnimationDuration,TopicsUrl:this.props.TopicsUrl,SetTitle:this.props.SetTitle});case"page":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__text_js__["a" /* default */],{Location:this.props.Location,FetchContent:this.props.FetchContent,ShowLoading:this.props.ShowLoading,AnimationDuration:this.props.AnimationDuration,SetTitle:this.props.SetTitle});default:return null;}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'main-content'},this.returnComponent());}}]);return Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Page);

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__intro_css__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__intro_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__intro_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dataviz_summary_js__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dataviz_results_js__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dataviz_keywords_js__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dataviz_leaders_js__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dataviz_timeline_js__ = __webpack_require__(617);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Intro=function(_Component){_inherits(Intro,_Component);function Intro(props){_classCallCheck(this,Intro);var _this=_possibleConstructorReturn(this,(Intro.__proto__||Object.getPrototypeOf(Intro)).call(this,props));_this.state={"collections":[],"logs":[]};return _this;}_createClass(Intro,[{key:'componentDidMount',value:function componentDidMount(){this.props.SetTitle('');this.props.ShowLoading(false);}},{key:'render',value:function render(){if(this.props.IsHome){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'intro'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'intro--claim in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'intro--claim--text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Le elezioni sono passate,',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'questo \xE8 quello che abbiamo imparato'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Durante la campagna elettorale abbiamo monitorato i social network e i media nazionali per capire se e come i media hanno influenzato il voto, e quali sono state le parole chiave pi\xF9 importanti.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Quelle che seguono sono delle visualizzazioni che aiutano a capire cosa \xE8 successo, e perch\xE9.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__dataviz_summary_js__["a" /* default */],{Data:this.props.Data}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__dataviz_results_js__["a" /* default */],{Data:this.props.Data}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__dataviz_keywords_js__["a" /* default */],{Data:this.props.Data}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__dataviz_leaders_js__["a" /* default */],{Data:this.props.Data}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__dataviz_timeline_js__["a" /* default */],{Data:this.props.Data}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'archives in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'archives--legend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'archives--legend--item item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Gli Archivi')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Grazie per essere arrivato fino a qui :). Oltre alle aggregazioni che ti abbiamo mostrato, sono ancora disponibili i nostri archivi, dove potrai trovare tutti i ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'28.837'),' articoli che abbiamo utilizzato per analizzare l\'andamento delle elezioni. Questi articoli, categorizzati grazie all\'aiuto di un motore di intelligenza artificiale, sono accessibili tramite le categorie che corrispondono agli schieramenti ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/#/categoria/destra'},'Destra'),', ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/#/categoria/centro-destra'},'Centro Destra'),', ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/#/categoria/m5s'},'Movimento 5 Stelle'),', ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/#/categoria/centro-sinistra'},'Centro Sinista'),', e ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/#/categoria/sinistra'},'Sinistra'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\xC8 inoltre possibile cercare tra le news, utilizzando il form nel menu di navigazione o cliccando sui ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'#tag'),' associati alle singole news.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Se sei uno sviluppatore, o solamente curioso di vedere come sono i dati non aggregati, puoi trovare un ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://github.com/leeppolis/elezioni-io-data'},'export del nostro database su Github'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Le pagine ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/#/leggi/chi-siamo'},'Chi Siamo'),' e ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/#/leggi/come-funziona'},'Come Funziona'),', oltre a ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://medium.com/simone-lippolis/elezioni-io-is-a-news-aggregator-and-analysis-tool-about-the-italian-general-elections-held-on-e664001fec7a'},'questo articolo'),' (in inglese) pubblicato su ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://medium.com'},'Medium'),', spiegano chi siamo, perch\xE9 l\'abbiamo fatto, e come. Se vuoi metterti in contatto con noi, per qualunque motivo, i nostri account ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://twitter.com/elezioni_io'},'Twitter'),' e ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.facebook.com/elezioni.io/'},'Facebook'),' sono il posto giusto per farlo.'))))))));}else{return null;}}}]);return Intro;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Intro);

/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_waypoint__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_markdown__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_helpers_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__summary_css__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__summary_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__summary_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_summary_json__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_summary_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__data_summary_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Summary=function(_Component){_inherits(Summary,_Component);function Summary(props){_classCallCheck(this,Summary);var _this=_possibleConstructorReturn(this,(Summary.__proto__||Object.getPrototypeOf(Summary)).call(this,props));_this.summaryChart=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.areaDestra=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.areaCentroDestra=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.areaSinistra=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.areaCentroSinistra=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.areaM5S=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.draw=_this.draw.bind(_this);_this.getCoalitions=_this.getCoalitions.bind(_this);_this.getMilestone=_this.getMilestone.bind(_this);_this.getTotalNumberOfArticles=_this.getTotalNumberOfArticles.bind(_this);_this.outputSVG=_this.outputSVG.bind(_this);_this.switchView=_this.switchView.bind(_this);_this.viewbox=_this.viewbox.bind(_this);_this.waypointPositionChanged=_this.waypointPositionChanged.bind(_this);_this.state={"labels":{},"paths":{},"ready":false,"show":"numbers","size":{"h":0,"w":0},"step":-1,"totals":{"days":126,"global":_this.getTotalNumberOfArticles(),"destra":_this.getTotalNumberOfArticles('destra'),"centro-destra":_this.getTotalNumberOfArticles('centro-destra'),"centro-sinistra":_this.getTotalNumberOfArticles('centro-sinistra'),"sinistra":_this.getTotalNumberOfArticles('sinistra'),"m5s":_this.getTotalNumberOfArticles('m5s')}};return _this;}_createClass(Summary,[{key:'componentDidMount',value:function componentDidMount(){this.viewbox();window.addEventListener('resize',this.viewbox,false);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevState.paths&&prevState.paths!==this.state.paths||!prevState.paths){__WEBPACK_IMPORTED_MODULE_4_d3__["g" /* select */](this.areaDestra).transition().ease(__WEBPACK_IMPORTED_MODULE_4_d3__["d" /* easePoly */]).duration(750).attr("d",this.state.paths.destra);__WEBPACK_IMPORTED_MODULE_4_d3__["g" /* select */](this.areaSinistra).transition().ease(__WEBPACK_IMPORTED_MODULE_4_d3__["d" /* easePoly */]).duration(750).attr("d",this.state.paths.sinistra);__WEBPACK_IMPORTED_MODULE_4_d3__["g" /* select */](this.areaCentroSinistra).transition().ease(__WEBPACK_IMPORTED_MODULE_4_d3__["d" /* easePoly */]).duration(750).attr("d",this.state.paths.centrosinistra);__WEBPACK_IMPORTED_MODULE_4_d3__["g" /* select */](this.areaM5S).transition().ease(__WEBPACK_IMPORTED_MODULE_4_d3__["d" /* easePoly */]).duration(750).attr("d",this.state.paths.m5s);__WEBPACK_IMPORTED_MODULE_4_d3__["g" /* select */](this.areaCentroDestra).transition().ease(__WEBPACK_IMPORTED_MODULE_4_d3__["d" /* easePoly */]).duration(750).attr("d",this.state.paths.centrodestra);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.viewbox,false);}},{key:'draw',value:function draw(){var _this2=this;var topBaseY=0;var bottomBaseY=this.state.size.h-60;var scaleY=void 0;var scaleX=__WEBPACK_IMPORTED_MODULE_4_d3__["f" /* scaleLinear */]().domain([this.props.Data.data.timeline['centro-destra'][0].timestamp,this.props.Data.data.timeline['centro-destra'][this.props.Data.data.timeline['centro-destra'].length-1].timestamp]).range([0,this.state.size.w]);if(this.state.show==='numbers'){scaleY=__WEBPACK_IMPORTED_MODULE_4_d3__["f" /* scaleLinear */]().domain([0,this.props.Data.data.timeline['max'].activity]).range([bottomBaseY,topBaseY]);}else{scaleY=__WEBPACK_IMPORTED_MODULE_4_d3__["f" /* scaleLinear */]().domain([0,100]).range([bottomBaseY,topBaseY]);}var activityArea=__WEBPACK_IMPORTED_MODULE_4_d3__["b" /* area */]().x(function(points){return points.x;}).y1(function(points){return points.y;}).y0(function(points){return bottomBaseY;}).curve(__WEBPACK_IMPORTED_MODULE_4_d3__["c" /* curveBasis */]);var basepoints={};var basepointsPerc={};this.props.Data.data.timeline['centro-destra'].forEach(function(item){basepoints[item.timestamp]=0;basepointsPerc[item.timestamp]=0;});var destra=[];/* */this.props.Data.data.timeline['destra'].forEach(function(item){basepoints[item.timestamp]=basepoints[item.timestamp]+parseInt(item.activity,10);basepointsPerc[item.timestamp]=basepointsPerc[item.timestamp]+parseInt(item.activity_perc,10);destra.push({"a":item.activity,"b":basepoints[item.timestamp],"t":item.timestamp,"x":scaleX(item.timestamp),"y":_this2.state.show==='numbers'?scaleY(basepoints[item.timestamp]):scaleY(basepointsPerc[item.timestamp])});});/* */var sinistra=[];/* */this.props.Data.data.timeline['sinistra'].forEach(function(item){basepoints[item.timestamp]=basepoints[item.timestamp]+parseInt(item.activity,10);basepointsPerc[item.timestamp]=basepointsPerc[item.timestamp]+parseInt(item.activity_perc,10);sinistra.push({"a":item.activity,"b":basepoints[item.timestamp],"t":item.timestamp,"x":scaleX(item.timestamp),"y":_this2.state.show==='numbers'?scaleY(basepoints[item.timestamp]):scaleY(basepointsPerc[item.timestamp])});});/* */var centrosinistra=[];this.props.Data.data.timeline['centro-sinistra'].forEach(function(item){basepoints[item.timestamp]=basepoints[item.timestamp]+parseInt(item.activity,10);basepointsPerc[item.timestamp]=basepointsPerc[item.timestamp]+parseInt(item.activity_perc,10);centrosinistra.push({"a":item.activity,"b":basepoints[item.timestamp],"t":item.timestamp,"x":scaleX(item.timestamp),"y":_this2.state.show==='numbers'?scaleY(basepoints[item.timestamp]):scaleY(basepointsPerc[item.timestamp])});});/* */var m5s=[];this.props.Data.data.timeline['m5s'].forEach(function(item){basepoints[item.timestamp]=basepoints[item.timestamp]+parseInt(item.activity,10);basepointsPerc[item.timestamp]=basepointsPerc[item.timestamp]+parseInt(item.activity_perc,10);m5s.push({"a":item.activity,"b":basepoints[item.timestamp],"t":item.timestamp,"x":scaleX(item.timestamp),"y":_this2.state.show==='numbers'?scaleY(basepoints[item.timestamp]):scaleY(basepointsPerc[item.timestamp])});});/* */var centrodestra=[];this.props.Data.data.timeline['centro-destra'].forEach(function(item){basepoints[item.timestamp]=basepoints[item.timestamp]+parseInt(item.activity,10);basepointsPerc[item.timestamp]=basepointsPerc[item.timestamp]+parseInt(item.activity_perc,10);centrodestra.push({"a":item.activity,"b":basepoints[item.timestamp],"t":item.timestamp,"x":scaleX(item.timestamp),"y":_this2.state.show==='numbers'?scaleY(basepoints[item.timestamp]):scaleY(100)});});var electionDay=new Date('2018-03-04T07:00:00').getTime()/1000;var electionDayX=scaleX(electionDay);var electionDayEnd=new Date('2018-03-04T23:00:00').getTime()/1000;var electionDayEndX=scaleX(electionDayEnd);var coalitions=this.getCoalitions(scaleX,scaleY,topBaseY,bottomBaseY);var calendar=[];var startDay=new Date('2018-02-01T00:00:00').getTime()/1000;var endDay=this.props.Data.data.timeline['centro-destra'][this.props.Data.data.timeline['centro-destra'].length-1].timestamp;startDay+=60*60*24*14;while(startDay<endDay){calendar.push({"x":scaleX(startDay),"y1":bottomBaseY,"y2":bottomBaseY+5,"y":bottomBaseY+18,"label":Object(__WEBPACK_IMPORTED_MODULE_3__helpers_helpers_js__["b" /* formatDate */])(startDay)});startDay+=60*60*24*14;}this.setState({"paths":{"destra":activityArea(destra),"centrodestra":activityArea(centrodestra),"m5s":activityArea(m5s),"centrosinistra":activityArea(centrosinistra),"sinistra":activityArea(sinistra),"xAxis":{"x1":0,"y1":bottomBaseY,"x2":this.state.size.w,"y2":bottomBaseY,"legend":{"pre":{"arrow":"M"+(electionDayX-5)+","+(topBaseY+15)+" L"+(electionDayX-10)+","+(topBaseY+12)+" L"+(electionDayX-10)+","+(topBaseY+18)+"Z","line":{"x1":2,"y1":topBaseY+15,"x2":electionDayX-5,"y2":topBaseY+15},"stopper":{"x1":2,"y1":topBaseY+12,"x2":2,"y2":topBaseY+18},"label":{"x":2+(electionDayX-5-2)/2,"y":topBaseY+10}},"post":{"arrow":"M"+(electionDayEndX+3)+","+(topBaseY+15)+" L"+(electionDayEndX+8)+","+(topBaseY+12)+" L"+(electionDayEndX+8)+","+(topBaseY+18)+"Z","line":{"x1":this.state.size.w-2,"y1":topBaseY+15,"x2":electionDayEndX+5,"y2":topBaseY+15},"stopper":{"x1":this.state.size.w-2,"y1":topBaseY+12,"x2":this.state.size.w-2,"y2":topBaseY+18},"label":{"x":electionDayEndX+3+(this.state.size.w-2-(electionDayEndX+3))/2,"y":topBaseY+10}}}},"start":{"x1":1,"y1":bottomBaseY,"x2":1,"y2":bottomBaseY+15},"end":{"x1":this.state.size.w-1,"y1":bottomBaseY,"x2":this.state.size.w-1,"y2":bottomBaseY+15},"dates":calendar,"election":{"x1":electionDayX,"y1":bottomBaseY,"x2":electionDayX,"y2":bottomBaseY+15,"x3":electionDayEndX,"x4":electionDayEndX,"y3":bottomBaseY,"y4":bottomBaseY+15,"y5":topBaseY,"area":"M"+electionDayX+","+bottomBaseY+" L"+electionDayEndX+","+bottomBaseY+" L"+electionDayEndX+","+topBaseY+" L"+electionDayX+","+topBaseY+"Z"},"coalitions":coalitions},"labels":{"start":{"x":4,"y":bottomBaseY+30,"label":Object(__WEBPACK_IMPORTED_MODULE_3__helpers_helpers_js__["b" /* formatDate */])(this.props.Data.data.timeline['centro-destra'][0].timestamp)},"end":{"x":this.state.size.w-4,"y":bottomBaseY+30,"label":Object(__WEBPACK_IMPORTED_MODULE_3__helpers_helpers_js__["b" /* formatDate */])(this.props.Data.data.timeline['centro-destra'][this.props.Data.data.timeline['centro-destra'].length-1].timestamp)},"election":{"x":electionDayX+(electionDayEndX-electionDayX)/2,"y":bottomBaseY+30,"label":Object(__WEBPACK_IMPORTED_MODULE_3__helpers_helpers_js__["b" /* formatDate */])(electionDay),"y1":bottomBaseY+44,"label1":"Seggi Aperti 7-23"}},"ready":true});}},{key:'getCoalitions',value:function getCoalitions(scaleX,scaleY,topBaseY,bottomBaseY){var _this3=this;var output=[];__WEBPACK_IMPORTED_MODULE_6__data_summary_json___default.a.forEach(function(item){var milestones=[];item.milestones.forEach(function(milestone,index){var detail=_this3.getMilestone(milestone);var xPos=scaleX(detail.timestamp_order);var elevation=25;if(index%2===1){elevation=50;}milestones.push({"line":{"x1":xPos,"y1":topBaseY+20+elevation,"x2":xPos,"y2":bottomBaseY},"text":{"x":xPos,"y":topBaseY+12+elevation,"alignment":"left","elevation":0,"label":index+1},"path":"M"+xPos+","+(topBaseY+25+elevation)+" L"+(xPos+3)+","+(topBaseY+20+elevation)+" L"+(xPos-3)+","+(topBaseY+20+elevation)+"Z","circle":{"cx":xPos,"cy":topBaseY+11+elevation,"r":9}});});var coalition={"id":item.id,"milestones":milestones};output.push(coalition);});return output;}},{key:'getMilestone',value:function getMilestone(id){var output=null;id=parseInt(id,10);this.props.Data.data.milestones.forEach(function(milestone){if(parseInt(milestone.dbid,10)===id){output=milestone;}});return output||false;}},{key:'getTotalNumberOfArticles',value:function getTotalNumberOfArticles(area){var total=0;if(area){for(var element in this.props.Data.data.timeline[area]){total+=parseInt(this.props.Data.data.timeline[area][element].activity,10);}}else{for(var property in this.props.Data.data.timeline){if(property!=='max'){if(this.props.Data.data.timeline.hasOwnProperty(property)){for(var _element in this.props.Data.data.timeline[property]){total+=parseInt(this.props.Data.data.timeline[property][_element].activity,10)||0;}}}}}return total;}},{key:'outputSVG',value:function outputSVG(){var _this4=this;if(this.state.ready){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{viewport:"0 0 "+this.state.size.w+' '+this.state.size.h,preserveAspectRatio:'xMidYMid meet',width:this.state.size.w,height:this.state.size.h},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'areas-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'',className:'centro-destra',ref:function ref(path){return _this4.areaCentroDestra=path;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'',className:'m5s',ref:function ref(path){return _this4.areaM5S=path;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'',className:'centro-sinistra',ref:function ref(path){return _this4.areaCentroSinistra=path;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'',className:'sinistra',ref:function ref(path){return _this4.areaSinistra=path;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'',className:'destra',ref:function ref(path){return _this4.areaDestra=path;}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'x-axis'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.xAxis.x1,x2:this.state.paths.xAxis.x2,y1:this.state.paths.xAxis.y1,y2:this.state.paths.xAxis.y2}),this.state.paths.dates.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{key:item.x,className:'calendar-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:item.x,x2:item.x,y1:item.y1,y2:item.y2,className:'date'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:item.x,y:item.y,className:'label-date'},item.label));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'vertical-lines vertical-lines-labels'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.start.x1,x2:this.state.paths.start.x2,y1:this.state.paths.start.y1,y2:this.state.paths.start.y2,className:'start'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.state.labels.start.x,y:this.state.labels.start.y,className:'label-start'},this.state.labels.start.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.end.x1,x2:this.state.paths.end.x2,y1:this.state.paths.end.y1,y2:this.state.paths.end.y2,className:'end'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.state.labels.end.x,y:this.state.labels.end.y,className:'label-end'},this.state.labels.end.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.election.x1,x2:this.state.paths.election.x2,y1:this.state.paths.election.y1,y2:this.state.paths.election.y2,className:'election'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.election.x3,x2:this.state.paths.election.x4,y1:this.state.paths.election.y3,y2:this.state.paths.election.y4,className:'election'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.state.labels.election.x,y:this.state.labels.election.y,className:'label-election'},this.state.labels.election.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.state.labels.election.x,y:this.state.labels.election.y1,className:'label-election'},this.state.labels.election.label1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:this.state.paths.election.area,className:'electionArea'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.election.x1,x2:this.state.paths.election.x2,y1:this.state.paths.election.y1,y2:this.state.paths.election.y5,className:'electionLine'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.election.x3,x2:this.state.paths.election.x4,y1:this.state.paths.election.y1,y2:this.state.paths.election.y5,className:'electionLine'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'horizontal-lines horizontal-lines-labels'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'pre'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'stopper',x1:this.state.paths.xAxis.legend.pre.stopper.x1,y1:this.state.paths.xAxis.legend.pre.stopper.y1,x2:this.state.paths.xAxis.legend.pre.stopper.x2,y2:this.state.paths.xAxis.legend.pre.stopper.y2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'arrow',d:this.state.paths.xAxis.legend.pre.arrow}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'line',x1:this.state.paths.xAxis.legend.pre.line.x1,y1:this.state.paths.xAxis.legend.pre.line.y1,x2:this.state.paths.xAxis.legend.pre.line.x2,y2:this.state.paths.xAxis.legend.pre.line.y2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{className:'label',x:this.state.paths.xAxis.legend.pre.label.x,y:this.state.paths.xAxis.legend.pre.label.y},'Prima')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'post'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'stopper',x1:this.state.paths.xAxis.legend.post.stopper.x1,y1:this.state.paths.xAxis.legend.post.stopper.y1,x2:this.state.paths.xAxis.legend.post.stopper.x2,y2:this.state.paths.xAxis.legend.post.stopper.y2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'arrow',d:this.state.paths.xAxis.legend.post.arrow}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'line',x1:this.state.paths.xAxis.legend.post.line.x1,y1:this.state.paths.xAxis.legend.post.line.y1,x2:this.state.paths.xAxis.legend.post.line.x2,y2:this.state.paths.xAxis.legend.post.line.y2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{className:'label',x:this.state.paths.xAxis.legend.post.label.x,y:this.state.paths.xAxis.legend.post.label.y},'Dopo'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'milestones-lines'},this.state.paths.coalitions.map(function(coalition,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:"milestones-lines-group milestones-lines-"+coalition.id,key:'C-'+index},coalition.milestones.map(function(milestone,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{key:'CM-'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:milestone.line.x1,x2:milestone.line.x2,y1:milestone.line.y1,y2:milestone.line.y2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:milestone.path,className:'milestones-lines-arrow'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{cx:milestone.circle.cx,cy:milestone.circle.cy,r:milestone.circle.r}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:milestone.text.x,y:milestone.text.y,className:"milestone-lines-"+milestone.text.alignement+" milestone.lines-"+milestone.text.elevation},milestone.text.label));}));})));}else{return null;}}},{key:'switchView',value:function switchView(show){var _this5=this;if(show!==this.state.show){this.setState({show:show},function(){_this5.draw();});}}},{key:'viewbox',value:function viewbox(){var _this6=this;var svgWrapper=this.summaryChart.current.querySelector('.summary--chart--wrapper');var size={"h":svgWrapper.offsetHeight,"w":svgWrapper.offsetWidth};this.setState({size:size},function(){_this6.draw();});}},{key:'waypointPositionChanged',value:function waypointPositionChanged(pos,step){if(pos.currentPosition==='inside'){this.setState({step:step});}if(step===0&&pos.currentPosition==='below'){step=-1;this.setState({step:step});}if(step===5&&pos.currentPosition==='above'){step=-1;this.setState({step:step});}}},{key:'render',value:function render(){var _this7=this;var getMilestone=this.getMilestone;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'summary in','data-step':this.state.step,'data-view':this.state.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'summary--legend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'summary--legend--item item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Gli schieramenti')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Iniziamo dalla copertura data dai giornali alle diverse coalizioni: abbiamo raccolto e analizzato un totale di ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'28.837 articoli'),', e questa \xE8 la situazione generale durante il periodo monitorato: dal primo di febbraio al 6 giugno, pochi giorni dopo il giuramento del nuovo governo.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Come sono stai raccolti gli articoli?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Abbiamo utilizzato un metodo semplice: un nostro bot ha monitorato Twitter per una serie di parole chiave, e da questi tweet ha estratto eventuali link ad articoli di testate online (la ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'white-list'),' delle nostre fonti comprende testate registrate in Italia che abbiano un sito internet).'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Questi articoli sono stati poi analizzati in maniera automatica al fine di categorizzarli per capire ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'di chi'),' parlano. Quando parliamo di "',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'attivit\xE0'),'" di uno schieramento intendiamo quanti articoli che parlano di lui sono stati pubblicati. Maggiori informazioni sono disponibili nella pagina ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/#/leggi/come-funziona/'},'come funziona'),' o in ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://medium.com/simone-lippolis/elezioni-io-is-a-news-aggregator-and-analysis-tool-about-the-italian-general-elections-held-on-e664001fec7a'},'questo articolo pubblicato su Medium'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Gli schieramenti'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Il progetto ha avuto inizio quando ancora lo scenario politico italiano era suddiviso in ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'cinque principali schieramenti'),' e tutte le nostre analisi riflettono questa realt\xE0: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'Destra'),', ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'Centro Destra'),', ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'Movimento 5 Stelle'),', ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'Centro Sinistra'),', e ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'Sinistra'),'. All\'interno degli schieramenti sono stati raggruppati partiti e movimenti che non si sono necessariamente presentati assieme alle elezioni, ma che erano affini da un punto di vista politico-ideologico.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'I risultati delle elezioni'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Nelle tabelle che seguono vedrete riportate delle percentuali descritte come "',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'risultati elettorali'),'": la fonte di questi dati \xE8 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.cattaneo.org/wp-content/uploads/2018/03/Analisi-Istituto-Cattaneo-Elezioni-Politiche-2018-Chi-ha-vinto-chi-ha-perso-5-marzo-2018-2.pdf'},'questo documento dell\'Istituto Cattaneo'),'.')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'summary--chart',ref:this.summaryChart},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'summary--chart--wrapper'},this.outputSVG()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'summary--chart--switch'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){if(_this7.state.step!==0&&_this7.state.step!==6){_this7.switchView('percent');}},className:this.state.show==='percent'?'active':''},'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){if(_this7.state.step!==0&&_this7.state.step!==6){_this7.switchView('numbers');}},className:this.state.show==='numbers'?'active':''},'#')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'summary--legend'},__WEBPACK_IMPORTED_MODULE_6__data_summary_json___default.a.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_waypoint__["a" /* default */],{onPositionChange:function onPositionChange(position){_this7.waypointPositionChanged(position,index);},topOffset:'40%',bottomOffset:'10%',key:'K-'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'summary--legend--item item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,item.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_markdown___default.a,{source:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_helpers_js__["d" /* prepareMarkDown */])(item.body)}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--stats data'},item.data.map(function(topic,index){var content=void 0;var id=void 0;var avg=void 0;var percent=void 0;var data=void 0;if(topic.body){content=topic.body;}else if(topic.function){switch(topic.function){case'Activity-Average':id=item.id;if(id==='intro'||id==='conclusioni'){id='global';}avg=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_helpers_js__["c" /* formatNumber */])(Math.round(_this7.state.totals[id]/_this7.state.totals.days));content='# '+avg;break;case'Activity-Total':id=item.id;if(id==='intro'||id==='conclusioni'){id='global';}content='# '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_helpers_js__["c" /* formatNumber */])(_this7.state.totals[id]);break;case'Percentage-Activity':id=item.id;if(id==='intro'||id==='conclusioni'){id='global';}percent=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_helpers_js__["c" /* formatNumber */])((_this7.state.totals[id]*100/_this7.state.totals.global).toFixed(2));content='# '+percent+'%';break;case'Percentage-Total':data=topic.data.split('|');percent=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_helpers_js__["c" /* formatNumber */])((_this7.state.totals[data[0]]*100/_this7.state.totals.global).toFixed(2));content='## '+percent+'% - '+data[1]+'\n### (attività - risultati)'+(data[2]?'\n#### '+data[2]:'');break;default:break;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'data--item',key:'T-'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'data--item--title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,topic.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'data--item--body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_markdown___default.a,{source:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_helpers_js__["d" /* prepareMarkDown */])(content)})));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--milestones--title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Eventi importanti')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--milestones'},item.milestones.map(function(milestoneId,index){var milestone=getMilestone(milestoneId);if(milestone){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',{className:'item--milestone',key:'M-'+item.id+'-'+milestone.dbid+'-'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--milestone--title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'badge'},index+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_3__helpers_helpers_js__["b" /* formatDate */])(milestone.timestamp_published),' \u2014 ',milestone.source),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:milestone.url,target:'_read_'},milestone.title))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--milestone--body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:milestone.url,target:'_read_'},Object(__WEBPACK_IMPORTED_MODULE_3__helpers_helpers_js__["a" /* createAbstract */])(milestone.description),' (continua a leggere su ',milestone.source,')'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--milestone--tags'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'intro'},'Tags:'),milestone.tags.map(function(tag,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:tag+'-'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"/#/filtra/"+escape(tag.trim())},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,tag.trim())));}))));}else{return null;}}))));})));}}]);return Summary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Summary);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// Adapted from Modernizr
// https://github.com/Modernizr/Modernizr/blob/acb3f0d9/feature-detects/dom/passiveeventlisteners.js#L26-L37
function testPassiveEventListeners() {
  if (!CAN_USE_DOM) {
    return false;
  }

  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
    return false;
  }

  var supportsPassiveOption = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      // eslint-disable-next-line getter-return
      get: function () {
        function get() {
          supportsPassiveOption = true;
        }

        return get;
      }()
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, opts);
    window.removeEventListener('testPassiveEventSupport', noop, opts);
  } catch (e) {
    // do nothing
  }

  return supportsPassiveOption;
}

var memoized = void 0;

function canUsePassiveEventListeners() {
  if (memoized === undefined) {
    memoized = testPassiveEventListeners();
  }
  return memoized;
}

function normalizeEventOptions(eventOptions) {
  if (!eventOptions) {
    return undefined;
  }

  if (!canUsePassiveEventListeners()) {
    // If the browser does not support the passive option, then it is expecting
    // a boolean for the options argument to specify whether it should use
    // capture or not. In more modern browsers, this is passed via the `capture`
    // option, so let's just hoist that value up.
    return !!eventOptions.capture;
  }

  return eventOptions;
}

/* eslint-disable no-bitwise */

/**
 * Generate a unique key for any set of event options
 */
function eventOptionsKey(normalizedEventOptions) {
  if (!normalizedEventOptions) {
    return 0;
  }

  // If the browser does not support passive event listeners, the normalized
  // event options will be a boolean.
  if (normalizedEventOptions === true) {
    return 100;
  }

  // At this point, the browser supports passive event listeners, so we expect
  // the event options to be an object with possible properties of capture,
  // passive, and once.
  //
  // We want to consistently return the same value, regardless of the order of
  // these properties, so let's use binary maths to assign each property to a
  // bit, and then add those together (with an offset to account for the
  // booleans at the beginning of this function).
  var capture = normalizedEventOptions.capture << 0;
  var passive = normalizedEventOptions.passive << 1;
  var once = normalizedEventOptions.once << 2;
  return capture + passive + once;
}

function ensureCanMutateNextEventHandlers(eventHandlers) {
  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
    // eslint-disable-next-line no-param-reassign
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
  }
}

function TargetEventHandlers(target) {
  this.target = target;
  this.events = {};
}

TargetEventHandlers.prototype.getEventHandlers = function () {
  function getEventHandlers(eventName, options) {
    var key = String(eventName) + ' ' + String(eventOptionsKey(options));

    if (!this.events[key]) {
      this.events[key] = {
        handlers: [],
        handleEvent: undefined
      };
      this.events[key].nextHandlers = this.events[key].handlers;
    }

    return this.events[key];
  }

  return getEventHandlers;
}();

TargetEventHandlers.prototype.handleEvent = function () {
  function handleEvent(eventName, options, event) {
    var eventHandlers = this.getEventHandlers(eventName, options);
    eventHandlers.handlers = eventHandlers.nextHandlers;
    eventHandlers.handlers.forEach(function (handler) {
      if (handler) {
        // We need to check for presence here because a handler function may
        // cause later handlers to get removed. This can happen if you for
        // instance have a waypoint that unmounts another waypoint as part of an
        // onEnter/onLeave handler.
        handler(event);
      }
    });
  }

  return handleEvent;
}();

TargetEventHandlers.prototype.add = function () {
  function add(eventName, listener, options) {
    var _this = this;

    // options has already been normalized at this point.
    var eventHandlers = this.getEventHandlers(eventName, options);

    ensureCanMutateNextEventHandlers(eventHandlers);

    if (eventHandlers.nextHandlers.length === 0) {
      eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);

      this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
    }

    eventHandlers.nextHandlers.push(listener);

    var isSubscribed = true;
    var unsubscribe = function () {
      function unsubscribe() {
        if (!isSubscribed) {
          return;
        }

        isSubscribed = false;

        ensureCanMutateNextEventHandlers(eventHandlers);
        var index = eventHandlers.nextHandlers.indexOf(listener);
        eventHandlers.nextHandlers.splice(index, 1);

        if (eventHandlers.nextHandlers.length === 0) {
          // All event handlers have been removed, so we want to remove the event
          // listener from the target node.

          if (_this.target) {
            // There can be a race condition where the target may no longer exist
            // when this function is called, e.g. when a React component is
            // unmounting. Guarding against this prevents the following error:
            //
            //   Cannot read property 'removeEventListener' of undefined
            _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
          }

          eventHandlers.handleEvent = undefined;
        }
      }

      return unsubscribe;
    }();
    return unsubscribe;
  }

  return add;
}();

var EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';

// eslint-disable-next-line import/prefer-default-export
function addEventListener(target, eventName, listener, options) {
  if (!target[EVENT_HANDLERS_KEY]) {
    // eslint-disable-next-line no-param-reassign
    target[EVENT_HANDLERS_KEY] = new TargetEventHandlers(target);
  }
  var normalizedEventOptions = normalizeEventOptions(options);
  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}




/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(228);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(230);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* Dependencies. */
var extend = __webpack_require__(232)
var bail = __webpack_require__(233)
var vfile = __webpack_require__(234)
var trough = __webpack_require__(240)
var string = __webpack_require__(242)
var plain = __webpack_require__(243)

/* Expose a frozen processor. */
module.exports = unified().freeze()

var slice = [].slice
var own = {}.hasOwnProperty

/* Process pipeline. */
var pipeline = trough()
  .use(pipelineParse)
  .use(pipelineRun)
  .use(pipelineStringify)

function pipelineParse(p, ctx) {
  ctx.tree = p.parse(ctx.file)
}

function pipelineRun(p, ctx, next) {
  p.run(ctx.tree, ctx.file, done)

  function done(err, tree, file) {
    if (err) {
      next(err)
    } else {
      ctx.tree = tree
      ctx.file = file
      next()
    }
  }
}

function pipelineStringify(p, ctx) {
  ctx.file.contents = p.stringify(ctx.tree, ctx.file)
}

/* Function to create the first processor. */
function unified() {
  var attachers = []
  var transformers = trough()
  var namespace = {}
  var frozen = false
  var freezeIndex = -1

  /* Data management. */
  processor.data = data

  /* Lock. */
  processor.freeze = freeze

  /* Plug-ins. */
  processor.attachers = attachers
  processor.use = use

  /* API. */
  processor.parse = parse
  processor.stringify = stringify
  processor.run = run
  processor.runSync = runSync
  processor.process = process
  processor.processSync = processSync

  /* Expose. */
  return processor

  /* Create a new processor based on the processor
   * in the current scope. */
  function processor() {
    var destination = unified()
    var length = attachers.length
    var index = -1

    while (++index < length) {
      destination.use.apply(null, attachers[index])
    }

    destination.data(extend(true, {}, namespace))

    return destination
  }

  /* Freeze: used to signal a processor that has finished
   * configuration.
   *
   * For example, take unified itself.  It’s frozen.
   * Plug-ins should not be added to it.  Rather, it should
   * be extended, by invoking it, before modifying it.
   *
   * In essence, always invoke this when exporting a
   * processor. */
  function freeze() {
    var values
    var plugin
    var options
    var transformer

    if (frozen) {
      return processor
    }

    while (++freezeIndex < attachers.length) {
      values = attachers[freezeIndex]
      plugin = values[0]
      options = values[1]
      transformer = null

      if (options === false) {
        continue
      }

      if (options === true) {
        values[1] = undefined
      }

      transformer = plugin.apply(processor, values.slice(1))

      if (typeof transformer === 'function') {
        transformers.use(transformer)
      }
    }

    frozen = true
    freezeIndex = Infinity

    return processor
  }

  /* Data management.
   * Getter / setter for processor-specific informtion. */
  function data(key, value) {
    if (string(key)) {
      /* Set `key`. */
      if (arguments.length === 2) {
        assertUnfrozen('data', frozen)

        namespace[key] = value

        return processor
      }

      /* Get `key`. */
      return (own.call(namespace, key) && namespace[key]) || null
    }

    /* Set space. */
    if (key) {
      assertUnfrozen('data', frozen)
      namespace = key
      return processor
    }

    /* Get space. */
    return namespace
  }

  /* Plug-in management.
   *
   * Pass it:
   * *   an attacher and options,
   * *   a preset,
   * *   a list of presets, attachers, and arguments (list
   *     of attachers and options). */
  function use(value) {
    var settings

    assertUnfrozen('use', frozen)

    if (value === null || value === undefined) {
      /* Empty */
    } else if (typeof value === 'function') {
      addPlugin.apply(null, arguments)
    } else if (typeof value === 'object') {
      if ('length' in value) {
        addList(value)
      } else {
        addPreset(value)
      }
    } else {
      throw new Error('Expected usable value, not `' + value + '`')
    }

    if (settings) {
      namespace.settings = extend(namespace.settings || {}, settings)
    }

    return processor

    function addPreset(result) {
      addList(result.plugins)

      if (result.settings) {
        settings = extend(settings || {}, result.settings)
      }
    }

    function add(value) {
      if (typeof value === 'function') {
        addPlugin(value)
      } else if (typeof value === 'object') {
        if ('length' in value) {
          addPlugin.apply(null, value)
        } else {
          addPreset(value)
        }
      } else {
        throw new Error('Expected usable value, not `' + value + '`')
      }
    }

    function addList(plugins) {
      var length
      var index

      if (plugins === null || plugins === undefined) {
        /* Empty */
      } else if (typeof plugins === 'object' && 'length' in plugins) {
        length = plugins.length
        index = -1

        while (++index < length) {
          add(plugins[index])
        }
      } else {
        throw new Error('Expected a list of plugins, not `' + plugins + '`')
      }
    }

    function addPlugin(plugin, value) {
      var entry = find(plugin)

      if (entry) {
        if (plain(entry[1]) && plain(value)) {
          value = extend(entry[1], value)
        }

        entry[1] = value
      } else {
        attachers.push(slice.call(arguments))
      }
    }
  }

  function find(plugin) {
    var length = attachers.length
    var index = -1
    var entry

    while (++index < length) {
      entry = attachers[index]

      if (entry[0] === plugin) {
        return entry
      }
    }
  }

  /* Parse a file (in string or VFile representation)
   * into a Unist node using the `Parser` on the
   * processor. */
  function parse(doc) {
    var file = vfile(doc)
    var Parser

    freeze()
    Parser = processor.Parser
    assertParser('parse', Parser)

    if (newable(Parser)) {
      return new Parser(String(file), file).parse()
    }

    return Parser(String(file), file) // eslint-disable-line new-cap
  }

  /* Run transforms on a Unist node representation of a file
   * (in string or VFile representation), async. */
  function run(node, file, cb) {
    assertNode(node)
    freeze()

    if (!cb && typeof file === 'function') {
      cb = file
      file = null
    }

    if (!cb) {
      return new Promise(executor)
    }

    executor(null, cb)

    function executor(resolve, reject) {
      transformers.run(node, vfile(file), done)

      function done(err, tree, file) {
        tree = tree || node
        if (err) {
          reject(err)
        } else if (resolve) {
          resolve(tree)
        } else {
          cb(null, tree, file)
        }
      }
    }
  }

  /* Run transforms on a Unist node representation of a file
   * (in string or VFile representation), sync. */
  function runSync(node, file) {
    var complete = false
    var result

    run(node, file, done)

    assertDone('runSync', 'run', complete)

    return result

    function done(err, tree) {
      complete = true
      bail(err)
      result = tree
    }
  }

  /* Stringify a Unist node representation of a file
   * (in string or VFile representation) into a string
   * using the `Compiler` on the processor. */
  function stringify(node, doc) {
    var file = vfile(doc)
    var Compiler

    freeze()
    Compiler = processor.Compiler
    assertCompiler('stringify', Compiler)
    assertNode(node)

    if (newable(Compiler)) {
      return new Compiler(node, file).compile()
    }

    return Compiler(node, file) // eslint-disable-line new-cap
  }

  /* Parse a file (in string or VFile representation)
   * into a Unist node using the `Parser` on the processor,
   * then run transforms on that node, and compile the
   * resulting node using the `Compiler` on the processor,
   * and store that result on the VFile. */
  function process(doc, cb) {
    freeze()
    assertParser('process', processor.Parser)
    assertCompiler('process', processor.Compiler)

    if (!cb) {
      return new Promise(executor)
    }

    executor(null, cb)

    function executor(resolve, reject) {
      var file = vfile(doc)

      pipeline.run(processor, {file: file}, done)

      function done(err) {
        if (err) {
          reject(err)
        } else if (resolve) {
          resolve(file)
        } else {
          cb(null, file)
        }
      }
    }
  }

  /* Process the given document (in string or VFile
   * representation), sync. */
  function processSync(doc) {
    var complete = false
    var file

    freeze()
    assertParser('processSync', processor.Parser)
    assertCompiler('processSync', processor.Compiler)
    file = vfile(doc)

    process(file, done)

    assertDone('processSync', 'process', complete)

    return file

    function done(err) {
      complete = true
      bail(err)
    }
  }
}

/* Check if `func` is a constructor. */
function newable(value) {
  return typeof value === 'function' && keys(value.prototype)
}

/* Check if `value` is an object with keys. */
function keys(value) {
  var key
  for (key in value) {
    return true
  }
  return false
}

/* Assert a parser is available. */
function assertParser(name, Parser) {
  if (typeof Parser !== 'function') {
    throw new Error('Cannot `' + name + '` without `Parser`')
  }
}

/* Assert a compiler is available. */
function assertCompiler(name, Compiler) {
  if (typeof Compiler !== 'function') {
    throw new Error('Cannot `' + name + '` without `Compiler`')
  }
}

/* Assert the processor is not frozen. */
function assertUnfrozen(name, frozen) {
  if (frozen) {
    throw new Error(
      [
        'Cannot invoke `' + name + '` on a frozen processor.\nCreate a new ',
        'processor first, by invoking it: use `processor()` instead of ',
        '`processor`.'
      ].join('')
    )
  }
}

/* Assert `node` is a Unist node. */
function assertNode(node) {
  if (!node || !string(node.type)) {
    throw new Error('Expected node, got `' + node + '`')
  }
}

/* Assert that `complete` is `true`. */
function assertDone(name, asyncName, complete) {
  if (!complete) {
    throw new Error(
      '`' + name + '` finished async. Use `' + asyncName + '` instead'
    )
  }
}


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = bail

function bail(err) {
  if (err) {
    throw err
  }
}


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var VMessage = __webpack_require__(235);
var VFile = __webpack_require__(237);

module.exports = VFile;

var proto = VFile.prototype;

proto.message = message;
proto.info = info;
proto.fail = fail;

/* Slight backwards compatibility.  Remove in the future. */
proto.warn = message;

/* Create a message with `reason` at `position`.
 * When an error is passed in as `reason`, copies the stack. */
function message(reason, position, origin) {
  var filePath = this.path;
  var message = new VMessage(reason, position, origin);

  if (filePath) {
    message.name = filePath + ':' + message.name;
    message.file = filePath;
  }

  message.fatal = false;

  this.messages.push(message);

  return message;
}

/* Fail. Creates a vmessage, associates it with the file,
 * and throws it. */
function fail() {
  var message = this.message.apply(this, arguments);

  message.fatal = true;

  throw message;
}

/* Info. Creates a vmessage, associates it with the file,
 * and marks the fatality as null. */
function info() {
  var message = this.message.apply(this, arguments);

  message.fatal = null;

  return message;
}


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(236)

module.exports = VMessage

// Inherit from `Error#`.
function VMessagePrototype() {}
VMessagePrototype.prototype = Error.prototype
VMessage.prototype = new VMessagePrototype()

// Message properties.
var proto = VMessage.prototype

proto.file = ''
proto.name = ''
proto.reason = ''
proto.message = ''
proto.stack = ''
proto.fatal = null
proto.column = null
proto.line = null

// Construct a new VMessage.
//
// Note: We cannot invoke `Error` on the created context, as that adds readonly
// `line` and `column` attributes on Safari 9, thus throwing and failing the
// data.
function VMessage(reason, position, origin) {
  var parts
  var range
  var location

  if (typeof position === 'string') {
    origin = position
    position = null
  }

  parts = parseOrigin(origin)
  range = stringify(position) || '1:1'

  location = {
    start: {line: null, column: null},
    end: {line: null, column: null}
  }

  // Node.
  if (position && position.position) {
    position = position.position
  }

  if (position) {
    // Position.
    if (position.start) {
      location = position
      position = position.start
    } else {
      // Point.
      location.start = position
    }
  }

  if (reason.stack) {
    this.stack = reason.stack
    reason = reason.message
  }

  this.message = reason
  this.name = range
  this.reason = reason
  this.line = position ? position.line : null
  this.column = position ? position.column : null
  this.location = location
  this.source = parts[0]
  this.ruleId = parts[1]
}

function parseOrigin(origin) {
  var result = [null, null]
  var index

  if (typeof origin === 'string') {
    index = origin.indexOf(':')

    if (index === -1) {
      result[1] = origin
    } else {
      result[0] = origin.slice(0, index)
      result[1] = origin.slice(index + 1)
    }
  }

  return result
}


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var own = {}.hasOwnProperty

module.exports = stringify

function stringify(value) {
  /* Nothing. */
  if (!value || typeof value !== 'object') {
    return null
  }

  /* Node. */
  if (own.call(value, 'position') || own.call(value, 'type')) {
    return position(value.position)
  }

  /* Position. */
  if (own.call(value, 'start') || own.call(value, 'end')) {
    return position(value)
  }

  /* Point. */
  if (own.call(value, 'line') || own.call(value, 'column')) {
    return point(value)
  }

  /* ? */
  return null
}

function point(point) {
  if (!point || typeof point !== 'object') {
    point = {}
  }

  return index(point.line) + ':' + index(point.column)
}

function position(pos) {
  if (!pos || typeof pos !== 'object') {
    pos = {}
  }

  return point(pos.start) + '-' + point(pos.end)
}

function index(value) {
  return value && typeof value === 'number' ? value : 1
}


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var path = __webpack_require__(110);
var replace = __webpack_require__(238);
var buffer = __webpack_require__(239);

module.exports = VFile;

var own = {}.hasOwnProperty;
var proto = VFile.prototype;

proto.toString = toString;

/* Order of setting (least specific to most), we need this because
 * otherwise `{stem: 'a', path: '~/b.js'}` would throw, as a path
 * is needed before a stem can be set. */
var order = [
  'history',
  'path',
  'basename',
  'stem',
  'extname',
  'dirname'
];

/* Construct a new file. */
function VFile(options) {
  var prop;
  var index;
  var length;

  if (!options) {
    options = {};
  } else if (typeof options === 'string' || buffer(options)) {
    options = {contents: options};
  } else if ('message' in options && 'messages' in options) {
    return options;
  }

  if (!(this instanceof VFile)) {
    return new VFile(options);
  }

  this.data = {};
  this.messages = [];
  this.history = [];
  this.cwd = process.cwd();

  /* Set path related properties in the correct order. */
  index = -1;
  length = order.length;

  while (++index < length) {
    prop = order[index];

    if (own.call(options, prop)) {
      this[prop] = options[prop];
    }
  }

  /* Set non-path related properties. */
  for (prop in options) {
    if (order.indexOf(prop) === -1) {
      this[prop] = options[prop];
    }
  }
}

/* Access full path (`~/index.min.js`). */
Object.defineProperty(proto, 'path', {
  get: function () {
    return this.history[this.history.length - 1];
  },
  set: function (path) {
    assertNonEmpty(path, 'path');

    if (path !== this.path) {
      this.history.push(path);
    }
  }
});

/* Access parent path (`~`). */
Object.defineProperty(proto, 'dirname', {
  get: function () {
    return typeof this.path === 'string' ? path.dirname(this.path) : undefined;
  },
  set: function (dirname) {
    assertPath(this.path, 'dirname');
    this.path = path.join(dirname || '', this.basename);
  }
});

/* Access basename (`index.min.js`). */
Object.defineProperty(proto, 'basename', {
  get: function () {
    return typeof this.path === 'string' ? path.basename(this.path) : undefined;
  },
  set: function (basename) {
    assertNonEmpty(basename, 'basename');
    assertPart(basename, 'basename');
    this.path = path.join(this.dirname || '', basename);
  }
});

/* Access extname (`.js`). */
Object.defineProperty(proto, 'extname', {
  get: function () {
    return typeof this.path === 'string' ? path.extname(this.path) : undefined;
  },
  set: function (extname) {
    var ext = extname || '';

    assertPart(ext, 'extname');
    assertPath(this.path, 'extname');

    if (ext) {
      if (ext.charAt(0) !== '.') {
        throw new Error('`extname` must start with `.`');
      }

      if (ext.indexOf('.', 1) !== -1) {
        throw new Error('`extname` cannot contain multiple dots');
      }
    }

    this.path = replace(this.path, ext);
  }
});

/* Access stem (`index.min`). */
Object.defineProperty(proto, 'stem', {
  get: function () {
    return typeof this.path === 'string' ? path.basename(this.path, this.extname) : undefined;
  },
  set: function (stem) {
    assertNonEmpty(stem, 'stem');
    assertPart(stem, 'stem');
    this.path = path.join(this.dirname || '', stem + (this.extname || ''));
  }
});

/* Get the value of the file. */
function toString(encoding) {
  var value = this.contents || '';
  return buffer(value) ? value.toString(encoding) : String(value);
}

/* Assert that `part` is not a path (i.e., does
 * not contain `path.sep`). */
function assertPart(part, name) {
  if (part.indexOf(path.sep) !== -1) {
    throw new Error('`' + name + '` cannot be a path: did not expect `' + path.sep + '`');
  }
}

/* Assert that `part` is not empty. */
function assertNonEmpty(part, name) {
  if (!part) {
    throw new Error('`' + name + '` cannot be empty');
  }
}

/* Assert `path` exists. */
function assertPath(path, name) {
  if (!path) {
    throw new Error('Setting `' + name + '` requires `path` to be set too');
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(109)))

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var path = __webpack_require__(110);

function replaceExt(npath, ext) {
  if (typeof npath !== 'string') {
    return npath;
  }

  if (npath.length === 0) {
    return npath;
  }

  var nFileName = path.basename(npath, path.extname(npath)) + ext;
  return path.join(path.dirname(npath), nFileName);
}

module.exports = replaceExt;


/***/ }),
/* 239 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wrap = __webpack_require__(241)

module.exports = trough

trough.wrap = wrap

var slice = [].slice

// Create new middleware.
function trough() {
  var fns = []
  var middleware = {}

  middleware.run = run
  middleware.use = use

  return middleware

  // Run `fns`.  Last argument must be a completion handler.
  function run() {
    var index = -1
    var input = slice.call(arguments, 0, -1)
    var done = arguments[arguments.length - 1]

    if (typeof done !== 'function') {
      throw new Error('Expected function as last argument, not ' + done)
    }

    next.apply(null, [null].concat(input))

    // Run the next `fn`, if any.
    function next(err) {
      var fn = fns[++index]
      var params = slice.call(arguments, 0)
      var values = params.slice(1)
      var length = input.length
      var pos = -1

      if (err) {
        done(err)
        return
      }

      // Copy non-nully input into values.
      while (++pos < length) {
        if (values[pos] === null || values[pos] === undefined) {
          values[pos] = input[pos]
        }
      }

      input = values

      // Next or done.
      if (fn) {
        wrap(fn, next).apply(null, input)
      } else {
        done.apply(null, [null].concat(input))
      }
    }
  }

  // Add `fn` to the list.
  function use(fn) {
    if (typeof fn !== 'function') {
      throw new Error('Expected `fn` to be a function, not ' + fn)
    }

    fns.push(fn)

    return middleware
  }
}


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = [].slice

module.exports = wrap

// Wrap `fn`.
// Can be sync or async; return a promise, receive a completion handler, return
// new values and errors.
function wrap(fn, callback) {
  var invoked

  return wrapped

  function wrapped() {
    var params = slice.call(arguments, 0)
    var callback = fn.length > params.length
    var result

    if (callback) {
      params.push(done)
    }

    try {
      result = fn.apply(null, params)
    } catch (error) {
      // Well, this is quite the pickle.
      // `fn` received a callback and invoked it (thus continuing the pipeline),
      // but later also threw an error.
      // We’re not about to restart the pipeline again, so the only thing left
      // to do is to throw the thing instead.
      if (callback && invoked) {
        throw error
      }

      return done(error)
    }

    if (!callback) {
      if (result && typeof result.then === 'function') {
        result.then(then, done)
      } else if (result instanceof Error) {
        done(result)
      } else {
        then(result)
      }
    }
  }

  // Invoke `next`, only once.
  function done() {
    if (!invoked) {
      invoked = true

      callback.apply(null, arguments)
    }
  }

  // Invoke `done` with one value.
  // Tracks if an error is passed, too.
  function then(value) {
    done(null, value)
  }
}


/***/ }),
/* 242 */
/***/ (function(module, exports) {

var toString = Object.prototype.toString

module.exports = isString

function isString(obj) {
    return toString.call(obj) === "[object String]"
}


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toString = Object.prototype.toString;

module.exports = function (x) {
	var prototype;
	return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var unherit = __webpack_require__(245);
var xtend = __webpack_require__(12);
var Parser = __webpack_require__(247);

module.exports = parse;
parse.Parser = Parser;

function parse(options) {
  var Local = unherit(Parser);
  Local.prototype.options = xtend(Local.prototype.options, this.data('settings'), options);
  this.Parser = Local;
}


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var xtend = __webpack_require__(12)
var inherits = __webpack_require__(246)

module.exports = unherit

// Create a custom constructor which can be modified without affecting the
// original class.
function unherit(Super) {
  var result
  var key
  var value

  inherits(Of, Super)
  inherits(From, Of)

  // Clone values.
  result = Of.prototype

  for (key in result) {
    value = result[key]

    if (value && typeof value === 'object') {
      result[key] = 'concat' in value ? value.concat() : xtend(value)
    }
  }

  return Of

  // Constructor accepting a single argument, which itself is an `arguments`
  // object.
  function From(parameters) {
    return Super.apply(this, parameters)
  }

  // Constructor accepting variadic arguments.
  function Of() {
    if (!(this instanceof Of)) {
      return new From(arguments)
    }

    return Super.apply(this, arguments)
  }
}


/***/ }),
/* 246 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var xtend = __webpack_require__(12);
var toggle = __webpack_require__(248);
var vfileLocation = __webpack_require__(249);
var unescape = __webpack_require__(250);
var decode = __webpack_require__(251);
var tokenizer = __webpack_require__(257);

module.exports = Parser;

function Parser(doc, file) {
  this.file = file;
  this.offset = {};
  this.options = xtend(this.options);
  this.setOptions({});

  this.inList = false;
  this.inBlock = false;
  this.inLink = false;
  this.atStart = true;

  this.toOffset = vfileLocation(file).toOffset;
  this.unescape = unescape(this, 'escape');
  this.decode = decode(this);
}

var proto = Parser.prototype;

/* Expose core. */
proto.setOptions = __webpack_require__(258);
proto.parse = __webpack_require__(261);

/* Expose `defaults`. */
proto.options = __webpack_require__(112);

/* Enter and exit helpers. */
proto.exitStart = toggle('atStart', true);
proto.enterList = toggle('inList', false);
proto.enterLink = toggle('inLink', false);
proto.enterBlock = toggle('inBlock', false);

/* Nodes that can interupt a paragraph:
 *
 * ```markdown
 * A paragraph, followed by a thematic break.
 * ___
 * ```
 *
 * In the above example, the thematic break “interupts”
 * the paragraph. */
proto.interruptParagraph = [
  ['thematicBreak'],
  ['atxHeading'],
  ['fencedCode'],
  ['blockquote'],
  ['html'],
  ['setextHeading', {commonmark: false}],
  ['definition', {commonmark: false}],
  ['footnote', {commonmark: false}]
];

/* Nodes that can interupt a list:
 *
 * ```markdown
 * - One
 * ___
 * ```
 *
 * In the above example, the thematic break “interupts”
 * the list. */
proto.interruptList = [
  ['atxHeading', {pedantic: false}],
  ['fencedCode', {pedantic: false}],
  ['thematicBreak', {pedantic: false}],
  ['definition', {commonmark: false}],
  ['footnote', {commonmark: false}]
];

/* Nodes that can interupt a blockquote:
 *
 * ```markdown
 * > A paragraph.
 * ___
 * ```
 *
 * In the above example, the thematic break “interupts”
 * the blockquote. */
proto.interruptBlockquote = [
  ['indentedCode', {commonmark: true}],
  ['fencedCode', {commonmark: true}],
  ['atxHeading', {commonmark: true}],
  ['setextHeading', {commonmark: true}],
  ['thematicBreak', {commonmark: true}],
  ['html', {commonmark: true}],
  ['list', {commonmark: true}],
  ['definition', {commonmark: false}],
  ['footnote', {commonmark: false}]
];

/* Handlers. */
proto.blockTokenizers = {
  newline: __webpack_require__(265),
  indentedCode: __webpack_require__(266),
  fencedCode: __webpack_require__(267),
  blockquote: __webpack_require__(268),
  atxHeading: __webpack_require__(269),
  thematicBreak: __webpack_require__(270),
  list: __webpack_require__(271),
  setextHeading: __webpack_require__(273),
  html: __webpack_require__(274),
  footnote: __webpack_require__(275),
  definition: __webpack_require__(277),
  table: __webpack_require__(278),
  paragraph: __webpack_require__(279)
};

proto.inlineTokenizers = {
  escape: __webpack_require__(280),
  autoLink: __webpack_require__(282),
  url: __webpack_require__(283),
  html: __webpack_require__(285),
  link: __webpack_require__(286),
  reference: __webpack_require__(287),
  strong: __webpack_require__(288),
  emphasis: __webpack_require__(290),
  deletion: __webpack_require__(293),
  code: __webpack_require__(295),
  break: __webpack_require__(297),
  text: __webpack_require__(299)
};

/* Expose precedence. */
proto.blockMethods = keys(proto.blockTokenizers);
proto.inlineMethods = keys(proto.inlineTokenizers);

/* Tokenizers. */
proto.tokenizeBlock = tokenizer('block');
proto.tokenizeInline = tokenizer('inline');
proto.tokenizeFactory = tokenizer;

/* Get all keys in `value`. */
function keys(value) {
  var result = [];
  var key;

  for (key in value) {
    result.push(key);
  }

  return result;
}


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = factory

// Construct a state `toggler`: a function which inverses `property` in context
// based on its current value.
// The by `toggler` returned function restores that value.
function factory(key, state, ctx) {
  return enter

  function enter() {
    var context = ctx || this
    var current = context[key]

    context[key] = !state

    return exit

    function exit() {
      context[key] = current
    }
  }
}


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = factory

function factory(file) {
  var contents = indices(String(file))

  return {
    toPosition: offsetToPositionFactory(contents),
    toOffset: positionToOffsetFactory(contents)
  }
}

// Factory to get the line and column-based `position` for `offset` in the bound
// indices.
function offsetToPositionFactory(indices) {
  return offsetToPosition

  // Get the line and column-based `position` for `offset` in the bound indices.
  function offsetToPosition(offset) {
    var index = -1
    var length = indices.length

    if (offset < 0) {
      return {}
    }

    while (++index < length) {
      if (indices[index] > offset) {
        return {
          line: index + 1,
          column: offset - (indices[index - 1] || 0) + 1,
          offset: offset
        }
      }
    }

    return {}
  }
}

// Factory to get the `offset` for a line and column-based `position` in the
// bound indices.
function positionToOffsetFactory(indices) {
  return positionToOffset

  // Get the `offset` for a line and column-based `position` in the bound
  // indices.
  function positionToOffset(position) {
    var line = position && position.line
    var column = position && position.column

    if (!isNaN(line) && !isNaN(column) && line - 1 in indices) {
      return (indices[line - 2] || 0) + column - 1 || 0
    }

    return -1
  }
}

// Get indices of line-breaks in `value`.
function indices(value) {
  var result = []
  var index = value.indexOf('\n')

  while (index !== -1) {
    result.push(index + 1)
    index = value.indexOf('\n', index + 1)
  }

  result.push(value.length + 1)

  return result
}


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = factory;

/* Factory to de-escape a value, based on a list at `key`
 * in `ctx`. */
function factory(ctx, key) {
  return unescape;

  /* De-escape a string using the expression at `key`
   * in `ctx`. */
  function unescape(value) {
    var prev = 0;
    var index = value.indexOf('\\');
    var escape = ctx[key];
    var queue = [];
    var character;

    while (index !== -1) {
      queue.push(value.slice(prev, index));
      prev = index + 1;
      character = value.charAt(prev);

      /* If the following character is not a valid escape,
       * add the slash. */
      if (!character || escape.indexOf(character) === -1) {
        queue.push('\\');
      }

      index = value.indexOf('\\', prev);
    }

    queue.push(value.slice(prev));

    return queue.join('');
  }
}


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var xtend = __webpack_require__(12);
var entities = __webpack_require__(60);

module.exports = factory;

/* Factory to create an entity decoder. */
function factory(ctx) {
  decoder.raw = decodeRaw;

  return decoder;

  /* Normalize `position` to add an `indent`. */
  function normalize(position) {
    var offsets = ctx.offset;
    var line = position.line;
    var result = [];

    while (++line) {
      if (!(line in offsets)) {
        break;
      }

      result.push((offsets[line] || 0) + 1);
    }

    return {
      start: position,
      indent: result
    };
  }

  /* Handle a warning.
   * See https://github.com/wooorm/parse-entities
   * for the warnings. */
  function handleWarning(reason, position, code) {
    if (code === 3) {
      return;
    }

    ctx.file.message(reason, position);
  }

  /* Decode `value` (at `position`) into text-nodes. */
  function decoder(value, position, handler) {
    entities(value, {
      position: normalize(position),
      warning: handleWarning,
      text: handler,
      reference: handler,
      textContext: ctx,
      referenceContext: ctx
    });
  }

  /* Decode `value` (at `position`) into a string. */
  function decodeRaw(value, position, options) {
    return entities(value, xtend(options, {
      position: normalize(position),
      warning: handleWarning
    }));
  }
}


/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports = {"AElig":"Æ","AMP":"&","Aacute":"Á","Acirc":"Â","Agrave":"À","Aring":"Å","Atilde":"Ã","Auml":"Ä","COPY":"©","Ccedil":"Ç","ETH":"Ð","Eacute":"É","Ecirc":"Ê","Egrave":"È","Euml":"Ë","GT":">","Iacute":"Í","Icirc":"Î","Igrave":"Ì","Iuml":"Ï","LT":"<","Ntilde":"Ñ","Oacute":"Ó","Ocirc":"Ô","Ograve":"Ò","Oslash":"Ø","Otilde":"Õ","Ouml":"Ö","QUOT":"\"","REG":"®","THORN":"Þ","Uacute":"Ú","Ucirc":"Û","Ugrave":"Ù","Uuml":"Ü","Yacute":"Ý","aacute":"á","acirc":"â","acute":"´","aelig":"æ","agrave":"à","amp":"&","aring":"å","atilde":"ã","auml":"ä","brvbar":"¦","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","curren":"¤","deg":"°","divide":"÷","eacute":"é","ecirc":"ê","egrave":"è","eth":"ð","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","iacute":"í","icirc":"î","iexcl":"¡","igrave":"ì","iquest":"¿","iuml":"ï","laquo":"«","lt":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","ntilde":"ñ","oacute":"ó","ocirc":"ô","ograve":"ò","ordf":"ª","ordm":"º","oslash":"ø","otilde":"õ","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","raquo":"»","reg":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","thorn":"þ","times":"×","uacute":"ú","ucirc":"û","ugrave":"ù","uml":"¨","uuml":"ü","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports = {"0":"�","128":"€","130":"‚","131":"ƒ","132":"„","133":"…","134":"†","135":"‡","136":"ˆ","137":"‰","138":"Š","139":"‹","140":"Œ","142":"Ž","145":"‘","146":"’","147":"“","148":"”","149":"•","150":"–","151":"—","152":"˜","153":"™","154":"š","155":"›","156":"œ","158":"ž","159":"Ÿ"}

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = hexadecimal

// Check if the given character code, or the character code at the first
// character, is hexadecimal.
function hexadecimal(character) {
  var code = typeof character === 'string' ? character.charCodeAt(0) : character

  return (
    (code >= 97 /* a */ && code <= 102) /* z */ ||
    (code >= 65 /* A */ && code <= 70) /* Z */ ||
    (code >= 48 /* A */ && code <= 57) /* Z */
  )
}


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabetical = __webpack_require__(111)
var decimal = __webpack_require__(39)

module.exports = alphanumerical

// Check if the given character code, or the character code at the first
// character, is alphanumerical.
function alphanumerical(character) {
  return alphabetical(character) || decimal(character)
}


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-env browser */

var el

var semicolon = 59 //  ';'

module.exports = decodeEntity

function decodeEntity(characters) {
  var entity = '&' + characters + ';'
  var char

  el = el || document.createElement('i')
  el.innerHTML = entity
  char = el.textContent

  // Some entities do not require the closing semicolon (`&not` - for instance),
  // which leads to situations where parsing the assumed entity of &notit; will
  // result in the string `¬it;`.  When we encounter a trailing semicolon after
  // parsing and the entity to decode was not a semicolon (`&semi;`), we can
  // assume that the matching was incomplete
  if (char.charCodeAt(char.length - 1) === semicolon && characters !== 'semi') {
    return false
  }

  // If the decoded string is equal to the input, the entity was not valid
  return char === entity ? false : char
}


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = factory;

var MERGEABLE_NODES = {
  text: mergeText,
  blockquote: mergeBlockquote
};

/* Check whether a node is mergeable with adjacent nodes. */
function mergeable(node) {
  var start;
  var end;

  if (node.type !== 'text' || !node.position) {
    return true;
  }

  start = node.position.start;
  end = node.position.end;

  /* Only merge nodes which occupy the same size as their
   * `value`. */
  return start.line !== end.line ||
      end.column - start.column === node.value.length;
}

/* Merge two text nodes: `node` into `prev`. */
function mergeText(prev, node) {
  prev.value += node.value;

  return prev;
}

/* Merge two blockquotes: `node` into `prev`, unless in
 * CommonMark mode. */
function mergeBlockquote(prev, node) {
  if (this.options.commonmark) {
    return node;
  }

  prev.children = prev.children.concat(node.children);

  return prev;
}

/* Construct a tokenizer.  This creates both
 * `tokenizeInline` and `tokenizeBlock`. */
function factory(type) {
  return tokenize;

  /* Tokenizer for a bound `type`. */
  function tokenize(value, location) {
    var self = this;
    var offset = self.offset;
    var tokens = [];
    var methods = self[type + 'Methods'];
    var tokenizers = self[type + 'Tokenizers'];
    var line = location.line;
    var column = location.column;
    var index;
    var length;
    var method;
    var name;
    var matched;
    var valueLength;

    /* Trim white space only lines. */
    if (!value) {
      return tokens;
    }

    /* Expose on `eat`. */
    eat.now = now;
    eat.file = self.file;

    /* Sync initial offset. */
    updatePosition('');

    /* Iterate over `value`, and iterate over all
     * tokenizers.  When one eats something, re-iterate
     * with the remaining value.  If no tokenizer eats,
     * something failed (should not happen) and an
     * exception is thrown. */
    while (value) {
      index = -1;
      length = methods.length;
      matched = false;

      while (++index < length) {
        name = methods[index];
        method = tokenizers[name];

        if (
          method &&
          /* istanbul ignore next */ (!method.onlyAtStart || self.atStart) &&
          (!method.notInList || !self.inList) &&
          (!method.notInBlock || !self.inBlock) &&
          (!method.notInLink || !self.inLink)
        ) {
          valueLength = value.length;

          method.apply(self, [eat, value]);

          matched = valueLength !== value.length;

          if (matched) {
            break;
          }
        }
      }

      /* istanbul ignore if */
      if (!matched) {
        self.file.fail(new Error('Infinite loop'), eat.now());
      }
    }

    self.eof = now();

    return tokens;

    /* Update line, column, and offset based on
     * `value`. */
    function updatePosition(subvalue) {
      var lastIndex = -1;
      var index = subvalue.indexOf('\n');

      while (index !== -1) {
        line++;
        lastIndex = index;
        index = subvalue.indexOf('\n', index + 1);
      }

      if (lastIndex === -1) {
        column += subvalue.length;
      } else {
        column = subvalue.length - lastIndex;
      }

      if (line in offset) {
        if (lastIndex !== -1) {
          column += offset[line];
        } else if (column <= offset[line]) {
          column = offset[line] + 1;
        }
      }
    }

    /* Get offset.  Called before the first character is
     * eaten to retrieve the range's offsets. */
    function getOffset() {
      var indentation = [];
      var pos = line + 1;

      /* Done.  Called when the last character is
       * eaten to retrieve the range’s offsets. */
      return function () {
        var last = line + 1;

        while (pos < last) {
          indentation.push((offset[pos] || 0) + 1);

          pos++;
        }

        return indentation;
      };
    }

    /* Get the current position. */
    function now() {
      var pos = {line: line, column: column};

      pos.offset = self.toOffset(pos);

      return pos;
    }

    /* Store position information for a node. */
    function Position(start) {
      this.start = start;
      this.end = now();
    }

    /* Throw when a value is incorrectly eaten.
     * This shouldn’t happen but will throw on new,
     * incorrect rules. */
    function validateEat(subvalue) {
      /* istanbul ignore if */
      if (value.substring(0, subvalue.length) !== subvalue) {
        /* Capture stack-trace. */
        self.file.fail(
          new Error(
            'Incorrectly eaten value: please report this ' +
            'warning on http://git.io/vg5Ft'
          ),
          now()
        );
      }
    }

    /* Mark position and patch `node.position`. */
    function position() {
      var before = now();

      return update;

      /* Add the position to a node. */
      function update(node, indent) {
        var prev = node.position;
        var start = prev ? prev.start : before;
        var combined = [];
        var n = prev && prev.end.line;
        var l = before.line;

        node.position = new Position(start);

        /* If there was already a `position`, this
         * node was merged.  Fixing `start` wasn’t
         * hard, but the indent is different.
         * Especially because some information, the
         * indent between `n` and `l` wasn’t
         * tracked.  Luckily, that space is
         * (should be?) empty, so we can safely
         * check for it now. */
        if (prev && indent && prev.indent) {
          combined = prev.indent;

          if (n < l) {
            while (++n < l) {
              combined.push((offset[n] || 0) + 1);
            }

            combined.push(before.column);
          }

          indent = combined.concat(indent);
        }

        node.position.indent = indent || [];

        return node;
      }
    }

    /* Add `node` to `parent`s children or to `tokens`.
     * Performs merges where possible. */
    function add(node, parent) {
      var children = parent ? parent.children : tokens;
      var prev = children[children.length - 1];

      if (
        prev &&
        node.type === prev.type &&
        node.type in MERGEABLE_NODES &&
        mergeable(prev) &&
        mergeable(node)
      ) {
        node = MERGEABLE_NODES[node.type].call(self, prev, node);
      }

      if (node !== prev) {
        children.push(node);
      }

      if (self.atStart && tokens.length !== 0) {
        self.exitStart();
      }

      return node;
    }

    /* Remove `subvalue` from `value`.
     * `subvalue` must be at the start of `value`. */
    function eat(subvalue) {
      var indent = getOffset();
      var pos = position();
      var current = now();

      validateEat(subvalue);

      apply.reset = reset;
      reset.test = test;
      apply.test = test;

      value = value.substring(subvalue.length);

      updatePosition(subvalue);

      indent = indent();

      return apply;

      /* Add the given arguments, add `position` to
       * the returned node, and return the node. */
      function apply(node, parent) {
        return pos(add(pos(node), parent), indent);
      }

      /* Functions just like apply, but resets the
       * content:  the line and column are reversed,
       * and the eaten value is re-added.
       * This is useful for nodes with a single
       * type of content, such as lists and tables.
       * See `apply` above for what parameters are
       * expected. */
      function reset() {
        var node = apply.apply(null, arguments);

        line = current.line;
        column = current.column;
        value = subvalue + value;

        return node;
      }

      /* Test the position, after eating, and reverse
       * to a not-eaten state. */
      function test() {
        var result = pos({});

        line = current.line;
        column = current.column;
        value = subvalue + value;

        return result.position;
      }
    }
  }
}


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var xtend = __webpack_require__(12);
var escapes = __webpack_require__(259);
var defaults = __webpack_require__(112);

module.exports = setOptions;

function setOptions(options) {
  var self = this;
  var current = self.options;
  var key;
  var value;

  if (options == null) {
    options = {};
  } else if (typeof options === 'object') {
    options = xtend(options);
  } else {
    throw new Error(
      'Invalid value `' + options + '` ' +
      'for setting `options`'
    );
  }

  for (key in defaults) {
    value = options[key];

    if (value == null) {
      value = current[key];
    }

    if (
      (key !== 'blocks' && typeof value !== 'boolean') ||
      (key === 'blocks' && typeof value !== 'object')
    ) {
      throw new Error('Invalid value `' + value + '` for setting `options.' + key + '`');
    }

    options[key] = value;
  }

  self.options = options;
  self.escape = escapes(options);

  return self;
}


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = escapes

var defaults = [
  '\\',
  '`',
  '*',
  '{',
  '}',
  '[',
  ']',
  '(',
  ')',
  '#',
  '+',
  '-',
  '.',
  '!',
  '_',
  '>'
]

var gfm = defaults.concat(['~', '|'])

var commonmark = gfm.concat([
  '\n',
  '"',
  '$',
  '%',
  '&',
  "'",
  ',',
  '/',
  ':',
  ';',
  '<',
  '=',
  '?',
  '@',
  '^'
])

escapes.default = defaults
escapes.gfm = gfm
escapes.commonmark = commonmark

// Get markdown escapes.
function escapes(options) {
  var settings = options || {}

  if (settings.commonmark) {
    return commonmark
  }

  return settings.gfm ? gfm : defaults
}


/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports = ["address","article","aside","base","basefont","blockquote","body","caption","center","col","colgroup","dd","details","dialog","dir","div","dl","dt","fieldset","figcaption","figure","footer","form","frame","frameset","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","iframe","legend","li","link","main","menu","menuitem","meta","nav","noframes","ol","optgroup","option","p","param","pre","section","source","title","summary","table","tbody","td","tfoot","th","thead","title","tr","track","ul"]

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var xtend = __webpack_require__(12);
var removePosition = __webpack_require__(262);

module.exports = parse;

var C_NEWLINE = '\n';
var EXPRESSION_LINE_BREAKS = /\r\n|\r/g;

/* Parse the bound file. */
function parse() {
  var self = this;
  var value = String(self.file);
  var start = {line: 1, column: 1, offset: 0};
  var content = xtend(start);
  var node;

  /* Clean non-unix newlines: `\r\n` and `\r` are all
   * changed to `\n`.  This should not affect positional
   * information. */
  value = value.replace(EXPRESSION_LINE_BREAKS, C_NEWLINE);

  if (value.charCodeAt(0) === 0xFEFF) {
    value = value.slice(1);

    content.column++;
    content.offset++;
  }

  node = {
    type: 'root',
    children: self.tokenizeBlock(value, content),
    position: {
      start: start,
      end: self.eof || xtend(start)
    }
  };

  if (!self.options.position) {
    removePosition(node, true);
  }

  return node;
}


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var visit = __webpack_require__(40)

module.exports = removePosition

function removePosition(node, force) {
  visit(node, force ? hard : soft)
  return node
}

function hard(node) {
  delete node.position
}

function soft(node) {
  node.position = undefined
}


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = visitParents

var convert = __webpack_require__(264)

var CONTINUE = true
var SKIP = 'skip'
var EXIT = false

visitParents.CONTINUE = CONTINUE
visitParents.SKIP = SKIP
visitParents.EXIT = EXIT

function visitParents(tree, test, visitor, reverse) {
  var is

  if (typeof test === 'function' && typeof visitor !== 'function') {
    reverse = visitor
    visitor = test
    test = null
  }

  is = convert(test)

  one(tree, null, [])

  // Visit a single node.
  function one(node, index, parents) {
    var result = []
    var subresult

    if (!test || is(node, index, parents[parents.length - 1] || null)) {
      result = toResult(visitor(node, parents))

      if (result[0] === EXIT) {
        return result
      }
    }

    if (node.children && result[0] !== SKIP) {
      subresult = toResult(all(node.children, parents.concat(node)))
      return subresult[0] === EXIT ? subresult : result
    }

    return result
  }

  // Visit children in `parent`.
  function all(children, parents) {
    var min = -1
    var step = reverse ? -1 : 1
    var index = (reverse ? children.length : min) + step
    var result

    while (index > min && index < children.length) {
      result = one(children[index], index, parents)

      if (result[0] === EXIT) {
        return result
      }

      index = typeof result[1] === 'number' ? result[1] : index + step
    }
  }
}

function toResult(value) {
  if (value !== null && typeof value === 'object' && 'length' in value) {
    return value
  }

  if (typeof value === 'number') {
    return [CONTINUE, value]
  }

  return [value]
}


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = convert

function convert(test) {
  if (typeof test === 'string') {
    return typeFactory(test)
  }

  if (test === null || test === undefined) {
    return ok
  }

  if (typeof test === 'object') {
    return ('length' in test ? anyFactory : matchesFactory)(test)
  }

  if (typeof test === 'function') {
    return test
  }

  throw new Error('Expected function, string, or object as test')
}

function convertAll(tests) {
  var results = []
  var length = tests.length
  var index = -1

  while (++index < length) {
    results[index] = convert(tests[index])
  }

  return results
}

// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function matchesFactory(test) {
  return matches

  function matches(node) {
    var key

    for (key in test) {
      if (node[key] !== test[key]) {
        return false
      }
    }

    return true
  }
}

function anyFactory(tests) {
  var checks = convertAll(tests)
  var length = checks.length

  return matches

  function matches() {
    var index = -1

    while (++index < length) {
      if (checks[index].apply(this, arguments)) {
        return true
      }
    }

    return false
  }
}

// Utility to convert a string into a function which checks a given node’s type
// for said string.
function typeFactory(test) {
  return type

  function type(node) {
    return Boolean(node && node.type === test)
  }
}

// Utility to return true.
function ok() {
  return true
}


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var whitespace = __webpack_require__(5);

module.exports = newline;

/* Tokenise newline. */
function newline(eat, value, silent) {
  var character = value.charAt(0);
  var length;
  var subvalue;
  var queue;
  var index;

  if (character !== '\n') {
    return;
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true;
  }

  index = 1;
  length = value.length;
  subvalue = character;
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (!whitespace(character)) {
      break;
    }

    queue += character;

    if (character === '\n') {
      subvalue += queue;
      queue = '';
    }

    index++;
  }

  eat(subvalue);
}


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var repeat = __webpack_require__(61);
var trim = __webpack_require__(62);

module.exports = indentedCode;

var C_NEWLINE = '\n';
var C_TAB = '\t';
var C_SPACE = ' ';

var CODE_INDENT_COUNT = 4;
var CODE_INDENT = repeat(C_SPACE, CODE_INDENT_COUNT);

/* Tokenise indented code. */
function indentedCode(eat, value, silent) {
  var index = -1;
  var length = value.length;
  var subvalue = '';
  var content = '';
  var subvalueQueue = '';
  var contentQueue = '';
  var character;
  var blankQueue;
  var indent;

  while (++index < length) {
    character = value.charAt(index);

    if (indent) {
      indent = false;

      subvalue += subvalueQueue;
      content += contentQueue;
      subvalueQueue = '';
      contentQueue = '';

      if (character === C_NEWLINE) {
        subvalueQueue = character;
        contentQueue = character;
      } else {
        subvalue += character;
        content += character;

        while (++index < length) {
          character = value.charAt(index);

          if (!character || character === C_NEWLINE) {
            contentQueue = character;
            subvalueQueue = character;
            break;
          }

          subvalue += character;
          content += character;
        }
      }
    } else if (
      character === C_SPACE &&
      value.charAt(index + 1) === character &&
      value.charAt(index + 2) === character &&
      value.charAt(index + 3) === character
    ) {
      subvalueQueue += CODE_INDENT;
      index += 3;
      indent = true;
    } else if (character === C_TAB) {
      subvalueQueue += character;
      indent = true;
    } else {
      blankQueue = '';

      while (character === C_TAB || character === C_SPACE) {
        blankQueue += character;
        character = value.charAt(++index);
      }

      if (character !== C_NEWLINE) {
        break;
      }

      subvalueQueue += blankQueue + character;
      contentQueue += character;
    }
  }

  if (content) {
    if (silent) {
      return true;
    }

    return eat(subvalue)({
      type: 'code',
      lang: null,
      value: trim(content)
    });
  }
}


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var trim = __webpack_require__(62);

module.exports = fencedCode;

var C_NEWLINE = '\n';
var C_TAB = '\t';
var C_SPACE = ' ';
var C_TILDE = '~';
var C_TICK = '`';

var MIN_FENCE_COUNT = 3;
var CODE_INDENT_COUNT = 4;

function fencedCode(eat, value, silent) {
  var self = this;
  var settings = self.options;
  var length = value.length + 1;
  var index = 0;
  var subvalue = '';
  var fenceCount;
  var marker;
  var character;
  var flag;
  var queue;
  var content;
  var exdentedContent;
  var closing;
  var exdentedClosing;
  var indent;
  var now;

  if (!settings.gfm) {
    return;
  }

  /* Eat initial spacing. */
  while (index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE && character !== C_TAB) {
      break;
    }

    subvalue += character;
    index++;
  }

  indent = index;

  /* Eat the fence. */
  character = value.charAt(index);

  if (character !== C_TILDE && character !== C_TICK) {
    return;
  }

  index++;
  marker = character;
  fenceCount = 1;
  subvalue += character;

  while (index < length) {
    character = value.charAt(index);

    if (character !== marker) {
      break;
    }

    subvalue += character;
    fenceCount++;
    index++;
  }

  if (fenceCount < MIN_FENCE_COUNT) {
    return;
  }

  /* Eat spacing before flag. */
  while (index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE && character !== C_TAB) {
      break;
    }

    subvalue += character;
    index++;
  }

  /* Eat flag. */
  flag = '';
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (
      character === C_NEWLINE ||
      character === C_TILDE ||
      character === C_TICK
    ) {
      break;
    }

    if (character === C_SPACE || character === C_TAB) {
      queue += character;
    } else {
      flag += queue + character;
      queue = '';
    }

    index++;
  }

  character = value.charAt(index);

  if (character && character !== C_NEWLINE) {
    return;
  }

  if (silent) {
    return true;
  }

  now = eat.now();
  now.column += subvalue.length;
  now.offset += subvalue.length;

  subvalue += flag;
  flag = self.decode.raw(self.unescape(flag), now);

  if (queue) {
    subvalue += queue;
  }

  queue = '';
  closing = '';
  exdentedClosing = '';
  content = '';
  exdentedContent = '';

  /* Eat content. */
  while (index < length) {
    character = value.charAt(index);
    content += closing;
    exdentedContent += exdentedClosing;
    closing = '';
    exdentedClosing = '';

    if (character !== C_NEWLINE) {
      content += character;
      exdentedClosing += character;
      index++;
      continue;
    }

    /* Add the newline to `subvalue` if its the first
     * character.  Otherwise, add it to the `closing`
     * queue. */
    if (content) {
      closing += character;
      exdentedClosing += character;
    } else {
      subvalue += character;
    }

    queue = '';
    index++;

    while (index < length) {
      character = value.charAt(index);

      if (character !== C_SPACE) {
        break;
      }

      queue += character;
      index++;
    }

    closing += queue;
    exdentedClosing += queue.slice(indent);

    if (queue.length >= CODE_INDENT_COUNT) {
      continue;
    }

    queue = '';

    while (index < length) {
      character = value.charAt(index);

      if (character !== marker) {
        break;
      }

      queue += character;
      index++;
    }

    closing += queue;
    exdentedClosing += queue;

    if (queue.length < fenceCount) {
      continue;
    }

    queue = '';

    while (index < length) {
      character = value.charAt(index);

      if (character !== C_SPACE && character !== C_TAB) {
        break;
      }

      closing += character;
      exdentedClosing += character;
      index++;
    }

    if (!character || character === C_NEWLINE) {
      break;
    }
  }

  subvalue += content + closing;

  return eat(subvalue)({
    type: 'code',
    lang: flag || null,
    value: trim(exdentedContent)
  });
}


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var trim = __webpack_require__(22);
var interrupt = __webpack_require__(63);

module.exports = blockquote;

var C_NEWLINE = '\n';
var C_TAB = '\t';
var C_SPACE = ' ';
var C_GT = '>';

/* Tokenise a blockquote. */
function blockquote(eat, value, silent) {
  var self = this;
  var offsets = self.offset;
  var tokenizers = self.blockTokenizers;
  var interruptors = self.interruptBlockquote;
  var now = eat.now();
  var currentLine = now.line;
  var length = value.length;
  var values = [];
  var contents = [];
  var indents = [];
  var add;
  var index = 0;
  var character;
  var rest;
  var nextIndex;
  var content;
  var line;
  var startIndex;
  var prefixed;
  var exit;

  while (index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE && character !== C_TAB) {
      break;
    }

    index++;
  }

  if (value.charAt(index) !== C_GT) {
    return;
  }

  if (silent) {
    return true;
  }

  index = 0;

  while (index < length) {
    nextIndex = value.indexOf(C_NEWLINE, index);
    startIndex = index;
    prefixed = false;

    if (nextIndex === -1) {
      nextIndex = length;
    }

    while (index < length) {
      character = value.charAt(index);

      if (character !== C_SPACE && character !== C_TAB) {
        break;
      }

      index++;
    }

    if (value.charAt(index) === C_GT) {
      index++;
      prefixed = true;

      if (value.charAt(index) === C_SPACE) {
        index++;
      }
    } else {
      index = startIndex;
    }

    content = value.slice(index, nextIndex);

    if (!prefixed && !trim(content)) {
      index = startIndex;
      break;
    }

    if (!prefixed) {
      rest = value.slice(index);

      /* Check if the following code contains a possible
       * block. */
      if (interrupt(interruptors, tokenizers, self, [eat, rest, true])) {
        break;
      }
    }

    line = startIndex === index ? content : value.slice(startIndex, nextIndex);

    indents.push(index - startIndex);
    values.push(line);
    contents.push(content);

    index = nextIndex + 1;
  }

  index = -1;
  length = indents.length;
  add = eat(values.join(C_NEWLINE));

  while (++index < length) {
    offsets[currentLine] = (offsets[currentLine] || 0) + indents[index];
    currentLine++;
  }

  exit = self.enterBlock();
  contents = self.tokenizeBlock(contents.join(C_NEWLINE), now);
  exit();

  return add({
    type: 'blockquote',
    children: contents
  });
}


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = atxHeading;

var C_NEWLINE = '\n';
var C_TAB = '\t';
var C_SPACE = ' ';
var C_HASH = '#';

var MAX_ATX_COUNT = 6;

function atxHeading(eat, value, silent) {
  var self = this;
  var settings = self.options;
  var length = value.length + 1;
  var index = -1;
  var now = eat.now();
  var subvalue = '';
  var content = '';
  var character;
  var queue;
  var depth;

  /* Eat initial spacing. */
  while (++index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE && character !== C_TAB) {
      index--;
      break;
    }

    subvalue += character;
  }

  /* Eat hashes. */
  depth = 0;

  while (++index <= length) {
    character = value.charAt(index);

    if (character !== C_HASH) {
      index--;
      break;
    }

    subvalue += character;
    depth++;
  }

  if (depth > MAX_ATX_COUNT) {
    return;
  }

  if (
    !depth ||
    (!settings.pedantic && value.charAt(index + 1) === C_HASH)
  ) {
    return;
  }

  length = value.length + 1;

  /* Eat intermediate white-space. */
  queue = '';

  while (++index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE && character !== C_TAB) {
      index--;
      break;
    }

    queue += character;
  }

  /* Exit when not in pedantic mode without spacing. */
  if (
    !settings.pedantic &&
    queue.length === 0 &&
    character &&
    character !== C_NEWLINE
  ) {
    return;
  }

  if (silent) {
    return true;
  }

  /* Eat content. */
  subvalue += queue;
  queue = '';
  content = '';

  while (++index < length) {
    character = value.charAt(index);

    if (!character || character === C_NEWLINE) {
      break;
    }

    if (
      character !== C_SPACE &&
      character !== C_TAB &&
      character !== C_HASH
    ) {
      content += queue + character;
      queue = '';
      continue;
    }

    while (character === C_SPACE || character === C_TAB) {
      queue += character;
      character = value.charAt(++index);
    }

    while (character === C_HASH) {
      queue += character;
      character = value.charAt(++index);
    }

    while (character === C_SPACE || character === C_TAB) {
      queue += character;
      character = value.charAt(++index);
    }

    index--;
  }

  now.column += subvalue.length;
  now.offset += subvalue.length;
  subvalue += content + queue;

  return eat(subvalue)({
    type: 'heading',
    depth: depth,
    children: self.tokenizeInline(content, now)
  });
}


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = thematicBreak;

var C_NEWLINE = '\n';
var C_TAB = '\t';
var C_SPACE = ' ';
var C_ASTERISK = '*';
var C_UNDERSCORE = '_';
var C_DASH = '-';

var THEMATIC_BREAK_MARKER_COUNT = 3;

function thematicBreak(eat, value, silent) {
  var index = -1;
  var length = value.length + 1;
  var subvalue = '';
  var character;
  var marker;
  var markerCount;
  var queue;

  while (++index < length) {
    character = value.charAt(index);

    if (character !== C_TAB && character !== C_SPACE) {
      break;
    }

    subvalue += character;
  }

  if (
    character !== C_ASTERISK &&
    character !== C_DASH &&
    character !== C_UNDERSCORE
  ) {
    return;
  }

  marker = character;
  subvalue += character;
  markerCount = 1;
  queue = '';

  while (++index < length) {
    character = value.charAt(index);

    if (character === marker) {
      markerCount++;
      subvalue += queue + marker;
      queue = '';
    } else if (character === C_SPACE) {
      queue += character;
    } else if (
      markerCount >= THEMATIC_BREAK_MARKER_COUNT &&
      (!character || character === C_NEWLINE)
    ) {
      subvalue += queue;

      if (silent) {
        return true;
      }

      return eat(subvalue)({type: 'thematicBreak'});
    } else {
      return;
    }
  }
}


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable max-params */

var trim = __webpack_require__(22);
var repeat = __webpack_require__(61);
var decimal = __webpack_require__(39);
var getIndent = __webpack_require__(113);
var removeIndent = __webpack_require__(272);
var interrupt = __webpack_require__(63);

module.exports = list;

var C_ASTERISK = '*';
var C_UNDERSCORE = '_';
var C_PLUS = '+';
var C_DASH = '-';
var C_DOT = '.';
var C_SPACE = ' ';
var C_NEWLINE = '\n';
var C_TAB = '\t';
var C_PAREN_CLOSE = ')';
var C_X_LOWER = 'x';

var TAB_SIZE = 4;
var EXPRESSION_LOOSE_LIST_ITEM = /\n\n(?!\s*$)/;
var EXPRESSION_TASK_ITEM = /^\[([ \t]|x|X)][ \t]/;
var EXPRESSION_BULLET = /^([ \t]*)([*+-]|\d+[.)])( {1,4}(?! )| |\t|$|(?=\n))([^\n]*)/;
var EXPRESSION_PEDANTIC_BULLET = /^([ \t]*)([*+-]|\d+[.)])([ \t]+)/;
var EXPRESSION_INITIAL_INDENT = /^( {1,4}|\t)?/gm;

/* Map of characters which can be used to mark
 * list-items. */
var LIST_UNORDERED_MARKERS = {};

LIST_UNORDERED_MARKERS[C_ASTERISK] = true;
LIST_UNORDERED_MARKERS[C_PLUS] = true;
LIST_UNORDERED_MARKERS[C_DASH] = true;

/* Map of characters which can be used to mark
 * list-items after a digit. */
var LIST_ORDERED_MARKERS = {};

LIST_ORDERED_MARKERS[C_DOT] = true;

/* Map of characters which can be used to mark
 * list-items after a digit. */
var LIST_ORDERED_COMMONMARK_MARKERS = {};

LIST_ORDERED_COMMONMARK_MARKERS[C_DOT] = true;
LIST_ORDERED_COMMONMARK_MARKERS[C_PAREN_CLOSE] = true;

function list(eat, value, silent) {
  var self = this;
  var commonmark = self.options.commonmark;
  var pedantic = self.options.pedantic;
  var tokenizers = self.blockTokenizers;
  var interuptors = self.interruptList;
  var markers;
  var index = 0;
  var length = value.length;
  var start = null;
  var size = 0;
  var queue;
  var ordered;
  var character;
  var marker;
  var nextIndex;
  var startIndex;
  var prefixed;
  var currentMarker;
  var content;
  var line;
  var prevEmpty;
  var empty;
  var items;
  var allLines;
  var emptyLines;
  var item;
  var enterTop;
  var exitBlockquote;
  var isLoose;
  var node;
  var now;
  var end;
  var indented;

  while (index < length) {
    character = value.charAt(index);

    if (character === C_TAB) {
      size += TAB_SIZE - (size % TAB_SIZE);
    } else if (character === C_SPACE) {
      size++;
    } else {
      break;
    }

    index++;
  }

  if (size >= TAB_SIZE) {
    return;
  }

  character = value.charAt(index);

  markers = commonmark ?
    LIST_ORDERED_COMMONMARK_MARKERS :
    LIST_ORDERED_MARKERS;

  if (LIST_UNORDERED_MARKERS[character] === true) {
    marker = character;
    ordered = false;
  } else {
    ordered = true;
    queue = '';

    while (index < length) {
      character = value.charAt(index);

      if (!decimal(character)) {
        break;
      }

      queue += character;
      index++;
    }

    character = value.charAt(index);

    if (!queue || markers[character] !== true) {
      return;
    }

    start = parseInt(queue, 10);
    marker = character;
  }

  character = value.charAt(++index);

  if (character !== C_SPACE && character !== C_TAB) {
    return;
  }

  if (silent) {
    return true;
  }

  index = 0;
  items = [];
  allLines = [];
  emptyLines = [];

  while (index < length) {
    nextIndex = value.indexOf(C_NEWLINE, index);
    startIndex = index;
    prefixed = false;
    indented = false;

    if (nextIndex === -1) {
      nextIndex = length;
    }

    end = index + TAB_SIZE;
    size = 0;

    while (index < length) {
      character = value.charAt(index);

      if (character === C_TAB) {
        size += TAB_SIZE - (size % TAB_SIZE);
      } else if (character === C_SPACE) {
        size++;
      } else {
        break;
      }

      index++;
    }

    if (size >= TAB_SIZE) {
      indented = true;
    }

    if (item && size >= item.indent) {
      indented = true;
    }

    character = value.charAt(index);
    currentMarker = null;

    if (!indented) {
      if (LIST_UNORDERED_MARKERS[character] === true) {
        currentMarker = character;
        index++;
        size++;
      } else {
        queue = '';

        while (index < length) {
          character = value.charAt(index);

          if (!decimal(character)) {
            break;
          }

          queue += character;
          index++;
        }

        character = value.charAt(index);
        index++;

        if (queue && markers[character] === true) {
          currentMarker = character;
          size += queue.length + 1;
        }
      }

      if (currentMarker) {
        character = value.charAt(index);

        if (character === C_TAB) {
          size += TAB_SIZE - (size % TAB_SIZE);
          index++;
        } else if (character === C_SPACE) {
          end = index + TAB_SIZE;

          while (index < end) {
            if (value.charAt(index) !== C_SPACE) {
              break;
            }

            index++;
            size++;
          }

          if (index === end && value.charAt(index) === C_SPACE) {
            index -= TAB_SIZE - 1;
            size -= TAB_SIZE - 1;
          }
        } else if (character !== C_NEWLINE && character !== '') {
          currentMarker = null;
        }
      }
    }

    if (currentMarker) {
      if (!pedantic && marker !== currentMarker) {
        break;
      }

      prefixed = true;
    } else {
      if (!commonmark && !indented && value.charAt(startIndex) === C_SPACE) {
        indented = true;
      } else if (commonmark && item) {
        indented = size >= item.indent || size > TAB_SIZE;
      }

      prefixed = false;
      index = startIndex;
    }

    line = value.slice(startIndex, nextIndex);
    content = startIndex === index ? line : value.slice(index, nextIndex);

    if (
      currentMarker === C_ASTERISK ||
      currentMarker === C_UNDERSCORE ||
      currentMarker === C_DASH
    ) {
      if (tokenizers.thematicBreak.call(self, eat, line, true)) {
        break;
      }
    }

    prevEmpty = empty;
    empty = !trim(content).length;

    if (indented && item) {
      item.value = item.value.concat(emptyLines, line);
      allLines = allLines.concat(emptyLines, line);
      emptyLines = [];
    } else if (prefixed) {
      if (emptyLines.length !== 0) {
        item.value.push('');
        item.trail = emptyLines.concat();
      }

      item = {
        value: [line],
        indent: size,
        trail: []
      };

      items.push(item);
      allLines = allLines.concat(emptyLines, line);
      emptyLines = [];
    } else if (empty) {
      if (prevEmpty) {
        break;
      }

      emptyLines.push(line);
    } else {
      if (prevEmpty) {
        break;
      }

      if (interrupt(interuptors, tokenizers, self, [eat, line, true])) {
        break;
      }

      item.value = item.value.concat(emptyLines, line);
      allLines = allLines.concat(emptyLines, line);
      emptyLines = [];
    }

    index = nextIndex + 1;
  }

  node = eat(allLines.join(C_NEWLINE)).reset({
    type: 'list',
    ordered: ordered,
    start: start,
    loose: null,
    children: []
  });

  enterTop = self.enterList();
  exitBlockquote = self.enterBlock();
  isLoose = false;
  index = -1;
  length = items.length;

  while (++index < length) {
    item = items[index].value.join(C_NEWLINE);
    now = eat.now();

    item = eat(item)(listItem(self, item, now), node);

    if (item.loose) {
      isLoose = true;
    }

    item = items[index].trail.join(C_NEWLINE);

    if (index !== length - 1) {
      item += C_NEWLINE;
    }

    eat(item);
  }

  enterTop();
  exitBlockquote();

  node.loose = isLoose;

  return node;
}

function listItem(ctx, value, position) {
  var offsets = ctx.offset;
  var fn = ctx.options.pedantic ? pedanticListItem : normalListItem;
  var checked = null;
  var task;
  var indent;

  value = fn.apply(null, arguments);

  if (ctx.options.gfm) {
    task = value.match(EXPRESSION_TASK_ITEM);

    if (task) {
      indent = task[0].length;
      checked = task[1].toLowerCase() === C_X_LOWER;
      offsets[position.line] += indent;
      value = value.slice(indent);
    }
  }

  return {
    type: 'listItem',
    loose: EXPRESSION_LOOSE_LIST_ITEM.test(value) ||
      value.charAt(value.length - 1) === C_NEWLINE,
    checked: checked,
    children: ctx.tokenizeBlock(value, position)
  };
}

/* Create a list-item using overly simple mechanics. */
function pedanticListItem(ctx, value, position) {
  var offsets = ctx.offset;
  var line = position.line;

  /* Remove the list-item’s bullet. */
  value = value.replace(EXPRESSION_PEDANTIC_BULLET, replacer);

  /* The initial line was also matched by the below, so
   * we reset the `line`. */
  line = position.line;

  return value.replace(EXPRESSION_INITIAL_INDENT, replacer);

  /* A simple replacer which removed all matches,
   * and adds their length to `offset`. */
  function replacer($0) {
    offsets[line] = (offsets[line] || 0) + $0.length;
    line++;

    return '';
  }
}

/* Create a list-item using sane mechanics. */
function normalListItem(ctx, value, position) {
  var offsets = ctx.offset;
  var line = position.line;
  var max;
  var bullet;
  var rest;
  var lines;
  var trimmedLines;
  var index;
  var length;

  /* Remove the list-item’s bullet. */
  value = value.replace(EXPRESSION_BULLET, replacer);

  lines = value.split(C_NEWLINE);

  trimmedLines = removeIndent(value, getIndent(max).indent).split(C_NEWLINE);

  /* We replaced the initial bullet with something
   * else above, which was used to trick
   * `removeIndentation` into removing some more
   * characters when possible.  However, that could
   * result in the initial line to be stripped more
   * than it should be. */
  trimmedLines[0] = rest;

  offsets[line] = (offsets[line] || 0) + bullet.length;
  line++;

  index = 0;
  length = lines.length;

  while (++index < length) {
    offsets[line] = (offsets[line] || 0) +
      lines[index].length - trimmedLines[index].length;
    line++;
  }

  return trimmedLines.join(C_NEWLINE);

  function replacer($0, $1, $2, $3, $4) {
    bullet = $1 + $2 + $3;
    rest = $4;

    /* Make sure that the first nine numbered list items
     * can indent with an extra space.  That is, when
     * the bullet did not receive an extra final space. */
    if (Number($2) < 10 && bullet.length % 2 === 1) {
      $2 = C_SPACE + $2;
    }

    max = $1 + repeat(C_SPACE, $2.length) + $3;

    return max + rest;
  }
}


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var trim = __webpack_require__(22);
var repeat = __webpack_require__(61);
var getIndent = __webpack_require__(113);

module.exports = indentation;

var C_SPACE = ' ';
var C_NEWLINE = '\n';
var C_TAB = '\t';

/* Remove the minimum indent from every line in `value`.
 * Supports both tab, spaced, and mixed indentation (as
 * well as possible). */
function indentation(value, maximum) {
  var values = value.split(C_NEWLINE);
  var position = values.length + 1;
  var minIndent = Infinity;
  var matrix = [];
  var index;
  var indentation;
  var stops;
  var padding;

  values.unshift(repeat(C_SPACE, maximum) + '!');

  while (position--) {
    indentation = getIndent(values[position]);

    matrix[position] = indentation.stops;

    if (trim(values[position]).length === 0) {
      continue;
    }

    if (indentation.indent) {
      if (indentation.indent > 0 && indentation.indent < minIndent) {
        minIndent = indentation.indent;
      }
    } else {
      minIndent = Infinity;

      break;
    }
  }

  if (minIndent !== Infinity) {
    position = values.length;

    while (position--) {
      stops = matrix[position];
      index = minIndent;

      while (index && !(index in stops)) {
        index--;
      }

      if (
        trim(values[position]).length !== 0 &&
        minIndent &&
        index !== minIndent
      ) {
        padding = C_TAB;
      } else {
        padding = '';
      }

      values[position] = padding + values[position].slice(
        index in stops ? stops[index] + 1 : 0
      );
    }
  }

  values.shift();

  return values.join(C_NEWLINE);
}


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = setextHeading;

var C_NEWLINE = '\n';
var C_TAB = '\t';
var C_SPACE = ' ';
var C_EQUALS = '=';
var C_DASH = '-';

var MAX_HEADING_INDENT = 3;

/* Map of characters which can be used to mark setext
 * headers, mapping to their corresponding depth. */
var SETEXT_MARKERS = {};

SETEXT_MARKERS[C_EQUALS] = 1;
SETEXT_MARKERS[C_DASH] = 2;

function setextHeading(eat, value, silent) {
  var self = this;
  var now = eat.now();
  var length = value.length;
  var index = -1;
  var subvalue = '';
  var content;
  var queue;
  var character;
  var marker;
  var depth;

  /* Eat initial indentation. */
  while (++index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE || index >= MAX_HEADING_INDENT) {
      index--;
      break;
    }

    subvalue += character;
  }

  /* Eat content. */
  content = '';
  queue = '';

  while (++index < length) {
    character = value.charAt(index);

    if (character === C_NEWLINE) {
      index--;
      break;
    }

    if (character === C_SPACE || character === C_TAB) {
      queue += character;
    } else {
      content += queue + character;
      queue = '';
    }
  }

  now.column += subvalue.length;
  now.offset += subvalue.length;
  subvalue += content + queue;

  /* Ensure the content is followed by a newline and a
   * valid marker. */
  character = value.charAt(++index);
  marker = value.charAt(++index);

  if (character !== C_NEWLINE || !SETEXT_MARKERS[marker]) {
    return;
  }

  subvalue += character;

  /* Eat Setext-line. */
  queue = marker;
  depth = SETEXT_MARKERS[marker];

  while (++index < length) {
    character = value.charAt(index);

    if (character !== marker) {
      if (character !== C_NEWLINE) {
        return;
      }

      index--;
      break;
    }

    queue += character;
  }

  if (silent) {
    return true;
  }

  return eat(subvalue + queue)({
    type: 'heading',
    depth: depth,
    children: self.tokenizeInline(content, now)
  });
}


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var openCloseTag = __webpack_require__(114).openCloseTag;

module.exports = blockHTML;

var C_TAB = '\t';
var C_SPACE = ' ';
var C_NEWLINE = '\n';
var C_LT = '<';

function blockHTML(eat, value, silent) {
  var self = this;
  var blocks = self.options.blocks;
  var length = value.length;
  var index = 0;
  var next;
  var line;
  var offset;
  var character;
  var count;
  var sequence;
  var subvalue;

  var sequences = [
    [/^<(script|pre|style)(?=(\s|>|$))/i, /<\/(script|pre|style)>/i, true],
    [/^<!--/, /-->/, true],
    [/^<\?/, /\?>/, true],
    [/^<![A-Za-z]/, />/, true],
    [/^<!\[CDATA\[/, /\]\]>/, true],
    [new RegExp('^</?(' + blocks.join('|') + ')(?=(\\s|/?>|$))', 'i'), /^$/, true],
    [new RegExp(openCloseTag.source + '\\s*$'), /^$/, false]
  ];

  /* Eat initial spacing. */
  while (index < length) {
    character = value.charAt(index);

    if (character !== C_TAB && character !== C_SPACE) {
      break;
    }

    index++;
  }

  if (value.charAt(index) !== C_LT) {
    return;
  }

  next = value.indexOf(C_NEWLINE, index + 1);
  next = next === -1 ? length : next;
  line = value.slice(index, next);
  offset = -1;
  count = sequences.length;

  while (++offset < count) {
    if (sequences[offset][0].test(line)) {
      sequence = sequences[offset];
      break;
    }
  }

  if (!sequence) {
    return;
  }

  if (silent) {
    return sequence[2];
  }

  index = next;

  if (!sequence[1].test(line)) {
    while (index < length) {
      next = value.indexOf(C_NEWLINE, index + 1);
      next = next === -1 ? length : next;
      line = value.slice(index + 1, next);

      if (sequence[1].test(line)) {
        if (line) {
          index = next;
        }

        break;
      }

      index = next;
    }
  }

  subvalue = value.slice(0, index);

  return eat(subvalue)({type: 'html', value: subvalue});
}


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var whitespace = __webpack_require__(5);
var normalize = __webpack_require__(64);

module.exports = footnoteDefinition;
footnoteDefinition.notInList = true;
footnoteDefinition.notInBlock = true;

var C_BACKSLASH = '\\';
var C_NEWLINE = '\n';
var C_TAB = '\t';
var C_SPACE = ' ';
var C_BRACKET_OPEN = '[';
var C_BRACKET_CLOSE = ']';
var C_CARET = '^';
var C_COLON = ':';

var EXPRESSION_INITIAL_TAB = /^( {4}|\t)?/gm;

function footnoteDefinition(eat, value, silent) {
  var self = this;
  var offsets = self.offset;
  var index;
  var length;
  var subvalue;
  var now;
  var currentLine;
  var content;
  var queue;
  var subqueue;
  var character;
  var identifier;
  var add;
  var exit;

  if (!self.options.footnotes) {
    return;
  }

  index = 0;
  length = value.length;
  subvalue = '';
  now = eat.now();
  currentLine = now.line;

  while (index < length) {
    character = value.charAt(index);

    if (!whitespace(character)) {
      break;
    }

    subvalue += character;
    index++;
  }

  if (
    value.charAt(index) !== C_BRACKET_OPEN ||
    value.charAt(index + 1) !== C_CARET
  ) {
    return;
  }

  subvalue += C_BRACKET_OPEN + C_CARET;
  index = subvalue.length;
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (character === C_BRACKET_CLOSE) {
      break;
    } else if (character === C_BACKSLASH) {
      queue += character;
      index++;
      character = value.charAt(index);
    }

    queue += character;
    index++;
  }

  if (
    !queue ||
    value.charAt(index) !== C_BRACKET_CLOSE ||
    value.charAt(index + 1) !== C_COLON
  ) {
    return;
  }

  if (silent) {
    return true;
  }

  identifier = normalize(queue);
  subvalue += queue + C_BRACKET_CLOSE + C_COLON;
  index = subvalue.length;

  while (index < length) {
    character = value.charAt(index);

    if (character !== C_TAB && character !== C_SPACE) {
      break;
    }

    subvalue += character;
    index++;
  }

  now.column += subvalue.length;
  now.offset += subvalue.length;
  queue = '';
  content = '';
  subqueue = '';

  while (index < length) {
    character = value.charAt(index);

    if (character === C_NEWLINE) {
      subqueue = character;
      index++;

      while (index < length) {
        character = value.charAt(index);

        if (character !== C_NEWLINE) {
          break;
        }

        subqueue += character;
        index++;
      }

      queue += subqueue;
      subqueue = '';

      while (index < length) {
        character = value.charAt(index);

        if (character !== C_SPACE) {
          break;
        }

        subqueue += character;
        index++;
      }

      if (subqueue.length === 0) {
        break;
      }

      queue += subqueue;
    }

    if (queue) {
      content += queue;
      queue = '';
    }

    content += character;
    index++;
  }

  subvalue += content;

  content = content.replace(EXPRESSION_INITIAL_TAB, function (line) {
    offsets[currentLine] = (offsets[currentLine] || 0) + line.length;
    currentLine++;

    return '';
  });

  add = eat(subvalue);

  exit = self.enterBlock();
  content = self.tokenizeBlock(content, now);
  exit();

  return add({
    type: 'footnoteDefinition',
    identifier: identifier,
    children: content
  });
}


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = collapse

// `collapse(' \t\nbar \nbaz\t') // ' bar baz '`
function collapse(value) {
  return String(value).replace(/\s+/g, ' ')
}


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var whitespace = __webpack_require__(5);
var normalize = __webpack_require__(64);

module.exports = definition;
definition.notInList = true;
definition.notInBlock = true;

var C_DOUBLE_QUOTE = '"';
var C_SINGLE_QUOTE = '\'';
var C_BACKSLASH = '\\';
var C_NEWLINE = '\n';
var C_TAB = '\t';
var C_SPACE = ' ';
var C_BRACKET_OPEN = '[';
var C_BRACKET_CLOSE = ']';
var C_PAREN_OPEN = '(';
var C_PAREN_CLOSE = ')';
var C_COLON = ':';
var C_LT = '<';
var C_GT = '>';

function definition(eat, value, silent) {
  var self = this;
  var commonmark = self.options.commonmark;
  var index = 0;
  var length = value.length;
  var subvalue = '';
  var beforeURL;
  var beforeTitle;
  var queue;
  var character;
  var test;
  var identifier;
  var url;
  var title;

  while (index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE && character !== C_TAB) {
      break;
    }

    subvalue += character;
    index++;
  }

  character = value.charAt(index);

  if (character !== C_BRACKET_OPEN) {
    return;
  }

  index++;
  subvalue += character;
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (character === C_BRACKET_CLOSE) {
      break;
    } else if (character === C_BACKSLASH) {
      queue += character;
      index++;
      character = value.charAt(index);
    }

    queue += character;
    index++;
  }

  if (
    !queue ||
    value.charAt(index) !== C_BRACKET_CLOSE ||
    value.charAt(index + 1) !== C_COLON
  ) {
    return;
  }

  identifier = queue;
  subvalue += queue + C_BRACKET_CLOSE + C_COLON;
  index = subvalue.length;
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (
      character !== C_TAB &&
      character !== C_SPACE &&
      character !== C_NEWLINE
    ) {
      break;
    }

    subvalue += character;
    index++;
  }

  character = value.charAt(index);
  queue = '';
  beforeURL = subvalue;

  if (character === C_LT) {
    index++;

    while (index < length) {
      character = value.charAt(index);

      if (!isEnclosedURLCharacter(character)) {
        break;
      }

      queue += character;
      index++;
    }

    character = value.charAt(index);

    if (character === isEnclosedURLCharacter.delimiter) {
      subvalue += C_LT + queue + character;
      index++;
    } else {
      if (commonmark) {
        return;
      }

      index -= queue.length + 1;
      queue = '';
    }
  }

  if (!queue) {
    while (index < length) {
      character = value.charAt(index);

      if (!isUnclosedURLCharacter(character)) {
        break;
      }

      queue += character;
      index++;
    }

    subvalue += queue;
  }

  if (!queue) {
    return;
  }

  url = queue;
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (
      character !== C_TAB &&
      character !== C_SPACE &&
      character !== C_NEWLINE
    ) {
      break;
    }

    queue += character;
    index++;
  }

  character = value.charAt(index);
  test = null;

  if (character === C_DOUBLE_QUOTE) {
    test = C_DOUBLE_QUOTE;
  } else if (character === C_SINGLE_QUOTE) {
    test = C_SINGLE_QUOTE;
  } else if (character === C_PAREN_OPEN) {
    test = C_PAREN_CLOSE;
  }

  if (!test) {
    queue = '';
    index = subvalue.length;
  } else if (queue) {
    subvalue += queue + character;
    index = subvalue.length;
    queue = '';

    while (index < length) {
      character = value.charAt(index);

      if (character === test) {
        break;
      }

      if (character === C_NEWLINE) {
        index++;
        character = value.charAt(index);

        if (character === C_NEWLINE || character === test) {
          return;
        }

        queue += C_NEWLINE;
      }

      queue += character;
      index++;
    }

    character = value.charAt(index);

    if (character !== test) {
      return;
    }

    beforeTitle = subvalue;
    subvalue += queue + character;
    index++;
    title = queue;
    queue = '';
  } else {
    return;
  }

  while (index < length) {
    character = value.charAt(index);

    if (character !== C_TAB && character !== C_SPACE) {
      break;
    }

    subvalue += character;
    index++;
  }

  character = value.charAt(index);

  if (!character || character === C_NEWLINE) {
    if (silent) {
      return true;
    }

    beforeURL = eat(beforeURL).test().end;
    url = self.decode.raw(self.unescape(url), beforeURL, {nonTerminated: false});

    if (title) {
      beforeTitle = eat(beforeTitle).test().end;
      title = self.decode.raw(self.unescape(title), beforeTitle);
    }

    return eat(subvalue)({
      type: 'definition',
      identifier: normalize(identifier),
      title: title || null,
      url: url
    });
  }
}

/* Check if `character` can be inside an enclosed URI. */
function isEnclosedURLCharacter(character) {
  return character !== C_GT &&
    character !== C_BRACKET_OPEN &&
    character !== C_BRACKET_CLOSE;
}

isEnclosedURLCharacter.delimiter = C_GT;

/* Check if `character` can be inside an unclosed URI. */
function isUnclosedURLCharacter(character) {
  return character !== C_BRACKET_OPEN &&
    character !== C_BRACKET_CLOSE &&
    !whitespace(character);
}


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var whitespace = __webpack_require__(5);

module.exports = table;

var C_BACKSLASH = '\\';
var C_TICK = '`';
var C_DASH = '-';
var C_PIPE = '|';
var C_COLON = ':';
var C_SPACE = ' ';
var C_NEWLINE = '\n';
var C_TAB = '\t';

var MIN_TABLE_COLUMNS = 1;
var MIN_TABLE_ROWS = 2;

var TABLE_ALIGN_LEFT = 'left';
var TABLE_ALIGN_CENTER = 'center';
var TABLE_ALIGN_RIGHT = 'right';
var TABLE_ALIGN_NONE = null;

function table(eat, value, silent) {
  var self = this;
  var index;
  var alignments;
  var alignment;
  var subvalue;
  var row;
  var length;
  var lines;
  var queue;
  var character;
  var hasDash;
  var align;
  var cell;
  var preamble;
  var count;
  var opening;
  var now;
  var position;
  var lineCount;
  var line;
  var rows;
  var table;
  var lineIndex;
  var pipeIndex;
  var first;

  /* Exit when not in gfm-mode. */
  if (!self.options.gfm) {
    return;
  }

  /* Get the rows.
   * Detecting tables soon is hard, so there are some
   * checks for performance here, such as the minimum
   * number of rows, and allowed characters in the
   * alignment row. */
  index = 0;
  lineCount = 0;
  length = value.length + 1;
  lines = [];

  while (index < length) {
    lineIndex = value.indexOf(C_NEWLINE, index);
    pipeIndex = value.indexOf(C_PIPE, index + 1);

    if (lineIndex === -1) {
      lineIndex = value.length;
    }

    if (pipeIndex === -1 || pipeIndex > lineIndex) {
      if (lineCount < MIN_TABLE_ROWS) {
        return;
      }

      break;
    }

    lines.push(value.slice(index, lineIndex));
    lineCount++;
    index = lineIndex + 1;
  }

  /* Parse the alignment row. */
  subvalue = lines.join(C_NEWLINE);
  alignments = lines.splice(1, 1)[0] || [];
  index = 0;
  length = alignments.length;
  lineCount--;
  alignment = false;
  align = [];

  while (index < length) {
    character = alignments.charAt(index);

    if (character === C_PIPE) {
      hasDash = null;

      if (alignment === false) {
        if (first === false) {
          return;
        }
      } else {
        align.push(alignment);
        alignment = false;
      }

      first = false;
    } else if (character === C_DASH) {
      hasDash = true;
      alignment = alignment || TABLE_ALIGN_NONE;
    } else if (character === C_COLON) {
      if (alignment === TABLE_ALIGN_LEFT) {
        alignment = TABLE_ALIGN_CENTER;
      } else if (hasDash && alignment === TABLE_ALIGN_NONE) {
        alignment = TABLE_ALIGN_RIGHT;
      } else {
        alignment = TABLE_ALIGN_LEFT;
      }
    } else if (!whitespace(character)) {
      return;
    }

    index++;
  }

  if (alignment !== false) {
    align.push(alignment);
  }

  /* Exit when without enough columns. */
  if (align.length < MIN_TABLE_COLUMNS) {
    return;
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true;
  }

  /* Parse the rows. */
  position = -1;
  rows = [];

  table = eat(subvalue).reset({
    type: 'table',
    align: align,
    children: rows
  });

  while (++position < lineCount) {
    line = lines[position];
    row = {type: 'tableRow', children: []};

    /* Eat a newline character when this is not the
     * first row. */
    if (position) {
      eat(C_NEWLINE);
    }

    /* Eat the row. */
    eat(line).reset(row, table);

    length = line.length + 1;
    index = 0;
    queue = '';
    cell = '';
    preamble = true;
    count = null;
    opening = null;

    while (index < length) {
      character = line.charAt(index);

      if (character === C_TAB || character === C_SPACE) {
        if (cell) {
          queue += character;
        } else {
          eat(character);
        }

        index++;
        continue;
      }

      if (character === '' || character === C_PIPE) {
        if (preamble) {
          eat(character);
        } else {
          if (character && opening) {
            queue += character;
            index++;
            continue;
          }

          if ((cell || character) && !preamble) {
            subvalue = cell;

            if (queue.length > 1) {
              if (character) {
                subvalue += queue.slice(0, queue.length - 1);
                queue = queue.charAt(queue.length - 1);
              } else {
                subvalue += queue;
                queue = '';
              }
            }

            now = eat.now();

            eat(subvalue)({
              type: 'tableCell',
              children: self.tokenizeInline(cell, now)
            }, row);
          }

          eat(queue + character);

          queue = '';
          cell = '';
        }
      } else {
        if (queue) {
          cell += queue;
          queue = '';
        }

        cell += character;

        if (character === C_BACKSLASH && index !== length - 2) {
          cell += line.charAt(index + 1);
          index++;
        }

        if (character === C_TICK) {
          count = 1;

          while (line.charAt(index + 1) === character) {
            cell += character;
            index++;
            count++;
          }

          if (!opening) {
            opening = count;
          } else if (count >= opening) {
            opening = 0;
          }
        }
      }

      preamble = false;
      index++;
    }

    /* Eat the alignment row. */
    if (!position) {
      eat(C_NEWLINE + alignments);
    }
  }

  return table;
}


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var trim = __webpack_require__(22);
var decimal = __webpack_require__(39);
var trimTrailingLines = __webpack_require__(62);
var interrupt = __webpack_require__(63);

module.exports = paragraph;

var C_NEWLINE = '\n';
var C_TAB = '\t';
var C_SPACE = ' ';

var TAB_SIZE = 4;

/* Tokenise paragraph. */
function paragraph(eat, value, silent) {
  var self = this;
  var settings = self.options;
  var commonmark = settings.commonmark;
  var gfm = settings.gfm;
  var tokenizers = self.blockTokenizers;
  var interruptors = self.interruptParagraph;
  var index = value.indexOf(C_NEWLINE);
  var length = value.length;
  var position;
  var subvalue;
  var character;
  var size;
  var now;

  while (index < length) {
    /* Eat everything if there’s no following newline. */
    if (index === -1) {
      index = length;
      break;
    }

    /* Stop if the next character is NEWLINE. */
    if (value.charAt(index + 1) === C_NEWLINE) {
      break;
    }

    /* In commonmark-mode, following indented lines
     * are part of the paragraph. */
    if (commonmark) {
      size = 0;
      position = index + 1;

      while (position < length) {
        character = value.charAt(position);

        if (character === C_TAB) {
          size = TAB_SIZE;
          break;
        } else if (character === C_SPACE) {
          size++;
        } else {
          break;
        }

        position++;
      }

      if (size >= TAB_SIZE) {
        index = value.indexOf(C_NEWLINE, index + 1);
        continue;
      }
    }

    subvalue = value.slice(index + 1);

    /* Check if the following code contains a possible
     * block. */
    if (interrupt(interruptors, tokenizers, self, [eat, subvalue, true])) {
      break;
    }

    /* Break if the following line starts a list, when
     * already in a list, or when in commonmark, or when
     * in gfm mode and the bullet is *not* numeric. */
    if (
      tokenizers.list.call(self, eat, subvalue, true) &&
      (
        self.inList ||
        commonmark ||
        (gfm && !decimal(trim.left(subvalue).charAt(0)))
      )
    ) {
      break;
    }

    position = index;
    index = value.indexOf(C_NEWLINE, index + 1);

    if (index !== -1 && trim(value.slice(position, index)) === '') {
      index = position;
      break;
    }
  }

  subvalue = value.slice(0, index);

  if (trim(subvalue) === '') {
    eat(subvalue);

    return null;
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true;
  }

  now = eat.now();
  subvalue = trimTrailingLines(subvalue);

  return eat(subvalue)({
    type: 'paragraph',
    children: self.tokenizeInline(subvalue, now)
  });
}


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var locate = __webpack_require__(281);

module.exports = escape;
escape.locator = locate;

function escape(eat, value, silent) {
  var self = this;
  var character;
  var node;

  if (value.charAt(0) === '\\') {
    character = value.charAt(1);

    if (self.escape.indexOf(character) !== -1) {
      /* istanbul ignore if - never used (yet) */
      if (silent) {
        return true;
      }

      if (character === '\n') {
        node = {type: 'break'};
      } else {
        node = {
          type: 'text',
          value: character
        };
      }

      return eat('\\' + character)(node);
    }
  }
}


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('\\', fromIndex);
}


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var whitespace = __webpack_require__(5);
var decode = __webpack_require__(60);
var locate = __webpack_require__(115);

module.exports = autoLink;
autoLink.locator = locate;
autoLink.notInLink = true;

var C_LT = '<';
var C_GT = '>';
var C_AT_SIGN = '@';
var C_SLASH = '/';
var MAILTO = 'mailto:';
var MAILTO_LENGTH = MAILTO.length;

/* Tokenise a link. */
function autoLink(eat, value, silent) {
  var self;
  var subvalue;
  var length;
  var index;
  var queue;
  var character;
  var hasAtCharacter;
  var link;
  var now;
  var content;
  var tokenizers;
  var exit;

  if (value.charAt(0) !== C_LT) {
    return;
  }

  self = this;
  subvalue = '';
  length = value.length;
  index = 0;
  queue = '';
  hasAtCharacter = false;
  link = '';

  index++;
  subvalue = C_LT;

  while (index < length) {
    character = value.charAt(index);

    if (
      whitespace(character) ||
      character === C_GT ||
      character === C_AT_SIGN ||
      (character === ':' && value.charAt(index + 1) === C_SLASH)
    ) {
      break;
    }

    queue += character;
    index++;
  }

  if (!queue) {
    return;
  }

  link += queue;
  queue = '';

  character = value.charAt(index);
  link += character;
  index++;

  if (character === C_AT_SIGN) {
    hasAtCharacter = true;
  } else {
    if (
      character !== ':' ||
      value.charAt(index + 1) !== C_SLASH
    ) {
      return;
    }

    link += C_SLASH;
    index++;
  }

  while (index < length) {
    character = value.charAt(index);

    if (whitespace(character) || character === C_GT) {
      break;
    }

    queue += character;
    index++;
  }

  character = value.charAt(index);

  if (!queue || character !== C_GT) {
    return;
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true;
  }

  link += queue;
  content = link;
  subvalue += link + character;
  now = eat.now();
  now.column++;
  now.offset++;

  if (hasAtCharacter) {
    if (link.slice(0, MAILTO_LENGTH).toLowerCase() === MAILTO) {
      content = content.substr(MAILTO_LENGTH);
      now.column += MAILTO_LENGTH;
      now.offset += MAILTO_LENGTH;
    } else {
      link = MAILTO + link;
    }
  }

  /* Temporarily remove all tokenizers except text in autolinks. */
  tokenizers = self.inlineTokenizers;
  self.inlineTokenizers = {text: tokenizers.text};

  exit = self.enterLink();

  content = self.tokenizeInline(content, now);

  self.inlineTokenizers = tokenizers;
  exit();

  return eat(subvalue)({
    type: 'link',
    title: null,
    url: decode(link, {nonTerminated: false}),
    children: content
  });
}


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var decode = __webpack_require__(60);
var whitespace = __webpack_require__(5);
var locate = __webpack_require__(284);

module.exports = url;
url.locator = locate;
url.notInLink = true;

var C_BRACKET_OPEN = '[';
var C_BRACKET_CLOSE = ']';
var C_PAREN_OPEN = '(';
var C_PAREN_CLOSE = ')';
var C_LT = '<';
var C_AT_SIGN = '@';

var HTTP_PROTOCOL = 'http://';
var HTTPS_PROTOCOL = 'https://';
var MAILTO_PROTOCOL = 'mailto:';

var PROTOCOLS = [
  HTTP_PROTOCOL,
  HTTPS_PROTOCOL,
  MAILTO_PROTOCOL
];

var PROTOCOLS_LENGTH = PROTOCOLS.length;

function url(eat, value, silent) {
  var self = this;
  var subvalue;
  var content;
  var character;
  var index;
  var position;
  var protocol;
  var match;
  var length;
  var queue;
  var parenCount;
  var nextCharacter;
  var exit;

  if (!self.options.gfm) {
    return;
  }

  subvalue = '';
  index = -1;
  length = PROTOCOLS_LENGTH;

  while (++index < length) {
    protocol = PROTOCOLS[index];
    match = value.slice(0, protocol.length);

    if (match.toLowerCase() === protocol) {
      subvalue = match;
      break;
    }
  }

  if (!subvalue) {
    return;
  }

  index = subvalue.length;
  length = value.length;
  queue = '';
  parenCount = 0;

  while (index < length) {
    character = value.charAt(index);

    if (whitespace(character) || character === C_LT) {
      break;
    }

    if (
      character === '.' ||
      character === ',' ||
      character === ':' ||
      character === ';' ||
      character === '"' ||
      character === '\'' ||
      character === ')' ||
      character === ']'
    ) {
      nextCharacter = value.charAt(index + 1);

      if (!nextCharacter || whitespace(nextCharacter)) {
        break;
      }
    }

    if (character === C_PAREN_OPEN || character === C_BRACKET_OPEN) {
      parenCount++;
    }

    if (character === C_PAREN_CLOSE || character === C_BRACKET_CLOSE) {
      parenCount--;

      if (parenCount < 0) {
        break;
      }
    }

    queue += character;
    index++;
  }

  if (!queue) {
    return;
  }

  subvalue += queue;
  content = subvalue;

  if (protocol === MAILTO_PROTOCOL) {
    position = queue.indexOf(C_AT_SIGN);

    if (position === -1 || position === length - 1) {
      return;
    }

    content = content.substr(MAILTO_PROTOCOL.length);
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true;
  }

  exit = self.enterLink();
  content = self.tokenizeInline(content, eat.now());
  exit();

  return eat(subvalue)({
    type: 'link',
    title: null,
    url: decode(subvalue, {nonTerminated: false}),
    children: content
  });
}


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = locate;

var PROTOCOLS = ['https://', 'http://', 'mailto:'];

function locate(value, fromIndex) {
  var length = PROTOCOLS.length;
  var index = -1;
  var min = -1;
  var position;

  if (!this.options.gfm) {
    return -1;
  }

  while (++index < length) {
    position = value.indexOf(PROTOCOLS[index], fromIndex);

    if (position !== -1 && (position < min || min === -1)) {
      min = position;
    }
  }

  return min;
}


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabetical = __webpack_require__(111);
var locate = __webpack_require__(115);
var tag = __webpack_require__(114).tag;

module.exports = inlineHTML;
inlineHTML.locator = locate;

var EXPRESSION_HTML_LINK_OPEN = /^<a /i;
var EXPRESSION_HTML_LINK_CLOSE = /^<\/a>/i;

function inlineHTML(eat, value, silent) {
  var self = this;
  var length = value.length;
  var character;
  var subvalue;

  if (value.charAt(0) !== '<' || length < 3) {
    return;
  }

  character = value.charAt(1);

  if (
    !alphabetical(character) &&
    character !== '?' &&
    character !== '!' &&
    character !== '/'
  ) {
    return;
  }

  subvalue = value.match(tag);

  if (!subvalue) {
    return;
  }

  /* istanbul ignore if - not used yet. */
  if (silent) {
    return true;
  }

  subvalue = subvalue[0];

  if (!self.inLink && EXPRESSION_HTML_LINK_OPEN.test(subvalue)) {
    self.inLink = true;
  } else if (self.inLink && EXPRESSION_HTML_LINK_CLOSE.test(subvalue)) {
    self.inLink = false;
  }

  return eat(subvalue)({type: 'html', value: subvalue});
}


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var whitespace = __webpack_require__(5);
var locate = __webpack_require__(116);

module.exports = link;
link.locator = locate;

var own = {}.hasOwnProperty;

var C_BACKSLASH = '\\';
var C_BRACKET_OPEN = '[';
var C_BRACKET_CLOSE = ']';
var C_PAREN_OPEN = '(';
var C_PAREN_CLOSE = ')';
var C_LT = '<';
var C_GT = '>';
var C_TICK = '`';
var C_DOUBLE_QUOTE = '"';
var C_SINGLE_QUOTE = '\'';

/* Map of characters, which can be used to mark link
 * and image titles. */
var LINK_MARKERS = {};

LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;

/* Map of characters, which can be used to mark link
 * and image titles in commonmark-mode. */
var COMMONMARK_LINK_MARKERS = {};

COMMONMARK_LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
COMMONMARK_LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;
COMMONMARK_LINK_MARKERS[C_PAREN_OPEN] = C_PAREN_CLOSE;

function link(eat, value, silent) {
  var self = this;
  var subvalue = '';
  var index = 0;
  var character = value.charAt(0);
  var pedantic = self.options.pedantic;
  var commonmark = self.options.commonmark;
  var gfm = self.options.gfm;
  var closed;
  var count;
  var opening;
  var beforeURL;
  var beforeTitle;
  var subqueue;
  var hasMarker;
  var markers;
  var isImage;
  var content;
  var marker;
  var length;
  var title;
  var depth;
  var queue;
  var url;
  var now;
  var exit;
  var node;

  /* Detect whether this is an image. */
  if (character === '!') {
    isImage = true;
    subvalue = character;
    character = value.charAt(++index);
  }

  /* Eat the opening. */
  if (character !== C_BRACKET_OPEN) {
    return;
  }

  /* Exit when this is a link and we’re already inside
   * a link. */
  if (!isImage && self.inLink) {
    return;
  }

  subvalue += character;
  queue = '';
  index++;

  /* Eat the content. */
  length = value.length;
  now = eat.now();
  depth = 0;

  now.column += index;
  now.offset += index;

  while (index < length) {
    character = value.charAt(index);
    subqueue = character;

    if (character === C_TICK) {
      /* Inline-code in link content. */
      count = 1;

      while (value.charAt(index + 1) === C_TICK) {
        subqueue += character;
        index++;
        count++;
      }

      if (!opening) {
        opening = count;
      } else if (count >= opening) {
        opening = 0;
      }
    } else if (character === C_BACKSLASH) {
      /* Allow brackets to be escaped. */
      index++;
      subqueue += value.charAt(index);
    /* In GFM mode, brackets in code still count.
     * In all other modes, they don’t.  This empty
     * block prevents the next statements are
     * entered. */
    } else if ((!opening || gfm) && character === C_BRACKET_OPEN) {
      depth++;
    } else if ((!opening || gfm) && character === C_BRACKET_CLOSE) {
      if (depth) {
        depth--;
      } else {
        /* Allow white-space between content and
         * url in GFM mode. */
        if (!pedantic) {
          while (index < length) {
            character = value.charAt(index + 1);

            if (!whitespace(character)) {
              break;
            }

            subqueue += character;
            index++;
          }
        }

        if (value.charAt(index + 1) !== C_PAREN_OPEN) {
          return;
        }

        subqueue += C_PAREN_OPEN;
        closed = true;
        index++;

        break;
      }
    }

    queue += subqueue;
    subqueue = '';
    index++;
  }

  /* Eat the content closing. */
  if (!closed) {
    return;
  }

  content = queue;
  subvalue += queue + subqueue;
  index++;

  /* Eat white-space. */
  while (index < length) {
    character = value.charAt(index);

    if (!whitespace(character)) {
      break;
    }

    subvalue += character;
    index++;
  }

  /* Eat the URL. */
  character = value.charAt(index);
  markers = commonmark ? COMMONMARK_LINK_MARKERS : LINK_MARKERS;
  queue = '';
  beforeURL = subvalue;

  if (character === C_LT) {
    index++;
    beforeURL += C_LT;

    while (index < length) {
      character = value.charAt(index);

      if (character === C_GT) {
        break;
      }

      if (commonmark && character === '\n') {
        return;
      }

      queue += character;
      index++;
    }

    if (value.charAt(index) !== C_GT) {
      return;
    }

    subvalue += C_LT + queue + C_GT;
    url = queue;
    index++;
  } else {
    character = null;
    subqueue = '';

    while (index < length) {
      character = value.charAt(index);

      if (subqueue && own.call(markers, character)) {
        break;
      }

      if (whitespace(character)) {
        if (!pedantic) {
          break;
        }

        subqueue += character;
      } else {
        if (character === C_PAREN_OPEN) {
          depth++;
        } else if (character === C_PAREN_CLOSE) {
          if (depth === 0) {
            break;
          }

          depth--;
        }

        queue += subqueue;
        subqueue = '';

        if (character === C_BACKSLASH) {
          queue += C_BACKSLASH;
          character = value.charAt(++index);
        }

        queue += character;
      }

      index++;
    }

    subvalue += queue;
    url = queue;
    index = subvalue.length;
  }

  /* Eat white-space. */
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (!whitespace(character)) {
      break;
    }

    queue += character;
    index++;
  }

  character = value.charAt(index);
  subvalue += queue;

  /* Eat the title. */
  if (queue && own.call(markers, character)) {
    index++;
    subvalue += character;
    queue = '';
    marker = markers[character];
    beforeTitle = subvalue;

    /* In commonmark-mode, things are pretty easy: the
     * marker cannot occur inside the title.
     *
     * Non-commonmark does, however, support nested
     * delimiters. */
    if (commonmark) {
      while (index < length) {
        character = value.charAt(index);

        if (character === marker) {
          break;
        }

        if (character === C_BACKSLASH) {
          queue += C_BACKSLASH;
          character = value.charAt(++index);
        }

        index++;
        queue += character;
      }

      character = value.charAt(index);

      if (character !== marker) {
        return;
      }

      title = queue;
      subvalue += queue + character;
      index++;

      while (index < length) {
        character = value.charAt(index);

        if (!whitespace(character)) {
          break;
        }

        subvalue += character;
        index++;
      }
    } else {
      subqueue = '';

      while (index < length) {
        character = value.charAt(index);

        if (character === marker) {
          if (hasMarker) {
            queue += marker + subqueue;
            subqueue = '';
          }

          hasMarker = true;
        } else if (!hasMarker) {
          queue += character;
        } else if (character === C_PAREN_CLOSE) {
          subvalue += queue + marker + subqueue;
          title = queue;
          break;
        } else if (whitespace(character)) {
          subqueue += character;
        } else {
          queue += marker + subqueue + character;
          subqueue = '';
          hasMarker = false;
        }

        index++;
      }
    }
  }

  if (value.charAt(index) !== C_PAREN_CLOSE) {
    return;
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true;
  }

  subvalue += C_PAREN_CLOSE;

  url = self.decode.raw(self.unescape(url), eat(beforeURL).test().end, {nonTerminated: false});

  if (title) {
    beforeTitle = eat(beforeTitle).test().end;
    title = self.decode.raw(self.unescape(title), beforeTitle);
  }

  node = {
    type: isImage ? 'image' : 'link',
    title: title || null,
    url: url
  };

  if (isImage) {
    node.alt = self.decode.raw(self.unescape(content), now) || null;
  } else {
    exit = self.enterLink();
    node.children = self.tokenizeInline(content, now);
    exit();
  }

  return eat(subvalue)(node);
}


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var whitespace = __webpack_require__(5);
var locate = __webpack_require__(116);
var normalize = __webpack_require__(64);

module.exports = reference;
reference.locator = locate;

var T_LINK = 'link';
var T_IMAGE = 'image';
var T_FOOTNOTE = 'footnote';
var REFERENCE_TYPE_SHORTCUT = 'shortcut';
var REFERENCE_TYPE_COLLAPSED = 'collapsed';
var REFERENCE_TYPE_FULL = 'full';
var C_CARET = '^';
var C_BACKSLASH = '\\';
var C_BRACKET_OPEN = '[';
var C_BRACKET_CLOSE = ']';

function reference(eat, value, silent) {
  var self = this;
  var character = value.charAt(0);
  var index = 0;
  var length = value.length;
  var subvalue = '';
  var intro = '';
  var type = T_LINK;
  var referenceType = REFERENCE_TYPE_SHORTCUT;
  var content;
  var identifier;
  var now;
  var node;
  var exit;
  var queue;
  var bracketed;
  var depth;

  /* Check whether we’re eating an image. */
  if (character === '!') {
    type = T_IMAGE;
    intro = character;
    character = value.charAt(++index);
  }

  if (character !== C_BRACKET_OPEN) {
    return;
  }

  index++;
  intro += character;
  queue = '';

  /* Check whether we’re eating a footnote. */
  if (self.options.footnotes && value.charAt(index) === C_CARET) {
    /* Exit if `![^` is found, so the `!` will be seen as text after this,
     * and we’ll enter this function again when `[^` is found. */
    if (type === T_IMAGE) {
      return;
    }

    intro += C_CARET;
    index++;
    type = T_FOOTNOTE;
  }

  /* Eat the text. */
  depth = 0;

  while (index < length) {
    character = value.charAt(index);

    if (character === C_BRACKET_OPEN) {
      bracketed = true;
      depth++;
    } else if (character === C_BRACKET_CLOSE) {
      if (!depth) {
        break;
      }

      depth--;
    }

    if (character === C_BACKSLASH) {
      queue += C_BACKSLASH;
      character = value.charAt(++index);
    }

    queue += character;
    index++;
  }

  subvalue = queue;
  content = queue;
  character = value.charAt(index);

  if (character !== C_BRACKET_CLOSE) {
    return;
  }

  index++;
  subvalue += character;
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (!whitespace(character)) {
      break;
    }

    queue += character;
    index++;
  }

  character = value.charAt(index);

  /* Inline footnotes cannot have an identifier. */
  if (type !== T_FOOTNOTE && character === C_BRACKET_OPEN) {
    identifier = '';
    queue += character;
    index++;

    while (index < length) {
      character = value.charAt(index);

      if (character === C_BRACKET_OPEN || character === C_BRACKET_CLOSE) {
        break;
      }

      if (character === C_BACKSLASH) {
        identifier += C_BACKSLASH;
        character = value.charAt(++index);
      }

      identifier += character;
      index++;
    }

    character = value.charAt(index);

    if (character === C_BRACKET_CLOSE) {
      referenceType = identifier ? REFERENCE_TYPE_FULL : REFERENCE_TYPE_COLLAPSED;
      queue += identifier + character;
      index++;
    } else {
      identifier = '';
    }

    subvalue += queue;
    queue = '';
  } else {
    if (!content) {
      return;
    }

    identifier = content;
  }

  /* Brackets cannot be inside the identifier. */
  if (referenceType !== REFERENCE_TYPE_FULL && bracketed) {
    return;
  }

  subvalue = intro + subvalue;

  if (type === T_LINK && self.inLink) {
    return null;
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true;
  }

  if (type === T_FOOTNOTE && content.indexOf(' ') !== -1) {
    return eat(subvalue)({
      type: 'footnote',
      children: this.tokenizeInline(content, eat.now())
    });
  }

  now = eat.now();
  now.column += intro.length;
  now.offset += intro.length;
  identifier = referenceType === REFERENCE_TYPE_FULL ? identifier : content;

  node = {
    type: type + 'Reference',
    identifier: normalize(identifier)
  };

  if (type === T_LINK || type === T_IMAGE) {
    node.referenceType = referenceType;
  }

  if (type === T_LINK) {
    exit = self.enterLink();
    node.children = self.tokenizeInline(content, now);
    exit();
  } else if (type === T_IMAGE) {
    node.alt = self.decode.raw(self.unescape(content), now) || null;
  }

  return eat(subvalue)(node);
}


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var trim = __webpack_require__(22);
var whitespace = __webpack_require__(5);
var locate = __webpack_require__(289);

module.exports = strong;
strong.locator = locate;

var C_ASTERISK = '*';
var C_UNDERSCORE = '_';

function strong(eat, value, silent) {
  var self = this;
  var index = 0;
  var character = value.charAt(index);
  var now;
  var pedantic;
  var marker;
  var queue;
  var subvalue;
  var length;
  var prev;

  if (
    (character !== C_ASTERISK && character !== C_UNDERSCORE) ||
    value.charAt(++index) !== character
  ) {
    return;
  }

  pedantic = self.options.pedantic;
  marker = character;
  subvalue = marker + marker;
  length = value.length;
  index++;
  queue = '';
  character = '';

  if (pedantic && whitespace(value.charAt(index))) {
    return;
  }

  while (index < length) {
    prev = character;
    character = value.charAt(index);

    if (
      character === marker &&
      value.charAt(index + 1) === marker &&
      (!pedantic || !whitespace(prev))
    ) {
      character = value.charAt(index + 2);

      if (character !== marker) {
        if (!trim(queue)) {
          return;
        }

        /* istanbul ignore if - never used (yet) */
        if (silent) {
          return true;
        }

        now = eat.now();
        now.column += 2;
        now.offset += 2;

        return eat(subvalue + queue + subvalue)({
          type: 'strong',
          children: self.tokenizeInline(queue, now)
        });
      }
    }

    if (!pedantic && character === '\\') {
      queue += character;
      character = value.charAt(++index);
    }

    queue += character;
    index++;
  }
}


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = locate;

function locate(value, fromIndex) {
  var asterisk = value.indexOf('**', fromIndex);
  var underscore = value.indexOf('__', fromIndex);

  if (underscore === -1) {
    return asterisk;
  }

  if (asterisk === -1) {
    return underscore;
  }

  return underscore < asterisk ? underscore : asterisk;
}


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var trim = __webpack_require__(22);
var word = __webpack_require__(291);
var whitespace = __webpack_require__(5);
var locate = __webpack_require__(292);

module.exports = emphasis;
emphasis.locator = locate;

var C_ASTERISK = '*';
var C_UNDERSCORE = '_';

function emphasis(eat, value, silent) {
  var self = this;
  var index = 0;
  var character = value.charAt(index);
  var now;
  var pedantic;
  var marker;
  var queue;
  var subvalue;
  var length;
  var prev;

  if (character !== C_ASTERISK && character !== C_UNDERSCORE) {
    return;
  }

  pedantic = self.options.pedantic;
  subvalue = character;
  marker = character;
  length = value.length;
  index++;
  queue = '';
  character = '';

  if (pedantic && whitespace(value.charAt(index))) {
    return;
  }

  while (index < length) {
    prev = character;
    character = value.charAt(index);

    if (character === marker && (!pedantic || !whitespace(prev))) {
      character = value.charAt(++index);

      if (character !== marker) {
        if (!trim(queue) || prev === marker) {
          return;
        }

        if (!pedantic && marker === C_UNDERSCORE && word(character)) {
          queue += marker;
          continue;
        }

        /* istanbul ignore if - never used (yet) */
        if (silent) {
          return true;
        }

        now = eat.now();
        now.column++;
        now.offset++;

        return eat(subvalue + queue + marker)({
          type: 'emphasis',
          children: self.tokenizeInline(queue, now)
        });
      }

      queue += marker;
    }

    if (!pedantic && character === '\\') {
      queue += character;
      character = value.charAt(++index);
    }

    queue += character;
    index++;
  }
}


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = wordCharacter

var fromCode = String.fromCharCode
var re = /\w/

// Check if the given character code, or the character code at the first
// character, is a word character.
function wordCharacter(character) {
  return re.test(
    typeof character === 'number' ? fromCode(character) : character.charAt(0)
  )
}


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = locate;

function locate(value, fromIndex) {
  var asterisk = value.indexOf('*', fromIndex);
  var underscore = value.indexOf('_', fromIndex);

  if (underscore === -1) {
    return asterisk;
  }

  if (asterisk === -1) {
    return underscore;
  }

  return underscore < asterisk ? underscore : asterisk;
}


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var whitespace = __webpack_require__(5);
var locate = __webpack_require__(294);

module.exports = strikethrough;
strikethrough.locator = locate;

var C_TILDE = '~';
var DOUBLE = '~~';

function strikethrough(eat, value, silent) {
  var self = this;
  var character = '';
  var previous = '';
  var preceding = '';
  var subvalue = '';
  var index;
  var length;
  var now;

  if (
    !self.options.gfm ||
    value.charAt(0) !== C_TILDE ||
    value.charAt(1) !== C_TILDE ||
    whitespace(value.charAt(2))
  ) {
    return;
  }

  index = 1;
  length = value.length;
  now = eat.now();
  now.column += 2;
  now.offset += 2;

  while (++index < length) {
    character = value.charAt(index);

    if (
      character === C_TILDE &&
      previous === C_TILDE &&
      (!preceding || !whitespace(preceding))
    ) {
      /* istanbul ignore if - never used (yet) */
      if (silent) {
        return true;
      }

      return eat(DOUBLE + subvalue + DOUBLE)({
        type: 'delete',
        children: self.tokenizeInline(subvalue, now)
      });
    }

    subvalue += previous;
    preceding = previous;
    previous = character;
  }
}


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('~~', fromIndex);
}


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var whitespace = __webpack_require__(5);
var locate = __webpack_require__(296);

module.exports = inlineCode;
inlineCode.locator = locate;

var C_TICK = '`';

/* Tokenise inline code. */
function inlineCode(eat, value, silent) {
  var length = value.length;
  var index = 0;
  var queue = '';
  var tickQueue = '';
  var contentQueue;
  var subqueue;
  var count;
  var openingCount;
  var subvalue;
  var character;
  var found;
  var next;

  while (index < length) {
    if (value.charAt(index) !== C_TICK) {
      break;
    }

    queue += C_TICK;
    index++;
  }

  if (!queue) {
    return;
  }

  subvalue = queue;
  openingCount = index;
  queue = '';
  next = value.charAt(index);
  count = 0;

  while (index < length) {
    character = next;
    next = value.charAt(index + 1);

    if (character === C_TICK) {
      count++;
      tickQueue += character;
    } else {
      count = 0;
      queue += character;
    }

    if (count && next !== C_TICK) {
      if (count === openingCount) {
        subvalue += queue + tickQueue;
        found = true;
        break;
      }

      queue += tickQueue;
      tickQueue = '';
    }

    index++;
  }

  if (!found) {
    if (openingCount % 2 !== 0) {
      return;
    }

    queue = '';
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true;
  }

  contentQueue = '';
  subqueue = '';
  length = queue.length;
  index = -1;

  while (++index < length) {
    character = queue.charAt(index);

    if (whitespace(character)) {
      subqueue += character;
      continue;
    }

    if (subqueue) {
      if (contentQueue) {
        contentQueue += subqueue;
      }

      subqueue = '';
    }

    contentQueue += character;
  }

  return eat(subvalue)({
    type: 'inlineCode',
    value: contentQueue
  });
}


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('`', fromIndex);
}


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var locate = __webpack_require__(298);

module.exports = hardBreak;
hardBreak.locator = locate;

var MIN_BREAK_LENGTH = 2;

function hardBreak(eat, value, silent) {
  var length = value.length;
  var index = -1;
  var queue = '';
  var character;

  while (++index < length) {
    character = value.charAt(index);

    if (character === '\n') {
      if (index < MIN_BREAK_LENGTH) {
        return;
      }

      /* istanbul ignore if - never used (yet) */
      if (silent) {
        return true;
      }

      queue += character;

      return eat(queue)({type: 'break'});
    }

    if (character !== ' ') {
      return;
    }

    queue += character;
  }
}


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = locate;

function locate(value, fromIndex) {
  var index = value.indexOf('\n', fromIndex);

  while (index > fromIndex) {
    if (value.charAt(index - 1) !== ' ') {
      break;
    }

    index--;
  }

  return index;
}


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = text;

function text(eat, value, silent) {
  var self = this;
  var methods;
  var tokenizers;
  var index;
  var length;
  var subvalue;
  var position;
  var tokenizer;
  var name;
  var min;
  var now;

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true;
  }

  methods = self.inlineMethods;
  length = methods.length;
  tokenizers = self.inlineTokenizers;
  index = -1;
  min = value.length;

  while (++index < length) {
    name = methods[index];

    if (name === 'text' || !tokenizers[name]) {
      continue;
    }

    tokenizer = tokenizers[name].locator;

    if (!tokenizer) {
      eat.file.fail('Missing locator: `' + name + '`');
    }

    position = tokenizer.call(self, value, 1);

    if (position !== -1 && position < min) {
      min = position;
    }
  }

  subvalue = value.slice(0, min);
  now = eat.now();

  self.decode(subvalue, now, function (content, position, source) {
    eat(source || content)({
      type: 'text',
      value: content
    });
  });
}


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var visitWithParents = __webpack_require__(301);

function addListMetadata() {
  return function (ast) {
    visitWithParents(ast, 'list', function (listNode, parents) {
      var depth = 0, i, n;
      for (i = 0, n = parents.length; i < n; i++) {
        if (parents[i].type === 'list') depth += 1;
      }
      for (i = 0, n = listNode.children.length; i < n; i++) {
        var child = listNode.children[i];
        child.index = i;
        child.ordered = listNode.ordered;
      }
      listNode.depth = depth;
    });
    return ast;
  };
}

module.exports = addListMetadata;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* Expose. */
module.exports = visitParents

/* Visit. */
function visitParents(tree, type, visitor) {
  var stack = []

  if (typeof type === 'function') {
    visitor = type
    type = null
  }

  one(tree)

  /* Visit a single node. */
  function one(node) {
    var result

    if (!type || node.type === type) {
      result = visitor(node, stack.concat())
    }

    if (node.children && result !== false) {
      return all(node.children, node)
    }

    return result
  }

  /* Visit children in `parent`. */
  function all(children, parent) {
    var length = children.length
    var index = -1
    var child

    stack.push(parent)

    while (++index < length) {
      child = children[index]

      if (child && one(child) === false) {
        return false
      }
    }

    stack.pop()

    return true
  }
}


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Naive, simple plugin to match inline nodes without attributes
 * This allows say <strong>foo</strong>, but not <strong class="very">foo</strong>
 * For proper HTML support, you'll want a different plugin
 **/
var visit = __webpack_require__(40);

var type = 'virtualHtml';
var selfClosingRe = /^<(area|base|br|col|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)\s*\/?>$/i;
var simpleTagRe = /^<(\/?)([a-z]+)\s*>$/;

module.exports = function (tree) {
  var open = void 0;
  var currentParent = void 0;
  visit(tree, 'html', function (node, index, parent) {
    if (currentParent !== parent) {
      open = [];
      currentParent = parent;
    }

    var selfClosing = getSelfClosing(node);
    if (selfClosing) {
      parent.children.splice(index, 1, {
        type: type,
        tag: selfClosing,
        position: node.position
      });
      return true;
    }

    var current = getSimpleTag(node, parent);
    if (!current) {
      return true;
    }

    var matching = findAndPull(open, current.tag);

    if (matching) {
      parent.children.splice(index, 0, virtual(current, matching, parent));
    } else if (!current.opening) {
      open.push(current);
    }

    return true;
  }, true // Iterate in reverse
  );

  return tree;
};

function findAndPull(open, matchingTag) {
  var i = open.length;
  while (i--) {
    if (open[i].tag === matchingTag) {
      return open.splice(i, 1)[0];
    }
  }

  return false;
}

function getSimpleTag(node, parent) {
  var match = node.value.match(simpleTagRe);
  return match ? { tag: match[2], opening: !match[1], node: node } : false;
}

function getSelfClosing(node) {
  var match = node.value.match(selfClosingRe);
  return match ? match[1] : false;
}

function virtual(fromNode, toNode, parent) {
  var fromIndex = parent.children.indexOf(fromNode.node);
  var toIndex = parent.children.indexOf(toNode.node);

  var extracted = parent.children.splice(fromIndex, toIndex - fromIndex + 1);
  var children = extracted.slice(1, -1);
  return {
    type: type,
    children: children,
    tag: fromNode.tag,
    position: {
      start: fromNode.node.position.start,
      end: toNode.node.position.end,
      indent: []
    }
  };
}

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var visit = __webpack_require__(40);

exports.ofType = function (types, mode) {
  return function (node) {
    types.forEach(function (type) {
      return visit(node, type, disallow, true);
    });
    return node;
  };

  function disallow(node, index, parent) {
    if (parent) {
      untangle(node, index, parent, mode);
    }
  }
};

exports.ifNotMatch = function (allowNode, mode) {
  return function (node) {
    visit(node, disallow, true);
    return node;
  };

  function disallow(node, index, parent) {
    if (parent && !allowNode(node, index, parent)) {
      untangle(node, index, parent, mode);
    }
  }
};

function untangle(node, index, parent, mode) {
  if (mode === 'remove') {
    parent.children.splice(index, 1);
  } else if (mode === 'unwrap') {
    var args = [index, 1];

    if (node.children) {
      args = args.concat(node.children);
    }

    Array.prototype.splice.apply(parent.children, args);
  }
}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var xtend = __webpack_require__(12);

function astToReact(node, options) {
  var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var renderer = options.renderers[node.type];

  var pos = node.position.start;
  var key = [node.type, pos.line, pos.column].join('-');

  if (node.type === 'text') {
    return renderer ? renderer(node.value, key) : node.value;
  }

  if (typeof renderer !== 'function' && typeof renderer !== 'string' && !isReactFragment(renderer)) {
    throw new Error('Renderer for type `' + node.type + '` not defined or is not renderable');
  }

  var nodeProps = getNodeProps(node, key, options, renderer, parent, index);

  return React.createElement(renderer, nodeProps, nodeProps.children || resolveChildren() || undefined);

  function resolveChildren() {
    return node.children && node.children.map(function (childNode, i) {
      return astToReact(childNode, options, { node: node, props: nodeProps }, i);
    });
  }
}

function isReactFragment(renderer) {
  return React.Fragment && React.Fragment === renderer;
}

// eslint-disable-next-line max-params, complexity
function getNodeProps(node, key, opts, renderer, parent, index) {
  var props = { key: key };

  var isTagRenderer = typeof renderer === 'string';

  // `sourcePos` is true if the user wants source information (line/column info from markdown source)
  if (opts.sourcePos && node.position) {
    props['data-sourcepos'] = flattenPosition(node.position);
  }

  if (opts.rawSourcePos && !isTagRenderer) {
    props.sourcePosition = node.position;
  }

  // If `includeNodeIndex` is true, pass node index info to all non-tag renderers
  if (opts.includeNodeIndex && parent.node && parent.node.children && !isTagRenderer) {
    props.index = parent.node.children.indexOf(node);
    props.parentChildCount = parent.node.children.length;
  }

  var ref = node.identifier !== null && node.identifier !== undefined ? opts.definitions[node.identifier] || {} : null;

  switch (node.type) {
    case 'root':
      assignDefined(props, { className: opts.className });
      break;
    case 'heading':
      props.level = node.depth;
      break;
    case 'list':
      props.start = node.start;
      props.ordered = node.ordered;
      props.tight = !node.loose;
      props.depth = node.depth;
      break;
    case 'listItem':
      props.checked = node.checked;
      props.tight = !node.loose;
      props.ordered = node.ordered;
      props.index = node.index;
      props.children = (props.tight ? unwrapParagraphs(node) : node.children).map(function (childNode, i) {
        return astToReact(childNode, opts, { node: node, props: props }, i);
      });
      break;
    case 'definition':
      assignDefined(props, { identifier: node.identifier, title: node.title, url: node.url });
      break;
    case 'code':
      assignDefined(props, { language: node.lang && node.lang.split(/\s/, 1)[0] });
      break;
    case 'inlineCode':
      props.children = node.value;
      props.inline = true;
      break;
    case 'link':
      assignDefined(props, {
        title: node.title || undefined,
        target: typeof opts.linkTarget === 'function' ? opts.linkTarget(node.url, node.children, node.title) : opts.linkTarget,
        href: opts.transformLinkUri ? opts.transformLinkUri(node.url, node.children, node.title) : node.url
      });
      break;
    case 'image':
      assignDefined(props, {
        alt: node.alt || undefined,
        title: node.title || undefined,
        src: opts.transformImageUri ? opts.transformImageUri(node.url, node.children, node.title, node.alt) : node.url
      });
      break;
    case 'linkReference':
      assignDefined(props, xtend(ref, {
        href: opts.transformLinkUri ? opts.transformLinkUri(ref.href) : ref.href
      }));
      break;
    case 'imageReference':
      assignDefined(props, {
        src: opts.transformImageUri && ref.href ? opts.transformImageUri(ref.href, node.children, ref.title, node.alt) : ref.href,
        title: ref.title || undefined,
        alt: node.alt || undefined
      });
      break;
    case 'table':
    case 'tableHead':
    case 'tableBody':
      props.columnAlignment = node.align;
      break;
    case 'tableRow':
      props.isHeader = parent.node.type === 'tableHead';
      props.columnAlignment = parent.props.columnAlignment;
      break;
    case 'tableCell':
      assignDefined(props, {
        isHeader: parent.props.isHeader,
        align: parent.props.columnAlignment[index]
      });
      break;
    case 'virtualHtml':
      props.tag = node.tag;
      break;
    case 'html':
      // @todo find a better way than this
      props.isBlock = node.position.start.line !== node.position.end.line;
      props.escapeHtml = opts.escapeHtml;
      props.skipHtml = opts.skipHtml;
      break;
    default:
      assignDefined(props, xtend(node, {
        type: undefined,
        position: undefined,
        children: undefined
      }));
  }

  if (!isTagRenderer && node.value) {
    props.value = node.value;
  }

  return props;
}

function assignDefined(target, attrs) {
  for (var key in attrs) {
    if (typeof attrs[key] !== 'undefined') {
      target[key] = attrs[key];
    }
  }
}

function flattenPosition(pos) {
  return [pos.start.line, ':', pos.start.column, '-', pos.end.line, ':', pos.end.column].map(String).join('');
}

function unwrapParagraphs(node) {
  return node.children.reduce(function (array, child) {
    return array.concat(child.type === 'paragraph' ? child.children || [] : [child]);
  }, []);
}

module.exports = astToReact;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var visit = __webpack_require__(40);

module.exports = function (node) {
  visit(node, 'table', wrap);
  return node;
};

function wrap(table) {
  var children = table.children;
  table.children = [{
    type: 'tableHead',
    align: table.align,
    children: [children[0]],
    position: children[0].position
  }];
  if (children.length > 1) {
    table.children.push({
      type: 'tableBody',
      align: table.align,
      children: children.slice(1),
      position: {
        start: children[1].position.start,
        end: children[children.length - 1].position.end
      }
    });
  }
}

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function getDefinitions(node) {
  var defs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return (node.children || []).reduce(function (definitions, child) {
    if (child.type === 'definition') {
      definitions[child.identifier] = {
        href: child.url,
        title: child.title
      };
    }

    return getDefinitions(child, definitions);
  }, defs);
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var protocols = ['http', 'https', 'mailto', 'tel'];

module.exports = function uriTransformer(uri) {
  var url = (uri || '').trim();
  var first = url.charAt(0);

  if (first === '#' || first === '/') {
    return url;
  }

  var colon = url.indexOf(':');
  if (colon === -1) {
    return url;
  }

  var length = protocols.length;
  var index = -1;

  while (++index < length) {
    var protocol = protocols[index];

    if (colon === protocol.length && url.slice(0, protocol.length) === protocol) {
      return url;
    }
  }

  index = url.indexOf('?');
  if (index !== -1 && colon > index) {
    return url;
  }

  index = url.indexOf('#');
  if (index !== -1 && colon > index) {
    return url;
  }

  // eslint-disable-next-line no-script-url
  return 'javascript:void(0)';
};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable react/prop-types, react/no-multi-comp */


var xtend = __webpack_require__(12);
var React = __webpack_require__(1);
var createElement = React.createElement;

module.exports = {
  root: 'div',
  break: 'br',
  paragraph: 'p',
  emphasis: 'em',
  strong: 'strong',
  thematicBreak: 'hr',
  blockquote: 'blockquote',
  delete: 'del',
  link: 'a',
  image: 'img',
  linkReference: 'a',
  imageReference: 'img',
  table: SimpleRenderer.bind(null, 'table'),
  tableHead: SimpleRenderer.bind(null, 'thead'),
  tableBody: SimpleRenderer.bind(null, 'tbody'),
  tableRow: SimpleRenderer.bind(null, 'tr'),
  tableCell: TableCell,

  list: List,
  listItem: ListItem,
  definition: NullRenderer,
  heading: Heading,
  inlineCode: InlineCode,
  code: CodeBlock,
  html: Html,
  virtualHtml: VirtualHtml
};

function SimpleRenderer(tag, props) {
  return createElement(tag, getCoreProps(props), props.children);
}

function TableCell(props) {
  var style = props.align ? { textAlign: props.align } : undefined;
  var coreProps = getCoreProps(props);
  return createElement(props.isHeader ? 'th' : 'td', style ? xtend({ style: style }, coreProps) : coreProps, props.children);
}

function Heading(props) {
  return createElement('h' + props.level, getCoreProps(props), props.children);
}

function List(props) {
  var attrs = getCoreProps(props);
  if (props.start !== null && props.start !== 1) {
    attrs.start = props.start.toString();
  }

  return createElement(props.ordered ? 'ol' : 'ul', attrs, props.children);
}

function ListItem(props) {
  var checkbox = null;
  if (props.checked !== null) {
    var checked = props.checked;
    checkbox = createElement('input', { type: 'checkbox', checked: checked, readOnly: true });
  }

  return createElement('li', getCoreProps(props), checkbox, props.children);
}

function CodeBlock(props) {
  var className = props.language && 'language-' + props.language;
  var code = createElement('code', className ? { className: className } : null, props.value);
  return createElement('pre', getCoreProps(props), code);
}

function InlineCode(props) {
  return createElement('code', getCoreProps(props), props.children);
}

function Html(props) {
  if (props.skipHtml) {
    return null;
  }

  var tag = props.isBlock ? 'div' : 'span';
  if (props.escapeHtml) {
    // @todo when fiber lands, we can simply render props.value
    return createElement(tag, null, props.value);
  }

  var nodeProps = { dangerouslySetInnerHTML: { __html: props.value } };
  return createElement(tag, nodeProps);
}

function VirtualHtml(props) {
  return createElement(props.tag, getCoreProps(props), props.children);
}

function NullRenderer() {
  return null;
}

function getCoreProps(props) {
  return props['data-sourcepos'] ? { 'data-sourcepos': props['data-sourcepos'] } : {};
}

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export name */
/* unused harmony export version */
/* unused harmony export description */
/* unused harmony export keywords */
/* unused harmony export homepage */
/* unused harmony export license */
/* unused harmony export author */
/* unused harmony export main */
/* unused harmony export unpkg */
/* unused harmony export jsdelivr */
/* unused harmony export module */
/* unused harmony export repository */
/* unused harmony export scripts */
/* unused harmony export devDependencies */
/* unused harmony export dependencies */
var name = "d3";
var version = "4.13.0";
var description = "Data-Driven Documents";
var keywords = ["dom","visualization","svg","animation","canvas"];
var homepage = "https://d3js.org";
var license = "BSD-3-Clause";
var author = {"name":"Mike Bostock","url":"https://bost.ocks.org/mike"};
var main = "build/d3.node.js";
var unpkg = "build/d3.min.js";
var jsdelivr = "build/d3.min.js";
var module = "index";
var repository = {"type":"git","url":"https://github.com/d3/d3.git"};
var scripts = {"pretest":"rimraf build && mkdir build && json2module package.json > build/package.js && node rollup.node","test":"tape 'test/**/*-test.js'","prepublishOnly":"npm run test && rollup -c --banner \"$(preamble)\" && uglifyjs -b beautify=false,preamble=\"'$(preamble)'\" build/d3.js -c negate_iife=false -m -o build/d3.min.js","postpublish":"git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/build/d3.js d3.v4.js && cp ../d3/build/d3.min.js d3.v4.min.js && git add d3.v4.js d3.v4.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && cd ../d3-bower && git pull && cp ../d3/LICENSE ../d3/README.md ../d3/build/d3.js ../d3/build/d3.min.js . && git add -- LICENSE README.md d3.js d3.min.js && git commit -m \"${npm_package_version}\" && git tag -am \"${npm_package_version}\" v${npm_package_version} && git push && git push --tags && cd - && zip -j build/d3.zip -- LICENSE README.md API.md CHANGES.md build/d3.js build/d3.min.js"};
var devDependencies = {"json2module":"0.0","package-preamble":"0.1","rimraf":"2","rollup":"0.53","rollup-plugin-ascii":"0.0","rollup-plugin-node-resolve":"3","tape":"4","uglify-js":"3.2"};
var dependencies = {"d3-array":"1.2.1","d3-axis":"1.0.8","d3-brush":"1.0.4","d3-chord":"1.0.4","d3-collection":"1.0.4","d3-color":"1.0.3","d3-dispatch":"1.0.3","d3-drag":"1.2.1","d3-dsv":"1.0.8","d3-ease":"1.0.3","d3-force":"1.1.0","d3-format":"1.2.2","d3-geo":"1.9.1","d3-hierarchy":"1.1.5","d3-interpolate":"1.1.6","d3-path":"1.0.5","d3-polygon":"1.0.3","d3-quadtree":"1.0.3","d3-queue":"3.0.7","d3-random":"1.1.0","d3-request":"1.0.6","d3-scale":"1.0.7","d3-selection":"1.3.0","d3-shape":"1.2.0","d3-time":"1.0.8","d3-time-format":"2.1.1","d3-timer":"1.0.7","d3-transition":"1.1.1","d3-voronoi":"1.1.2","d3-zoom":"1.7.1"};


/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(119);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["a" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(126);









/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = Object(__WEBPACK_IMPORTED_MODULE_6__ticks__["c" /* tickStep */])(x0, x1, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[Object(__WEBPACK_IMPORTED_MODULE_1__bisect__["a" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(65);





/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(120);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * Object(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(27);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(65);




/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(23);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(128);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_axis__ = __webpack_require__(327);
/* unused harmony reexport axisTop */
/* unused harmony reexport axisRight */
/* unused harmony reexport axisBottom */
/* unused harmony reexport axisLeft */



/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export axisTop */
/* unused harmony export axisRight */
/* unused harmony export axisBottom */
/* unused harmony export axisLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(329);



var top = 1,
    right = 2,
    bottom = 3,
    left = 4,
    epsilon = 1e-6;

function translateX(x) {
  return "translate(" + (x + 0.5) + ",0)";
}

function translateY(y) {
  return "translate(0," + (y + 0.5) + ")";
}

function number(scale) {
  return function(d) {
    return +scale(d);
  };
}

function center(scale) {
  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
  if (scale.round()) offset = Math.round(offset);
  return function(d) {
    return +scale(d) + offset;
  };
}

function entering() {
  return !this.__axis;
}

function axis(orient, scale) {
  var tickArguments = [],
      tickValues = null,
      tickFormat = null,
      tickSizeInner = 6,
      tickSizeOuter = 6,
      tickPadding = 3,
      k = orient === top || orient === left ? -1 : 1,
      x = orient === left || orient === right ? "x" : "y",
      transform = orient === top || orient === bottom ? translateX : translateY;

  function axis(context) {
    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */]) : tickFormat,
        spacing = Math.max(tickSizeInner, 0) + tickPadding,
        range = scale.range(),
        range0 = +range[0] + 0.5,
        range1 = +range[range.length - 1] + 0.5,
        position = (scale.bandwidth ? center : number)(scale.copy()),
        selection = context.selection ? context.selection() : context,
        path = selection.selectAll(".domain").data([null]),
        tick = selection.selectAll(".tick").data(values, scale).order(),
        tickExit = tick.exit(),
        tickEnter = tick.enter().append("g").attr("class", "tick"),
        line = tick.select("line"),
        text = tick.select("text");

    path = path.merge(path.enter().insert("path", ".tick")
        .attr("class", "domain")
        .attr("stroke", "#000"));

    tick = tick.merge(tickEnter);

    line = line.merge(tickEnter.append("line")
        .attr("stroke", "#000")
        .attr(x + "2", k * tickSizeInner));

    text = text.merge(tickEnter.append("text")
        .attr("fill", "#000")
        .attr(x, k * spacing)
        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));

    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text = text.transition(context);

      tickExit = tickExit.transition(context)
          .attr("opacity", epsilon)
          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform"); });

      tickEnter
          .attr("opacity", epsilon)
          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform(p && isFinite(p = p(d)) ? p : position(d)); });
    }

    tickExit.remove();

    path
        .attr("d", orient === left || orient == right
            ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
            : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);

    tick
        .attr("opacity", 1)
        .attr("transform", function(d) { return transform(position(d)); });

    line
        .attr(x + "2", k * tickSizeInner);

    text
        .attr(x, k * spacing)
        .text(format);

    selection.filter(entering)
        .attr("fill", "none")
        .attr("font-size", 10)
        .attr("font-family", "sans-serif")
        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");

    selection
        .each(function() { this.__axis = position; });
  }

  axis.scale = function(_) {
    return arguments.length ? (scale = _, axis) : scale;
  };

  axis.ticks = function() {
    return tickArguments = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(arguments), axis;
  };

  axis.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_), axis) : tickArguments.slice();
  };

  axis.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_), axis) : tickValues && tickValues.slice();
  };

  axis.tickFormat = function(_) {
    return arguments.length ? (tickFormat = _, axis) : tickFormat;
  };

  axis.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
  };

  axis.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
  };

  axis.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
  };

  axis.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
  };

  return axis;
}

function axisTop(scale) {
  return axis(top, scale);
}

function axisRight(scale) {
  return axis(right, scale);
}

function axisBottom(scale) {
  return axis(bottom, scale);
}

function axisLeft(scale) {
  return axis(left, scale);
}


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_brush__ = __webpack_require__(331);
/* unused harmony reexport brush */
/* unused harmony reexport brushX */
/* unused harmony reexport brushY */
/* unused harmony reexport brushSelection */



/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export brushSelection */
/* unused harmony export brushX */
/* unused harmony export brushY */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_drag__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_selection__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_transition__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constant__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__noevent__ = __webpack_require__(416);









var MODE_DRAG = {name: "drag"},
    MODE_SPACE = {name: "space"},
    MODE_HANDLE = {name: "handle"},
    MODE_CENTER = {name: "center"};

var X = {
  name: "x",
  handles: ["e", "w"].map(type),
  input: function(x, e) { return x && [[x[0], e[0][1]], [x[1], e[1][1]]]; },
  output: function(xy) { return xy && [xy[0][0], xy[1][0]]; }
};

var Y = {
  name: "y",
  handles: ["n", "s"].map(type),
  input: function(y, e) { return y && [[e[0][0], y[0]], [e[1][0], y[1]]]; },
  output: function(xy) { return xy && [xy[0][1], xy[1][1]]; }
};

var XY = {
  name: "xy",
  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(type),
  input: function(xy) { return xy; },
  output: function(xy) { return xy; }
};

var cursors = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
};

var flipX = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
};

var flipY = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
};

var signsX = {
  overlay: +1,
  selection: +1,
  n: null,
  e: +1,
  s: null,
  w: -1,
  nw: -1,
  ne: +1,
  se: +1,
  sw: -1
};

var signsY = {
  overlay: +1,
  selection: +1,
  n: -1,
  e: null,
  s: +1,
  w: null,
  nw: -1,
  ne: -1,
  se: +1,
  sw: +1
};

function type(t) {
  return {type: t};
}

// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].button;
}

function defaultExtent() {
  var svg = this.ownerSVGElement || this;
  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
}

// Like d3.local, but with the name “__brush” rather than auto-generated.
function local(node) {
  while (!node.__brush) if (!(node = node.parentNode)) return;
  return node.__brush;
}

function empty(extent) {
  return extent[0][0] === extent[1][0]
      || extent[0][1] === extent[1][1];
}

function brushSelection(node) {
  var state = node.__brush;
  return state ? state.dim.output(state.selection) : null;
}

function brushX() {
  return brush(X);
}

function brushY() {
  return brush(Y);
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return brush(XY);
});

function brush(dim) {
  var extent = defaultExtent,
      filter = defaultFilter,
      listeners = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])(brush, "start", "brush", "end"),
      handleSize = 6,
      touchending;

  function brush(group) {
    var overlay = group
        .property("__brush", initialize)
      .selectAll(".overlay")
      .data([type("overlay")]);

    overlay.enter().append("rect")
        .attr("class", "overlay")
        .attr("pointer-events", "all")
        .attr("cursor", cursors.overlay)
      .merge(overlay)
        .each(function() {
          var extent = local(this).extent;
          Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["f" /* select */])(this)
              .attr("x", extent[0][0])
              .attr("y", extent[0][1])
              .attr("width", extent[1][0] - extent[0][0])
              .attr("height", extent[1][1] - extent[0][1]);
        });

    group.selectAll(".selection")
      .data([type("selection")])
      .enter().append("rect")
        .attr("class", "selection")
        .attr("cursor", cursors.selection)
        .attr("fill", "#777")
        .attr("fill-opacity", 0.3)
        .attr("stroke", "#fff")
        .attr("shape-rendering", "crispEdges");

    var handle = group.selectAll(".handle")
      .data(dim.handles, function(d) { return d.type; });

    handle.exit().remove();

    handle.enter().append("rect")
        .attr("class", function(d) { return "handle handle--" + d.type; })
        .attr("cursor", function(d) { return cursors[d.type]; });

    group
        .each(redraw)
        .attr("fill", "none")
        .attr("pointer-events", "all")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
        .on("mousedown.brush touchstart.brush", started);
  }

  brush.move = function(group, selection) {
    if (group.selection) {
      group
          .on("start.brush", function() { emitter(this, arguments).beforestart().start(); })
          .on("interrupt.brush end.brush", function() { emitter(this, arguments).end(); })
          .tween("brush", function() {
            var that = this,
                state = that.__brush,
                emit = emitter(that, arguments),
                selection0 = state.selection,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent),
                i = Object(__WEBPACK_IMPORTED_MODULE_2_d3_interpolate__["a" /* interpolate */])(selection0, selection1);

            function tween(t) {
              state.selection = t === 1 && empty(selection1) ? null : i(t);
              redraw.call(that);
              emit.brush();
            }

            return selection0 && selection1 ? tween : tween(1);
          });
    } else {
      group
          .each(function() {
            var that = this,
                args = arguments,
                state = that.__brush,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent),
                emit = emitter(that, args).beforestart();

            Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["a" /* interrupt */])(that);
            state.selection = selection1 == null || empty(selection1) ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
          });
    }
  };

  function redraw() {
    var group = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["f" /* select */])(this),
        selection = local(this).selection;

    if (selection) {
      group.selectAll(".selection")
          .style("display", null)
          .attr("x", selection[0][0])
          .attr("y", selection[0][1])
          .attr("width", selection[1][0] - selection[0][0])
          .attr("height", selection[1][1] - selection[0][1]);

      group.selectAll(".handle")
          .style("display", null)
          .attr("x", function(d) { return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2; })
          .attr("y", function(d) { return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2; })
          .attr("width", function(d) { return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize; })
          .attr("height", function(d) { return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize; });
    }

    else {
      group.selectAll(".selection,.handle")
          .style("display", "none")
          .attr("x", null)
          .attr("y", null)
          .attr("width", null)
          .attr("height", null);
    }
  }

  function emitter(that, args) {
    return that.__brush.emitter || new Emitter(that, args);
  }

  function Emitter(that, args) {
    this.that = that;
    this.args = args;
    this.state = that.__brush;
    this.active = 0;
  }

  Emitter.prototype = {
    beforestart: function() {
      if (++this.active === 1) this.state.emitter = this, this.starting = true;
      return this;
    },
    start: function() {
      if (this.starting) this.starting = false, this.emit("start");
      return this;
    },
    brush: function() {
      this.emit("brush");
      return this;
    },
    end: function() {
      if (--this.active === 0) delete this.state.emitter, this.emit("end");
      return this;
    },
    emit: function(type) {
      Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_6__event__["a" /* default */](brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function started() {
    if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].touches) { if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].changedTouches.length < __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].touches.length) return Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])(); }
    else if (touchending) return;
    if (!filter.apply(this, arguments)) return;

    var that = this,
        type = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].target.__data__.type,
        mode = (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].altKey ? MODE_CENTER : MODE_HANDLE),
        signX = dim === Y ? null : signsX[type],
        signY = dim === X ? null : signsY[type],
        state = local(that),
        extent = state.extent,
        selection = state.selection,
        W = extent[0][0], w0, w1,
        N = extent[0][1], n0, n1,
        E = extent[1][0], e0, e1,
        S = extent[1][1], s0, s1,
        dx,
        dy,
        moving,
        shifting = signX && signY && __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].shiftKey,
        lockX,
        lockY,
        point0 = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(that),
        point = point0,
        emit = emitter(that, arguments).beforestart();

    if (type === "overlay") {
      state.selection = selection = [
        [w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]],
        [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]
      ];
    } else {
      w0 = selection[0][0];
      n0 = selection[0][1];
      e0 = selection[1][0];
      s0 = selection[1][1];
    }

    w1 = w0;
    n1 = n0;
    e1 = e0;
    s1 = s0;

    var group = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["f" /* select */])(that)
        .attr("pointer-events", "none");

    var overlay = group.selectAll(".overlay")
        .attr("cursor", cursors[type]);

    if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].touches) {
      group
          .on("touchmove.brush", moved, true)
          .on("touchend.brush touchcancel.brush", ended, true);
    } else {
      var view = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view)
          .on("keydown.brush", keydowned, true)
          .on("keyup.brush", keyupped, true)
          .on("mousemove.brush", moved, true)
          .on("mouseup.brush", ended, true);

      Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["a" /* dragDisable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view);
    }

    Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["b" /* nopropagation */])();
    Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["a" /* interrupt */])(that);
    redraw.call(that);
    emit.start();

    function moved() {
      var point1 = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(that);
      if (shifting && !lockX && !lockY) {
        if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
        else lockX = true;
      }
      point = point1;
      moving = true;
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
      move();
    }

    function move() {
      var t;

      dx = point[0] - point0[0];
      dy = point[1] - point0[1];

      switch (mode) {
        case MODE_SPACE:
        case MODE_DRAG: {
          if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
          if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
          break;
        }
        case MODE_HANDLE: {
          if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
          else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
          if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
          else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
          break;
        }
        case MODE_CENTER: {
          if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
          if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
          break;
        }
      }

      if (e1 < w1) {
        signX *= -1;
        t = w0, w0 = e0, e0 = t;
        t = w1, w1 = e1, e1 = t;
        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
      }

      if (s1 < n1) {
        signY *= -1;
        t = n0, n0 = s0, s0 = t;
        t = n1, n1 = s1, s1 = t;
        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
      }

      if (state.selection) selection = state.selection; // May be set by brush.move!
      if (lockX) w1 = selection[0][0], e1 = selection[1][0];
      if (lockY) n1 = selection[0][1], s1 = selection[1][1];

      if (selection[0][0] !== w1
          || selection[0][1] !== n1
          || selection[1][0] !== e1
          || selection[1][1] !== s1) {
        state.selection = [[w1, n1], [e1, s1]];
        redraw.call(that);
        emit.brush();
      }
    }

    function ended() {
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["b" /* nopropagation */])();
      if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].touches) {
        if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].touches.length) return;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
        group.on("touchmove.brush touchend.brush touchcancel.brush", null);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["b" /* dragEnable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view, moving);
        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      }
      group.attr("pointer-events", "all");
      overlay.attr("cursor", cursors.overlay);
      if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
      if (empty(selection)) state.selection = null, redraw.call(that);
      emit.end();
    }

    function keydowned() {
      switch (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].keyCode) {
        case 16: { // SHIFT
          shifting = signX && signY;
          break;
        }
        case 18: { // ALT
          if (mode === MODE_HANDLE) {
            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
            mode = MODE_CENTER;
            move();
          }
          break;
        }
        case 32: { // SPACE; takes priority over ALT
          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
            if (signX < 0) e0 = e1 - dx; else if (signX > 0) w0 = w1 - dx;
            if (signY < 0) s0 = s1 - dy; else if (signY > 0) n0 = n1 - dy;
            mode = MODE_SPACE;
            overlay.attr("cursor", cursors.selection);
            move();
          }
          break;
        }
        default: return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
    }

    function keyupped() {
      switch (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].keyCode) {
        case 16: { // SHIFT
          if (shifting) {
            lockX = lockY = shifting = false;
            move();
          }
          break;
        }
        case 18: { // ALT
          if (mode === MODE_CENTER) {
            if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
            if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
            mode = MODE_HANDLE;
            move();
          }
          break;
        }
        case 32: { // SPACE
          if (mode === MODE_SPACE) {
            if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].altKey) {
              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
              mode = MODE_CENTER;
            } else {
              if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
              if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
              mode = MODE_HANDLE;
            }
            overlay.attr("cursor", cursors[type]);
            move();
          }
          break;
        }
        default: return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
    }
  }

  function initialize() {
    var state = this.__brush || {selection: null};
    state.extent = extent.apply(this, arguments);
    state.dim = dim;
    return state;
  }

  brush.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), brush) : extent;
  };

  brush.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(!!_), brush) : filter;
  };

  brush.handleSize = function(_) {
    return arguments.length ? (handleSize = +_, brush) : handleSize;
  };

  brush.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? brush : value;
  };

  return brush;
}


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var noop = {value: function() {}};

function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

/* harmony default export */ __webpack_exports__["a"] = (dispatch);


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodrag__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__noevent__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constant__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event__ = __webpack_require__(369);







// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].button;
}

function defaultContainer() {
  return this.parentNode;
}

function defaultSubject(d) {
  return d == null ? {x: __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].x, y: __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].y} : d;
}

function defaultTouchable() {
  return "ontouchstart" in this;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var filter = defaultFilter,
      container = defaultContainer,
      subject = defaultSubject,
      touchable = defaultTouchable,
      gestures = {},
      listeners = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "drag", "end"),
      active = 0,
      mousedownx,
      mousedowny,
      mousemoving,
      touchending,
      clickDistance2 = 0;

  function drag(selection) {
    selection
        .on("mousedown.drag", mousedowned)
      .filter(touchable)
        .on("touchstart.drag", touchstarted)
        .on("touchmove.drag", touchmoved)
        .on("touchend.drag touchcancel.drag", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var gesture = beforestart("mouse", container.apply(this, arguments), __WEBPACK_IMPORTED_MODULE_1_d3_selection__["d" /* mouse */], this, arguments);
    if (!gesture) return;
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
    Object(__WEBPACK_IMPORTED_MODULE_2__nodrag__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].view);
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
    mousemoving = false;
    mousedownx = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].clientX;
    mousedowny = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].clientY;
    gesture("start");
  }

  function mousemoved() {
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
    if (!mousemoving) {
      var dx = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].clientX - mousedownx, dy = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].clientY - mousedowny;
      mousemoving = dx * dx + dy * dy > clickDistance2;
    }
    gestures.mouse("drag");
  }

  function mouseupped() {
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].view).on("mousemove.drag mouseup.drag", null);
    Object(__WEBPACK_IMPORTED_MODULE_2__nodrag__["b" /* yesdrag */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].view, mousemoving);
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
    gestures.mouse("end");
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].changedTouches,
        c = container.apply(this, arguments),
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = beforestart(touches[i].identifier, c, __WEBPACK_IMPORTED_MODULE_1_d3_selection__["k" /* touch */], this, arguments)) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
        gesture("start");
      }
    }
  }

  function touchmoved() {
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].changedTouches,
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
        gesture("drag");
      }
    }
  }

  function touchended() {
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].changedTouches,
        n = touches.length, i, gesture;

    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
        gesture("end");
      }
    }
  }

  function beforestart(id, container, point, that, args) {
    var p = point(container, id), s, dx, dy,
        sublisteners = listeners.copy();

    if (!Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["a" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_5__event__["a" /* default */](drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
      if ((__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].subject = s = subject.apply(that, args)) == null) return false;
      dx = s.x - p[0] || 0;
      dy = s.y - p[1] || 0;
      return true;
    })) return;

    return function gesture(type) {
      var p0 = p, n;
      switch (type) {
        case "start": gestures[id] = gesture, n = active++; break;
        case "end": delete gestures[id], --active; // nobreak
        case "drag": p = point(container, id), n = active; break;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["a" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_5__event__["a" /* default */](drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [type, that, args]);
    };
  }

  drag.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(!!_), drag) : filter;
  };

  drag.container = function(_) {
    return arguments.length ? (container = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(_), drag) : container;
  };

  drag.subject = function(_) {
    return arguments.length ? (subject = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(_), drag) : subject;
  };

  drag.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(!!_), drag) : touchable;
  };

  drag.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? drag : value;
  };

  drag.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
  };

  return drag;
});


/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__select__ = __webpack_require__(129);



/* unused harmony default export */ var _unused_webpack_default_export = (function(name) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__select__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name).call(document.documentElement));
});


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(69);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectorAll__ = __webpack_require__(130);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_1__selectorAll__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, parents);
});


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matcher__ = __webpack_require__(131);



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = Object(__WEBPACK_IMPORTED_MODULE_1__matcher__["a" /* default */])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enter__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(339);




var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["a" /* EnterNode */](parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["a" /* EnterNode */](parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
});


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._exit || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (function(selection) {

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](merges, this._parents);
});


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
});


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (!compare) compare = ascending;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](sortgroups, this._parents).order();
});

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
});


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
});


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
});


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
});


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return !this.node();
});


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
});


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(67);


function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
});


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
});


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
});


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
});


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
});


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(raise);
});


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(lower);
});


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(41);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var create = typeof name === "function" ? name : Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
});


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(69);



function constantNull() {
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, before) {
  var create = typeof name === "function" ? name : Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name),
      select = before == null ? constantNull : typeof before === "function" ? before : Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
});


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(remove);
});


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function selection_cloneShallow() {
  return this.parentNode.insertBefore(this.cloneNode(false), this.nextSibling);
}

function selection_cloneDeep() {
  return this.parentNode.insertBefore(this.cloneNode(true), this.nextSibling);
}

/* harmony default export */ __webpack_exports__["a"] = (function(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
});


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
});


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(70);


function dispatchEvent(node, type, params) {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
});


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
var nextId = 0;

function local() {
  return new Local;
}

function Local() {
  this._ = "@" + (++nextId).toString(36);
}

Local.prototype = local.prototype = {
  constructor: Local,
  get: function(node) {
    var id = this._;
    while (!(id in node)) if (!(node = node.parentNode)) return;
    return node[id];
  },
  set: function(node, value) {
    return node[this._] = value;
  },
  remove: function(node) {
    return this._ in node && delete node[this._];
  },
  toString: function() {
    return this._;
  }
};


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(42);



/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  var event = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])();
  if (event.changedTouches) event = event.changedTouches[0];
  return Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, event);
});


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(6);


/* unused harmony default export */ var _unused_webpack_default_export = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([document.querySelectorAll(selector)], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([selector == null ? [] : selector], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" /* root */]);
});


/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(42);



/* harmony default export */ __webpack_exports__["a"] = (function(node, touches, identifier) {
  if (arguments.length < 3) identifier = touches, touches = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().changedTouches;

  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
    if ((touch = touches[i]).identifier === identifier) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touch);
    }
  }

  return null;
});


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(42);



/* unused harmony default export */ var _unused_webpack_default_export = (function(node, touches) {
  if (touches == null) touches = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().touches;

  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
    points[i] = Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touches[i]);
  }

  return points;
});


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DragEvent;
function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch) {
  this.target = target;
  this.type = type;
  this.subject = subject;
  this.identifier = id;
  this.active = active;
  this.x = x;
  this.y = y;
  this.dx = dx;
  this.dy = dy;
  this._ = dispatch;
}

DragEvent.prototype.on = function() {
  var value = this._.on.apply(this._, arguments);
  return value === this._ ? this : value;
};


/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* unused harmony export Lab */
/* harmony export (immutable) */ __webpack_exports__["b"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(137);




var Kn = 18,
    Xn = 0.950470, // D65 standard referent
    Yn = 1,
    Zn = 1.088830,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var b = rgb2xyz(o.r),
      a = rgb2xyz(o.g),
      l = rgb2xyz(o.b),
      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function xyz2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2xyz(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(137);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return interpolateTransformCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return interpolateTransformSvg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(374);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(375);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  value = value.matrix;
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* harmony default export */ __webpack_exports__["a"] = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(28);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(end)).h),
        s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(28);



function lab(start, end) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(start)).l, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(end)).l),
      a = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(28);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(end)).h),
        c = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(28);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(end)).h),
          s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* unused harmony default export */ var _unused_webpack_default_export = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interrupt__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transition__ = __webpack_require__(386);




__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* selection */].prototype.interrupt = __WEBPACK_IMPORTED_MODULE_1__interrupt__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* selection */].prototype.transition = __WEBPACK_IMPORTED_MODULE_2__transition__["a" /* default */];


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interrupt__ = __webpack_require__(145);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  return this.each(function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__interrupt__["a" /* default */])(this, name);
  });
});


/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(78);


/* harmony default export */ __webpack_exports__["a"] = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["a" /* Timer */];
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
});


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(78);


/* unused harmony default export */ var _unused_webpack_default_export = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["a" /* Timer */], total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? Object(__WEBPACK_IMPORTED_MODULE_0__timer__["b" /* now */])() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
});


/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_index__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transition_schedule__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_ease__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_timer__ = __webpack_require__(44);





var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: __WEBPACK_IMPORTED_MODULE_2_d3_ease__["a" /* easeCubicInOut */]
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      return defaultTiming.time = Object(__WEBPACK_IMPORTED_MODULE_3_d3_timer__["a" /* now */])(), defaultTiming;
    }
  }
  return timing;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var id,
      timing;

  if (name instanceof __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */]) {
    id = name._id, name = name._name;
  } else {
    id = Object(__WEBPACK_IMPORTED_MODULE_0__transition_index__["b" /* newId */])(), (timing = defaultTiming).time = Object(__WEBPACK_IMPORTED_MODULE_3_d3_timer__["a" /* now */])(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        Object(__WEBPACK_IMPORTED_MODULE_1__transition_schedule__["e" /* default */])(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */](groups, this._parents, name, id);
});


/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tween__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__(146);





function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attrConstantNS(fullname, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attrFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttribute(name);
    value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function attrFunctionNS(fullname, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* namespace */])(name), i = fullname === "transform" ? __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["h" /* interpolateTransformSvg */] : __WEBPACK_IMPORTED_MODULE_3__interpolate__["a" /* default */];
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, Object(__WEBPACK_IMPORTED_MODULE_2__tween__["b" /* tweenValue */])(this, "attr." + name, value))
      : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname)
      : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value + ""));
});


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(2);


function attrTweenNS(fullname, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttributeNS(fullname.space, fullname.local, i(t));
    };
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttribute(name, i(t));
    };
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* namespace */])(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
});


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(8);


function delayFunction(id, value) {
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */])(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */])(this, id).delay = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).delay;
});


/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(8);


function durationFunction(id, value) {
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).duration = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).duration;
});


/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(8);


function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).ease = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).ease;
});


/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["c" /* matcher */])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, this._parents, this._name, this._id);
});


/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(14);


/* harmony default export */ __webpack_exports__["a"] = (function(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Transition */](merges, this._parents, this._name, this._id);
});


/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(8);


function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start(name) ? __WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */] : __WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */];
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
});


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.on("end.remove", removeFunction(this._id));
});


/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["h" /* selector */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["e" /* default */])(subgroup[i], name, id, i, subgroup, Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["f" /* get */])(node, id));
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, this._parents, name, id);
});


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["i" /* selectorAll */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select.call(node, node.__data__, i, group), child, inherit = Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["f" /* get */])(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["e" /* default */])(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, parents, name, id);
});


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(2);


var Selection = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* selection */].prototype.constructor;

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new Selection(this._groups, this._parents);
});


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tween__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__(146);





function styleRemove(name, interpolate) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["j" /* style */])(this, name),
        value1 = (this.style.removeProperty(name), Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["j" /* style */])(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function styleRemoveEnd(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["j" /* style */])(this, name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function styleFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["j" /* style */])(this, name),
        value1 = value(this);
    if (value1 == null) value1 = (this.style.removeProperty(name), Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["j" /* style */])(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  var i = (name += "") === "transform" ? __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["g" /* interpolateTransformCss */] : __WEBPACK_IMPORTED_MODULE_3__interpolate__["a" /* default */];
  return value == null ? this
          .styleTween(name, styleRemove(name, i))
          .on("end.style." + name, styleRemoveEnd(name))
      : this.styleTween(name, typeof value === "function"
          ? styleFunction(name, i, Object(__WEBPACK_IMPORTED_MODULE_2__tween__["b" /* tweenValue */])(this, "style." + name, value))
          : styleConstant(name, i, value + ""), priority);
});


/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function styleTween(name, value, priority) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.style.setProperty(name, i(t), priority);
    };
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
});


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tween__ = __webpack_require__(45);


function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction(Object(__WEBPACK_IMPORTED_MODULE_0__tween__["b" /* tweenValue */])(this, "text", value))
      : textConstant(value == null ? "" : value + ""));
});


/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schedule__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  var name = this._name,
      id0 = this._id,
      id1 = Object(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* newId */])();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = Object(__WEBPACK_IMPORTED_MODULE_1__schedule__["f" /* get */])(node, id0);
        Object(__WEBPACK_IMPORTED_MODULE_1__schedule__["e" /* default */])(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Transition */](groups, this._parents, name, id1);
});


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export linear */
function linear(t) {
  return +t;
}


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export quadIn */
/* unused harmony export quadOut */
/* unused harmony export quadInOut */
function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export cubicIn */
/* unused harmony export cubicOut */
/* harmony export (immutable) */ __webpack_exports__["a"] = cubicInOut;
function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export polyIn */
/* unused harmony export polyOut */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return polyInOut; });
var exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(exponent);


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sinIn */
/* unused harmony export sinOut */
/* unused harmony export sinInOut */
var pi = Math.PI,
    halfPi = pi / 2;

function sinIn(t) {
  return 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export expIn */
/* unused harmony export expOut */
/* unused harmony export expInOut */
function expIn(t) {
  return Math.pow(2, 10 * t - 10);
}

function expOut(t) {
  return 1 - Math.pow(2, -10 * t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
}


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export circleIn */
/* unused harmony export circleOut */
/* unused harmony export circleInOut */
function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bounceIn */
/* unused harmony export bounceOut */
/* unused harmony export bounceInOut */
var b1 = 4 / 11,
    b2 = 6 / 11,
    b3 = 8 / 11,
    b4 = 3 / 4,
    b5 = 9 / 11,
    b6 = 10 / 11,
    b7 = 15 / 16,
    b8 = 21 / 22,
    b9 = 63 / 64,
    b0 = 1 / b1 / b1;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export backIn */
/* unused harmony export backOut */
/* unused harmony export backInOut */
var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return t * t * ((s + 1) * t - s);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((s + 1) * t + s) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export elasticIn */
/* unused harmony export elasticOut */
/* unused harmony export elasticInOut */
var tau = 2 * Math.PI,
    amplitude = 1,
    period = 0.3;

var elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_index__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transition_schedule__ = __webpack_require__(8);



var root = [null];

/* unused harmony default export */ var _unused_webpack_default_export = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      i;

  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule = schedules[i]).state > __WEBPACK_IMPORTED_MODULE_1__transition_schedule__["c" /* SCHEDULED */] && schedule.name === name) {
        return new __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */]([[node]], root, name, +i);
      }
    }
  }

  return null;
});


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
});


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nopropagation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(2);


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
});


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_chord__ = __webpack_require__(418);
/* unused harmony reexport chord */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ribbon__ = __webpack_require__(419);
/* unused harmony reexport ribbon */




/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(148);



function compareValue(compare) {
  return function(a, b) {
    return compare(
      a.source.value + a.target.value,
      b.source.value + b.target.value
    );
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var padAngle = 0,
      sortGroups = null,
      sortSubgroups = null,
      sortChords = null;

  function chord(matrix) {
    var n = matrix.length,
        groupSums = [],
        groupIndex = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* range */])(n),
        subgroupIndex = [],
        chords = [],
        groups = chords.groups = new Array(n),
        subgroups = new Array(n * n),
        k,
        x,
        x0,
        dx,
        i,
        j;

    // Compute the sum.
    k = 0, i = -1; while (++i < n) {
      x = 0, j = -1; while (++j < n) {
        x += matrix[i][j];
      }
      groupSums.push(x);
      subgroupIndex.push(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* range */])(n));
      k += x;
    }

    // Sort groups…
    if (sortGroups) groupIndex.sort(function(a, b) {
      return sortGroups(groupSums[a], groupSums[b]);
    });

    // Sort subgroups…
    if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
      d.sort(function(a, b) {
        return sortSubgroups(matrix[i][a], matrix[i][b]);
      });
    });

    // Convert the sum to scaling factor for [0, 2pi].
    // TODO Allow start and end angle to be specified?
    // TODO Allow padding to be specified as percentage?
    k = Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* max */])(0, __WEBPACK_IMPORTED_MODULE_1__math__["e" /* tau */] - padAngle * n) / k;
    dx = k ? padAngle : __WEBPACK_IMPORTED_MODULE_1__math__["e" /* tau */] / n;

    // Compute the start and end angle for each group and subgroup.
    // Note: Opera has a bug reordering object literal properties!
    x = 0, i = -1; while (++i < n) {
      x0 = x, j = -1; while (++j < n) {
        var di = groupIndex[i],
            dj = subgroupIndex[di][j],
            v = matrix[di][dj],
            a0 = x,
            a1 = x += v * k;
        subgroups[dj * n + di] = {
          index: di,
          subindex: dj,
          startAngle: a0,
          endAngle: a1,
          value: v
        };
      }
      groups[di] = {
        index: di,
        startAngle: x0,
        endAngle: x,
        value: groupSums[di]
      };
      x += dx;
    }

    // Generate chords for each (non-empty) subgroup-subgroup link.
    i = -1; while (++i < n) {
      j = i - 1; while (++j < n) {
        var source = subgroups[j * n + i],
            target = subgroups[i * n + j];
        if (source.value || target.value) {
          chords.push(source.value < target.value
              ? {source: target, target: source}
              : {source: source, target: target});
        }
      }
    }

    return sortChords ? chords.sort(sortChords) : chords;
  }

  chord.padAngle = function(_) {
    return arguments.length ? (padAngle = Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* max */])(0, _), chord) : padAngle;
  };

  chord.sortGroups = function(_) {
    return arguments.length ? (sortGroups = _, chord) : sortGroups;
  };

  chord.sortSubgroups = function(_) {
    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
  };

  chord.sortChords = function(_) {
    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
  };

  return chord;
});


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_path__ = __webpack_require__(18);





function defaultSource(d) {
  return d.source;
}

function defaultTarget(d) {
  return d.target;
}

function defaultRadius(d) {
  return d.radius;
}

function defaultStartAngle(d) {
  return d.startAngle;
}

function defaultEndAngle(d) {
  return d.endAngle;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var source = defaultSource,
      target = defaultTarget,
      radius = defaultRadius,
      startAngle = defaultStartAngle,
      endAngle = defaultEndAngle,
      context = null;

  function ribbon() {
    var buffer,
        argv = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(arguments),
        s = source.apply(this, argv),
        t = target.apply(this, argv),
        sr = +radius.apply(this, (argv[0] = s, argv)),
        sa0 = startAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */],
        sa1 = endAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */],
        sx0 = sr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* cos */])(sa0),
        sy0 = sr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(sa0),
        tr = +radius.apply(this, (argv[0] = t, argv)),
        ta0 = startAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */],
        ta1 = endAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */];

    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_3_d3_path__["a" /* path */])();

    context.moveTo(sx0, sy0);
    context.arc(0, 0, sr, sa0, sa1);
    if (sa0 !== ta0 || sa1 !== ta1) { // TODO sr !== tr?
      context.quadraticCurveTo(0, 0, tr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* cos */])(ta0), tr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(ta0));
      context.arc(0, 0, tr, ta0, ta1);
    }
    context.quadraticCurveTo(0, 0, sx0, sy0);
    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  ribbon.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), ribbon) : radius;
  };

  ribbon.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), ribbon) : startAngle;
  };

  ribbon.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), ribbon) : endAngle;
  };

  ribbon.source = function(_) {
    return arguments.length ? (source = _, ribbon) : source;
  };

  ribbon.target = function(_) {
    return arguments.length ? (target = _, ribbon) : target;
  };

  ribbon.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), ribbon) : context;
  };

  return ribbon;
});


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon)) {}

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (path);


/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(79);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}


/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(79);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* unused harmony default export */ var _unused_webpack_default_export = (set);


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});


/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});


/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return csvParse; });
/* unused harmony export csvParseRows */
/* unused harmony export csvFormat */
/* unused harmony export csvFormatRows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dsv__ = __webpack_require__(81);


var csv = Object(__WEBPACK_IMPORTED_MODULE_0__dsv__["a" /* default */])(",");

var csvParse = csv.parse;
var csvParseRows = csv.parseRows;
var csvFormat = csv.format;
var csvFormatRows = csv.formatRows;


/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tsvParse; });
/* unused harmony export tsvParseRows */
/* unused harmony export tsvFormat */
/* unused harmony export tsvFormatRows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dsv__ = __webpack_require__(81);


var tsv = Object(__WEBPACK_IMPORTED_MODULE_0__dsv__["a" /* default */])("\t");

var tsvParse = tsv.parse;
var tsvParseRows = tsv.parseRows;
var tsvFormat = tsv.format;
var tsvFormatRows = tsv.formatRows;


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_center__ = __webpack_require__(431);
/* unused harmony reexport forceCenter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_collide__ = __webpack_require__(432);
/* unused harmony reexport forceCollide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_link__ = __webpack_require__(446);
/* unused harmony reexport forceLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_manyBody__ = __webpack_require__(447);
/* unused harmony reexport forceManyBody */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_radial__ = __webpack_require__(448);
/* unused harmony reexport forceRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_simulation__ = __webpack_require__(149);
/* unused harmony reexport forceSimulation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_x__ = __webpack_require__(449);
/* unused harmony reexport forceX */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_y__ = __webpack_require__(450);
/* unused harmony reexport forceY */










/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(x, y) {
  var nodes;

  if (x == null) x = 0;
  if (y == null) y = 0;

  function force() {
    var i,
        n = nodes.length,
        node,
        sx = 0,
        sy = 0;

    for (i = 0; i < n; ++i) {
      node = nodes[i], sx += node.x, sy += node.y;
    }

    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
      node = nodes[i], node.x -= sx, node.y -= sy;
    }
  }

  force.initialize = function(_) {
    nodes = _;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
});


/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_quadtree__ = __webpack_require__(83);




function x(d) {
  return d.x + d.vx;
}

function y(d) {
  return d.y + d.vy;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(radius) {
  var nodes,
      radii,
      strength = 1,
      iterations = 1;

  if (typeof radius !== "function") radius = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(radius == null ? 1 : +radius);

  function force() {
    var i, n = nodes.length,
        tree,
        node,
        xi,
        yi,
        ri,
        ri2;

    for (var k = 0; k < iterations; ++k) {
      tree = Object(__WEBPACK_IMPORTED_MODULE_2_d3_quadtree__["a" /* quadtree */])(nodes, x, y).visitAfter(prepare);
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        ri = radii[node.index], ri2 = ri * ri;
        xi = node.x + node.vx;
        yi = node.y + node.vy;
        tree.visit(apply);
      }
    }

    function apply(quad, x0, y0, x1, y1) {
      var data = quad.data, rj = quad.r, r = ri + rj;
      if (data) {
        if (data.index > node.index) {
          var x = xi - data.x - data.vx,
              y = yi - data.y - data.vy,
              l = x * x + y * y;
          if (l < r * r) {
            if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
            if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
            l = (r - (l = Math.sqrt(l))) / l * strength;
            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
            node.vy += (y *= l) * r;
            data.vx -= x * (r = 1 - r);
            data.vy -= y * r;
          }
        }
        return;
      }
      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
    }
  }

  function prepare(quad) {
    if (quad.data) return quad.r = radii[quad.data.index];
    for (var i = quad.r = 0; i < 4; ++i) {
      if (quad[i] && quad[i].r > quad.r) {
        quad.r = quad[i].r;
      }
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    radii = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = +_, force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : radius;
  };

  return force;
});


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quadtree;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__add__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cover__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__find__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__remove__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__root__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__size__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__visit__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__visitAfter__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__x__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__y__ = __webpack_require__(445);













function quadtree(nodes, x, y) {
  var tree = new Quadtree(x == null ? __WEBPACK_IMPORTED_MODULE_10__x__["b" /* defaultX */] : x, y == null ? __WEBPACK_IMPORTED_MODULE_11__y__["b" /* defaultY */] : y, NaN, NaN, NaN, NaN);
  return nodes == null ? tree : tree.addAll(nodes);
}

function Quadtree(x, y, x0, y0, x1, y1) {
  this._x = x;
  this._y = y;
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  this._root = undefined;
}

function leaf_copy(leaf) {
  var copy = {data: leaf.data}, next = copy;
  while (leaf = leaf.next) next = next.next = {data: leaf.data};
  return copy;
}

var treeProto = quadtree.prototype = Quadtree.prototype;

treeProto.copy = function() {
  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
      node = this._root,
      nodes,
      child;

  if (!node) return copy;

  if (!node.length) return copy._root = leaf_copy(node), copy;

  nodes = [{source: node, target: copy._root = new Array(4)}];
  while (node = nodes.pop()) {
    for (var i = 0; i < 4; ++i) {
      if (child = node.source[i]) {
        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
        else node.target[i] = leaf_copy(child);
      }
    }
  }

  return copy;
};

treeProto.add = __WEBPACK_IMPORTED_MODULE_0__add__["b" /* default */];
treeProto.addAll = __WEBPACK_IMPORTED_MODULE_0__add__["a" /* addAll */];
treeProto.cover = __WEBPACK_IMPORTED_MODULE_1__cover__["a" /* default */];
treeProto.data = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */];
treeProto.extent = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */];
treeProto.find = __WEBPACK_IMPORTED_MODULE_4__find__["a" /* default */];
treeProto.remove = __WEBPACK_IMPORTED_MODULE_5__remove__["a" /* default */];
treeProto.removeAll = __WEBPACK_IMPORTED_MODULE_5__remove__["b" /* removeAll */];
treeProto.root = __WEBPACK_IMPORTED_MODULE_6__root__["a" /* default */];
treeProto.size = __WEBPACK_IMPORTED_MODULE_7__size__["a" /* default */];
treeProto.visit = __WEBPACK_IMPORTED_MODULE_8__visit__["a" /* default */];
treeProto.visitAfter = __WEBPACK_IMPORTED_MODULE_9__visitAfter__["a" /* default */];
treeProto.x = __WEBPACK_IMPORTED_MODULE_10__x__["a" /* default */];
treeProto.y = __WEBPACK_IMPORTED_MODULE_11__y__["a" /* default */];


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addAll;
/* harmony default export */ __webpack_exports__["b"] = (function(d) {
  var x = +this._x.call(null, d),
      y = +this._y.call(null, d);
  return add(this.cover(x, y), x, y, d);
});

function add(tree, x, y, d) {
  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points

  var parent,
      node = tree._root,
      leaf = {data: d},
      x0 = tree._x0,
      y0 = tree._y0,
      x1 = tree._x1,
      y1 = tree._y1,
      xm,
      ym,
      xp,
      yp,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return tree._root = leaf, tree;

  // Find the existing leaf for the new point, or add it.
  while (node.length) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
  }

  // Is the new point is exactly coincident with the existing point?
  xp = +tree._x.call(null, node.data);
  yp = +tree._y.call(null, node.data);
  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;

  // Otherwise, split the leaf node until the old and new point are separated.
  do {
    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
  return parent[j] = node, parent[i] = leaf, tree;
}

function addAll(data) {
  var d, i, n = data.length,
      x,
      y,
      xz = new Array(n),
      yz = new Array(n),
      x0 = Infinity,
      y0 = Infinity,
      x1 = -Infinity,
      y1 = -Infinity;

  // Compute the points and their extent.
  for (i = 0; i < n; ++i) {
    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
    xz[i] = x;
    yz[i] = y;
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
  }

  // If there were no (valid) points, inherit the existing extent.
  if (x1 < x0) x0 = this._x0, x1 = this._x1;
  if (y1 < y0) y0 = this._y0, y1 = this._y1;

  // Expand the tree to cover the new points.
  this.cover(x0, y0).cover(x1, y1);

  // Add the new points.
  for (i = 0; i < n; ++i) {
    add(this, xz[i], yz[i], data[i]);
  }

  return this;
}


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points

  var x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1;

  // If the quadtree has no extent, initialize them.
  // Integer extent are necessary so that if we later double the extent,
  // the existing quadrant boundaries don’t change due to floating point error!
  if (isNaN(x0)) {
    x1 = (x0 = Math.floor(x)) + 1;
    y1 = (y0 = Math.floor(y)) + 1;
  }

  // Otherwise, double repeatedly to cover.
  else if (x0 > x || x > x1 || y0 > y || y > y1) {
    var z = x1 - x0,
        node = this._root,
        parent,
        i;

    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
      case 0: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
        break;
      }
      case 1: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
        break;
      }
      case 2: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
        break;
      }
      case 3: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
        break;
      }
    }

    if (this._root && this._root.length) this._root = node;
  }

  // If the quadtree covers the point already, just return.
  else return this;

  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  return this;
});


/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var data = [];
  this.visit(function(node) {
    if (!node.length) do data.push(node.data); while (node = node.next)
  });
  return data;
});


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length
      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
});


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(84);


/* harmony default export */ __webpack_exports__["a"] = (function(x, y, radius) {
  var data,
      x0 = this._x0,
      y0 = this._y0,
      x1,
      y1,
      x2,
      y2,
      x3 = this._x1,
      y3 = this._y1,
      quads = [],
      node = this._root,
      q,
      i;

  if (node) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node, x0, y0, x3, y3));
  if (radius == null) radius = Infinity;
  else {
    x0 = x - radius, y0 = y - radius;
    x3 = x + radius, y3 = y + radius;
    radius *= radius;
  }

  while (q = quads.pop()) {

    // Stop searching if this quadrant can’t contain a closer node.
    if (!(node = q.node)
        || (x1 = q.x0) > x3
        || (y1 = q.y0) > y3
        || (x2 = q.x1) < x0
        || (y2 = q.y1) < y0) continue;

    // Bisect the current quadrant.
    if (node.length) {
      var xm = (x1 + x2) / 2,
          ym = (y1 + y2) / 2;

      quads.push(
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[3], xm, ym, x2, y2),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[2], x1, ym, xm, y2),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[1], xm, y1, x2, ym),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[0], x1, y1, xm, ym)
      );

      // Visit the closest quadrant first.
      if (i = (y >= ym) << 1 | (x >= xm)) {
        q = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i];
        quads[quads.length - 1 - i] = q;
      }
    }

    // Visit this point. (Visiting coincident points isn’t necessary!)
    else {
      var dx = x - +this._x.call(null, node.data),
          dy = y - +this._y.call(null, node.data),
          d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d = Math.sqrt(radius = d2);
        x0 = x - d, y0 = y - d;
        x3 = x + d, y3 = y + d;
        data = node.data;
      }
    }
  }

  return data;
});


/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = removeAll;
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points

  var parent,
      node = this._root,
      retainer,
      previous,
      next,
      x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1,
      x,
      y,
      xm,
      ym,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return this;

  // Find the leaf node for the point.
  // While descending, also retain the deepest parent with a non-removed sibling.
  if (node.length) while (true) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
    if (!node.length) break;
    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
  }

  // Find the point to remove.
  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
  if (next = node.next) delete node.next;

  // If there are multiple coincident points, remove just the point.
  if (previous) return (next ? previous.next = next : delete previous.next), this;

  // If this is the root point, remove it.
  if (!parent) return this._root = next, this;

  // Remove this leaf.
  next ? parent[i] = next : delete parent[i];

  // If the parent now contains exactly one leaf, collapse superfluous parents.
  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
      && node === (parent[3] || parent[2] || parent[1] || parent[0])
      && !node.length) {
    if (retainer) retainer[j] = node;
    else this._root = node;
  }

  return this;
});

function removeAll(data) {
  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
  return this;
}


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this._root;
});


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
});


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(84);


/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
  if (node) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[3]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, ym, x1, y1));
      if (child = node[2]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, ym, xm, y1));
      if (child = node[1]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, y0, x1, ym));
      if (child = node[0]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, y0, xm, ym));
    }
  }
  return this;
});


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(84);


/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var quads = [], next = [], q;
  if (this._root) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](this._root, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    var node = q.node;
    if (node.length) {
      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[0]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, y0, xm, ym));
      if (child = node[1]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, y0, x1, ym));
      if (child = node[2]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, ym, xm, y1));
      if (child = node[3]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, ym, x1, y1));
    }
    next.push(q);
  }
  while (q = next.pop()) {
    callback(q.node, q.x0, q.y0, q.x1, q.y1);
  }
  return this;
});


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultX;
function defaultX(d) {
  return d[0];
}

/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length ? (this._x = _, this) : this._x;
});


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultY;
function defaultY(d) {
  return d[1];
}

/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length ? (this._y = _, this) : this._y;
});


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_collection__ = __webpack_require__(29);




function index(d) {
  return d.index;
}

function find(nodeById, nodeId) {
  var node = nodeById.get(nodeId);
  if (!node) throw new Error("missing: " + nodeId);
  return node;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(links) {
  var id = index,
      strength = defaultStrength,
      strengths,
      distance = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(30),
      distances,
      nodes,
      count,
      bias,
      iterations = 1;

  if (links == null) links = [];

  function defaultStrength(link) {
    return 1 / Math.min(count[link.source.index], count[link.target.index]);
  }

  function force(alpha) {
    for (var k = 0, n = links.length; k < iterations; ++k) {
      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
        link = links[i], source = link.source, target = link.target;
        x = target.x + target.vx - source.x - source.vx || Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])();
        y = target.y + target.vy - source.y - source.vy || Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])();
        l = Math.sqrt(x * x + y * y);
        l = (l - distances[i]) / l * alpha * strengths[i];
        x *= l, y *= l;
        target.vx -= x * (b = bias[i]);
        target.vy -= y * b;
        source.vx += x * (b = 1 - b);
        source.vy += y * b;
      }
    }
  }

  function initialize() {
    if (!nodes) return;

    var i,
        n = nodes.length,
        m = links.length,
        nodeById = Object(__WEBPACK_IMPORTED_MODULE_2_d3_collection__["a" /* map */])(nodes, id),
        link;

    for (i = 0, count = new Array(n); i < m; ++i) {
      link = links[i], link.index = i;
      if (typeof link.source !== "object") link.source = find(nodeById, link.source);
      if (typeof link.target !== "object") link.target = find(nodeById, link.target);
      count[link.source.index] = (count[link.source.index] || 0) + 1;
      count[link.target.index] = (count[link.target.index] || 0) + 1;
    }

    for (i = 0, bias = new Array(m); i < m; ++i) {
      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
    }

    strengths = new Array(m), initializeStrength();
    distances = new Array(m), initializeDistance();
  }

  function initializeStrength() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      strengths[i] = +strength(links[i], i, links);
    }
  }

  function initializeDistance() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      distances[i] = +distance(links[i], i, links);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.links = function(_) {
    return arguments.length ? (links = _, initialize(), force) : links;
  };

  force.id = function(_) {
    return arguments.length ? (id = _, force) : id;
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initializeStrength(), force) : strength;
  };

  force.distance = function(_) {
    return arguments.length ? (distance = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initializeDistance(), force) : distance;
  };

  return force;
});


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_quadtree__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__simulation__ = __webpack_require__(149);





/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var nodes,
      node,
      alpha,
      strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(-30),
      strengths,
      distanceMin2 = 1,
      distanceMax2 = Infinity,
      theta2 = 0.81;

  function force(_) {
    var i, n = nodes.length, tree = Object(__WEBPACK_IMPORTED_MODULE_2_d3_quadtree__["a" /* quadtree */])(nodes, __WEBPACK_IMPORTED_MODULE_3__simulation__["a" /* x */], __WEBPACK_IMPORTED_MODULE_3__simulation__["b" /* y */]).visitAfter(accumulate);
    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    strengths = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
  }

  function accumulate(quad) {
    var strength = 0, q, c, weight = 0, x, y, i;

    // For internal nodes, accumulate forces from child quadrants.
    if (quad.length) {
      for (x = y = i = 0; i < 4; ++i) {
        if ((q = quad[i]) && (c = Math.abs(q.value))) {
          strength += q.value, weight += c, x += c * q.x, y += c * q.y;
        }
      }
      quad.x = x / weight;
      quad.y = y / weight;
    }

    // For leaf nodes, accumulate forces from coincident quadrants.
    else {
      q = quad;
      q.x = q.data.x;
      q.y = q.data.y;
      do strength += strengths[q.data.index];
      while (q = q.next);
    }

    quad.value = strength;
  }

  function apply(quad, x1, _, x2) {
    if (!quad.value) return true;

    var x = quad.x - node.x,
        y = quad.y - node.y,
        w = x2 - x1,
        l = x * x + y * y;

    // Apply the Barnes-Hut approximation if possible.
    // Limit forces for very close nodes; randomize direction if coincident.
    if (w * w / theta2 < l) {
      if (l < distanceMax2) {
        if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
        if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        node.vx += x * quad.value * alpha / l;
        node.vy += y * quad.value * alpha / l;
      }
      return true;
    }

    // Otherwise, process points directly.
    else if (quad.length || l >= distanceMax2) return;

    // Limit forces for very close nodes; randomize direction if coincident.
    if (quad.data !== node || quad.next) {
      if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
      if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
    }

    do if (quad.data !== node) {
      w = strengths[quad.data.index] * alpha / l;
      node.vx += x * w;
      node.vy += y * w;
    } while (quad = quad.next);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.distanceMin = function(_) {
    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
  };

  force.distanceMax = function(_) {
    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
  };

  force.theta = function(_) {
    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
  };

  return force;
});


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(24);


/* unused harmony default export */ var _unused_webpack_default_export = (function(radius, x, y) {
  var nodes,
      strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0.1),
      strengths,
      radiuses;

  if (typeof radius !== "function") radius = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+radius);
  if (x == null) x = 0;
  if (y == null) y = 0;

  function force(alpha) {
    for (var i = 0, n = nodes.length; i < n; ++i) {
      var node = nodes[i],
          dx = node.x - x || 1e-6,
          dy = node.y - y || 1e-6,
          r = Math.sqrt(dx * dx + dy * dy),
          k = (radiuses[i] - r) * strengths[i] * alpha / r;
      node.vx += dx * k;
      node.vy += dy * k;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    radiuses = new Array(n);
    for (i = 0; i < n; ++i) {
      radiuses[i] = +radius(nodes[i], i, nodes);
      strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _, initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : radius;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
});


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(24);


/* unused harmony default export */ var _unused_webpack_default_export = (function(x) {
  var strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0.1),
      nodes,
      strengths,
      xz;

  if (typeof x !== "function") x = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(x == null ? 0 : +x);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    xz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : x;
  };

  return force;
});


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(24);


/* unused harmony default export */ var _unused_webpack_default_export = (function(y) {
  var strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0.1),
      nodes,
      strengths,
      yz;

  if (typeof y !== "function") y = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(y == null ? 0 : +y);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    yz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : y;
  };

  return force;
});


/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatPrefix; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(150);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  x = x.toPrecision(p);

  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (x[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      case "e": break out;
      default: if (i0 > 0) i0 = 0; break;
    }
  }

  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
});


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(86);


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(46);


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(46);


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3 - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(46);


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(max) - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(step)) + 1;
});


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_area__ = __webpack_require__(154);
/* unused harmony reexport geoArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_bounds__ = __webpack_require__(461);
/* unused harmony reexport geoBounds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_centroid__ = __webpack_require__(462);
/* unused harmony reexport geoCentroid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_circle__ = __webpack_require__(155);
/* unused harmony reexport geoCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_clip_antimeridian__ = __webpack_require__(157);
/* unused harmony reexport geoClipAntimeridian */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_clip_circle__ = __webpack_require__(163);
/* unused harmony reexport geoClipCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_clip_extent__ = __webpack_require__(464);
/* unused harmony reexport geoClipExtent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_clip_rectangle__ = __webpack_require__(48);
/* unused harmony reexport geoClipRectangle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_contains__ = __webpack_require__(466);
/* unused harmony reexport geoContains */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_distance__ = __webpack_require__(164);
/* unused harmony reexport geoDistance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_graticule__ = __webpack_require__(467);
/* unused harmony reexport geoGraticule */
/* unused harmony reexport geoGraticule10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_interpolate__ = __webpack_require__(468);
/* unused harmony reexport geoInterpolate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_length__ = __webpack_require__(165);
/* unused harmony reexport geoLength */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_path_index__ = __webpack_require__(469);
/* unused harmony reexport geoPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_projection_albers__ = __webpack_require__(167);
/* unused harmony reexport geoAlbers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_projection_albersUsa__ = __webpack_require__(477);
/* unused harmony reexport geoAlbersUsa */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_projection_azimuthalEqualArea__ = __webpack_require__(478);
/* unused harmony reexport geoAzimuthalEqualArea */
/* unused harmony reexport geoAzimuthalEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_projection_azimuthalEquidistant__ = __webpack_require__(479);
/* unused harmony reexport geoAzimuthalEquidistant */
/* unused harmony reexport geoAzimuthalEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_projection_conicConformal__ = __webpack_require__(480);
/* unused harmony reexport geoConicConformal */
/* unused harmony reexport geoConicConformalRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_projection_conicEqualArea__ = __webpack_require__(88);
/* unused harmony reexport geoConicEqualArea */
/* unused harmony reexport geoConicEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_projection_conicEquidistant__ = __webpack_require__(481);
/* unused harmony reexport geoConicEquidistant */
/* unused harmony reexport geoConicEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_projection_equirectangular__ = __webpack_require__(168);
/* unused harmony reexport geoEquirectangular */
/* unused harmony reexport geoEquirectangularRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_projection_gnomonic__ = __webpack_require__(482);
/* unused harmony reexport geoGnomonic */
/* unused harmony reexport geoGnomonicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_projection_identity__ = __webpack_require__(483);
/* unused harmony reexport geoIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_projection_index__ = __webpack_require__(11);
/* unused harmony reexport geoProjection */
/* unused harmony reexport geoProjectionMutator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_projection_mercator__ = __webpack_require__(91);
/* unused harmony reexport geoMercator */
/* unused harmony reexport geoMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_projection_naturalEarth1__ = __webpack_require__(484);
/* unused harmony reexport geoNaturalEarth1 */
/* unused harmony reexport geoNaturalEarth1Raw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_projection_orthographic__ = __webpack_require__(485);
/* unused harmony reexport geoOrthographic */
/* unused harmony reexport geoOrthographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_projection_stereographic__ = __webpack_require__(486);
/* unused harmony reexport geoStereographic */
/* unused harmony reexport geoStereographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_projection_transverseMercator__ = __webpack_require__(487);
/* unused harmony reexport geoTransverseMercator */
/* unused harmony reexport geoTransverseMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_rotation__ = __webpack_require__(47);
/* unused harmony reexport geoRotation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_stream__ = __webpack_require__(19);
/* unused harmony reexport geoStream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_transform__ = __webpack_require__(49);
/* unused harmony reexport geoTransform */






 // DEPRECATED! Use d3.geoIdentity().clipExtent(…).




























/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stream__ = __webpack_require__(19);






var lambda0, phi0, lambda1, phi1, // bounds
    lambda2, // previous lambda-coordinate
    lambda00, phi00, // first point
    p0, // previous 3D point
    deltaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    ranges,
    range;

var boundsStream = {
  point: boundsPoint,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream.point = boundsRingPoint;
    boundsStream.lineStart = boundsRingStart;
    boundsStream.lineEnd = boundsRingEnd;
    deltaSum.reset();
    __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].polygonStart();
  },
  polygonEnd: function() {
    __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].polygonEnd();
    boundsStream.point = boundsPoint;
    boundsStream.lineStart = boundsLineStart;
    boundsStream.lineEnd = boundsLineEnd;
    if (__WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaRingSum */] < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > __WEBPACK_IMPORTED_MODULE_3__math__["i" /* epsilon */]) phi1 = 90;
    else if (deltaSum < -__WEBPACK_IMPORTED_MODULE_3__math__["i" /* epsilon */]) phi0 = -90;
    range[0] = lambda0, range[1] = lambda1;
  }
};

function boundsPoint(lambda, phi) {
  ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
}

function linePoint(lambda, phi) {
  var p = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["a" /* cartesian */])([lambda * __WEBPACK_IMPORTED_MODULE_3__math__["r" /* radians */], phi * __WEBPACK_IMPORTED_MODULE_3__math__["r" /* radians */]]);
  if (p0) {
    var normal = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["c" /* cartesianCross */])(p0, p),
        equatorial = [normal[1], -normal[0], 0],
        inflection = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["c" /* cartesianCross */])(equatorial, normal);
    Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["e" /* cartesianNormalizeInPlace */])(inflection);
    inflection = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["g" /* spherical */])(inflection);
    var delta = lambda - lambda2,
        sign = delta > 0 ? 1 : -1,
        lambdai = inflection[0] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */] * sign,
        phii,
        antimeridian = Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" /* abs */])(delta) > 180;
    if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */];
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = -inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */];
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi < phi0) phi0 = phi;
      if (phi > phi1) phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
      }
    } else {
      if (lambda1 >= lambda0) {
        if (lambda < lambda0) lambda0 = lambda;
        if (lambda > lambda1) lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  }
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
  p0 = p, lambda2 = lambda;
}

function boundsLineStart() {
  boundsStream.point = linePoint;
}

function boundsLineEnd() {
  range[0] = lambda0, range[1] = lambda1;
  boundsStream.point = boundsPoint;
  p0 = null;
}

function boundsRingPoint(lambda, phi) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" /* abs */])(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda00 = lambda, phi00 = phi;
  }
  __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].point(lambda, phi);
  linePoint(lambda, phi);
}

function boundsRingStart() {
  __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].lineStart();
}

function boundsRingEnd() {
  boundsRingPoint(lambda00, phi00);
  __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].lineEnd();
  if (Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" /* abs */])(deltaSum) > __WEBPACK_IMPORTED_MODULE_3__math__["i" /* epsilon */]) lambda0 = -(lambda1 = 180);
  range[0] = lambda0, range[1] = lambda1;
  p0 = null;
}

// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}

function rangeCompare(a, b) {
  return a[0] - b[0];
}

function rangeContains(range, x) {
  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(feature) {
  var i, n, a, b, merged, deltaMax, delta;

  phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
  ranges = [];
  Object(__WEBPACK_IMPORTED_MODULE_4__stream__["a" /* default */])(feature, boundsStream);

  // First, sort ranges by their minimum longitudes.
  if (n = ranges.length) {
    ranges.sort(rangeCompare);

    // Then, merge any ranges that overlap.
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }

    // Finally, find the largest gap between the merged ranges.
    // The final bounding box will be the inverse of this gap.
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
    }
  }

  ranges = range = null;

  return lambda0 === Infinity || phi0 === Infinity
      ? [[NaN, NaN], [NaN, NaN]]
      : [[lambda0, phi0], [lambda1, phi1]];
});


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stream__ = __webpack_require__(19);




var W0, W1,
    X0, Y0, Z0,
    X1, Y1, Z1,
    X2, Y2, Z2,
    lambda00, phi00, // first point
    x0, y0, z0; // previous point

var centroidStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  }
};

// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  centroidPointCartesian(cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda), cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi));
}

function centroidPointCartesian(x, y, z) {
  ++W0;
  X0 += (x - X0) / W0;
  Y0 += (y - Y0) / W0;
  Z0 += (z - Z0) / W0;
}

function centroidLineStart() {
  centroidStream.point = centroidLinePointFirst;
}

function centroidLinePointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  x0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda);
  y0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda);
  z0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi);
  centroidStream.point = centroidLinePoint;
  centroidPointCartesian(x0, y0, z0);
}

function centroidLinePoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi),
      x = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda),
      y = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda),
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi),
      w = Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
  centroidStream.point = centroidRingPointFirst;
}

function centroidRingEnd() {
  centroidRingPoint(lambda00, phi00);
  centroidStream.point = centroidPoint;
}

function centroidRingPointFirst(lambda, phi) {
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  centroidStream.point = centroidRingPoint;
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  x0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda);
  y0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda);
  z0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi);
  centroidPointCartesian(x0, y0, z0);
}

function centroidRingPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi),
      x = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda),
      y = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda),
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi),
      cx = y0 * z - z0 * y,
      cy = z0 * x - x0 * z,
      cz = x0 * y - y0 * x,
      m = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(cx * cx + cy * cy + cz * cz),
      w = Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(m), // line weight = angle
      v = m && -w / m; // area weight multiplier
  X2 += v * cx;
  Y2 += v * cy;
  Z2 += v * cz;
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(object) {
  W0 = W1 =
  X0 = Y0 = Z0 =
  X1 = Y1 = Z1 =
  X2 = Y2 = Z2 = 0;
  Object(__WEBPACK_IMPORTED_MODULE_2__stream__["a" /* default */])(object, centroidStream);

  var x = X2,
      y = Y2,
      z = Z2,
      m = x * x + y * y + z * z;

  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
  if (m < __WEBPACK_IMPORTED_MODULE_0__math__["j" /* epsilon2 */]) {
    x = X1, y = Y1, z = Z1;
    // If the feature has zero length, fall back to arithmetic mean of point vectors.
    if (W1 < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) x = X0, y = Y0, z = Z0;
    m = x * x + y * y + z * z;
    // If the feature still has an undefined ccentroid, then return.
    if (m < __WEBPACK_IMPORTED_MODULE_0__math__["j" /* epsilon2 */]) return [NaN, NaN];
  }

  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(z / Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(m)) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
});


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rectangle__ = __webpack_require__(48);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var x0 = 0,
      y0 = 0,
      x1 = 960,
      y1 = 500,
      cache,
      cacheStream,
      clip;

  return clip = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = Object(__WEBPACK_IMPORTED_MODULE_0__rectangle__["a" /* default */])(x0, y0, x1, y1)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
    }
  };
});


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b, x0, y0, x1, y1) {
  var ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
  return true;
});


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polygonContains__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__distance__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(0);




var containsObjectType = {
  Feature: function(object, point) {
    return containsGeometry(object.geometry, point);
  },
  FeatureCollection: function(object, point) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
    return false;
  }
};

var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object, point) {
    return containsPoint(object.coordinates, point);
  },
  MultiPoint: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
    return false;
  },
  LineString: function(object, point) {
    return containsLine(object.coordinates, point);
  },
  MultiLineString: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsLine(coordinates[i], point)) return true;
    return false;
  },
  Polygon: function(object, point) {
    return containsPolygon(object.coordinates, point);
  },
  MultiPolygon: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
    return false;
  },
  GeometryCollection: function(object, point) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
    return false;
  }
};

function containsGeometry(geometry, point) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
      ? containsGeometryType[geometry.type](geometry, point)
      : false;
}

function containsPoint(coordinates, point) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates, point) === 0;
}

function containsLine(coordinates, point) {
  var ab = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates[0], coordinates[1]),
      ao = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates[0], point),
      ob = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(point, coordinates[1]);
  return ao + ob <= ab + __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];
}

function containsPolygon(coordinates, point) {
  return !!Object(__WEBPACK_IMPORTED_MODULE_0__polygonContains__["a" /* default */])(coordinates.map(ringRadians), pointRadians(point));
}

function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}

function pointRadians(point) {
  return [point[0] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */], point[1] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */]];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(object, point) {
  return (object && containsObjectType.hasOwnProperty(object.type)
      ? containsObjectType[object.type]
      : containsGeometry)(object, point);
});


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export graticule10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);



function graticuleX(y0, y1, dy) {
  var y = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* range */])(y0, y1 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */], dy).concat(y1);
  return function(x) { return y.map(function(y) { return [x, y]; }); };
}

function graticuleY(x0, x1, dx) {
  var x = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* range */])(x0, x1 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */], dx).concat(x1);
  return function(y) { return x.map(function(x) { return [x, y]; }); };
}

function graticule() {
  var x1, x0, X1, X0,
      y1, y0, Y1, Y0,
      dx = 10, dy = dx, DX = 90, DY = 360,
      x, y, X, Y,
      precision = 2.5;

  function graticule() {
    return {type: "MultiLineString", coordinates: lines()};
  }

  function lines() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* range */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(X0 / DX) * DX, X1, DX).map(X)
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* range */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(Y0 / DY) * DY, Y1, DY).map(Y))
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* range */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(x0 / dx) * dx, x1, dx).filter(function(x) { return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(x % DX) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]; }).map(x))
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* range */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(y0 / dy) * dy, y1, dy).filter(function(y) { return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y % DY) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]; }).map(y));
  }

  graticule.lines = function() {
    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
  };

  graticule.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X(X0).concat(
        Y(Y1).slice(1),
        X(X1).reverse().slice(1),
        Y(Y0).reverse().slice(1))
      ]
    };
  };

  graticule.extent = function(_) {
    if (!arguments.length) return graticule.extentMinor();
    return graticule.extentMajor(_).extentMinor(_);
  };

  graticule.extentMajor = function(_) {
    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
    X0 = +_[0][0], X1 = +_[1][0];
    Y0 = +_[0][1], Y1 = +_[1][1];
    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
    return graticule.precision(precision);
  };

  graticule.extentMinor = function(_) {
    if (!arguments.length) return [[x0, y0], [x1, y1]];
    x0 = +_[0][0], x1 = +_[1][0];
    y0 = +_[0][1], y1 = +_[1][1];
    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
    return graticule.precision(precision);
  };

  graticule.step = function(_) {
    if (!arguments.length) return graticule.stepMinor();
    return graticule.stepMajor(_).stepMinor(_);
  };

  graticule.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule;
  };

  graticule.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule;
  };

  graticule.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y0, y1, 90);
    y = graticuleY(x0, x1, precision);
    X = graticuleX(Y0, Y1, 90);
    Y = graticuleY(X0, X1, precision);
    return graticule;
  };

  return graticule
      .extentMajor([[-180, -90 + __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]], [180, 90 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]]])
      .extentMinor([[-180, -80 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]], [180, 80 + __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]]]);
}

function graticule10() {
  return graticule()();
}


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);


/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  var x0 = a[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      y0 = a[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      x1 = b[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      y1 = b[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y0),
      sy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0),
      cy1 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y1),
      sy1 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y1),
      kx0 = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x0),
      ky0 = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x0),
      kx1 = cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x1),
      ky1 = cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x1),
      d = 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* haversin */])(y1 - y0) + cy0 * cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* haversin */])(x1 - x0))),
      k = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(d);

  var interpolate = d ? function(t) {
    var B = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(t *= d) / k,
        A = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(d - t) / k,
        x = A * kx0 + B * kx1,
        y = A * ky0 + B * ky1,
        z = A * sy0 + B * sy1;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */],
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(z, Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + y * y)) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]
    ];
  } : function() {
    return [x0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], y0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
  };

  interpolate.distance = d;

  return interpolate;
});


/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stream__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__area__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bounds__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__centroid__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__measure__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__string__ = __webpack_require__(474);









/* unused harmony default export */ var _unused_webpack_default_export = (function(projection, context) {
  var pointRadius = 4.5,
      projectionStream,
      contextStream;

  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }

  path.area = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_2__area__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_2__area__["a" /* default */].result();
  };

  path.measure = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_6__measure__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_6__measure__["a" /* default */].result();
  };

  path.bounds = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_3__bounds__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_3__bounds__["a" /* default */].result();
  };

  path.centroid = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_4__centroid__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_4__centroid__["a" /* default */].result();
  };

  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection = null, __WEBPACK_IMPORTED_MODULE_0__identity__["a" /* default */]) : (projection = _).stream, path) : projection;
  };

  path.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new __WEBPACK_IMPORTED_MODULE_7__string__["a" /* default */]) : new __WEBPACK_IMPORTED_MODULE_5__context__["a" /* default */](context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };

  path.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };

  return path.projection(projection).context(context);
});


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(15);




var areaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    areaRingSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    x00,
    y00,
    x0,
    y0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: function() {
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    areaStream.lineStart = areaStream.lineEnd = areaStream.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
    areaSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(areaRingSum));
    areaRingSum.reset();
  },
  result: function() {
    var area = areaSum / 2;
    areaSum.reset();
    return area;
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaPointFirst(x, y) {
  areaStream.point = areaPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function areaPoint(x, y) {
  areaRingSum.add(y0 * x - x0 * y);
  x0 = x, y0 = y;
}

function areaRingEnd() {
  areaPoint(x00, y00);
}

/* harmony default export */ __webpack_exports__["a"] = (areaStream);


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);


// TODO Enforce positive area for exterior, negative area for interior?

var X0 = 0,
    Y0 = 0,
    Z0 = 0,
    X1 = 0,
    Y1 = 0,
    Z1 = 0,
    X2 = 0,
    Y2 = 0,
    Z2 = 0,
    x00,
    y00,
    x0,
    y0;

var centroidStream = {
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.point = centroidPoint;
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  },
  result: function() {
    var centroid = Z2 ? [X2 / Z2, Y2 / Z2]
        : Z1 ? [X1 / Z1, Y1 / Z1]
        : Z0 ? [X0 / Z0, Y0 / Z0]
        : [NaN, NaN];
    X0 = Y0 = Z0 =
    X1 = Y1 = Z1 =
    X2 = Y2 = Z2 = 0;
    return centroid;
  }
};

function centroidPoint(x, y) {
  X0 += x;
  Y0 += y;
  ++Z0;
}

function centroidLineStart() {
  centroidStream.point = centroidPointFirstLine;
}

function centroidPointFirstLine(x, y) {
  centroidStream.point = centroidPointLine;
  centroidPoint(x0 = x, y0 = y);
}

function centroidPointLine(x, y) {
  var dx = x - x0, dy = y - y0, z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(dx * dx + dy * dy);
  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;
  centroidPoint(x0 = x, y0 = y);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

function centroidRingStart() {
  centroidStream.point = centroidPointFirstRing;
}

function centroidRingEnd() {
  centroidPointRing(x00, y00);
}

function centroidPointFirstRing(x, y) {
  centroidStream.point = centroidPointRing;
  centroidPoint(x00 = x0 = x, y00 = y0 = y);
}

function centroidPointRing(x, y) {
  var dx = x - x0,
      dy = y - y0,
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(dx * dx + dy * dy);

  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;

  z = y0 * x - x0 * y;
  X2 += z * (x0 + x);
  Y2 += z * (y0 + y);
  Z2 += z * 3;
  centroidPoint(x0 = x, y0 = y);
}

/* harmony default export */ __webpack_exports__["a"] = (centroidStream);


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PathContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(15);



function PathContext(context) {
  this._context = context;
}

PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, __WEBPACK_IMPORTED_MODULE_0__math__["w" /* tau */]);
        break;
      }
    }
  },
  result: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */]
};


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(15);




var lengthSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lengthRing,
    x00,
    y00,
    x0,
    y0;

var lengthStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: function() {
    lengthStream.point = lengthPointFirst;
  },
  lineEnd: function() {
    if (lengthRing) lengthPoint(x00, y00);
    lengthStream.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length = +lengthSum;
    lengthSum.reset();
    return length;
  }
};

function lengthPointFirst(x, y) {
  lengthStream.point = lengthPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function lengthPoint(x, y) {
  x0 -= x, y0 -= y;
  lengthSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* sqrt */])(x0 * x0 + y0 * y0));
  x0 = x, y0 = y;
}

/* harmony default export */ __webpack_exports__["a"] = (lengthStream);


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PathString;
function PathString() {
  this._string = [];
}

PathString.prototype = {
  _radius: 4.5,
  _circle: circle(4.5),
  pointRadius: function(_) {
    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        if (this._circle == null) this._circle = circle(this._radius);
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};

function circle(radius) {
  return "m0," + radius
      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
      + "z";
}


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__(49);




var maxDepth = 16, // maximum depth of subdivision
    cosMinDistance = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(30 * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */]); // cos(minimum angular distance)

/* harmony default export */ __webpack_exports__["a"] = (function(project, delta2) {
  return +delta2 ? resample(project, delta2) : resampleNone(project);
});

function resampleNone(project) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__transform__["a" /* transformer */])({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}

function resample(project, delta2) {

  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
        dy = y1 - y0,
        d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
          b = b0 + b1,
          c = c0 + c1,
          m = Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* sqrt */])(a * a + b * b + c * c),
          phi2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* asin */])(c /= m),
          lambda2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(c) - 1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */] || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda0 - lambda1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */] ? (lambda0 + lambda1) / 2 : Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(b, a),
          p = project(lambda2, phi2),
          x2 = p[0],
          y2 = p[1],
          dx2 = x2 - x0,
          dy2 = y2 - y0,
          dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 // perpendicular projected distance
          || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda00, x00, y00, a00, b00, c00, // first point
        lambda0, x0, y0, a0, b0, c0; // previous point

    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
    };

    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }

    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }

    function linePoint(lambda, phi) {
      var c = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])([lambda, phi]), p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }

    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }

    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }

    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }

    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }

    return resampleStream;
  };
}


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cylindricalEqualAreaRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);


function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(y * cosPhi0)];
  };

  return forward;
}


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__albers__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conicEqualArea__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fit__ = __webpack_require__(90);





// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
  };
}

// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var cache,
      cacheStream,
      lower48 = Object(__WEBPACK_IMPORTED_MODULE_1__albers__["a" /* default */])(), lower48Point,
      alaska = Object(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea__["a" /* default */])().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
      hawaii = Object(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea__["a" /* default */])().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
      point, pointStream = {point: function(x, y) { point = [x, y]; }};

  function albersUsa(coordinates) {
    var x = coordinates[0], y = coordinates[1];
    return point = null,
        (lower48Point.point(x, y), point)
        || (alaskaPoint.point(x, y), point)
        || (hawaiiPoint.point(x, y), point);
  }

  albersUsa.invert = function(coordinates) {
    var k = lower48.scale(),
        t = lower48.translate(),
        x = (coordinates[0] - t[0]) / k,
        y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : lower48).invert(coordinates);
  };

  albersUsa.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };

  albersUsa.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };

  albersUsa.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };

  albersUsa.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];

    lower48Point = lower48
        .translate(_)
        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
        .stream(pointStream);

    alaskaPoint = alaska
        .translate([x - 0.307 * k, y + 0.201 * k])
        .clipExtent([[x - 0.425 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.120 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]], [x - 0.214 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]]])
        .stream(pointStream);

    hawaiiPoint = hawaii
        .translate([x - 0.205 * k, y + 0.212 * k])
        .clipExtent([[x - 0.214 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.166 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]], [x - 0.115 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]]])
        .stream(pointStream);

    return reset();
  };

  albersUsa.fitExtent = function(extent, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["a" /* fitExtent */])(albersUsa, extent, object);
  };

  albersUsa.fitSize = function(size, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["c" /* fitSize */])(albersUsa, size, object);
  };

  albersUsa.fitWidth = function(width, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["d" /* fitWidth */])(albersUsa, width, object);
  };

  albersUsa.fitHeight = function(height, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["b" /* fitHeight */])(albersUsa, height, object);
  };

  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }

  return albersUsa.scale(1070);
});


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export azimuthalEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(11);




var azimuthalEqualAreaRaw = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["b" /* azimuthalRaw */])(function(cxcy) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(2 / (1 + cxcy));
});

azimuthalEqualAreaRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(z / 2);
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(azimuthalEqualAreaRaw)
      .scale(124.75)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export azimuthalEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(11);




var azimuthalEquidistantRaw = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["b" /* azimuthalRaw */])(function(c) {
  return (c = Object(__WEBPACK_IMPORTED_MODULE_0__math__["b" /* acos */])(c)) && c / Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(c);
});

azimuthalEquidistantRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return z;
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(azimuthalEquidistantRaw)
      .scale(79.4188)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicConformalRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mercator__ = __webpack_require__(91);




function tany(y) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + y) / 2);
}

function conicConformalRaw(y0, y1) {
  var cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y0),
      n = y0 === y1 ? Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0) : Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(cy0 / Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y1)) / Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(tany(y1) / tany(y0)),
      f = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" /* pow */])(tany(y0), n) / n;

  if (!n) return __WEBPACK_IMPORTED_MODULE_2__mercator__["b" /* mercatorRaw */];

  function project(x, y) {
    if (f > 0) { if (y < -__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) y = -__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]; }
    else { if (y > __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) y = __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]; }
    var r = f / Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" /* pow */])(tany(y), n);
    return [r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(n * x), f - r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(n * x)];
  }

  project.invert = function(x, y) {
    var fy = f - y, r = Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(n) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + fy * fy);
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(fy)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(fy), 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" /* pow */])(f / r, 1 / n)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */]];
  };

  return project;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicConformalRaw)
      .scale(109.5)
      .parallels([30, 30]);
});


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equirectangular__ = __webpack_require__(168);




function conicEquidistantRaw(y0, y1) {
  var cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y0),
      n = y0 === y1 ? Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0) : (cy0 - Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y1)) / (y1 - y0),
      g = cy0 / n + y0;

  if (Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(n) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) return __WEBPACK_IMPORTED_MODULE_2__equirectangular__["a" /* equirectangularRaw */];

  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(nx), g - gy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(nx)];
  }

  project.invert = function(x, y) {
    var gy = g - y;
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(gy)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(gy), g - Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(n) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + gy * gy)];
  };

  return project;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicEquidistantRaw)
      .scale(131.154)
      .center([0, 13.9389]);
});


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gnomonicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(11);




function gnomonicRaw(x, y) {
  var cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y), k = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x) * cy;
  return [cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x) / k, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y) / k];
}

gnomonicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */]);

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(gnomonicRaw)
      .scale(144.049)
      .clipAngle(60);
});


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clip_rectangle__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fit__ = __webpack_require__(90);





function scaleTranslate(kx, ky, tx, ty) {
  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */] : Object(__WEBPACK_IMPORTED_MODULE_2__transform__["a" /* transformer */])({
    point: function(x, y) {
      this.stream.point(x * kx + tx, y * ky + ty);
    }
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */], // scale, translate and reflect
      x0 = null, y0, x1, y1, // clip extent
      postclip = __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */],
      cache,
      cacheStream,
      projection;

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return projection = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
    },
    postclip: function(_) {
      return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    },
    clipExtent: function(_) {
      return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */]) : Object(__WEBPACK_IMPORTED_MODULE_0__clip_rectangle__["a" /* default */])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
    },
    scale: function(_) {
      return arguments.length ? (transform = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
    },
    translate: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
    },
    reflectX: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
    },
    reflectY: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
    },
    fitExtent: function(extent, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["a" /* fitExtent */])(projection, extent, object);
    },
    fitSize: function(size, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["c" /* fitSize */])(projection, size, object);
    },
    fitWidth: function(width, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["d" /* fitWidth */])(projection, width, object);
    },
    fitHeight: function(height, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["b" /* fitHeight */])(projection, height, object);
    }
  };
});


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export naturalEarth1Raw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);



function naturalEarth1Raw(lambda, phi) {
  var phi2 = phi * phi, phi4 = phi2 * phi2;
  return [
    lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
    phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
  ];
}

naturalEarth1Raw.invert = function(x, y) {
  var phi = y, i = 25, delta;
  do {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) /
        (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 0.005916 * 11 * phi4)));
  } while (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */] && --i > 0);
  return [
    x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
    phi
  ];
};

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(naturalEarth1Raw)
      .scale(175.295);
});


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export orthographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(11);




function orthographicRaw(x, y) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y)];
}

orthographicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */]);

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(orthographicRaw)
      .scale(249.5)
      .clipAngle(90 + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]);
});


/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stereographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(11);




function stereographicRaw(x, y) {
  var cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y), k = 1 + Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x) * cy;
  return [cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x) / k, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y) / k];
}

stereographicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(z);
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(stereographicRaw)
      .scale(250)
      .clipAngle(142);
});


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export transverseMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mercator__ = __webpack_require__(91);



function transverseMercatorRaw(lambda, phi) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + phi) / 2)), -lambda];
}

transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["k" /* exp */])(x)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */]];
};

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var m = Object(__WEBPACK_IMPORTED_MODULE_1__mercator__["a" /* mercatorProjection */])(transverseMercatorRaw),
      center = m.center,
      rotate = m.rotate;

  m.center = function(_) {
    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
  };

  m.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };

  return rotate([0, 0, 90])
      .scale(159.155);
});


/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_cluster__ = __webpack_require__(489);
/* unused harmony reexport cluster */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_hierarchy_index__ = __webpack_require__(92);
/* unused harmony reexport hierarchy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_pack_index__ = __webpack_require__(501);
/* unused harmony reexport pack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pack_siblings__ = __webpack_require__(169);
/* unused harmony reexport packSiblings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_pack_enclose__ = __webpack_require__(170);
/* unused harmony reexport packEnclose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_partition__ = __webpack_require__(503);
/* unused harmony reexport partition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_stratify__ = __webpack_require__(504);
/* unused harmony reexport stratify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_tree__ = __webpack_require__(505);
/* unused harmony reexport tree */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_treemap_index__ = __webpack_require__(506);
/* unused harmony reexport treemap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_treemap_binary__ = __webpack_require__(507);
/* unused harmony reexport treemapBinary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_treemap_dice__ = __webpack_require__(32);
/* unused harmony reexport treemapDice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_treemap_slice__ = __webpack_require__(50);
/* unused harmony reexport treemapSlice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_treemap_sliceDice__ = __webpack_require__(508);
/* unused harmony reexport treemapSliceDice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_treemap_squarify__ = __webpack_require__(94);
/* unused harmony reexport treemapSquarify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_treemap_resquarify__ = __webpack_require__(509);
/* unused harmony reexport treemapResquarify */

















/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}

function meanXReduce(x, c) {
  return x + c.x;
}

function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}

function maxYReduce(y, c) {
  return Math.max(y, c.y);
}

function leafLeft(node) {
  var children;
  while (children = node.children) node = children[0];
  return node;
}

function leafRight(node) {
  var children;
  while (children = node.children) node = children[children.length - 1];
  return node;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = false;

  function cluster(root) {
    var previousNode,
        x = 0;

    // First walk, computing the initial x & y values.
    root.eachAfter(function(node) {
      var children = node.children;
      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });

    var left = leafLeft(root),
        right = leafRight(root),
        x0 = left.x - separation(left, right) / 2,
        x1 = right.x + separation(right, left) / 2;

    // Second walk, normalizing x & y to the desired size.
    return root.eachAfter(nodeSize ? function(node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function(node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }

  cluster.separation = function(x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };

  cluster.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
  };

  cluster.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
  };

  return cluster;
});


/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;
  else while (--i >= 0) sum += children[i].value;
  node.value = sum;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.eachAfter(count);
});


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, current, next = [node], children, i, n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      callback(node), children = node.children;
      if (children) for (i = 0, n = children.length; i < n; ++i) {
        next.push(children[i]);
      }
    }
  } while (next.length);
  return this;
});


/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, nodes = [node], children, i;
  while (node = nodes.pop()) {
    callback(node), children = node.children;
    if (children) for (i = children.length - 1; i >= 0; --i) {
      nodes.push(children[i]);
    }
  }
  return this;
});


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, nodes = [node], next = [], children, i, n;
  while (node = nodes.pop()) {
    next.push(node), children = node.children;
    if (children) for (i = 0, n = children.length; i < n; ++i) {
      nodes.push(children[i]);
    }
  }
  while (node = next.pop()) {
    callback(node);
  }
  return this;
});


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;
    while (--i >= 0) sum += children[i].value;
    node.value = sum;
  });
});


/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
});


/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(end) {
  var start = this,
      ancestor = leastCommonAncestor(start, end),
      nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
});

function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
      bNodes = b.ancestors(),
      c = null;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}


/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
});


/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
});


/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
});


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var root = this, links = [];
  root.each(function(node) {
    if (node !== root) { // Don’t include the root’s parent, if any.
      links.push({source: node.parent, target: node});
    }
  });
  return links;
});


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__siblings__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessors__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(171);




function defaultRadius(d) {
  return Math.sqrt(d.value);
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var radius = null,
      dx = 1,
      dy = 1,
      padding = __WEBPACK_IMPORTED_MODULE_2__constant__["a" /* constantZero */];

  function pack(root) {
    root.x = dx / 2, root.y = dy / 2;
    if (radius) {
      root.eachBefore(radiusLeaf(radius))
          .eachAfter(packChildren(padding, 0.5))
          .eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius))
          .eachAfter(packChildren(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* constantZero */], 1))
          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }
    return root;
  }

  pack.radius = function(x) {
    return arguments.length ? (radius = Object(__WEBPACK_IMPORTED_MODULE_1__accessors__["a" /* optional */])(x), pack) : radius;
  };

  pack.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };

  pack.padding = function(x) {
    return arguments.length ? (padding = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["b" /* default */])(+x), pack) : padding;
  };

  return pack;
});

function radiusLeaf(radius) {
  return function(node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}

function packChildren(padding, k) {
  return function(node) {
    if (children = node.children) {
      var children,
          i,
          n = children.length,
          r = padding(node) * k || 0,
          e;

      if (r) for (i = 0; i < n; ++i) children[i].r += r;
      e = Object(__WEBPACK_IMPORTED_MODULE_0__siblings__["a" /* packEnclose */])(children);
      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
      node.r = e + r;
    }
  };
}

function translateChild(k) {
  return function(node) {
    var parent = node.parent;
    node.r *= k;
    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}


/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (immutable) */ __webpack_exports__["a"] = shuffle;
var slice = Array.prototype.slice;

function shuffle(array) {
  var m = array.length,
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}


/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__treemap_round__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__treemap_dice__ = __webpack_require__(32);



/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var dx = 1,
      dy = 1,
      padding = 0,
      round = false;

  function partition(root) {
    var n = root.height + 1;
    root.x0 =
    root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__treemap_round__["a" /* default */]);
    return root;
  }

  function positionNode(dy, n) {
    return function(node) {
      if (node.children) {
        Object(__WEBPACK_IMPORTED_MODULE_1__treemap_dice__["a" /* default */])(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }
      var x0 = node.x0,
          y0 = node.y0,
          x1 = node.x1 - padding,
          y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }

  partition.round = function(x) {
    return arguments.length ? (round = !!x, partition) : round;
  };

  partition.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };

  partition.padding = function(x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };

  return partition;
});


/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessors__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__ = __webpack_require__(92);



var keyPrefix = "$", // Protect against keys like “__proto__”.
    preroot = {depth: -1},
    ambiguous = {};

function defaultId(d) {
  return d.id;
}

function defaultParentId(d) {
  return d.parentId;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var id = defaultId,
      parentId = defaultParentId;

  function stratify(data) {
    var d,
        i,
        n = data.length,
        root,
        parent,
        node,
        nodes = new Array(n),
        nodeId,
        nodeKey,
        nodeByKey = {};

    for (i = 0; i < n; ++i) {
      d = data[i], node = nodes[i] = new __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["a" /* Node */](d);
      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
        nodeKey = keyPrefix + (node.id = nodeId);
        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
      }
    }

    for (i = 0; i < n; ++i) {
      node = nodes[i], nodeId = parentId(data[i], i, data);
      if (nodeId == null || !(nodeId += "")) {
        if (root) throw new Error("multiple roots");
        root = node;
      } else {
        parent = nodeByKey[keyPrefix + nodeId];
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      }
    }

    if (!root) throw new Error("no root");
    root.parent = preroot;
    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(__WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["b" /* computeHeight */]);
    root.parent = null;
    if (n > 0) throw new Error("cycle");

    return root;
  }

  stratify.id = function(x) {
    return arguments.length ? (id = Object(__WEBPACK_IMPORTED_MODULE_0__accessors__["b" /* required */])(x), stratify) : id;
  };

  stratify.parentId = function(x) {
    return arguments.length ? (parentId = Object(__WEBPACK_IMPORTED_MODULE_0__accessors__["b" /* required */])(x), stratify) : parentId;
  };

  return stratify;
});


/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hierarchy_index__ = __webpack_require__(92);


function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }

// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
}

// This function works analogously to nextLeft.
function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
}

// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}

// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
  var shift = 0,
      change = 0,
      children = v.children,
      i = children.length,
      w;
  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}

// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}

function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor
  this.a = this; // ancestor
  this.z = 0; // prelim
  this.m = 0; // mod
  this.c = 0; // change
  this.s = 0; // shift
  this.t = null; // thread
  this.i = i; // number
}

TreeNode.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__hierarchy_index__["a" /* Node */].prototype);

function treeRoot(root) {
  var tree = new TreeNode(root, 0),
      node,
      nodes = [tree],
      child,
      children,
      i,
      n;

  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }

  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}

// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = null;

  function tree(root) {
    var t = treeRoot(root);

    // Compute the layout using Buchheim et al.’s algorithm.
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);

    // If a fixed node size is specified, scale x and y.
    if (nodeSize) root.eachBefore(sizeNode);

    // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
      var left = root,
          right = root,
          bottom = root;
      root.eachBefore(function(node) {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
        if (node.depth > bottom.depth) bottom = node;
      });
      var s = left === right ? 1 : separation(left, right) / 2,
          tx = s - left.x,
          kx = dx / (right.x + s + tx),
          ky = dy / (bottom.depth || 1);
      root.eachBefore(function(node) {
        node.x = (node.x + tx) * kx;
        node.y = node.depth * ky;
      });
    }

    return root;
  }

  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.
  function firstWalk(v) {
    var children = v.children,
        siblings = v.parent.children,
        w = v.i ? siblings[v.i - 1] : null;
    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }
    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  }

  // Computes all real x-coordinates by summing up the modifiers recursively.
  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  }

  // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).
  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
          vop = v,
          vim = w,
          vom = vip.parent.children[0],
          sip = vip.m,
          sop = vop.m,
          sim = vim.m,
          som = vom.m,
          shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }
    return ancestor;
  }

  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }

  tree.separation = function(x) {
    return arguments.length ? (separation = x, tree) : separation;
  };

  tree.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
  };

  tree.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
  };

  return tree;
});


/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__round__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__squarify__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accessors__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(171);





/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var tile = __WEBPACK_IMPORTED_MODULE_1__squarify__["a" /* default */],
      round = false,
      dx = 1,
      dy = 1,
      paddingStack = [0],
      paddingInner = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingTop = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingRight = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingBottom = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingLeft = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */];

  function treemap(root) {
    root.x0 =
    root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__round__["a" /* default */]);
    return root;
  }

  function positionNode(node) {
    var p = paddingStack[node.depth],
        x0 = node.x0 + p,
        y0 = node.y0 + p,
        x1 = node.x1 - p,
        y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }

  treemap.round = function(x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };

  treemap.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };

  treemap.tile = function(x) {
    return arguments.length ? (tile = Object(__WEBPACK_IMPORTED_MODULE_2__accessors__["b" /* required */])(x), treemap) : tile;
  };

  treemap.padding = function(x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };

  treemap.paddingInner = function(x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingInner;
  };

  treemap.paddingOuter = function(x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };

  treemap.paddingTop = function(x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingTop;
  };

  treemap.paddingRight = function(x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingRight;
  };

  treemap.paddingBottom = function(x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingBottom;
  };

  treemap.paddingLeft = function(x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingLeft;
  };

  return treemap;
});


/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i, n = nodes.length,
      sum, sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = (value / 2) + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;
      else hi = mid;
    }

    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;

    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if ((x1 - x0) > (y1 - y0)) {
      var xk = (x0 * valueRight + x1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = (y0 * valueRight + y1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
});


/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(50);



/* unused harmony default export */ var _unused_webpack_default_export = (function(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? __WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(parent, x0, y0, x1, y1);
});


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__squarify__ = __webpack_require__(94);




/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(ratio) {

  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
        if (row.dice) Object(__WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
        else Object(__WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */])(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = Object(__WEBPACK_IMPORTED_MODULE_2__squarify__["c" /* squarifyRatio */])(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
})(__WEBPACK_IMPORTED_MODULE_2__squarify__["b" /* phi */]));


/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_area__ = __webpack_require__(511);
/* unused harmony reexport polygonArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_centroid__ = __webpack_require__(512);
/* unused harmony reexport polygonCentroid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_hull__ = __webpack_require__(513);
/* unused harmony reexport polygonHull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_contains__ = __webpack_require__(515);
/* unused harmony reexport polygonContains */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_length__ = __webpack_require__(516);
/* unused harmony reexport polygonLength */







/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(polygon) {
  var i = -1,
      n = polygon.length,
      a,
      b = polygon[n - 1],
      area = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    area += a[1] * b[0] - a[0] * b[1];
  }

  return area / 2;
});


/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(polygon) {
  var i = -1,
      n = polygon.length,
      x = 0,
      y = 0,
      a,
      b = polygon[n - 1],
      c,
      k = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    k += c = a[0] * b[1] - b[0] * a[1];
    x += (a[0] + b[0]) * c;
    y += (a[1] + b[1]) * c;
  }

  return k *= 3, [x / k, y / k];
});


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cross__ = __webpack_require__(514);


function lexicographicOrder(a, b) {
  return a[0] - b[0] || a[1] - b[1];
}

// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function computeUpperHullIndexes(points) {
  var n = points.length,
      indexes = [0, 1],
      size = 2;

  for (var i = 2; i < n; ++i) {
    while (size > 1 && Object(__WEBPACK_IMPORTED_MODULE_0__cross__["a" /* default */])(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0) --size;
    indexes[size++] = i;
  }

  return indexes.slice(0, size); // remove popped points
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(points) {
  if ((n = points.length) < 3) return null;

  var i,
      n,
      sortedPoints = new Array(n),
      flippedPoints = new Array(n);

  for (i = 0; i < n; ++i) sortedPoints[i] = [+points[i][0], +points[i][1], i];
  sortedPoints.sort(lexicographicOrder);
  for (i = 0; i < n; ++i) flippedPoints[i] = [sortedPoints[i][0], -sortedPoints[i][1]];

  var upperIndexes = computeUpperHullIndexes(sortedPoints),
      lowerIndexes = computeUpperHullIndexes(flippedPoints);

  // Construct the hull polygon, removing possible duplicate endpoints.
  var skipLeft = lowerIndexes[0] === upperIndexes[0],
      skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1],
      hull = [];

  // Add upper hull in right-to-l order.
  // Then add lower hull in left-to-right order.
  for (i = upperIndexes.length - 1; i >= 0; --i) hull.push(points[sortedPoints[upperIndexes[i]][2]]);
  for (i = +skipLeft; i < lowerIndexes.length - skipRight; ++i) hull.push(points[sortedPoints[lowerIndexes[i]][2]]);

  return hull;
});


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
});


/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(polygon, point) {
  var n = polygon.length,
      p = polygon[n - 1],
      x = point[0], y = point[1],
      x0 = p[0], y0 = p[1],
      x1, y1,
      inside = false;

  for (var i = 0; i < n; ++i) {
    p = polygon[i], x1 = p[0], y1 = p[1];
    if (((y1 > y) !== (y0 > y)) && (x < (x0 - x1) * (y - y1) / (y0 - y1) + x1)) inside = !inside;
    x0 = x1, y0 = y1;
  }

  return inside;
});


/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(polygon) {
  var i = -1,
      n = polygon.length,
      b = polygon[n - 1],
      xa,
      ya,
      xb = b[0],
      yb = b[1],
      perimeter = 0;

  while (++i < n) {
    xa = xb;
    ya = yb;
    b = polygon[i];
    xb = b[0];
    yb = b[1];
    xa -= xb;
    ya -= yb;
    perimeter += Math.sqrt(xa * xa + ya * ya);
  }

  return perimeter;
});


/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_queue__ = __webpack_require__(518);
/* unused harmony reexport queue */



/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(519);


var noabort = {};

function Queue(size) {
  this._size = size;
  this._call =
  this._error = null;
  this._tasks = [];
  this._data = [];
  this._waiting =
  this._active =
  this._ended =
  this._start = 0; // inside a synchronous task callback?
}

Queue.prototype = queue.prototype = {
  constructor: Queue,
  defer: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("defer after await");
    if (this._error != null) return this;
    var t = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(arguments, 1);
    t.push(callback);
    ++this._waiting, this._tasks.push(t);
    poke(this);
    return this;
  },
  abort: function() {
    if (this._error == null) abort(this, new Error("abort"));
    return this;
  },
  await: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    this._call = function(error, results) { callback.apply(null, [error].concat(results)); };
    maybeNotify(this);
    return this;
  },
  awaitAll: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    this._call = callback;
    maybeNotify(this);
    return this;
  }
};

function poke(q) {
  if (!q._start) {
    try { start(q); } // let the current task complete
    catch (e) {
      if (q._tasks[q._ended + q._active - 1]) abort(q, e); // task errored synchronously
      else if (!q._data) throw e; // await callback errored synchronously
    }
  }
}

function start(q) {
  while (q._start = q._waiting && q._active < q._size) {
    var i = q._ended + q._active,
        t = q._tasks[i],
        j = t.length - 1,
        c = t[j];
    t[j] = end(q, i);
    --q._waiting, ++q._active;
    t = c.apply(null, t);
    if (!q._tasks[i]) continue; // task finished synchronously
    q._tasks[i] = t || noabort;
  }
}

function end(q, i) {
  return function(e, r) {
    if (!q._tasks[i]) return; // ignore multiple callbacks
    --q._active, ++q._ended;
    q._tasks[i] = null;
    if (q._error != null) return; // ignore secondary errors
    if (e != null) {
      abort(q, e);
    } else {
      q._data[i] = r;
      if (q._waiting) poke(q);
      else maybeNotify(q);
    }
  };
}

function abort(q, e) {
  var i = q._tasks.length, t;
  q._error = e; // ignore active callbacks
  q._data = undefined; // allow gc
  q._waiting = NaN; // prevent starting

  while (--i >= 0) {
    if (t = q._tasks[i]) {
      q._tasks[i] = null;
      if (t.abort) {
        try { t.abort(); }
        catch (e) { /* ignore */ }
      }
    }
  }

  q._active = NaN; // allow notification
  maybeNotify(q);
}

function maybeNotify(q) {
  if (!q._active && q._call) {
    var d = q._data;
    q._data = undefined; // allow gc
    q._call(q._error, d);
  }
}

function queue(concurrency) {
  if (concurrency == null) concurrency = Infinity;
  else if (!((concurrency = +concurrency) >= 1)) throw new Error("invalid concurrency");
  return new Queue(concurrency);
}


/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = [].slice;


/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_uniform__ = __webpack_require__(521);
/* unused harmony reexport randomUniform */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_normal__ = __webpack_require__(173);
/* unused harmony reexport randomNormal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_logNormal__ = __webpack_require__(522);
/* unused harmony reexport randomLogNormal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_bates__ = __webpack_require__(523);
/* unused harmony reexport randomBates */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_irwinHall__ = __webpack_require__(174);
/* unused harmony reexport randomIrwinHall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_exponential__ = __webpack_require__(524);
/* unused harmony reexport randomExponential */








/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(26);


/* unused harmony default export */ var _unused_webpack_default_export = ((function sourceRandomUniform(source) {
  function randomUniform(min, max) {
    min = min == null ? 0 : +min;
    max = max == null ? 1 : +max;
    if (arguments.length === 1) max = min, min = 0;
    else max -= min;
    return function() {
      return source() * max + min;
    };
  }

  randomUniform.source = sourceRandomUniform;

  return randomUniform;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__normal__ = __webpack_require__(173);



/* unused harmony default export */ var _unused_webpack_default_export = ((function sourceRandomLogNormal(source) {
  function randomLogNormal() {
    var randomNormal = __WEBPACK_IMPORTED_MODULE_1__normal__["a" /* default */].source(source).apply(this, arguments);
    return function() {
      return Math.exp(randomNormal());
    };
  }

  randomLogNormal.source = sourceRandomLogNormal;

  return randomLogNormal;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__irwinHall__ = __webpack_require__(174);



/* unused harmony default export */ var _unused_webpack_default_export = ((function sourceRandomBates(source) {
  function randomBates(n) {
    var randomIrwinHall = __WEBPACK_IMPORTED_MODULE_1__irwinHall__["a" /* default */].source(source)(n);
    return function() {
      return randomIrwinHall() / n;
    };
  }

  randomBates.source = sourceRandomBates;

  return randomBates;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(26);


/* unused harmony default export */ var _unused_webpack_default_export = ((function sourceRandomExponential(source) {
  function randomExponential(lambda) {
    return function() {
      return -Math.log(1 - source()) / lambda;
    };
  }

  randomExponential.source = sourceRandomExponential;

  return randomExponential;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_request__ = __webpack_require__(95);
/* unused harmony reexport request */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_html__ = __webpack_require__(526);
/* unused harmony reexport html */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_json__ = __webpack_require__(527);
/* unused harmony reexport json */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_text__ = __webpack_require__(528);
/* unused harmony reexport text */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_xml__ = __webpack_require__(529);
/* unused harmony reexport xml */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_csv__ = __webpack_require__(530);
/* unused harmony reexport csv */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_tsv__ = __webpack_require__(531);
/* unused harmony reexport tsv */









/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(51);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__type__["a" /* default */])("text/html", function(xhr) {
  return document.createRange().createContextualFragment(xhr.responseText);
}));


/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(51);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__type__["a" /* default */])("application/json", function(xhr) {
  return JSON.parse(xhr.responseText);
}));


/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(51);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__type__["a" /* default */])("text/plain", function(xhr) {
  return xhr.responseText;
}));


/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(51);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__type__["a" /* default */])("application/xml", function(xhr) {
  var xml = xhr.responseXML;
  if (!xml) throw new Error("parse error");
  return xml;
}));


/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dsv__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dsv__ = __webpack_require__(175);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__dsv__["a" /* default */])("text/csv", __WEBPACK_IMPORTED_MODULE_0_d3_dsv__["a" /* csvParse */]));


/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dsv__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dsv__ = __webpack_require__(175);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__dsv__["a" /* default */])("text/tab-separated-values", __WEBPACK_IMPORTED_MODULE_0_d3_dsv__["b" /* tsvParse */]));


/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_band__ = __webpack_require__(533);
/* unused harmony reexport scaleBand */
/* unused harmony reexport scalePoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_identity__ = __webpack_require__(534);
/* unused harmony reexport scaleIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_linear__ = __webpack_require__(33);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_log__ = __webpack_require__(536);
/* unused harmony reexport scaleLog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__ = __webpack_require__(176);
/* unused harmony reexport scaleOrdinal */
/* unused harmony reexport scaleImplicit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pow__ = __webpack_require__(537);
/* unused harmony reexport scalePow */
/* unused harmony reexport scaleSqrt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(538);
/* unused harmony reexport scaleQuantile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_quantize__ = __webpack_require__(539);
/* unused harmony reexport scaleQuantize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold__ = __webpack_require__(540);
/* unused harmony reexport scaleThreshold */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_time__ = __webpack_require__(179);
/* unused harmony reexport scaleTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__ = __webpack_require__(556);
/* unused harmony reexport scaleUtc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_category10__ = __webpack_require__(557);
/* unused harmony reexport schemeCategory10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_category20b__ = __webpack_require__(558);
/* unused harmony reexport schemeCategory20b */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_category20c__ = __webpack_require__(559);
/* unused harmony reexport schemeCategory20c */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_category20__ = __webpack_require__(560);
/* unused harmony reexport schemeCategory20 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(561);
/* unused harmony reexport interpolateCubehelixDefault */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_rainbow__ = __webpack_require__(562);
/* unused harmony reexport interpolateRainbow */
/* unused harmony reexport interpolateWarm */
/* unused harmony reexport interpolateCool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_viridis__ = __webpack_require__(563);
/* unused harmony reexport interpolateViridis */
/* unused harmony reexport interpolateMagma */
/* unused harmony reexport interpolateInferno */
/* unused harmony reexport interpolatePlasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_sequential__ = __webpack_require__(564);
/* unused harmony reexport scaleSequential */







































/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export point */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__(176);



function band() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* range */])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}


/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(177);




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity().domain(domain);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(85);



/* harmony default export */ __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* tickStep */])(start, stop, count == null ? 10 : count),
      precision;
  specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
});


/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(52);






function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(b);
}

function reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["b" /* default */])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* ticks */])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(Object(__WEBPACK_IMPORTED_MODULE_3__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* copy */])(scale, log().base(base));
  };

  return scale;
}


/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export sqrt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(52);




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, pow().exponent(exponent));
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}


/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(20);



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* quantile */])(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* ascending */]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(33);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(20);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export milliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);


var millisecond = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;


/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export seconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(13);



var second = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */];
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ __webpack_exports__["a"] = (second);
var seconds = second.range;


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(13);



var minute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */];
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (minute);
var minutes = minute.range;


/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(13);



var hour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  var offset = date.getTimezoneOffset() * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */] % __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
  if (offset < 0) offset += __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
  date.setTime(Math.floor((+date - offset) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */] + offset);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
}, function(date) {
  return date.getHours();
});

/* harmony default export */ __webpack_exports__["a"] = (hour);
var hours = hour.range;


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export days */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(13);



var day = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationDay */];
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (day);
var days = day.range;


/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return monday; });
/* unused harmony export tuesday */
/* unused harmony export wednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return thursday; });
/* unused harmony export friday */
/* unused harmony export saturday */
/* unused harmony export sundays */
/* unused harmony export mondays */
/* unused harmony export tuesdays */
/* unused harmony export wednesdays */
/* unused harmony export thursdays */
/* unused harmony export fridays */
/* unused harmony export saturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(13);



function weekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export months */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);


var month = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (month);
var months = month.range;


/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export years */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);


var year = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(13);



var utcMinute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */];
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(13);



var utcHour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;


/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(13);



var utcDay = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationDay */];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcMonday; });
/* unused harmony export utcTuesday */
/* unused harmony export utcWednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcThursday; });
/* unused harmony export utcFriday */
/* unused harmony export utcSaturday */
/* unused harmony export utcSundays */
/* unused harmony export utcMondays */
/* unused harmony export utcTuesdays */
/* unused harmony export utcWednesdays */
/* unused harmony export utcThursdays */
/* unused harmony export utcFridays */
/* unused harmony export utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(13);



function utcWeekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);


var utcMonth = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(3);


var utcYear = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale__ = __webpack_require__(98);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__["c" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat__["a" /* isoSpecifier */]);

/* unused harmony default export */ var _unused_webpack_default_export = (parseIso);


/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(53);




/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__time__["a" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["v" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["q" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["u" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["l" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["m" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["o" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["n" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["b" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(34);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));


/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(34);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"));


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(34);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"));


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(34);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"));


/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(7);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(300, 0.5, 0.0), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(-240, 0.5, 1.0)));


/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export warm */
/* unused harmony export cool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(7);



var warm = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(-100, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(80, 1.50, 0.8));

var cool = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(260, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(80, 1.50, 0.8));

var rainbow = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])();

/* unused harmony default export */ var _unused_webpack_default_export = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
});


/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export magma */
/* unused harmony export inferno */
/* unused harmony export plasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(34);


function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));


/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(33);


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_arc__ = __webpack_require__(566);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_arc__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_area__ = __webpack_require__(182);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_area__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_line__ = __webpack_require__(99);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__src_line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pie__ = __webpack_require__(567);
/* unused harmony reexport pie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__ = __webpack_require__(570);
/* unused harmony reexport areaRadial */
/* unused harmony reexport radialArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__ = __webpack_require__(184);
/* unused harmony reexport lineRadial */
/* unused harmony reexport radialLine */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_pointRadial__ = __webpack_require__(185);
/* unused harmony reexport pointRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_link_index__ = __webpack_require__(571);
/* unused harmony reexport linkHorizontal */
/* unused harmony reexport linkVertical */
/* unused harmony reexport linkRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_symbol__ = __webpack_require__(572);
/* unused harmony reexport symbol */
/* unused harmony reexport symbols */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_symbol_circle__ = __webpack_require__(187);
/* unused harmony reexport symbolCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_symbol_cross__ = __webpack_require__(188);
/* unused harmony reexport symbolCross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_symbol_diamond__ = __webpack_require__(189);
/* unused harmony reexport symbolDiamond */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_symbol_square__ = __webpack_require__(191);
/* unused harmony reexport symbolSquare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_symbol_star__ = __webpack_require__(190);
/* unused harmony reexport symbolStar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_symbol_triangle__ = __webpack_require__(192);
/* unused harmony reexport symbolTriangle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_symbol_wye__ = __webpack_require__(193);
/* unused harmony reexport symbolWye */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_curve_basisClosed__ = __webpack_require__(573);
/* unused harmony reexport curveBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_curve_basisOpen__ = __webpack_require__(574);
/* unused harmony reexport curveBasisOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_curve_basis__ = __webpack_require__(56);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_18__src_curve_basis__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_curve_bundle__ = __webpack_require__(575);
/* unused harmony reexport curveBundle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinalClosed__ = __webpack_require__(194);
/* unused harmony reexport curveCardinalClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_curve_cardinalOpen__ = __webpack_require__(195);
/* unused harmony reexport curveCardinalOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_curve_cardinal__ = __webpack_require__(57);
/* unused harmony reexport curveCardinal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRomClosed__ = __webpack_require__(576);
/* unused harmony reexport curveCatmullRomClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_curve_catmullRomOpen__ = __webpack_require__(577);
/* unused harmony reexport curveCatmullRomOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_curve_catmullRom__ = __webpack_require__(101);
/* unused harmony reexport curveCatmullRom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_curve_linearClosed__ = __webpack_require__(578);
/* unused harmony reexport curveLinearClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_curve_linear__ = __webpack_require__(54);
/* unused harmony reexport curveLinear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__ = __webpack_require__(579);
/* unused harmony reexport curveMonotoneX */
/* unused harmony reexport curveMonotoneY */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_curve_natural__ = __webpack_require__(580);
/* unused harmony reexport curveNatural */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_curve_step__ = __webpack_require__(581);
/* unused harmony reexport curveStep */
/* unused harmony reexport curveStepAfter */
/* unused harmony reexport curveStepBefore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_stack__ = __webpack_require__(582);
/* unused harmony reexport stack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_offset_expand__ = __webpack_require__(583);
/* unused harmony reexport stackOffsetExpand */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__src_offset_diverging__ = __webpack_require__(584);
/* unused harmony reexport stackOffsetDiverging */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__src_offset_none__ = __webpack_require__(36);
/* unused harmony reexport stackOffsetNone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__src_offset_silhouette__ = __webpack_require__(585);
/* unused harmony reexport stackOffsetSilhouette */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__src_offset_wiggle__ = __webpack_require__(586);
/* unused harmony reexport stackOffsetWiggle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__src_order_ascending__ = __webpack_require__(102);
/* unused harmony reexport stackOrderAscending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__src_order_descending__ = __webpack_require__(587);
/* unused harmony reexport stackOrderDescending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__src_order_insideOut__ = __webpack_require__(588);
/* unused harmony reexport stackOrderInsideOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__src_order_none__ = __webpack_require__(37);
/* unused harmony reexport stackOrderNone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__src_order_reverse__ = __webpack_require__(589);
/* unused harmony reexport stackOrderReverse */




 // Note: radialArea is deprecated!
 // Note: radialLine is deprecated!









































/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(35);




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* max */])(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" /* halfPi */],
        a1 = endAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" /* halfPi */],
        da = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > __WEBPACK_IMPORTED_MODULE_2__math__["m" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
      context.moveTo(r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a0), r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        context.moveTo(r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a1), r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) && (padRadius ? +padRadius.apply(this, arguments) : Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(r0 * r0 + r1 * r1)),
          rc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        var p0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(rp / r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(ap)),
            p1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(rp / r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(ap));
        if ((da0 -= p0 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a01),
          y01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a01),
          x10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a10),
          y10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a10);

      // Apply rounded corners?
      if (rc > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        var x11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a11),
            y11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a11),
            x00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a00),
            y00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < __WEBPACK_IMPORTED_MODULE_2__math__["j" /* pi */]) {
          var oc = da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */] ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["b" /* acos */])((ax * bx + ay * by) / (Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(ax * ax + ay * ay) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(bx * bx + by * by))) / 2),
              lc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(rc, (r0 - lc) / (kc - 1));
          rc1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) || !(da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - __WEBPACK_IMPORTED_MODULE_2__math__["j" /* pi */] / 2;
    return [Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a) * r, Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descending__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(35);





/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */],
      sortValues = __WEBPACK_IMPORTED_MODULE_1__descending__["a" /* default */],
      sort = null,
      startAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0),
      endAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */]),
      padAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */], Math.max(-__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */], endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : padAngle;
  };

  return pie;
});


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  return d;
});


/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lineRadial__ = __webpack_require__(184);




/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var a = Object(__WEBPACK_IMPORTED_MODULE_1__area__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return a;
});


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export linkHorizontal */
/* unused harmony export linkVertical */
/* unused harmony export linkRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pointRadial__ = __webpack_require__(185);






function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link(curve) {
  var source = linkSource,
      target = linkTarget,
      x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      context = null;

  function link() {
    var buffer, argv = __WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial(context, x0, y0, x1, y1) {
  var p0 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0),
      p1 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0 = (y0 + y1) / 2),
      p2 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y0),
      p3 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link(curveHorizontal);
}

function linkVertical() {
  return link(curveVertical);
}

function linkRadial() {
  var l = link(curveRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export symbols */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_circle__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_cross__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symbol_star__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symbol_square__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__symbol_wye__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant__ = __webpack_require__(21);










var symbols = [
  __WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_2__symbol_cross__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_5__symbol_square__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_4__symbol_star__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_7__symbol_wye__["a" /* default */]
];

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var type = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */]),
      size = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});


/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(56);



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__basis__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new BasisClosed(context);
});


/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(56);


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__basis__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new BasisOpen(context);
});


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(56);


function Bundle(context, beta) {
  this._basis = new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));


/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__catmullRom__ = __webpack_require__(101);




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_2__catmullRom__["a" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__["a" /* CardinalClosed */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__catmullRom__ = __webpack_require__(101);



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_1__catmullRom__["a" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__["a" /* CardinalOpen */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(55);


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new LinearClosed(context);
});


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export monotoneX */
/* unused harmony export monotoneY */
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}


/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new Natural(context);
});


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stepBefore */
/* unused harmony export stepAfter */
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}


/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__offset_none__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_none__ = __webpack_require__(37);





function stackValue(d, key) {
  return d[key];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var keys = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([]),
      order = __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */],
      offset = __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */],
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */] : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */] : _, stack) : offset;
  };

  return stack;
});


/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(36);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = yp;
      }
    }
  }
});


/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(36);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(36);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(102);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(series).reverse();
});


/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(102);



/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(__WEBPACK_IMPORTED_MODULE_1__ascending__["b" /* sum */]),
      order = Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[b] - sums[a]; }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});


/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(37);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).reverse();
});


/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_voronoi__ = __webpack_require__(591);
/* unused harmony reexport voronoi */



/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Diagram__ = __webpack_require__(38);




/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_1__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_1__point__["b" /* y */],
      extent = null;

  function voronoi(data) {
    return new __WEBPACK_IMPORTED_MODULE_2__Diagram__["d" /* default */](data.map(function(d, i) {
      var s = [Math.round(x(d, i, data) / __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]) * __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */], Math.round(y(d, i, data) / __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]) * __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]];
      s.index = i;
      s.data = d;
      return s;
    }), extent);
  }

  voronoi.polygons = function(data) {
    return voronoi(data).polygons();
  };

  voronoi.links = function(data) {
    return voronoi(data).links();
  };

  voronoi.triangles = function(data) {
    return voronoi(data).triangles();
  };

  voronoi.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), voronoi) : x;
  };

  voronoi.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), voronoi) : y;
  };

  voronoi.extent = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
  };

  voronoi.size = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
  };

  return voronoi;
});


/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(d) {
  return d[0];
}

function y(d) {
  return d[1];
}


/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = removeBeach;
/* harmony export (immutable) */ __webpack_exports__["a"] = addBeach;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedBlackTree__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edge__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Diagram__ = __webpack_require__(38);






var beachPool = [];

function Beach() {
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(this);
  this.edge =
  this.site =
  this.circle = null;
}

function createBeach(site) {
  var beach = beachPool.pop() || new Beach;
  beach.site = site;
  return beach;
}

function detachBeach(beach) {
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(beach);
  __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].remove(beach);
  beachPool.push(beach);
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(beach);
}

function removeBeach(beach) {
  var circle = beach.circle,
      x = circle.x,
      y = circle.cy,
      vertex = [x, y],
      previous = beach.P,
      next = beach.N,
      disappearing = [beach];

  detachBeach(beach);

  var lArc = previous;
  while (lArc.circle
      && Math.abs(x - lArc.circle.x) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]
      && Math.abs(y - lArc.circle.cy) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
    previous = lArc.P;
    disappearing.unshift(lArc);
    detachBeach(lArc);
    lArc = previous;
  }

  disappearing.unshift(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);

  var rArc = next;
  while (rArc.circle
      && Math.abs(x - rArc.circle.x) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]
      && Math.abs(y - rArc.circle.cy) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
    next = rArc.N;
    disappearing.push(rArc);
    detachBeach(rArc);
    rArc = next;
  }

  disappearing.push(rArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(rArc);

  var nArcs = disappearing.length,
      iArc;
  for (iArc = 1; iArc < nArcs; ++iArc) {
    rArc = disappearing[iArc];
    lArc = disappearing[iArc - 1];
    Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* setEdgeEnd */])(rArc.edge, lArc.site, rArc.site, vertex);
  }

  lArc = disappearing[0];
  rArc = disappearing[nArcs - 1];
  rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, rArc.site, null, vertex);

  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
}

function addBeach(site) {
  var x = site[0],
      directrix = site[1],
      lArc,
      rArc,
      dxl,
      dxr,
      node = __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */]._;

  while (node) {
    dxl = leftBreakPoint(node, directrix) - x;
    if (dxl > __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) node = node.L; else {
      dxr = x - rightBreakPoint(node, directrix);
      if (dxr > __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
        if (!node.R) {
          lArc = node;
          break;
        }
        node = node.R;
      } else {
        if (dxl > -__WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
          lArc = node.P;
          rArc = node;
        } else if (dxr > -__WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
          lArc = node;
          rArc = node.N;
        } else {
          lArc = rArc = node;
        }
        break;
      }
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["c" /* createCell */])(site);
  var newArc = createBeach(site);
  __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].insert(lArc, newArc);

  if (!lArc && !rArc) return;

  if (lArc === rArc) {
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);
    rArc = createBeach(lArc.site);
    __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].insert(newArc, rArc);
    newArc.edge = rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, newArc.site);
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
    return;
  }

  if (!rArc) { // && lArc
    newArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, newArc.site);
    return;
  }

  // else lArc !== rArc
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(rArc);

  var lSite = lArc.site,
      ax = lSite[0],
      ay = lSite[1],
      bx = site[0] - ax,
      by = site[1] - ay,
      rSite = rArc.site,
      cx = rSite[0] - ax,
      cy = rSite[1] - ay,
      d = 2 * (bx * cy - by * cx),
      hb = bx * bx + by * by,
      hc = cx * cx + cy * cy,
      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];

  Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* setEdgeEnd */])(rArc.edge, lSite, rSite, vertex);
  newArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lSite, site, null, vertex);
  rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(site, rSite, null, vertex);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
}

function leftBreakPoint(arc, directrix) {
  var site = arc.site,
      rfocx = site[0],
      rfocy = site[1],
      pby2 = rfocy - directrix;

  if (!pby2) return rfocx;

  var lArc = arc.P;
  if (!lArc) return -Infinity;

  site = lArc.site;
  var lfocx = site[0],
      lfocy = site[1],
      plby2 = lfocy - directrix;

  if (!plby2) return lfocx;

  var hl = lfocx - rfocx,
      aby2 = 1 / pby2 - 1 / plby2,
      b = hl / plby2;

  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;

  return (rfocx + lfocx) / 2;
}

function rightBreakPoint(arc, directrix) {
  var rArc = arc.N;
  if (rArc) return leftBreakPoint(rArc, directrix);
  var site = arc.site;
  return site[1] === directrix ? site[0] : Infinity;
}


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_zoom__ = __webpack_require__(596);
/* unused harmony reexport zoom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_transform__ = __webpack_require__(198);
/* unused harmony reexport zoomTransform */
/* unused harmony reexport zoomIdentity */




/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_drag__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_selection__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_transition__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constant__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transform__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__noevent__ = __webpack_require__(599);










// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].button;
}

function defaultExtent() {
  var e = this, w, h;
  if (e instanceof SVGElement) {
    e = e.ownerSVGElement || e;
    w = e.width.baseVal.value;
    h = e.height.baseVal.value;
  } else {
    w = e.clientWidth;
    h = e.clientHeight;
  }
  return [[0, 0], [w, h]];
}

function defaultTransform() {
  return this.__zoom || __WEBPACK_IMPORTED_MODULE_7__transform__["b" /* identity */];
}

function defaultWheelDelta() {
  return -__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].deltaY * (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].deltaMode ? 120 : 1) / 500;
}

function defaultTouchable() {
  return "ontouchstart" in this;
}

function defaultConstrain(transform, extent, translateExtent) {
  var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0],
      dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0],
      dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1],
      dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
  return transform.translate(
    dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1),
    dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1)
  );
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var filter = defaultFilter,
      extent = defaultExtent,
      constrain = defaultConstrain,
      wheelDelta = defaultWheelDelta,
      touchable = defaultTouchable,
      scaleExtent = [0, Infinity],
      translateExtent = [[-Infinity, -Infinity], [Infinity, Infinity]],
      duration = 250,
      interpolate = __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__["i" /* interpolateZoom */],
      gestures = [],
      listeners = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "zoom", "end"),
      touchstarting,
      touchending,
      touchDelay = 500,
      wheelDelay = 150,
      clickDistance2 = 0;

  function zoom(selection) {
    selection
        .property("__zoom", defaultTransform)
        .on("wheel.zoom", wheeled)
        .on("mousedown.zoom", mousedowned)
        .on("dblclick.zoom", dblclicked)
      .filter(touchable)
        .on("touchstart.zoom", touchstarted)
        .on("touchmove.zoom", touchmoved)
        .on("touchend.zoom touchcancel.zoom", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  zoom.transform = function(collection, transform) {
    var selection = collection.selection ? collection.selection() : collection;
    selection.property("__zoom", defaultTransform);
    if (collection !== selection) {
      schedule(collection, transform);
    } else {
      selection.interrupt().each(function() {
        gesture(this, arguments)
            .start()
            .zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform)
            .end();
      });
    }
  };

  zoom.scaleBy = function(selection, k) {
    zoom.scaleTo(selection, function() {
      var k0 = this.__zoom.k,
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return k0 * k1;
    });
  };

  zoom.scaleTo = function(selection, k) {
    zoom.transform(selection, function() {
      var e = extent.apply(this, arguments),
          t0 = this.__zoom,
          p0 = centroid(e),
          p1 = t0.invert(p0),
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
    });
  };

  zoom.translateBy = function(selection, x, y) {
    zoom.transform(selection, function() {
      return constrain(this.__zoom.translate(
        typeof x === "function" ? x.apply(this, arguments) : x,
        typeof y === "function" ? y.apply(this, arguments) : y
      ), extent.apply(this, arguments), translateExtent);
    });
  };

  zoom.translateTo = function(selection, x, y) {
    zoom.transform(selection, function() {
      var e = extent.apply(this, arguments),
          t = this.__zoom,
          p = centroid(e);
      return constrain(__WEBPACK_IMPORTED_MODULE_7__transform__["b" /* identity */].translate(p[0], p[1]).scale(t.k).translate(
        typeof x === "function" ? -x.apply(this, arguments) : -x,
        typeof y === "function" ? -y.apply(this, arguments) : -y
      ), e, translateExtent);
    });
  };

  function scale(transform, k) {
    k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
    return k === transform.k ? transform : new __WEBPACK_IMPORTED_MODULE_7__transform__["a" /* Transform */](k, transform.x, transform.y);
  }

  function translate(transform, p0, p1) {
    var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
    return x === transform.x && y === transform.y ? transform : new __WEBPACK_IMPORTED_MODULE_7__transform__["a" /* Transform */](transform.k, x, y);
  }

  function centroid(extent) {
    return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
  }

  function schedule(transition, transform, center) {
    transition
        .on("start.zoom", function() { gesture(this, arguments).start(); })
        .on("interrupt.zoom end.zoom", function() { gesture(this, arguments).end(); })
        .tween("zoom", function() {
          var that = this,
              args = arguments,
              g = gesture(that, args),
              e = extent.apply(that, args),
              p = center || centroid(e),
              w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
              a = that.__zoom,
              b = typeof transform === "function" ? transform.apply(that, args) : transform,
              i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
          return function(t) {
            if (t === 1) t = b; // Avoid rounding error on end.
            else { var l = i(t), k = w / l[2]; t = new __WEBPACK_IMPORTED_MODULE_7__transform__["a" /* Transform */](k, p[0] - l[0] * k, p[1] - l[1] * k); }
            g.zoom(null, t);
          };
        });
  }

  function gesture(that, args) {
    for (var i = 0, n = gestures.length, g; i < n; ++i) {
      if ((g = gestures[i]).that === that) {
        return g;
      }
    }
    return new Gesture(that, args);
  }

  function Gesture(that, args) {
    this.that = that;
    this.args = args;
    this.index = -1;
    this.active = 0;
    this.extent = extent.apply(that, args);
  }

  Gesture.prototype = {
    start: function() {
      if (++this.active === 1) {
        this.index = gestures.push(this) - 1;
        this.emit("start");
      }
      return this;
    },
    zoom: function(key, transform) {
      if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
      if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
      if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
      this.that.__zoom = transform;
      this.emit("zoom");
      return this;
    },
    end: function() {
      if (--this.active === 0) {
        gestures.splice(this.index, 1);
        this.index = -1;
        this.emit("end");
      }
      return this;
    },
    emit: function(type) {
      Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_6__event__["a" /* default */](zoom, type, this.that.__zoom), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function wheeled() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        t = this.__zoom,
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))),
        p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(this);

    // If the mouse is in the same location as before, reuse it.
    // If there were recent wheel events, reset the wheel idle timeout.
    if (g.wheel) {
      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
        g.mouse[1] = t.invert(g.mouse[0] = p);
      }
      clearTimeout(g.wheel);
    }

    // If this wheel event won’t trigger a transform change, ignore it.
    else if (t.k === k) return;

    // Otherwise, capture the mouse point and location at the start.
    else {
      g.mouse = [p, t.invert(p)];
      Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["a" /* interrupt */])(this);
      g.start();
    }

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
    g.wheel = setTimeout(wheelidled, wheelDelay);
    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));

    function wheelidled() {
      g.wheel = null;
      g.end();
    }
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        v = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
        p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(this),
        x0 = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].clientX,
        y0 = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].clientY;

    Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["a" /* dragDisable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view);
    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" /* nopropagation */])();
    g.mouse = [p, this.__zoom.invert(p)];
    Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["a" /* interrupt */])(this);
    g.start();

    function mousemoved() {
      Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
      if (!g.moved) {
        var dx = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].clientX - x0, dy = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].clientY - y0;
        g.moved = dx * dx + dy * dy > clickDistance2;
      }
      g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(g.that), g.mouse[1]), g.extent, translateExtent));
    }

    function mouseupped() {
      v.on("mousemove.zoom mouseup.zoom", null);
      Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["b" /* dragEnable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view, g.moved);
      Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
      g.end();
    }
  }

  function dblclicked() {
    if (!filter.apply(this, arguments)) return;
    var t0 = this.__zoom,
        p0 = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(this),
        p1 = t0.invert(p0),
        k1 = t0.k * (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].shiftKey ? 0.5 : 2),
        t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments), translateExtent);

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
    if (duration > 0) Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["f" /* select */])(this).transition().duration(duration).call(schedule, t1, p0);
    else Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["f" /* select */])(this).call(zoom.transform, t1);
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].changedTouches,
        started,
        n = touches.length, i, t, p;

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" /* nopropagation */])();
    for (i = 0; i < n; ++i) {
      t = touches[i], p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* touch */])(this, touches, t.identifier);
      p = [p, this.__zoom.invert(p), t.identifier];
      if (!g.touch0) g.touch0 = p, started = true;
      else if (!g.touch1) g.touch1 = p;
    }

    // If this is a dbltap, reroute to the (optional) dblclick.zoom handler.
    if (touchstarting) {
      touchstarting = clearTimeout(touchstarting);
      if (!g.touch1) {
        g.end();
        p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["f" /* select */])(this).on("dblclick.zoom");
        if (p) p.apply(this, arguments);
        return;
      }
    }

    if (started) {
      touchstarting = setTimeout(function() { touchstarting = null; }, touchDelay);
      Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["a" /* interrupt */])(this);
      g.start();
    }
  }

  function touchmoved() {
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].changedTouches,
        n = touches.length, i, t, p, l;

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
    if (touchstarting) touchstarting = clearTimeout(touchstarting);
    for (i = 0; i < n; ++i) {
      t = touches[i], p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* touch */])(this, touches, t.identifier);
      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
    }
    t = g.that.__zoom;
    if (g.touch1) {
      var p0 = g.touch0[0], l0 = g.touch0[1],
          p1 = g.touch1[0], l1 = g.touch1[1],
          dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
          dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
      t = scale(t, Math.sqrt(dp / dl));
      p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
    }
    else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
    else return;
    g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
  }

  function touchended() {
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].changedTouches,
        n = touches.length, i, t;

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" /* nopropagation */])();
    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, touchDelay);
    for (i = 0; i < n; ++i) {
      t = touches[i];
      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
    }
    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
    if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
    else g.end();
  }

  zoom.wheelDelta = function(_) {
    return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(+_), zoom) : wheelDelta;
  };

  zoom.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(!!_), zoom) : filter;
  };

  zoom.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(!!_), zoom) : touchable;
  };

  zoom.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
  };

  zoom.scaleExtent = function(_) {
    return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [scaleExtent[0], scaleExtent[1]];
  };

  zoom.translateExtent = function(_) {
    return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [[translateExtent[0][0], translateExtent[0][1]], [translateExtent[1][0], translateExtent[1][1]]];
  };

  zoom.constrain = function(_) {
    return arguments.length ? (constrain = _, zoom) : constrain;
  };

  zoom.duration = function(_) {
    return arguments.length ? (duration = +_, zoom) : duration;
  };

  zoom.interpolate = function(_) {
    return arguments.length ? (interpolate = _, zoom) : interpolate;
  };

  zoom.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? zoom : value;
  };

  zoom.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
  };

  return zoom;
});


/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ZoomEvent;
function ZoomEvent(target, type, transform) {
  this.target = target;
  this.type = type;
  this.transform = transform;
}


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nopropagation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(2);


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
});


/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports = [{"title":"","link":null,"body":"","id":"intro","data":[{"title":"Periodo monitorato","body":"## 1 febbraio\n## 6 giugno"},{"title":"Attività totale","function":"Activity-Total"},{"title":"Attività media al giorno","function":"Activity-Average"},{"title":"Giorno con maggiore attività","body":"## 5 marzo"}],"milestones":[11,21,32]},{"title":"Destra","link":"/#/categoria/destra/","body":"Lo schieramento include tutti quei partiti e movimenti che fanno riferimento all'area neo-post fascista dello schieramento politico, in particolare **CasaPound Italia** e **Forza Nuova** i due partiti di quest'area più attivi sia online che sul piano sociale.\n\nQuesti partiti non si sono presentati alle elezioni come coalizione, né erano presenti in tutte le circoscrizioni: il dato \"**Risultato Elettorale**\" è la somma dei risultati dei partiti **CasaPound Italia**, **Forza Nuova**, e **Fiamma Tricolore**.","id":"destra","data":[{"title":"Attività totale","function":"Activity-Total"},{"title":"Attività media/giorno","function":"Activity-Average"},{"title":"Giorno con maggiore attività","body":"## 21 febbraio"},{"title":"% sull'attività totale","function":"Percentage-Activity"},{"title":"Risultati elettorali","body":"# 1,30%"}],"milestones":[5,14,16]},{"title":"Sinistra","link":"/#/categoria/sinistra/","body":"Abbiamo raccolto in questo schieramento partiti e movimenti che pur non avendo corso assieme condividono un'etica \"*di sinistra*\": **Liberi e Uguali**, **Potere al Popolo**, **Sinistra e Libertà**, **Rifondazione Comunista**, e **Partito Comunista**, oltre ad alcuni movimenti extra-parlamentari spesso definiti \"*antagonisti*\". Il dato \"**Risultato Elettorale**\" è la somma dei risultati dei singoli partiti.","id":"sinistra","data":[{"title":"Attività totale","function":"Activity-Total"},{"title":"Attività media/giorno","function":"Activity-Average"},{"title":"% sull'attività totale","function":"Percentage-Activity"},{"title":"Risultati elettorali","body":"# 5%"}],"milestones":[34,15,16]},{"title":"Centro Sinistra","link":"/#/categoria/centro-sinistra/","body":"Lo schieramento al governo al momento del voto comprende partiti che si sono presentati uniti alle elezioni, condividendo una visione di continuità con il governo Gentiloni. Questa categoria contiene il partito uscito peggio dalle elezioni (il **Partito Democratico** di Matteo Renzi, -6,7% rispetto alle politiche del 2013) oltre ad altre sigle quali ad esempio **+Europa** di Emma Bonino, **Civica Popolare** dell'ex Ministro della Sanità Beatrice Lorenzin, e la **SVP**.","id":"centro-sinistra","data":[{"title":"Attività totale","function":"Activity-Total"},{"title":"Attività media/giorno","function":"Activity-Average"},{"title":"% sull'attività totale","function":"Percentage-Activity"},{"title":"Risultati elettorali","body":"# 22,80%"}],"milestones":[9,33,36]},{"title":"Movimento 5 Stelle","link":"/#/categoria/m5s/","body":"L'unico schieramento monopartitico presente alle elezioni e, a partire dal 5 marzo scorso, primo partito nazionale.\n\nL'attività riguardante il Movimento 5 Stelle è stata molto influenzata non solo dalla sua popolarità presso gli elettori, ma anche da quanto avvenuto nel Comune di Roma (le accuse di abuso d'ufficio mosse dalla procura di Roma alla sindaca Virginia Raggi sono state archiviate in piena campagna elettorale), dall'inusuale decisione di presentare la lista dei ministri prima del voto e, in seguito, dalle difficoltà nel formare un governo.","id":"m5s","data":[{"title":"Attività totale","function":"Activity-Total"},{"title":"Attività media/giorno","function":"Activity-Average"},{"title":"Giorno con maggiore attività","body":"## 17 maggio"},{"title":"% sull'attività totale","function":"Percentage-Activity"},{"title":"Risultati elettorali","body":"# 32,60%"}],"milestones":[7,26,32]},{"title":"Centro Destra","link":"/#/categoria/centro-destra/","body":"Uno schieramento storico, se così si può dire, nello scenario politico italiano: presente in questa forma dall'inizio degli anni 2000 e costituito da **Forza Italia** di Silvio Berlusconi, dalla **Lega** di Matteo Salvini, da **Fratelli d'Italia** guidato da Giorgia Meloni e dall'UDC.\n\nI risultati elettorali hanno mostrato come i rapporti di forza all'interno dello schieramento siano cambiati, con la Lega divenuta primo partito dello schieramento (e terzo partito a livello nazionale, +13,4%) e Forza Italia in caduta libera (-7,4% rispetto al 2013).\n\nChe non tirasse una buona aria Giorgia Meloni l'aveva probabilmente capito già a metà febbraio tanto che organizzò una [manifestazione anti \"inciucio\"](/#/filtra/anti+inciucio) a Roma, misteriosamente disertata dai suo alleati di schieramento.","id":"centro-destra","data":[{"title":"Attività totale","function":"Activity-Total"},{"title":"Attività media/giorno","function":"Activity-Average"},{"title":"% sull'attività totale","function":"Percentage-Activity"},{"title":"Risultati elettorali","body":"# 37,20%"}],"milestones":[5,26,32]}]

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_slope__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_markdown__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_helpers_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__results_css__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__results_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__results_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_results_json__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_results_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__data_results_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Waypoint from 'react-waypoint';
var Results=function(_Component){_inherits(Results,_Component);function Results(props){_classCallCheck(this,Results);var _this=_possibleConstructorReturn(this,(Results.__proto__||Object.getPrototypeOf(Results)).call(this,props));_this.waypointPositionChanged=_this.waypointPositionChanged.bind(_this);_this.formatData=_this.formatData.bind(_this);_this.outputChartFooter=_this.outputChartFooter.bind(_this);_this.state={dates:{separator:Math.round(new Date('2018-04-03T23:00:00').getTime()/1000)},coalitions:[{body:'CasaPound Italia, Forza Nuova, Italia Agli Italiani, Fiamma Tricolore',global:0,id:'destra',post:0,pre:0,result:1.3,title:'Destra',title_short:'Destra'},{id:'sinistra',title:'Sinistra',title_short:'Sinistra',body:'Liberi e Uguali, Sinistra e Libertà, Potere al Popolo!, Partito della Rifondazione Comunista, Partito Comunista, altri',result:5,pre:0,post:0,global:0},{id:'centro-sinistra',title:'Centro Sinistra',title_short:'Cen. Sin.',body:'Partito Democratico, +Europa, Civica Popolare, Südtiroler Volkspartei, altri',result:22.8,pre:0,post:0,global:0},{id:'m5s',title:'Movimento 5 Stelle',title_short:'M. 5 Stelle',body:'',result:32.6,pre:0,post:0,global:0},{id:'centro-destra',title:'Centro Destra',title_short:'C. Destra',body:'Forza Italia, Lega, Fratelli d\'Italia, Unione Di Centro, altri',result:37.2,pre:0,post:0,global:0}],total:{pre:0,post:0,global:0}};return _this;}_createClass(Results,[{key:'componentDidMount',value:function componentDidMount(){this.formatData();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'formatData',value:function formatData(){var coalitions=this.state.coalitions.slice(0);var total=Object.assign({},this.state.total);for(var i=0,l=coalitions.length;i<l;i++){for(var element in this.props.Data.data.timeline[coalitions[i].id]){coalitions[i].global+=parseInt(this.props.Data.data.timeline[coalitions[i].id][element].activity,10);if(parseInt(this.props.Data.data.timeline[coalitions[i].id][element].timestamp,10)<=this.state.dates.separator){coalitions[i].pre+=parseInt(this.props.Data.data.timeline[coalitions[i].id][element].activity,10);total.pre+=parseInt(this.props.Data.data.timeline[coalitions[i].id][element].activity,10);}else{coalitions[i].post+=parseInt(this.props.Data.data.timeline[coalitions[i].id][element].activity,10);total.post+=parseInt(this.props.Data.data.timeline[coalitions[i].id][element].activity,10);}total.global+=parseInt(this.props.Data.data.timeline[coalitions[i].id][element].activity,10);}}this.setState({coalitions:coalitions,total:total});}},{key:'outputChartFooter',value:function outputChartFooter(notes){if(notes&&notes.length>5){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'results--chart--footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Include: ',notes,'.'));}return null;}},{key:'waypointPositionChanged',value:function waypointPositionChanged(pos,step){if(pos.currentPosition==='inside'){this.setState({step:step});}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'results in','data-step':this.state.step,'data-view':this.state.show,ref:this.charts},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'results--legend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'results--legend--item item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_5__data_results_json___default.a.intro.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_markdown___default.a,{source:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_helpers_js__["d" /* prepareMarkDown */])(__WEBPACK_IMPORTED_MODULE_5__data_results_json___default.a.intro.body)}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'results--chart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'results--chart--wrapper'},this.state.coalitions.map(function(item,index){var pre=item.pre*100/_this2.state.total.pre;var post=item.post*100/_this2.state.total.post;var global=item.global*100/_this2.state.total.global;var max=Math.max(pre,post,global,item.result);var series=[{"end":post,"id":"activity","label":"Variazione Att.","start":pre},{"end":global,"id":"global","label":"Att. globale","start":global},{"end":item.result,"id":"results","label":"Risult. Elett.","start":item.result}];var labels=['Prima','Dopo'];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:item.id,className:"results--chart--in "+item.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'results--chart--header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,item.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'results--chart--body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'results--chart--container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__charts_slope__["a" /* default */],{id:item.id,title:item.title,series:series,domain:[0,50],unit:'%',labels:labels,legendPosition:max>25?'bottom':'top'}))),_this2.outputChartFooter(item.body));}))));}}]);return Results;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Results);

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_helpers_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slope_css__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slope_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__slope_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Slope=function(_Component){_inherits(Slope,_Component);function Slope(props){_classCallCheck(this,Slope);var _this=_possibleConstructorReturn(this,(Slope.__proto__||Object.getPrototypeOf(Slope)).call(this,props));_this.chart=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.draw=_this.draw.bind(_this);_this.outputSVG=_this.outputSVG.bind(_this);_this.viewbox=_this.viewbox.bind(_this);_this.state={"paths":{"axis":{},"series":[]},"ready":false,"size":{"h":0,"w":0}};return _this;}_createClass(Slope,[{key:'componentDidMount',value:function componentDidMount(){this.viewbox();window.addEventListener('resize',this.viewbox,false);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.viewbox,false);}},{key:'draw',value:function draw(){var _this2=this;var legendHeight=15;var distanceFromAxis=4;var topBaseY=30;var bottomBaseY=this.state.size.h-legendHeight*(this.props.series.length+3);var leftBaseX=40;var rightBaseX=this.state.size.w-leftBaseX;var scaleY=__WEBPACK_IMPORTED_MODULE_1_d3__["f" /* scaleLinear */]().domain(this.props.domain).range([bottomBaseY,topBaseY]);var series=[];var axis={labels:{end:{text:this.props.labels[0],x:leftBaseX,y:topBaseY/2},start:{text:this.props.labels[1],x:rightBaseX,y:topBaseY/2}},lines:{end:{labelBottom:{text:this.props.domain[0]+this.props.unit,x:rightBaseX+distanceFromAxis,y:bottomBaseY},labelTop:{text:this.props.domain[1]+this.props.unit,x:rightBaseX+distanceFromAxis,y:topBaseY},x1:rightBaseX,x2:rightBaseX,y1:bottomBaseY,y2:topBaseY},start:{labelBottom:{text:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_helpers_js__["c" /* formatNumber */])(this.props.domain[0])+this.props.unit,x:leftBaseX-distanceFromAxis,y:bottomBaseY},labelTop:{text:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_helpers_js__["c" /* formatNumber */])(this.props.domain[1])+this.props.unit,x:leftBaseX-distanceFromAxis,y:topBaseY},x1:leftBaseX,x2:leftBaseX,y1:bottomBaseY,y2:topBaseY}}};var i=2;this.props.series.forEach(function(serie){var path={end:{label:{text:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_helpers_js__["c" /* formatNumber */])(serie.end)+_this2.props.unit,x:rightBaseX+distanceFromAxis,y:scaleY(serie.end)}},id:serie.id,legend:{line:{x1:distanceFromAxis,x2:(rightBaseX-leftBaseX)/2-distanceFromAxis,y1:bottomBaseY+legendHeight*i,y2:bottomBaseY+legendHeight*i},label:{text:serie.label,x:(rightBaseX-leftBaseX)/2+distanceFromAxis,y:bottomBaseY+legendHeight*i},detail:{text:serie.id!=='activity'?Object(__WEBPACK_IMPORTED_MODULE_2__helpers_helpers_js__["c" /* formatNumber */])(serie.start)+_this2.props.unit:''}},line:{x1:leftBaseX,x2:rightBaseX,y1:scaleY(serie.start),y2:scaleY(serie.end)},start:{label:{text:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_helpers_js__["c" /* formatNumber */])(serie.start)+_this2.props.unit,x:leftBaseX-distanceFromAxis,y:scaleY(serie.start)}}};series.push(path);i++;});this.setState({paths:{axis:axis,series:series},ready:true});}},{key:'outputSVG',value:function outputSVG(){var _this3=this;if(this.state.ready){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{viewport:"0 0 "+this.state.size.w+' '+this.state.size.h,preserveAspectRatio:'xMidYMid meet',width:this.state.size.w,height:this.state.size.h},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'axis'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'axis--background'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:"M"+this.state.paths.axis.lines.start.x1+","+this.state.paths.axis.lines.start.y1+" L"+this.state.paths.axis.lines.start.x2+","+this.state.paths.axis.lines.start.y2+" L"+this.state.paths.axis.lines.end.x2+","+this.state.paths.axis.lines.end.y2+" L"+this.state.paths.axis.lines.end.x1+","+this.state.paths.axis.lines.start.y1+"Z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'axis--labels'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.state.paths.axis.labels.start.x,y:this.state.paths.axis.labels.start.y},this.state.paths.axis.labels.start.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.state.paths.axis.labels.end.x,y:this.state.paths.axis.labels.end.y},this.state.paths.axis.labels.end.text)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'axis--start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.axis.lines.start.x1,x2:this.state.paths.axis.lines.start.x2,y1:this.state.paths.axis.lines.start.y1,y2:this.state.paths.axis.lines.start.y2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.state.paths.axis.lines.start.labelTop.x,y:this.state.paths.axis.lines.start.labelTop.y},this.state.paths.axis.lines.start.labelTop.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.state.paths.axis.lines.start.labelBottom.x,y:this.state.paths.axis.lines.start.labelBottom.y},this.state.paths.axis.lines.start.labelBottom.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{cx:this.state.paths.axis.lines.start.x1,cy:this.state.paths.axis.lines.start.y1,r:'2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{cx:this.state.paths.axis.lines.start.x2,cy:this.state.paths.axis.lines.start.y2,r:'2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'axis--end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.paths.axis.lines.end.x1,x2:this.state.paths.axis.lines.end.x2,y1:this.state.paths.axis.lines.end.y1,y2:this.state.paths.axis.lines.end.y2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.state.paths.axis.lines.end.labelTop.x,y:this.state.paths.axis.lines.end.labelTop.y},this.state.paths.axis.lines.end.labelTop.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.state.paths.axis.lines.end.labelBottom.x,y:this.state.paths.axis.lines.end.labelBottom.y},this.state.paths.axis.lines.end.labelBottom.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{cx:this.state.paths.axis.lines.end.x1,cy:this.state.paths.axis.lines.end.y1,r:'2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{cx:this.state.paths.axis.lines.end.x2,cy:this.state.paths.axis.lines.end.y2,r:'2'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'series'},this.state.paths.series.map(function(serie){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{key:serie.id,className:"serie serie-"+serie.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'serie--fill',d:'M'+serie.line.x1+','+serie.line.y1+' L'+serie.line.x2+','+serie.line.y2+' L'+_this3.state.paths.axis.lines.end.x1+','+_this3.state.paths.axis.lines.end.y1+' L'+_this3.state.paths.axis.lines.start.x1+','+_this3.state.paths.axis.lines.start.y1+'Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:serie.line.x1,x2:serie.line.x2,y1:serie.line.y1,y2:serie.line.y2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{cx:serie.line.x1,cy:serie.line.y1,r:'2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{cx:serie.line.x2,cy:serie.line.y2,r:'2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{className:'serie--label-end',x:serie.end.label.x,y:serie.end.label.y},serie.end.label.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{className:'serie--label-start',x:serie.start.label.x,y:serie.start.label.y},serie.start.label.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{className:'serie--label-middle',x:serie.start.label.x+(serie.end.label.x-serie.start.label.x)/2,y:serie.end.label.y},serie.end.label.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'legend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:serie.legend.line.x1,x2:serie.legend.line.x2,y1:serie.legend.line.y1,y2:serie.legend.line.y2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:serie.legend.label.x,y:serie.legend.label.y},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tspan',null,serie.legend.label.text,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tspan',{className:'data'},' ',serie.legend.detail.text))));})));}return null;}},{key:'viewbox',value:function viewbox(){var _this4=this;var svgWrapper=this.chart.current;var size={"h":svgWrapper.offsetHeight,"w":svgWrapper.offsetWidth};this.setState({size:size},function(){_this4.draw();});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slope',ref:this.chart},this.outputSVG());}}]);return Slope;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Slope);

/***/ }),
/* 604 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports = {"intro":{"title":"I Risultati","body":"Abbiamo visto nei dati precedenti che per gran parte degli schieramenti la **percentuale di attività sulla stampa nazionale è molto vicina alla percentuale di voti ottenuti alle elezioni**. C'è un nesso tra le due cose? La stampa italiana è così sensibile agli umori del paese da ripartire lo spazio in maniera proporzionale tra i diversi schieramenti, oppure gli equilibri si sono rotti dopo le elezioni?\n\nPer capirlo abbiamo fatto un piccolo gioco: per ogni schieramento **abbiamo calcolato la percentuale di attività prima e dopo le elezioni** (__linea piena__)**, e abbiamo confrontato questo dato con il risultato elettorale** (__riempimento grigio__). La percentuale di **attività globale media su tutto il periodo** è invece mostrata come una __linea a puntini__. La pietra di confine è impostata alle 23:00 del 4 marzo 2018, ora di chiusura dei seggi.\n\nI dati sui risultati elettorali, anche in questo caso, provengono da [questo documento dell'Istituto Cattaneo](http://www.cattaneo.org/wp-content/uploads/2018/03/Analisi-Istituto-Cattaneo-Elezioni-Politiche-2018-Chi-ha-vinto-chi-ha-perso-5-marzo-2018-2.pdf)"}}

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_waypoint__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_markdown__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_helpers_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__charts_line_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keywords_css__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keywords_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__keywords_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_keywords_json__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_keywords_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__data_keywords_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Keywords=function(_Component){_inherits(Keywords,_Component);function Keywords(props){_classCallCheck(this,Keywords);var _this=_possibleConstructorReturn(this,(Keywords.__proto__||Object.getPrototypeOf(Keywords)).call(this,props));_this.waypointPositionChanged=_this.waypointPositionChanged.bind(_this);_this.state={step:-1,title:''};return _this;}_createClass(Keywords,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){}},{key:'waypointPositionChanged',value:function waypointPositionChanged(pos,step,title){if(pos.currentPosition==='inside'){this.setState({step:step,title:title});}if(step===0&&pos.currentPosition==='below'){step=-1;this.setState({step:step,title:''});}if(step===4&&pos.currentPosition==='above'){step=-1;this.setState({step:step,title:''});}}},{key:'render',value:function render(){var _this2=this;var series=[];__WEBPACK_IMPORTED_MODULE_6__data_keywords_json___default.a.forEach(function(item){series.push(_this2.props.Data.data.keywords[item.id]);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'keywords in','data-step':this.state.step},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'keywords--legend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'keywords--legend--item item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Le parole')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'La questa campagna elettorale \xE8 stata molto incentrata sulle ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'parole'),' pi\xF9 che sui programmi. Quella che si \xE8 vista \xE8 stata una battaglia a colpi di slogan, e ben pochi tra noi elettori sono stati realmente in grado di capire in profondit\xE0 le proposte delle diversi parti politiche.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Le parole sono importanti?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Sicuramente s\xEC. Non siamo in grado di stabilire ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'quanto'),' le singole parole che hanno caratterizzato questa campagna abbiano influenzato il voto, quello che possiamo cercare di capire, tramite la copertura data dalla stampa, \xE8 se ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'quelle'),' parole sono state usate anche ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'dopo'),' le elezioni.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Il metodo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Tra i nostri oltre ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'28.800'),' articoli, abbiamo contato per ogni giorno quanti articoli contengono una parola (o un ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'set di parole'),') per verificare quanto alcuni dei temi ritenuti ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'caldi'),' in campagna elettorale abbiano poi avuto seguito nell\'immediato dopo elezioni.')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'keywords--chart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'keywords--chart--wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.state.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__charts_line_js__["a" /* default */],{series:series})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'keywords--data'},__WEBPACK_IMPORTED_MODULE_6__data_keywords_json___default.a.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_waypoint__["a" /* default */],{onPositionChange:function onPositionChange(position){_this2.waypointPositionChanged(position,index,item.title);},topOffset:'80%',bottomOffset:'10%',key:item.id+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,item.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_markdown___default.a,{source:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_helpers_js__["d" /* prepareMarkDown */])(item.body)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'intro'},'Keywords:'),item.terms.map(function(term,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:term+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:term,href:"/#/filtra/"+escape(term)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,term)));}))))));})));}}]);return Keywords;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Keywords);

/***/ }),
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports = [{"title":"La flat tax","id":"flattax","body":"È stato uno dei cavalli di battaglia della campagna elettorale dello schieramento di centro destra: la \"flat tax\", ovvero la volontà di sostituire l'attuale metodo di tassazione progressiva con uno più semplice, basato esclusivamente su uno o due scaglioni. Il provvedimento è molto discusso: secondo i suoi promotori si tradurrebbe in una [riduzione delle imposte per tutti](https://api.elezioni.io/click?u=aHR0cHM6Ly90ZzI0LnNreS5pdC9wb2xpdGljYS8yMDE4LzA2LzA2L2dvdmVybm8tc2FsdmluaS1mbGF0LXRheC5odG1sP3NvY2lhbD10d2l0dGVyX3NreXRnMjQ=), per i suoi detrattori [solo chi ha redditi alti avrebbe un vero guadagno](https://api.elezioni.io/click?u=aHR0cDovL3d3dy5hZG5rcm9ub3MuY29tL3NvbGRpL2Vjb25vbWlhLzIwMTgvMDUvMTIvZmxhdC10YXgtbGVnYS1lY2NvLWNoaS1ndWFkYWduZXJhX0E2dDN3a29OSzdIc2ZNM3VqMlFMSkwuaHRtbA==). Dopo le elezioni, pur separato dalla sua coalizione, uno dei partiti promotori dell'idea è entrato nella coalizione di governo: come si è evoluta la discussione su questo provvedimento?","terms":["flat tax"]},{"title":"Il reddito di cittadinanza","id":"reddito","body":"Sembra che già pochi giorni dopo l'annuncio dei risultati elettorali [in alcuni comuni del Sud si siano create code ai CAF](https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wMy8wOC9wdWdsaWEtZS1iYXNpbGljYXRhLWRvcG8tbGEtdml0dG9yaWEtbTVzLWNvZGUtYWktc2luZGFjYXRpLXBlci1pbC1yZWRkaXRvLWRpLWNpdHRhZGluYW56YS1pLWNhZi1zbWVudGlzY29uby1jYXNpLWlzb2xhdGkvNDIxMjQzMC8=) per chiedere il contributo statale che è stato uno dei primi punti del programma di governo del Movimento 5 Stelle.","terms":["reddito di cittadinanza"]},{"title":"Vaccini sì, vaccini no…","id":"vaccini","body":"L'estate 2017, e l'anno scolastico 2017/18 sono stati segnati dal decreto sull'obbligo vaccinale emesso dal governo Gentiloni e firmato dall'allora Ministro della Salute Beatrice Lorenzin. Il decreto, che anche dopo la conversione in legge prevede l'allontanamento da Nidi e Scuole d'Infanzia dei bambini non in regola, ha causato molti disguidi sia alle ASL che a comuni e scuole, a causa di decreti attuativi confusi, rimpalli di responsabilità tra gli enti coinvolti e… problemi di costituzionalità e privacy.\n\nTra tutti i partiti in lizza a queste elezioni, la Lega di Matteo Salvini si è fin da subito dichiarata [contraria all'obbligo vaccinale](https://api.elezioni.io/click?u=aHR0cDovL3d3dy5pbGdpb3JuYWxlLml0L25ld3MvcG9saXRpY2EvdmFjY2luaS1kdXJhLWJvdHRhLWUtcmlzcG9zdGEtc2FsdmluaS1lLWxvcmVuemluLTE0ODE2NDMuaHRtbA==) (e non c'è dubbio che una posizione così forte su un argomento così controverso abbia portato dei consensi al partito di Salvini), mentre il Movimento 5 Stelle guidato da Luigi di Maio ha avuto [una posizione meno radicale ma comunque critica](https://api.elezioni.io/click?u=aHR0cDovL3RnLmxhNy5pdC9wb2xpdGljYS9zZS12aW5jZS1pbC1tNXMtbGEtbGVnZ2UtbG9yZW56aW4tc2FsdGEtc29sby00LXZhY2Npbmktb2JibGlnYXRvcmktY29zw6wtZGktbWFpby1yaWFjY2VuZGUtbGEtZGlzcHV0YS0xNS0wMS0yMDE4LTEyMzc0MA==).","terms":["vaccino","vaccini","vaccinazione","vaccinazioni","obbligo vaccinale","vaccinale"]},{"title":"Il pericolo fascista","id":"fascismo","body":"Per un certo periodo di questa campagna elettorale è sembrato che il \"pericolo fascista\" fosse concreto, e che la destra estrema fosse abbastanza matura e popolare per reclamare uno spazio in parlamento, tanto che anche politici di spicco, come ad esempio la ex Presidente della Camera Laura Boldrini, [si sono esposti chiedendo duri interventi](https://api.elezioni.io/click?u=aHR0cHM6Ly92aWRlby5yZXB1YmJsaWNhLml0L3BvbGl0aWNhL21vdmltZW50aS1pc3BpcmF0aS1hbC1mYXNjaXNtby1ib2xkcmluaS12YW5uby1zY2lvbHRpLW9ybGFuZG8tZ2l1c3RvLW1hLW5vbi1lLWNvc2ktc2VtcGxpY2UvMjk4MDkzLzI5ODcxND9yZWY9dHdocg==). I risultati elettorali hanno provato il contrario, dando spazio sui giornali a [commenti particolarmente acidi](https://api.elezioni.io/click?u=aHR0cDovL3d3dy5kYWdvc3BpYS5jb20vcnVicmljYS0zL3BvbGl0aWNhL3ZpLWNoaWVkZXRlLXBlcmNoZS1yc3F1by1zaW5pc3RyYS1wZXJkZS1wZC1sZHF1by1sZXUtcmRxdW8tMTY4NTc4Lmh0bQ==).","terms":["fascismo","fascista","fascisti","fasciste"]},{"title":"Il razzismo","id":"razzismo","body":"Diversi sono stati i fatti che hanno evidenziato come l'Italia non sia un paese immune da sentimenti razzisti. In questa campagna elettorale il \"fischi d'inizio\" è stato dato da [Luca Traini](/#/filtra/luca%20traini) e dal suo attacco a Macerata. Fatti spiacevoli sono poi continuati e, secondo alcuni, [il razzismo è divenuto istituzionale con la Lega al governo](https://api.elezioni.io/click?u=aHR0cDovL3d3dy5sYXByZXNzZS5pdC92aWRlby92aW9sYS1jYXJvZmFsby1jLWUtcG9jby1kYS1zdGFyZS1hbGxlZ3JpLWNvbi1sYS1sZWdhLWlsLXJhenppc21vLWUtaWwtc2Vzc2lzbW8tY2hlLWNyZXNjb25vLz91dG1fc291cmNlPWRsdnIuaXQmdXRtX21lZGl1bT10d2l0dGVy) e Matteo Salvini al Viminale.","terms":["razzismo","razzista","razzisti","xenofobi","xenofobia"]}]

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_line_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_spine_js__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charts_matrix_js__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__leaders_css__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__leaders_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__leaders_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_leaders_json__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_leaders_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__data_leaders_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Leaders=function(_Component){_inherits(Leaders,_Component);function Leaders(props){_classCallCheck(this,Leaders);var _this=_possibleConstructorReturn(this,(Leaders.__proto__||Object.getPrototypeOf(Leaders)).call(this,props));_this.getBoundaries=_this.getBoundaries.bind(_this);_this.toggleSerie=_this.toggleSerie.bind(_this);_this.state={activeSeries:['serie-0','serie-1'],xBoundaries:[new Date('2018-02-01').getTime(),new Date('2018-06-06').getTime()],yBoundaries:_this.getBoundaries()};return _this;}_createClass(Leaders,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){}},{key:'getBoundaries',value:function getBoundaries(){var _this2=this;var quantities=[];__WEBPACK_IMPORTED_MODULE_5__data_leaders_json___default.a.leaders.forEach(function(leader){var serie=_this2.props.Data.data.keywords[leader.id];serie.forEach(function(point){quantities.push(parseInt(point.number,10));});});return[Math.min(0,Math.min.apply(Math,quantities)),Math.max.apply(Math,quantities)];}},{key:'toggleSerie',value:function toggleSerie(serie){var needle='serie-'+serie;var activeSeries=this.state.activeSeries.slice(0);var index=activeSeries.indexOf(needle);if(index===-1){activeSeries.push(needle);}else{activeSeries.splice(index,1);}this.setState({activeSeries:activeSeries});}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leaders in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leaders--legend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leaders--legend--item item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'I Leader')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Questa campagna elettorale \xE8 stata molto personalizzata, quasi all\'americana. Ogni schieramento si \xE8 presentato alle elezioni con un leader dichiarato, che ha assunto il ruolo di guida e voce della sua coalizione.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Questo \xE8 stato indubbiamente vero per tutti gli schieramenti tranne che per il Centro Destra, dove sia ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/#/filtra/berlusconi'},'Silvio Berlusconi'),' che ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/#/filtra/salvini'},'Matteo Salvini'),' hanno reclamato pi\xF9 volte il ruolo di guida, e dove alcune spaccature avevano iniziato a vedersi gi\xE0 ad inizio febbraio, in occasione della ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/#/filtra/anti+inciucio'},'manifestazione anti-inciucio'),' promossa da ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/#/filtra/meloni'},'Giorgia Meloni'),'. Come sia andata a finire \xE8 sotto agli occhi di tutti: Salvini al governo alleato con il ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/#/categoria/m5s'},'Movimento 5 Stelle'),' guidato da ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/#/filtra/di+maio'},'Luigi Di Maio'),', e Silvio Berlusconi praticamente scomparso dalla scena politica.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Proviamo quindi a vedere come si \xE8 evoluta la copertura stampa dedicata ai vari leader di partito nel periodo monitorato.')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leaders--data'},__WEBPACK_IMPORTED_MODULE_5__data_leaders_json___default.a.leaders.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',{key:item.id+index,className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,item.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,item.body)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--chart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__charts_line_js__["a" /* default */],{series:[_this3.props.Data.data.keywords[item.id]],xBoundaries:_this3.state.xBoundaries,yBoundaries:_this3.state.yBoundaries})));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leaders--legend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leaders--legend--item item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Le relazioni')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Quanti punti di contatto hanno avuto i leader dei diversi partiti durante la campagna elettorale? E dopo il voto? Queste matrici mostrano il volume di articoli pubblicati dalla stampa che citano assieme due politici (i leader dei diversi schieramenti, pi\xF9 il Presidente della Repubblica Sergio Mattarella), e ci consentono di capire come gli equilibri, anche sui giornali, siano cambiati in pochi mesi.')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leaders--data matrix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Prima delle elezioni')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--chart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__charts_matrix_js__["a" /* default */],{Matrix:this.props.Data.data.matrix.pre.matrix,Axis:this.props.Data.data.matrix.pre.keywords,ChartId:'id',Min:0,Max:this.props.Data.data.matrix.pre.max})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Dopo le elezioni')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--chart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__charts_matrix_js__["a" /* default */],{Matrix:this.props.Data.data.matrix.post.matrix,Axis:this.props.Data.data.matrix.post.keywords,ChartId:'id',Min:0,Max:this.props.Data.data.matrix.post.max}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leaders--legend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leaders--legend--item item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Le coppie')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Come in ogni vera commedia all\'italiana, a tenere in piedi la storia sono le coppie, e i tradimenti, che in politica talvolta prendono il nome di "',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'responsabilit\xE0'),'", altre volte di "',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'inciucio'),'". Queste elezioni non si sono differenziate e, come nella migliore tradizione, ci hanno offerto un ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'inciucio'),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Matteo Salvini'),', ben sessanta giorni dopo la fine dello spoglio dei voti, cede alle lusinghe di ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Luigi Di Maio'),' e lascia il suo alleato ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Silvio Berlusconi'),' per entrare nel governo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'gialloverde'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Ma come hanno reagito i giornali?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'In questo grafico potete vedere come \xE8 cambiata l\'attivit\xE0 che riguarda i tre protagonisti di questa vicenda presi singolarmente (Salvini in verde, Di Maio in giallo, Berlusconi in blu) e tenendo conto solo degli articoli che parlano contemporaneamente di due dei protagonisti: Salvini e Di Maio (tratteggiata gialla), e Salvini e Berlusconi (tratteggiata blu).'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Clicca sui nomi nella legenda per evidenziare le singole linee.')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leaders--data couples'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"item--chart "+this.state.activeSeries.join(' ')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__charts_line_js__["a" /* default */],{series:[this.props.Data.data.keywords.dimaiosalvini,this.props.Data.data.keywords.berlusconisalvini,this.props.Data.data.keywords.berlusconi,this.props.Data.data.keywords.salvini,this.props.Data.data.keywords.dimaio],xBoundaries:this.state.xBoundaries}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--chart--legend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'entry dimaio',onClick:function onClick(){_this3.toggleSerie('4');}},'Luigi Di Maio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'entry dimaiosalvini',onClick:function onClick(){_this3.toggleSerie('0');}},'Di Maio e Salvini'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'entry salvini',onClick:function onClick(){_this3.toggleSerie('3');}},'Matteo Salvini'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'entry berlusconisalvini',onClick:function onClick(){_this3.toggleSerie('1');}},'Berlusconi e Salvini'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'entry berlusconi',onClick:function onClick(){_this3.toggleSerie('2');}},'Silvio Berlusconi'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leaders--legend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leaders--legend--item item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'I vice')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Sarebbe logico aspettarsi che la coppia uscita vincente da queste elezioni (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Matteo Salvini, Luigi Di Maio'),') sia stata quasi una novit\xE0 per i media, e che gli articoli che parlano di entrambi abbiano iniziato ad aumentare dopo le elezioni. Ma quanto \xE8 importante la differenza di attivit\xE0 tra il prima e il dopo elezioni?')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leaders--data vice'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--chart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__charts_spine_js__["a" /* default */],{data:[{title:'Prima',value:parseInt(this.props.Data.data.vice.pre.matrix.salvini['di maio'],10)},{title:'Dopo',value:parseInt(this.props.Data.data.vice.post.matrix.salvini['di maio'],10)}],description:'Articoli che parlano contemporaneamente di Matteo Salvini e Luigi Di Maio, prima e dopo le elezioni. ',title:'I vice-premier'})))));}}]);return Leaders;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Leaders);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_helpers_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spine_css__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spine_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__spine_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spine=function(_Component){_inherits(Spine,_Component);function Spine(props){_classCallCheck(this,Spine);var _this=_possibleConstructorReturn(this,(Spine.__proto__||Object.getPrototypeOf(Spine)).call(this,props));_this.draw=_this.draw.bind(_this);_this.state={section:[0,0]};return _this;}_createClass(Spine,[{key:'componentDidMount',value:function componentDidMount(){this.draw();}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'draw',value:function draw(){var total=this.props.data[0].value+this.props.data[1].value;console.log(total);var section=[];section.push(this.props.data[0].value*100/total);section.push(this.props.data[1].value*100/total);this.setState({section:section});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'spine'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'spine--title'},this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'spine--header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'spine--section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.props.data[0].title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'spine--section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.props.data[1].title))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'spine--body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'spine--section section-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'spine--section--bar',style:{width:this.state.section[0]+'%'}},this.state.section[0]>10?Object(__WEBPACK_IMPORTED_MODULE_1__helpers_helpers_js__["c" /* formatNumber */])(this.props.data[0].value):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'spine--section section-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'spine--section--bar',style:{width:this.state.section[1]+'%'}},this.state.section[1]>10?Object(__WEBPACK_IMPORTED_MODULE_1__helpers_helpers_js__["c" /* formatNumber */])(this.props.data[1].value):'')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'spine--description'},this.props.description)));}}]);return Spine;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Spine);

/***/ }),
/* 613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 614 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports = {"leaders":[{"title":"Simone Di Stefano","id":"distefano","body":"Casa Pound Italia"},{"title":"Giorgia Meloni","id":"meloni","body":"Fratelli d'Italia"},{"title":"Matteo Salvini","id":"salvini","body":"Lega"},{"title":"Silvio Berlusconi","id":"berlusconi","body":"Forza Italia"},{"title":"Luigi Di Maio","id":"dimaio","body":"Movimento 5 Stelle"},{"title":"Paolo Gentiloni","id":"gentiloni","body":"Partito Democratico"},{"title":"Matteo Renzi","id":"renzi","body":"Partito Democratico"},{"title":"Pietro Grasso","id":"grasso","body":"Liberi e Uguali"},{"title":"Viola Carofalo","id":"carofalo","body":"Potere al Popolo!"}],"comparison":[{"title":"La flat tax","id":"flattax","body":"È stato uno dei cavalli di battaglia della campagna elettorale dello schieramento di centro destra: la \"flat tax\", ovvero la volontà di sostituire l'attuale metodo di tassazione progressiva con uno più semplice, basato esclusivamente su uno o due scaglioni. Il provvedimento è molto discusso: secondo i suoi promotori si tradurrebbe in una [riduzione delle imposte per tutti](https://api.elezioni.io/click?u=aHR0cHM6Ly90ZzI0LnNreS5pdC9wb2xpdGljYS8yMDE4LzA2LzA2L2dvdmVybm8tc2FsdmluaS1mbGF0LXRheC5odG1sP3NvY2lhbD10d2l0dGVyX3NreXRnMjQ=), per i suoi detrattori [solo chi ha redditi alti avrebbe un vero guadagno](https://api.elezioni.io/click?u=aHR0cDovL3d3dy5hZG5rcm9ub3MuY29tL3NvbGRpL2Vjb25vbWlhLzIwMTgvMDUvMTIvZmxhdC10YXgtbGVnYS1lY2NvLWNoaS1ndWFkYWduZXJhX0E2dDN3a29OSzdIc2ZNM3VqMlFMSkwuaHRtbA==). Dopo le elezioni, pur separato dalla sua coalizione, uno dei partiti promotori dell'idea è entrato nella coalizione di governo: come si è evoluta la discussione su questo provvedimento?","terms":["di maio","salvini"]}]}

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timeline_css__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timeline_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__timeline_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DTimeline=function(_Component){_inherits(DTimeline,_Component);function DTimeline(props){_classCallCheck(this,DTimeline);var _this=_possibleConstructorReturn(this,(DTimeline.__proto__||Object.getPrototypeOf(DTimeline)).call(this,props));_this.chart=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.abstract=_this.abstract.bind(_this);_this.dateFormat=_this.dateFormat.bind(_this);_this.draw=_this.draw.bind(_this);_this.setMax=_this.setMax.bind(_this);_this.viewbox=_this.viewbox.bind(_this);_this.writeMarkup=_this.writeMarkup.bind(_this);_this.positionData={};_this.state={"activity":{},"articleHeight":110,"articleWidth":175,"articles":[],"borders":40,"debug":[],"enabled":false,"milestones":[],"max_values":{"activity":-1,"popularity":-1},"min_width":400,"oneDay":60*60*24,"parties":{"destra":"Destra","centro-destra":"C. Destra","m5s":"Mov. 5 Stelle","centro-sinistra":"C. Sinistra","sinistra":"Sinistra"},"paths":{"date_lines":[],"curves":[]},"size":{"h":1600,"w":800}};return _this;}_createClass(DTimeline,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.setState({activity:this.props.Data.data.history.activity,articles:this.props.Data.data.history.articles},function(){_this2.setMax();window.addEventListener('resize',_this2.viewbox,false);_this2.viewbox();});}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.viewbox,false);}},{key:'abstract',value:function abstract(text,maxLength){if(maxLength===undefined){maxLength=75;}if(text.length<=maxLength){return text;}text=text.substr(0,maxLength);return text.substr(0,Math.min(text.length,text.lastIndexOf(" ")))+'…';}},{key:'dateFormat',value:function dateFormat(timestamp,ht){var d=new Date(timestamp*1000);var gg="00"+d.getDate();var mm="00"+(d.getMonth()+1);var YY="00"+d.getFullYear();var hh="00"+d.getHours();var nn="00"+d.getMinutes();return gg.substr(gg.length-2)+'/'+mm.substr(mm.length-2)+'/'+YY.substr(YY.length-4)+(ht===true?'':' '+hh.substr(hh.length-2)+':'+nn.substr(nn.length-2));}},{key:'draw',value:function draw(){var news=[];var lines=[];var curves=[];var debug=[];var parties=this.state.parties;if(this.state.articles.length>0){var minY=parseInt(this.state.articles[0].date_published_timestamp,10)+this.state.oneDay,maxY=parseInt(this.state.articles[this.state.articles.length-1].date_published_timestamp,10)-this.state.oneDay,maxXActivity=this.state.max_values.activity,maxXPopularity=this.state.max_values.popularity,scaleY=__WEBPACK_IMPORTED_MODULE_1_d3__["f" /* scaleLinear */]().domain([minY,maxY]).range([0,this.state.size.h]);for(var i=0,l=this.state.articles.length;i<l;i++){var y=scaleY(this.state.articles[i].date_published_timestamp);// Articles' list
news[i]=this.state.articles[i];news[i].top=y-6;// SVG lines 
lines.push({"y":y});}}if(Object.keys(this.state.activity).length>0&&this.state.articles.length>0){// Charts
var activity=this.state.activity;var availableSpace=this.state.size.w-this.state.articleWidth-this.state.borders;var slots=availableSpace/Object.keys(activity).length;var baseX=this.state.articleWidth+this.state.borders/2;// Boundaries
Object.keys(activity).forEach(function(key,index){var max=baseX+slots*index;var boundaries={"max":max-slots/3,"center":max+slots/2,"min":max+slots+slots/3};var scaleXActivity=__WEBPACK_IMPORTED_MODULE_1_d3__["f" /* scaleLinear */]().domain([0,maxXActivity]).range([boundaries.center,boundaries.max]);var scaleXPopularity=__WEBPACK_IMPORTED_MODULE_1_d3__["f" /* scaleLinear */]().domain([0,maxXPopularity]).range([boundaries.center,boundaries.max]);var points=[{"xAct":scaleXActivity(0),"xPop":scaleXPopularity(0),"y":scaleY(maxY)}];activity[key].forEach(function(point,index){points.push({"xAct":scaleXActivity(parseInt(point.activity,10)),"xPop":scaleXPopularity(parseInt(point.popularity,10)),"y":scaleY(parseInt(point.timestamp,10))});});var mirror=[];points.forEach(function(point){mirror.push({"xAct":boundaries.center+(boundaries.center-point.xAct),"xPop":boundaries.center+(boundaries.center-point.xPop),"y":point.y});});mirror.reverse();points=points.concat(mirror);var activityArea=__WEBPACK_IMPORTED_MODULE_1_d3__["b" /* area */]().x(function(points){return points.xAct;}).y1(function(points){return points.y;}).curve(__WEBPACK_IMPORTED_MODULE_1_d3__["c" /* curveBasis */]);var popularityArea=__WEBPACK_IMPORTED_MODULE_1_d3__["b" /* area */]().x(function(points){return points.xPop;}).y1(function(points){return points.y;}).curve(__WEBPACK_IMPORTED_MODULE_1_d3__["c" /* curveBasis */]);curves.push({"activityPath":activityArea(points),"name":parties[key],"popularityPath":popularityArea(points),"slug":key,"style":{"left":boundaries.center+'px'}});debug.push(points);});}var milestones=[];if(this.state.milestones.length>0){var pm=0;for(var _i=0,_l=this.state.milestones.length;_i<_l;_i++){if(this.state.milestones[_i].timestamp_published>=news[news.length-1].date_published_timestamp&&this.state.milestones[_i].timestamp_published<=news[0].date_published_timestamp){var milestone=this.state.milestones[_i];milestone.top=scaleY(milestone.timestamp_order);if(pm===milestone.timestamp_order){milestone.position=2;}else{milestone.position=1;}pm=milestone.timestamp_order;milestones.push(milestone);}}}var paths={"date_lines":lines,"curves":curves};this.setState({"articles":news,"debug":debug,"milestones":milestones,"paths":paths});}},{key:'setMax',value:function setMax(log){var _this3=this;var activity=this.state.activity;var max_values={"activity":-1,"popularity":-1};Object.keys(activity).forEach(function(key,index){activity[key].forEach(function(day){if(max_values.activity<parseInt(day.activity,10)){max_values.activity=parseInt(day.activity,10);}if(max_values.popularity<parseInt(day.popularity,10)){max_values.popularity=parseInt(day.popularity,10);}});});this.setState({"max_values":max_values},function(){_this3.viewbox();});}},{key:'viewbox',value:function viewbox(){var _this4=this;var width=this.chart.current.offsetWidth;var size={"w":width,"h":this.state.articles?this.state.articles.length*this.state.articleHeight+this.state.borders:document.querySelector('#timeline-page').offsetHeight};this.setState({'enabled':width>=this.state.min_width?true:false,'size':size},function(){_this4.draw();});}},{key:'writeMarkup',value:function writeMarkup(){var _this5=this;if(this.state.enabled){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timeline--page--viz',style:{"height":this.state.size.h+"px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timeline--page--viz--articles',id:'timeline--page--viz--articles'},this.state.articles.map(function(article){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',{key:article.id,className:'timeline-page--articles--article',style:{"top":article.top+"px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'timeline-page--articles--article--collections'},article.collections.map(function(collection,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:collection.slug+collection.id+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"#/categoria/"+collection.slug,title:collection.name,className:collection.slug},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,collection.name)));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,article.date_published_short),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_read',href:article.url,title:article.title,className:'timeline-page--viz--articles--article--link'},_this5.abstract(article.title),' (',article.source,')')));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timeline--page--viz--legend',id:'timeline--page--viz--legend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'party-title articles'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Articoli pi\xF9 popolari di ogni giorno')),this.state.paths.curves.map(function(curve,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"T-"+index,className:"party-title "+curve.slug,style:curve.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,curve.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'activity'},'Att. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'popularity'},'Pop. '));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{id:'timeline-page--viz--svg',className:'timeline-page--viz--svg',width:this.state.size.w,height:this.state.size.h,preserveAspectRatio:'xMidYMid meet',viewBox:"0 0 "+this.state.size.w+" "+this.state.size.h},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'timeline-page--viz--svg--curves'},this.state.paths.curves.map(function(curve,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{key:"PT-"+index,className:curve.slug},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:curve.activityPath,className:'timeline-page--viz--svg--curve-activity'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:curve.popularityPath,className:'timeline-page--viz--svg--curve-popularity'}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'timeline-page--viz--svg--date-lines'},this.state.paths.date_lines.map(function(line,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{key:"LN-"+index,x1:'0',y1:line.y,x2:_this5.state.size.w,y2:line.y,className:'timeline-page--viz--svg--date-line'});})))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Questa visualizzazione richiede uno schermo grande. Su molti smartphone, \xE8 sufficiente ruotare il telefono in posizione orizzontale per poter vedere correttamente la timeline.'));}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timeline in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timeline--legend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timeline--legend--item item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'La Timeline')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item--text--body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Cerchiamo infine di raccontare queste elezioni tramite la loro timeline, mostrando sia l\'attivit\xE0 quotidiana per ogni schieramento che la popolarit\xE0 (calcolata basandosi sulle condivisioni Twitter e Facebook) dei vari articoli.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Nella prima colonna a sinistra, assieme al calendario, \xE8 mostrato l\'articolo pi\xF9 popolare tra quelli importati quel giorno. Ogni altra colonna rappresenta uno schieramento composto secondo il nostro solito standard: Destra ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'color destra'}),', Centro Destra ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'color centro-destra'}),', Movimento 5 Stelle ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'color m5s'}),', Centro Sinistra ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'color centro-sinistra'}),', e Sinistra ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'color sinistra'}),'. L\'area grigia rappresenta il numero di articoli pubblicati che parlano di quello schieramento, l\'area colorata rappresenta l\'attivit\xE0 sui social network degli stessi articoli (tweets, retweets, like, condivisioni, commenti, ecc.).')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timeline--data',ref:this.chart},this.writeMarkup()));}}]);return DTimeline;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DTimeline);

/***/ }),
/* 618 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__items_css__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__items_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__items_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__item_js__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charts_milestones_js__ = __webpack_require__(201);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Items=function(_Component){_inherits(Items,_Component);function Items(props){_classCallCheck(this,Items);var _this=_possibleConstructorReturn(this,(Items.__proto__||Object.getPrototypeOf(Items)).call(this,props));_this.load=_this.load.bind(_this);_this.getStats=_this.getStats.bind(_this);_this.state={"articles":[],"current_page":0,"next_page":-1,"prev_page":-1,"slug":null,"name":null,"short_name":null,"path":null,"stats":null};return _this;}_createClass(Items,[{key:'componentDidMount',value:function componentDidMount(){this.load();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.Location!==this.props.Location){this.load();}}},{key:'getStats',value:function getStats(slug){var _this2=this;slug=slug.split('/')[0];var location=this.props.BaseUrl+this.props.StatsUrl+'/'+slug;this.props.FetchContent(location,{},function(data){if(!data.error){_this2.setState({"stats":data.stats});}else{console.log(data.errormessage);}},function(error){console.log(error);});}},{key:'load',value:function load(){var _this3=this;var location=null,slug=false;if(this.props.Location){if(this.props.Location==='#/'){slug='';location=false;// this.props.BaseUrl + this.props.BrowseUrl;
}else if(this.props.Location.indexOf('/categoria/')>-1){slug=this.props.Location.replace(/#\/categoria\//ig,'');location=this.props.BaseUrl+this.props.BrowseUrl+'/'+slug;}else if(this.props.Location.indexOf('/filtra/')>-1){location=this.props.BaseUrl+this.props.FilterUrl+'/'+this.props.Location.replace(/#\/filtra\//ig,'');}else if(this.props.Location.indexOf('/temi')>-1){location=this.props.BaseUrl+this.props.TopicsUrl+'/'+this.props.Location.replace(/temi\//ig,'temi').replace(/#\/temi/ig,'');}}if(location){this.props.FetchContent(location,{},function(data){if(data.error){console.log(data.errormessage);window.location.hash='/leggi/errore';}else{_this3.setState({"articles":data.articles});if(data.function==='browse'||data.function==='topics'){if(data.collection&&data.collection.name){_this3.props.SetTitle(data.collection.name);_this3.setState({"current_page":data.page,"prev_page":data.page>0?data.page-1:-1,"next_page":data.page<data.total_pages-1?data.page+1:-1,"slug":data.collection.slug,"name":data.collection.name,"short_name":data.collection.short_name,"path":'categoria',"stats":null},function(){_this3.props.ShowLoading(false);_this3.getStats(slug);});}else if(data.function==='topics'){_this3.props.SetTitle('Temi');_this3.setState({"current_page":data.page,"prev_page":data.page>0?data.page-1:-1,"next_page":data.page<data.total_pages-1?data.page+1:-1,"slug":null,"name":null,"short_name":null,"path":'temi',"stats":null},function(){_this3.props.ShowLoading(false);});}else{_this3.props.SetTitle('');_this3.setState({"current_page":0,"prev_page":-1,"next_page":-1,"slug":null,"name":null,"short_name":null,"path":null,"stats":null},function(){_this3.props.ShowLoading(false);_this3.getStats(slug);});}}else if(data.function==='search'){if(data.keyword){_this3.props.SetTitle('#'+data.keyword);}_this3.setState({"current_page":data.page,"prev_page":data.page>0?data.page-1:-1,"next_page":data.page<data.total_pages-1?data.page+1:-1,"slug":escape(data.keyword),"path":'filtra',"name":null,"short_name":null,"stats":null},function(){_this3.props.ShowLoading(false);_this3.getStats('');});}}},function(error){console.log(error);window.location.hash='/leggi/errore';});}}},{key:'render',value:function render(){var filtered,stats,slug,name,short_name,fetchContent,popularity_url,base_url;if(this.state.slug===null||this.state.path==='filtra'){filtered=false;}else{filtered=true;}stats=this.state.stats;slug=this.state.slug;name=this.state.name;fetchContent=this.props.FetchContent;short_name=this.state.short_name;popularity_url=this.props.PopularityUrl;base_url=this.props.BaseUrl;if(this.state.articles.length>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'items-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemsCoverage,{Path:this.state.path,Collection:name,CollectionSlug:slug,FetchContent:this.props.FetchContent,BaseUrl:this.props.BaseUrl,VizUrl:this.props.VizUrl,AnimationDuration:this.props.AnimationDuration}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',{className:'items'},this.state.articles.map(function(article,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__item_js__["a" /* default */],{key:article.id+'-'+index,Article:article,Filtered:filtered,Stats:stats,Slug:slug,Name:name,ShortName:short_name,FetchContent:fetchContent,PopularityUrl:popularity_url,BaseUrl:base_url});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Pagination,{CurrentPage:this.state.current_page,PrevPage:this.state.prev_page,NextPage:this.state.next_page,Slug:this.state.slug,Path:this.state.path}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'items-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',{className:'items'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'article message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Nessun risultato :(')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Ci spiace, non siamo stati in grado di trovare alcun articolo su "',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.slug),'".'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Puoi provare ad effettuare una nuova ricerca, oppure ripartire da una delle nostre categorie: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/categoria/centro-destra'},'Centro Destra'),', ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/categoria/centro-sinistra'},'Centro Sinistra'),', ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/categoria/m5s'},'Movimento 5 Stelle'),', ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/categoria/sinistra'},'Sinistra'),', ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/categoria/destra'},'Destra'),' che rappresentano i maggiori schieramenti presenti alle elezioni del 4 marzo 2018.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Se cerchi qualche suggerimento per le ricerche, al temine di ogni articolo sono presenti dei ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'tag'),' generati automaticamente che attivano le funzionalit\xE0 di ricerca.')))));}}}]);return Items;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Items);var Pagination=function(_Component2){_inherits(Pagination,_Component2);function Pagination(){_classCallCheck(this,Pagination);return _possibleConstructorReturn(this,(Pagination.__proto__||Object.getPrototypeOf(Pagination)).apply(this,arguments));}_createClass(Pagination,[{key:'render',value:function render(){var prev=this.props.PrevPage>-1?true:false;var next=this.props.NextPage>-1?true:false;if(this.props.Slug){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pagination'},prev&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pagination-prev'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"#/"+this.props.Path+"/"+this.props.Slug+(this.props.PrevPage>0?"/"+this.props.PrevPage:"")},'Precedente')),next&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pagination-next'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"#/"+this.props.Path+"/"+this.props.Slug+"/"+this.props.NextPage},'Successivo'))));}else{return null;}}}]);return Pagination;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ItemsCoverage=function(_Component3){_inherits(ItemsCoverage,_Component3);function ItemsCoverage(){_classCallCheck(this,ItemsCoverage);return _possibleConstructorReturn(this,(ItemsCoverage.__proto__||Object.getPrototypeOf(ItemsCoverage)).apply(this,arguments));}_createClass(ItemsCoverage,[{key:'render',value:function render(){if(this.props.Path==='categoria'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'items-coverage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__charts_milestones_js__["a" /* default */],{ChartId:'coverage-over-time',Collection:this.props.Collection,CollectionSlug:this.props.CollectionSlug,FetchContent:this.props.FetchContent,BaseUrl:this.props.BaseUrl,VizUrl:this.props.VizUrl,AnimationDuration:this.props.AnimationDuration,AddLabel:'true'}));}else{return null;}}}]);return ItemsCoverage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__item_css__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__item_stats_css__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__item_stats_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__item_stats_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__item_stats_front_css__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__item_stats_front_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__item_stats_front_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__item_stats_back_css__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__item_stats_back_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__item_stats_back_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__item_stats_tabs_css__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__item_stats_tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__item_stats_tabs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__item_milestone_css__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__item_milestone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__item_milestone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_d3__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Item=function(_Component){_inherits(Item,_Component);function Item(props){_classCallCheck(this,Item);var _this=_possibleConstructorReturn(this,(Item.__proto__||Object.getPrototypeOf(Item)).call(this,props));_this.abstract=_this.abstract.bind(_this);_this.state={"abstractLength":150};return _this;}_createClass(Item,[{key:'abstract',value:function abstract(text,length){var trimmedString;if(text.length>=length){trimmedString=text.substr(0,length);trimmedString=trimmedString.substr(0,Math.min(trimmedString.length,trimmedString.lastIndexOf(" ")))+"…";}else{trimmedString=text;}return trimmedString.trim();}},{key:'render',value:function render(){var popular=parseInt(this.props.Article.popularity,10)>=1000000?true:false;if(this.props.Article.type==='milestone'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Milestone,{Article:this.props.Article});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:"item article "+(popular?'popular ':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.props.Article.source,' / ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('time',{dateTime:this.props.Article.date_published},this.props.Article.short_published)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.props.Article.url,target:'_read',rel:'noopener'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.Article.title)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Collections,{Items:this.props.Article.collections,Filtered:this.props.Filtered}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.props.Article.url,target:'_read',rel:'noopener'},this.abstract(this.props.Article.description,this.state.abstractLength))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tags,{Items:this.props.Article.tags}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Stats,{Slug:this.props.Slug,Name:this.props.Name,ShortName:this.props.ShortName,Stats:this.props.Stats,Article:this.props.Article,FetchContent:this.props.FetchContent,PopularityUrl:this.props.PopularityUrl,BaseUrl:this.props.BaseUrl}))));}}}]);return Item;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Item);var Tags=function(_Component2){_inherits(Tags,_Component2);function Tags(){_classCallCheck(this,Tags);return _possibleConstructorReturn(this,(Tags.__proto__||Object.getPrototypeOf(Tags)).apply(this,arguments));}_createClass(Tags,[{key:'render',value:function render(){if(this.props.Items&&this.props.Items.length>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'tags'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'intro'},'Tags:'),this.props.Items.map(function(tag,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag,{key:tag+'-'+index,Tag:tag});})));}else{return null;}}}]);return Tags;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Tag=function(_Component3){_inherits(Tag,_Component3);function Tag(){_classCallCheck(this,Tag);return _possibleConstructorReturn(this,(Tag.__proto__||Object.getPrototypeOf(Tag)).apply(this,arguments));}_createClass(Tag,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'tag'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"#/filtra/"+escape(this.props.Tag.trim())},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.Tag.trim())));}}]);return Tag;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Collections=function(_Component4){_inherits(Collections,_Component4);function Collections(){_classCallCheck(this,Collections);return _possibleConstructorReturn(this,(Collections.__proto__||Object.getPrototypeOf(Collections)).apply(this,arguments));}_createClass(Collections,[{key:'render',value:function render(){if(this.props.Items&&this.props.Items.length>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collections-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'collections'},this.props.Items.map(function(collection){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:"collection "+collection.slug,key:collection.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"#/categoria/"+collection.slug},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,collection.name)));})));}else{return null;}}}]);return Collections;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Stats=function(_Component5){_inherits(Stats,_Component5);function Stats(props){_classCallCheck(this,Stats);var _this5=_possibleConstructorReturn(this,(Stats.__proto__||Object.getPrototypeOf(Stats)).call(this,props));_this5.getLn=_this5.getLn.bind(_this5);_this5.switchView=_this5.switchView.bind(_this5);_this5.state={"itemProps":{},"avgProps":{},"avgCollectionProps":{},"showBack":false};return _this5;}_createClass(Stats,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var itemProps={},avgProps={},avgCollectionProps={},percent,lnBase=2;if(this.props.Stats&&prevProps.Stats!==this.props.Stats){percent=100*this.getLn(parseInt(this.props.Article.popularity,10),lnBase)/this.getLn(parseInt(this.props.Stats.global.popularity.max,10),lnBase);itemProps={"left":percent<50?Math.round(percent)+'%':'auto',"right":percent<50?'auto':100-percent+'%'};percent=100*this.getLn(parseInt(this.props.Stats.global.popularity.avg,10),lnBase)/this.getLn(parseInt(this.props.Stats.global.popularity.max,10),lnBase);avgProps={"left":percent<50?Math.round(percent)+'%':'auto',"right":percent<50?'auto':100-percent+'%'};if(this.props.Stats.collection){percent=100*this.getLn(parseInt(this.props.Stats.collection.popularity,10),lnBase)/this.getLn(parseInt(this.props.Stats.global.popularity.max,10),lnBase);avgCollectionProps={"left":percent<50?Math.round(percent)+'%':'auto',"right":percent<50?'auto':100-percent+'%'};}else{avgCollectionProps={"display":"none","right":null,"left":null};}this.setState({"itemProps":itemProps,"avgProps":avgProps,"avgCollectionProps":avgCollectionProps});}}},{key:'switchView',value:function switchView(side){this.setState({"showBack":side});}},{key:'getLn',value:function getLn(val,base){if(base>0){return Math.log(val)/Math.log(base);}else{return Math.log(val);}}},{key:'render',value:function render(){var popularity=this.props.Article.popularity!==undefined?parseInt(this.props.Article.popularity,10):0;if(this.props.Stats&&popularity>=10){var classes=this.props.Stats.collection?this.props.Slug:'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"stats-wrapper "+(this.state.showBack?'show-back':'show-front')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StatsTabs,{ShowBack:this.state.showBack,switchView:this.switchView,Logs:this.props.Article.popularity_logs}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stats-tabs-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StatsFront,{Id:this.props.Article.id,AvgProps:this.state.avgProps,AvgCollectionProps:this.state.avgCollectionProps,ShortName:this.props.ShortName,ItemProps:this.state.itemProps,Classes:classes}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StatsBack,{Id:this.props.Article.id,Logs:this.props.Article.popularity_logs,FetchContent:this.props.FetchContent,Active:this.state.showBack?true:false,PopularityUrl:this.props.PopularityUrl,BaseUrl:this.props.BaseUrl,Classes:classes})))));}else{return null;}}}]);return Stats;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var StatsFront=function(_Component6){_inherits(StatsFront,_Component6);function StatsFront(){_classCallCheck(this,StatsFront);return _possibleConstructorReturn(this,(StatsFront.__proto__||Object.getPrototypeOf(StatsFront)).apply(this,arguments));}_createClass(StatsFront,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stats-front'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"item-stats item-stats-"+this.props.Classes,id:"item-stats-"+this.props.Id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-stats-group in',id:"item-stats-group-"+this.props.Id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-stats-line',id:"item-stats-line-"+this.props.Id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"item-stats-rect-avg "+(this.props.AvgProps.right!=='auto'?'invert':''),id:"item-stats-rect-avg-"+this.props.Id,style:this.props.AvgProps},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},'Popolarit\xE0 media')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"item-stats-rect-collection-avg "+(this.props.AvgCollectionProps.right!=='auto'?'invert':''),id:"item-stats-rect-collection-avg-"+this.props.Id,style:this.props.AvgCollectionProps},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},'Popolarit\xE0 media ',this.props.ShortName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"item-stats-rect-item "+(this.props.ItemProps.right!=='auto'?'invert':''),id:"item-stats-rect-item-"+this.props.Id,style:this.props.ItemProps},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},'Popolarit\xE0'))))));}}]);return StatsFront;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var StatsBack=function(_Component7){_inherits(StatsBack,_Component7);function StatsBack(props){_classCallCheck(this,StatsBack);var _this7=_possibleConstructorReturn(this,(StatsBack.__proto__||Object.getPrototypeOf(StatsBack)).call(this,props));_this7.draw=_this7.draw.bind(_this7);_this7.load=_this7.load.bind(_this7);_this7.viewbox=_this7.viewbox.bind(_this7);_this7.dateFormat=_this7.dateFormat.bind(_this7);_this7.state={"lines":[],"log":[],"loading":true,"path":null,"size":{"w":300,"h":90}};return _this7;}_createClass(StatsBack,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.viewbox,false);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.viewbox,false);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.Active!==this.props.Active&&this.props.Active===true&&this.state.log.length===0){this.load();}}},{key:'viewbox',value:function viewbox(){var _this8=this;if(document.querySelector('#chart-pop-'+this.props.Id)!==null){var size={"w":document.querySelector('#chart-pop-'+this.props.Id+" .stats-detail-chart-wrapper").offsetWidth,"h":document.querySelector('#chart-pop-'+this.props.Id+" .stats-detail-chart-wrapper").offsetHeight};this.setState({'size':size},function(){if(_this8.state.log.length>0){_this8.draw();}});}}},{key:'dateFormat',value:function dateFormat(timestamp){var d=new Date(timestamp*1000);var gg="00"+d.getDate();var mm="00"+(d.getMonth()+1);var hh="00"+d.getHours();var nn="00"+d.getMinutes();return gg.substr(gg.length-2)+'/'+mm.substr(mm.length-2)+' '+hh.substr(hh.length-2)+':'+nn.substr(nn.length-2);}},{key:'draw',value:function draw(){var _this9=this;var scaleX=__WEBPACK_IMPORTED_MODULE_7_d3__["f" /* scaleLinear */]().domain([this.state.log[0].timestamp_added,this.state.log[this.state.log.length-1].timestamp_added]).range([0,this.state.size.w]);var scaleY=__WEBPACK_IMPORTED_MODULE_7_d3__["f" /* scaleLinear */]().domain([this.state.log[0].popularity*.85,this.state.log[this.state.log.length-1].popularity]).range([this.state.size.h,0]);var points=[{"x":0,"y":this.state.size.h}];for(var i=0,l=this.state.log.length;i<l;i++){points.push({"x":scaleX(this.state.log[i].timestamp_added),"y":scaleY(this.state.log[i].popularity)});}var area=__WEBPACK_IMPORTED_MODULE_7_d3__["b" /* area */]().x(function(points){return points.x;}).y1(function(points){return points.y;}).y0(function(points){return _this9.state.size.h;}).curve(__WEBPACK_IMPORTED_MODULE_7_d3__["c" /* curveBasis */]);var lines=[];for(var j=1,m=this.state.log.length;j<m-1;j++){lines.push({"x":scaleX(this.state.log[j].timestamp_added)});}this.setState({"lines":lines,"loading":false,"path":area(points)});}},{key:'load',value:function load(){var _this10=this;var location=this.props.BaseUrl+this.props.PopularityUrl+'/'+this.props.Id;this.props.FetchContent(location,{},function(data){if(data.error){console.log(data.errormessage);}else{_this10.setState({"log":data.log.reverse()},function(){_this10.viewbox();});}},function(error){console.log(error);});}},{key:'render',value:function render(){if(parseInt(this.props.Logs,10)>1&&this.state.log.length>1){var h=this.state.size.h;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"stats-back "+(this.state.loading?'loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'stats-logo-small',preserveAspectRatio:'xMidYMid meet',width:'426px',height:'426px',viewBox:'0 0 426 426'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'stats-logo-small-group',transform:'translate(0.000000, 84.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{className:'stats-logo-small-red',transform:'translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) ',x:'205.693434',y:'37.6934342',width:'182',height:'182'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{className:'stats-logo-small-green',transform:'translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) ',x:'38',y:'38',width:'182',height:'182'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"chart chart-"+this.props.Classes,id:'chart-pop-'+this.props.Id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stats-detail-chart-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'stats-detail-chart',preserveAspectRatio:'xMidYMid meet',viewBox:"0 0 "+this.state.size.w+" "+this.state.size.h},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'stats-detail-chart-path'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:this.state.path})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'stats-detail-chart-lines'},this.state.lines.map(function(line){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{key:line.x,x1:line.x,y1:0,x2:line.x,y2:h});}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'y-axis'},'+',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u21E1',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Pop',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u21E3',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'x-axis-start'},this.dateFormat(this.state.log[0].timestamp_added)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'x-axis-legend'},'\u21E2 Tempo \u21E2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'x-axis-end'},this.dateFormat(this.state.log[this.state.log.length-1].timestamp_added))))));}else{return null;}}}]);return StatsBack;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var StatsTabs=function(_Component8){_inherits(StatsTabs,_Component8);function StatsTabs(props){_classCallCheck(this,StatsTabs);var _this11=_possibleConstructorReturn(this,(StatsTabs.__proto__||Object.getPrototypeOf(StatsTabs)).call(this,props));_this11.switchView=_this11.switchView.bind(_this11);_this11.state={"labels":[],"log":[],"loading":true,"path":null,"size":{"w":300,"h":90}};return _this11;}_createClass(StatsTabs,[{key:'switchView',value:function switchView(e,side){e.preventDefault();if(side==='back'){side=true;}else{side=false;}this.props.switchView(side);}},{key:'render',value:function render(){var _this12=this;if(parseInt(this.props.Logs,10)>1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stats-tabs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:"stats-tab "+(this.props.ShowBack?'':'active')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/stats/front',onClick:function onClick(e){_this12.switchView(e,'front');}},'Popolarit\xE0 articolo ',this.props.showBack)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:"stats-tab "+(this.props.ShowBack?'active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/stats/front',onClick:function onClick(e){_this12.switchView(e,'back');}},'Evoluzione popolarit\xE0'))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stats-tabs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'stats-tab active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,'Popolarit\xE0 articolo'))));}}}]);return StatsTabs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Milestone=function(_Component9){_inherits(Milestone,_Component9);function Milestone(){_classCallCheck(this,Milestone);return _possibleConstructorReturn(this,(Milestone.__proto__||Object.getPrototypeOf(Milestone)).apply(this,arguments));}_createClass(Milestone,[{key:'dateFormat',value:function dateFormat(timestamp){var d=new Date(timestamp*1000);var gg="00"+d.getDate();var mm="00"+(d.getMonth()+1);var yy=d.getFullYear();return gg.substr(gg.length-2)+'/'+mm.substr(mm.length-2)+'/'+yy;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'item article milestone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Temi - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('time',{dateTime:this.props.Article.date_published},this.dateFormat(this.props.Article.timestamp_published))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.Article.title))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'milestone-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'milestone-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.Article.description,' \u2014 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.props.Article.url,target:'_read',rel:'noopener'},'Leggi l\'articolo su ',this.props.Article.source))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Ricerche correlate:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.props.Article.tags.map(function(tag){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag,{key:tag,Tag:tag});}))))));}}]);return Milestone;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 627 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 628 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__text_css__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__text_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__text_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Text=function(_Component){_inherits(Text,_Component);function Text(props){_classCallCheck(this,Text);var _this=_possibleConstructorReturn(this,(Text.__proto__||Object.getPrototypeOf(Text)).call(this,props));_this.load=_this.load.bind(_this);_this.state={"title":null,"text":null,"visible":false};return _this;}_createClass(Text,[{key:'componentDidMount',value:function componentDidMount(){this.load();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.Location!==this.props.Location&&this.props.Location.indexOf('/leggi/')>-1){this.load();}else if(prevProps.Location!==this.props.Location&&prevState.visible===true){this.setState({"visible":false,"body":null,"title":null});}}},{key:'load',value:function load(){var _this2=this;var location=""+this.props.Location.replace(/#/ig,'')+'.json';if(location){this.props.FetchContent(location,{},function(data){if(data.error){console.log(data.errormessage);window.location.hash='/leggi/errore';}else{_this2.setState({"title":data.title,"text":data.text,"visible":true});_this2.props.SetTitle(data.title);_this2.props.ShowLoading(false);}},function(error){console.log(error);window.location.hash='/leggi/errore';});}}},{key:'render',value:function render(){if(this.state.visible){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'text-title'},this.state.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-body',dangerouslySetInnerHTML:{__html:this.state.text}}));}else{return null;}}}]);return Text;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Text);

/***/ }),
/* 630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stats_css__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stats_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__stats_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charts_parliament_js__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__charts_scatter_js__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__charts_milestones_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__charts_matrix_js__ = __webpack_require__(200);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Stats=function(_Component){_inherits(Stats,_Component);function Stats(){_classCallCheck(this,Stats);return _possibleConstructorReturn(this,(Stats.__proto__||Object.getPrototypeOf(Stats)).apply(this,arguments));}_createClass(Stats,[{key:'componentDidMount',value:function componentDidMount(){this.props.SetTitle("Analisi");this.props.ShowLoading(false);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stats'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'stats-title'},'Analisi'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Giochiamo coi dati a nostra disposizione. Su questa pagina puoi trovare grafici e visualizzazioni che evidenziano i rapporti tra stampa, utenti dei social network, e politica. Questa pagina non contiene previsioni elettorali o giudizi sui candidati e sui loro programmi, ma solo rielaborazioni grafiche dei dati in nostro possesso relativi agli articoli e alla loro popolarit\xE0 sui Social Network.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Articoli e schieramenti'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MilestonesAndReactions,{FetchContent:this.props.FetchContent,ShowLoading:this.props.ShowLoading,BaseUrl:this.props.BaseUrl,VizUrl:this.props.VizUrl,AnimationDuration:this.props.AnimationDuration}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CollectionsMatrix,{FetchContent:this.props.FetchContent,ShowLoading:this.props.ShowLoading,BaseUrl:this.props.BaseUrl,VizUrl:this.props.VizUrl,AnimationDuration:this.props.AnimationDuration}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PoliticiansMatrix2,{FetchContent:this.props.FetchContent,ShowLoading:this.props.ShowLoading,BaseUrl:this.props.BaseUrl,VizUrl:this.props.VizUrl,AnimationDuration:this.props.AnimationDuration}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PoliticiansMatrix,{FetchContent:this.props.FetchContent,ShowLoading:this.props.ShowLoading,BaseUrl:this.props.BaseUrl,VizUrl:this.props.VizUrl,AnimationDuration:this.props.AnimationDuration}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ParliamentByVolume,{FetchContent:this.props.FetchContent,ShowLoading:this.props.ShowLoading,BaseUrl:this.props.BaseUrl,VizUrl:this.props.VizUrl,AnimationDuration:this.props.AnimationDuration}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ParliamentByPopularity,{FetchContent:this.props.FetchContent,ShowLoading:this.props.ShowLoading,BaseUrl:this.props.BaseUrl,VizUrl:this.props.VizUrl,AnimationDuration:this.props.AnimationDuration})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Fonti e media'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SourcesActivityByPopularity,{FetchContent:this.props.FetchContent,ShowLoading:this.props.ShowLoading,BaseUrl:this.props.BaseUrl,VizUrl:this.props.VizUrl,AnimationDuration:this.props.AnimationDuration})));}}]);return Stats;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Stats);var ParliamentByVolume=function(_Component2){_inherits(ParliamentByVolume,_Component2);function ParliamentByVolume(props){_classCallCheck(this,ParliamentByVolume);var _this2=_possibleConstructorReturn(this,(ParliamentByVolume.__proto__||Object.getPrototypeOf(ParliamentByVolume)).call(this,props));_this2.load=_this2.load.bind(_this2);_this2.createData=_this2.createData.bind(_this2);_this2.state={"drawing_data":{},"id":"ParliamentByVolume","items":[],"loading":true,"updated":null};return _this2;}_createClass(ParliamentByVolume,[{key:'componentDidMount',value:function componentDidMount(){this.load();}},{key:'dateFormat',value:function dateFormat(timestamp){var d=new Date(timestamp*1000);var gg="00"+d.getDate();var mm="00"+(d.getMonth()+1);var YY="00"+d.getFullYear();var hh="00"+d.getHours();var nn="00"+d.getMinutes();return gg.substr(gg.length-2)+'/'+mm.substr(mm.length-2)+'/'+YY.substr(YY.length-4)+' '+hh.substr(hh.length-2)+':'+nn.substr(nn.length-2);}},{key:'load',value:function load(){var _this3=this;this.props.FetchContent(this.props.BaseUrl+this.props.VizUrl+'/articles/number-by-collection',{},function(response){_this3.setState({"items":response.data,"updated":_this3.dateFormat(response.generated)},function(){_this3.createData();});},function(error){console.log(error);});}},{key:'createData',value:function createData(){var total=0,scale,data={};this.state.items.forEach(function(i){total+=parseInt(i.volume,10);});scale=__WEBPACK_IMPORTED_MODULE_1_d3__["f" /* scaleLinear */]().domain([0,total]).range([0,1]);this.state.items.forEach(function(i){data[i.slug]={"id":i.id,"label":i.name,"slug":i.slug,"percent":scale(i.volume)};});data.ready=true;this.setState({"drawing_data":data,"loading":false});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'block block-chart parliament articles-parliament',id:"parliament-"+this.state.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'intro'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Se gli articoli fossero voti...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Come sarebbe il parlamento se la copertura data dai media a ogni schieramento politico rappresentasse fedelmente le intenzioni di voto degli elettori? Questo grafico \xE8 un esercizio che non tiene conto di ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'come'),' i media parlino di uno schieramento politico. Come si usa dire: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'l\'importante \xE8 che se ne parli'),'.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"chart "+(this.state.loading?"":"ready")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-loading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'stats-logo-small',preserveAspectRatio:'xMidYMid meet',width:'426px',height:'426px',viewBox:'0 0 426 426'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'stats-logo-small-group',transform:'translate(0.000000, 84.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{className:'stats-logo-small-red',transform:'translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) ',x:'205.693434',y:'37.6934342',width:'182',height:'182'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{className:'stats-logo-small-green',transform:'translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) ',x:'38',y:'38',width:'182',height:'182'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-dataviz'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__charts_parliament_js__["a" /* default */],{DrawingData:this.state.drawing_data,ChartId:this.state.id})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'method'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Metodo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Questa visualizzazione non rappresenta i risultati di un sondaggio elettorale. Le percentuali attribuite a ciascuno schieramento sono calcolate sulla base del numero di articoli importati dai nostri bot e da essi attribuiti ai diversi schieramenti. Si tratta pi\xF9 che di una proiezione dei voti, di una istantanea di quanto spazio la stampa dedica ai diversi schieramenti. I dati sono aggiornati ogni 24 ore ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'(ultimo aggiornamento: ',this.state.updated,')'),'.')));}}]);return ParliamentByVolume;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ParliamentByPopularity=function(_Component3){_inherits(ParliamentByPopularity,_Component3);function ParliamentByPopularity(props){_classCallCheck(this,ParliamentByPopularity);var _this4=_possibleConstructorReturn(this,(ParliamentByPopularity.__proto__||Object.getPrototypeOf(ParliamentByPopularity)).call(this,props));_this4.load=_this4.load.bind(_this4);_this4.createData=_this4.createData.bind(_this4);_this4.dateFormat=_this4.dateFormat.bind(_this4);_this4.state={"drawing_data":{},"id":"ParliamentByPopularity","items":[],"loading":true,"updated":null};return _this4;}_createClass(ParliamentByPopularity,[{key:'componentDidMount',value:function componentDidMount(){this.load();}},{key:'dateFormat',value:function dateFormat(timestamp){var d=new Date(timestamp*1000);var gg="00"+d.getDate();var mm="00"+(d.getMonth()+1);var YY="00"+d.getFullYear();var hh="00"+d.getHours();var nn="00"+d.getMinutes();return gg.substr(gg.length-2)+'/'+mm.substr(mm.length-2)+'/'+YY.substr(YY.length-4)+' '+hh.substr(hh.length-2)+':'+nn.substr(nn.length-2);}},{key:'load',value:function load(){var _this5=this;this.props.FetchContent(this.props.BaseUrl+this.props.VizUrl+'/articles/number-by-collection',{},function(response){_this5.setState({"items":response.data,"updated":_this5.dateFormat(response.generated)},function(){_this5.createData();});},function(error){console.log(error);});}},{key:'createData',value:function createData(){var total=0,scale,data={};this.state.items.forEach(function(i){total+=parseInt(i.popularity,10);});scale=__WEBPACK_IMPORTED_MODULE_1_d3__["f" /* scaleLinear */]().domain([0,total]).range([0,1]);this.state.items.forEach(function(i){data[i.slug]={"id":i.id,"label":i.name,"slug":i.slug,"percent":scale(i.popularity)};});data.ready=true;this.setState({"drawing_data":data,"loading":false});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'block block-chart parliament articles-parliament',id:"parliament-"+this.state.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'intro'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Se le condivisioni fossero voti...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'La base di dati \xE8 la stessa della visualizzazione precedente, ma questa volta ad attribuire i voti ai diversi schieramenti non sono il numero di articoli, ma l\'indice di popolarit\xE0 attribuito a questi articoli. Questa visualizzazione consente di vedere quali schieramenti generano pi\xF9 reazioni tra il pubblico, indipendentemente dalla copertura che ottengono dai giornali.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"chart "+(this.state.loading?"":"ready")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-loading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'stats-logo-small',preserveAspectRatio:'xMidYMid meet',width:'426px',height:'426px',viewBox:'0 0 426 426'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'stats-logo-small-group',transform:'translate(0.000000, 84.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{className:'stats-logo-small-red',transform:'translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) ',x:'205.693434',y:'37.6934342',width:'182',height:'182'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{className:'stats-logo-small-green',transform:'translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) ',x:'38',y:'38',width:'182',height:'182'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-dataviz'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__charts_parliament_js__["a" /* default */],{DrawingData:this.state.drawing_data,ChartId:this.state.id})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'method'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Metodo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Questa visualizzazione non rappresenta i risultati di un sondaggio elettorale. Le percentuali attribuite a ciascuno schieramento sono calcolate sulla base del numero di condivisioni degli articoli importati dai nostri bot e da essi attribuiti ai diversi schieramenti. Si tratta, pi\xF9 che di una proiezione dei voti, di una istantanea di quanto siano attivi online i sostenitori dei diversi schieramenti. I dati sono aggiornati ogni 24 ore ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'(ultimo aggiornamento: ',this.state.updated,')'),'.')));}}]);return ParliamentByPopularity;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var SourcesActivityByPopularity=function(_Component4){_inherits(SourcesActivityByPopularity,_Component4);function SourcesActivityByPopularity(props){_classCallCheck(this,SourcesActivityByPopularity);var _this6=_possibleConstructorReturn(this,(SourcesActivityByPopularity.__proto__||Object.getPrototypeOf(SourcesActivityByPopularity)).call(this,props));_this6.load=_this6.load.bind(_this6);_this6.dateFormat=_this6.dateFormat.bind(_this6);_this6.state={"id":"SourceByActivityAndPopularity","items":{"items":[],"ready":false},"loading":true,"max_activity":0,"max_popularity":0,"avg_activity":0,"avg_popularity":0,"updated":null};return _this6;}_createClass(SourcesActivityByPopularity,[{key:'componentDidMount',value:function componentDidMount(){this.load();}},{key:'dateFormat',value:function dateFormat(timestamp){var d=new Date(timestamp*1000);var gg="00"+d.getDate();var mm="00"+(d.getMonth()+1);var YY="00"+d.getFullYear();var hh="00"+d.getHours();var nn="00"+d.getMinutes();return gg.substr(gg.length-2)+'/'+mm.substr(mm.length-2)+'/'+YY.substr(YY.length-4)+' '+hh.substr(hh.length-2)+':'+nn.substr(nn.length-2);}},{key:'load',value:function load(){var _this7=this;this.props.FetchContent(this.props.BaseUrl+this.props.VizUrl+'/sources/activity-and-popularity',{},function(response){var drawingData={"items":response.data,"ready":true};_this7.setState({"items":drawingData,"max_activity":response.max_activity,"max_popularity":response.max_popularity,"avg_activity":response.avg_activity,"avg_popularity":response.avg_popularity,"loading":false,"updated":_this7.dateFormat(response.generated)});},function(error){console.log(error);});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'block block-chart scatter sources-scatter',id:"scatter-"+this.state.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'intro'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'La popolarit\xE0 di una fonte \xE8 correlata con la quantit\xE0 di news pubblicate?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Quali sono i siti pi\xF9 popolari? Quali i pi\xF9 attivi (in termine di news pubblicate)? Esiste una correlazione tra questi due indici? In questo grafico i punti rappresentato i siti aggregati per dominio (ad esempio "www.repubblica.it" e "espresso.repubblica.it" sono calcolati assieme, come "repubblica.it"). Pi\xF9 un punto \xE8 "in alto" rispetto all\'asse ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'x'),', tanto pi\xF9 il sito \xE8 popolare; pi\xF9 il punto \xE8 lontano dall\'asse ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'y'),', pi\xF9 il sito \xE8 attivo. La linea verde rappresenta la ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'regressione lineare'),' della serie, ovvero una proiezione statistica di quale, sulla base dei dati a disposizione, dovrebbe essere la relazione tra attivit\xE0 e popolarit\xE0.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"chart "+(this.state.loading?"":"ready")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-loading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'stats-logo-small',preserveAspectRatio:'xMidYMid meet',width:'426px',height:'426px',viewBox:'0 0 426 426'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'stats-logo-small-group',transform:'translate(0.000000, 84.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{className:'stats-logo-small-red',transform:'translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) ',x:'205.693434',y:'37.6934342',width:'182',height:'182'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{className:'stats-logo-small-green',transform:'translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) ',x:'38',y:'38',width:'182',height:'182'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-dataviz'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__charts_scatter_js__["a" /* default */],{DrawingData:this.state.items,ChartId:this.state.id,Updated:this.state.updated,MinX:'0',MinY:'0',MaxX:this.state.max_activity,MaxY:this.state.max_popularity,LabelX:'Attivit\xE0',LabelY:'Popolarit\xE0'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'method'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Metodo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'L\'attivit\xE0 corrisponde al numero di articoli importati e pubblicati per ogni fonte. La popolarit\xE0 invece si basa sul valore medio dell\'indice di popolarit\xE0 degli articoli pubblicati da una determinata fonte; l\'indice di popolarit\xE0 \xE8 dato dai valori pesati delle condivisioni di ogni articolo su Facebook e Twitter ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'(ultimo aggiornamento: ',this.state.updated,')'),'.')));}}]);return SourcesActivityByPopularity;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var MilestonesAndReactions=function(_Component5){_inherits(MilestonesAndReactions,_Component5);function MilestonesAndReactions(props){_classCallCheck(this,MilestonesAndReactions);var _this8=_possibleConstructorReturn(this,(MilestonesAndReactions.__proto__||Object.getPrototypeOf(MilestonesAndReactions)).call(this,props));_this8.setDate=_this8.setDate.bind(_this8);_this8.setLoading=_this8.setLoading.bind(_this8);_this8.state={"charts":[{"collection":"Movimento 5 Stelle","collection_slug":"m5s","milestone_id":32},{"collection":"Centro Destra","collection_slug":"centro-destra","milestone_id":32},{"collection":"Movimento 5 Stelle","collection_slug":"m5s","milestone_id":31},{"collection":"Centro Destra","collection_slug":"centro-destra","milestone_id":31},{"collection":"Movimento 5 Stelle","collection_slug":"m5s","milestone_id":26},{"collection":"Centro Destra","collection_slug":"centro-destra","milestone_id":26},{"collection":"Movimento 5 Stelle","collection_slug":"m5s","milestone_id":25},{"collection":"Centro Destra","collection_slug":"centro-destra","milestone_id":25},{"collection":"Centro Destra","collection_slug":"centro-destra","milestone_id":24},{"collection":"Movimento 5 Stelle","collection_slug":"m5s","milestone_id":23},{"collection":"Movimento 5 Stelle","collection_slug":"m5s","milestone_id":22},{"collection":"Centro Destra","collection_slug":"centro-destra","milestone_id":22},{"collection":"Movimento 5 Stelle","collection_slug":"m5s","milestone_id":21},{"collection":"Centro Destra","collection_slug":"centro-destra","milestone_id":21},{"collection":"Centro Sinistra","collection_slug":"centro-sinistra","milestone_id":21},{"collection":"Sinistra","collection_slug":"sinistra","milestone_id":21},{"collection":"Destra","collection_slug":"destra","milestone_id":21},{"collection":"Destra","collection_slug":"destra","milestone_id":18},{"collection":"Movimento 5 Stelle","collection_slug":"m5s","milestone_id":17},{"collection":"Sinistra","collection_slug":"sinistra","milestone_id":15},{"collection":"Destra","collection_slug":"destra","milestone_id":14},{"collection":"Centro Destra","collection_slug":"centro-destra","milestone_id":10},{"collection":"Centro Sinistra","collection_slug":"centro-sinistra","milestone_id":9},{"collection":"Movimento 5 Stelle","collection_slug":"m5s","milestone_id":7}],"id":"ActivityAndPopularityByCollectionAndMilestones","items":{"items":[],"ready":false},"loading":true,"updated":null};return _this8;}_createClass(MilestonesAndReactions,[{key:'setDate',value:function setDate(timestamp){var d=new Date(timestamp*1000);var gg="00"+d.getDate();var mm="00"+(d.getMonth()+1);var YY="00"+d.getFullYear();var hh="00"+d.getHours();var nn="00"+d.getMinutes();this.setState({"updated":gg.substr(gg.length-2)+'/'+mm.substr(mm.length-2)+'/'+YY.substr(YY.length-4)+' '+hh.substr(hh.length-2)+':'+nn.substr(nn.length-2)});}},{key:'setLoading',value:function setLoading(show){this.setState({"loading":show});}},{key:'render',value:function render(){var props=this.props;var state=this.state;var setDate=this.setDate;var setLoading=this.setLoading;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'block block-chart milestone milestone-area',id:"milestone-"+this.state.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'intro'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Quali avvenimenti hanno influito sulla copertura mediatica di queste elezioni?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Nel corso di questa campagna elettorale abbiamo individuato dei ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/temi/'},'temi'),' che rappresentato degli avvenimenti importanti, e che a nostro parere avrebbero potuto influenzare l\'esito del voto. Con questi grafici cercheremo di capire se hanno influenzato la copertura dei media per lo schieramento coinvolto, e come hanno reagito i Social Network.')),this.state.charts.map(function(chart,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"milestone-"+index+"-"+chart.collection_slug,className:"chart "+(state.loading?"":"ready"),id:"milestone-"+index+"-"+chart.collection_slug},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-loading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'stats-logo-small',preserveAspectRatio:'xMidYMid meet',width:'426px',height:'426px',viewBox:'0 0 426 426'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'stats-logo-small-group',transform:'translate(0.000000, 84.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{className:'stats-logo-small-red',transform:'translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) ',x:'205.693434',y:'37.6934342',width:'182',height:'182'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{className:'stats-logo-small-green',transform:'translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) ',x:'38',y:'38',width:'182',height:'182'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-dataviz'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__charts_milestones_js__["a" /* default */],{Collection:chart.collection,CollectionSlug:chart.collection_slug,MilestoneId:chart.milestone_id,ChartId:"milestone-"+index+"-"+chart.collection_slug,FetchContent:props.FetchContent,BaseUrl:props.BaseUrl,VizUrl:props.VizUrl,AnimationDuration:props.AnimationDuration,SetDate:setDate,SetLoading:setLoading}))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'method'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Metodo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'L\'indice di "attivit\xE0" rappresenta il numero di articoli pubblicati ogni giorno dai siti che monitoriamo e che i nostri bot hanno assegnato a un determinato schieramento. L\'indice di "popolarit\xE0" \xE8 invece la media quotidiana della popolarit\xE0 di ogni articolo compreso nel dataset. L\'indice di popolarit\xE0 di un articolo \xE8 un valore pesato calcolato tenendo conto di tweet, retweet, favorites (e numero di follower di chi li fa) e di commenti, condivisioni, e reazioni su Facebook ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'(ultimo aggiornamento: ',this.state.updated,')'),'.')));}}]);return MilestonesAndReactions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var CollectionsMatrix=function(_Component6){_inherits(CollectionsMatrix,_Component6);function CollectionsMatrix(props){_classCallCheck(this,CollectionsMatrix);var _this9=_possibleConstructorReturn(this,(CollectionsMatrix.__proto__||Object.getPrototypeOf(CollectionsMatrix)).call(this,props));_this9.load=_this9.load.bind(_this9);_this9.dateFormat=_this9.dateFormat.bind(_this9);_this9.state={"collections":[],"id":"CollectionsMatrix","max":0,"matrix":[],"min":0,"loading":true,"updated":null};return _this9;}_createClass(CollectionsMatrix,[{key:'componentDidMount',value:function componentDidMount(){this.load();}},{key:'dateFormat',value:function dateFormat(timestamp){var d=new Date(timestamp*1000);var gg="00"+d.getDate();var mm="00"+(d.getMonth()+1);var YY="00"+d.getFullYear();var hh="00"+d.getHours();var nn="00"+d.getMinutes();return gg.substr(gg.length-2)+'/'+mm.substr(mm.length-2)+'/'+YY.substr(YY.length-4)+' '+hh.substr(hh.length-2)+':'+nn.substr(nn.length-2);}},{key:'load',value:function load(){var _this10=this;this.props.FetchContent(this.props.BaseUrl+this.props.VizUrl+'/articles/map-by-collection-collision',{},function(response){_this10.setState({"matrix":response.data.matrix,"max":response.data.max,"min":response.data.min,"collections":response.data.collections,"loading":false,"updated":_this10.dateFormat(response.generated)});},function(error){console.log(error);});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'block block-chart matrix',id:"matrix-"+this.state.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'intro'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Quanti articoli parlano di pi\xF9 di uno schieramento? Articoli comuni indicano conflitti o convergenze?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'La matrice mostra quanti sono i punti di contatto tra i diversi schieramenti. Ovviamente, anche qui, non si parla di contenuti dei programmi elettorali, ma di come la stampa tende ad associare i gruppi partecipanti alle prossime elezioni.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"chart "+(this.state.loading?"":"ready")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-loading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'stats-logo-small',preserveAspectRatio:'xMidYMid meet',width:'426px',height:'426px',viewBox:'0 0 426 426'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'stats-logo-small-group',transform:'translate(0.000000, 84.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{className:'stats-logo-small-red',transform:'translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) ',x:'205.693434',y:'37.6934342',width:'182',height:'182'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{className:'stats-logo-small-green',transform:'translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) ',x:'38',y:'38',width:'182',height:'182'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-dataviz'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__charts_matrix_js__["a" /* default */],{Matrix:this.state.matrix,Axis:this.state.collections,ChartId:this.state.id,Min:this.state.min,Max:this.state.max})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'method'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Metodo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'La matrice mostra gli stessi schieramenti elettorali sia sulle righe che sulle colonne. Il colore pi\xF9 scuro indica maggiori punti di contatto rispetto a quello pi\xF9 chiaro. Il colore \xE8 determinato estraendo dal nostro database solo gli articoli associati contemporaneamente ai due schieramenti ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'(ultimo aggiornamento: ',this.state.updated,')'),'.')));}}]);return CollectionsMatrix;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var PoliticiansMatrix2=function(_Component7){_inherits(PoliticiansMatrix2,_Component7);function PoliticiansMatrix2(props){_classCallCheck(this,PoliticiansMatrix2);var _this11=_possibleConstructorReturn(this,(PoliticiansMatrix2.__proto__||Object.getPrototypeOf(PoliticiansMatrix2)).call(this,props));_this11.load=_this11.load.bind(_this11);_this11.dateFormat=_this11.dateFormat.bind(_this11);_this11.state={"collections":[],"id":"PoliticiansMatrix","max":0,"matrix":[],"min":0,"loading":true,"query":[{"name":"S. Mattarella","keyword":"Mattarella","slug":"mattarella"},{"name":"C. Cottarelli","keyword":"Cottarelli","slug":"cottarelli"},{"name":"G. Massolo","keyword":"Massolo","slug":"massolo"},{"name":"G. Giorgetti","keyword":"Giorgetti","slug":"giorgetti"},{"name":"G. Bongiorno","keyword":"Bongiorno","slug":"bongiorno"},{"name":"G. Sapelli","keyword":"Sapelli","slug":"sapelli"},{"name":"G. Conte","keyword":"Conte","slug":"conte"},{"name":"G. M. Centinaio","keyword":"Centinaio","slug":"centinaio"},{"name":"N. Molteni","keyword":"Molteni","slug":"molteni"},{"name":"A. Siri","keyword":"Siri","slug":"siri"},{"name":"S. Candiani","keyword":"Candiani","slug":"candiani"},{"name":"M. Salvini","keyword":"Salvini","slug":"salvini"},{"name":"S. Berlusconi","keyword":"Berlusconi","slug":"berlusconi"},{"name":"L. Di Maio","keyword":"Di Maio","slug":"dimaio"},{"name":"M. Renzi","keyword":"Renzi","slug":"renzi"}],"updated":null};return _this11;}_createClass(PoliticiansMatrix2,[{key:'componentDidMount',value:function componentDidMount(){this.load();}},{key:'dateFormat',value:function dateFormat(timestamp){var d=new Date(timestamp*1000);var gg="00"+d.getDate();var mm="00"+(d.getMonth()+1);var YY="00"+d.getFullYear();var hh="00"+d.getHours();var nn="00"+d.getMinutes();return gg.substr(gg.length-2)+'/'+mm.substr(mm.length-2)+'/'+YY.substr(YY.length-4)+' '+hh.substr(hh.length-2)+':'+nn.substr(nn.length-2);}},{key:'load',value:function load(){var _this12=this;this.props.FetchContent(this.props.BaseUrl+this.props.VizUrl+'/articles/map-by-keywords-collision?q='+escape(JSON.stringify(this.state.query))+'&from_date='+escape('2018-03-05 00:00:00'),{},function(response){_this12.setState({"matrix":response.data.matrix,"max":response.data.max,"min":response.data.min,"keywords":response.data.keywords,"loading":false,"updated":_this12.dateFormat(response.generated)});},function(error){console.log(error);});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'block block-chart matrix',id:"matrix-"+this.state.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'intro'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Come interagiscono tra loro i leader dei partiti usciti vincenti da queste elezioni e i possibili primi ministri?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'I risultati delle elezioni non hanno prodotto una netta maggioranza quindi, come ai tempi della prima repubblica, i partiti vincitori hanno iniziato a trattare su se e come formare un governo. La matrice illustra le interazioni (negli articoli di giornale) tra i leader dei partiti e quei personaggi che, a mano a mano, vengono indicati come possibili primi ministri nell\'ipotetico governo che dovrebbe nascere sulle ceneri degli schieramenti che si sono sgretolati dopo la campagna elettorale. Questi dati si riferiscono agli articoli pubblicati ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'dopo'),' il 4 marzo 2018.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"chart "+(this.state.loading?"":"ready")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-loading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'stats-logo-small',preserveAspectRatio:'xMidYMid meet',width:'426px',height:'426px',viewBox:'0 0 426 426'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'stats-logo-small-group',transform:'translate(0.000000, 84.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{className:'stats-logo-small-red',transform:'translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) ',x:'205.693434',y:'37.6934342',width:'182',height:'182'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{className:'stats-logo-small-green',transform:'translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) ',x:'38',y:'38',width:'182',height:'182'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-dataviz'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__charts_matrix_js__["a" /* default */],{Matrix:this.state.matrix,Axis:this.state.keywords,ChartId:this.state.id,Min:this.state.min,Max:this.state.max})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'method'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Metodo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'La matrice mostra gli stessi politici elettorali sia sulle righe che sulle colonne. Il colore pi\xF9 scuro indica maggiori punti di contatto rispetto a quello pi\xF9 chiaro. Il colore \xE8 determinato estraendo dal nostro database solo gli articoli associati contemporaneamente ai due schieramenti ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'(ultimo aggiornamento: ',this.state.updated,')'),'.')));}}]);return PoliticiansMatrix2;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var PoliticiansMatrix=function(_Component8){_inherits(PoliticiansMatrix,_Component8);function PoliticiansMatrix(props){_classCallCheck(this,PoliticiansMatrix);var _this13=_possibleConstructorReturn(this,(PoliticiansMatrix.__proto__||Object.getPrototypeOf(PoliticiansMatrix)).call(this,props));_this13.load=_this13.load.bind(_this13);_this13.dateFormat=_this13.dateFormat.bind(_this13);_this13.state={"collections":[],"id":"PoliticiansMatrix","max":0,"matrix":[],"min":0,"loading":true,"query":[{"name":"S. Mattarella","keyword":"Mattarella","slug":"mattarella"},{"name":"S. Di Stefano","keyword":"Di Stefano","slug":"distefano"},{"name":"G. Meloni","keyword":"Meloni","slug":"meloni"},{"name":"M. Salvini","keyword":"Salvini","slug":"salvini"},{"name":"S. Berlusconi","keyword":"Berlusconi","slug":"berlusconi"},{"name":"A. Tajani","keyword":"Tajani","slug":"tajani"},{"name":"M. E. A. Casellati","keyword":"Casellati","slug":"casellati"},{"name":"B. Grillo","keyword":"Grillo","slug":"grillo"},{"name":"L. Di Maio","keyword":"Di Maio","slug":"dimaio"},{"name":"A. Di Battista","keyword":"Di Battista","slug":"dibattista"},{"name":"R. Fico","keyword":"Fico","slug":"fico"},{"name":"M. Renzi","keyword":"Renzi","slug":"renzi"},{"name":"M. Martina","keyword":"Martina","slug":"martina"},{"name":"E. Bonino","keyword":"Bonino","slug":"bonino"},{"name":"P. Gentiloni","keyword":"Gentiloni","slug":"gentiloni"},{"name":"P. Grasso","keyword":"Grasso","slug":"grasso"},{"name":"L. Boldrini","keyword":"Boldrini","slug":"boldrini"},{"name":"V. Carofalo","keyword":"Carofalo","slug":"carofalo"}],"updated":null};return _this13;}_createClass(PoliticiansMatrix,[{key:'componentDidMount',value:function componentDidMount(){this.load();}},{key:'dateFormat',value:function dateFormat(timestamp){var d=new Date(timestamp*1000);var gg="00"+d.getDate();var mm="00"+(d.getMonth()+1);var YY="00"+d.getFullYear();var hh="00"+d.getHours();var nn="00"+d.getMinutes();return gg.substr(gg.length-2)+'/'+mm.substr(mm.length-2)+'/'+YY.substr(YY.length-4)+' '+hh.substr(hh.length-2)+':'+nn.substr(nn.length-2);}},{key:'load',value:function load(){var _this14=this;this.props.FetchContent(this.props.BaseUrl+this.props.VizUrl+'/articles/map-by-keywords-collision?q='+escape(JSON.stringify(this.state.query))+'&to_date='+escape('2018-03-04 23:59:59'),{},function(response){_this14.setState({"matrix":response.data.matrix,"max":response.data.max,"min":response.data.min,"keywords":response.data.keywords,"loading":false,"updated":_this14.dateFormat(response.generated)});},function(error){console.log(error);});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'block block-chart matrix',id:"matrix-"+this.state.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'intro'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Come interagiscono tra loro i leader degli schieramenti negli articoli di giornale?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'La matrice mostra quanti sono i punti di contatto tra i diversi leader di schieramento. Anche qui non si parla di contenuti dei programmi elettorali, ma di come la stampa tende ad associare i gruppi partecipanti a queste elezioni. Questa matrice utilizza i dati importati ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'fino al'),' 4 marzo 2018.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"chart "+(this.state.loading?"":"ready")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-loading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'stats-logo-small',preserveAspectRatio:'xMidYMid meet',width:'426px',height:'426px',viewBox:'0 0 426 426'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'stats-logo-small-group',transform:'translate(0.000000, 84.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{className:'stats-logo-small-red',transform:'translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) ',x:'205.693434',y:'37.6934342',width:'182',height:'182'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{className:'stats-logo-small-green',transform:'translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) ',x:'38',y:'38',width:'182',height:'182'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-dataviz'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__charts_matrix_js__["a" /* default */],{Matrix:this.state.matrix,Axis:this.state.keywords,ChartId:this.state.id,Min:this.state.min,Max:this.state.max})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'method'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Metodo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'La matrice mostra gli stessi politici elettorali sia sulle righe che sulle colonne. Il colore pi\xF9 scuro indica maggiori punti di contatto rispetto a quello pi\xF9 chiaro. Il colore \xE8 determinato estraendo dal nostro database solo gli articoli associati contemporaneamente ai due schieramenti ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'(ultimo aggiornamento: ',this.state.updated,')'),'.')));}}]);return PoliticiansMatrix;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/*
 */

/***/ }),
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parliament_css__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parliament_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__parliament_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChartParliament=function(_Component){_inherits(ChartParliament,_Component);function ChartParliament(props){_classCallCheck(this,ChartParliament);var _this=_possibleConstructorReturn(this,(ChartParliament.__proto__||Object.getPrototypeOf(ChartParliament)).call(this,props));_this.draw=_this.draw.bind(_this);_this.format=_this.format.bind(_this);_this.state={"arcs":{"sinistra":null,"centro-sinistra":null,"m5s":null,"centro-destra":null,"destra":null,"border":null},"loading":true};return _this;}_createClass(ChartParliament,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.DrawingData!==this.props.DrawingData&&this.props.DrawingData.ready){this.draw();}}},{key:'format',value:function format(percent){return(percent*100).toLocaleString();}},{key:'draw',value:function draw(){var innerRadius=40;var outerRadius=160;var startAngle=-Math.PI/2;var arc=__WEBPACK_IMPORTED_MODULE_1_d3__["a" /* arc */]();var endAngle=startAngle+Math.PI*this.props.DrawingData['sinistra'].percent;var sinistra=arc({innerRadius:innerRadius,outerRadius:outerRadius,startAngle:startAngle,endAngle:endAngle});endAngle=endAngle+Math.PI*this.props.DrawingData['centro-sinistra'].percent;var centroSinistra=arc({innerRadius:innerRadius,outerRadius:outerRadius,startAngle:startAngle,endAngle:endAngle});endAngle=endAngle+Math.PI*this.props.DrawingData['m5s'].percent;var m5s=arc({innerRadius:innerRadius,outerRadius:outerRadius,startAngle:startAngle,endAngle:endAngle});endAngle=endAngle+Math.PI*this.props.DrawingData['centro-destra'].percent;var centroDestra=arc({innerRadius:innerRadius,outerRadius:outerRadius,startAngle:startAngle,endAngle:endAngle});var destra=arc({innerRadius:innerRadius,outerRadius:outerRadius,startAngle:startAngle,endAngle:Math.PI/2});this.setState({"loading":false,"arcs":{"sinistra":sinistra,"centro-sinistra":centroSinistra,"m5s":m5s,"centro-destra":centroDestra,"destra":destra,"border":destra}});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-parliament',id:"chart-parliament-"+this.props.ChartId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'chart-parliament-viz',preserveAspectRatio:'xMidYMid meet',viewBox:'0 0 400 200'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'chart-parliament-arcs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'chart-parliament-arc chart-parliament-destra',d:this.state.arcs['destra']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'chart-parliament-arc chart-parliament-centro-destra',d:this.state.arcs['centro-destra']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'chart-parliament-arc chart-parliament-m5s',d:this.state.arcs['m5s']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'chart-parliament-arc chart-parliament-centro-sinistra',d:this.state.arcs['centro-sinistra']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'chart-parliament-arc chart-parliament-sinistra',d:this.state.arcs['sinistra']})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'chart-parliament-borders'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'chart-parliament-base',x1:'-50%',y1:'0',x2:'50%',y2:'0',strokeWidth:'4',stroke:'#ccc'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'chart-parliament-border',d:this.state.arcs.border,fill:'transparent',strokeWidth:'4',stroke:'#ccc'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'chart-parliament-base',x1:'-50%',y1:'0',x2:'50%',y2:'0',strokeWidth:'4',stroke:'#ccc'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{className:'chart-parliament-hole',cx:'0',cy:'0',r:'39',fill:'#fff'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-parliament-legend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'chart-parliament-legend-item sinistra'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/categoria/sinistra',className:' '},'Sinistra'),' \u2014 ',this.props.DrawingData&&this.props.DrawingData['sinistra']?this.format(this.props.DrawingData['sinistra'].percent):"",'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'chart-parliament-legend-item centro-sinistra'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/categoria/centro-sinistra',className:' '},'Centro Sinistra'),' \u2014 ',this.props.DrawingData&&this.props.DrawingData['centro-sinistra']?this.format(this.props.DrawingData['centro-sinistra'].percent):"",'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'chart-parliament-legend-item m5s'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/categoria/m5s',className:' '},'Movimento 5 Stelle'),' \u2014 ',this.props.DrawingData&&this.props.DrawingData['m5s']?this.format(this.props.DrawingData['m5s'].percent):"",'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'chart-parliament-legend-item centro-destra'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/categoria/centro-destra',className:''},'Centro Destra'),' \u2014 ',this.props.DrawingData&&this.props.DrawingData['centro-destra']?this.format(this.props.DrawingData['centro-destra'].percent):"",'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'chart-parliament-legend-item destra'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/categoria/destra',className:' '},'Destra'),' \u2014 ',this.props.DrawingData&&this.props.DrawingData['destra']?this.format(this.props.DrawingData['destra'].percent):"",'%'))));}}]);return ChartParliament;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ChartParliament);

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scatter_css__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scatter_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__scatter_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChartScatter=function(_Component){_inherits(ChartScatter,_Component);function ChartScatter(props){_classCallCheck(this,ChartScatter);var _this=_possibleConstructorReturn(this,(ChartScatter.__proto__||Object.getPrototypeOf(ChartScatter)).call(this,props));_this.viewbox=_this.viewbox.bind(_this);_this.draw=_this.draw.bind(_this);_this.findLineByLeastSquares=_this.findLineByLeastSquares.bind(_this);_this.state={"avg":{"x":{"x1":0,"y1":0,"x2":0,"y2":0},"y":{"x1":0,"y1":0,"x2":0,"y2":0}},"axis":{"x":{"x1":0,"y1":0,"x2":0,"y2":0,"label":{"x":0,"y":0}},"y":{"x1":0,"y1":0,"x2":0,"y2":0,"label":{"x":0,"y":0}}},"loading":false,"point_config":{"h":15,"rx":3,"ry":3,"w":15},"points":[],"regression":{"x1":0,"y1":0,"x2":0,"y2":0},"size":{"h":200,"w":400}};return _this;}_createClass(ChartScatter,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.DrawingData!==this.props.DrawingData&&this.props.DrawingData.ready){this.draw();}}},{key:'componentDidMount',value:function componentDidMount(){this.viewbox();window.addEventListener('resize',this.viewbox,false);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.viewbox,false);}},{key:'viewbox',value:function viewbox(){var _this2=this;if(document.querySelector('#chart-scatter-'+this.props.ChartId)!==null){var size={"w":document.querySelector('#chart-scatter-'+this.props.ChartId).offsetWidth,"h":document.querySelector('#chart-scatter-'+this.props.ChartId).offsetHeight};this.setState({'size':size},function(){if(_this2.props.DrawingData&&_this2.props.DrawingData.ready){_this2.draw();}});}}},{key:'findLineByLeastSquares',value:function findLineByLeastSquares(values_x,values_y){var sum_x=0;var sum_y=0;var sum_xy=0;var sum_xx=0;var count=0;var x=0;var y=0;var v=0;var values_length=values_x.length;if(values_length!==values_y.length){throw new Error('The parameters values_x and values_y need to have same size!');}/*
	     * Nothing to do.
	     */if(values_length===0){return[[],[]];}/*
	     * Calculate the sum for each of the parts necessary.
	     */for(v=0;v<values_length;v++){x=values_x[v];y=values_y[v];sum_x+=x;sum_y+=y;sum_xx+=x*x;sum_xy+=x*y;count++;}/*
	     * Calculate m and b for the formular:
	     * y = x * m + b
	     */var m=(count*sum_xy-sum_x*sum_y)/(count*sum_xx-sum_x*sum_x);var b=sum_y/count-m*sum_x/count;/*
	     * We will make the x and y result line now
	     */var result_values_x=[];var result_values_y=[];for(v=0;v<values_length;v++){x=values_x[v];y=x*m+b;result_values_x.push(x);result_values_y.push(y);}return[result_values_x,result_values_y];}},{key:'draw',value:function draw(){var scaleX=__WEBPACK_IMPORTED_MODULE_1_d3__["f" /* scaleLinear */]().domain([this.props.MinX,this.props.MaxX]).range([40,this.state.size.w-40]);var scaleY=__WEBPACK_IMPORTED_MODULE_1_d3__["f" /* scaleLinear */]().domain([this.props.MinY,this.props.MaxY]).range([this.state.size.h-40,20]);var points=[],xVal=[],yVal=[],regression=[],totX=0,totY=0;var point_config=this.state.point_config;this.props.DrawingData.items.forEach(function(p){xVal.push(parseFloat(p.activity));yVal.push(parseFloat(p.popularity));points.push({"id":p.id,"label":p.label,"x":scaleX(p.activity)-point_config.w/2,"y":scaleY(p.popularity)-point_config.h/2});totX+=parseFloat(p.activity);totY+=parseFloat(p.popularity);});var avgX=totX/this.props.DrawingData.items.length;var avgY=totY/this.props.DrawingData.items.length;regression=this.findLineByLeastSquares(xVal,yVal);this.setState({"avg":{"x":{"x1":scaleX(avgX),"y1":scaleY(this.props.MinY),"x2":scaleX(avgX),"y2":scaleY(this.props.MaxY)},"y":{"x1":scaleX(this.props.MinX),"y1":scaleY(avgY),"x2":scaleX(this.props.MaxX),"y2":scaleY(avgY)}},"axis":{"x":{"x1":scaleX(this.props.MinX),"y1":scaleY(this.props.MinY),"x2":scaleX(this.props.MaxX),"y2":scaleY(this.props.MinY),"label":{"x":scaleX(this.props.MaxX/2),"y":this.state.size.h-20}},"y":{"x1":scaleX(this.props.MinX),"y1":scaleY(this.props.MinY),"x2":scaleX(this.props.MinX),"y2":scaleY(this.props.MaxY),"label":{"x":30,"y":scaleY(this.props.MaxY/2)}}},"loading":false,"points":points,"regression":{"x1":scaleX(regression[0][0]),"y1":scaleY(regression[1][0]),"x2":scaleX(regression[0][regression[0].length-1]),"y2":scaleY(regression[1][regression[1].length-1])}});}},{key:'render',value:function render(){var point_config=this.state.point_config;var axis=this.state.axis;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-scatter',id:"chart-scatter-"+this.props.ChartId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'chart-scatter-viz',preserveAspectRatio:'xMidYMid meet',viewBox:"0 0 "+this.state.size.w+" "+this.state.size.h},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'axis'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.axis.x.x1,y1:this.state.axis.x.y1,x2:this.state.axis.x.x2,y2:this.state.axis.x.y2,className:'axis axis-x',strokeWidth:'1',stroke:'red'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.axis.y.x1,y1:this.state.axis.y.y1,x2:this.state.axis.y.x2,y2:this.state.axis.y.y2,className:'axis axis-y',strokeWidth:'1',stroke:'red'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.state.axis.x.label.x,y:this.state.axis.x.label.y,textAnchor:'middle',className:'label label-x'},'- ',this.props.LabelX,' +'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.state.axis.y.label.x,y:this.state.axis.y.label.y,textAnchor:'middle',className:'label label-y',transform:"rotate(-90 "+this.state.axis.y.label.x+" "+this.state.axis.y.label.y+")"},'- ',this.props.LabelY,' +'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:"M"+this.state.axis.x.x2+" "+this.state.axis.x.y2+"L"+(this.state.axis.x.x2-5)+" "+(this.state.axis.x.y2-2)+"L"+(this.state.axis.x.x2-5)+" "+(this.state.axis.x.y2+2)+"Z",className:'arrow arrow-x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:"M"+this.state.axis.y.x2+" "+this.state.axis.y.y2+"L"+(this.state.axis.y.x2-2)+" "+(this.state.axis.y.y2+5)+"L"+(this.state.axis.y.x2+2)+" "+(this.state.axis.y.y2+5)+"Z",className:'arrow arrow-y'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.avg.x.x1,y1:this.state.avg.x.y1,x2:this.state.avg.x.x2,y2:this.state.avg.x.y2,className:'avg avg-x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.avg.y.x1,y1:this.state.avg.y.y1,x2:this.state.avg.y.x2,y2:this.state.avg.y.y2,className:'avg avg-y'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:this.state.regression.x1,y1:this.state.regression.y1,x2:this.state.regression.x2,y2:this.state.regression.y2,className:'regression',strokeWidth:'1',stroke:'red'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.state.avg.x.x1,y:this.state.avg.x.y2,textAnchor:'end',className:'label label-avg',transform:"rotate(-90 "+this.state.avg.x.x1+" "+this.state.avg.x.y2+")"},'Attivit\xE0 media'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.state.avg.y.x2,y:this.state.avg.y.y1,textAnchor:'end',className:'label label-avg'},'Popolarit\xE0 media')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'points'},this.state.points.map(function(point,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{key:"point-"+index,className:'point-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{id:"source-"+point.label,x:point.x,y:point.y,width:point_config.w,height:point_config.h,rx:point_config.rx,ry:point_config.ry,className:"scatter-point "+point.label,title:point.label,transform:"rotate( 45 "+(point.x+point_config.w/2)+" "+(point.y+point_config.h/2)+")"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:point.x>axis.x.x2/2?point.x:point.x+point_config.w,y:point.y+point_config.h/2,textAnchor:point.x>axis.x.x2/2?"end":"start",className:'label label-over'},point.label.trim()));}))));}}]);return ChartScatter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ChartScatter);

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timeline_css__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timeline_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__timeline_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import ChartTimeline from "./charts/parliament.js";
var Timeline=function(_Component){_inherits(Timeline,_Component);function Timeline(props){_classCallCheck(this,Timeline);var _this=_possibleConstructorReturn(this,(Timeline.__proto__||Object.getPrototypeOf(Timeline)).call(this,props));_this.abstract=_this.abstract.bind(_this);_this.dateFormat=_this.dateFormat.bind(_this);_this.draw=_this.draw.bind(_this);_this.getActivity=_this.getActivity.bind(_this);_this.getTopArticles=_this.getTopArticles.bind(_this);_this.setMax=_this.setMax.bind(_this);_this.viewbox=_this.viewbox.bind(_this);_this.writeMarkup=_this.writeMarkup.bind(_this);_this.positionData={};_this.state={"activity":{},"articleHeight":110,"articleWidth":175,"articles":[],"borders":40,"debug":[],"enabled":false,"milestones":[],"max_values":{"activity":-1,"popularity":-1},"min_width":400,"oneDay":60*60*24,"parties":{"destra":"Destra","centro-destra":"C. Destra","m5s":"Mov. 5 Stelle","centro-sinistra":"C. Sinistra","sinistra":"Sinistra"},"paths":{"date_lines":[],"curves":[]},"size":{"h":1600,"w":800},"updated":""};return _this;}_createClass(Timeline,[{key:'componentDidMount',value:function componentDidMount(){this.props.SetTitle("Timeline");this.getTopArticles();window.addEventListener('resize',this.viewbox,false);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.viewbox,false);}},{key:'abstract',value:function abstract(text,maxLength){if(maxLength===undefined){maxLength=75;}if(text.length<=maxLength){return text;}text=text.substr(0,maxLength);return text.substr(0,Math.min(text.length,text.lastIndexOf(" ")))+'…';}},{key:'dateFormat',value:function dateFormat(timestamp,ht){var d=new Date(timestamp*1000);var gg="00"+d.getDate();var mm="00"+(d.getMonth()+1);var YY="00"+d.getFullYear();var hh="00"+d.getHours();var nn="00"+d.getMinutes();return gg.substr(gg.length-2)+'/'+mm.substr(mm.length-2)+'/'+YY.substr(YY.length-4)+(ht===true?'':' '+hh.substr(hh.length-2)+':'+nn.substr(nn.length-2));}},{key:'draw',value:function draw(){var _this2=this;var news=[];var lines=[];var curves=[];var debug=[];var parties=this.state.parties;if(this.state.articles.length>0){var minY=parseInt(this.state.articles[0].date_published_timestamp,10)+this.state.oneDay,maxY=parseInt(this.state.articles[this.state.articles.length-1].date_published_timestamp,10)-this.state.oneDay,maxXActivity=this.state.max_values.activity,maxXPopularity=this.state.max_values.popularity,scaleY=__WEBPACK_IMPORTED_MODULE_1_d3__["f" /* scaleLinear */]().domain([minY,maxY]).range([0,this.state.size.h]);for(var i=0,l=this.state.articles.length;i<l;i++){var y=scaleY(this.state.articles[i].date_published_timestamp);// Articles' list
news[i]=this.state.articles[i];news[i].top=y-6;// SVG lines 
lines.push({"y":y});}}if(Object.keys(this.state.activity).length>0&&this.state.articles.length>0){// Charts
var activity=this.state.activity;var availableSpace=this.state.size.w-this.state.articleWidth-this.state.borders;var slots=availableSpace/Object.keys(activity).length;var baseX=this.state.articleWidth+this.state.borders/2;// Boundaries
Object.keys(activity).forEach(function(key,index){var max=baseX+slots*index;var boundaries={"max":max-slots/3,"center":max+slots/2,"min":max+slots+slots/3};var scaleXActivity=__WEBPACK_IMPORTED_MODULE_1_d3__["f" /* scaleLinear */]().domain([0,maxXActivity]).range([boundaries.center,boundaries.max]);var scaleXPopularity=__WEBPACK_IMPORTED_MODULE_1_d3__["f" /* scaleLinear */]().domain([0,maxXPopularity]).range([boundaries.center,boundaries.max]);var points=[{"xAct":scaleXActivity(0),"xPop":scaleXPopularity(0),"y":scaleY(maxY)}];activity[key].forEach(function(point,index){points.push({"xAct":scaleXActivity(parseInt(point.activity,10)),"xPop":scaleXPopularity(parseInt(point.popularity,10)),"y":scaleY(parseInt(point.timestamp,10))});});var mirror=[];points.forEach(function(point){mirror.push({"xAct":boundaries.center+(boundaries.center-point.xAct),"xPop":boundaries.center+(boundaries.center-point.xPop),"y":point.y});});mirror.reverse();points=points.concat(mirror);var activityArea=__WEBPACK_IMPORTED_MODULE_1_d3__["b" /* area */]().x(function(points){return points.xAct;}).y1(function(points){return points.y;}).curve(__WEBPACK_IMPORTED_MODULE_1_d3__["c" /* curveBasis */]);var popularityArea=__WEBPACK_IMPORTED_MODULE_1_d3__["b" /* area */]().x(function(points){return points.xPop;}).y1(function(points){return points.y;}).curve(__WEBPACK_IMPORTED_MODULE_1_d3__["c" /* curveBasis */]);curves.push({"activityPath":activityArea(points),"name":parties[key],"popularityPath":popularityArea(points),"slug":key,"style":{"left":boundaries.center+'px'}});debug.push(points);});}var milestones=[];if(this.state.milestones.length>0){var pm=0;for(var _i=0,_l=this.state.milestones.length;_i<_l;_i++){if(this.state.milestones[_i].timestamp_published>=news[news.length-1].date_published_timestamp&&this.state.milestones[_i].timestamp_published<=news[0].date_published_timestamp){var milestone=this.state.milestones[_i];milestone.top=scaleY(milestone.timestamp_order);if(pm===milestone.timestamp_order){milestone.position=2;}else{milestone.position=1;}pm=milestone.timestamp_order;milestones.push(milestone);}}}var paths={"date_lines":lines,"curves":curves};this.setState({"articles":news,"debug":debug,"milestones":milestones,"paths":paths},function(){_this2.props.ShowLoading(false);});}},{key:'getActivity',value:function getActivity(){var _this3=this;this.props.FetchContent(this.props.BaseUrl+this.props.VizUrl+'/articles/number-and-popularity-by-day-by-collection-aggregated',{},function(response){if(!response.error){_this3.setState({"activity":response.data,"updated":_this3.dateFormat(response.generated)},function(){_this3.setMax();_this3.viewbox();});}else{console.log(response.errormessage);}},function(error){console.log(error);});}},{key:'getTopArticles',value:function getTopArticles(){var _this4=this;this.props.FetchContent(this.props.BaseUrl+this.props.VizUrl+'/articles/top-by-day',{},function(response){if(!response.error){_this4.setState({"articles":response.data},function(){_this4.getActivity();});}else{console.log(response.errormessage);}},function(error){console.log(error);});}},{key:'setMax',value:function setMax(log){var _this5=this;var activity=this.state.activity;var max_values={"activity":-1,"popularity":-1};Object.keys(activity).forEach(function(key,index){activity[key].forEach(function(day){if(max_values.activity<parseInt(day.activity,10)){max_values.activity=parseInt(day.activity,10);}if(max_values.popularity<parseInt(day.popularity,10)){max_values.popularity=parseInt(day.popularity,10);}});});this.setState({"max_values":max_values},function(){_this5.viewbox();});}},{key:'viewbox',value:function viewbox(){var _this6=this;var width=document.querySelector('#timeline-page').offsetWidth;var size={"w":width,"h":this.state.articles?this.state.articles.length*this.state.articleHeight+this.state.borders:document.querySelector('#timeline-page').offsetHeight};this.setState({'enabled':width>=this.state.min_width?true:false,'size':size},function(){_this6.draw();});}},{key:'writeMarkup',value:function writeMarkup(){var _this7=this;if(this.state.enabled){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timeline--page--viz',style:{"height":this.state.size.h+"px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timeline--page--viz--articles',id:'timeline--page--viz--articles'},this.state.articles.map(function(article){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',{key:article.id,className:'timeline-page--articles--article',style:{"top":article.top+"px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'timeline-page--articles--article--collections'},article.collections.map(function(collection,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:collection.slug+collection.id+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"#/categoria/"+collection.slug,title:collection.name,className:collection.slug},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,collection.name)));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,article.date_published_short),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_read',href:article.url,title:article.title,className:'timeline-page--viz--articles--article--link'},_this7.abstract(article.title),' (',article.source,')')));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timeline--page--viz--legend',id:'timeline--page--viz--legend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'party-title articles'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Articoli pi\xF9 popolari di ogni giorno')),this.state.paths.curves.map(function(curve,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"T-"+index,className:"party-title "+curve.slug,style:curve.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,curve.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'activity'},'Att. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'popularity'},'Pop. '));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{id:'timeline-page--viz--svg',className:'timeline-page--viz--svg',width:this.state.size.w,height:this.state.size.h,preserveAspectRatio:'xMidYMid meet',viewBox:"0 0 "+this.state.size.w+" "+this.state.size.h},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'timeline-page--viz--svg--curves'},this.state.paths.curves.map(function(curve,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{key:"PT-"+index,className:curve.slug},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:curve.activityPath,className:'timeline-page--viz--svg--curve-activity'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:curve.popularityPath,className:'timeline-page--viz--svg--curve-popularity'}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'timeline-page--viz--svg--date-lines'},this.state.paths.date_lines.map(function(line,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{key:"LN-"+index,x1:'0',y1:line.y,x2:_this7.state.size.w,y2:line.y,className:'timeline-page--viz--svg--date-line'});})))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Questa visualizzazione richiede uno schermo grande. Su molti smartphone, \xE8 sufficiente ruotare il telefono in posizione orizzontale per poter vedere correttamente la timeline.'));}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'timeline-page',className:'timeline-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stats'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'stats-title'},'Timeline'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Questa visualizzazione mostra l\'andamento di attivit\xE0 e popolarit\xE0 di ogni schieramento nel tempo. Dato il metodo di calcolo applicato (ogni articolo viene monitorato dal giorno della publicazione per cinque giorni) l\'indice  di popolarit\xE0 degli schieramenti negli ultimi giorni di calendario pu\xF2 variare nel tempo.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Nella prima colonna a sinistra, assieme al calendario, \xE8 mostrato l\'articolo pi\xF9 popolare tra quelli importati quel giorno. Ogni altra colonna rappresenta uno schieramento composto secondo il nostro solito standard: Destra ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'color destra'}),', Centro Destra ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'color centro-destra'}),', Movimento 5 Stelle ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'color m5s'}),', Centro Sinistra ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'color centro-sinistra'}),', e Sinistra ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'color sinistra'}),'. L\'area grigia rappresenta il numero di articoli pubblicati che parlano di quello schieramento, l\'area colorata rappresenta l\'attivit\xE0 sui social network degli stessi articoli (tweets, retweets, like, condivisioni, commenti, ecc.).'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Ultimo aggiornamento: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,this.state.updated),'.')),this.writeMarkup());}}]);return Timeline;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Timeline);

/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer_css__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__footer_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Footer=function(_Component){_inherits(Footer,_Component);function Footer(){_classCallCheck(this,Footer);return _possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).apply(this,arguments));}_createClass(Footer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'main-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'\xA9 ',new Date().getFullYear(),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://visualize.news/',target:'_read',rel:'noopener'},'Visualize News'),' - Designed and developed by ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.makinguse.com/',target:'_read',rel:'noopener'},'Carlo Zapponi'),', ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://simonelippolis.com/',target:'_read',rel:'noopener'},'Simone Lippolis'),' - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/leggi/privacy'},'Informativa sulla privacy e termini del servizio'),' - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://github.com/leeppolis/elezioni-io-data',rel:'noopener'},'Data Source'),'.'));}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loading_css__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loading_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Loading=function(_Component){_inherits(Loading,_Component);function Loading(props){_classCallCheck(this,Loading);var _this=_possibleConstructorReturn(this,(Loading.__proto__||Object.getPrototypeOf(Loading)).call(this,props));_this.timeout=0;_this.hideLoader=_this.hideLoader.bind(_this);_this.showLoader=_this.showLoader.bind(_this);_this.state={"visible":true,"$html":null};return _this;}_createClass(Loading,[{key:'componentDidMount',value:function componentDidMount(){this.setState({"$html":document.documentElement});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){//console.log( prevProps, this.props.Show );
if(prevProps.Show!==this.props.Show){if(this.props.Show){this.setState({"visible":true},this.showLoader);}else{this.hideLoader();}}}},{key:'componentWillUnmout',value:function componentWillUnmout(){clearTimeout(this.timeout);}},{key:'showLoader',value:function showLoader(){var _this2=this;this.state.$html.classList.add("loading-visible");this.timeout=setTimeout(function(){_this2.state.$html.classList.add("loading-in");},1);}},{key:'hideLoader',value:function hideLoader(){var _this3=this;window.scrollTo(0,0);this.state.$html.classList.remove("loading-in");this.timeout=setTimeout(function(){_this3.state.$html.classList.remove("loading-visible");_this3.setState({"visible":false});},this.props.AnimationDuration);}},{key:'render',value:function render(){if(this.state.visible){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{id:'loading-logo-small',preserveAspectRatio:'xMidYMid meet',width:'426px',height:'426px',viewBox:'0 0 426 426'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'loading-logo-small-group',transform:'translate(0.000000, 84.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{id:'loading-logo-small-red',transform:'translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) ',x:'205.693434',y:'37.6934342',width:'182',height:'182'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{id:'loading-logo-small-green',transform:'translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) ',x:'38',y:'38',width:'182',height:'182'}))))));}else{return null;}}}]);return Loading;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Loading);

/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports = {"error":false,"properties":{"base_url":"https://api.elezioni.io","theme_url":"https://api.elezioni.io/themes/e.io","my_url":"stats/articles/global-summary","my_url_clean":"stats/articles/global-summary","referer":null,"time":1532614561,"UTCDateTime":"2018-07-26T14:16:01+00:00","debug":32767},"errormessage":null,"hash":"f743f56cfdd4db72e3ef502edb9303eb.json","data":{"timeline":{"destra":[{"date_published":"2018-02-01","activity":"13","popularity":"1570.5","timestamp":1517439600,"activity_perc":5.1792828685259,"popularity_perc":19.65951054641},{"date_published":"2018-02-02","activity":"9","popularity":"2841.5","timestamp":1517526000,"activity_perc":3.1802120141343,"popularity_perc":7.2753574949112},{"date_published":"2018-02-03","activity":"18","popularity":"31447.5","timestamp":1517612400,"activity_perc":6.6420664206642,"popularity_perc":32.369046761294},{"date_published":"2018-02-04","activity":"8","popularity":"359","timestamp":1517698800,"activity_perc":3.6199095022624,"popularity_perc":2.4378650006791},{"date_published":"2018-02-05","activity":"16","popularity":"99.5","timestamp":1517785200,"activity_perc":6.0606060606061,"popularity_perc":0.0071975166759047},{"date_published":"2018-02-06","activity":"16","popularity":"14521568.75","timestamp":1517871600,"activity_perc":4.9844236760125,"popularity_perc":9.3608193488351},{"date_published":"2018-02-07","activity":"8","popularity":"16290022.75","timestamp":1517958000,"activity_perc":2.7397260273973,"popularity_perc":7.0256589201952},{"date_published":"2018-02-08","activity":"20","popularity":"12210458.5","timestamp":1518044400,"activity_perc":7.8740157480315,"popularity_perc":5.2792525877664},{"date_published":"2018-02-09","activity":"25","popularity":"29907660.75","timestamp":1518130800,"activity_perc":10,"popularity_perc":8.8577874766998},{"date_published":"2018-02-10","activity":"28","popularity":"30950672.5","timestamp":1518217200,"activity_perc":13.084112149533,"popularity_perc":4.1624800230979},{"date_published":"2018-02-11","activity":"6","popularity":"8590894.25","timestamp":1518303600,"activity_perc":3.2786885245902,"popularity_perc":1.8328531209535},{"date_published":"2018-02-12","activity":"9","popularity":"37280437.75","timestamp":1518390000,"activity_perc":3.2374100719424,"popularity_perc":3.4861385657177},{"date_published":"2018-02-13","activity":"8","popularity":"4755148.5","timestamp":1518476400,"activity_perc":2.9520295202952,"popularity_perc":0.91869493679885},{"date_published":"2018-02-14","activity":"6","popularity":"1226790.5","timestamp":1518562800,"activity_perc":2.5316455696203,"popularity_perc":0.26338297998897},{"date_published":"2018-02-15","activity":"15","popularity":"11788313","timestamp":1518649200,"activity_perc":5.6179775280899,"popularity_perc":1.7125643822823},{"date_published":"2018-02-16","activity":"26","popularity":"30289712","timestamp":1518735600,"activity_perc":9.4545454545455,"popularity_perc":3.4132171008386},{"date_published":"2018-02-17","activity":"14","popularity":"21760515.25","timestamp":1518822000,"activity_perc":5.0909090909091,"popularity_perc":1.6542852382767},{"date_published":"2018-02-18","activity":"19","popularity":"54362278","timestamp":1518908400,"activity_perc":7.037037037037,"popularity_perc":10.412501779632},{"date_published":"2018-02-19","activity":"16","popularity":"11284612.5","timestamp":1518994800,"activity_perc":5.8394160583942,"popularity_perc":2.0012533907075},{"date_published":"2018-02-20","activity":"21","popularity":"56013448","timestamp":1519081200,"activity_perc":6.4814814814815,"popularity_perc":7.5143385826549},{"date_published":"2018-02-21","activity":"75","popularity":"192954153.75","timestamp":1519167600,"activity_perc":23.148148148148,"popularity_perc":24.484775483385},{"date_published":"2018-02-22","activity":"56","popularity":"226252608","timestamp":1519254000,"activity_perc":19.858156028369,"popularity_perc":28.661115674272},{"date_published":"2018-02-23","activity":"30","popularity":"86941936.5","timestamp":1519340400,"activity_perc":11.111111111111,"popularity_perc":7.2490381334099},{"date_published":"2018-02-24","activity":"33","popularity":"117603599.75","timestamp":1519426800,"activity_perc":13.524590163934,"popularity_perc":18.214394264532},{"date_published":"2018-02-25","activity":"20","popularity":"28049487","timestamp":1519513200,"activity_perc":9.1743119266055,"popularity_perc":6.5192272266994},{"date_published":"2018-02-26","activity":"26","popularity":"18603230.5","timestamp":1519599600,"activity_perc":9.7378277153558,"popularity_perc":2.4431195869067},{"date_published":"2018-02-27","activity":"23","popularity":"30565866.75","timestamp":1519686000,"activity_perc":9.0551181102362,"popularity_perc":4.0055124877381},{"date_published":"2018-02-28","activity":"17","popularity":"20268643","timestamp":1519772400,"activity_perc":6.0070671378092,"popularity_perc":4.8413181943769},{"date_published":"2018-03-01","activity":"36","popularity":"38643761","timestamp":1519858800,"activity_perc":12.676056338028,"popularity_perc":6.1377612376711},{"date_published":"2018-03-02","activity":"31","popularity":"12185062.5","timestamp":1519945200,"activity_perc":11.610486891386,"popularity_perc":2.9738678547876},{"date_published":"2018-03-03","activity":"9","popularity":"2047005.25","timestamp":1520031600,"activity_perc":5.9210526315789,"popularity_perc":0.72417882758179},{"date_published":"2018-03-04","activity":"6","popularity":"3609091","timestamp":1520118000,"activity_perc":3.7037037037037,"popularity_perc":2.4757514525654},{"date_published":"2018-03-05","activity":"26","popularity":"379134029","timestamp":1520204400,"activity_perc":4.7970479704797,"popularity_perc":5.4770730734967},{"date_published":"2018-03-06","activity":"7","popularity":"349145.75","timestamp":1520290800,"activity_perc":1.5659955257271,"popularity_perc":0.027699533252284},{"date_published":"2018-03-07","activity":"23","popularity":"16335754","timestamp":1520377200,"activity_perc":6.0367454068241,"popularity_perc":2.3231903689612},{"date_published":"2018-03-08","activity":"11","popularity":"2135236.25","timestamp":1520463600,"activity_perc":4.7826086956522,"popularity_perc":0.29123207972193},{"date_published":"2018-03-09","activity":"1","popularity":"549955.5","timestamp":1520550000,"activity_perc":0.355871886121,"popularity_perc":0.088612774420641},{"date_published":"2018-03-10","activity":"3","popularity":"4643919.75","timestamp":1520636400,"activity_perc":1.4084507042254,"popularity_perc":1.4590062261025},{"date_published":"2018-03-11","activity":"1","popularity":"1454.25","timestamp":1520722800,"activity_perc":0.4739336492891,"popularity_perc":0.00061084842417809},{"date_published":"2018-03-12","activity":"1","popularity":"3749103.5","timestamp":1520809200,"activity_perc":0.42553191489362,"popularity_perc":0.70094345450065},{"date_published":"2018-03-13","activity":"5","popularity":"811691.5","timestamp":1520895600,"activity_perc":1.9305019305019,"popularity_perc":0.12242434608709},{"date_published":"2018-03-14","activity":"2","popularity":"410088.25","timestamp":1520982000,"activity_perc":0.8298755186722,"popularity_perc":0.081474748553298},{"date_published":"2018-03-15","activity":"2","popularity":"2361649","timestamp":1521068400,"activity_perc":0.76045627376426,"popularity_perc":0.63944205765797},{"date_published":"2018-03-16","activity":"2","popularity":"27267511.5","timestamp":1521154800,"activity_perc":0.93457943925234,"popularity_perc":5.4376366899243},{"date_published":"2018-03-17","activity":"6","popularity":"79562.5","timestamp":1521241200,"activity_perc":2.7149321266968,"popularity_perc":0.019603582351185},{"date_published":"2018-03-18","activity":"4","popularity":"6332","timestamp":1521327600,"activity_perc":2.2222222222222,"popularity_perc":0.0021913752319444},{"date_published":"2018-03-19","activity":"9","popularity":"8106279.5","timestamp":1521414000,"activity_perc":4.147465437788,"popularity_perc":1.3048696889535},{"date_published":"2018-03-20","activity":"4","popularity":"346478.75","timestamp":1521500400,"activity_perc":2.1164021164021,"popularity_perc":0.12263576733956},{"date_published":"2018-03-21","activity":"6","popularity":"10981501.75","timestamp":1521586800,"activity_perc":2.970297029703,"popularity_perc":1.8615627095496},{"date_published":"2018-03-22","activity":"3","popularity":"388274","timestamp":1521673200,"activity_perc":1.5151515151515,"popularity_perc":0.074329079608404},{"date_published":"2018-03-23","activity":"3","popularity":"2492485.5","timestamp":1521759600,"activity_perc":1.1450381679389,"popularity_perc":0.078083561297058},{"date_published":"2018-03-24","activity":"2","popularity":"39650.75","timestamp":1521846000,"activity_perc":0.88105726872247,"popularity_perc":0.0044717732855407},{"date_published":"2018-03-25","activity":"1","popularity":"85031.75","timestamp":1521932400,"activity_perc":0.49751243781095,"popularity_perc":0.028427773647757},{"date_published":"2018-03-26","activity":"2","popularity":"57753.25","timestamp":1522015200,"activity_perc":0.80971659919028,"popularity_perc":0.01254840079018},{"date_published":"2018-03-27","activity":"1","popularity":"0","timestamp":1522101600,"activity_perc":0.39370078740157,"popularity_perc":0},{"date_published":"2018-03-28","activity":"2","popularity":"456024","timestamp":1522188000,"activity_perc":0.91324200913242,"popularity_perc":0.088447740724718},{"date_published":"2018-03-29","activity":"2","popularity":"332828.5","timestamp":1522274400,"activity_perc":0.87719298245614,"popularity_perc":0.018864324402371},{"date_published":"2018-04-05","activity":"10","popularity":"6963000","timestamp":1522879200,"activity_perc":4.0816326530612,"popularity_perc":0.4110518883054},{"date_published":"2018-04-06","activity":"3","popularity":"332191.5","timestamp":1522965600,"activity_perc":1.7241379310345,"popularity_perc":0.065777556095273},{"date_published":"2018-04-07","activity":"6","popularity":"20088794.25","timestamp":1523052000,"activity_perc":3.3149171270718,"popularity_perc":4.0924671592508},{"date_published":"2018-04-09","activity":"4","popularity":"15555615.5","timestamp":1523224800,"activity_perc":1.8099547511312,"popularity_perc":5.8178631483737},{"date_published":"2018-04-10","activity":"2","popularity":"8936","timestamp":1523311200,"activity_perc":0.92165898617512,"popularity_perc":0.0028058727346511},{"date_published":"2018-04-11","activity":"1","popularity":"233.5","timestamp":1523397600,"activity_perc":0.418410041841,"popularity_perc":0.000083754817871476},{"date_published":"2018-04-13","activity":"3","popularity":"364114","timestamp":1523570400,"activity_perc":1.1904761904762,"popularity_perc":0.098064001782612},{"date_published":"2018-04-14","activity":"8","popularity":"5783228","timestamp":1523656800,"activity_perc":5.2980132450331,"popularity_perc":2.4822048876492},{"date_published":"2018-04-15","activity":"2","popularity":"12405958.5","timestamp":1523743200,"activity_perc":1.1976047904192,"popularity_perc":5.5420265567846},{"date_published":"2018-04-16","activity":"2","popularity":"185681.75","timestamp":1523829600,"activity_perc":1.123595505618,"popularity_perc":0.096906991836454},{"date_published":"2018-04-17","activity":"7","popularity":"4732857.5","timestamp":1523916000,"activity_perc":2.928870292887,"popularity_perc":0.91600832529352},{"date_published":"2018-04-18","activity":"3","popularity":"148367","timestamp":1524002400,"activity_perc":1.2345679012346,"popularity_perc":0.018012042242467},{"date_published":"2018-04-19","activity":"2","popularity":"3572486","timestamp":1524088800,"activity_perc":0.77821011673152,"popularity_perc":0.20182032537465},{"date_published":"2018-04-20","activity":"1","popularity":"4994.5","timestamp":1524175200,"activity_perc":0.39525691699605,"popularity_perc":0.0011005078293874},{"date_published":"2018-04-21","activity":"1","popularity":"256248.25","timestamp":1524261600,"activity_perc":0.5,"popularity_perc":0.051923234991927},{"date_published":"2018-04-22","activity":"4","popularity":"22830796.25","timestamp":1524348000,"activity_perc":3.3613445378151,"popularity_perc":13.142844312152},{"date_published":"2018-04-23","activity":"2","popularity":"260628","timestamp":1524434400,"activity_perc":0.87719298245614,"popularity_perc":0.012634150722233},{"date_published":"2018-04-24","activity":"1","popularity":"144236.25","timestamp":1524520800,"activity_perc":0.44247787610619,"popularity_perc":0.044551145901966},{"date_published":"2018-04-25","activity":"5","popularity":"39463.5","timestamp":1524607200,"activity_perc":2.1551724137931,"popularity_perc":0.0067545284473978},{"date_published":"2018-04-26","activity":"5","popularity":"451210.75","timestamp":1524693600,"activity_perc":2.2831050228311,"popularity_perc":0.088410314930353},{"date_published":"2018-04-27","activity":"3","popularity":"766157.5","timestamp":1524780000,"activity_perc":1.5384615384615,"popularity_perc":0.3120461194966},{"date_published":"2018-04-28","activity":"1","popularity":"589.25","timestamp":1524866400,"activity_perc":0.63291139240506,"popularity_perc":0.00012982215184778},{"date_published":"2018-04-30","activity":"2","popularity":"439186.75","timestamp":1525039200,"activity_perc":0.88105726872247,"popularity_perc":0.072450158885398},{"date_published":"2018-05-01","activity":"1","popularity":"420430.5","timestamp":1525125600,"activity_perc":0.80645161290323,"popularity_perc":0.13501341149261},{"date_published":"2018-05-02","activity":"1","popularity":"3148260.25","timestamp":1525212000,"activity_perc":0.48076923076923,"popularity_perc":0.90906049976661},{"date_published":"2018-05-03","activity":"4","popularity":"4857033.75","timestamp":1525298400,"activity_perc":1.7094017094017,"popularity_perc":1.0202952503766},{"date_published":"2018-05-04","activity":"5","popularity":"2192555.5","timestamp":1525384800,"activity_perc":2.1097046413502,"popularity_perc":0.3001508484043},{"date_published":"2018-05-05","activity":"1","popularity":"4770.5","timestamp":1525471200,"activity_perc":0.61728395061728,"popularity_perc":0.0012535823034242},{"date_published":"2018-05-06","activity":"1","popularity":"204.5","timestamp":1525557600,"activity_perc":0.58823529411765,"popularity_perc":0.000039735845387752},{"date_published":"2018-05-07","activity":"6","popularity":"668156.5","timestamp":1525644000,"activity_perc":2.8169014084507,"popularity_perc":0.074393211436036},{"date_published":"2018-05-08","activity":"4","popularity":"352682.5","timestamp":1525730400,"activity_perc":1.8867924528302,"popularity_perc":0.039221545146829},{"date_published":"2018-05-09","activity":"1","popularity":"618","timestamp":1525816800,"activity_perc":0.43290043290043,"popularity_perc":0.00010390915562498},{"date_published":"2018-05-10","activity":"14","popularity":"25624294.75","timestamp":1525903200,"activity_perc":5.0359712230216,"popularity_perc":3.5877710257048},{"date_published":"2018-05-11","activity":"3","popularity":"106658.25","timestamp":1525989600,"activity_perc":1.0344827586207,"popularity_perc":0.0094492711765135},{"date_published":"2018-05-12","activity":"4","popularity":"488525.75","timestamp":1526076000,"activity_perc":1.4925373134328,"popularity_perc":0.13023925653167},{"date_published":"2018-05-13","activity":"4","popularity":"798927.5","timestamp":1526162400,"activity_perc":2.4539877300613,"popularity_perc":0.24856670730217},{"date_published":"2018-05-14","activity":"1","popularity":"0","timestamp":1526248800,"activity_perc":0.46296296296296,"popularity_perc":0},{"date_published":"2018-05-15","activity":"3","popularity":"36250.25","timestamp":1526335200,"activity_perc":1.3392857142857,"popularity_perc":0.0031766254021265},{"date_published":"2018-05-16","activity":"7","popularity":"20253118.5","timestamp":1526421600,"activity_perc":2.8925619834711,"popularity_perc":2.2213635326588},{"date_published":"2018-05-17","activity":"4","popularity":"3947404.25","timestamp":1526508000,"activity_perc":1.5325670498084,"popularity_perc":0.40998998134411},{"date_published":"2018-05-18","activity":"5","popularity":"864858","timestamp":1526594400,"activity_perc":2.0576131687243,"popularity_perc":0.065436217116686},{"date_published":"2018-05-19","activity":"4","popularity":"4757293.75","timestamp":1526680800,"activity_perc":1.6949152542373,"popularity_perc":0.98733250503527},{"date_published":"2018-05-20","activity":"2","popularity":"10703","timestamp":1526767200,"activity_perc":1.3157894736842,"popularity_perc":0.0017990825557244},{"date_published":"2018-05-21","activity":"3","popularity":"154084.25","timestamp":1526853600,"activity_perc":1.2448132780083,"popularity_perc":0.011606598024126},{"date_published":"2018-05-22","activity":"1","popularity":"4371478","timestamp":1526940000,"activity_perc":0.55865921787709,"popularity_perc":1.0335919634294},{"date_published":"2018-05-23","activity":"5","popularity":"547029.25","timestamp":1527026400,"activity_perc":2.6178010471204,"popularity_perc":0.026220444884861},{"date_published":"2018-05-25","activity":"7","popularity":"66105628.25","timestamp":1527199200,"activity_perc":4.6052631578947,"popularity_perc":20.431589528498},{"date_published":"2018-05-26","activity":"2","popularity":"37111.75","timestamp":1527285600,"activity_perc":1.2658227848101,"popularity_perc":0.017584079254507},{"date_published":"2018-05-27","activity":"2","popularity":"21583.25","timestamp":1527372000,"activity_perc":1.3245033112583,"popularity_perc":0.0069935368890192},{"date_published":"2018-05-28","activity":"8","popularity":"26637508.25","timestamp":1527458400,"activity_perc":2.9411764705882,"popularity_perc":3.1790443061507},{"date_published":"2018-05-29","activity":"8","popularity":"2522456.5","timestamp":1527544800,"activity_perc":2.9739776951673,"popularity_perc":0.50854533210364},{"date_published":"2018-05-30","activity":"6","popularity":"497711","timestamp":1527631200,"activity_perc":2.5,"popularity_perc":0.17778278620979},{"date_published":"2018-05-31","activity":"3","popularity":"350527.25","timestamp":1527717600,"activity_perc":1.1904761904762,"popularity_perc":0.14434845042985},{"date_published":"2018-06-01","activity":"2","popularity":"34145","timestamp":1527804000,"activity_perc":0.6993006993007,"popularity_perc":0.010425694264427},{"date_published":"2018-06-02","activity":"1","popularity":"178","timestamp":1527890400,"activity_perc":0.42918454935622,"popularity_perc":0.000041627241955992},{"date_published":"2018-06-03","activity":"1","popularity":"110574.5","timestamp":1527976800,"activity_perc":0.64102564102564,"popularity_perc":0.020260484849236},{"date_published":"2018-06-04","activity":"2","popularity":"14799","timestamp":1528063200,"activity_perc":0.95238095238095,"popularity_perc":0.0040470778774815},{"date_published":"2018-06-05","activity":"2","popularity":"181655.25","timestamp":1528149600,"activity_perc":1.025641025641,"popularity_perc":0.078677605023779},{"date_published":"2018-06-06","activity":"3","popularity":"2832","timestamp":1528236000,"activity_perc":1.7142857142857,"popularity_perc":0.00027989376400919}],"centro-destra":[{"date_published":"2018-02-01","activity":"91","popularity":"1938","timestamp":1517439600,"activity_perc":36.254980079681,"popularity_perc":24.259873568254},{"date_published":"2018-02-02","activity":"76","popularity":"12461.5","timestamp":1517526000,"activity_perc":26.855123674912,"popularity_perc":31.906340813949},{"date_published":"2018-02-03","activity":"84","popularity":"21340.5","timestamp":1517612400,"activity_perc":30.9963099631,"popularity_perc":21.965868269637},{"date_published":"2018-02-04","activity":"62","popularity":"4403","timestamp":1517698800,"activity_perc":28.054298642534,"popularity_perc":29.899497487437},{"date_published":"2018-02-05","activity":"99","popularity":"129964","timestamp":1517785200,"activity_perc":37.5,"popularity_perc":9.4011865051988},{"date_published":"2018-02-06","activity":"93","popularity":"40384075.75","timestamp":1517871600,"activity_perc":28.971962616822,"popularity_perc":26.032176287112},{"date_published":"2018-02-07","activity":"117","popularity":"74257811.75","timestamp":1517958000,"activity_perc":40.068493150685,"popularity_perc":32.026355366236},{"date_published":"2018-02-08","activity":"89","popularity":"70643779.5","timestamp":1518044400,"activity_perc":35.03937007874,"popularity_perc":30.54319014597},{"date_published":"2018-02-09","activity":"104","popularity":"166530408.25","timestamp":1518130800,"activity_perc":41.6,"popularity_perc":49.32150919515},{"date_published":"2018-02-10","activity":"82","popularity":"242352143.75","timestamp":1518217200,"activity_perc":38.317757009346,"popularity_perc":32.593345327612},{"date_published":"2018-02-11","activity":"66","popularity":"110542359.5","timestamp":1518303600,"activity_perc":36.065573770492,"popularity_perc":23.584030103401},{"date_published":"2018-02-12","activity":"88","popularity":"237065303.5","timestamp":1518390000,"activity_perc":31.654676258993,"popularity_perc":22.168261613959},{"date_published":"2018-02-13","activity":"96","popularity":"120166929","timestamp":1518476400,"activity_perc":35.424354243542,"popularity_perc":23.216256914577},{"date_published":"2018-02-14","activity":"79","popularity":"97010528","timestamp":1518562800,"activity_perc":33.333333333333,"popularity_perc":20.827453387472},{"date_published":"2018-02-15","activity":"84","popularity":"251514644.5","timestamp":1518649200,"activity_perc":31.460674157303,"popularity_perc":36.539157196886},{"date_published":"2018-02-16","activity":"66","popularity":"232673395.75","timestamp":1518735600,"activity_perc":24,"popularity_perc":26.218962177127},{"date_published":"2018-02-17","activity":"71","popularity":"732578921.5","timestamp":1518822000,"activity_perc":25.818181818182,"popularity_perc":55.692362142488},{"date_published":"2018-02-18","activity":"67","popularity":"115529592.75","timestamp":1518908400,"activity_perc":24.814814814815,"popularity_perc":22.128434171016},{"date_published":"2018-02-19","activity":"66","popularity":"110760934.5","timestamp":1518994800,"activity_perc":24.087591240876,"popularity_perc":19.642738793739},{"date_published":"2018-02-20","activity":"98","popularity":"167803568.25","timestamp":1519081200,"activity_perc":30.246913580247,"popularity_perc":22.511251712413},{"date_published":"2018-02-21","activity":"80","popularity":"59352966.75","timestamp":1519167600,"activity_perc":24.691358024691,"popularity_perc":7.5315510804161},{"date_published":"2018-02-22","activity":"85","popularity":"100737697.25","timestamp":1519254000,"activity_perc":30.141843971631,"popularity_perc":12.76120005495},{"date_published":"2018-02-23","activity":"59","popularity":"405043341.5","timestamp":1519340400,"activity_perc":21.851851851852,"popularity_perc":33.771672755613},{"date_published":"2018-02-24","activity":"70","popularity":"157273622","timestamp":1519426800,"activity_perc":28.688524590164,"popularity_perc":24.358470017998},{"date_published":"2018-02-25","activity":"53","popularity":"75059429.75","timestamp":1519513200,"activity_perc":24.311926605505,"popularity_perc":17.445220229758},{"date_published":"2018-02-26","activity":"77","popularity":"219270899.75","timestamp":1519599600,"activity_perc":28.838951310861,"popularity_perc":28.796344270307},{"date_published":"2018-02-27","activity":"68","popularity":"339877910","timestamp":1519686000,"activity_perc":26.771653543307,"popularity_perc":44.539395003785},{"date_published":"2018-02-28","activity":"100","popularity":"173946708.25","timestamp":1519772400,"activity_perc":35.335689045936,"popularity_perc":41.548482722928},{"date_published":"2018-03-01","activity":"69","popularity":"123755642","timestamp":1519858800,"activity_perc":24.295774647887,"popularity_perc":19.656021120995},{"date_published":"2018-03-02","activity":"73","popularity":"112088496.25","timestamp":1519945200,"activity_perc":27.340823970037,"popularity_perc":27.356148225695},{"date_published":"2018-03-03","activity":"54","popularity":"69885212.25","timestamp":1520031600,"activity_perc":35.526315789474,"popularity_perc":24.723625438923},{"date_published":"2018-03-04","activity":"50","popularity":"31831095.25","timestamp":1520118000,"activity_perc":30.864197530864,"popularity_perc":21.835381901408},{"date_published":"2018-03-05","activity":"173","popularity":"2495582714.75","timestamp":1520204400,"activity_perc":31.918819188192,"popularity_perc":36.051865156217},{"date_published":"2018-03-06","activity":"148","popularity":"222222299.5","timestamp":1520290800,"activity_perc":33.109619686801,"popularity_perc":17.630041248961},{"date_published":"2018-03-07","activity":"122","popularity":"244341375","timestamp":1520377200,"activity_perc":32.020997375328,"popularity_perc":34.749025306009},{"date_published":"2018-03-08","activity":"66","popularity":"130965477.75","timestamp":1520463600,"activity_perc":28.695652173913,"popularity_perc":17.862823590087},{"date_published":"2018-03-09","activity":"100","popularity":"240455692","timestamp":1520550000,"activity_perc":35.5871886121,"popularity_perc":38.743945634429},{"date_published":"2018-03-10","activity":"43","popularity":"49123665","timestamp":1520636400,"activity_perc":20.18779342723,"popularity_perc":15.433456420941},{"date_published":"2018-03-11","activity":"77","popularity":"82651306","timestamp":1520722800,"activity_perc":36.492890995261,"popularity_perc":34.717153189865},{"date_published":"2018-03-12","activity":"76","popularity":"171170958","timestamp":1520809200,"activity_perc":32.340425531915,"popularity_perc":32.002627457659},{"date_published":"2018-03-13","activity":"92","popularity":"164961836.5","timestamp":1520895600,"activity_perc":35.521235521236,"popularity_perc":24.880567263348},{"date_published":"2018-03-14","activity":"93","popularity":"108172439.5","timestamp":1520982000,"activity_perc":38.589211618257,"popularity_perc":21.491282202451},{"date_published":"2018-03-15","activity":"96","popularity":"92580323.75","timestamp":1521068400,"activity_perc":36.501901140684,"popularity_perc":25.067125858813},{"date_published":"2018-03-16","activity":"71","popularity":"121139388.5","timestamp":1521154800,"activity_perc":33.177570093458,"popularity_perc":24.157392708997},{"date_published":"2018-03-17","activity":"73","popularity":"95254089.75","timestamp":1521241200,"activity_perc":33.031674208145,"popularity_perc":23.469868250763},{"date_published":"2018-03-18","activity":"65","popularity":"68330930.75","timestamp":1521327600,"activity_perc":36.111111111111,"popularity_perc":23.647932599693},{"date_published":"2018-03-19","activity":"76","popularity":"254814628.5","timestamp":1521414000,"activity_perc":35.023041474654,"popularity_perc":41.017569778045},{"date_published":"2018-03-20","activity":"58","popularity":"81246410.25","timestamp":1521500400,"activity_perc":30.687830687831,"popularity_perc":28.757076341893},{"date_published":"2018-03-21","activity":"79","popularity":"185158127","timestamp":1521586800,"activity_perc":39.108910891089,"popularity_perc":31.387643733996},{"date_published":"2018-03-22","activity":"71","popularity":"152896322.25","timestamp":1521673200,"activity_perc":35.858585858586,"popularity_perc":29.269646971861},{"date_published":"2018-03-23","activity":"97","popularity":"1720739537","timestamp":1521759600,"activity_perc":37.022900763359,"popularity_perc":53.906620966746},{"date_published":"2018-03-24","activity":"89","popularity":"408931427.5","timestamp":1521846000,"activity_perc":39.20704845815,"popularity_perc":46.118891398335},{"date_published":"2018-03-25","activity":"76","popularity":"100435282","timestamp":1521932400,"activity_perc":37.810945273632,"popularity_perc":33.577475036614},{"date_published":"2018-03-26","activity":"130","popularity":"275146941","timestamp":1522015200,"activity_perc":52.631578947368,"popularity_perc":59.782853637846},{"date_published":"2018-03-27","activity":"105","popularity":"203153635.25","timestamp":1522101600,"activity_perc":41.338582677165,"popularity_perc":35.565859365824},{"date_published":"2018-03-28","activity":"83","popularity":"149883145.75","timestamp":1522188000,"activity_perc":37.899543378995,"popularity_perc":29.070455972276},{"date_published":"2018-03-29","activity":"93","popularity":"733290668","timestamp":1522274400,"activity_perc":40.789473684211,"popularity_perc":41.562044844067},{"date_published":"2018-03-30","activity":"106","popularity":"228894822.5","timestamp":1522360800,"activity_perc":47.963800904977,"popularity_perc":61.790779960559},{"date_published":"2018-03-31","activity":"58","popularity":"43934819.25","timestamp":1522447200,"activity_perc":36.942675159236,"popularity_perc":14.727121135897},{"date_published":"2018-04-01","activity":"22","popularity":"29233068.5","timestamp":1522533600,"activity_perc":32.352941176471,"popularity_perc":24.982840468168},{"date_published":"2018-04-02","activity":"34","popularity":"88299106.75","timestamp":1522620000,"activity_perc":50.746268656716,"popularity_perc":50.977612044465},{"date_published":"2018-04-03","activity":"66","popularity":"157473401.25","timestamp":1522706400,"activity_perc":41.25,"popularity_perc":16.131141973855},{"date_published":"2018-04-04","activity":"101","popularity":"243925183","timestamp":1522792800,"activity_perc":41.056910569106,"popularity_perc":53.634221032621},{"date_published":"2018-04-05","activity":"94","popularity":"875122826.5","timestamp":1522879200,"activity_perc":38.367346938776,"popularity_perc":51.661767963807},{"date_published":"2018-04-06","activity":"53","popularity":"162046876.75","timestamp":1522965600,"activity_perc":30.459770114943,"popularity_perc":32.087056789493},{"date_published":"2018-04-07","activity":"50","popularity":"78231267.5","timestamp":1523052000,"activity_perc":27.624309392265,"popularity_perc":15.937188120204},{"date_published":"2018-04-08","activity":"67","popularity":"219841272","timestamp":1523138400,"activity_perc":35.63829787234,"popularity_perc":26.330943908121},{"date_published":"2018-04-09","activity":"72","popularity":"39514409.25","timestamp":1523224800,"activity_perc":32.579185520362,"popularity_perc":14.77854896872},{"date_published":"2018-04-10","activity":"72","popularity":"82601192.25","timestamp":1523311200,"activity_perc":33.179723502304,"popularity_perc":25.936485360783},{"date_published":"2018-04-11","activity":"100","popularity":"90413650","timestamp":1523397600,"activity_perc":41.8410041841,"popularity_perc":32.430744277711},{"date_published":"2018-04-12","activity":"96","popularity":"96274821.5","timestamp":1523484000,"activity_perc":41.558441558442,"popularity_perc":20.832261005451},{"date_published":"2018-04-13","activity":"100","popularity":"177880837.75","timestamp":1523570400,"activity_perc":39.68253968254,"popularity_perc":47.907267477242},{"date_published":"2018-04-14","activity":"61","popularity":"115393150.75","timestamp":1523656800,"activity_perc":40.397350993377,"popularity_perc":49.527606864695},{"date_published":"2018-04-15","activity":"69","popularity":"50121210.5","timestamp":1523743200,"activity_perc":41.317365269461,"popularity_perc":22.390295731619},{"date_published":"2018-04-16","activity":"78","popularity":"78558732.5","timestamp":1523829600,"activity_perc":43.820224719101,"popularity_perc":40.999669860175},{"date_published":"2018-04-17","activity":"86","popularity":"139714548.25","timestamp":1523916000,"activity_perc":35.983263598326,"popularity_perc":27.040680891327},{"date_published":"2018-04-18","activity":"86","popularity":"351563849","timestamp":1524002400,"activity_perc":35.390946502058,"popularity_perc":42.68053474905},{"date_published":"2018-04-19","activity":"102","popularity":"716227718","timestamp":1524088800,"activity_perc":39.688715953307,"popularity_perc":40.461827167161},{"date_published":"2018-04-20","activity":"117","popularity":"209999577","timestamp":1524175200,"activity_perc":46.245059288538,"popularity_perc":46.272135079898},{"date_published":"2018-04-21","activity":"86","popularity":"181952937.5","timestamp":1524261600,"activity_perc":43,"popularity_perc":36.868876690022},{"date_published":"2018-04-22","activity":"50","popularity":"89768356.5","timestamp":1524348000,"activity_perc":42.016806722689,"popularity_perc":51.676320033613},{"date_published":"2018-04-23","activity":"84","popularity":"1163879732","timestamp":1524434400,"activity_perc":36.842105263158,"popularity_perc":56.420000754487},{"date_published":"2018-04-24","activity":"68","popularity":"107048663","timestamp":1524520800,"activity_perc":30.088495575221,"popularity_perc":33.064785058703},{"date_published":"2018-04-25","activity":"61","popularity":"67153475.75","timestamp":1524607200,"activity_perc":26.293103448276,"popularity_perc":11.493913674535},{"date_published":"2018-04-26","activity":"67","popularity":"104286370.5","timestamp":1524693600,"activity_perc":30.593607305936,"popularity_perc":20.4338900588},{"date_published":"2018-04-27","activity":"60","popularity":"29030007.25","timestamp":1524780000,"activity_perc":30.769230769231,"popularity_perc":11.82354948078},{"date_published":"2018-04-28","activity":"51","popularity":"141359927","timestamp":1524866400,"activity_perc":32.278481012658,"popularity_perc":31.144081303667},{"date_published":"2018-04-29","activity":"34","popularity":"32850907.75","timestamp":1524952800,"activity_perc":24.460431654676,"popularity_perc":17.461235437541},{"date_published":"2018-04-30","activity":"71","popularity":"147369810.25","timestamp":1525039200,"activity_perc":31.277533039648,"popularity_perc":24.310765676613},{"date_published":"2018-05-01","activity":"42","popularity":"124175067","timestamp":1525125600,"activity_perc":33.870967741935,"popularity_perc":39.87650614785},{"date_published":"2018-05-02","activity":"66","popularity":"114276072","timestamp":1525212000,"activity_perc":31.730769230769,"popularity_perc":32.997228587975},{"date_published":"2018-05-03","activity":"62","popularity":"114126218","timestamp":1525298400,"activity_perc":26.495726495726,"popularity_perc":23.973981685602},{"date_published":"2018-05-04","activity":"71","popularity":"143654399.5","timestamp":1525384800,"activity_perc":29.957805907173,"popularity_perc":19.665632129693},{"date_published":"2018-05-05","activity":"60","popularity":"88380184.25","timestamp":1525471200,"activity_perc":37.037037037037,"popularity_perc":23.224365359851},{"date_published":"2018-05-06","activity":"65","popularity":"209057352","timestamp":1525557600,"activity_perc":38.235294117647,"popularity_perc":40.621372206576},{"date_published":"2018-05-07","activity":"83","popularity":"325614044.75","timestamp":1525644000,"activity_perc":38.967136150235,"popularity_perc":36.254192659399},{"date_published":"2018-05-08","activity":"80","popularity":"436410012.25","timestamp":1525730400,"activity_perc":37.735849056604,"popularity_perc":48.532816337617},{"date_published":"2018-05-09","activity":"104","popularity":"342164421.75","timestamp":1525816800,"activity_perc":45.021645021645,"popularity_perc":57.530770467562},{"date_published":"2018-05-10","activity":"120","popularity":"357493779.5","timestamp":1525903200,"activity_perc":43.165467625899,"popularity_perc":50.054287794976},{"date_published":"2018-05-11","activity":"122","popularity":"267210077.25","timestamp":1525989600,"activity_perc":42.068965517241,"popularity_perc":23.67318497193},{"date_published":"2018-05-12","activity":"140","popularity":"210737047","timestamp":1526076000,"activity_perc":52.238805970149,"popularity_perc":56.181759763859},{"date_published":"2018-05-13","activity":"81","popularity":"160683679.75","timestamp":1526162400,"activity_perc":49.693251533742,"popularity_perc":49.992788072327},{"date_published":"2018-05-14","activity":"101","popularity":"399047969.5","timestamp":1526248800,"activity_perc":46.759259259259,"popularity_perc":50.659918717616},{"date_published":"2018-05-15","activity":"94","popularity":"542436188","timestamp":1526335200,"activity_perc":41.964285714286,"popularity_perc":47.533922492492},{"date_published":"2018-05-16","activity":"121","popularity":"416145240.25","timestamp":1526421600,"activity_perc":50,"popularity_perc":45.642840680603},{"date_published":"2018-05-17","activity":"124","popularity":"374851184.75","timestamp":1526508000,"activity_perc":47.509578544061,"popularity_perc":38.933238277399},{"date_published":"2018-05-18","activity":"119","popularity":"675437019","timestamp":1526594400,"activity_perc":48.971193415638,"popularity_perc":51.104393350042},{"date_published":"2018-05-19","activity":"96","popularity":"108977597","timestamp":1526680800,"activity_perc":40.677966101695,"popularity_perc":22.617296617165},{"date_published":"2018-05-20","activity":"72","popularity":"312472008.75","timestamp":1526767200,"activity_perc":47.368421052632,"popularity_perc":52.523866214545},{"date_published":"2018-05-21","activity":"108","popularity":"612296945.75","timestamp":1526853600,"activity_perc":44.813278008299,"popularity_perc":46.122069716539},{"date_published":"2018-05-22","activity":"74","popularity":"145399349","timestamp":1526940000,"activity_perc":41.340782122905,"popularity_perc":34.378212269229},{"date_published":"2018-05-23","activity":"73","popularity":"288132545","timestamp":1527026400,"activity_perc":38.219895287958,"popularity_perc":13.810894967147},{"date_published":"2018-05-24","activity":"93","popularity":"1742880311.75","timestamp":1527112800,"activity_perc":54.385964912281,"popularity_perc":40.97070516619},{"date_published":"2018-05-25","activity":"62","popularity":"124552100.5","timestamp":1527199200,"activity_perc":40.789473684211,"popularity_perc":38.495926287914},{"date_published":"2018-05-26","activity":"74","popularity":"105973451.25","timestamp":1527285600,"activity_perc":46.835443037975,"popularity_perc":50.211740638845},{"date_published":"2018-05-27","activity":"62","popularity":"88052875.5","timestamp":1527372000,"activity_perc":41.059602649007,"popularity_perc":28.531432151945},{"date_published":"2018-05-28","activity":"101","popularity":"357214746","timestamp":1527458400,"activity_perc":37.132352941176,"popularity_perc":42.631671614569},{"date_published":"2018-05-29","activity":"106","popularity":"179147687.5","timestamp":1527544800,"activity_perc":39.405204460967,"popularity_perc":36.117459403279},{"date_published":"2018-05-30","activity":"103","popularity":"122098063.5","timestamp":1527631200,"activity_perc":42.916666666667,"popularity_perc":43.613530582708},{"date_published":"2018-05-31","activity":"106","popularity":"113102101","timestamp":1527717600,"activity_perc":42.063492063492,"popularity_perc":46.575873971881},{"date_published":"2018-06-01","activity":"136","popularity":"139831066.5","timestamp":1527804000,"activity_perc":47.552447552448,"popularity_perc":42.695444369535},{"date_published":"2018-06-02","activity":"115","popularity":"209444307.75","timestamp":1527890400,"activity_perc":49.356223175966,"popularity_perc":48.980836376486},{"date_published":"2018-06-03","activity":"66","popularity":"285256087.25","timestamp":1527976800,"activity_perc":42.307692307692,"popularity_perc":52.267264458632},{"date_published":"2018-06-04","activity":"108","popularity":"176393380.75","timestamp":1528063200,"activity_perc":51.428571428571,"popularity_perc":48.238242379046},{"date_published":"2018-06-05","activity":"101","popularity":"102938040.75","timestamp":1528149600,"activity_perc":51.794871794872,"popularity_perc":44.58400465745},{"date_published":"2018-06-06","activity":"78","popularity":"353898765","timestamp":1528236000,"activity_perc":44.571428571429,"popularity_perc":34.976715188578}],"m5s":[{"date_published":"2018-02-01","activity":"50","popularity":"2783","timestamp":1517439600,"activity_perc":19.9203187251,"popularity_perc":34.837579019841},{"date_published":"2018-02-02","activity":"93","popularity":"19451","timestamp":1517526000,"activity_perc":32.862190812721,"popularity_perc":49.802209619398},{"date_published":"2018-02-03","activity":"56","popularity":"9018","timestamp":1517612400,"activity_perc":20.664206642066,"popularity_perc":9.282266116332},{"date_published":"2018-02-04","activity":"52","popularity":"852","timestamp":1517698800,"activity_perc":23.529411764706,"popularity_perc":5.7856851826701},{"date_published":"2018-02-05","activity":"45","popularity":"2150","timestamp":1517785200,"activity_perc":17.045454545455,"popularity_perc":0.15552422968035},{"date_published":"2018-02-06","activity":"72","popularity":"35738136","timestamp":1517871600,"activity_perc":22.429906542056,"popularity_perc":23.037334376157},{"date_published":"2018-02-07","activity":"60","popularity":"65231071","timestamp":1517958000,"activity_perc":20.547945205479,"popularity_perc":28.133248361795},{"date_published":"2018-02-08","activity":"52","popularity":"65375276","timestamp":1518044400,"activity_perc":20.472440944882,"popularity_perc":28.265326400229},{"date_published":"2018-02-09","activity":"52","popularity":"91864233.25","timestamp":1518130800,"activity_perc":20.8,"popularity_perc":27.20753928702},{"date_published":"2018-02-10","activity":"35","popularity":"39843772.5","timestamp":1518217200,"activity_perc":16.355140186916,"popularity_perc":5.3584912274881},{"date_published":"2018-02-11","activity":"37","popularity":"244709216","timestamp":1518303600,"activity_perc":20.218579234973,"popularity_perc":52.208307682483},{"date_published":"2018-02-12","activity":"85","popularity":"289718314.25","timestamp":1518390000,"activity_perc":30.575539568345,"popularity_perc":27.091907967246},{"date_published":"2018-02-13","activity":"92","popularity":"299619408.25","timestamp":1518476400,"activity_perc":33.948339483395,"popularity_perc":57.886485211964},{"date_published":"2018-02-14","activity":"70","popularity":"173667628.75","timestamp":1518562800,"activity_perc":29.535864978903,"popularity_perc":37.285174272048},{"date_published":"2018-02-15","activity":"68","popularity":"153197362.25","timestamp":1518649200,"activity_perc":25.468164794007,"popularity_perc":22.25597047253},{"date_published":"2018-02-16","activity":"85","popularity":"287308572","timestamp":1518735600,"activity_perc":30.909090909091,"popularity_perc":32.375564718737},{"date_published":"2018-02-17","activity":"80","popularity":"303894042","timestamp":1518822000,"activity_perc":29.090909090909,"popularity_perc":23.102735477776},{"date_published":"2018-02-18","activity":"81","popularity":"96708704","timestamp":1518908400,"activity_perc":30,"popularity_perc":18.52349808641},{"date_published":"2018-02-19","activity":"65","popularity":"95668509.75","timestamp":1518994800,"activity_perc":23.722627737226,"popularity_perc":16.966194410408},{"date_published":"2018-02-20","activity":"85","popularity":"190079744","timestamp":1519081200,"activity_perc":26.234567901235,"popularity_perc":25.499654192335},{"date_published":"2018-02-21","activity":"45","popularity":"123338054.75","timestamp":1519167600,"activity_perc":13.888888888889,"popularity_perc":15.650891781392},{"date_published":"2018-02-22","activity":"54","popularity":"138437433.25","timestamp":1519254000,"activity_perc":19.148936170213,"popularity_perc":17.536908516111},{"date_published":"2018-02-23","activity":"83","popularity":"461105826","timestamp":1519340400,"activity_perc":30.740740740741,"popularity_perc":38.446046301389},{"date_published":"2018-02-24","activity":"59","popularity":"129663508.5","timestamp":1519426800,"activity_perc":24.180327868852,"popularity_perc":20.082227674681},{"date_published":"2018-02-25","activity":"63","popularity":"155624595","timestamp":1519513200,"activity_perc":28.899082568807,"popularity_perc":36.170076724329},{"date_published":"2018-02-26","activity":"72","popularity":"285808063.25","timestamp":1519599600,"activity_perc":26.966292134831,"popularity_perc":37.534517320631},{"date_published":"2018-02-27","activity":"78","popularity":"122715391.25","timestamp":1519686000,"activity_perc":30.708661417323,"popularity_perc":16.081272489665},{"date_published":"2018-02-28","activity":"79","popularity":"68024893","timestamp":1519772400,"activity_perc":27.91519434629,"popularity_perc":16.248258561337},{"date_published":"2018-03-01","activity":"97","popularity":"324267548","timestamp":1519858800,"activity_perc":34.154929577465,"popularity_perc":51.503185384804},{"date_published":"2018-03-02","activity":"79","popularity":"126833139.75","timestamp":1519945200,"activity_perc":29.588014981273,"popularity_perc":30.954703533471},{"date_published":"2018-03-03","activity":"38","popularity":"137561273","timestamp":1520031600,"activity_perc":25,"popularity_perc":48.665708796691},{"date_published":"2018-03-04","activity":"42","popularity":"71733531.5","timestamp":1520118000,"activity_perc":25.925925925926,"popularity_perc":49.207513694937},{"date_published":"2018-03-05","activity":"166","popularity":"1501017935.5","timestamp":1520204400,"activity_perc":30.627306273063,"popularity_perc":21.684112447112},{"date_published":"2018-03-06","activity":"132","popularity":"503669257.5","timestamp":1520290800,"activity_perc":29.530201342282,"popularity_perc":39.958680139382},{"date_published":"2018-03-07","activity":"126","popularity":"275128391.25","timestamp":1520377200,"activity_perc":33.070866141732,"popularity_perc":39.127402921211},{"date_published":"2018-03-08","activity":"70","popularity":"291197816.25","timestamp":1520463600,"activity_perc":30.434782608696,"popularity_perc":39.717453109449},{"date_published":"2018-03-09","activity":"99","popularity":"226717185","timestamp":1520550000,"activity_perc":35.231316725979,"popularity_perc":36.530298854521},{"date_published":"2018-03-10","activity":"117","popularity":"159875927.5","timestamp":1520636400,"activity_perc":54.929577464789,"popularity_perc":50.229113805511},{"date_published":"2018-03-11","activity":"82","popularity":"94225272.75","timestamp":1520722800,"activity_perc":38.862559241706,"popularity_perc":39.57872400006},{"date_published":"2018-03-12","activity":"55","popularity":"102348713.25","timestamp":1520809200,"activity_perc":23.404255319149,"popularity_perc":19.135417474911},{"date_published":"2018-03-13","activity":"70","popularity":"230688124","timestamp":1520895600,"activity_perc":27.027027027027,"popularity_perc":34.793813574194},{"date_published":"2018-03-14","activity":"89","popularity":"190562922.75","timestamp":1520982000,"activity_perc":36.929460580913,"popularity_perc":37.860304982252},{"date_published":"2018-03-15","activity":"89","popularity":"167541976.5","timestamp":1521068400,"activity_perc":33.84030418251,"popularity_perc":45.363805627865},{"date_published":"2018-03-16","activity":"73","popularity":"165901825","timestamp":1521154800,"activity_perc":34.11214953271,"popularity_perc":33.083834971351},{"date_published":"2018-03-17","activity":"70","popularity":"126510557.25","timestamp":1521241200,"activity_perc":31.674208144796,"popularity_perc":31.171219196792},{"date_published":"2018-03-18","activity":"68","popularity":"119536825","timestamp":1521327600,"activity_perc":37.777777777778,"popularity_perc":41.369241568268},{"date_published":"2018-03-19","activity":"78","popularity":"217144691.25","timestamp":1521414000,"activity_perc":35.944700460829,"popularity_perc":34.953831252584},{"date_published":"2018-03-20","activity":"75","popularity":"153838620","timestamp":1521500400,"activity_perc":39.68253968254,"popularity_perc":54.451008063725},{"date_published":"2018-03-21","activity":"69","popularity":"297887904.75","timestamp":1521586800,"activity_perc":34.158415841584,"popularity_perc":50.497375289173},{"date_published":"2018-03-22","activity":"62","popularity":"168690787.25","timestamp":1521673200,"activity_perc":31.313131313131,"popularity_perc":32.293254131643},{"date_published":"2018-03-23","activity":"80","popularity":"937346467.25","timestamp":1521759600,"activity_perc":30.534351145038,"popularity_perc":29.364804863297},{"date_published":"2018-03-24","activity":"78","popularity":"399393452","timestamp":1521846000,"activity_perc":34.361233480176,"popularity_perc":45.043207734368},{"date_published":"2018-03-25","activity":"89","popularity":"182384297","timestamp":1521932400,"activity_perc":44.278606965174,"popularity_perc":60.974630206026},{"date_published":"2018-03-26","activity":"79","popularity":"123466459.25","timestamp":1522015200,"activity_perc":31.983805668016,"popularity_perc":26.826310464145},{"date_published":"2018-03-27","activity":"87","popularity":"140793414.25","timestamp":1522101600,"activity_perc":34.251968503937,"popularity_perc":24.648531465792},{"date_published":"2018-03-28","activity":"82","popularity":"224930980.5","timestamp":1522188000,"activity_perc":37.442922374429,"popularity_perc":43.626293888525},{"date_published":"2018-03-29","activity":"73","popularity":"617139369","timestamp":1522274400,"activity_perc":32.017543859649,"popularity_perc":34.978727057},{"date_published":"2018-03-30","activity":"77","popularity":"90386409.5","timestamp":1522360800,"activity_perc":34.841628959276,"popularity_perc":24.400057108498},{"date_published":"2018-03-31","activity":"57","popularity":"184145927","timestamp":1522447200,"activity_perc":36.305732484076,"popularity_perc":61.726426099067},{"date_published":"2018-04-01","activity":"28","popularity":"62640669.75","timestamp":1522533600,"activity_perc":41.176470588235,"popularity_perc":53.533273771224},{"date_published":"2018-04-02","activity":"21","popularity":"72634532.25","timestamp":1522620000,"activity_perc":31.34328358209,"popularity_perc":41.934002985503},{"date_published":"2018-04-03","activity":"59","popularity":"177450948","timestamp":1522706400,"activity_perc":36.875,"popularity_perc":18.177586899509},{"date_published":"2018-04-04","activity":"85","popularity":"135607236.5","timestamp":1522792800,"activity_perc":34.552845528455,"popularity_perc":29.817292362404},{"date_published":"2018-04-05","activity":"84","popularity":"472940292.75","timestamp":1522879200,"activity_perc":34.285714285714,"popularity_perc":27.919431335717},{"date_published":"2018-04-06","activity":"65","popularity":"207156189.75","timestamp":1522965600,"activity_perc":37.35632183908,"popularity_perc":41.019194927515},{"date_published":"2018-04-07","activity":"71","popularity":"275711571","timestamp":1523052000,"activity_perc":39.226519337017,"popularity_perc":56.167659228375},{"date_published":"2018-04-08","activity":"67","popularity":"343305482.5","timestamp":1523138400,"activity_perc":35.63829787234,"popularity_perc":41.118563956716},{"date_published":"2018-04-09","activity":"85","popularity":"108907641","timestamp":1523224800,"activity_perc":38.461538461538,"popularity_perc":40.731898467805},{"date_published":"2018-04-10","activity":"71","popularity":"112886409.75","timestamp":1523311200,"activity_perc":32.718894009217,"popularity_perc":35.445937693619},{"date_published":"2018-04-11","activity":"79","popularity":"138159577.5","timestamp":1523397600,"activity_perc":33.054393305439,"popularity_perc":49.556874735386},{"date_published":"2018-04-12","activity":"78","popularity":"129466759.75","timestamp":1523484000,"activity_perc":33.766233766234,"popularity_perc":28.014441248712},{"date_published":"2018-04-13","activity":"92","popularity":"116672264.25","timestamp":1523570400,"activity_perc":36.507936507937,"popularity_perc":31.42243673518},{"date_published":"2018-04-14","activity":"41","popularity":"78177113.25","timestamp":1523656800,"activity_perc":27.152317880795,"popularity_perc":33.554204090079},{"date_published":"2018-04-15","activity":"67","popularity":"119382167.25","timestamp":1523743200,"activity_perc":40.119760479042,"popularity_perc":53.330755645039},{"date_published":"2018-04-16","activity":"53","popularity":"56460155.5","timestamp":1523829600,"activity_perc":29.775280898876,"popularity_perc":29.466459833147},{"date_published":"2018-04-17","activity":"82","popularity":"302136591","timestamp":1523916000,"activity_perc":34.309623430962,"popularity_perc":58.476223451013},{"date_published":"2018-04-18","activity":"89","popularity":"251441502","timestamp":1524002400,"activity_perc":36.625514403292,"popularity_perc":30.525487173922},{"date_published":"2018-04-19","activity":"90","popularity":"396936632.75","timestamp":1524088800,"activity_perc":35.019455252918,"popularity_perc":22.42412716935},{"date_published":"2018-04-20","activity":"96","popularity":"171085990.75","timestamp":1524175200,"activity_perc":37.944664031621,"popularity_perc":37.697762001979},{"date_published":"2018-04-21","activity":"65","popularity":"161853004.25","timestamp":1524261600,"activity_perc":32.5,"popularity_perc":32.796054505044},{"date_published":"2018-04-22","activity":"45","popularity":"32815058.75","timestamp":1524348000,"activity_perc":37.81512605042,"popularity_perc":18.890414662842},{"date_published":"2018-04-23","activity":"96","popularity":"732718419.75","timestamp":1524434400,"activity_perc":42.105263157895,"popularity_perc":35.51911134674},{"date_published":"2018-04-24","activity":"94","popularity":"111373037","timestamp":1524520800,"activity_perc":41.592920353982,"popularity_perc":34.400481300173},{"date_published":"2018-04-25","activity":"83","popularity":"229043145.75","timestamp":1524607200,"activity_perc":35.775862068966,"popularity_perc":39.202768219997},{"date_published":"2018-04-26","activity":"84","popularity":"195024291.25","timestamp":1524693600,"activity_perc":38.356164383562,"popularity_perc":38.213094454158},{"date_published":"2018-04-27","activity":"62","popularity":"79351559.75","timestamp":1524780000,"activity_perc":31.794871794872,"popularity_perc":32.31887215878},{"date_published":"2018-04-28","activity":"47","popularity":"159634309","timestamp":1524866400,"activity_perc":29.746835443038,"popularity_perc":35.17024947495},{"date_published":"2018-04-29","activity":"57","popularity":"62967853.75","timestamp":1524952800,"activity_perc":41.007194244604,"popularity_perc":33.469288815174},{"date_published":"2018-04-30","activity":"90","popularity":"303812551.5","timestamp":1525039200,"activity_perc":39.647577092511,"popularity_perc":50.118241562509},{"date_published":"2018-05-01","activity":"43","popularity":"80150553.5","timestamp":1525125600,"activity_perc":34.677419354839,"popularity_perc":25.738854961893},{"date_published":"2018-05-02","activity":"72","popularity":"114878790","timestamp":1525212000,"activity_perc":34.615384615385,"popularity_perc":33.171263477975},{"date_published":"2018-05-03","activity":"66","popularity":"162922852.5","timestamp":1525298400,"activity_perc":28.205128205128,"popularity_perc":34.224471383087},{"date_published":"2018-05-04","activity":"79","popularity":"304045984.5","timestamp":1525384800,"activity_perc":33.333333333333,"popularity_perc":41.622508621376},{"date_published":"2018-05-05","activity":"54","popularity":"145516673","timestamp":1525471200,"activity_perc":33.333333333333,"popularity_perc":38.238575857031},{"date_published":"2018-05-06","activity":"67","popularity":"235476889.25","timestamp":1525557600,"activity_perc":39.411764705882,"popularity_perc":45.754881484727},{"date_published":"2018-05-07","activity":"85","popularity":"388161397.75","timestamp":1525644000,"activity_perc":39.906103286385,"popularity_perc":43.218277355864},{"date_published":"2018-05-08","activity":"75","popularity":"153261530.5","timestamp":1525730400,"activity_perc":35.377358490566,"popularity_perc":17.044095008337},{"date_published":"2018-05-09","activity":"90","popularity":"216259455.75","timestamp":1525816800,"activity_perc":38.961038961039,"popularity_perc":36.36138744806},{"date_published":"2018-05-10","activity":"107","popularity":"264531613.5","timestamp":1525903200,"activity_perc":38.489208633094,"popularity_perc":37.038243103188},{"date_published":"2018-05-11","activity":"109","popularity":"302681020","timestamp":1525989600,"activity_perc":37.586206896552,"popularity_perc":26.815694406796},{"date_published":"2018-05-12","activity":"93","popularity":"142388065","timestamp":1526076000,"activity_perc":34.701492537313,"popularity_perc":37.960160185175},{"date_published":"2018-05-13","activity":"62","popularity":"145201252.25","timestamp":1526162400,"activity_perc":38.036809815951,"popularity_perc":45.175810280575},{"date_published":"2018-05-14","activity":"95","popularity":"336326173","timestamp":1526248800,"activity_perc":43.981481481481,"popularity_perc":42.697264211457},{"date_published":"2018-05-15","activity":"92","popularity":"551933657.5","timestamp":1526335200,"activity_perc":41.071428571429,"popularity_perc":48.366189935327},{"date_published":"2018-05-16","activity":"89","popularity":"398175016.75","timestamp":1526421600,"activity_perc":36.776859504132,"popularity_perc":43.671865240123},{"date_published":"2018-05-17","activity":"111","popularity":"451649953.75","timestamp":1526508000,"activity_perc":42.528735632184,"popularity_perc":46.909803097068},{"date_published":"2018-05-18","activity":"91","popularity":"469872302.5","timestamp":1526594400,"activity_perc":37.448559670782,"popularity_perc":35.551114753528},{"date_published":"2018-05-19","activity":"76","popularity":"105043635.25","timestamp":1526680800,"activity_perc":32.203389830508,"popularity_perc":21.80083908617},{"date_published":"2018-05-20","activity":"61","popularity":"273802842.75","timestamp":1526767200,"activity_perc":40.131578947368,"popularity_perc":46.023910875387},{"date_published":"2018-05-21","activity":"99","popularity":"627014204.75","timestamp":1526853600,"activity_perc":41.078838174274,"popularity_perc":47.230666534383},{"date_published":"2018-05-22","activity":"69","popularity":"174935481","timestamp":1526940000,"activity_perc":38.54748603352,"popularity_perc":41.361733326864},{"date_published":"2018-05-23","activity":"91","popularity":"1534393487.75","timestamp":1527026400,"activity_perc":47.643979057592,"popularity_perc":73.547218685725},{"date_published":"2018-05-24","activity":"52","popularity":"1516754834.25","timestamp":1527112800,"activity_perc":30.409356725146,"popularity_perc":35.655067479106},{"date_published":"2018-05-25","activity":"46","popularity":"88681264.75","timestamp":1527199200,"activity_perc":30.263157894737,"popularity_perc":27.409151810611},{"date_published":"2018-05-26","activity":"48","popularity":"50640310.5","timestamp":1527285600,"activity_perc":30.379746835443,"popularity_perc":23.994105190536},{"date_published":"2018-05-27","activity":"63","popularity":"201203861","timestamp":1527372000,"activity_perc":41.721854304636,"popularity_perc":65.195307662961},{"date_published":"2018-05-28","activity":"112","popularity":"391061396.25","timestamp":1527458400,"activity_perc":41.176470588235,"popularity_perc":46.671088505582},{"date_published":"2018-05-29","activity":"104","popularity":"237679270.5","timestamp":1527544800,"activity_perc":38.661710037175,"popularity_perc":47.917846571615},{"date_published":"2018-05-30","activity":"97","popularity":"113857259.25","timestamp":1527631200,"activity_perc":40.416666666667,"popularity_perc":40.669908400007},{"date_published":"2018-05-31","activity":"111","popularity":"107343050.75","timestamp":1527717600,"activity_perc":44.047619047619,"popularity_perc":44.204275245861},{"date_published":"2018-06-01","activity":"103","popularity":"159981230.75","timestamp":1527804000,"activity_perc":36.013986013986,"popularity_perc":48.848012881719},{"date_published":"2018-06-02","activity":"87","popularity":"176777374.75","timestamp":1527890400,"activity_perc":37.339055793991,"popularity_perc":41.341317702603},{"date_published":"2018-06-03","activity":"74","popularity":"121589601.5","timestamp":1527976800,"activity_perc":47.435897435897,"popularity_perc":22.278773849445},{"date_published":"2018-06-04","activity":"63","popularity":"106355656.75","timestamp":1528063200,"activity_perc":30,"popularity_perc":29.085048015267},{"date_published":"2018-06-05","activity":"49","popularity":"71013737","timestamp":1528149600,"activity_perc":25.128205128205,"popularity_perc":30.757111346622},{"date_published":"2018-06-06","activity":"45","popularity":"479417804","timestamp":1528236000,"activity_perc":25.714285714286,"popularity_perc":47.382081106843}],"centro-sinistra":[{"date_published":"2018-02-01","activity":"72","popularity":"1488","timestamp":1517439600,"activity_perc":28.685258964143,"popularity_perc":18.626775990486},{"date_published":"2018-02-02","activity":"78","popularity":"3519","timestamp":1517526000,"activity_perc":27.56183745583,"popularity_perc":9.0100239396771},{"date_published":"2018-02-03","activity":"79","popularity":"34068","timestamp":1517612400,"activity_perc":29.151291512915,"popularity_perc":35.066338661699},{"date_published":"2018-02-04","activity":"44","popularity":"7365","timestamp":1517698800,"activity_perc":19.909502262443,"popularity_perc":50.013581420617},{"date_published":"2018-02-05","activity":"71","popularity":"1249409.25","timestamp":1517785200,"activity_perc":26.893939393939,"popularity_perc":90.37833077291},{"date_published":"2018-02-06","activity":"93","popularity":"48584388.5","timestamp":1517871600,"activity_perc":28.971962616822,"popularity_perc":31.318219935578},{"date_published":"2018-02-07","activity":"69","popularity":"31927156.5","timestamp":1517958000,"activity_perc":23.630136986301,"popularity_perc":13.769735948386},{"date_published":"2018-02-08","activity":"65","popularity":"55612726.5","timestamp":1518044400,"activity_perc":25.590551181102,"popularity_perc":24.044439468663},{"date_published":"2018-02-09","activity":"53","popularity":"45299807","timestamp":1518130800,"activity_perc":21.2,"popularity_perc":13.416497749377},{"date_published":"2018-02-10","activity":"37","popularity":"92868938.5","timestamp":1518217200,"activity_perc":17.289719626168,"popularity_perc":12.489715733077},{"date_published":"2018-02-11","activity":"52","popularity":"85163431","timestamp":1518303600,"activity_perc":28.415300546448,"popularity_perc":18.169477560436},{"date_published":"2018-02-12","activity":"72","popularity":"431605926.75","timestamp":1518390000,"activity_perc":25.89928057554,"popularity_perc":40.359989239544},{"date_published":"2018-02-13","activity":"56","popularity":"57523905.25","timestamp":1518476400,"activity_perc":20.664206642066,"popularity_perc":11.113621477452},{"date_published":"2018-02-14","activity":"59","popularity":"173019554.25","timestamp":1518562800,"activity_perc":24.894514767932,"popularity_perc":37.146037399808},{"date_published":"2018-02-15","activity":"66","popularity":"152901593","timestamp":1518649200,"activity_perc":24.719101123596,"popularity_perc":22.213002162907},{"date_published":"2018-02-16","activity":"82","popularity":"300392663.25","timestamp":1518735600,"activity_perc":29.818181818182,"popularity_perc":33.849954571088},{"date_published":"2018-02-17","activity":"88","popularity":"241360452.75","timestamp":1518822000,"activity_perc":32,"popularity_perc":18.348785839899},{"date_published":"2018-02-18","activity":"61","popularity":"122715308.5","timestamp":1518908400,"activity_perc":22.592592592593,"popularity_perc":23.504779695661},{"date_published":"2018-02-19","activity":"89","popularity":"295299669.5","timestamp":1518994800,"activity_perc":32.481751824818,"popularity_perc":52.3694956173},{"date_published":"2018-02-20","activity":"92","popularity":"257930724","timestamp":1519081200,"activity_perc":28.395061728395,"popularity_perc":34.60202612425},{"date_published":"2018-02-21","activity":"89","popularity":"294831111.5","timestamp":1519167600,"activity_perc":27.469135802469,"popularity_perc":37.412377138808},{"date_published":"2018-02-22","activity":"63","popularity":"238027372","timestamp":1519254000,"activity_perc":22.340425531915,"popularity_perc":30.152713388988},{"date_published":"2018-02-23","activity":"66","popularity":"169917589.5","timestamp":1519340400,"activity_perc":24.444444444444,"popularity_perc":14.167375784442},{"date_published":"2018-02-24","activity":"53","popularity":"207887216.5","timestamp":1519426800,"activity_perc":21.72131147541,"popularity_perc":32.197481471116},{"date_published":"2018-02-25","activity":"55","popularity":"72810145.5","timestamp":1519513200,"activity_perc":25.229357798165,"popularity_perc":16.922444354278},{"date_published":"2018-02-26","activity":"62","popularity":"180158011.75","timestamp":1519599600,"activity_perc":23.220973782772,"popularity_perc":23.659738411809},{"date_published":"2018-02-27","activity":"60","popularity":"130226897.5","timestamp":1519686000,"activity_perc":23.622047244094,"popularity_perc":17.065619910014},{"date_published":"2018-02-28","activity":"64","popularity":"105209512.75","timestamp":1519772400,"activity_perc":22.614840989399,"popularity_perc":25.130085339117},{"date_published":"2018-03-01","activity":"64","popularity":"88621496.75","timestamp":1519858800,"activity_perc":22.535211267606,"popularity_perc":14.075689671524},{"date_published":"2018-03-02","activity":"63","popularity":"111819935","timestamp":1519945200,"activity_perc":23.595505617978,"popularity_perc":27.290603574741},{"date_published":"2018-03-03","activity":"30","popularity":"35434598.5","timestamp":1520031600,"activity_perc":19.736842105263,"popularity_perc":12.535867212632},{"date_published":"2018-03-04","activity":"42","popularity":"34994203","timestamp":1520118000,"activity_perc":25.925925925926,"popularity_perc":24.005199344827},{"date_published":"2018-03-05","activity":"119","popularity":"1574932361.5","timestamp":1520204400,"activity_perc":21.955719557196,"popularity_perc":22.751900304233},{"date_published":"2018-03-06","activity":"124","popularity":"489338044","timestamp":1520290800,"activity_perc":27.740492170022,"popularity_perc":38.821711051576},{"date_published":"2018-03-07","activity":"93","popularity":"149184111.75","timestamp":1520377200,"activity_perc":24.409448818898,"popularity_perc":21.216228624625},{"date_published":"2018-03-08","activity":"76","popularity":"288327866","timestamp":1520463600,"activity_perc":33.04347826087,"popularity_perc":39.326010907208},{"date_published":"2018-03-09","activity":"67","popularity":"137728373.75","timestamp":1520550000,"activity_perc":23.843416370107,"popularity_perc":22.191783361437},{"date_published":"2018-03-10","activity":"44","popularity":"95908261.5","timestamp":1520636400,"activity_perc":20.657276995305,"popularity_perc":30.132034616482},{"date_published":"2018-03-11","activity":"45","popularity":"57390285.5","timestamp":1520722800,"activity_perc":21.327014218009,"popularity_perc":24.106422871449},{"date_published":"2018-03-12","activity":"96","popularity":"251415770","timestamp":1520809200,"activity_perc":40.851063829787,"popularity_perc":47.005434323096},{"date_published":"2018-03-13","activity":"85","popularity":"258506965.25","timestamp":1520895600,"activity_perc":32.818532818533,"popularity_perc":38.989623742136},{"date_published":"2018-03-14","activity":"53","popularity":"151261581.75","timestamp":1520982000,"activity_perc":21.991701244813,"popularity_perc":30.052066448759},{"date_published":"2018-03-15","activity":"63","popularity":"62738480.75","timestamp":1521068400,"activity_perc":23.954372623574,"popularity_perc":16.987123499349},{"date_published":"2018-03-16","activity":"64","popularity":"181776496.5","timestamp":1521154800,"activity_perc":29.906542056075,"popularity_perc":36.249532588784},{"date_published":"2018-03-17","activity":"61","popularity":"169214353","timestamp":1521241200,"activity_perc":27.601809954751,"popularity_perc":41.693102957273},{"date_published":"2018-03-18","activity":"40","popularity":"101009341.5","timestamp":1521327600,"activity_perc":22.222222222222,"popularity_perc":34.957259816506},{"date_published":"2018-03-19","activity":"49","popularity":"107389318.25","timestamp":1521414000,"activity_perc":22.58064516129,"popularity_perc":17.286483435687},{"date_published":"2018-03-20","activity":"42","popularity":"33866266.5","timestamp":1521500400,"activity_perc":22.222222222222,"popularity_perc":11.986927276647},{"date_published":"2018-03-21","activity":"35","popularity":"81283212.5","timestamp":1521586800,"activity_perc":17.326732673267,"popularity_perc":13.778971287092},{"date_published":"2018-03-22","activity":"51","popularity":"129361048.25","timestamp":1521673200,"activity_perc":25.757575757576,"popularity_perc":24.764181103038},{"date_published":"2018-03-23","activity":"69","popularity":"481122128","timestamp":1521759600,"activity_perc":26.335877862595,"popularity_perc":15.072396277956},{"date_published":"2018-03-24","activity":"43","popularity":"56671479.5","timestamp":1521846000,"activity_perc":18.942731277533,"popularity_perc":6.3913547178848},{"date_published":"2018-03-25","activity":"27","popularity":"12560145","timestamp":1521932400,"activity_perc":13.432835820896,"popularity_perc":4.1991016184308},{"date_published":"2018-03-26","activity":"25","popularity":"50615661.75","timestamp":1522015200,"activity_perc":10.121457489879,"popularity_perc":10.997573468145},{"date_published":"2018-03-27","activity":"51","popularity":"140837549","timestamp":1522101600,"activity_perc":20.07874015748,"popularity_perc":24.656258082693},{"date_published":"2018-03-28","activity":"48","popularity":"140207236.5","timestamp":1522188000,"activity_perc":21.917808219178,"popularity_perc":27.193773357721},{"date_published":"2018-03-29","activity":"52","popularity":"408508884.75","timestamp":1522274400,"activity_perc":22.80701754386,"popularity_perc":23.153798797804},{"date_published":"2018-03-30","activity":"36","popularity":"43802032.5","timestamp":1522360800,"activity_perc":16.289592760181,"popularity_perc":11.824477821174},{"date_published":"2018-03-31","activity":"39","popularity":"69854581.75","timestamp":1522447200,"activity_perc":24.84076433121,"popularity_perc":23.415525655762},{"date_published":"2018-04-01","activity":"14","popularity":"13057030.75","timestamp":1522533600,"activity_perc":20.588235294118,"popularity_perc":11.15865466587},{"date_published":"2018-04-02","activity":"8","popularity":"10157889","timestamp":1522620000,"activity_perc":11.940298507463,"popularity_perc":5.8644412575866},{"date_published":"2018-04-03","activity":"32","popularity":"640612982.5","timestamp":1522706400,"activity_perc":20,"popularity_perc":65.622631434731},{"date_published":"2018-04-04","activity":"51","popularity":"56985817","timestamp":1522792800,"activity_perc":20.731707317073,"popularity_perc":12.530030180207},{"date_published":"2018-04-05","activity":"51","popularity":"337829108.5","timestamp":1522879200,"activity_perc":20.816326530612,"popularity_perc":19.943313654094},{"date_published":"2018-04-06","activity":"51","popularity":"123294459.5","timestamp":1522965600,"activity_perc":29.310344827586,"popularity_perc":24.413653648566},{"date_published":"2018-04-07","activity":"52","popularity":"116507637.75","timestamp":1523052000,"activity_perc":28.729281767956,"popularity_perc":23.734808339419},{"date_published":"2018-04-08","activity":"51","popularity":"269754775","timestamp":1523138400,"activity_perc":27.127659574468,"popularity_perc":32.309210117165},{"date_published":"2018-04-09","activity":"53","popularity":"86988413.25","timestamp":1523224800,"activity_perc":23.981900452489,"popularity_perc":32.534018585293},{"date_published":"2018-04-10","activity":"61","popularity":"113456871.25","timestamp":1523311200,"activity_perc":28.110599078341,"popularity_perc":35.625060608684},{"date_published":"2018-04-11","activity":"56","popularity":"49806275","timestamp":1523397600,"activity_perc":23.430962343096,"popularity_perc":17.865162704418},{"date_published":"2018-04-12","activity":"54","popularity":"235447636","timestamp":1523484000,"activity_perc":23.376623376623,"popularity_perc":50.946930151082},{"date_published":"2018-04-13","activity":"52","popularity":"67236690.5","timestamp":1523570400,"activity_perc":20.634920634921,"popularity_perc":18.108336776529},{"date_published":"2018-04-14","activity":"37","popularity":"32643153.75","timestamp":1523656800,"activity_perc":24.503311258278,"popularity_perc":14.010686728335},{"date_published":"2018-04-15","activity":"28","popularity":"41874245.5","timestamp":1523743200,"activity_perc":16.766467065868,"popularity_perc":18.706187079887},{"date_published":"2018-04-16","activity":"43","popularity":"55423251.5","timestamp":1523829600,"activity_perc":24.157303370787,"popularity_perc":28.925301386163},{"date_published":"2018-04-17","activity":"62","popularity":"70097459.75","timestamp":1523916000,"activity_perc":25.941422594142,"popularity_perc":13.566826534061},{"date_published":"2018-04-18","activity":"61","popularity":"216575231","timestamp":1524002400,"activity_perc":25.102880658436,"popularity_perc":26.292654090492},{"date_published":"2018-04-19","activity":"59","popularity":"349858761","timestamp":1524088800,"activity_perc":22.95719844358,"popularity_perc":19.764558623936},{"date_published":"2018-04-20","activity":"36","popularity":"72738763.5","timestamp":1524175200,"activity_perc":14.229249011858,"popularity_perc":16.027546046994},{"date_published":"2018-04-21","activity":"46","popularity":"148425922.75","timestamp":1524261600,"activity_perc":23,"popularity_perc":30.075343210507},{"date_published":"2018-04-22","activity":"16","popularity":"17329175.75","timestamp":1524348000,"activity_perc":13.445378151261,"popularity_perc":9.9757650344833},{"date_published":"2018-04-23","activity":"42","popularity":"161261418.5","timestamp":1524434400,"activity_perc":18.421052631579,"popularity_perc":7.8172762213198},{"date_published":"2018-04-24","activity":"58","popularity":"96469171","timestamp":1524520800,"activity_perc":25.663716814159,"popularity_perc":29.797031691151},{"date_published":"2018-04-25","activity":"77","popularity":"274064721.75","timestamp":1524607200,"activity_perc":33.189655172414,"popularity_perc":46.908610728611},{"date_published":"2018-04-26","activity":"58","popularity":"173077081.25","timestamp":1524693600,"activity_perc":26.48401826484,"popularity_perc":33.912754207516},{"date_published":"2018-04-27","activity":"64","popularity":"135399393","timestamp":1524780000,"activity_perc":32.820512820513,"popularity_perc":55.146435514689},{"date_published":"2018-04-28","activity":"55","popularity":"152729684.25","timestamp":1524866400,"activity_perc":34.810126582278,"popularity_perc":33.649039050263},{"date_published":"2018-04-29","activity":"48","popularity":"92317455.25","timestamp":1524952800,"activity_perc":34.532374100719,"popularity_perc":49.069475747285},{"date_published":"2018-04-30","activity":"63","popularity":"154482741.75","timestamp":1525039200,"activity_perc":27.753303964758,"popularity_perc":25.484145832813},{"date_published":"2018-05-01","activity":"34","popularity":"102399879.75","timestamp":1525125600,"activity_perc":27.41935483871,"popularity_perc":32.883811002011},{"date_published":"2018-05-02","activity":"65","popularity":"114002548.5","timestamp":1525212000,"activity_perc":31.25,"popularity_perc":32.918248646718},{"date_published":"2018-05-03","activity":"97","popularity":"181741569.75","timestamp":1525298400,"activity_perc":41.452991452991,"popularity_perc":38.177634736823},{"date_published":"2018-05-04","activity":"74","popularity":"239088309.25","timestamp":1525384800,"activity_perc":31.223628691983,"popularity_perc":32.730099130871},{"date_published":"2018-05-05","activity":"44","popularity":"145518537","timestamp":1525471200,"activity_perc":27.16049382716,"popularity_perc":38.239065675166},{"date_published":"2018-05-06","activity":"36","popularity":"70060171.25","timestamp":1525557600,"activity_perc":21.176470588235,"popularity_perc":13.61320358254},{"date_published":"2018-05-07","activity":"38","popularity":"183694942.75","timestamp":1525644000,"activity_perc":17.840375586854,"popularity_perc":20.452778227453},{"date_published":"2018-05-08","activity":"49","popularity":"300047744.25","timestamp":1525730400,"activity_perc":23.11320754717,"popularity_perc":33.36807510241},{"date_published":"2018-05-09","activity":"31","popularity":"26989681.75","timestamp":1525816800,"activity_perc":13.419913419913,"popularity_perc":4.5379855036076},{"date_published":"2018-05-10","activity":"33","popularity":"45317301.5","timestamp":1525903200,"activity_perc":11.870503597122,"popularity_perc":6.3450761424303},{"date_published":"2018-05-11","activity":"52","popularity":"539616374","timestamp":1525989600,"activity_perc":17.931034482759,"popularity_perc":47.806723335634},{"date_published":"2018-05-12","activity":"28","popularity":"15775997.5","timestamp":1526076000,"activity_perc":10.44776119403,"popularity_perc":4.2058257634228},{"date_published":"2018-05-13","activity":"15","popularity":"14728202.5","timestamp":1526162400,"activity_perc":9.2024539877301,"popularity_perc":4.5823191715201},{"date_published":"2018-05-14","activity":"16","popularity":"52273594.75","timestamp":1526248800,"activity_perc":7.4074074074074,"popularity_perc":6.6362348978513},{"date_published":"2018-05-15","activity":"30","popularity":"46703363.5","timestamp":1526335200,"activity_perc":13.392857142857,"popularity_perc":4.0926363503382},{"date_published":"2018-05-16","activity":"21","popularity":"52389285.5","timestamp":1526421600,"activity_perc":8.6776859504132,"popularity_perc":5.7460607022937},{"date_published":"2018-05-17","activity":"22","popularity":"132356508.5","timestamp":1526508000,"activity_perc":8.4291187739464,"popularity_perc":13.746968644188},{"date_published":"2018-05-18","activity":"27","popularity":"174922528.5","timestamp":1526594400,"activity_perc":11.111111111111,"popularity_perc":13.23485306666},{"date_published":"2018-05-19","activity":"57","popularity":"261203250.25","timestamp":1526680800,"activity_perc":24.152542372881,"popularity_perc":54.210329011675},{"date_published":"2018-05-20","activity":"16","popularity":"8628779.25","timestamp":1526767200,"activity_perc":10.526315789474,"popularity_perc":1.450423827513},{"date_published":"2018-05-21","activity":"30","popularity":"88087253","timestamp":1526853600,"activity_perc":12.448132780083,"popularity_perc":6.635287750828},{"date_published":"2018-05-22","activity":"30","popularity":"97555273","timestamp":1526940000,"activity_perc":16.759776536313,"popularity_perc":23.065962167249},{"date_published":"2018-05-23","activity":"21","popularity":"254098565.75","timestamp":1527026400,"activity_perc":10.994764397906,"popularity_perc":12.179563411957},{"date_published":"2018-05-24","activity":"19","popularity":"247124960.75","timestamp":1527112800,"activity_perc":11.111111111111,"popularity_perc":5.8092823918175},{"date_published":"2018-05-25","activity":"28","popularity":"43642735","timestamp":1527199200,"activity_perc":18.421052631579,"popularity_perc":13.488873353549},{"date_published":"2018-05-26","activity":"29","popularity":"44701298.25","timestamp":1527285600,"activity_perc":18.354430379747,"popularity_perc":21.18011603353},{"date_published":"2018-05-27","activity":"21","popularity":"16299949","timestamp":1527372000,"activity_perc":13.907284768212,"popularity_perc":5.2816093322661},{"date_published":"2018-05-28","activity":"48","popularity":"56246297.75","timestamp":1527458400,"activity_perc":17.647058823529,"popularity_perc":6.7126951562445},{"date_published":"2018-05-29","activity":"46","popularity":"75530572.5","timestamp":1527544800,"activity_perc":17.100371747212,"popularity_perc":15.227505440031},{"date_published":"2018-05-30","activity":"30","popularity":"38223101.75","timestamp":1527631200,"activity_perc":12.5,"popularity_perc":13.653323970528},{"date_published":"2018-05-31","activity":"31","popularity":"22033348.75","timestamp":1527717600,"activity_perc":12.301587301587,"popularity_perc":9.0734165456263},{"date_published":"2018-06-01","activity":"40","popularity":"27638363.75","timestamp":1527804000,"activity_perc":13.986013986014,"popularity_perc":8.4389846368876},{"date_published":"2018-06-02","activity":"21","popularity":"35237769.75","timestamp":1527890400,"activity_perc":9.0128755364807,"popularity_perc":8.2407368953528},{"date_published":"2018-06-03","activity":"12","popularity":"126290122.5","timestamp":1527976800,"activity_perc":7.6923076923077,"popularity_perc":23.140046878073},{"date_published":"2018-06-04","activity":"34","popularity":"67322274.25","timestamp":1528063200,"activity_perc":16.190476190476,"popularity_perc":18.410601174331},{"date_published":"2018-06-05","activity":"41","popularity":"26495160.25","timestamp":1528149600,"activity_perc":21.025641025641,"popularity_perc":11.475450080255},{"date_published":"2018-06-06","activity":"42","popularity":"177660093","timestamp":1528236000,"activity_perc":24,"popularity_perc":17.558598920901}],"sinistra":[{"date_published":"2018-02-01","activity":"25","popularity":"209","timestamp":1517439600,"activity_perc":9.9601593625498,"popularity_perc":2.6162608750078},{"date_published":"2018-02-02","activity":"27","popularity":"783.5","timestamp":1517526000,"activity_perc":9.5406360424028,"popularity_perc":2.0060681320651},{"date_published":"2018-02-03","activity":"34","popularity":"1279","timestamp":1517612400,"activity_perc":12.546125461255,"popularity_perc":1.3164801910389},{"date_published":"2018-02-04","activity":"55","popularity":"1747","timestamp":1517698800,"activity_perc":24.886877828054,"popularity_perc":11.863370908597},{"date_published":"2018-02-05","activity":"33","popularity":"798.5","timestamp":1517785200,"activity_perc":12.5,"popularity_perc":0.057760975534773},{"date_published":"2018-02-06","activity":"47","popularity":"15903216.5","timestamp":1517871600,"activity_perc":14.641744548287,"popularity_perc":10.251450052317},{"date_published":"2018-02-07","activity":"38","popularity":"44158634.75","timestamp":1517958000,"activity_perc":13.013698630137,"popularity_perc":19.045001403389},{"date_published":"2018-02-08","activity":"28","popularity":"27449183.75","timestamp":1518044400,"activity_perc":11.023622047244,"popularity_perc":11.867791397372},{"date_published":"2018-02-09","activity":"16","popularity":"4040454.75","timestamp":1518130800,"activity_perc":6.4,"popularity_perc":1.1966662917534},{"date_published":"2018-02-10","activity":"32","popularity":"337547741","timestamp":1518217200,"activity_perc":14.953271028037,"popularity_perc":45.395967688725},{"date_published":"2018-02-11","activity":"22","popularity":"19711104","timestamp":1518303600,"activity_perc":12.021857923497,"popularity_perc":4.2053315327259},{"date_published":"2018-02-12","activity":"24","popularity":"73720607","timestamp":1518390000,"activity_perc":8.6330935251799,"popularity_perc":6.8937026135327},{"date_published":"2018-02-13","activity":"19","popularity":"35532813.75","timestamp":1518476400,"activity_perc":7.0110701107011,"popularity_perc":6.8649414592082},{"date_published":"2018-02-14","activity":"23","popularity":"20857494","timestamp":1518562800,"activity_perc":9.704641350211,"popularity_perc":4.4779519606829},{"date_published":"2018-02-15","activity":"34","popularity":"118940851","timestamp":1518649200,"activity_perc":12.734082397004,"popularity_perc":17.279305785395},{"date_published":"2018-02-16","activity":"16","popularity":"36759782.25","timestamp":1518735600,"activity_perc":5.8181818181818,"popularity_perc":4.1423014322091},{"date_published":"2018-02-17","activity":"22","popularity":"15808923.25","timestamp":1518822000,"activity_perc":8,"popularity_perc":1.2018313015601},{"date_published":"2018-02-18","activity":"42","popularity":"132770731","timestamp":1518908400,"activity_perc":15.555555555556,"popularity_perc":25.430786267281},{"date_published":"2018-02-19","activity":"38","popularity":"50863519.5","timestamp":1518994800,"activity_perc":13.868613138686,"popularity_perc":9.0203177878454},{"date_published":"2018-02-20","activity":"28","popularity":"73593385.25","timestamp":1519081200,"activity_perc":8.641975308642,"popularity_perc":9.8727293883472},{"date_published":"2018-02-21","activity":"35","popularity":"117581393.75","timestamp":1519167600,"activity_perc":10.802469135802,"popularity_perc":14.920404515999},{"date_published":"2018-02-22","activity":"24","popularity":"85951033.25","timestamp":1519254000,"activity_perc":8.5106382978723,"popularity_perc":10.888062365679},{"date_published":"2018-02-23","activity":"32","popularity":"76349551","timestamp":1519340400,"activity_perc":11.851851851852,"popularity_perc":6.3658670251464},{"date_published":"2018-02-24","activity":"29","popularity":"33235027.5","timestamp":1519426800,"activity_perc":11.885245901639,"popularity_perc":5.1474265716732},{"date_published":"2018-02-25","activity":"27","popularity":"98714194.25","timestamp":1519513200,"activity_perc":12.385321100917,"popularity_perc":22.943031464935},{"date_published":"2018-02-26","activity":"30","popularity":"57613740.75","timestamp":1519599600,"activity_perc":11.23595505618,"popularity_perc":7.5662804103454},{"date_published":"2018-02-27","activity":"25","popularity":"139708965.25","timestamp":1519686000,"activity_perc":9.8425196850394,"popularity_perc":18.308200108798},{"date_published":"2018-02-28","activity":"23","popularity":"51209835","timestamp":1519772400,"activity_perc":8.1272084805654,"popularity_perc":12.231855182241},{"date_published":"2018-03-01","activity":"18","popularity":"54318334","timestamp":1519858800,"activity_perc":6.3380281690141,"popularity_perc":8.6273425850054},{"date_published":"2018-03-02","activity":"21","popularity":"46811226.25","timestamp":1519945200,"activity_perc":7.8651685393258,"popularity_perc":11.424676811306},{"date_published":"2018-03-03","activity":"21","popularity":"37737624.5","timestamp":1520031600,"activity_perc":13.815789473684,"popularity_perc":13.350619724171},{"date_published":"2018-03-04","activity":"22","popularity":"3609677.25","timestamp":1520118000,"activity_perc":13.58024691358,"popularity_perc":2.4761536062626},{"date_published":"2018-03-05","activity":"58","popularity":"971534359.75","timestamp":1520204400,"activity_perc":10.70110701107,"popularity_perc":14.035049018941},{"date_published":"2018-03-06","activity":"36","popularity":"44896463.5","timestamp":1520290800,"activity_perc":8.0536912751678,"popularity_perc":3.561868026829},{"date_published":"2018-03-07","activity":"17","popularity":"18170738.25","timestamp":1520377200,"activity_perc":4.4619422572178,"popularity_perc":2.5841527791931},{"date_published":"2018-03-08","activity":"7","popularity":"20547041.25","timestamp":1520463600,"activity_perc":3.0434782608696,"popularity_perc":2.8024803135343},{"date_published":"2018-03-09","activity":"14","popularity":"15176579.75","timestamp":1520550000,"activity_perc":4.982206405694,"popularity_perc":2.4453593751924},{"date_published":"2018-03-10","activity":"6","popularity":"8741573.25","timestamp":1520636400,"activity_perc":2.8169014084507,"popularity_perc":2.7463889309631},{"date_published":"2018-03-11","activity":"6","popularity":"3802198.25","timestamp":1520722800,"activity_perc":2.8436018957346,"popularity_perc":1.5970890902013},{"date_published":"2018-03-12","activity":"7","popularity":"6180782.25","timestamp":1520809200,"activity_perc":2.9787234042553,"popularity_perc":1.1555772898324},{"date_published":"2018-03-13","activity":"7","popularity":"8046155.5","timestamp":1520895600,"activity_perc":2.7027027027027,"popularity_perc":1.2135710742352},{"date_published":"2018-03-14","activity":"4","popularity":"52924683.75","timestamp":1520982000,"activity_perc":1.6597510373444,"popularity_perc":10.514871617985},{"date_published":"2018-03-15","activity":"13","popularity":"44107202.25","timestamp":1521068400,"activity_perc":4.9429657794677,"popularity_perc":11.942502956314},{"date_published":"2018-03-16","activity":"4","popularity":"5373648.5","timestamp":1521154800,"activity_perc":1.8691588785047,"popularity_perc":1.0716030409433},{"date_published":"2018-03-17","activity":"11","popularity":"14798380.25","timestamp":1521241200,"activity_perc":4.9773755656109,"popularity_perc":3.6462060128205},{"date_published":"2018-03-18","activity":"3","popularity":"67541.25","timestamp":1521327600,"activity_perc":1.6666666666667,"popularity_perc":0.023374640300784},{"date_published":"2018-03-19","activity":"5","popularity":"33777958.75","timestamp":1521414000,"activity_perc":2.3041474654378,"popularity_perc":5.43724584473},{"date_published":"2018-03-20","activity":"10","popularity":"13228894.75","timestamp":1521500400,"activity_perc":5.2910052910053,"popularity_perc":4.6823525503961},{"date_published":"2018-03-21","activity":"13","popularity":"14596953.25","timestamp":1521586800,"activity_perc":6.4356435643564,"popularity_perc":2.47444698019},{"date_published":"2018-03-22","activity":"11","popularity":"71035165","timestamp":1521673200,"activity_perc":5.5555555555556,"popularity_perc":13.598588713849},{"date_published":"2018-03-23","activity":"13","popularity":"50373947.75","timestamp":1521759600,"activity_perc":4.9618320610687,"popularity_perc":1.578094330704},{"date_published":"2018-03-24","activity":"15","popularity":"21653620.25","timestamp":1521846000,"activity_perc":6.6079295154185,"popularity_perc":2.4420743761264},{"date_published":"2018-03-25","activity":"8","popularity":"3650296.5","timestamp":1521932400,"activity_perc":3.9800995024876,"popularity_perc":1.2203653652806},{"date_published":"2018-03-26","activity":"11","popularity":"10957091.25","timestamp":1522015200,"activity_perc":4.4534412955466,"popularity_perc":2.3807140290732},{"date_published":"2018-03-27","activity":"10","popularity":"86419468.75","timestamp":1522101600,"activity_perc":3.9370078740157,"popularity_perc":15.129351085691},{"date_published":"2018-03-28","activity":"4","popularity":"108422.75","timestamp":1522188000,"activity_perc":1.8264840182648,"popularity_perc":0.02102904075369},{"date_published":"2018-03-29","activity":"8","popularity":"5055945.25","timestamp":1522274400,"activity_perc":3.5087719298246,"popularity_perc":0.28656497672714},{"date_published":"2018-03-30","activity":"2","popularity":"7351973","timestamp":1522360800,"activity_perc":0.90497737556561,"popularity_perc":1.984685109769},{"date_published":"2018-03-31","activity":"3","popularity":"390589.5","timestamp":1522447200,"activity_perc":1.9108280254777,"popularity_perc":0.13092710927471},{"date_published":"2018-04-01","activity":"4","popularity":"12081820.25","timestamp":1522533600,"activity_perc":5.8823529411765,"popularity_perc":10.325231094739},{"date_published":"2018-04-02","activity":"4","popularity":"2120011.75","timestamp":1522620000,"activity_perc":5.9701492537313,"popularity_perc":1.2239437124454},{"date_published":"2018-04-03","activity":"3","popularity":"670065.75","timestamp":1522706400,"activity_perc":1.875,"popularity_perc":0.068639691905223},{"date_published":"2018-04-04","activity":"9","popularity":"18275696","timestamp":1522792800,"activity_perc":3.6585365853659,"popularity_perc":4.0184564247677},{"date_published":"2018-04-05","activity":"6","popularity":"1091497.25","timestamp":1522879200,"activity_perc":2.4489795918367,"popularity_perc":0.064435158077359},{"date_published":"2018-04-06","activity":"2","popularity":"12192846","timestamp":1522965600,"activity_perc":1.1494252873563,"popularity_perc":2.4143170783299},{"date_published":"2018-04-07","activity":"2","popularity":"333190.25","timestamp":1523052000,"activity_perc":1.1049723756906,"popularity_perc":0.067877152751841},{"date_published":"2018-04-08","activity":"3","popularity":"2014502.25","timestamp":1523138400,"activity_perc":1.5957446808511,"popularity_perc":0.24128201799857},{"date_published":"2018-04-09","activity":"7","popularity":"16410707","timestamp":1523224800,"activity_perc":3.1674208144796,"popularity_perc":6.1376708298079},{"date_published":"2018-04-10","activity":"11","popularity":"9521477","timestamp":1523311200,"activity_perc":5.0691244239631,"popularity_perc":2.9897104641795},{"date_published":"2018-04-11","activity":"3","popularity":"410196.25","timestamp":1523397600,"activity_perc":1.255230125523,"popularity_perc":0.14713452766729},{"date_published":"2018-04-12","activity":"3","popularity":"953713.25","timestamp":1523484000,"activity_perc":1.2987012987013,"popularity_perc":0.20636759475432},{"date_published":"2018-04-13","activity":"5","popularity":"9148501.5","timestamp":1523570400,"activity_perc":1.984126984127,"popularity_perc":2.4638950092669},{"date_published":"2018-04-14","activity":"4","popularity":"990890","timestamp":1523656800,"activity_perc":2.6490066225166,"popularity_perc":0.42529742924241},{"date_published":"2018-04-15","activity":"1","popularity":"68801","timestamp":1523743200,"activity_perc":0.59880239520958,"popularity_perc":0.030734986670585},{"date_published":"2018-04-16","activity":"2","popularity":"980386.25","timestamp":1523829600,"activity_perc":1.123595505618,"popularity_perc":0.51166192867808},{"date_published":"2018-04-17","activity":"2","popularity":"1347.5","timestamp":1523916000,"activity_perc":0.83682008368201,"popularity_perc":0.00026079830595639},{"date_published":"2018-04-18","activity":"4","popularity":"3981089","timestamp":1524002400,"activity_perc":1.6460905349794,"popularity_perc":0.48331194429368},{"date_published":"2018-04-19","activity":"4","popularity":"303536322","timestamp":1524088800,"activity_perc":1.556420233463,"popularity_perc":17.147666714177},{"date_published":"2018-04-20","activity":"3","popularity":"6609.5","timestamp":1524175200,"activity_perc":1.1857707509881,"popularity_perc":0.0014563632992965},{"date_published":"2018-04-21","activity":"2","popularity":"1025533","timestamp":1524261600,"activity_perc":1,"popularity_perc":0.20780235943456},{"date_published":"2018-04-22","activity":"4","popularity":"10969362.5","timestamp":1524348000,"activity_perc":3.3613445378151,"popularity_perc":6.3146559569097},{"date_published":"2018-04-23","activity":"4","popularity":"4764800.75","timestamp":1524434400,"activity_perc":1.7543859649123,"popularity_perc":0.23097752673124},{"date_published":"2018-04-24","activity":"5","popularity":"8719191.5","timestamp":1524520800,"activity_perc":2.212389380531,"popularity_perc":2.693150804071},{"date_published":"2018-04-25","activity":"6","popularity":"13951673.75","timestamp":1524607200,"activity_perc":2.5862068965517,"popularity_perc":2.387952848409},{"date_published":"2018-04-26","activity":"5","popularity":"37520895.5","timestamp":1524693600,"activity_perc":2.2831050228311,"popularity_perc":7.3518509645966},{"date_published":"2018-04-27","activity":"6","popularity":"979890.25","timestamp":1524780000,"activity_perc":3.0769230769231,"popularity_perc":0.39909672625414},{"date_published":"2018-04-28","activity":"4","popularity":"165671.5","timestamp":1524866400,"activity_perc":2.5316455696203,"popularity_perc":0.036500348968774},{"date_published":"2018-04-30","activity":"1","popularity":"87272","timestamp":1525039200,"activity_perc":0.44052863436123,"popularity_perc":0.014396769179048},{"date_published":"2018-05-01","activity":"4","popularity":"4253133.5","timestamp":1525125600,"activity_perc":3.2258064516129,"popularity_perc":1.365814476753},{"date_published":"2018-05-02","activity":"4","popularity":"14541.25","timestamp":1525212000,"activity_perc":1.9230769230769,"popularity_perc":0.0041987875659998},{"date_published":"2018-05-03","activity":"5","popularity":"12394309.75","timestamp":1525298400,"activity_perc":2.1367521367521,"popularity_perc":2.6036169441116},{"date_published":"2018-05-04","activity":"8","popularity":"41503276.5","timestamp":1525384800,"activity_perc":3.3755274261603,"popularity_perc":5.6816092696551},{"date_published":"2018-05-05","activity":"3","popularity":"1129240.5","timestamp":1525471200,"activity_perc":1.8518518518519,"popularity_perc":0.29673952564928},{"date_published":"2018-05-06","activity":"1","popularity":"54053.5","timestamp":1525557600,"activity_perc":0.58823529411765,"popularity_perc":0.010502990311329},{"date_published":"2018-05-07","activity":"1","popularity":"3220.25","timestamp":1525644000,"activity_perc":0.46948356807512,"popularity_perc":0.00035854584835573},{"date_published":"2018-05-08","activity":"4","popularity":"9134063","timestamp":1525730400,"activity_perc":1.8867924528302,"popularity_perc":1.0157920064888},{"date_published":"2018-05-09","activity":"5","popularity":"9336108.5","timestamp":1525816800,"activity_perc":2.1645021645022,"popularity_perc":1.5697526716153},{"date_published":"2018-05-10","activity":"4","popularity":"21245109.75","timestamp":1525903200,"activity_perc":1.4388489208633,"popularity_perc":2.974621933701},{"date_published":"2018-05-11","activity":"4","popularity":"19131654.25","timestamp":1525989600,"activity_perc":1.3793103448276,"popularity_perc":1.6949480144625},{"date_published":"2018-05-12","activity":"3","popularity":"5709058.5","timestamp":1526076000,"activity_perc":1.1194029850746,"popularity_perc":1.5220150310108},{"date_published":"2018-05-13","activity":"1","popularity":"1657.75","timestamp":1526162400,"activity_perc":0.61349693251534,"popularity_perc":0.00051576827563224},{"date_published":"2018-05-14","activity":"3","popularity":"51847.75","timestamp":1526248800,"activity_perc":1.3888888888889,"popularity_perc":0.0065821730755387},{"date_published":"2018-05-15","activity":"5","popularity":"46497.5","timestamp":1526335200,"activity_perc":2.2321428571429,"popularity_perc":0.0040745964410004},{"date_published":"2018-05-16","activity":"4","popularity":"24779978.25","timestamp":1526421600,"activity_perc":1.6528925619835,"popularity_perc":2.7178698443219},{"date_published":"2018-05-18","activity":"1","popularity":"584217.5","timestamp":1526594400,"activity_perc":0.41152263374486,"popularity_perc":0.044202612652444},{"date_published":"2018-05-19","activity":"3","popularity":"1851215.75","timestamp":1526680800,"activity_perc":1.271186440678,"popularity_perc":0.3842027799541},{"date_published":"2018-05-20","activity":"1","popularity":"0","timestamp":1526767200,"activity_perc":0.65789473684211,"popularity_perc":0},{"date_published":"2018-05-21","activity":"1","popularity":"4904","timestamp":1526853600,"activity_perc":0.4149377593361,"popularity_perc":0.00036940022559292},{"date_published":"2018-05-22","activity":"5","popularity":"678820.5","timestamp":1526940000,"activity_perc":2.7932960893855,"popularity_perc":0.16050027322821},{"date_published":"2018-05-23","activity":"1","popularity":"9098275","timestamp":1527026400,"activity_perc":0.52356020942408,"popularity_perc":0.43610249028696},{"date_published":"2018-05-24","activity":"7","popularity":"747206977","timestamp":1527112800,"activity_perc":4.093567251462,"popularity_perc":17.564944962887},{"date_published":"2018-05-25","activity":"9","popularity":"564455.5","timestamp":1527199200,"activity_perc":5.9210526315789,"popularity_perc":0.17445901942704},{"date_published":"2018-05-26","activity":"5","popularity":"9700960.25","timestamp":1527285600,"activity_perc":3.1645569620253,"popularity_perc":4.5964540578341},{"date_published":"2018-05-27","activity":"3","popularity":"3038820.75","timestamp":1527372000,"activity_perc":1.9867549668874,"popularity_perc":0.98465731593908},{"date_published":"2018-05-28","activity":"3","popularity":"6749363","timestamp":1527458400,"activity_perc":1.1029411764706,"popularity_perc":0.80550041745344},{"date_published":"2018-05-29","activity":"5","popularity":"1134102.75","timestamp":1527544800,"activity_perc":1.8587360594796,"popularity_perc":0.22864325297122},{"date_published":"2018-05-30","activity":"4","popularity":"5278415","timestamp":1527631200,"activity_perc":1.6666666666667,"popularity_perc":1.8854542605479},{"date_published":"2018-05-31","activity":"1","popularity":"5065","timestamp":1527717600,"activity_perc":0.3968253968254,"popularity_perc":0.0020857862018635},{"date_published":"2018-06-01","activity":"5","popularity":"23359.25","timestamp":1527804000,"activity_perc":1.7482517482517,"popularity_perc":0.0071324175939763},{"date_published":"2018-06-02","activity":"9","popularity":"6144966.25","timestamp":1527890400,"activity_perc":3.862660944206,"popularity_perc":1.4370673983155},{"date_published":"2018-06-03","activity":"3","popularity":"12517947.25","timestamp":1527976800,"activity_perc":1.9230769230769,"popularity_perc":2.2936543290014},{"date_published":"2018-06-04","activity":"3","popularity":"15585132.75","timestamp":1528063200,"activity_perc":1.4285714285714,"popularity_perc":4.2620613534791},{"date_published":"2018-06-05","activity":"2","popularity":"30256993.5","timestamp":1528149600,"activity_perc":1.025641025641,"popularity_perc":13.104756310649},{"date_published":"2018-06-06","activity":"7","popularity":"832973.5","timestamp":1528236000,"activity_perc":4,"popularity_perc":0.082324889913456}],"max":{"activity":542,"popularity":6922201400.5,"activity_timestamp":1520204400,"popularity_timestamp":1520204400,"destra":{"activity":"75","activity_timestamp":1519167600,"popularity":"379134029","popularity_timestamp":1520204400},"centro-destra":{"activity":"173","activity_timestamp":1520204400,"popularity":"2495582714.75","popularity_timestamp":1520204400},"sinistra":{"activity":"58","activity_timestamp":1520204400,"popularity":"971534359.75","popularity_timestamp":1520204400},"centro-sinistra":{"activity":"124","activity_timestamp":1520290800,"popularity":"1574932361.5","popularity_timestamp":1520204400},"m5s":{"activity":"166","activity_timestamp":1520204400,"popularity":"1534393487.75","popularity_timestamp":1527026400}}},"milestones":[{"dbid":"32","type":"milestone","id":"M32","title":"M5S-Lega, il governo ha giurato. Conte: «Non siamo dei marziani e lo dimostreremo»","description":"È nato il nuovo governo M5S-Lega presieduto dal professore Giuseppe Conte. L’esecutivo, che ha giurato nel pomeriggio nel Salone delle Feste del Quirinale sulla Costituzione davanti al Capo dello Stato Sergio Mattarella, è nella pienezza dei suoi poteri. ","date_published":"2018-06-01 20:00:00","short_published":"01-06-2018 20:00","timestamp_published":"1527876000","timestamp_order":"1527804000","url":"http://www.ilsole24ore.com/art/notizie/2018-06-01/m5s-lega-governo-conte-giura-a-mattarella-152802.shtml?uuid=AEGmDnyE","source":"www.ilsole24ore.com","tags":["sergio mattarella","giuseppe conte","luigi di maio"," matteo salvini"]},{"dbid":"31","type":"milestone","id":"M31","title":"Giovanni Tria, Enzo Moavero Milanesi, Marco Bussetti, Alfonso Bonafede, Giulia Grillo: chi sono i ministri del Governo Conte","description":"Confermato il nome fatto da Matteo Salvini e Luigi Di Maio per la presidenza del Consiglio: Giuseppe Conte. Nato a Volturara Appula, in provincia di Foggia, laureato in Giurisprudenza nel 1988, docente di Diritto Privato all’università di Firenze, ha 53 anni.","date_published":"2018-05-30 22:00:00","short_published":"30-05-2018 22:00","timestamp_published":"1527710400","timestamp_order":"1527631200","url":"https://roma.corriere.it/politica/cards/tria-economia-savona-affari-europei-tutti-altri-ministri-governo-conte-lega-5-stelle/presidente-consiglio-giuseppe-conte_principale.shtml","source":"www.corriere.it","tags":["giuseppe conte","sergio mattarella","matteo salvini","luigi di maio"]},{"dbid":"30","type":"milestone","id":"M30","title":"Come funziona la messa in stato d’accusa del presidente della Repubblica","description":"Dopo la crisi istituzionale cominciata ieri sera con la rinuncia all’incarico di presidente del Consiglio di Giuseppe Conte, dovuta all’opposizione del presidente della Repubblica Sergio Mattarella alla nomina di Paolo Savona come ministro dell’Economia, Luigi Di Maio ha detto che chiederà la “messa in stato d’accusa” di Mattarella. Il leader della Lega Matteo Salvini, che insieme al M5S aveva coordinato la formazione del governo Conte, fin qui non ha seguito Di Maio su questa strada: forse perché estrema e senza precedenti, e forse perché, per come stanno le cose, sarebbe molto improbabile avesse successo.","date_published":"2018-05-28 15:17:50","short_published":"28-05-2018 15:17","timestamp_published":"1527513470","timestamp_order":"1527458400","url":"https://www.ilpost.it/2018/05/28/messa-stato-accusa-presidente-repubblica/","source":"www.ilpost.it","tags":["sergio mattarella","luigi di maio"]},{"dbid":"29","type":"milestone","id":"M29","title":"Governo, Conte rimette mandato. Mattarella convoca Cottarelli","description":"Nulla di fatto per la formazione del nuovo esecutivo, no di Mattarella su Savona. Conte: \"Ci ho messo il massimo impegno\". Leader Lega: \"Ora al voto\". M5S chiede impeachment.","date_published":"2018-05-27 23:00:00","short_published":"27-05-2018 23:00","timestamp_published":"1527454800","timestamp_order":"1527372000","url":"https://tg24.sky.it/politica/2018/05/27/governo-conte-mattarella-diretta.html","source":"tg24.sky.it","tags":["sergio mattarella","giuseppe conte","carlo cottarelli"]},{"dbid":"28","type":"milestone","id":"M28","title":"Governo, Mattarella affida incarico a Conte. Lui: “Confermerò la collocazione europea dell’Italia. Sarò avvocato del popolo”","description":"Dopo due giorni di silenzio il capo dello Stato ha sciolto le riserve e ha affidato l'incarico al professore indicato da Lega e Movimento 5 stelle. Nel primo discorso davanti ai giornalisti ha tranquillizzato i partner europei e garantito che la base d'azione sarà il contratto di governo firmato dalle due forze politiche. Dal 24 maggio partono i colloqui con i partiti per formare la squadra. Resta il nodo Savona all'Economia","date_published":"2018-05-23 18:00:00","short_published":"23-05-2018 18:00","timestamp_published":"1527091200","timestamp_order":"1527026400","url":"https://www.ilfattoquotidiano.it/2018/05/23/governo-mattarella-affida-lincarico-conte-lui-confermero-la-posizione-ue-saro-avvocato-del-popolo-italiano/4375622/","source":"www.ilfattoquotidiano.it","tags":["sergio mattarella","giuseppe conte"]},{"dbid":"27","type":"milestone","id":"M27","title":"Governo, Mattarella convoca M5S e Lega. Inizio consultazioni alle 17 e 30","description":"Il presidente della Repubblica, Sergio Mattarella, ha fissato la scaletta degli incontri per oggi pomeriggio per l’incontro con M5S e Lega in vista del nuovo governo. ","date_published":"2018-05-21 12:54:32","short_published":"21-05-2018 12:54","timestamp_published":"1526900072","timestamp_order":"1526853600","url":"https://www.corriere.it/politica/18_maggio_21/governo-mattarella-convoca-m5s-lega-inizio-consultazioni-17-30-49f809f4-5cce-11e8-9df6-a1f7c25f6df9.shtml","source":"www.corriere.it","tags":["m5s","lega","sergio mattarella"]},{"dbid":"35","type":"milestone","id":"M35","title":"La nuova bozza del programma Lega-M5S","description":"Dovrebbe essere la versione definitiva: ora sarà esaminata un'ultima volta da Salvini e Di Maio, che dovranno anche scegliere il futuro presidente del Consiglio","date_published":"2018-05-17 16:00:00","short_published":"17-05-2018 16:00","timestamp_published":"1526565600","timestamp_order":"1526508000","url":"https://www.ilpost.it/2018/05/17/bozza-lega-movimento-5-stelle/","source":"www.ilpost.it","tags":["matteo slavini","luigi di maio","lega","movimento 5 stelle"]},{"dbid":"26","type":"milestone","id":"M26","title":"M5S - Lega: l'accordo c'è (67 giorni dal voto)","description":"A 67 giorni dal voto sembra che si sia trovato un accordo per il prossimo governo.","date_published":"2018-05-10 22:00:00","short_published":"10-05-2018 22:00","timestamp_published":"1525982400","timestamp_order":"1525903200","url":"http://www.la7.it/piazzapulita/video/m5s-lega-laccordo-c%C3%A8-67-giorni-dal-voto-10-05-2018-241325","source":"www.la7.it","tags":["lega","m5s","luigi di maio","matteo salvini"]},{"dbid":"36","type":"milestone","id":"M36","title":"Direzione Pd, passa la linea Renzi. Martina: \"Con M5S capitolo chiuso\". E chiede la fiducia fino all'assemblea (e non al Congresso)","description":"Con M5s \"capitolo chiuso\". \"Parlavamo molto di loro ma il tema vero eravamo noi, il nostro ruolo e la nostra funzione anche quando si è minoranza. Per me era non condannarci all'irrilevanza e accettare una sfida. Era un'ipotesi più rischiosa ma l'ho immaginata per come potevo fino a qui con questa ambizione\". Lo ha detto il reggente Maurizio Martina in direzione Pd. ","date_published":"2018-05-03 16:00:00","short_published":"03-05-2018 16:00","timestamp_published":"1525356000","timestamp_order":"1525298400","url":"https://www.huffingtonpost.it/2018/05/03/al-via-la-direzione-pd-e-ressa-tra-militanti-fuori-la-sede-del-nazareno_a_23426214/","source":"www.huffingtonpost.it","tags":["pd","matteo renzi","maurizio martina","movimento 5 stelle"]},{"dbid":"33","type":"milestone","id":"M33","title":"Il Pd prepara lo scongelamento verso il M5s con la non belligeranza di Renzi: se fallisce Casellati, scatta l'ora della responsabilità","description":"Ma non con Di Maio premier e con tante altre condizioni dure da accettare. Tra i Dem gira l'ipotesi di un incarico a Fico su perimetro 5s-Pd...","date_published":"2018-04-18 16:00:00","short_published":"18-04-2018 16:00","timestamp_published":"1524060000","timestamp_order":"1524002400","url":"https://www.huffingtonpost.it/2018/04/18/il-pd-prepara-lo-scongelamento-verso-il-m5s-con-la-non-belligeranza-di-renzi-se-fallisce-casellati-scatta-lora-della-responsabilita_a_23414271/","source":"www.huffingtonpost.it","tags":["pd","movimento 5 stelle","matteo renzi","roberto fico"]},{"dbid":"25","type":"milestone","id":"M25","title":"Quirinale, l'ipotesi pre-incarico per mettere alla prova Salvini e Di Maio","description":"Nel secondo round al Colle il pressing di Mattarella per far cadere il gioco dei veti incrociati fra i duellanti. Si fa il nome anche di Casellati come soluzione istituzionale","date_published":"2018-04-11 12:00:00","short_published":"11-04-2018 12:00","timestamp_published":"1523440800","timestamp_order":"1523397600","url":"http://www.repubblica.it/politica/2018/04/11/news/quirinale_l_ipotesi_pre-incarico_per_mettere_alla_prova_salvini_e_di_maio-193574446/?ref=RHPPLF-BH-I0-C8-P1-S1.8-T2","source":"www.repubblica.it","tags":["sergio mattarella","luigi di maio","matteo salvini","maria elisabetta alberti casellati"]},{"dbid":"24","type":"milestone","id":"M24","title":"Voto truffa e false promesse elettorali: l'inchiesta che spazza via la Lega in Sicilia","description":"Indagati tutti i vertici di «Noi con Salvini» in Sicilia. Intercettazioni imbarazzati per il deputato nazionale Pagano. Si ribellano alcune anime del movimento che chiedono un intervento del leader","date_published":"2018-04-04 16:35:00","short_published":"04-04-2018 16:35","timestamp_published":"1522852500","timestamp_order":"1522792800","url":"http://www.lasicilia.it/news/cronaca/151442/voto-truffa-e-false-promesse-elettorali-l-inchiesta-che-spazza-via-la-lega-in-sicilia.html","source":"www.lasicilia.it","tags":["lega","matteo salvini","Salvino Caputo","Angelo Attaguile"]},{"dbid":"23","type":"milestone","id":"M23","title":"Boeri: \"Reddito cittadinanza M5S costa 35-38 mld\"","description":"Il presidente dell'Inps, Tito Boeri, riaccende le polemiche relativamente al costo che lo Stato dovrebbe sostenere per questo strumento universale. ","date_published":"2018-03-28 13:40:13","short_published":"28-03-2018 13:40","timestamp_published":"1522237213","timestamp_order":"1522188000","url":"http://www.adnkronos.com/lavoro/2018/03/28/boeri-reddito-cittadinanza-costa-mld_wvzClzWssIhPy672NpEd7J.html","source":"www.adnkronos.com","tags":["tito boeri","movimento 5 stelle","inps","reddito di cittadinanza"]},{"dbid":"22","type":"milestone","id":"M22","title":"Casellati e Fico sono i nuovi presidenti di Senato e Camera","description":"Roberto Fico, del movimento 5 Stelle, e Maria Elisabetta Alberti Casellati, di Forza Italia, sono stati eletti: 422 voti per Fico eletto al quarto scrutinio, 240 per Casellati, eletta alla terza votazione","date_published":"2018-03-24 19:32:00","short_published":"24-03-2018 19:32","timestamp_published":"1521916320","timestamp_order":"1521846000","url":"http://www.corriere.it/cronache/18_marzo_24/casellati-fico-elezioni-senato-camera-8239dace-2f59-11e8-8bb6-779994a184b2.shtml","source":"www.corriere.it","tags":["Fico","Casellati","Roberto Fico","Camere","Senato","Camera"]},{"dbid":"21","type":"milestone","id":"M21","title":"Elezioni 2018, i risultati: M5S primo partito, nel centrodestra la Lega supera FI","description":"I pentastellati superano il 30%, la coalizione di centrodestra viaggia attorno al 36%. Crollo del Pd, che raggiunge a fatica il 20%. Nessuna maggioranza alle viste. Ipotesi dimissioni per Renzi","date_published":"2018-03-05 07:00:00","short_published":"05-03-2018 07:00","timestamp_published":"1520229600","timestamp_order":"1520204400","url":"http://www.corriere.it/elezioni-2018/notizie/elezioni-2018-exit-poll-risultati-proiezioni-spoglio-eb21387e-1ff1-11e8-a09a-92b478235f6f.shtml","source":"www.corriere.it","tags":["risultati","risultati elezioni","movimento 5 stelle","lega","pd"]},{"dbid":"20","type":"milestone","id":"M20","title":"Chiusura della campagna elettorale da Vespa e Mentana: la tv del 2 marzo","description":"A conclusione della campagna elettorale in vista delle elezioni del prossimo 4 marzo, venerdì 2 marzo alle 21.25 su RaiUno andrà in onda “Sfida finale – Speciale Porta a porta”, condotto da Bruno Vespa.\nTra gli ospiti Matteo Renzi, Luigi Di Maio, Silvio Berlusconi.\nBruno Vespa intervista i tre leader con la partecipazione del direttore del Corriere della Sera Luciano Fontana e del direttore de La Stampa Maurizio Molinari.\n\nLa politica sarà protagonista anche su La7 dove alle 21.10 ci sarà il programma di attualità “Bersaglio Mobile”, l’approfondimento settimanale è curato dal direttore Enrico Mentana che anche stasera non potrà che soffermare la propria attenzione sulla tornata elettorale. La trasmissione chiuderà a mezzanotte, in coincidenza con il silenzio elettorale, e sostituisce Propaganda Live, che andrà in onda eccezionalmente lunedì 5 marzo.\nFocus, ovviamente su Matteo Renzi, Silvio Berlusconi, Luigi Di Maio, la Lega di Matteo Salvini, Liberi e Uguali di Piero Grasso e Fratelli d’Italia di Giorgia Meloni.","date_published":"2018-03-03 00:00:00","short_published":"03-03-2018 00:00","timestamp_published":"1520031600","timestamp_order":"1520031600","url":"https://www.bergamonews.it/2018/03/02/chiusura-della-campagna-elettorale-vespa-mentana-la-tv-del-2-marzo/277219/","source":"www.bergamonews.it","tags":["campagna elettorale"]},{"dbid":"19","type":"milestone","id":"M19","title":"Berlusconi ufficializza: il candidato premier è Tajani","description":"Intanto il leader di Forza Italia ha ribadito che il nome del candidato premier in caso di vittoria: «Il nostro primo nome è quello di Antonio Tajani, attuale presidente del Parlamento Europeo». Lo ha detto ospite della Tribuna elettorale su Rai 2. «Il presidente del Parlamento europeo ha una grande responsabilità. Ma Antonio, che con me ha fondato Forza Italia, - ha aggiunto - è la persona migliore per ricoprire un ruolo così importante per il nostro paese».","date_published":"2018-02-28 08:00:00","short_published":"28-02-2018 08:00","timestamp_published":"1519801200","timestamp_order":"1519772400","url":"http://www.lastampa.it/2018/02/28/italia/speciali/elezioni/2018/politiche/berlusconi-ufficializza-il-candidato-premier-tajani-hAgPYQcY2cc19nJvjxGegO/pagina.html","source":"www.lastampa.it","tags":["Antonio Tajani","Silvio Berlusconi","Forza Italia"]},{"dbid":"18","type":"milestone","id":"M18","title":"Livorno, CasaPound: \"Attivista aggredito a bastonate\"","description":"\"La notte scorsa un militante di CasaPound è stato aggredito a Livorno\". Lo rende noto lo stesso movimento di estrema destra spiegando che l'attivista \"è stato assalito da quattro persone che, cappucci alzati e bastoni alla mano, prima lo hanno pestato e poi hanno sfondato i finestrini della sua auto, all'interno della quale era presente la compagna incinta, per fortuna rimasta illesa anche se sotto choc\". L'uomo, 37 anni, livornese, è stato dimesso dal pronto soccorso dell'ospedale di Livorno con 30 giorni di prognosi.","date_published":"2018-02-28 00:00:00","short_published":"28-02-2018 00:00","timestamp_published":"1519772400","timestamp_order":"1519772400","url":"http://firenze.repubblica.it/cronaca/2018/03/01/news/luvorno_casapound_attivista_aggredito_-190086461/","source":"www.repubblica.it","tags":["livorno","casa pound"]},{"dbid":"17","type":"milestone","id":"M17","title":"Elezioni, Di Maio a La7 presenta quattro ministri M5s: “La mia squadra di governo sarà di 18 persone”","description":"Pasquale Tridico, economista, per il Ministero del Lavoro e della Previdenza Sociale; Alessandra Pesce, dirigente Mipaf, all’Agricoltura; Giuseppe Conte, professore di Diritto Privato, per il Ministero della Pa, de-burocratizzazione e meritocrazia; Lorenzo Fioramonti, economista (e unico dei 4 candidati nelle liste M5S), al Mise. Sono alcuni dei componenti della possibile squadra di governo M5S presentati a Dimartedì (La7) da Luigi Di Maio, che li ha definiti “quattro persone che sono le persone giuste al posto giusto”. ","date_published":"2018-02-25 12:00:00","short_published":"25-02-2018 12:00","timestamp_published":"1519556400","timestamp_order":"1519513200","url":"https://www.ilfattoquotidiano.it/2018/02/28/elezioni-di-maio-a-la7-presenta-quattro-ministri-m5s-la-mia-squadra-di-governo-sara-di-18-persone/4192385/","source":"www.ilfattoquotidiano.it","tags":["lista dei ministri","armando bartolazzi","salvatore giuliano","pasquale tridico","alessandra pesce","giuseppe conte","lorenzo fioramonti","domenico fioravanti","sergio costa","movimento 5 stelle","sergio mattarella","quirinale"]},{"dbid":"16","type":"milestone","id":"M16","title":"Tensione a Torino, idranti sui manifestanti contro CasaPound","description":"Tafferugli a Torino durante il corteo antifascista contro CasaPound. I manifestanti sono arrivati a ridosso del cordone con cui le forze dell’ordine hanno sbarrato corso Vittorio Emanuele per tentare di raggiungere l’albergo in cui è previsto un comizio elettorale di Simone Di Stefano. Al tentativo di forzare il blocco la polizia ha risposto con idranti e una brevissima carica di alleggerimento.","date_published":"2018-02-22 00:00:00","short_published":"22-02-2018 00:00","timestamp_published":"1519254000","timestamp_order":"1519254000","url":"http://www.lastampa.it/2018/02/22/multimedia/cronaca/tensione-a-torino-idranti-sui-manifestanti-contro-casapound-3Z0lyMiQ2ifCcvcEPTEmGP/pagina.html","source":"www.lastampa.it","tags":["torino","casa pound","antagonisti"]},{"dbid":"15","type":"milestone","id":"M15","title":"Perugia, accoltellato militante di Potere al popolo","description":"Secondo quanto raccontato dalla vittima è stato colpito, in modo non grave, mentre affiggeva manifesti elettorali. Maurizio Acerbo, segretario di Rifondazione comunista: \"Atto di estrema destra\". Il procuratore: \"Vicenda da chiarire\"","date_published":"2018-02-21 00:00:00","short_published":"21-02-2018 00:00","timestamp_published":"1519167600","timestamp_order":"1519167600","url":"http://www.repubblica.it/cronaca/2018/02/21/news/accoltellato_potere_al_popolo_perugia-189368683/","source":"www.repubblica.it","tags":["perugia","potere al popolo"]},{"dbid":"14","type":"milestone","id":"M14","title":"Palermo, militante di Forza Nuova legato mani e piedi e pestato in strada","description":"Almeno sei persone hanno accerchiato a Palermo il responsabile provinciale di Forza Nuova, Massimo Ursino, legandolo mani e piedi con nastro adesivo da imballaggio e pestandolo a sangue.\r\n\r\nE' accaduto nella trafficata e centrale via Dante, intorno alle 19, coi negozi aperti e gente lungo il marciapiede. Gli aggressori erano vestiti di nero e avevano i volti coperti da sciarpe; tra loro, secondo i testimoni, c'era una ragazza che riprendeva il pestaggio con un telefonino.","date_published":"2018-02-20 19:00:00","short_published":"20-02-2018 19:00","timestamp_published":"1519149600","timestamp_order":"1519081200","url":"http://palermo.gds.it/2018/02/20/palermo-militante-di-forza-nuova-legato-mani-e-piedi-e-pestato-in-strada_806539/?utm_medium=feed&utm_source=twitter.com&utm_campaign=Feed%3A+gds_twitter_feed","source":"palermo.gds.it","tags":["massimo ursino","palermo","forza nuova"]},{"dbid":"13","type":"milestone","id":"M13","title":"La procura di Roma archivia la posizione di Virginia Raggi per la nomina di Salvatore Romeo","description":"La sindaca di Roma, Virginia Raggi, è stata archiviata dal tribunale di Roma in merito all’accusa di abuso d’ufficio per la nomina a capo della segreteria politica del Campidoglio di Salvatore Romeo (anche per lui il gip ha emesso decreto di archiviazione).  \r\n\r\nA darne notizia la stessa Raggi con un post su Facebook nel quale spiega di essere stata archiviata per “infondatezza della notizia di reato” e aggiunge che il Tribunale di Roma grazie a questo provvedimento ha cancellato “più di un anno di schizzi di fango, ricostruzioni fantasiose e insulti perché avevo nominato Salvatore Romeo a capo della mia segreteria politica”.","date_published":"2018-02-20 14:00:00","short_published":"20-02-2018 14:00","timestamp_published":"1519131600","timestamp_order":"1519081200","url":"http://www.lastampa.it/2018/02/20/italia/cronache/archiviata-la-sindaca-raggi-dallaccusa-di-abuso-dufficio-per-nomina-romeo-f5cyge8QfJeBI8m7Iwn1KM/amphtml/pagina.amp.html","source":"www.lastampa.it","tags":["salvatore romeo","virginia raggi"]},{"dbid":"11","type":"milestone","id":"M11","title":"Il governo russo sta influenzando le elezioni italiane sostenendo Movimento 5 Stelle e Lega?","description":"Dopo la pubblicazione da parte della rivista Foreign Affairs di un articolo firmato Joe Biden la polemica si riaccende. Immediate le smentite di Matteo Salvini e del blog a 5 Stelle, mentre Matteo Renzi chiede immediate verifiche da parte del Ministero degli Esteri. Al centro della polemica, tra le altre cose, la questione delle sanzioni UE alla Russia, da molte forze politiche ritenute estremamente lesive per l’economia italiana. ","date_published":"2018-02-19 10:38:42","short_published":"19-02-2018 10:38","timestamp_published":"1519033122","timestamp_order":"1518994800","url":"https://www.ilgazzettino.it/italia/primopiano/joe_biden_lega_russia_m5s_aiuti-3416431.html","source":"www.ilgazzettino.it","tags":["russia","putin","lega","movimento 5 stelle","biden "]},{"dbid":"34","type":"milestone","id":"M34","title":"Boldrini: «I gruppi che si ispirano al fascismo vanno sciolti»","description":"Ha scelto il murales realizzato nel quartiere Niguarda a Milano dedicato ai partigiani e riempito di svastiche e croci celtiche per affermare con forza che «i gruppi che si rifanno a un’ideologia fascista vanno sciolti. Non c’è spazio per loro in democrazia». Così ieri la presidente della Camera Laura Boldrini, candidata di Liberi e uguali in Lombardia, davanti a quello che ha definito «un simbolo della Resistenza e della Liberazione di Milano».","date_published":"2018-02-18 18:00:00","short_published":"18-02-2018 18:00","timestamp_published":"1518973200","timestamp_order":"1518908400","url":"https://www.corriere.it/video-articoli/2018/02/18/boldrini-gruppi-che-si-ispirano-fascismo-vanno-sciolti/ba3e6606-14ce-11e8-81fe-8b94b4e31ffd.shtml","source":"www.corriere.it","tags":["laura boldrini","milano","liberi e uguali"]},{"dbid":"10","type":"milestone","id":"M10","title":"Meloni, a Roma la manifestazione anti-inciucio: «Salvini e Berlusconi? Perplessa per loro assenza»","description":"In una manifestazione pubblica a Roma i candidati di Fratelli d'Italia prendono un impegno \"ufficiale\" contro l'eventuale formazione di un governo che comprenda una coalizione differente da quella indicata agli elettori al momento del voto: Forza Italia, Lega, Fratelli d'Italia.\r\nI due leader alleati, seppur invitati, non si sono però presentati.","date_published":"2018-02-18 14:00:00","short_published":"18-02-2018 14:00","timestamp_published":"1518958800","timestamp_order":"1518908400","url":"http://www.ilmessaggero.it/primopiano/speciale_elezioni/meloni_roma_manifestazione_antiinciucio_salvini_berlusconi_perplessa_loro_assenza-3556375.html","source":"www.ilmessaggero.it","tags":["inciucio","centrodestra","fratelli d'italia","giorgia meloni","forza italia","lega","silvio berlusconi","matteo salvini"]},{"dbid":"9","type":"milestone","id":"M9","title":"Scoppia lo scandalo rifiuti in Campania","description":"Un'inchiesta giornalistica condotta sal sito di informazione Fanpage sul traffico dei rifiuti in Campania sta imbarazzando politici e inquirenti della regione. E' una vicenda che vede protagonisti un ex boss della Camorra, una potente dinastia politica - quella dei De Luca - e istituzioni che potrebbero non aver reagito a denunce e sollecitazioni con la dovuta prontezza. Ma per spiegare chi è Nunzio Perrella, cosa c'entra uno dei siti italiani di maggiore traffico e perché sono in ballo milioni di tonnellate di spazzatura bisogna andare per ordine. Cominciando con i nomi.","date_published":"2018-02-15 00:00:00","short_published":"15-02-2018 00:00","timestamp_published":"1518649200","timestamp_order":"1518649200","url":"https://www.agi.it/cronaca/de_luca_rifiuti_campania_fanpage-3509070/news/2018-02-17/","source":"www.agi.it","tags":["bloody money","roberto de luca","salerno","campania","vincenzo de luca","nunzio perrella","luciano passariello"]},{"dbid":"7","type":"milestone","id":"M7","title":"Esplode il caso \"rimborsopoli\" del Movimento 5 Stelle","description":"Un'intervista della trasmissione \"Le Iene\" ad un ex militante del Movimento 5 Stelle fa scoppiare lo scandalo \"rimborsopoli\". «Tra deputati e senatori siamo ad una doppia cifra, è un partito fatto di furbi e furbastri che tradisce la fiducia dei cittadini»","date_published":"2018-02-12 00:00:00","short_published":"12-02-2018 00:00","timestamp_published":"1518390000","timestamp_order":"1518390000","url":"https://www.leggo.it/spettacoli/le_iene/le_iene_cinque_stelle_ex_militante_rimborsi_11_febbraio_2018-3542408.html","source":"leggo.it","tags":["movimento 5 stelle","rimborsopoli"]},{"dbid":"8","type":"milestone","id":"M8","title":"Al via I giochi invernali di PyeongChang","description":"Sono ufficialmente iniziati oggi alle 12 ora italiana, con una spettacolare cerimonia di apertura i giochi invernali di PyeongChang, in Corea. Tante le speranze per l'Italia, a cominciare dalla stella dello short track Arianna Fontana.","date_published":"2018-02-09 12:00:00","short_published":"09-02-2018 12:00","timestamp_published":"1518174000","timestamp_order":"1518130800","url":"https://sport.sky.it/olimpiadi/2018/02/09/olimpiadi-invernali-corea-2018-risultati-giornata-2.html","source":"Sky Sport","tags":["Arianna fontana","PyeongChang","corea","olimpiadi"]},{"dbid":"6","type":"milestone","id":"M6","title":"Inizia il Festival di Sanremo","description":"L'Evento Nazional-Popolare per eccellenza ha inizio oggi. Sarà capace la passerella Sanremese di rimanere estranea al dibattito politico delle prossime elezioni?","date_published":"2018-02-06 20:30:00","short_published":"06-02-2018 20:30","timestamp_published":"1517945400","timestamp_order":"1517871600","url":"https://www.quotidiano.net/magazine/sanremo-2018-1.3706840","source":"quotidiano.net","tags":["sanremo"]},{"dbid":"5","type":"milestone","id":"M5","title":"Attacco terroristico xenofobo a Macerata","description":"Luca Traini, ex candidato della Lega, semina il terrore in città sparando dalla sua auto in corsa contro passanti di colore. Il suo gesto dà inizio ad un accesissimo dibattito tra gli esponenti di tutte le forze politiche in corsa alle prossime politiche.","date_published":"2018-02-03 00:00:00","short_published":"03-02-2018 00:00","timestamp_published":"1517612400","timestamp_order":"1517612400","url":"http://www.corriere.it/cronache/18_febbraio_04/raid-xenofobo-macerata-537f8b6e-092c-11e8-8b93-b872f63dbb4d.shtml","source":"www.corriere.it","tags":["macerata","luca traini","lega"]},{"dbid":"12","type":"milestone","id":"M12","title":"Il Museo Egizio di Torino e lo sconto agli arabi","description":"Un video diventato virale, una denuncia del Museo, che afferma che i suoi contenuti sono falsi. La polemica che monta, e che viene quotidianamente rilanciata e cavalcata da Matteo Salvini e Giorgia Meloni, che arriva ad organizzare una manifestazione di fronte all'entrata dell'istituto. Al centro del contendere: quello che gli esponenti di destra ritengono essere un caso di \"razzismo contro gli italiani\".","date_published":"2018-01-29 00:00:00","short_published":"29-01-2018 00:00","timestamp_published":"1517180400","timestamp_order":"1517180400","url":"http://www.torinoggi.it/2018/01/29/leggi-notizia/argomenti/cronaca-11/articolo/sconti-agli-arabi-museo-egizio-di-torino-presenta-esposto-in-questura.html","source":"www.torinoggi.it","tags":["museo egizio","torino","giorgia meloni","lega","matteo salvini"]},{"dbid":"4","type":"milestone","id":"M4","title":"Annunciata la lista dei simboli ufficialmente accettati","description":"Il ministero dell’Interno, esaminati i 103 contrassegni depositati per le elezioni politiche del 4 marzo, ne ha ammessi 75. In 19 casi il ministero ha invitato i depositanti, in base alla normativa vigente, alla sostituzione del contrassegno e/o all’integrazione della dichiarazione di trasparenza entro 48 ore dalla notifica. Per carenza documentale a 9 contrassegni non è stata consentita la presentazione di liste.","date_published":"2018-01-23 18:00:00","short_published":"23-01-2018 18:00","timestamp_published":"1516726800","timestamp_order":"1516662000","url":"http://www.corriere.it/politica/18_gennaio_23/elezioni-2018-viminale-ammette-75-simboli-su-103-presentati-d697b5c6-0062-11e8-9961-f20884a97d4b.shtml","source":"www.corriere.it","tags":["simboli","loghi"]},{"dbid":"2","type":"milestone","id":"M2","title":"Presentati i programmi del Movimento 5 Stelle e +Europa","description":"Presentato oggi il programma della lista capeggiata da Emma Bonino: maggiore integrazione tra i diversi stati europei, disarmo nucleare e responsabilità ambientali i temi più importanti.\n\nDa Pescara arrivano anche informazioni sul programma M5S: \"daspo\" ai corrotti e reddito di cittadinanza in cima alle priorità del Movimento.","date_published":"2018-01-21 17:29:42","short_published":"21-01-2018 17:29","timestamp_published":"1516552182","timestamp_order":"1516489200","url":"https://www.ilfattoquotidiano.it/2018/01/22/m5s-20-punti-in-4-minuti-la-nostra-sintesi-della-presentazione-del-programma-di-luigi-di-maio-a-pescara/4107338/","source":"www.ilfattoquotidiano.it","tags":["movimento 5 stelle","+europa","emma bonino","luigi di maio"]},{"dbid":"3","type":"milestone","id":"M3","title":"Attilio Fontana e la \"razza bianca\"","description":"\"Dobbiamo decidere se la nostra etnia, la nostra razza bianca, la nostra società devono continuare a esistere o devono essere cancellate\". Quest le parole del candidato governatore della Lega per la Regione Lombardia che infiammano il dibattito politico.","date_published":"2018-01-15 00:00:00","short_published":"15-01-2018 00:00","timestamp_published":"1515970800","timestamp_order":"1515970800","url":"http://www.lapresse.it/lombardia-fontana-razza-bianca-a-rischio-gori-questa-e-demagogia.html","source":"www.lapresse.it","tags":["attilio fontana"]},{"dbid":"1","type":"milestone","id":"M1","title":"Mattarella scioglie le Camere, si vota il 4 marzo","description":"Dopo i colloqui al Quirinale col premier Gentiloni e i presidenti delle Camere, Grasso e Boldrini, il capo dello Stato ha firmato il decreto presidenziale di fine legislatura. E in serata il Consiglio dei ministri ha indicato il giorno delle prossime elezioni e il successivo 23 marzo data di insediamento del nuovo Parlamento","date_published":"2017-12-28 18:24:00","short_published":"28-12-2017 18:24","timestamp_published":"1514481840","timestamp_order":"1514415600","url":"http://www.repubblica.it/politica/2017/12/28/news/gentiloni_al_quirinale_al_via_l_iter_verso_lo_scioglimento_delle_camere-185379672/","source":"repubblica.it","tags":["Sergio mattarella"]}],"keywords":{"dimaiosalvini":[{"date_short":"2018-02-01","number":"11"},{"date_short":"2018-02-02","number":"29"},{"date_short":"2018-02-03","number":"16"},{"date_short":"2018-02-04","number":"9"},{"date_short":"2018-02-05","number":"15"},{"date_short":"2018-02-06","number":"9"},{"date_short":"2018-02-07","number":"10"},{"date_short":"2018-02-08","number":"11"},{"date_short":"2018-02-09","number":"16"},{"date_short":"2018-02-10","number":"10"},{"date_short":"2018-02-11","number":"18"},{"date_short":"2018-02-12","number":"10"},{"date_short":"2018-02-13","number":"8"},{"date_short":"2018-02-14","number":"12"},{"date_short":"2018-02-15","number":"9"},{"date_short":"2018-02-16","number":"14"},{"date_short":"2018-02-17","number":"12"},{"date_short":"2018-02-18","number":"15"},{"date_short":"2018-02-19","number":"13"},{"date_short":"2018-02-20","number":"19"},{"date_short":"2018-02-21","number":"9"},{"date_short":"2018-02-22","number":"17"},{"date_short":"2018-02-23","number":"18"},{"date_short":"2018-02-24","number":"12"},{"date_short":"2018-02-25","number":"11"},{"date_short":"2018-02-26","number":"16"},{"date_short":"2018-02-27","number":"12"},{"date_short":"2018-02-28","number":"16"},{"date_short":"2018-03-01","number":"19"},{"date_short":"2018-03-02","number":"25"},{"date_short":"2018-03-03","number":"9"},{"date_short":"2018-03-04","number":"7"},{"date_short":"2018-03-05","number":"59"},{"date_short":"2018-03-06","number":"66"},{"date_short":"2018-03-07","number":"65"},{"date_short":"2018-03-08","number":"25"},{"date_short":"2018-03-09","number":"37"},{"date_short":"2018-03-10","number":"26"},{"date_short":"2018-03-11","number":"31"},{"date_short":"2018-03-12","number":"23"},{"date_short":"2018-03-13","number":"32"},{"date_short":"2018-03-14","number":"41"},{"date_short":"2018-03-15","number":"42"},{"date_short":"2018-03-16","number":"29"},{"date_short":"2018-03-17","number":"36"},{"date_short":"2018-03-18","number":"33"},{"date_short":"2018-03-19","number":"22"},{"date_short":"2018-03-20","number":"29"},{"date_short":"2018-03-21","number":"40"},{"date_short":"2018-03-22","number":"42"},{"date_short":"2018-03-23","number":"60"},{"date_short":"2018-03-24","number":"53"},{"date_short":"2018-03-25","number":"50"},{"date_short":"2018-03-26","number":"57"},{"date_short":"2018-03-27","number":"59"},{"date_short":"2018-03-28","number":"49"},{"date_short":"2018-03-29","number":"41"},{"date_short":"2018-03-30","number":"43"},{"date_short":"2018-03-31","number":"25"},{"date_short":"2018-04-01","number":"11"},{"date_short":"2018-04-02","number":"15"},{"date_short":"2018-04-03","number":"32"},{"date_short":"2018-04-04","number":"65"},{"date_short":"2018-04-05","number":"42"},{"date_short":"2018-04-06","number":"33"},{"date_short":"2018-04-07","number":"37"},{"date_short":"2018-04-08","number":"45"},{"date_short":"2018-04-09","number":"54"},{"date_short":"2018-04-10","number":"34"},{"date_short":"2018-04-11","number":"49"},{"date_short":"2018-04-12","number":"59"},{"date_short":"2018-04-13","number":"55"},{"date_short":"2018-04-14","number":"25"},{"date_short":"2018-04-15","number":"45"},{"date_short":"2018-04-16","number":"42"},{"date_short":"2018-04-17","number":"58"},{"date_short":"2018-04-18","number":"52"},{"date_short":"2018-04-19","number":"50"},{"date_short":"2018-04-20","number":"57"},{"date_short":"2018-04-21","number":"44"},{"date_short":"2018-04-22","number":"27"},{"date_short":"2018-04-23","number":"38"},{"date_short":"2018-04-24","number":"44"},{"date_short":"2018-04-25","number":"29"},{"date_short":"2018-04-26","number":"44"},{"date_short":"2018-04-27","number":"29"},{"date_short":"2018-04-28","number":"13"},{"date_short":"2018-04-29","number":"20"},{"date_short":"2018-04-30","number":"46"},{"date_short":"2018-05-01","number":"32"},{"date_short":"2018-05-02","number":"46"},{"date_short":"2018-05-03","number":"54"},{"date_short":"2018-05-04","number":"40"},{"date_short":"2018-05-05","number":"26"},{"date_short":"2018-05-06","number":"42"},{"date_short":"2018-05-07","number":"62"},{"date_short":"2018-05-08","number":"42"},{"date_short":"2018-05-09","number":"62"},{"date_short":"2018-05-10","number":"83"},{"date_short":"2018-05-11","number":"86"},{"date_short":"2018-05-12","number":"73"},{"date_short":"2018-05-13","number":"48"},{"date_short":"2018-05-14","number":"75"},{"date_short":"2018-05-15","number":"91"},{"date_short":"2018-05-16","number":"68"},{"date_short":"2018-05-17","number":"84"},{"date_short":"2018-05-18","number":"70"},{"date_short":"2018-05-19","number":"53"},{"date_short":"2018-05-20","number":"56"},{"date_short":"2018-05-21","number":"64"},{"date_short":"2018-05-22","number":"56"},{"date_short":"2018-05-23","number":"52"},{"date_short":"2018-05-24","number":"56"},{"date_short":"2018-05-25","number":"46"},{"date_short":"2018-05-26","number":"50"},{"date_short":"2018-05-27","number":"40"},{"date_short":"2018-05-28","number":"85"},{"date_short":"2018-05-29","number":"69"},{"date_short":"2018-05-30","number":"78"},{"date_short":"2018-05-31","number":"95"},{"date_short":"2018-06-01","number":"65"},{"date_short":"2018-06-02","number":"51"},{"date_short":"2018-06-03","number":"27"},{"date_short":"2018-06-04","number":"38"},{"date_short":"2018-06-05","number":"36"},{"date_short":"2018-06-06","number":"42"}],"berlusconisalvini":[{"date_short":"2018-02-01","number":"10"},{"date_short":"2018-02-02","number":"16"},{"date_short":"2018-02-03","number":"18"},{"date_short":"2018-02-04","number":"7"},{"date_short":"2018-02-05","number":"21"},{"date_short":"2018-02-06","number":"17"},{"date_short":"2018-02-07","number":"18"},{"date_short":"2018-02-08","number":"20"},{"date_short":"2018-02-09","number":"23"},{"date_short":"2018-02-10","number":"11"},{"date_short":"2018-02-11","number":"20"},{"date_short":"2018-02-12","number":"10"},{"date_short":"2018-02-13","number":"9"},{"date_short":"2018-02-14","number":"10"},{"date_short":"2018-02-15","number":"17"},{"date_short":"2018-02-16","number":"15"},{"date_short":"2018-02-17","number":"20"},{"date_short":"2018-02-18","number":"24"},{"date_short":"2018-02-19","number":"27"},{"date_short":"2018-02-20","number":"25"},{"date_short":"2018-02-21","number":"16"},{"date_short":"2018-02-22","number":"24"},{"date_short":"2018-02-23","number":"11"},{"date_short":"2018-02-24","number":"17"},{"date_short":"2018-02-25","number":"16"},{"date_short":"2018-02-26","number":"19"},{"date_short":"2018-02-27","number":"17"},{"date_short":"2018-02-28","number":"18"},{"date_short":"2018-03-01","number":"19"},{"date_short":"2018-03-02","number":"25"},{"date_short":"2018-03-03","number":"11"},{"date_short":"2018-03-04","number":"11"},{"date_short":"2018-03-05","number":"62"},{"date_short":"2018-03-06","number":"41"},{"date_short":"2018-03-07","number":"42"},{"date_short":"2018-03-08","number":"17"},{"date_short":"2018-03-09","number":"22"},{"date_short":"2018-03-10","number":"15"},{"date_short":"2018-03-11","number":"19"},{"date_short":"2018-03-12","number":"21"},{"date_short":"2018-03-13","number":"25"},{"date_short":"2018-03-14","number":"36"},{"date_short":"2018-03-15","number":"31"},{"date_short":"2018-03-16","number":"21"},{"date_short":"2018-03-17","number":"16"},{"date_short":"2018-03-18","number":"18"},{"date_short":"2018-03-19","number":"14"},{"date_short":"2018-03-20","number":"29"},{"date_short":"2018-03-21","number":"33"},{"date_short":"2018-03-22","number":"41"},{"date_short":"2018-03-23","number":"42"},{"date_short":"2018-03-24","number":"51"},{"date_short":"2018-03-25","number":"39"},{"date_short":"2018-03-26","number":"48"},{"date_short":"2018-03-27","number":"35"},{"date_short":"2018-03-28","number":"29"},{"date_short":"2018-03-29","number":"23"},{"date_short":"2018-03-30","number":"16"},{"date_short":"2018-03-31","number":"13"},{"date_short":"2018-04-01","number":"3"},{"date_short":"2018-04-02","number":"4"},{"date_short":"2018-04-03","number":"26"},{"date_short":"2018-04-04","number":"47"},{"date_short":"2018-04-05","number":"33"},{"date_short":"2018-04-06","number":"33"},{"date_short":"2018-04-07","number":"28"},{"date_short":"2018-04-08","number":"34"},{"date_short":"2018-04-09","number":"40"},{"date_short":"2018-04-10","number":"21"},{"date_short":"2018-04-11","number":"29"},{"date_short":"2018-04-12","number":"46"},{"date_short":"2018-04-13","number":"57"},{"date_short":"2018-04-14","number":"32"},{"date_short":"2018-04-15","number":"32"},{"date_short":"2018-04-16","number":"28"},{"date_short":"2018-04-17","number":"38"},{"date_short":"2018-04-18","number":"33"},{"date_short":"2018-04-19","number":"43"},{"date_short":"2018-04-20","number":"57"},{"date_short":"2018-04-21","number":"35"},{"date_short":"2018-04-22","number":"17"},{"date_short":"2018-04-23","number":"31"},{"date_short":"2018-04-24","number":"28"},{"date_short":"2018-04-25","number":"20"},{"date_short":"2018-04-26","number":"26"},{"date_short":"2018-04-27","number":"25"},{"date_short":"2018-04-28","number":"17"},{"date_short":"2018-04-29","number":"15"},{"date_short":"2018-04-30","number":"29"},{"date_short":"2018-05-01","number":"21"},{"date_short":"2018-05-02","number":"25"},{"date_short":"2018-05-03","number":"43"},{"date_short":"2018-05-04","number":"31"},{"date_short":"2018-05-05","number":"16"},{"date_short":"2018-05-06","number":"28"},{"date_short":"2018-05-07","number":"39"},{"date_short":"2018-05-08","number":"34"},{"date_short":"2018-05-09","number":"56"},{"date_short":"2018-05-10","number":"61"},{"date_short":"2018-05-11","number":"52"},{"date_short":"2018-05-12","number":"44"},{"date_short":"2018-05-13","number":"23"},{"date_short":"2018-05-14","number":"29"},{"date_short":"2018-05-15","number":"39"},{"date_short":"2018-05-16","number":"31"},{"date_short":"2018-05-17","number":"19"},{"date_short":"2018-05-18","number":"46"},{"date_short":"2018-05-19","number":"19"},{"date_short":"2018-05-20","number":"14"},{"date_short":"2018-05-21","number":"15"},{"date_short":"2018-05-22","number":"14"},{"date_short":"2018-05-23","number":"12"},{"date_short":"2018-05-24","number":"34"},{"date_short":"2018-05-25","number":"16"},{"date_short":"2018-05-26","number":"6"},{"date_short":"2018-05-27","number":"10"},{"date_short":"2018-05-28","number":"40"},{"date_short":"2018-05-29","number":"30"},{"date_short":"2018-05-30","number":"20"},{"date_short":"2018-05-31","number":"14"},{"date_short":"2018-06-01","number":"18"},{"date_short":"2018-06-02","number":"23"},{"date_short":"2018-06-03","number":"4"},{"date_short":"2018-06-04","number":"8"},{"date_short":"2018-06-05","number":"10"},{"date_short":"2018-06-06","number":"22"}],"razzismo":[{"date_short":"2018-02-01","number":"10"},{"date_short":"2018-02-02","number":"7"},{"date_short":"2018-02-03","number":"20"},{"date_short":"2018-02-04","number":"23"},{"date_short":"2018-02-05","number":"33"},{"date_short":"2018-02-06","number":"19"},{"date_short":"2018-02-07","number":"14"},{"date_short":"2018-02-08","number":"19"},{"date_short":"2018-02-09","number":"14"},{"date_short":"2018-02-10","number":"28"},{"date_short":"2018-02-11","number":"16"},{"date_short":"2018-02-12","number":"24"},{"date_short":"2018-02-13","number":"7"},{"date_short":"2018-02-14","number":"12"},{"date_short":"2018-02-15","number":"4"},{"date_short":"2018-02-16","number":"3"},{"date_short":"2018-02-17","number":"7"},{"date_short":"2018-02-18","number":"11"},{"date_short":"2018-02-19","number":"7"},{"date_short":"2018-02-20","number":"14"},{"date_short":"2018-02-21","number":"17"},{"date_short":"2018-02-22","number":"11"},{"date_short":"2018-02-23","number":"9"},{"date_short":"2018-02-24","number":"13"},{"date_short":"2018-02-25","number":"5"},{"date_short":"2018-02-26","number":"11"},{"date_short":"2018-02-27","number":"6"},{"date_short":"2018-02-28","number":"8"},{"date_short":"2018-03-01","number":"3"},{"date_short":"2018-03-02","number":"3"},{"date_short":"2018-03-03","number":"3"},{"date_short":"2018-03-04","number":"5"},{"date_short":"2018-03-05","number":"8"},{"date_short":"2018-03-06","number":"11"},{"date_short":"2018-03-07","number":"21"},{"date_short":"2018-03-08","number":"4"},{"date_short":"2018-03-09","number":"6"},{"date_short":"2018-03-10","number":"5"},{"date_short":"2018-03-11","number":"3"},{"date_short":"2018-03-12","number":"4"},{"date_short":"2018-03-13","number":"5"},{"date_short":"2018-03-15","number":"1"},{"date_short":"2018-03-17","number":"7"},{"date_short":"2018-03-18","number":"6"},{"date_short":"2018-03-19","number":"5"},{"date_short":"2018-03-20","number":"3"},{"date_short":"2018-03-21","number":"2"},{"date_short":"2018-03-22","number":"4"},{"date_short":"2018-03-23","number":"7"},{"date_short":"2018-03-24","number":"4"},{"date_short":"2018-03-25","number":"3"},{"date_short":"2018-03-26","number":"3"},{"date_short":"2018-03-27","number":"2"},{"date_short":"2018-03-29","number":"3"},{"date_short":"2018-03-30","number":"3"},{"date_short":"2018-03-31","number":"1"},{"date_short":"2018-04-01","number":"2"},{"date_short":"2018-04-03","number":"3"},{"date_short":"2018-04-04","number":"3"},{"date_short":"2018-04-05","number":"2"},{"date_short":"2018-04-06","number":"2"},{"date_short":"2018-04-08","number":"2"},{"date_short":"2018-04-09","number":"2"},{"date_short":"2018-04-10","number":"2"},{"date_short":"2018-04-16","number":"2"},{"date_short":"2018-04-18","number":"7"},{"date_short":"2018-04-19","number":"2"},{"date_short":"2018-04-20","number":"3"},{"date_short":"2018-04-21","number":"2"},{"date_short":"2018-04-22","number":"4"},{"date_short":"2018-04-23","number":"1"},{"date_short":"2018-04-24","number":"2"},{"date_short":"2018-04-25","number":"1"},{"date_short":"2018-04-27","number":"1"},{"date_short":"2018-04-28","number":"2"},{"date_short":"2018-05-01","number":"3"},{"date_short":"2018-05-02","number":"1"},{"date_short":"2018-05-04","number":"5"},{"date_short":"2018-05-05","number":"2"},{"date_short":"2018-05-06","number":"1"},{"date_short":"2018-05-07","number":"2"},{"date_short":"2018-05-08","number":"3"},{"date_short":"2018-05-09","number":"2"},{"date_short":"2018-05-10","number":"6"},{"date_short":"2018-05-11","number":"3"},{"date_short":"2018-05-12","number":"8"},{"date_short":"2018-05-13","number":"3"},{"date_short":"2018-05-14","number":"4"},{"date_short":"2018-05-15","number":"1"},{"date_short":"2018-05-16","number":"3"},{"date_short":"2018-05-18","number":"2"},{"date_short":"2018-05-19","number":"2"},{"date_short":"2018-05-21","number":"3"},{"date_short":"2018-05-22","number":"1"},{"date_short":"2018-05-23","number":"3"},{"date_short":"2018-05-24","number":"2"},{"date_short":"2018-05-25","number":"4"},{"date_short":"2018-05-26","number":"1"},{"date_short":"2018-05-28","number":"5"},{"date_short":"2018-05-30","number":"4"},{"date_short":"2018-05-31","number":"1"},{"date_short":"2018-06-01","number":"3"},{"date_short":"2018-06-02","number":"6"},{"date_short":"2018-06-03","number":"1"},{"date_short":"2018-06-04","number":"7"},{"date_short":"2018-06-05","number":"13"},{"date_short":"2018-06-06","number":"4"}],"fascismo":[{"date_short":"2018-02-01","number":"7"},{"date_short":"2018-02-02","number":"6"},{"date_short":"2018-02-03","number":"23"},{"date_short":"2018-02-04","number":"23"},{"date_short":"2018-02-05","number":"19"},{"date_short":"2018-02-06","number":"18"},{"date_short":"2018-02-07","number":"16"},{"date_short":"2018-02-08","number":"28"},{"date_short":"2018-02-09","number":"28"},{"date_short":"2018-02-10","number":"47"},{"date_short":"2018-02-11","number":"27"},{"date_short":"2018-02-12","number":"31"},{"date_short":"2018-02-13","number":"17"},{"date_short":"2018-02-14","number":"22"},{"date_short":"2018-02-15","number":"24"},{"date_short":"2018-02-16","number":"13"},{"date_short":"2018-02-17","number":"14"},{"date_short":"2018-02-18","number":"22"},{"date_short":"2018-02-19","number":"29"},{"date_short":"2018-02-20","number":"32"},{"date_short":"2018-02-21","number":"44"},{"date_short":"2018-02-22","number":"27"},{"date_short":"2018-02-23","number":"35"},{"date_short":"2018-02-24","number":"52"},{"date_short":"2018-02-25","number":"21"},{"date_short":"2018-02-26","number":"24"},{"date_short":"2018-02-27","number":"27"},{"date_short":"2018-02-28","number":"17"},{"date_short":"2018-03-01","number":"29"},{"date_short":"2018-03-02","number":"25"},{"date_short":"2018-03-03","number":"15"},{"date_short":"2018-03-04","number":"11"},{"date_short":"2018-03-05","number":"27"},{"date_short":"2018-03-06","number":"8"},{"date_short":"2018-03-07","number":"31"},{"date_short":"2018-03-08","number":"12"},{"date_short":"2018-03-09","number":"4"},{"date_short":"2018-03-10","number":"5"},{"date_short":"2018-03-11","number":"4"},{"date_short":"2018-03-12","number":"6"},{"date_short":"2018-03-13","number":"5"},{"date_short":"2018-03-14","number":"4"},{"date_short":"2018-03-15","number":"3"},{"date_short":"2018-03-16","number":"6"},{"date_short":"2018-03-17","number":"7"},{"date_short":"2018-03-18","number":"7"},{"date_short":"2018-03-19","number":"14"},{"date_short":"2018-03-20","number":"3"},{"date_short":"2018-03-21","number":"4"},{"date_short":"2018-03-22","number":"2"},{"date_short":"2018-03-23","number":"6"},{"date_short":"2018-03-24","number":"3"},{"date_short":"2018-03-25","number":"5"},{"date_short":"2018-03-26","number":"3"},{"date_short":"2018-03-27","number":"1"},{"date_short":"2018-03-28","number":"2"},{"date_short":"2018-03-29","number":"1"},{"date_short":"2018-03-30","number":"3"},{"date_short":"2018-03-31","number":"2"},{"date_short":"2018-04-01","number":"1"},{"date_short":"2018-04-02","number":"1"},{"date_short":"2018-04-03","number":"8"},{"date_short":"2018-04-04","number":"2"},{"date_short":"2018-04-05","number":"4"},{"date_short":"2018-04-06","number":"3"},{"date_short":"2018-04-07","number":"3"},{"date_short":"2018-04-08","number":"5"},{"date_short":"2018-04-09","number":"9"},{"date_short":"2018-04-10","number":"5"},{"date_short":"2018-04-11","number":"2"},{"date_short":"2018-04-13","number":"3"},{"date_short":"2018-04-14","number":"4"},{"date_short":"2018-04-15","number":"6"},{"date_short":"2018-04-16","number":"4"},{"date_short":"2018-04-17","number":"7"},{"date_short":"2018-04-18","number":"4"},{"date_short":"2018-04-19","number":"1"},{"date_short":"2018-04-20","number":"1"},{"date_short":"2018-04-21","number":"2"},{"date_short":"2018-04-22","number":"6"},{"date_short":"2018-04-23","number":"2"},{"date_short":"2018-04-24","number":"7"},{"date_short":"2018-04-25","number":"10"},{"date_short":"2018-04-26","number":"12"},{"date_short":"2018-04-27","number":"8"},{"date_short":"2018-04-28","number":"9"},{"date_short":"2018-04-29","number":"2"},{"date_short":"2018-04-30","number":"1"},{"date_short":"2018-05-01","number":"3"},{"date_short":"2018-05-02","number":"1"},{"date_short":"2018-05-03","number":"4"},{"date_short":"2018-05-04","number":"7"},{"date_short":"2018-05-05","number":"2"},{"date_short":"2018-05-07","number":"3"},{"date_short":"2018-05-08","number":"5"},{"date_short":"2018-05-09","number":"5"},{"date_short":"2018-05-10","number":"14"},{"date_short":"2018-05-11","number":"9"},{"date_short":"2018-05-12","number":"5"},{"date_short":"2018-05-13","number":"4"},{"date_short":"2018-05-14","number":"2"},{"date_short":"2018-05-15","number":"2"},{"date_short":"2018-05-16","number":"9"},{"date_short":"2018-05-17","number":"3"},{"date_short":"2018-05-18","number":"4"},{"date_short":"2018-05-19","number":"5"},{"date_short":"2018-05-20","number":"5"},{"date_short":"2018-05-21","number":"4"},{"date_short":"2018-05-22","number":"1"},{"date_short":"2018-05-23","number":"13"},{"date_short":"2018-05-24","number":"3"},{"date_short":"2018-05-25","number":"2"},{"date_short":"2018-05-27","number":"1"},{"date_short":"2018-05-28","number":"13"},{"date_short":"2018-05-29","number":"10"},{"date_short":"2018-05-30","number":"11"},{"date_short":"2018-05-31","number":"6"},{"date_short":"2018-06-01","number":"14"},{"date_short":"2018-06-02","number":"7"},{"date_short":"2018-06-03","number":"2"},{"date_short":"2018-06-04","number":"5"},{"date_short":"2018-06-05","number":"3"},{"date_short":"2018-06-06","number":"7"}],"flattax":[{"date_short":"2018-02-01","number":"1"},{"date_short":"2018-02-02","number":"10"},{"date_short":"2018-02-03","number":"9"},{"date_short":"2018-02-04","number":"2"},{"date_short":"2018-02-05","number":"1"},{"date_short":"2018-02-06","number":"2"},{"date_short":"2018-02-07","number":"8"},{"date_short":"2018-02-08","number":"4"},{"date_short":"2018-02-09","number":"5"},{"date_short":"2018-02-10","number":"1"},{"date_short":"2018-02-11","number":"2"},{"date_short":"2018-02-12","number":"1"},{"date_short":"2018-02-14","number":"6"},{"date_short":"2018-02-15","number":"10"},{"date_short":"2018-02-16","number":"6"},{"date_short":"2018-02-17","number":"9"},{"date_short":"2018-02-18","number":"5"},{"date_short":"2018-02-19","number":"7"},{"date_short":"2018-02-20","number":"5"},{"date_short":"2018-02-21","number":"8"},{"date_short":"2018-02-22","number":"7"},{"date_short":"2018-02-23","number":"3"},{"date_short":"2018-02-24","number":"8"},{"date_short":"2018-02-25","number":"6"},{"date_short":"2018-02-26","number":"10"},{"date_short":"2018-02-27","number":"10"},{"date_short":"2018-02-28","number":"4"},{"date_short":"2018-03-01","number":"6"},{"date_short":"2018-03-02","number":"3"},{"date_short":"2018-03-03","number":"6"},{"date_short":"2018-03-04","number":"4"},{"date_short":"2018-03-05","number":"2"},{"date_short":"2018-03-06","number":"8"},{"date_short":"2018-03-07","number":"6"},{"date_short":"2018-03-08","number":"2"},{"date_short":"2018-03-09","number":"3"},{"date_short":"2018-03-10","number":"8"},{"date_short":"2018-03-11","number":"5"},{"date_short":"2018-03-12","number":"4"},{"date_short":"2018-03-13","number":"5"},{"date_short":"2018-03-14","number":"12"},{"date_short":"2018-03-15","number":"6"},{"date_short":"2018-03-16","number":"4"},{"date_short":"2018-03-17","number":"2"},{"date_short":"2018-03-18","number":"3"},{"date_short":"2018-03-19","number":"4"},{"date_short":"2018-03-20","number":"1"},{"date_short":"2018-03-21","number":"7"},{"date_short":"2018-03-22","number":"2"},{"date_short":"2018-03-23","number":"5"},{"date_short":"2018-03-24","number":"2"},{"date_short":"2018-03-25","number":"9"},{"date_short":"2018-03-26","number":"13"},{"date_short":"2018-03-27","number":"12"},{"date_short":"2018-03-28","number":"10"},{"date_short":"2018-03-29","number":"12"},{"date_short":"2018-03-30","number":"9"},{"date_short":"2018-03-31","number":"6"},{"date_short":"2018-04-02","number":"1"},{"date_short":"2018-04-03","number":"5"},{"date_short":"2018-04-04","number":"7"},{"date_short":"2018-04-05","number":"4"},{"date_short":"2018-04-06","number":"3"},{"date_short":"2018-04-07","number":"5"},{"date_short":"2018-04-08","number":"2"},{"date_short":"2018-04-09","number":"5"},{"date_short":"2018-04-10","number":"3"},{"date_short":"2018-04-11","number":"3"},{"date_short":"2018-04-12","number":"5"},{"date_short":"2018-04-13","number":"4"},{"date_short":"2018-04-14","number":"2"},{"date_short":"2018-04-16","number":"2"},{"date_short":"2018-04-17","number":"5"},{"date_short":"2018-04-18","number":"2"},{"date_short":"2018-04-19","number":"2"},{"date_short":"2018-04-20","number":"5"},{"date_short":"2018-04-21","number":"3"},{"date_short":"2018-04-22","number":"2"},{"date_short":"2018-04-23","number":"9"},{"date_short":"2018-04-24","number":"3"},{"date_short":"2018-04-25","number":"2"},{"date_short":"2018-04-27","number":"2"},{"date_short":"2018-04-28","number":"2"},{"date_short":"2018-04-29","number":"1"},{"date_short":"2018-04-30","number":"2"},{"date_short":"2018-05-01","number":"1"},{"date_short":"2018-05-02","number":"5"},{"date_short":"2018-05-03","number":"7"},{"date_short":"2018-05-04","number":"3"},{"date_short":"2018-05-05","number":"1"},{"date_short":"2018-05-06","number":"1"},{"date_short":"2018-05-07","number":"1"},{"date_short":"2018-05-08","number":"4"},{"date_short":"2018-05-09","number":"5"},{"date_short":"2018-05-10","number":"24"},{"date_short":"2018-05-11","number":"28"},{"date_short":"2018-05-12","number":"17"},{"date_short":"2018-05-13","number":"15"},{"date_short":"2018-05-14","number":"17"},{"date_short":"2018-05-15","number":"23"},{"date_short":"2018-05-16","number":"8"},{"date_short":"2018-05-17","number":"24"},{"date_short":"2018-05-18","number":"25"},{"date_short":"2018-05-19","number":"12"},{"date_short":"2018-05-20","number":"6"},{"date_short":"2018-05-21","number":"10"},{"date_short":"2018-05-22","number":"6"},{"date_short":"2018-05-23","number":"6"},{"date_short":"2018-05-24","number":"19"},{"date_short":"2018-05-25","number":"11"},{"date_short":"2018-05-26","number":"10"},{"date_short":"2018-05-27","number":"2"},{"date_short":"2018-05-28","number":"4"},{"date_short":"2018-05-29","number":"15"},{"date_short":"2018-05-30","number":"4"},{"date_short":"2018-05-31","number":"10"},{"date_short":"2018-06-01","number":"14"},{"date_short":"2018-06-02","number":"9"},{"date_short":"2018-06-03","number":"1"},{"date_short":"2018-06-04","number":"23"},{"date_short":"2018-06-05","number":"24"},{"date_short":"2018-06-06","number":"23"}],"vaccini":[{"date_short":"2018-02-01","number":"3"},{"date_short":"2018-02-02","number":"6"},{"date_short":"2018-02-03","number":"6"},{"date_short":"2018-02-04","number":"2"},{"date_short":"2018-02-05","number":"1"},{"date_short":"2018-02-07","number":"1"},{"date_short":"2018-02-08","number":"3"},{"date_short":"2018-02-09","number":"1"},{"date_short":"2018-02-10","number":"2"},{"date_short":"2018-02-11","number":"3"},{"date_short":"2018-02-12","number":"1"},{"date_short":"2018-02-13","number":"2"},{"date_short":"2018-02-14","number":"1"},{"date_short":"2018-02-15","number":"1"},{"date_short":"2018-02-16","number":"2"},{"date_short":"2018-02-17","number":"2"},{"date_short":"2018-02-18","number":"1"},{"date_short":"2018-02-19","number":"2"},{"date_short":"2018-02-20","number":"2"},{"date_short":"2018-02-21","number":"4"},{"date_short":"2018-02-22","number":"1"},{"date_short":"2018-02-23","number":"5"},{"date_short":"2018-02-24","number":"6"},{"date_short":"2018-02-25","number":"2"},{"date_short":"2018-02-26","number":"2"},{"date_short":"2018-03-01","number":"6"},{"date_short":"2018-03-02","number":"4"},{"date_short":"2018-03-03","number":"1"},{"date_short":"2018-03-04","number":"2"},{"date_short":"2018-03-05","number":"1"},{"date_short":"2018-03-06","number":"2"},{"date_short":"2018-03-08","number":"2"},{"date_short":"2018-03-09","number":"3"},{"date_short":"2018-03-10","number":"2"},{"date_short":"2018-03-11","number":"1"},{"date_short":"2018-03-12","number":"5"},{"date_short":"2018-03-13","number":"6"},{"date_short":"2018-03-15","number":"2"},{"date_short":"2018-03-16","number":"2"},{"date_short":"2018-03-17","number":"1"},{"date_short":"2018-03-18","number":"3"},{"date_short":"2018-03-19","number":"6"},{"date_short":"2018-03-21","number":"1"},{"date_short":"2018-03-24","number":"2"},{"date_short":"2018-03-25","number":"1"},{"date_short":"2018-03-26","number":"1"},{"date_short":"2018-03-27","number":"1"},{"date_short":"2018-03-28","number":"1"},{"date_short":"2018-03-29","number":"3"},{"date_short":"2018-03-30","number":"2"},{"date_short":"2018-04-01","number":"2"},{"date_short":"2018-04-02","number":"1"},{"date_short":"2018-04-03","number":"1"},{"date_short":"2018-04-04","number":"1"},{"date_short":"2018-04-07","number":"1"},{"date_short":"2018-04-09","number":"1"},{"date_short":"2018-04-10","number":"1"},{"date_short":"2018-04-11","number":"3"},{"date_short":"2018-04-12","number":"1"},{"date_short":"2018-04-14","number":"1"},{"date_short":"2018-04-15","number":"2"},{"date_short":"2018-04-16","number":"1"},{"date_short":"2018-04-17","number":"3"},{"date_short":"2018-04-18","number":"1"},{"date_short":"2018-04-19","number":"2"},{"date_short":"2018-04-20","number":"2"},{"date_short":"2018-04-21","number":"1"},{"date_short":"2018-04-23","number":"11"},{"date_short":"2018-04-24","number":"3"},{"date_short":"2018-04-25","number":"3"},{"date_short":"2018-04-26","number":"3"},{"date_short":"2018-04-27","number":"4"},{"date_short":"2018-04-28","number":"2"},{"date_short":"2018-04-29","number":"2"},{"date_short":"2018-04-30","number":"7"},{"date_short":"2018-05-03","number":"2"},{"date_short":"2018-05-05","number":"1"},{"date_short":"2018-05-06","number":"1"},{"date_short":"2018-05-08","number":"1"},{"date_short":"2018-05-09","number":"2"},{"date_short":"2018-05-10","number":"2"},{"date_short":"2018-05-11","number":"1"},{"date_short":"2018-05-12","number":"1"},{"date_short":"2018-05-15","number":"2"},{"date_short":"2018-05-16","number":"9"},{"date_short":"2018-05-17","number":"7"},{"date_short":"2018-05-18","number":"3"},{"date_short":"2018-05-19","number":"3"},{"date_short":"2018-05-22","number":"2"},{"date_short":"2018-05-23","number":"6"},{"date_short":"2018-05-24","number":"1"},{"date_short":"2018-05-25","number":"1"},{"date_short":"2018-05-26","number":"1"},{"date_short":"2018-05-27","number":"1"},{"date_short":"2018-05-28","number":"1"},{"date_short":"2018-05-29","number":"1"},{"date_short":"2018-05-31","number":"1"},{"date_short":"2018-06-01","number":"8"},{"date_short":"2018-06-02","number":"5"},{"date_short":"2018-06-04","number":"6"},{"date_short":"2018-06-05","number":"4"},{"date_short":"2018-06-06","number":"2"}],"reddito":[{"date_short":"2018-02-01","number":"2"},{"date_short":"2018-02-02","number":"8"},{"date_short":"2018-02-03","number":"7"},{"date_short":"2018-02-04","number":"2"},{"date_short":"2018-02-05","number":"1"},{"date_short":"2018-02-07","number":"2"},{"date_short":"2018-02-08","number":"1"},{"date_short":"2018-02-09","number":"3"},{"date_short":"2018-02-10","number":"2"},{"date_short":"2018-02-11","number":"3"},{"date_short":"2018-02-13","number":"2"},{"date_short":"2018-02-14","number":"1"},{"date_short":"2018-02-15","number":"3"},{"date_short":"2018-02-16","number":"3"},{"date_short":"2018-02-17","number":"6"},{"date_short":"2018-02-18","number":"1"},{"date_short":"2018-02-19","number":"3"},{"date_short":"2018-02-20","number":"1"},{"date_short":"2018-02-21","number":"2"},{"date_short":"2018-02-23","number":"1"},{"date_short":"2018-02-24","number":"1"},{"date_short":"2018-02-25","number":"2"},{"date_short":"2018-02-26","number":"2"},{"date_short":"2018-02-27","number":"2"},{"date_short":"2018-02-28","number":"3"},{"date_short":"2018-03-01","number":"7"},{"date_short":"2018-03-02","number":"3"},{"date_short":"2018-03-03","number":"1"},{"date_short":"2018-03-04","number":"3"},{"date_short":"2018-03-05","number":"7"},{"date_short":"2018-03-06","number":"19"},{"date_short":"2018-03-07","number":"29"},{"date_short":"2018-03-08","number":"26"},{"date_short":"2018-03-09","number":"31"},{"date_short":"2018-03-10","number":"19"},{"date_short":"2018-03-11","number":"25"},{"date_short":"2018-03-12","number":"10"},{"date_short":"2018-03-13","number":"19"},{"date_short":"2018-03-14","number":"25"},{"date_short":"2018-03-15","number":"14"},{"date_short":"2018-03-16","number":"10"},{"date_short":"2018-03-17","number":"7"},{"date_short":"2018-03-18","number":"14"},{"date_short":"2018-03-19","number":"11"},{"date_short":"2018-03-20","number":"8"},{"date_short":"2018-03-21","number":"8"},{"date_short":"2018-03-22","number":"7"},{"date_short":"2018-03-23","number":"1"},{"date_short":"2018-03-24","number":"10"},{"date_short":"2018-03-25","number":"13"},{"date_short":"2018-03-26","number":"25"},{"date_short":"2018-03-27","number":"25"},{"date_short":"2018-03-28","number":"18"},{"date_short":"2018-03-29","number":"16"},{"date_short":"2018-03-30","number":"19"},{"date_short":"2018-03-31","number":"6"},{"date_short":"2018-04-01","number":"2"},{"date_short":"2018-04-02","number":"2"},{"date_short":"2018-04-03","number":"3"},{"date_short":"2018-04-04","number":"8"},{"date_short":"2018-04-05","number":"12"},{"date_short":"2018-04-06","number":"5"},{"date_short":"2018-04-07","number":"10"},{"date_short":"2018-04-08","number":"2"},{"date_short":"2018-04-09","number":"6"},{"date_short":"2018-04-10","number":"1"},{"date_short":"2018-04-11","number":"2"},{"date_short":"2018-04-12","number":"2"},{"date_short":"2018-04-13","number":"7"},{"date_short":"2018-04-14","number":"3"},{"date_short":"2018-04-15","number":"4"},{"date_short":"2018-04-16","number":"1"},{"date_short":"2018-04-17","number":"2"},{"date_short":"2018-04-18","number":"7"},{"date_short":"2018-04-19","number":"7"},{"date_short":"2018-04-20","number":"3"},{"date_short":"2018-04-21","number":"5"},{"date_short":"2018-04-22","number":"4"},{"date_short":"2018-04-23","number":"13"},{"date_short":"2018-04-24","number":"9"},{"date_short":"2018-04-25","number":"7"},{"date_short":"2018-04-26","number":"8"},{"date_short":"2018-04-27","number":"5"},{"date_short":"2018-04-28","number":"3"},{"date_short":"2018-04-29","number":"7"},{"date_short":"2018-04-30","number":"8"},{"date_short":"2018-05-01","number":"1"},{"date_short":"2018-05-02","number":"3"},{"date_short":"2018-05-03","number":"10"},{"date_short":"2018-05-04","number":"1"},{"date_short":"2018-05-05","number":"4"},{"date_short":"2018-05-06","number":"14"},{"date_short":"2018-05-07","number":"11"},{"date_short":"2018-05-08","number":"3"},{"date_short":"2018-05-09","number":"9"},{"date_short":"2018-05-10","number":"22"},{"date_short":"2018-05-11","number":"33"},{"date_short":"2018-05-12","number":"13"},{"date_short":"2018-05-13","number":"13"},{"date_short":"2018-05-14","number":"18"},{"date_short":"2018-05-15","number":"18"},{"date_short":"2018-05-16","number":"17"},{"date_short":"2018-05-17","number":"25"},{"date_short":"2018-05-18","number":"22"},{"date_short":"2018-05-19","number":"11"},{"date_short":"2018-05-20","number":"11"},{"date_short":"2018-05-21","number":"17"},{"date_short":"2018-05-22","number":"4"},{"date_short":"2018-05-23","number":"12"},{"date_short":"2018-05-24","number":"11"},{"date_short":"2018-05-25","number":"3"},{"date_short":"2018-05-26","number":"7"},{"date_short":"2018-05-27","number":"1"},{"date_short":"2018-05-28","number":"5"},{"date_short":"2018-05-29","number":"10"},{"date_short":"2018-05-30","number":"3"},{"date_short":"2018-05-31","number":"6"},{"date_short":"2018-06-01","number":"11"},{"date_short":"2018-06-02","number":"9"},{"date_short":"2018-06-03","number":"11"},{"date_short":"2018-06-04","number":"21"},{"date_short":"2018-06-05","number":"9"},{"date_short":"2018-06-06","number":"11"}],"berlusconi":[{"date_short":"2018-02-01","number":"35"},{"date_short":"2018-02-02","number":"38"},{"date_short":"2018-02-03","number":"35"},{"date_short":"2018-02-04","number":"21"},{"date_short":"2018-02-05","number":"45"},{"date_short":"2018-02-06","number":"41"},{"date_short":"2018-02-07","number":"40"},{"date_short":"2018-02-08","number":"34"},{"date_short":"2018-02-09","number":"42"},{"date_short":"2018-02-10","number":"27"},{"date_short":"2018-02-11","number":"28"},{"date_short":"2018-02-12","number":"29"},{"date_short":"2018-02-13","number":"29"},{"date_short":"2018-02-14","number":"36"},{"date_short":"2018-02-15","number":"48"},{"date_short":"2018-02-16","number":"29"},{"date_short":"2018-02-17","number":"35"},{"date_short":"2018-02-18","number":"47"},{"date_short":"2018-02-19","number":"46"},{"date_short":"2018-02-20","number":"48"},{"date_short":"2018-02-21","number":"47"},{"date_short":"2018-02-22","number":"53"},{"date_short":"2018-02-23","number":"23"},{"date_short":"2018-02-24","number":"25"},{"date_short":"2018-02-25","number":"37"},{"date_short":"2018-02-26","number":"43"},{"date_short":"2018-02-27","number":"41"},{"date_short":"2018-02-28","number":"54"},{"date_short":"2018-03-01","number":"39"},{"date_short":"2018-03-02","number":"49"},{"date_short":"2018-03-03","number":"33"},{"date_short":"2018-03-04","number":"37"},{"date_short":"2018-03-05","number":"87"},{"date_short":"2018-03-06","number":"56"},{"date_short":"2018-03-07","number":"58"},{"date_short":"2018-03-08","number":"31"},{"date_short":"2018-03-09","number":"28"},{"date_short":"2018-03-10","number":"24"},{"date_short":"2018-03-11","number":"28"},{"date_short":"2018-03-12","number":"39"},{"date_short":"2018-03-13","number":"41"},{"date_short":"2018-03-14","number":"46"},{"date_short":"2018-03-15","number":"42"},{"date_short":"2018-03-16","number":"27"},{"date_short":"2018-03-17","number":"23"},{"date_short":"2018-03-18","number":"25"},{"date_short":"2018-03-19","number":"22"},{"date_short":"2018-03-20","number":"37"},{"date_short":"2018-03-21","number":"47"},{"date_short":"2018-03-22","number":"51"},{"date_short":"2018-03-23","number":"52"},{"date_short":"2018-03-24","number":"69"},{"date_short":"2018-03-25","number":"50"},{"date_short":"2018-03-26","number":"73"},{"date_short":"2018-03-27","number":"49"},{"date_short":"2018-03-28","number":"33"},{"date_short":"2018-03-29","number":"49"},{"date_short":"2018-03-30","number":"33"},{"date_short":"2018-03-31","number":"19"},{"date_short":"2018-04-01","number":"5"},{"date_short":"2018-04-02","number":"6"},{"date_short":"2018-04-03","number":"31"},{"date_short":"2018-04-04","number":"63"},{"date_short":"2018-04-05","number":"50"},{"date_short":"2018-04-06","number":"43"},{"date_short":"2018-04-07","number":"39"},{"date_short":"2018-04-08","number":"40"},{"date_short":"2018-04-09","number":"52"},{"date_short":"2018-04-10","number":"32"},{"date_short":"2018-04-11","number":"34"},{"date_short":"2018-04-12","number":"60"},{"date_short":"2018-04-13","number":"80"},{"date_short":"2018-04-14","number":"42"},{"date_short":"2018-04-15","number":"40"},{"date_short":"2018-04-16","number":"37"},{"date_short":"2018-04-17","number":"47"},{"date_short":"2018-04-18","number":"49"},{"date_short":"2018-04-19","number":"55"},{"date_short":"2018-04-20","number":"80"},{"date_short":"2018-04-21","number":"57"},{"date_short":"2018-04-22","number":"31"},{"date_short":"2018-04-23","number":"43"},{"date_short":"2018-04-24","number":"48"},{"date_short":"2018-04-25","number":"35"},{"date_short":"2018-04-26","number":"33"},{"date_short":"2018-04-27","number":"35"},{"date_short":"2018-04-28","number":"32"},{"date_short":"2018-04-29","number":"23"},{"date_short":"2018-04-30","number":"34"},{"date_short":"2018-05-01","number":"30"},{"date_short":"2018-05-02","number":"36"},{"date_short":"2018-05-03","number":"56"},{"date_short":"2018-05-04","number":"39"},{"date_short":"2018-05-05","number":"21"},{"date_short":"2018-05-06","number":"31"},{"date_short":"2018-05-07","number":"43"},{"date_short":"2018-05-08","number":"46"},{"date_short":"2018-05-09","number":"67"},{"date_short":"2018-05-10","number":"75"},{"date_short":"2018-05-11","number":"64"},{"date_short":"2018-05-12","number":"65"},{"date_short":"2018-05-13","number":"43"},{"date_short":"2018-05-14","number":"41"},{"date_short":"2018-05-15","number":"47"},{"date_short":"2018-05-16","number":"59"},{"date_short":"2018-05-17","number":"29"},{"date_short":"2018-05-18","number":"54"},{"date_short":"2018-05-19","number":"31"},{"date_short":"2018-05-20","number":"31"},{"date_short":"2018-05-21","number":"23"},{"date_short":"2018-05-22","number":"16"},{"date_short":"2018-05-23","number":"18"},{"date_short":"2018-05-24","number":"40"},{"date_short":"2018-05-25","number":"23"},{"date_short":"2018-05-26","number":"8"},{"date_short":"2018-05-27","number":"16"},{"date_short":"2018-05-28","number":"47"},{"date_short":"2018-05-29","number":"38"},{"date_short":"2018-05-30","number":"22"},{"date_short":"2018-05-31","number":"18"},{"date_short":"2018-06-01","number":"33"},{"date_short":"2018-06-02","number":"33"},{"date_short":"2018-06-03","number":"12"},{"date_short":"2018-06-04","number":"14"},{"date_short":"2018-06-05","number":"17"},{"date_short":"2018-06-06","number":"28"}],"salvini":[{"date_short":"2018-02-01","number":"41"},{"date_short":"2018-02-02","number":"53"},{"date_short":"2018-02-03","number":"55"},{"date_short":"2018-02-04","number":"29"},{"date_short":"2018-02-05","number":"52"},{"date_short":"2018-02-06","number":"36"},{"date_short":"2018-02-07","number":"43"},{"date_short":"2018-02-08","number":"45"},{"date_short":"2018-02-09","number":"61"},{"date_short":"2018-02-10","number":"35"},{"date_short":"2018-02-11","number":"47"},{"date_short":"2018-02-12","number":"38"},{"date_short":"2018-02-13","number":"26"},{"date_short":"2018-02-14","number":"35"},{"date_short":"2018-02-15","number":"34"},{"date_short":"2018-02-16","number":"33"},{"date_short":"2018-02-17","number":"47"},{"date_short":"2018-02-18","number":"42"},{"date_short":"2018-02-19","number":"41"},{"date_short":"2018-02-20","number":"54"},{"date_short":"2018-02-21","number":"43"},{"date_short":"2018-02-22","number":"48"},{"date_short":"2018-02-23","number":"44"},{"date_short":"2018-02-24","number":"46"},{"date_short":"2018-02-25","number":"33"},{"date_short":"2018-02-26","number":"51"},{"date_short":"2018-02-27","number":"39"},{"date_short":"2018-02-28","number":"43"},{"date_short":"2018-03-01","number":"52"},{"date_short":"2018-03-02","number":"52"},{"date_short":"2018-03-03","number":"23"},{"date_short":"2018-03-04","number":"23"},{"date_short":"2018-03-05","number":"131"},{"date_short":"2018-03-06","number":"122"},{"date_short":"2018-03-07","number":"119"},{"date_short":"2018-03-08","number":"48"},{"date_short":"2018-03-09","number":"77"},{"date_short":"2018-03-10","number":"44"},{"date_short":"2018-03-11","number":"59"},{"date_short":"2018-03-12","number":"61"},{"date_short":"2018-03-13","number":"67"},{"date_short":"2018-03-14","number":"77"},{"date_short":"2018-03-15","number":"69"},{"date_short":"2018-03-16","number":"58"},{"date_short":"2018-03-17","number":"56"},{"date_short":"2018-03-18","number":"49"},{"date_short":"2018-03-19","number":"48"},{"date_short":"2018-03-20","number":"50"},{"date_short":"2018-03-21","number":"54"},{"date_short":"2018-03-22","number":"69"},{"date_short":"2018-03-23","number":"91"},{"date_short":"2018-03-24","number":"80"},{"date_short":"2018-03-25","number":"66"},{"date_short":"2018-03-26","number":"88"},{"date_short":"2018-03-27","number":"74"},{"date_short":"2018-03-28","number":"63"},{"date_short":"2018-03-29","number":"63"},{"date_short":"2018-03-30","number":"70"},{"date_short":"2018-03-31","number":"40"},{"date_short":"2018-04-01","number":"17"},{"date_short":"2018-04-02","number":"27"},{"date_short":"2018-04-03","number":"58"},{"date_short":"2018-04-04","number":"92"},{"date_short":"2018-04-05","number":"66"},{"date_short":"2018-04-06","number":"48"},{"date_short":"2018-04-07","number":"47"},{"date_short":"2018-04-08","number":"60"},{"date_short":"2018-04-09","number":"67"},{"date_short":"2018-04-10","number":"45"},{"date_short":"2018-04-11","number":"76"},{"date_short":"2018-04-12","number":"76"},{"date_short":"2018-04-13","number":"82"},{"date_short":"2018-04-14","number":"45"},{"date_short":"2018-04-15","number":"57"},{"date_short":"2018-04-16","number":"67"},{"date_short":"2018-04-17","number":"71"},{"date_short":"2018-04-18","number":"66"},{"date_short":"2018-04-19","number":"77"},{"date_short":"2018-04-20","number":"77"},{"date_short":"2018-04-21","number":"55"},{"date_short":"2018-04-22","number":"35"},{"date_short":"2018-04-23","number":"62"},{"date_short":"2018-04-24","number":"53"},{"date_short":"2018-04-25","number":"48"},{"date_short":"2018-04-26","number":"62"},{"date_short":"2018-04-27","number":"47"},{"date_short":"2018-04-28","number":"39"},{"date_short":"2018-04-29","number":"31"},{"date_short":"2018-04-30","number":"56"},{"date_short":"2018-05-01","number":"43"},{"date_short":"2018-05-02","number":"65"},{"date_short":"2018-05-03","number":"69"},{"date_short":"2018-05-04","number":"62"},{"date_short":"2018-05-05","number":"45"},{"date_short":"2018-05-06","number":"53"},{"date_short":"2018-05-07","number":"71"},{"date_short":"2018-05-08","number":"57"},{"date_short":"2018-05-09","number":"74"},{"date_short":"2018-05-10","number":"101"},{"date_short":"2018-05-11","number":"102"},{"date_short":"2018-05-12","number":"92"},{"date_short":"2018-05-13","number":"59"},{"date_short":"2018-05-14","number":"87"},{"date_short":"2018-05-15","number":"113"},{"date_short":"2018-05-16","number":"92"},{"date_short":"2018-05-17","number":"100"},{"date_short":"2018-05-18","number":"100"},{"date_short":"2018-05-19","number":"67"},{"date_short":"2018-05-20","number":"66"},{"date_short":"2018-05-21","number":"77"},{"date_short":"2018-05-22","number":"75"},{"date_short":"2018-05-23","number":"75"},{"date_short":"2018-05-24","number":"84"},{"date_short":"2018-05-25","number":"62"},{"date_short":"2018-05-26","number":"77"},{"date_short":"2018-05-27","number":"60"},{"date_short":"2018-05-28","number":"121"},{"date_short":"2018-05-29","number":"100"},{"date_short":"2018-05-30","number":"108"},{"date_short":"2018-05-31","number":"113"},{"date_short":"2018-06-01","number":"111"},{"date_short":"2018-06-02","number":"102"},{"date_short":"2018-06-03","number":"69"},{"date_short":"2018-06-04","number":"116"},{"date_short":"2018-06-05","number":"96"},{"date_short":"2018-06-06","number":"94"}],"meloni":[{"date_short":"2018-02-01","number":"8"},{"date_short":"2018-02-02","number":"11"},{"date_short":"2018-02-03","number":"9"},{"date_short":"2018-02-04","number":"6"},{"date_short":"2018-02-05","number":"17"},{"date_short":"2018-02-06","number":"14"},{"date_short":"2018-02-07","number":"19"},{"date_short":"2018-02-08","number":"7"},{"date_short":"2018-02-09","number":"21"},{"date_short":"2018-02-10","number":"17"},{"date_short":"2018-02-11","number":"19"},{"date_short":"2018-02-12","number":"25"},{"date_short":"2018-02-13","number":"24"},{"date_short":"2018-02-14","number":"21"},{"date_short":"2018-02-15","number":"18"},{"date_short":"2018-02-16","number":"16"},{"date_short":"2018-02-17","number":"21"},{"date_short":"2018-02-18","number":"21"},{"date_short":"2018-02-19","number":"14"},{"date_short":"2018-02-20","number":"21"},{"date_short":"2018-02-21","number":"11"},{"date_short":"2018-02-22","number":"13"},{"date_short":"2018-02-23","number":"12"},{"date_short":"2018-02-24","number":"24"},{"date_short":"2018-02-25","number":"7"},{"date_short":"2018-02-26","number":"10"},{"date_short":"2018-02-27","number":"17"},{"date_short":"2018-02-28","number":"16"},{"date_short":"2018-03-01","number":"18"},{"date_short":"2018-03-02","number":"31"},{"date_short":"2018-03-03","number":"8"},{"date_short":"2018-03-04","number":"13"},{"date_short":"2018-03-05","number":"32"},{"date_short":"2018-03-06","number":"19"},{"date_short":"2018-03-07","number":"10"},{"date_short":"2018-03-08","number":"7"},{"date_short":"2018-03-09","number":"9"},{"date_short":"2018-03-10","number":"6"},{"date_short":"2018-03-11","number":"7"},{"date_short":"2018-03-12","number":"2"},{"date_short":"2018-03-13","number":"16"},{"date_short":"2018-03-14","number":"19"},{"date_short":"2018-03-15","number":"13"},{"date_short":"2018-03-16","number":"21"},{"date_short":"2018-03-17","number":"12"},{"date_short":"2018-03-18","number":"10"},{"date_short":"2018-03-19","number":"18"},{"date_short":"2018-03-20","number":"10"},{"date_short":"2018-03-21","number":"19"},{"date_short":"2018-03-22","number":"24"},{"date_short":"2018-03-23","number":"30"},{"date_short":"2018-03-24","number":"25"},{"date_short":"2018-03-25","number":"10"},{"date_short":"2018-03-26","number":"13"},{"date_short":"2018-03-27","number":"15"},{"date_short":"2018-03-28","number":"8"},{"date_short":"2018-03-29","number":"12"},{"date_short":"2018-03-30","number":"12"},{"date_short":"2018-03-31","number":"5"},{"date_short":"2018-04-01","number":"2"},{"date_short":"2018-04-02","number":"3"},{"date_short":"2018-04-03","number":"4"},{"date_short":"2018-04-04","number":"21"},{"date_short":"2018-04-05","number":"14"},{"date_short":"2018-04-06","number":"14"},{"date_short":"2018-04-07","number":"10"},{"date_short":"2018-04-08","number":"17"},{"date_short":"2018-04-09","number":"13"},{"date_short":"2018-04-10","number":"6"},{"date_short":"2018-04-11","number":"10"},{"date_short":"2018-04-12","number":"19"},{"date_short":"2018-04-13","number":"19"},{"date_short":"2018-04-14","number":"14"},{"date_short":"2018-04-15","number":"11"},{"date_short":"2018-04-16","number":"16"},{"date_short":"2018-04-17","number":"8"},{"date_short":"2018-04-18","number":"12"},{"date_short":"2018-04-19","number":"25"},{"date_short":"2018-04-20","number":"24"},{"date_short":"2018-04-21","number":"5"},{"date_short":"2018-04-22","number":"3"},{"date_short":"2018-04-23","number":"12"},{"date_short":"2018-04-24","number":"7"},{"date_short":"2018-04-25","number":"7"},{"date_short":"2018-04-26","number":"7"},{"date_short":"2018-04-27","number":"2"},{"date_short":"2018-04-28","number":"7"},{"date_short":"2018-04-29","number":"3"},{"date_short":"2018-04-30","number":"6"},{"date_short":"2018-05-01","number":"3"},{"date_short":"2018-05-02","number":"9"},{"date_short":"2018-05-03","number":"14"},{"date_short":"2018-05-04","number":"15"},{"date_short":"2018-05-05","number":"11"},{"date_short":"2018-05-06","number":"10"},{"date_short":"2018-05-07","number":"25"},{"date_short":"2018-05-08","number":"15"},{"date_short":"2018-05-09","number":"12"},{"date_short":"2018-05-10","number":"26"},{"date_short":"2018-05-11","number":"22"},{"date_short":"2018-05-12","number":"24"},{"date_short":"2018-05-13","number":"19"},{"date_short":"2018-05-14","number":"16"},{"date_short":"2018-05-15","number":"22"},{"date_short":"2018-05-16","number":"9"},{"date_short":"2018-05-17","number":"9"},{"date_short":"2018-05-18","number":"14"},{"date_short":"2018-05-19","number":"6"},{"date_short":"2018-05-20","number":"5"},{"date_short":"2018-05-21","number":"12"},{"date_short":"2018-05-22","number":"12"},{"date_short":"2018-05-23","number":"15"},{"date_short":"2018-05-24","number":"12"},{"date_short":"2018-05-25","number":"8"},{"date_short":"2018-05-26","number":"17"},{"date_short":"2018-05-27","number":"12"},{"date_short":"2018-05-28","number":"27"},{"date_short":"2018-05-29","number":"19"},{"date_short":"2018-05-30","number":"21"},{"date_short":"2018-05-31","number":"31"},{"date_short":"2018-06-01","number":"17"},{"date_short":"2018-06-02","number":"12"},{"date_short":"2018-06-03","number":"4"},{"date_short":"2018-06-04","number":"9"},{"date_short":"2018-06-05","number":"10"},{"date_short":"2018-06-06","number":"7"}],"distefano":[{"date_short":"2018-02-01","number":"7"},{"date_short":"2018-02-02","number":"6"},{"date_short":"2018-02-03","number":"8"},{"date_short":"2018-02-04","number":"9"},{"date_short":"2018-02-05","number":"6"},{"date_short":"2018-02-06","number":"7"},{"date_short":"2018-02-07","number":"6"},{"date_short":"2018-02-08","number":"5"},{"date_short":"2018-02-09","number":"13"},{"date_short":"2018-02-10","number":"9"},{"date_short":"2018-02-11","number":"2"},{"date_short":"2018-02-12","number":"4"},{"date_short":"2018-02-13","number":"6"},{"date_short":"2018-02-14","number":"7"},{"date_short":"2018-02-15","number":"4"},{"date_short":"2018-02-16","number":"3"},{"date_short":"2018-02-17","number":"4"},{"date_short":"2018-02-18","number":"5"},{"date_short":"2018-02-19","number":"6"},{"date_short":"2018-02-20","number":"6"},{"date_short":"2018-02-21","number":"7"},{"date_short":"2018-02-22","number":"11"},{"date_short":"2018-02-23","number":"17"},{"date_short":"2018-02-24","number":"18"},{"date_short":"2018-02-25","number":"4"},{"date_short":"2018-02-26","number":"8"},{"date_short":"2018-02-27","number":"14"},{"date_short":"2018-02-28","number":"13"},{"date_short":"2018-03-01","number":"19"},{"date_short":"2018-03-02","number":"15"},{"date_short":"2018-03-03","number":"7"},{"date_short":"2018-03-04","number":"3"},{"date_short":"2018-03-05","number":"21"},{"date_short":"2018-03-06","number":"8"},{"date_short":"2018-03-07","number":"8"},{"date_short":"2018-03-09","number":"6"},{"date_short":"2018-03-10","number":"3"},{"date_short":"2018-03-11","number":"1"},{"date_short":"2018-03-12","number":"3"},{"date_short":"2018-03-13","number":"4"},{"date_short":"2018-03-14","number":"8"},{"date_short":"2018-03-15","number":"3"},{"date_short":"2018-03-16","number":"3"},{"date_short":"2018-03-17","number":"7"},{"date_short":"2018-03-19","number":"5"},{"date_short":"2018-03-20","number":"3"},{"date_short":"2018-03-21","number":"2"},{"date_short":"2018-03-22","number":"4"},{"date_short":"2018-03-23","number":"5"},{"date_short":"2018-03-24","number":"4"},{"date_short":"2018-03-25","number":"3"},{"date_short":"2018-03-26","number":"3"},{"date_short":"2018-03-27","number":"6"},{"date_short":"2018-03-28","number":"4"},{"date_short":"2018-03-29","number":"5"},{"date_short":"2018-03-30","number":"5"},{"date_short":"2018-03-31","number":"2"},{"date_short":"2018-04-01","number":"1"},{"date_short":"2018-04-03","number":"3"},{"date_short":"2018-04-04","number":"2"},{"date_short":"2018-04-05","number":"3"},{"date_short":"2018-04-06","number":"1"},{"date_short":"2018-04-07","number":"2"},{"date_short":"2018-04-08","number":"2"},{"date_short":"2018-04-09","number":"3"},{"date_short":"2018-04-10","number":"2"},{"date_short":"2018-04-11","number":"2"},{"date_short":"2018-04-12","number":"2"},{"date_short":"2018-04-13","number":"2"},{"date_short":"2018-04-14","number":"4"},{"date_short":"2018-04-15","number":"1"},{"date_short":"2018-04-16","number":"3"},{"date_short":"2018-04-17","number":"5"},{"date_short":"2018-04-18","number":"5"},{"date_short":"2018-04-19","number":"3"},{"date_short":"2018-04-20","number":"6"},{"date_short":"2018-04-21","number":"1"},{"date_short":"2018-04-23","number":"4"},{"date_short":"2018-04-24","number":"1"},{"date_short":"2018-04-25","number":"1"},{"date_short":"2018-04-26","number":"5"},{"date_short":"2018-04-27","number":"2"},{"date_short":"2018-04-28","number":"2"},{"date_short":"2018-04-29","number":"1"},{"date_short":"2018-04-30","number":"1"},{"date_short":"2018-05-01","number":"1"},{"date_short":"2018-05-02","number":"2"},{"date_short":"2018-05-03","number":"2"},{"date_short":"2018-05-04","number":"4"},{"date_short":"2018-05-05","number":"3"},{"date_short":"2018-05-06","number":"1"},{"date_short":"2018-05-08","number":"5"},{"date_short":"2018-05-09","number":"4"},{"date_short":"2018-05-10","number":"6"},{"date_short":"2018-05-11","number":"1"},{"date_short":"2018-05-12","number":"9"},{"date_short":"2018-05-13","number":"5"},{"date_short":"2018-05-14","number":"4"},{"date_short":"2018-05-15","number":"5"},{"date_short":"2018-05-16","number":"8"},{"date_short":"2018-05-17","number":"4"},{"date_short":"2018-05-18","number":"5"},{"date_short":"2018-05-19","number":"6"},{"date_short":"2018-05-20","number":"2"},{"date_short":"2018-05-21","number":"4"},{"date_short":"2018-05-22","number":"6"},{"date_short":"2018-05-23","number":"4"},{"date_short":"2018-05-24","number":"4"},{"date_short":"2018-05-25","number":"4"},{"date_short":"2018-05-26","number":"6"},{"date_short":"2018-05-27","number":"7"},{"date_short":"2018-05-28","number":"8"},{"date_short":"2018-05-29","number":"5"},{"date_short":"2018-05-30","number":"3"},{"date_short":"2018-05-31","number":"7"},{"date_short":"2018-06-01","number":"4"},{"date_short":"2018-06-02","number":"3"},{"date_short":"2018-06-04","number":"8"},{"date_short":"2018-06-05","number":"3"},{"date_short":"2018-06-06","number":"3"}],"dimaio":[{"date_short":"2018-02-01","number":"37"},{"date_short":"2018-02-02","number":"62"},{"date_short":"2018-02-03","number":"46"},{"date_short":"2018-02-04","number":"34"},{"date_short":"2018-02-05","number":"33"},{"date_short":"2018-02-06","number":"36"},{"date_short":"2018-02-07","number":"22"},{"date_short":"2018-02-08","number":"26"},{"date_short":"2018-02-09","number":"31"},{"date_short":"2018-02-10","number":"20"},{"date_short":"2018-02-11","number":"34"},{"date_short":"2018-02-12","number":"54"},{"date_short":"2018-02-13","number":"49"},{"date_short":"2018-02-14","number":"40"},{"date_short":"2018-02-15","number":"39"},{"date_short":"2018-02-16","number":"42"},{"date_short":"2018-02-17","number":"47"},{"date_short":"2018-02-18","number":"45"},{"date_short":"2018-02-19","number":"36"},{"date_short":"2018-02-20","number":"52"},{"date_short":"2018-02-21","number":"31"},{"date_short":"2018-02-22","number":"40"},{"date_short":"2018-02-23","number":"58"},{"date_short":"2018-02-24","number":"42"},{"date_short":"2018-02-25","number":"39"},{"date_short":"2018-02-26","number":"46"},{"date_short":"2018-02-27","number":"65"},{"date_short":"2018-02-28","number":"57"},{"date_short":"2018-03-01","number":"67"},{"date_short":"2018-03-02","number":"62"},{"date_short":"2018-03-03","number":"24"},{"date_short":"2018-03-04","number":"25"},{"date_short":"2018-03-05","number":"105"},{"date_short":"2018-03-06","number":"99"},{"date_short":"2018-03-07","number":"91"},{"date_short":"2018-03-08","number":"53"},{"date_short":"2018-03-09","number":"76"},{"date_short":"2018-03-10","number":"61"},{"date_short":"2018-03-11","number":"55"},{"date_short":"2018-03-12","number":"37"},{"date_short":"2018-03-13","number":"57"},{"date_short":"2018-03-14","number":"67"},{"date_short":"2018-03-15","number":"57"},{"date_short":"2018-03-16","number":"46"},{"date_short":"2018-03-17","number":"56"},{"date_short":"2018-03-18","number":"46"},{"date_short":"2018-03-19","number":"47"},{"date_short":"2018-03-20","number":"49"},{"date_short":"2018-03-21","number":"53"},{"date_short":"2018-03-22","number":"54"},{"date_short":"2018-03-23","number":"69"},{"date_short":"2018-03-24","number":"72"},{"date_short":"2018-03-25","number":"62"},{"date_short":"2018-03-26","number":"65"},{"date_short":"2018-03-27","number":"67"},{"date_short":"2018-03-28","number":"63"},{"date_short":"2018-03-29","number":"58"},{"date_short":"2018-03-30","number":"62"},{"date_short":"2018-03-31","number":"38"},{"date_short":"2018-04-01","number":"17"},{"date_short":"2018-04-02","number":"18"},{"date_short":"2018-04-03","number":"47"},{"date_short":"2018-04-04","number":"88"},{"date_short":"2018-04-05","number":"63"},{"date_short":"2018-04-06","number":"58"},{"date_short":"2018-04-07","number":"63"},{"date_short":"2018-04-08","number":"62"},{"date_short":"2018-04-09","number":"73"},{"date_short":"2018-04-10","number":"59"},{"date_short":"2018-04-11","number":"59"},{"date_short":"2018-04-12","number":"76"},{"date_short":"2018-04-13","number":"72"},{"date_short":"2018-04-14","number":"29"},{"date_short":"2018-04-15","number":"54"},{"date_short":"2018-04-16","number":"50"},{"date_short":"2018-04-17","number":"80"},{"date_short":"2018-04-18","number":"77"},{"date_short":"2018-04-19","number":"68"},{"date_short":"2018-04-20","number":"79"},{"date_short":"2018-04-21","number":"56"},{"date_short":"2018-04-22","number":"35"},{"date_short":"2018-04-23","number":"62"},{"date_short":"2018-04-24","number":"74"},{"date_short":"2018-04-25","number":"55"},{"date_short":"2018-04-26","number":"72"},{"date_short":"2018-04-27","number":"51"},{"date_short":"2018-04-28","number":"34"},{"date_short":"2018-04-29","number":"37"},{"date_short":"2018-04-30","number":"68"},{"date_short":"2018-05-01","number":"41"},{"date_short":"2018-05-02","number":"53"},{"date_short":"2018-05-03","number":"69"},{"date_short":"2018-05-04","number":"62"},{"date_short":"2018-05-05","number":"42"},{"date_short":"2018-05-06","number":"51"},{"date_short":"2018-05-07","number":"69"},{"date_short":"2018-05-08","number":"61"},{"date_short":"2018-05-09","number":"80"},{"date_short":"2018-05-10","number":"90"},{"date_short":"2018-05-11","number":"98"},{"date_short":"2018-05-12","number":"80"},{"date_short":"2018-05-13","number":"53"},{"date_short":"2018-05-14","number":"87"},{"date_short":"2018-05-15","number":"93"},{"date_short":"2018-05-16","number":"73"},{"date_short":"2018-05-17","number":"93"},{"date_short":"2018-05-18","number":"89"},{"date_short":"2018-05-19","number":"68"},{"date_short":"2018-05-20","number":"59"},{"date_short":"2018-05-21","number":"77"},{"date_short":"2018-05-22","number":"68"},{"date_short":"2018-05-23","number":"72"},{"date_short":"2018-05-24","number":"61"},{"date_short":"2018-05-25","number":"55"},{"date_short":"2018-05-26","number":"52"},{"date_short":"2018-05-27","number":"50"},{"date_short":"2018-05-28","number":"101"},{"date_short":"2018-05-29","number":"88"},{"date_short":"2018-05-30","number":"98"},{"date_short":"2018-05-31","number":"110"},{"date_short":"2018-06-01","number":"88"},{"date_short":"2018-06-02","number":"69"},{"date_short":"2018-06-03","number":"62"},{"date_short":"2018-06-04","number":"56"},{"date_short":"2018-06-05","number":"43"},{"date_short":"2018-06-06","number":"56"}],"renzi":[{"date_short":"2018-02-01","number":"43"},{"date_short":"2018-02-02","number":"59"},{"date_short":"2018-02-03","number":"41"},{"date_short":"2018-02-04","number":"38"},{"date_short":"2018-02-05","number":"46"},{"date_short":"2018-02-06","number":"58"},{"date_short":"2018-02-07","number":"34"},{"date_short":"2018-02-08","number":"34"},{"date_short":"2018-02-09","number":"29"},{"date_short":"2018-02-10","number":"31"},{"date_short":"2018-02-11","number":"45"},{"date_short":"2018-02-12","number":"46"},{"date_short":"2018-02-13","number":"49"},{"date_short":"2018-02-14","number":"43"},{"date_short":"2018-02-15","number":"49"},{"date_short":"2018-02-16","number":"48"},{"date_short":"2018-02-17","number":"54"},{"date_short":"2018-02-18","number":"58"},{"date_short":"2018-02-19","number":"60"},{"date_short":"2018-02-20","number":"69"},{"date_short":"2018-02-21","number":"64"},{"date_short":"2018-02-22","number":"40"},{"date_short":"2018-02-23","number":"45"},{"date_short":"2018-02-24","number":"46"},{"date_short":"2018-02-25","number":"39"},{"date_short":"2018-02-26","number":"56"},{"date_short":"2018-02-27","number":"50"},{"date_short":"2018-02-28","number":"62"},{"date_short":"2018-03-01","number":"52"},{"date_short":"2018-03-02","number":"53"},{"date_short":"2018-03-03","number":"29"},{"date_short":"2018-03-04","number":"33"},{"date_short":"2018-03-05","number":"132"},{"date_short":"2018-03-06","number":"116"},{"date_short":"2018-03-07","number":"88"},{"date_short":"2018-03-08","number":"62"},{"date_short":"2018-03-09","number":"65"},{"date_short":"2018-03-10","number":"46"},{"date_short":"2018-03-11","number":"42"},{"date_short":"2018-03-12","number":"72"},{"date_short":"2018-03-13","number":"70"},{"date_short":"2018-03-14","number":"38"},{"date_short":"2018-03-15","number":"35"},{"date_short":"2018-03-16","number":"42"},{"date_short":"2018-03-17","number":"44"},{"date_short":"2018-03-18","number":"36"},{"date_short":"2018-03-19","number":"37"},{"date_short":"2018-03-20","number":"26"},{"date_short":"2018-03-21","number":"27"},{"date_short":"2018-03-22","number":"37"},{"date_short":"2018-03-23","number":"49"},{"date_short":"2018-03-24","number":"48"},{"date_short":"2018-03-25","number":"38"},{"date_short":"2018-03-26","number":"28"},{"date_short":"2018-03-27","number":"42"},{"date_short":"2018-03-28","number":"42"},{"date_short":"2018-03-29","number":"32"},{"date_short":"2018-03-30","number":"30"},{"date_short":"2018-03-31","number":"28"},{"date_short":"2018-04-01","number":"11"},{"date_short":"2018-04-02","number":"10"},{"date_short":"2018-04-03","number":"29"},{"date_short":"2018-04-04","number":"42"},{"date_short":"2018-04-05","number":"38"},{"date_short":"2018-04-06","number":"40"},{"date_short":"2018-04-07","number":"47"},{"date_short":"2018-04-08","number":"30"},{"date_short":"2018-04-09","number":"48"},{"date_short":"2018-04-10","number":"48"},{"date_short":"2018-04-11","number":"40"},{"date_short":"2018-04-12","number":"34"},{"date_short":"2018-04-13","number":"37"},{"date_short":"2018-04-14","number":"20"},{"date_short":"2018-04-15","number":"22"},{"date_short":"2018-04-16","number":"21"},{"date_short":"2018-04-17","number":"19"},{"date_short":"2018-04-18","number":"45"},{"date_short":"2018-04-19","number":"42"},{"date_short":"2018-04-20","number":"31"},{"date_short":"2018-04-21","number":"22"},{"date_short":"2018-04-22","number":"17"},{"date_short":"2018-04-23","number":"31"},{"date_short":"2018-04-24","number":"44"},{"date_short":"2018-04-25","number":"55"},{"date_short":"2018-04-26","number":"49"},{"date_short":"2018-04-27","number":"51"},{"date_short":"2018-04-28","number":"33"},{"date_short":"2018-04-29","number":"36"},{"date_short":"2018-04-30","number":"62"},{"date_short":"2018-05-01","number":"45"},{"date_short":"2018-05-02","number":"65"},{"date_short":"2018-05-03","number":"79"},{"date_short":"2018-05-04","number":"66"},{"date_short":"2018-05-05","number":"29"},{"date_short":"2018-05-06","number":"28"},{"date_short":"2018-05-07","number":"29"},{"date_short":"2018-05-08","number":"40"},{"date_short":"2018-05-09","number":"42"},{"date_short":"2018-05-10","number":"46"},{"date_short":"2018-05-11","number":"48"},{"date_short":"2018-05-12","number":"32"},{"date_short":"2018-05-13","number":"30"},{"date_short":"2018-05-14","number":"21"},{"date_short":"2018-05-15","number":"22"},{"date_short":"2018-05-16","number":"24"},{"date_short":"2018-05-17","number":"27"},{"date_short":"2018-05-18","number":"23"},{"date_short":"2018-05-19","number":"45"},{"date_short":"2018-05-20","number":"13"},{"date_short":"2018-05-21","number":"27"},{"date_short":"2018-05-22","number":"31"},{"date_short":"2018-05-23","number":"26"},{"date_short":"2018-05-24","number":"27"},{"date_short":"2018-05-25","number":"22"},{"date_short":"2018-05-26","number":"28"},{"date_short":"2018-05-27","number":"29"},{"date_short":"2018-05-28","number":"34"},{"date_short":"2018-05-29","number":"32"},{"date_short":"2018-05-30","number":"35"},{"date_short":"2018-05-31","number":"37"},{"date_short":"2018-06-01","number":"41"},{"date_short":"2018-06-02","number":"30"},{"date_short":"2018-06-03","number":"17"},{"date_short":"2018-06-04","number":"42"},{"date_short":"2018-06-05","number":"49"},{"date_short":"2018-06-06","number":"50"}],"gentiloni":[{"date_short":"2018-02-01","number":"12"},{"date_short":"2018-02-02","number":"18"},{"date_short":"2018-02-03","number":"22"},{"date_short":"2018-02-04","number":"8"},{"date_short":"2018-02-05","number":"17"},{"date_short":"2018-02-06","number":"8"},{"date_short":"2018-02-07","number":"9"},{"date_short":"2018-02-08","number":"19"},{"date_short":"2018-02-09","number":"21"},{"date_short":"2018-02-10","number":"12"},{"date_short":"2018-02-11","number":"17"},{"date_short":"2018-02-12","number":"6"},{"date_short":"2018-02-13","number":"9"},{"date_short":"2018-02-14","number":"17"},{"date_short":"2018-02-15","number":"9"},{"date_short":"2018-02-16","number":"21"},{"date_short":"2018-02-17","number":"26"},{"date_short":"2018-02-18","number":"17"},{"date_short":"2018-02-19","number":"33"},{"date_short":"2018-02-20","number":"30"},{"date_short":"2018-02-21","number":"40"},{"date_short":"2018-02-22","number":"23"},{"date_short":"2018-02-23","number":"19"},{"date_short":"2018-02-24","number":"27"},{"date_short":"2018-02-25","number":"18"},{"date_short":"2018-02-26","number":"12"},{"date_short":"2018-02-27","number":"23"},{"date_short":"2018-02-28","number":"32"},{"date_short":"2018-03-01","number":"23"},{"date_short":"2018-03-02","number":"20"},{"date_short":"2018-03-03","number":"16"},{"date_short":"2018-03-04","number":"15"},{"date_short":"2018-03-05","number":"39"},{"date_short":"2018-03-06","number":"35"},{"date_short":"2018-03-07","number":"27"},{"date_short":"2018-03-08","number":"19"},{"date_short":"2018-03-09","number":"18"},{"date_short":"2018-03-10","number":"9"},{"date_short":"2018-03-11","number":"9"},{"date_short":"2018-03-12","number":"26"},{"date_short":"2018-03-13","number":"29"},{"date_short":"2018-03-14","number":"19"},{"date_short":"2018-03-15","number":"19"},{"date_short":"2018-03-16","number":"30"},{"date_short":"2018-03-17","number":"13"},{"date_short":"2018-03-18","number":"6"},{"date_short":"2018-03-19","number":"19"},{"date_short":"2018-03-20","number":"12"},{"date_short":"2018-03-21","number":"7"},{"date_short":"2018-03-22","number":"9"},{"date_short":"2018-03-23","number":"11"},{"date_short":"2018-03-24","number":"11"},{"date_short":"2018-03-25","number":"16"},{"date_short":"2018-03-26","number":"6"},{"date_short":"2018-03-27","number":"10"},{"date_short":"2018-03-28","number":"10"},{"date_short":"2018-03-29","number":"7"},{"date_short":"2018-03-30","number":"13"},{"date_short":"2018-03-31","number":"7"},{"date_short":"2018-04-01","number":"2"},{"date_short":"2018-04-02","number":"3"},{"date_short":"2018-04-03","number":"8"},{"date_short":"2018-04-04","number":"18"},{"date_short":"2018-04-05","number":"14"},{"date_short":"2018-04-06","number":"6"},{"date_short":"2018-04-07","number":"5"},{"date_short":"2018-04-08","number":"3"},{"date_short":"2018-04-09","number":"6"},{"date_short":"2018-04-10","number":"5"},{"date_short":"2018-04-11","number":"12"},{"date_short":"2018-04-12","number":"17"},{"date_short":"2018-04-13","number":"16"},{"date_short":"2018-04-14","number":"19"},{"date_short":"2018-04-15","number":"6"},{"date_short":"2018-04-16","number":"23"},{"date_short":"2018-04-17","number":"29"},{"date_short":"2018-04-18","number":"18"},{"date_short":"2018-04-19","number":"12"},{"date_short":"2018-04-20","number":"4"},{"date_short":"2018-04-21","number":"2"},{"date_short":"2018-04-22","number":"2"},{"date_short":"2018-04-23","number":"10"},{"date_short":"2018-04-24","number":"5"},{"date_short":"2018-04-25","number":"18"},{"date_short":"2018-04-26","number":"11"},{"date_short":"2018-04-27","number":"8"},{"date_short":"2018-04-28","number":"7"},{"date_short":"2018-04-29","number":"9"},{"date_short":"2018-04-30","number":"3"},{"date_short":"2018-05-01","number":"11"},{"date_short":"2018-05-02","number":"13"},{"date_short":"2018-05-03","number":"19"},{"date_short":"2018-05-04","number":"21"},{"date_short":"2018-05-05","number":"23"},{"date_short":"2018-05-06","number":"15"},{"date_short":"2018-05-07","number":"18"},{"date_short":"2018-05-08","number":"20"},{"date_short":"2018-05-09","number":"14"},{"date_short":"2018-05-10","number":"9"},{"date_short":"2018-05-11","number":"8"},{"date_short":"2018-05-12","number":"6"},{"date_short":"2018-05-13","number":"6"},{"date_short":"2018-05-14","number":"5"},{"date_short":"2018-05-15","number":"10"},{"date_short":"2018-05-16","number":"8"},{"date_short":"2018-05-17","number":"11"},{"date_short":"2018-05-18","number":"9"},{"date_short":"2018-05-19","number":"15"},{"date_short":"2018-05-20","number":"4"},{"date_short":"2018-05-21","number":"5"},{"date_short":"2018-05-22","number":"6"},{"date_short":"2018-05-23","number":"6"},{"date_short":"2018-05-24","number":"12"},{"date_short":"2018-05-25","number":"18"},{"date_short":"2018-05-26","number":"6"},{"date_short":"2018-05-27","number":"3"},{"date_short":"2018-05-28","number":"12"},{"date_short":"2018-05-29","number":"12"},{"date_short":"2018-05-30","number":"14"},{"date_short":"2018-05-31","number":"12"},{"date_short":"2018-06-01","number":"23"},{"date_short":"2018-06-02","number":"13"},{"date_short":"2018-06-03","number":"7"},{"date_short":"2018-06-04","number":"9"},{"date_short":"2018-06-05","number":"8"},{"date_short":"2018-06-06","number":"5"}],"grasso":[{"date_short":"2018-02-01","number":"6"},{"date_short":"2018-02-02","number":"15"},{"date_short":"2018-02-03","number":"22"},{"date_short":"2018-02-04","number":"12"},{"date_short":"2018-02-05","number":"14"},{"date_short":"2018-02-06","number":"5"},{"date_short":"2018-02-07","number":"7"},{"date_short":"2018-02-08","number":"9"},{"date_short":"2018-02-09","number":"8"},{"date_short":"2018-02-10","number":"11"},{"date_short":"2018-02-11","number":"10"},{"date_short":"2018-02-12","number":"7"},{"date_short":"2018-02-13","number":"8"},{"date_short":"2018-02-14","number":"10"},{"date_short":"2018-02-15","number":"18"},{"date_short":"2018-02-16","number":"8"},{"date_short":"2018-02-17","number":"12"},{"date_short":"2018-02-18","number":"8"},{"date_short":"2018-02-19","number":"19"},{"date_short":"2018-02-20","number":"12"},{"date_short":"2018-02-21","number":"14"},{"date_short":"2018-02-22","number":"8"},{"date_short":"2018-02-23","number":"12"},{"date_short":"2018-02-24","number":"15"},{"date_short":"2018-02-25","number":"16"},{"date_short":"2018-02-26","number":"11"},{"date_short":"2018-02-27","number":"9"},{"date_short":"2018-02-28","number":"14"},{"date_short":"2018-03-01","number":"13"},{"date_short":"2018-03-02","number":"15"},{"date_short":"2018-03-03","number":"10"},{"date_short":"2018-03-04","number":"13"},{"date_short":"2018-03-05","number":"52"},{"date_short":"2018-03-06","number":"16"},{"date_short":"2018-03-07","number":"7"},{"date_short":"2018-03-08","number":"5"},{"date_short":"2018-03-09","number":"3"},{"date_short":"2018-03-10","number":"6"},{"date_short":"2018-03-11","number":"9"},{"date_short":"2018-03-12","number":"2"},{"date_short":"2018-03-13","number":"6"},{"date_short":"2018-03-14","number":"8"},{"date_short":"2018-03-15","number":"18"},{"date_short":"2018-03-16","number":"15"},{"date_short":"2018-03-17","number":"10"},{"date_short":"2018-03-18","number":"3"},{"date_short":"2018-03-19","number":"6"},{"date_short":"2018-03-20","number":"3"},{"date_short":"2018-03-21","number":"7"},{"date_short":"2018-03-22","number":"10"},{"date_short":"2018-03-23","number":"8"},{"date_short":"2018-03-24","number":"7"},{"date_short":"2018-03-25","number":"6"},{"date_short":"2018-03-26","number":"4"},{"date_short":"2018-03-27","number":"7"},{"date_short":"2018-03-28","number":"4"},{"date_short":"2018-03-29","number":"1"},{"date_short":"2018-03-30","number":"2"},{"date_short":"2018-03-31","number":"2"},{"date_short":"2018-04-01","number":"1"},{"date_short":"2018-04-02","number":"6"},{"date_short":"2018-04-03","number":"4"},{"date_short":"2018-04-04","number":"7"},{"date_short":"2018-04-05","number":"6"},{"date_short":"2018-04-06","number":"1"},{"date_short":"2018-04-07","number":"2"},{"date_short":"2018-04-08","number":"3"},{"date_short":"2018-04-09","number":"6"},{"date_short":"2018-04-10","number":"5"},{"date_short":"2018-04-11","number":"1"},{"date_short":"2018-04-12","number":"9"},{"date_short":"2018-04-13","number":"5"},{"date_short":"2018-04-14","number":"4"},{"date_short":"2018-04-15","number":"3"},{"date_short":"2018-04-18","number":"4"},{"date_short":"2018-04-20","number":"1"},{"date_short":"2018-04-22","number":"3"},{"date_short":"2018-04-23","number":"1"},{"date_short":"2018-04-24","number":"1"},{"date_short":"2018-04-26","number":"2"},{"date_short":"2018-04-27","number":"3"},{"date_short":"2018-04-28","number":"2"},{"date_short":"2018-04-29","number":"2"},{"date_short":"2018-04-30","number":"1"},{"date_short":"2018-05-01","number":"1"},{"date_short":"2018-05-02","number":"3"},{"date_short":"2018-05-03","number":"3"},{"date_short":"2018-05-04","number":"3"},{"date_short":"2018-05-05","number":"4"},{"date_short":"2018-05-07","number":"10"},{"date_short":"2018-05-08","number":"1"},{"date_short":"2018-05-09","number":"4"},{"date_short":"2018-05-10","number":"4"},{"date_short":"2018-05-11","number":"1"},{"date_short":"2018-05-12","number":"1"},{"date_short":"2018-05-14","number":"1"},{"date_short":"2018-05-15","number":"1"},{"date_short":"2018-05-16","number":"2"},{"date_short":"2018-05-18","number":"2"},{"date_short":"2018-05-20","number":"2"},{"date_short":"2018-05-21","number":"2"},{"date_short":"2018-05-22","number":"4"},{"date_short":"2018-05-23","number":"5"},{"date_short":"2018-05-24","number":"6"},{"date_short":"2018-05-25","number":"5"},{"date_short":"2018-05-26","number":"3"},{"date_short":"2018-05-27","number":"3"},{"date_short":"2018-05-28","number":"2"},{"date_short":"2018-05-29","number":"1"},{"date_short":"2018-05-30","number":"3"},{"date_short":"2018-05-31","number":"1"},{"date_short":"2018-06-01","number":"2"},{"date_short":"2018-06-02","number":"4"},{"date_short":"2018-06-03","number":"3"},{"date_short":"2018-06-04","number":"4"},{"date_short":"2018-06-05","number":"2"}],"carofalo":[{"date_short":"2018-02-17","number":"1"},{"date_short":"2018-02-21","number":"2"},{"date_short":"2018-02-23","number":"1"},{"date_short":"2018-03-05","number":"6"},{"date_short":"2018-03-18","number":"1"},{"date_short":"2018-03-28","number":"1"},{"date_short":"2018-04-02","number":"1"},{"date_short":"2018-04-03","number":"1"},{"date_short":"2018-05-17","number":"1"}]},"matrix":{"pre":{"keywords":[{"name":"S. Mattarella","keyword":"Mattarella","slug":"mattarella"},{"name":"S. Di Stefano","keyword":"Di Stefano","slug":"distefano"},{"name":"G. Meloni","keyword":"Meloni","slug":"meloni"},{"name":"M. Salvini","keyword":"Salvini","slug":"salvini"},{"name":"S. Berlusconi","keyword":"Berlusconi","slug":"berlusconi"},{"name":"L. Di Maio","keyword":"Di Maio","slug":"dimaio"},{"name":"M. Renzi","keyword":"Renzi","slug":"renzi"},{"name":"M. Martina","keyword":"Martina","slug":"martina"},{"name":"E. Bonino","keyword":"Bonino","slug":"bonino"},{"name":"P. Gentiloni","keyword":"Gentiloni","slug":"gentiloni"},{"name":"P. Grasso","keyword":"Grasso","slug":"grasso"},{"name":"L. Boldrini","keyword":"Boldrini","slug":"boldrini"},{"name":"V. Carofalo","keyword":"Carofalo","slug":"carofalo"}],"matrix":{"mattarella":{"mattarella":"114","distefano":"1","meloni":"6","salvini":"11","berlusconi":"15","dimaio":"25","renzi":"21","martina":"0","bonino":"1","gentiloni":"31","grasso":"12","boldrini":"4","carofalo":"0"},"distefano":{"distefano":"93","meloni":"3","salvini":"7","berlusconi":"1","dimaio":"0","renzi":"2","martina":"0","bonino":"0","gentiloni":"0","grasso":"0","boldrini":"2","carofalo":"0","mattarella":"1"},"meloni":{"meloni":"506","salvini":"89","berlusconi":"79","dimaio":"9","renzi":"20","martina":"0","bonino":"8","gentiloni":"7","grasso":"2","boldrini":"10","carofalo":"0","distefano":"3","mattarella":"6"},"salvini":{"salvini":"1173","berlusconi":"199","dimaio":"47","renzi":"83","martina":"0","bonino":"6","gentiloni":"17","grasso":"23","boldrini":"88","carofalo":"0","meloni":"89","distefano":"7","mattarella":"11"},"berlusconi":{"berlusconi":"1386","dimaio":"85","renzi":"173","martina":"2","bonino":"10","gentiloni":"43","grasso":"32","boldrini":"7","carofalo":"0","salvini":"199","meloni":"79","distefano":"1","mattarella":"15"},"dimaio":{"dimaio":"1287","renzi":"139","martina":"0","bonino":"2","gentiloni":"21","grasso":"17","boldrini":"5","carofalo":"0","berlusconi":"85","salvini":"47","meloni":"9","distefano":"0","mattarella":"25"},"renzi":{"renzi":"1414","martina":"4","bonino":"46","gentiloni":"135","grasso":"69","boldrini":"11","carofalo":"0","dimaio":"139","berlusconi":"173","salvini":"83","meloni":"20","distefano":"2","mattarella":"21"},"martina":{"martina":"13","bonino":"1","gentiloni":"1","grasso":"0","boldrini":"2","carofalo":"0","renzi":"4","dimaio":"0","berlusconi":"2","salvini":"0","meloni":"0","distefano":"0","mattarella":"0"},"bonino":{"bonino":"249","gentiloni":"31","grasso":"3","boldrini":"9","carofalo":"0","martina":"1","renzi":"46","dimaio":"2","berlusconi":"10","salvini":"6","meloni":"8","distefano":"0","mattarella":"1"},"gentiloni":{"gentiloni":"645","grasso":"11","boldrini":"7","carofalo":"0","bonino":"31","martina":"1","renzi":"135","dimaio":"21","berlusconi":"43","salvini":"17","meloni":"7","distefano":"0","mattarella":"31"},"grasso":{"grasso":"351","boldrini":"30","carofalo":"0","gentiloni":"11","bonino":"3","martina":"0","renzi":"69","dimaio":"17","berlusconi":"32","salvini":"23","meloni":"2","distefano":"0","mattarella":"12"},"boldrini":{"boldrini":"458","carofalo":"0","grasso":"30","gentiloni":"7","bonino":"9","martina":"2","renzi":"11","dimaio":"5","berlusconi":"7","salvini":"88","meloni":"10","distefano":"2","mattarella":"4"},"carofalo":{"carofalo":"5","boldrini":"0","grasso":"0","gentiloni":"0","bonino":"0","martina":"0","renzi":"0","dimaio":"0","berlusconi":"0","salvini":"0","meloni":"0","distefano":"0","mattarella":"0"}},"max":"199","min":null},"post":{"keywords":[{"name":"S. Mattarella","keyword":"Mattarella","slug":"mattarella"},{"name":"S. Di Stefano","keyword":"Di Stefano","slug":"distefano"},{"name":"G. Meloni","keyword":"Meloni","slug":"meloni"},{"name":"M. Salvini","keyword":"Salvini","slug":"salvini"},{"name":"S. Berlusconi","keyword":"Berlusconi","slug":"berlusconi"},{"name":"L. Di Maio","keyword":"Di Maio","slug":"dimaio"},{"name":"M. Renzi","keyword":"Renzi","slug":"renzi"},{"name":"M. Martina","keyword":"Martina","slug":"martina"},{"name":"E. Bonino","keyword":"Bonino","slug":"bonino"},{"name":"P. Gentiloni","keyword":"Gentiloni","slug":"gentiloni"},{"name":"P. Grasso","keyword":"Grasso","slug":"grasso"},{"name":"L. Boldrini","keyword":"Boldrini","slug":"boldrini"},{"name":"V. Carofalo","keyword":"Carofalo","slug":"carofalo"}],"matrix":{"mattarella":{"mattarella":"1110","distefano":"5","meloni":"63","salvini":"351","berlusconi":"133","dimaio":"351","renzi":"53","martina":"28","bonino":"2","gentiloni":"35","grasso":"1","boldrini":"3","carofalo":"0"},"distefano":{"distefano":"66","meloni":"0","salvini":"4","berlusconi":"1","dimaio":"2","renzi":"1","martina":"0","bonino":"0","gentiloni":"0","grasso":"0","boldrini":"0","carofalo":"1","mattarella":"5"},"meloni":{"meloni":"436","salvini":"161","berlusconi":"76","dimaio":"78","renzi":"10","martina":"2","bonino":"1","gentiloni":"5","grasso":"2","boldrini":"0","carofalo":"0","distefano":"0","mattarella":"63"},"salvini":{"salvini":"3849","berlusconi":"684","dimaio":"1524","renzi":"167","martina":"34","bonino":"7","gentiloni":"40","grasso":"11","boldrini":"18","carofalo":"0","meloni":"161","distefano":"4","mattarella":"351"},"berlusconi":{"berlusconi":"1967","dimaio":"378","renzi":"113","martina":"16","bonino":"1","gentiloni":"14","grasso":"2","boldrini":"1","carofalo":"0","salvini":"684","meloni":"76","distefano":"1","mattarella":"133"},"dimaio":{"dimaio":"3519","renzi":"212","martina":"53","bonino":"4","gentiloni":"23","grasso":"12","boldrini":"8","carofalo":"0","berlusconi":"378","salvini":"1524","meloni":"78","distefano":"2","mattarella":"351"},"renzi":{"renzi":"1515","martina":"144","bonino":"3","gentiloni":"59","grasso":"8","boldrini":"3","carofalo":"0","dimaio":"212","berlusconi":"113","salvini":"167","meloni":"10","distefano":"1","mattarella":"53"},"martina":{"martina":"390","bonino":"0","gentiloni":"17","grasso":"5","boldrini":"0","carofalo":"0","renzi":"144","dimaio":"53","berlusconi":"16","salvini":"34","meloni":"2","distefano":"0","mattarella":"28"},"bonino":{"bonino":"59","gentiloni":"2","grasso":"2","boldrini":"0","carofalo":"0","martina":"0","renzi":"3","dimaio":"4","berlusconi":"1","salvini":"7","meloni":"1","distefano":"0","mattarella":"2"},"gentiloni":{"gentiloni":"445","grasso":"1","boldrini":"1","carofalo":"0","bonino":"2","martina":"17","renzi":"59","dimaio":"23","berlusconi":"14","salvini":"40","meloni":"5","distefano":"0","mattarella":"35"},"grasso":{"grasso":"127","boldrini":"32","carofalo":"0","gentiloni":"1","bonino":"2","martina":"5","renzi":"8","dimaio":"12","berlusconi":"2","salvini":"11","meloni":"2","distefano":"0","mattarella":"1"},"boldrini":{"boldrini":"177","carofalo":"0","grasso":"32","gentiloni":"1","bonino":"0","martina":"0","renzi":"3","dimaio":"8","berlusconi":"1","salvini":"18","meloni":"0","distefano":"0","mattarella":"3"},"carofalo":{"carofalo":"3","boldrini":"0","grasso":"0","gentiloni":"0","bonino":"0","martina":"0","renzi":"0","dimaio":"0","berlusconi":"0","salvini":"0","meloni":"0","distefano":"1","mattarella":"0"}},"max":"1524","min":null}},"vice":{"pre":{"keywords":[{"name":"Matteo Salvini","keyword":"salvini","slug":"salvini"},{"name":"Luigi Di Maio","keyword":"di maio","slug":"di maio"}],"matrix":{"salvini":{"salvini":"1173","di maio":"47"},"di maio":{"di maio":"1287","salvini":"47"}},"max":"47","min":null},"post":{"keywords":[{"name":"Matteo Salvini","keyword":"salvini","slug":"salvini"},{"name":"Luigi Di Maio","keyword":"di maio","slug":"di maio"}],"matrix":{"salvini":{"salvini":"3849","di maio":"1524"},"di maio":{"di maio":"3519","salvini":"1524"}},"max":"1524","min":null},"global":{"keywords":[{"name":"Matteo Salvini","keyword":"salvini","slug":"salvini"},{"name":"Luigi Di Maio","keyword":"di maio","slug":"di maio"}],"matrix":{"salvini":{"salvini":"5022","di maio":"1571"},"di maio":{"di maio":"4806","salvini":"1571"}},"max":"1571","min":null}},"history":{"activity":{"destra":[{"date_published":"2018-02-01","activity":"13","popularity":"1570.5","timestamp":1517439600},{"date_published":"2018-02-02","activity":"9","popularity":"2841.5","timestamp":1517526000},{"date_published":"2018-02-03","activity":"18","popularity":"31447.5","timestamp":1517612400},{"date_published":"2018-02-04","activity":"8","popularity":"359","timestamp":1517698800},{"date_published":"2018-02-05","activity":"16","popularity":"99.5","timestamp":1517785200},{"date_published":"2018-02-06","activity":"16","popularity":"14521568.75","timestamp":1517871600},{"date_published":"2018-02-07","activity":"8","popularity":"16290022.75","timestamp":1517958000},{"date_published":"2018-02-08","activity":"20","popularity":"12210458.5","timestamp":1518044400},{"date_published":"2018-02-09","activity":"25","popularity":"29907660.75","timestamp":1518130800},{"date_published":"2018-02-10","activity":"28","popularity":"30950672.5","timestamp":1518217200},{"date_published":"2018-02-11","activity":"6","popularity":"8590894.25","timestamp":1518303600},{"date_published":"2018-02-12","activity":"9","popularity":"37280437.75","timestamp":1518390000},{"date_published":"2018-02-13","activity":"8","popularity":"4755148.5","timestamp":1518476400},{"date_published":"2018-02-14","activity":"6","popularity":"1226790.5","timestamp":1518562800},{"date_published":"2018-02-15","activity":"15","popularity":"11788313","timestamp":1518649200},{"date_published":"2018-02-16","activity":"26","popularity":"30289712","timestamp":1518735600},{"date_published":"2018-02-17","activity":"14","popularity":"21760515.25","timestamp":1518822000},{"date_published":"2018-02-18","activity":"19","popularity":"54362278","timestamp":1518908400},{"date_published":"2018-02-19","activity":"16","popularity":"11284612.5","timestamp":1518994800},{"date_published":"2018-02-20","activity":"21","popularity":"56013448","timestamp":1519081200},{"date_published":"2018-02-21","activity":"75","popularity":"192954153.75","timestamp":1519167600},{"date_published":"2018-02-22","activity":"56","popularity":"226252608","timestamp":1519254000},{"date_published":"2018-02-23","activity":"30","popularity":"86941936.5","timestamp":1519340400},{"date_published":"2018-02-24","activity":"33","popularity":"117603599.75","timestamp":1519426800},{"date_published":"2018-02-25","activity":"20","popularity":"28049487","timestamp":1519513200},{"date_published":"2018-02-26","activity":"26","popularity":"18603230.5","timestamp":1519599600},{"date_published":"2018-02-27","activity":"23","popularity":"30565866.75","timestamp":1519686000},{"date_published":"2018-02-28","activity":"17","popularity":"20268643","timestamp":1519772400},{"date_published":"2018-03-01","activity":"36","popularity":"38643761","timestamp":1519858800},{"date_published":"2018-03-02","activity":"31","popularity":"12185062.5","timestamp":1519945200},{"date_published":"2018-03-03","activity":"9","popularity":"2047005.25","timestamp":1520031600},{"date_published":"2018-03-04","activity":"6","popularity":"3609091","timestamp":1520118000},{"date_published":"2018-03-05","activity":"26","popularity":"379134029","timestamp":1520204400},{"date_published":"2018-03-06","activity":"7","popularity":"349145.75","timestamp":1520290800},{"date_published":"2018-03-07","activity":"23","popularity":"16335754","timestamp":1520377200},{"date_published":"2018-03-08","activity":"11","popularity":"2135236.25","timestamp":1520463600},{"date_published":"2018-03-09","activity":"1","popularity":"549955.5","timestamp":1520550000},{"date_published":"2018-03-10","activity":"3","popularity":"4643919.75","timestamp":1520636400},{"date_published":"2018-03-11","activity":"1","popularity":"1454.25","timestamp":1520722800},{"date_published":"2018-03-12","activity":"1","popularity":"3749103.5","timestamp":1520809200},{"date_published":"2018-03-13","activity":"5","popularity":"811691.5","timestamp":1520895600},{"date_published":"2018-03-14","activity":"2","popularity":"410088.25","timestamp":1520982000},{"date_published":"2018-03-15","activity":"2","popularity":"2361649","timestamp":1521068400},{"date_published":"2018-03-16","activity":"2","popularity":"27267511.5","timestamp":1521154800},{"date_published":"2018-03-17","activity":"6","popularity":"79562.5","timestamp":1521241200},{"date_published":"2018-03-18","activity":"4","popularity":"6332","timestamp":1521327600},{"date_published":"2018-03-19","activity":"9","popularity":"8106279.5","timestamp":1521414000},{"date_published":"2018-03-20","activity":"4","popularity":"346478.75","timestamp":1521500400},{"date_published":"2018-03-21","activity":"6","popularity":"10981501.75","timestamp":1521586800},{"date_published":"2018-03-22","activity":"3","popularity":"388274","timestamp":1521673200},{"date_published":"2018-03-23","activity":"3","popularity":"2492485.5","timestamp":1521759600},{"date_published":"2018-03-24","activity":"2","popularity":"39650.75","timestamp":1521846000},{"date_published":"2018-03-25","activity":"1","popularity":"85031.75","timestamp":1521932400},{"date_published":"2018-03-26","activity":"2","popularity":"57753.25","timestamp":1522015200},{"date_published":"2018-03-27","activity":"1","popularity":"0","timestamp":1522101600},{"date_published":"2018-03-28","activity":"2","popularity":"456024","timestamp":1522188000},{"date_published":"2018-03-29","activity":"2","popularity":"332828.5","timestamp":1522274400},{"date_published":"2018-04-05","activity":"10","popularity":"6963000","timestamp":1522879200},{"date_published":"2018-04-06","activity":"3","popularity":"332191.5","timestamp":1522965600},{"date_published":"2018-04-07","activity":"6","popularity":"20088794.25","timestamp":1523052000},{"date_published":"2018-04-09","activity":"4","popularity":"15555615.5","timestamp":1523224800},{"date_published":"2018-04-10","activity":"2","popularity":"8936","timestamp":1523311200},{"date_published":"2018-04-11","activity":"1","popularity":"233.5","timestamp":1523397600},{"date_published":"2018-04-13","activity":"3","popularity":"364114","timestamp":1523570400},{"date_published":"2018-04-14","activity":"8","popularity":"5783228","timestamp":1523656800},{"date_published":"2018-04-15","activity":"2","popularity":"12405958.5","timestamp":1523743200},{"date_published":"2018-04-16","activity":"2","popularity":"185681.75","timestamp":1523829600},{"date_published":"2018-04-17","activity":"7","popularity":"4732857.5","timestamp":1523916000},{"date_published":"2018-04-18","activity":"3","popularity":"148367","timestamp":1524002400},{"date_published":"2018-04-19","activity":"2","popularity":"3572486","timestamp":1524088800},{"date_published":"2018-04-20","activity":"1","popularity":"4994.5","timestamp":1524175200},{"date_published":"2018-04-21","activity":"1","popularity":"256248.25","timestamp":1524261600},{"date_published":"2018-04-22","activity":"4","popularity":"22830796.25","timestamp":1524348000},{"date_published":"2018-04-23","activity":"2","popularity":"260628","timestamp":1524434400},{"date_published":"2018-04-24","activity":"1","popularity":"144236.25","timestamp":1524520800},{"date_published":"2018-04-25","activity":"5","popularity":"39463.5","timestamp":1524607200},{"date_published":"2018-04-26","activity":"5","popularity":"451210.75","timestamp":1524693600},{"date_published":"2018-04-27","activity":"3","popularity":"766157.5","timestamp":1524780000},{"date_published":"2018-04-28","activity":"1","popularity":"589.25","timestamp":1524866400},{"date_published":"2018-04-30","activity":"2","popularity":"439186.75","timestamp":1525039200},{"date_published":"2018-05-01","activity":"1","popularity":"420430.5","timestamp":1525125600},{"date_published":"2018-05-02","activity":"1","popularity":"3148260.25","timestamp":1525212000},{"date_published":"2018-05-03","activity":"4","popularity":"4857033.75","timestamp":1525298400},{"date_published":"2018-05-04","activity":"5","popularity":"2192555.5","timestamp":1525384800},{"date_published":"2018-05-05","activity":"1","popularity":"4770.5","timestamp":1525471200},{"date_published":"2018-05-06","activity":"1","popularity":"204.5","timestamp":1525557600},{"date_published":"2018-05-07","activity":"6","popularity":"668156.5","timestamp":1525644000},{"date_published":"2018-05-08","activity":"4","popularity":"352682.5","timestamp":1525730400},{"date_published":"2018-05-09","activity":"1","popularity":"618","timestamp":1525816800},{"date_published":"2018-05-10","activity":"14","popularity":"25624294.75","timestamp":1525903200},{"date_published":"2018-05-11","activity":"3","popularity":"106658.25","timestamp":1525989600},{"date_published":"2018-05-12","activity":"4","popularity":"488525.75","timestamp":1526076000},{"date_published":"2018-05-13","activity":"4","popularity":"798927.5","timestamp":1526162400},{"date_published":"2018-05-14","activity":"1","popularity":"0","timestamp":1526248800},{"date_published":"2018-05-15","activity":"3","popularity":"36250.25","timestamp":1526335200},{"date_published":"2018-05-16","activity":"7","popularity":"20253118.5","timestamp":1526421600},{"date_published":"2018-05-17","activity":"4","popularity":"3947404.25","timestamp":1526508000},{"date_published":"2018-05-18","activity":"5","popularity":"864858","timestamp":1526594400},{"date_published":"2018-05-19","activity":"4","popularity":"4757293.75","timestamp":1526680800},{"date_published":"2018-05-20","activity":"2","popularity":"10703","timestamp":1526767200},{"date_published":"2018-05-21","activity":"3","popularity":"154084.25","timestamp":1526853600},{"date_published":"2018-05-22","activity":"1","popularity":"4371478","timestamp":1526940000},{"date_published":"2018-05-23","activity":"5","popularity":"547029.25","timestamp":1527026400},{"date_published":"2018-05-25","activity":"7","popularity":"66105628.25","timestamp":1527199200},{"date_published":"2018-05-26","activity":"2","popularity":"37111.75","timestamp":1527285600},{"date_published":"2018-05-27","activity":"2","popularity":"21583.25","timestamp":1527372000},{"date_published":"2018-05-28","activity":"8","popularity":"26637508.25","timestamp":1527458400},{"date_published":"2018-05-29","activity":"8","popularity":"2522456.5","timestamp":1527544800},{"date_published":"2018-05-30","activity":"6","popularity":"497711","timestamp":1527631200},{"date_published":"2018-05-31","activity":"3","popularity":"350527.25","timestamp":1527717600},{"date_published":"2018-06-01","activity":"2","popularity":"34145","timestamp":1527804000},{"date_published":"2018-06-02","activity":"1","popularity":"178","timestamp":1527890400},{"date_published":"2018-06-03","activity":"1","popularity":"110574.5","timestamp":1527976800},{"date_published":"2018-06-04","activity":"2","popularity":"14799","timestamp":1528063200},{"date_published":"2018-06-05","activity":"2","popularity":"181655.25","timestamp":1528149600},{"date_published":"2018-06-06","activity":"3","popularity":"2832","timestamp":1528236000}],"centro-destra":[{"date_published":"2018-02-01","activity":"91","popularity":"1938","timestamp":1517439600},{"date_published":"2018-02-02","activity":"76","popularity":"12461.5","timestamp":1517526000},{"date_published":"2018-02-03","activity":"84","popularity":"21340.5","timestamp":1517612400},{"date_published":"2018-02-04","activity":"62","popularity":"4403","timestamp":1517698800},{"date_published":"2018-02-05","activity":"99","popularity":"129964","timestamp":1517785200},{"date_published":"2018-02-06","activity":"93","popularity":"40384075.75","timestamp":1517871600},{"date_published":"2018-02-07","activity":"117","popularity":"74257811.75","timestamp":1517958000},{"date_published":"2018-02-08","activity":"89","popularity":"70643779.5","timestamp":1518044400},{"date_published":"2018-02-09","activity":"104","popularity":"166530408.25","timestamp":1518130800},{"date_published":"2018-02-10","activity":"82","popularity":"242352143.75","timestamp":1518217200},{"date_published":"2018-02-11","activity":"66","popularity":"110542359.5","timestamp":1518303600},{"date_published":"2018-02-12","activity":"88","popularity":"237065303.5","timestamp":1518390000},{"date_published":"2018-02-13","activity":"96","popularity":"120166929","timestamp":1518476400},{"date_published":"2018-02-14","activity":"79","popularity":"97010528","timestamp":1518562800},{"date_published":"2018-02-15","activity":"84","popularity":"251514644.5","timestamp":1518649200},{"date_published":"2018-02-16","activity":"66","popularity":"232673395.75","timestamp":1518735600},{"date_published":"2018-02-17","activity":"71","popularity":"732578921.5","timestamp":1518822000},{"date_published":"2018-02-18","activity":"67","popularity":"115529592.75","timestamp":1518908400},{"date_published":"2018-02-19","activity":"66","popularity":"110760934.5","timestamp":1518994800},{"date_published":"2018-02-20","activity":"98","popularity":"167803568.25","timestamp":1519081200},{"date_published":"2018-02-21","activity":"80","popularity":"59352966.75","timestamp":1519167600},{"date_published":"2018-02-22","activity":"85","popularity":"100737697.25","timestamp":1519254000},{"date_published":"2018-02-23","activity":"59","popularity":"405043341.5","timestamp":1519340400},{"date_published":"2018-02-24","activity":"70","popularity":"157273622","timestamp":1519426800},{"date_published":"2018-02-25","activity":"53","popularity":"75059429.75","timestamp":1519513200},{"date_published":"2018-02-26","activity":"77","popularity":"219270899.75","timestamp":1519599600},{"date_published":"2018-02-27","activity":"68","popularity":"339877910","timestamp":1519686000},{"date_published":"2018-02-28","activity":"100","popularity":"173946708.25","timestamp":1519772400},{"date_published":"2018-03-01","activity":"69","popularity":"123755642","timestamp":1519858800},{"date_published":"2018-03-02","activity":"73","popularity":"112088496.25","timestamp":1519945200},{"date_published":"2018-03-03","activity":"54","popularity":"69885212.25","timestamp":1520031600},{"date_published":"2018-03-04","activity":"50","popularity":"31831095.25","timestamp":1520118000},{"date_published":"2018-03-05","activity":"173","popularity":"2495582714.75","timestamp":1520204400},{"date_published":"2018-03-06","activity":"148","popularity":"222222299.5","timestamp":1520290800},{"date_published":"2018-03-07","activity":"122","popularity":"244341375","timestamp":1520377200},{"date_published":"2018-03-08","activity":"66","popularity":"130965477.75","timestamp":1520463600},{"date_published":"2018-03-09","activity":"100","popularity":"240455692","timestamp":1520550000},{"date_published":"2018-03-10","activity":"43","popularity":"49123665","timestamp":1520636400},{"date_published":"2018-03-11","activity":"77","popularity":"82651306","timestamp":1520722800},{"date_published":"2018-03-12","activity":"76","popularity":"171170958","timestamp":1520809200},{"date_published":"2018-03-13","activity":"92","popularity":"164961836.5","timestamp":1520895600},{"date_published":"2018-03-14","activity":"93","popularity":"108172439.5","timestamp":1520982000},{"date_published":"2018-03-15","activity":"96","popularity":"92580323.75","timestamp":1521068400},{"date_published":"2018-03-16","activity":"71","popularity":"121139388.5","timestamp":1521154800},{"date_published":"2018-03-17","activity":"73","popularity":"95254089.75","timestamp":1521241200},{"date_published":"2018-03-18","activity":"65","popularity":"68330930.75","timestamp":1521327600},{"date_published":"2018-03-19","activity":"76","popularity":"254814628.5","timestamp":1521414000},{"date_published":"2018-03-20","activity":"58","popularity":"81246410.25","timestamp":1521500400},{"date_published":"2018-03-21","activity":"79","popularity":"185158127","timestamp":1521586800},{"date_published":"2018-03-22","activity":"71","popularity":"152896322.25","timestamp":1521673200},{"date_published":"2018-03-23","activity":"97","popularity":"1720739537","timestamp":1521759600},{"date_published":"2018-03-24","activity":"89","popularity":"408931427.5","timestamp":1521846000},{"date_published":"2018-03-25","activity":"76","popularity":"100435282","timestamp":1521932400},{"date_published":"2018-03-26","activity":"130","popularity":"275146941","timestamp":1522015200},{"date_published":"2018-03-27","activity":"105","popularity":"203153635.25","timestamp":1522101600},{"date_published":"2018-03-28","activity":"83","popularity":"149883145.75","timestamp":1522188000},{"date_published":"2018-03-29","activity":"93","popularity":"733290668","timestamp":1522274400},{"date_published":"2018-03-30","activity":"106","popularity":"228894822.5","timestamp":1522360800},{"date_published":"2018-03-31","activity":"58","popularity":"43934819.25","timestamp":1522447200},{"date_published":"2018-04-01","activity":"22","popularity":"29233068.5","timestamp":1522533600},{"date_published":"2018-04-02","activity":"34","popularity":"88299106.75","timestamp":1522620000},{"date_published":"2018-04-03","activity":"66","popularity":"157473401.25","timestamp":1522706400},{"date_published":"2018-04-04","activity":"101","popularity":"243925183","timestamp":1522792800},{"date_published":"2018-04-05","activity":"94","popularity":"875122826.5","timestamp":1522879200},{"date_published":"2018-04-06","activity":"53","popularity":"162046876.75","timestamp":1522965600},{"date_published":"2018-04-07","activity":"50","popularity":"78231267.5","timestamp":1523052000},{"date_published":"2018-04-08","activity":"67","popularity":"219841272","timestamp":1523138400},{"date_published":"2018-04-09","activity":"72","popularity":"39514409.25","timestamp":1523224800},{"date_published":"2018-04-10","activity":"72","popularity":"82601192.25","timestamp":1523311200},{"date_published":"2018-04-11","activity":"100","popularity":"90413650","timestamp":1523397600},{"date_published":"2018-04-12","activity":"96","popularity":"96274821.5","timestamp":1523484000},{"date_published":"2018-04-13","activity":"100","popularity":"177880837.75","timestamp":1523570400},{"date_published":"2018-04-14","activity":"61","popularity":"115393150.75","timestamp":1523656800},{"date_published":"2018-04-15","activity":"69","popularity":"50121210.5","timestamp":1523743200},{"date_published":"2018-04-16","activity":"78","popularity":"78558732.5","timestamp":1523829600},{"date_published":"2018-04-17","activity":"86","popularity":"139714548.25","timestamp":1523916000},{"date_published":"2018-04-18","activity":"86","popularity":"351563849","timestamp":1524002400},{"date_published":"2018-04-19","activity":"102","popularity":"716227718","timestamp":1524088800},{"date_published":"2018-04-20","activity":"117","popularity":"209999577","timestamp":1524175200},{"date_published":"2018-04-21","activity":"86","popularity":"181952937.5","timestamp":1524261600},{"date_published":"2018-04-22","activity":"50","popularity":"89768356.5","timestamp":1524348000},{"date_published":"2018-04-23","activity":"84","popularity":"1163879732","timestamp":1524434400},{"date_published":"2018-04-24","activity":"68","popularity":"107048663","timestamp":1524520800},{"date_published":"2018-04-25","activity":"61","popularity":"67153475.75","timestamp":1524607200},{"date_published":"2018-04-26","activity":"67","popularity":"104286370.5","timestamp":1524693600},{"date_published":"2018-04-27","activity":"60","popularity":"29030007.25","timestamp":1524780000},{"date_published":"2018-04-28","activity":"51","popularity":"141359927","timestamp":1524866400},{"date_published":"2018-04-29","activity":"34","popularity":"32850907.75","timestamp":1524952800},{"date_published":"2018-04-30","activity":"71","popularity":"147369810.25","timestamp":1525039200},{"date_published":"2018-05-01","activity":"42","popularity":"124175067","timestamp":1525125600},{"date_published":"2018-05-02","activity":"66","popularity":"114276072","timestamp":1525212000},{"date_published":"2018-05-03","activity":"62","popularity":"114126218","timestamp":1525298400},{"date_published":"2018-05-04","activity":"71","popularity":"143654399.5","timestamp":1525384800},{"date_published":"2018-05-05","activity":"60","popularity":"88380184.25","timestamp":1525471200},{"date_published":"2018-05-06","activity":"65","popularity":"209057352","timestamp":1525557600},{"date_published":"2018-05-07","activity":"83","popularity":"325614044.75","timestamp":1525644000},{"date_published":"2018-05-08","activity":"80","popularity":"436410012.25","timestamp":1525730400},{"date_published":"2018-05-09","activity":"104","popularity":"342164421.75","timestamp":1525816800},{"date_published":"2018-05-10","activity":"120","popularity":"357493779.5","timestamp":1525903200},{"date_published":"2018-05-11","activity":"122","popularity":"267210077.25","timestamp":1525989600},{"date_published":"2018-05-12","activity":"140","popularity":"210737047","timestamp":1526076000},{"date_published":"2018-05-13","activity":"81","popularity":"160683679.75","timestamp":1526162400},{"date_published":"2018-05-14","activity":"101","popularity":"399047969.5","timestamp":1526248800},{"date_published":"2018-05-15","activity":"94","popularity":"542436188","timestamp":1526335200},{"date_published":"2018-05-16","activity":"121","popularity":"416145240.25","timestamp":1526421600},{"date_published":"2018-05-17","activity":"124","popularity":"374851184.75","timestamp":1526508000},{"date_published":"2018-05-18","activity":"119","popularity":"675437019","timestamp":1526594400},{"date_published":"2018-05-19","activity":"96","popularity":"108977597","timestamp":1526680800},{"date_published":"2018-05-20","activity":"72","popularity":"312472008.75","timestamp":1526767200},{"date_published":"2018-05-21","activity":"108","popularity":"612296945.75","timestamp":1526853600},{"date_published":"2018-05-22","activity":"74","popularity":"145399349","timestamp":1526940000},{"date_published":"2018-05-23","activity":"73","popularity":"288132545","timestamp":1527026400},{"date_published":"2018-05-24","activity":"93","popularity":"1742880311.75","timestamp":1527112800},{"date_published":"2018-05-25","activity":"62","popularity":"124552100.5","timestamp":1527199200},{"date_published":"2018-05-26","activity":"74","popularity":"105973451.25","timestamp":1527285600},{"date_published":"2018-05-27","activity":"62","popularity":"88052875.5","timestamp":1527372000},{"date_published":"2018-05-28","activity":"101","popularity":"357214746","timestamp":1527458400},{"date_published":"2018-05-29","activity":"106","popularity":"179147687.5","timestamp":1527544800},{"date_published":"2018-05-30","activity":"103","popularity":"122098063.5","timestamp":1527631200},{"date_published":"2018-05-31","activity":"106","popularity":"113102101","timestamp":1527717600},{"date_published":"2018-06-01","activity":"136","popularity":"139831066.5","timestamp":1527804000},{"date_published":"2018-06-02","activity":"115","popularity":"209444307.75","timestamp":1527890400},{"date_published":"2018-06-03","activity":"66","popularity":"285256087.25","timestamp":1527976800},{"date_published":"2018-06-04","activity":"108","popularity":"176393380.75","timestamp":1528063200},{"date_published":"2018-06-05","activity":"101","popularity":"102938040.75","timestamp":1528149600},{"date_published":"2018-06-06","activity":"78","popularity":"353898765","timestamp":1528236000}],"m5s":[{"date_published":"2018-02-01","activity":"50","popularity":"2783","timestamp":1517439600},{"date_published":"2018-02-02","activity":"93","popularity":"19451","timestamp":1517526000},{"date_published":"2018-02-03","activity":"56","popularity":"9018","timestamp":1517612400},{"date_published":"2018-02-04","activity":"52","popularity":"852","timestamp":1517698800},{"date_published":"2018-02-05","activity":"45","popularity":"2150","timestamp":1517785200},{"date_published":"2018-02-06","activity":"72","popularity":"35738136","timestamp":1517871600},{"date_published":"2018-02-07","activity":"60","popularity":"65231071","timestamp":1517958000},{"date_published":"2018-02-08","activity":"52","popularity":"65375276","timestamp":1518044400},{"date_published":"2018-02-09","activity":"52","popularity":"91864233.25","timestamp":1518130800},{"date_published":"2018-02-10","activity":"35","popularity":"39843772.5","timestamp":1518217200},{"date_published":"2018-02-11","activity":"37","popularity":"244709216","timestamp":1518303600},{"date_published":"2018-02-12","activity":"85","popularity":"289718314.25","timestamp":1518390000},{"date_published":"2018-02-13","activity":"92","popularity":"299619408.25","timestamp":1518476400},{"date_published":"2018-02-14","activity":"70","popularity":"173667628.75","timestamp":1518562800},{"date_published":"2018-02-15","activity":"68","popularity":"153197362.25","timestamp":1518649200},{"date_published":"2018-02-16","activity":"85","popularity":"287308572","timestamp":1518735600},{"date_published":"2018-02-17","activity":"80","popularity":"303894042","timestamp":1518822000},{"date_published":"2018-02-18","activity":"81","popularity":"96708704","timestamp":1518908400},{"date_published":"2018-02-19","activity":"65","popularity":"95668509.75","timestamp":1518994800},{"date_published":"2018-02-20","activity":"85","popularity":"190079744","timestamp":1519081200},{"date_published":"2018-02-21","activity":"45","popularity":"123338054.75","timestamp":1519167600},{"date_published":"2018-02-22","activity":"54","popularity":"138437433.25","timestamp":1519254000},{"date_published":"2018-02-23","activity":"83","popularity":"461105826","timestamp":1519340400},{"date_published":"2018-02-24","activity":"59","popularity":"129663508.5","timestamp":1519426800},{"date_published":"2018-02-25","activity":"63","popularity":"155624595","timestamp":1519513200},{"date_published":"2018-02-26","activity":"72","popularity":"285808063.25","timestamp":1519599600},{"date_published":"2018-02-27","activity":"78","popularity":"122715391.25","timestamp":1519686000},{"date_published":"2018-02-28","activity":"79","popularity":"68024893","timestamp":1519772400},{"date_published":"2018-03-01","activity":"97","popularity":"324267548","timestamp":1519858800},{"date_published":"2018-03-02","activity":"79","popularity":"126833139.75","timestamp":1519945200},{"date_published":"2018-03-03","activity":"38","popularity":"137561273","timestamp":1520031600},{"date_published":"2018-03-04","activity":"42","popularity":"71733531.5","timestamp":1520118000},{"date_published":"2018-03-05","activity":"166","popularity":"1501017935.5","timestamp":1520204400},{"date_published":"2018-03-06","activity":"132","popularity":"503669257.5","timestamp":1520290800},{"date_published":"2018-03-07","activity":"126","popularity":"275128391.25","timestamp":1520377200},{"date_published":"2018-03-08","activity":"70","popularity":"291197816.25","timestamp":1520463600},{"date_published":"2018-03-09","activity":"99","popularity":"226717185","timestamp":1520550000},{"date_published":"2018-03-10","activity":"117","popularity":"159875927.5","timestamp":1520636400},{"date_published":"2018-03-11","activity":"82","popularity":"94225272.75","timestamp":1520722800},{"date_published":"2018-03-12","activity":"55","popularity":"102348713.25","timestamp":1520809200},{"date_published":"2018-03-13","activity":"70","popularity":"230688124","timestamp":1520895600},{"date_published":"2018-03-14","activity":"89","popularity":"190562922.75","timestamp":1520982000},{"date_published":"2018-03-15","activity":"89","popularity":"167541976.5","timestamp":1521068400},{"date_published":"2018-03-16","activity":"73","popularity":"165901825","timestamp":1521154800},{"date_published":"2018-03-17","activity":"70","popularity":"126510557.25","timestamp":1521241200},{"date_published":"2018-03-18","activity":"68","popularity":"119536825","timestamp":1521327600},{"date_published":"2018-03-19","activity":"78","popularity":"217144691.25","timestamp":1521414000},{"date_published":"2018-03-20","activity":"75","popularity":"153838620","timestamp":1521500400},{"date_published":"2018-03-21","activity":"69","popularity":"297887904.75","timestamp":1521586800},{"date_published":"2018-03-22","activity":"62","popularity":"168690787.25","timestamp":1521673200},{"date_published":"2018-03-23","activity":"80","popularity":"937346467.25","timestamp":1521759600},{"date_published":"2018-03-24","activity":"78","popularity":"399393452","timestamp":1521846000},{"date_published":"2018-03-25","activity":"89","popularity":"182384297","timestamp":1521932400},{"date_published":"2018-03-26","activity":"79","popularity":"123466459.25","timestamp":1522015200},{"date_published":"2018-03-27","activity":"87","popularity":"140793414.25","timestamp":1522101600},{"date_published":"2018-03-28","activity":"82","popularity":"224930980.5","timestamp":1522188000},{"date_published":"2018-03-29","activity":"73","popularity":"617139369","timestamp":1522274400},{"date_published":"2018-03-30","activity":"77","popularity":"90386409.5","timestamp":1522360800},{"date_published":"2018-03-31","activity":"57","popularity":"184145927","timestamp":1522447200},{"date_published":"2018-04-01","activity":"28","popularity":"62640669.75","timestamp":1522533600},{"date_published":"2018-04-02","activity":"21","popularity":"72634532.25","timestamp":1522620000},{"date_published":"2018-04-03","activity":"59","popularity":"177450948","timestamp":1522706400},{"date_published":"2018-04-04","activity":"85","popularity":"135607236.5","timestamp":1522792800},{"date_published":"2018-04-05","activity":"84","popularity":"472940292.75","timestamp":1522879200},{"date_published":"2018-04-06","activity":"65","popularity":"207156189.75","timestamp":1522965600},{"date_published":"2018-04-07","activity":"71","popularity":"275711571","timestamp":1523052000},{"date_published":"2018-04-08","activity":"67","popularity":"343305482.5","timestamp":1523138400},{"date_published":"2018-04-09","activity":"85","popularity":"108907641","timestamp":1523224800},{"date_published":"2018-04-10","activity":"71","popularity":"112886409.75","timestamp":1523311200},{"date_published":"2018-04-11","activity":"79","popularity":"138159577.5","timestamp":1523397600},{"date_published":"2018-04-12","activity":"78","popularity":"129466759.75","timestamp":1523484000},{"date_published":"2018-04-13","activity":"92","popularity":"116672264.25","timestamp":1523570400},{"date_published":"2018-04-14","activity":"41","popularity":"78177113.25","timestamp":1523656800},{"date_published":"2018-04-15","activity":"67","popularity":"119382167.25","timestamp":1523743200},{"date_published":"2018-04-16","activity":"53","popularity":"56460155.5","timestamp":1523829600},{"date_published":"2018-04-17","activity":"82","popularity":"302136591","timestamp":1523916000},{"date_published":"2018-04-18","activity":"89","popularity":"251441502","timestamp":1524002400},{"date_published":"2018-04-19","activity":"90","popularity":"396936632.75","timestamp":1524088800},{"date_published":"2018-04-20","activity":"96","popularity":"171085990.75","timestamp":1524175200},{"date_published":"2018-04-21","activity":"65","popularity":"161853004.25","timestamp":1524261600},{"date_published":"2018-04-22","activity":"45","popularity":"32815058.75","timestamp":1524348000},{"date_published":"2018-04-23","activity":"96","popularity":"732718419.75","timestamp":1524434400},{"date_published":"2018-04-24","activity":"94","popularity":"111373037","timestamp":1524520800},{"date_published":"2018-04-25","activity":"83","popularity":"229043145.75","timestamp":1524607200},{"date_published":"2018-04-26","activity":"84","popularity":"195024291.25","timestamp":1524693600},{"date_published":"2018-04-27","activity":"62","popularity":"79351559.75","timestamp":1524780000},{"date_published":"2018-04-28","activity":"47","popularity":"159634309","timestamp":1524866400},{"date_published":"2018-04-29","activity":"57","popularity":"62967853.75","timestamp":1524952800},{"date_published":"2018-04-30","activity":"90","popularity":"303812551.5","timestamp":1525039200},{"date_published":"2018-05-01","activity":"43","popularity":"80150553.5","timestamp":1525125600},{"date_published":"2018-05-02","activity":"72","popularity":"114878790","timestamp":1525212000},{"date_published":"2018-05-03","activity":"66","popularity":"162922852.5","timestamp":1525298400},{"date_published":"2018-05-04","activity":"79","popularity":"304045984.5","timestamp":1525384800},{"date_published":"2018-05-05","activity":"54","popularity":"145516673","timestamp":1525471200},{"date_published":"2018-05-06","activity":"67","popularity":"235476889.25","timestamp":1525557600},{"date_published":"2018-05-07","activity":"85","popularity":"388161397.75","timestamp":1525644000},{"date_published":"2018-05-08","activity":"75","popularity":"153261530.5","timestamp":1525730400},{"date_published":"2018-05-09","activity":"90","popularity":"216259455.75","timestamp":1525816800},{"date_published":"2018-05-10","activity":"107","popularity":"264531613.5","timestamp":1525903200},{"date_published":"2018-05-11","activity":"109","popularity":"302681020","timestamp":1525989600},{"date_published":"2018-05-12","activity":"93","popularity":"142388065","timestamp":1526076000},{"date_published":"2018-05-13","activity":"62","popularity":"145201252.25","timestamp":1526162400},{"date_published":"2018-05-14","activity":"95","popularity":"336326173","timestamp":1526248800},{"date_published":"2018-05-15","activity":"92","popularity":"551933657.5","timestamp":1526335200},{"date_published":"2018-05-16","activity":"89","popularity":"398175016.75","timestamp":1526421600},{"date_published":"2018-05-17","activity":"111","popularity":"451649953.75","timestamp":1526508000},{"date_published":"2018-05-18","activity":"91","popularity":"469872302.5","timestamp":1526594400},{"date_published":"2018-05-19","activity":"76","popularity":"105043635.25","timestamp":1526680800},{"date_published":"2018-05-20","activity":"61","popularity":"273802842.75","timestamp":1526767200},{"date_published":"2018-05-21","activity":"99","popularity":"627014204.75","timestamp":1526853600},{"date_published":"2018-05-22","activity":"69","popularity":"174935481","timestamp":1526940000},{"date_published":"2018-05-23","activity":"91","popularity":"1534393487.75","timestamp":1527026400},{"date_published":"2018-05-24","activity":"52","popularity":"1516754834.25","timestamp":1527112800},{"date_published":"2018-05-25","activity":"46","popularity":"88681264.75","timestamp":1527199200},{"date_published":"2018-05-26","activity":"48","popularity":"50640310.5","timestamp":1527285600},{"date_published":"2018-05-27","activity":"63","popularity":"201203861","timestamp":1527372000},{"date_published":"2018-05-28","activity":"112","popularity":"391061396.25","timestamp":1527458400},{"date_published":"2018-05-29","activity":"104","popularity":"237679270.5","timestamp":1527544800},{"date_published":"2018-05-30","activity":"97","popularity":"113857259.25","timestamp":1527631200},{"date_published":"2018-05-31","activity":"111","popularity":"107343050.75","timestamp":1527717600},{"date_published":"2018-06-01","activity":"103","popularity":"159981230.75","timestamp":1527804000},{"date_published":"2018-06-02","activity":"87","popularity":"176777374.75","timestamp":1527890400},{"date_published":"2018-06-03","activity":"74","popularity":"121589601.5","timestamp":1527976800},{"date_published":"2018-06-04","activity":"63","popularity":"106355656.75","timestamp":1528063200},{"date_published":"2018-06-05","activity":"49","popularity":"71013737","timestamp":1528149600},{"date_published":"2018-06-06","activity":"45","popularity":"479417804","timestamp":1528236000}],"centro-sinistra":[{"date_published":"2018-02-01","activity":"72","popularity":"1488","timestamp":1517439600},{"date_published":"2018-02-02","activity":"78","popularity":"3519","timestamp":1517526000},{"date_published":"2018-02-03","activity":"79","popularity":"34068","timestamp":1517612400},{"date_published":"2018-02-04","activity":"44","popularity":"7365","timestamp":1517698800},{"date_published":"2018-02-05","activity":"71","popularity":"1249409.25","timestamp":1517785200},{"date_published":"2018-02-06","activity":"93","popularity":"48584388.5","timestamp":1517871600},{"date_published":"2018-02-07","activity":"69","popularity":"31927156.5","timestamp":1517958000},{"date_published":"2018-02-08","activity":"65","popularity":"55612726.5","timestamp":1518044400},{"date_published":"2018-02-09","activity":"53","popularity":"45299807","timestamp":1518130800},{"date_published":"2018-02-10","activity":"37","popularity":"92868938.5","timestamp":1518217200},{"date_published":"2018-02-11","activity":"52","popularity":"85163431","timestamp":1518303600},{"date_published":"2018-02-12","activity":"72","popularity":"431605926.75","timestamp":1518390000},{"date_published":"2018-02-13","activity":"56","popularity":"57523905.25","timestamp":1518476400},{"date_published":"2018-02-14","activity":"59","popularity":"173019554.25","timestamp":1518562800},{"date_published":"2018-02-15","activity":"66","popularity":"152901593","timestamp":1518649200},{"date_published":"2018-02-16","activity":"82","popularity":"300392663.25","timestamp":1518735600},{"date_published":"2018-02-17","activity":"88","popularity":"241360452.75","timestamp":1518822000},{"date_published":"2018-02-18","activity":"61","popularity":"122715308.5","timestamp":1518908400},{"date_published":"2018-02-19","activity":"89","popularity":"295299669.5","timestamp":1518994800},{"date_published":"2018-02-20","activity":"92","popularity":"257930724","timestamp":1519081200},{"date_published":"2018-02-21","activity":"89","popularity":"294831111.5","timestamp":1519167600},{"date_published":"2018-02-22","activity":"63","popularity":"238027372","timestamp":1519254000},{"date_published":"2018-02-23","activity":"66","popularity":"169917589.5","timestamp":1519340400},{"date_published":"2018-02-24","activity":"53","popularity":"207887216.5","timestamp":1519426800},{"date_published":"2018-02-25","activity":"55","popularity":"72810145.5","timestamp":1519513200},{"date_published":"2018-02-26","activity":"62","popularity":"180158011.75","timestamp":1519599600},{"date_published":"2018-02-27","activity":"60","popularity":"130226897.5","timestamp":1519686000},{"date_published":"2018-02-28","activity":"64","popularity":"105209512.75","timestamp":1519772400},{"date_published":"2018-03-01","activity":"64","popularity":"88621496.75","timestamp":1519858800},{"date_published":"2018-03-02","activity":"63","popularity":"111819935","timestamp":1519945200},{"date_published":"2018-03-03","activity":"30","popularity":"35434598.5","timestamp":1520031600},{"date_published":"2018-03-04","activity":"42","popularity":"34994203","timestamp":1520118000},{"date_published":"2018-03-05","activity":"119","popularity":"1574932361.5","timestamp":1520204400},{"date_published":"2018-03-06","activity":"124","popularity":"489338044","timestamp":1520290800},{"date_published":"2018-03-07","activity":"93","popularity":"149184111.75","timestamp":1520377200},{"date_published":"2018-03-08","activity":"76","popularity":"288327866","timestamp":1520463600},{"date_published":"2018-03-09","activity":"67","popularity":"137728373.75","timestamp":1520550000},{"date_published":"2018-03-10","activity":"44","popularity":"95908261.5","timestamp":1520636400},{"date_published":"2018-03-11","activity":"45","popularity":"57390285.5","timestamp":1520722800},{"date_published":"2018-03-12","activity":"96","popularity":"251415770","timestamp":1520809200},{"date_published":"2018-03-13","activity":"85","popularity":"258506965.25","timestamp":1520895600},{"date_published":"2018-03-14","activity":"53","popularity":"151261581.75","timestamp":1520982000},{"date_published":"2018-03-15","activity":"63","popularity":"62738480.75","timestamp":1521068400},{"date_published":"2018-03-16","activity":"64","popularity":"181776496.5","timestamp":1521154800},{"date_published":"2018-03-17","activity":"61","popularity":"169214353","timestamp":1521241200},{"date_published":"2018-03-18","activity":"40","popularity":"101009341.5","timestamp":1521327600},{"date_published":"2018-03-19","activity":"49","popularity":"107389318.25","timestamp":1521414000},{"date_published":"2018-03-20","activity":"42","popularity":"33866266.5","timestamp":1521500400},{"date_published":"2018-03-21","activity":"35","popularity":"81283212.5","timestamp":1521586800},{"date_published":"2018-03-22","activity":"51","popularity":"129361048.25","timestamp":1521673200},{"date_published":"2018-03-23","activity":"69","popularity":"481122128","timestamp":1521759600},{"date_published":"2018-03-24","activity":"43","popularity":"56671479.5","timestamp":1521846000},{"date_published":"2018-03-25","activity":"27","popularity":"12560145","timestamp":1521932400},{"date_published":"2018-03-26","activity":"25","popularity":"50615661.75","timestamp":1522015200},{"date_published":"2018-03-27","activity":"51","popularity":"140837549","timestamp":1522101600},{"date_published":"2018-03-28","activity":"48","popularity":"140207236.5","timestamp":1522188000},{"date_published":"2018-03-29","activity":"52","popularity":"408508884.75","timestamp":1522274400},{"date_published":"2018-03-30","activity":"36","popularity":"43802032.5","timestamp":1522360800},{"date_published":"2018-03-31","activity":"39","popularity":"69854581.75","timestamp":1522447200},{"date_published":"2018-04-01","activity":"14","popularity":"13057030.75","timestamp":1522533600},{"date_published":"2018-04-02","activity":"8","popularity":"10157889","timestamp":1522620000},{"date_published":"2018-04-03","activity":"32","popularity":"640612982.5","timestamp":1522706400},{"date_published":"2018-04-04","activity":"51","popularity":"56985817","timestamp":1522792800},{"date_published":"2018-04-05","activity":"51","popularity":"337829108.5","timestamp":1522879200},{"date_published":"2018-04-06","activity":"51","popularity":"123294459.5","timestamp":1522965600},{"date_published":"2018-04-07","activity":"52","popularity":"116507637.75","timestamp":1523052000},{"date_published":"2018-04-08","activity":"51","popularity":"269754775","timestamp":1523138400},{"date_published":"2018-04-09","activity":"53","popularity":"86988413.25","timestamp":1523224800},{"date_published":"2018-04-10","activity":"61","popularity":"113456871.25","timestamp":1523311200},{"date_published":"2018-04-11","activity":"56","popularity":"49806275","timestamp":1523397600},{"date_published":"2018-04-12","activity":"54","popularity":"235447636","timestamp":1523484000},{"date_published":"2018-04-13","activity":"52","popularity":"67236690.5","timestamp":1523570400},{"date_published":"2018-04-14","activity":"37","popularity":"32643153.75","timestamp":1523656800},{"date_published":"2018-04-15","activity":"28","popularity":"41874245.5","timestamp":1523743200},{"date_published":"2018-04-16","activity":"43","popularity":"55423251.5","timestamp":1523829600},{"date_published":"2018-04-17","activity":"62","popularity":"70097459.75","timestamp":1523916000},{"date_published":"2018-04-18","activity":"61","popularity":"216575231","timestamp":1524002400},{"date_published":"2018-04-19","activity":"59","popularity":"349858761","timestamp":1524088800},{"date_published":"2018-04-20","activity":"36","popularity":"72738763.5","timestamp":1524175200},{"date_published":"2018-04-21","activity":"46","popularity":"148425922.75","timestamp":1524261600},{"date_published":"2018-04-22","activity":"16","popularity":"17329175.75","timestamp":1524348000},{"date_published":"2018-04-23","activity":"42","popularity":"161261418.5","timestamp":1524434400},{"date_published":"2018-04-24","activity":"58","popularity":"96469171","timestamp":1524520800},{"date_published":"2018-04-25","activity":"77","popularity":"274064721.75","timestamp":1524607200},{"date_published":"2018-04-26","activity":"58","popularity":"173077081.25","timestamp":1524693600},{"date_published":"2018-04-27","activity":"64","popularity":"135399393","timestamp":1524780000},{"date_published":"2018-04-28","activity":"55","popularity":"152729684.25","timestamp":1524866400},{"date_published":"2018-04-29","activity":"48","popularity":"92317455.25","timestamp":1524952800},{"date_published":"2018-04-30","activity":"63","popularity":"154482741.75","timestamp":1525039200},{"date_published":"2018-05-01","activity":"34","popularity":"102399879.75","timestamp":1525125600},{"date_published":"2018-05-02","activity":"65","popularity":"114002548.5","timestamp":1525212000},{"date_published":"2018-05-03","activity":"97","popularity":"181741569.75","timestamp":1525298400},{"date_published":"2018-05-04","activity":"74","popularity":"239088309.25","timestamp":1525384800},{"date_published":"2018-05-05","activity":"44","popularity":"145518537","timestamp":1525471200},{"date_published":"2018-05-06","activity":"36","popularity":"70060171.25","timestamp":1525557600},{"date_published":"2018-05-07","activity":"38","popularity":"183694942.75","timestamp":1525644000},{"date_published":"2018-05-08","activity":"49","popularity":"300047744.25","timestamp":1525730400},{"date_published":"2018-05-09","activity":"31","popularity":"26989681.75","timestamp":1525816800},{"date_published":"2018-05-10","activity":"33","popularity":"45317301.5","timestamp":1525903200},{"date_published":"2018-05-11","activity":"52","popularity":"539616374","timestamp":1525989600},{"date_published":"2018-05-12","activity":"28","popularity":"15775997.5","timestamp":1526076000},{"date_published":"2018-05-13","activity":"15","popularity":"14728202.5","timestamp":1526162400},{"date_published":"2018-05-14","activity":"16","popularity":"52273594.75","timestamp":1526248800},{"date_published":"2018-05-15","activity":"30","popularity":"46703363.5","timestamp":1526335200},{"date_published":"2018-05-16","activity":"21","popularity":"52389285.5","timestamp":1526421600},{"date_published":"2018-05-17","activity":"22","popularity":"132356508.5","timestamp":1526508000},{"date_published":"2018-05-18","activity":"27","popularity":"174922528.5","timestamp":1526594400},{"date_published":"2018-05-19","activity":"57","popularity":"261203250.25","timestamp":1526680800},{"date_published":"2018-05-20","activity":"16","popularity":"8628779.25","timestamp":1526767200},{"date_published":"2018-05-21","activity":"30","popularity":"88087253","timestamp":1526853600},{"date_published":"2018-05-22","activity":"30","popularity":"97555273","timestamp":1526940000},{"date_published":"2018-05-23","activity":"21","popularity":"254098565.75","timestamp":1527026400},{"date_published":"2018-05-24","activity":"19","popularity":"247124960.75","timestamp":1527112800},{"date_published":"2018-05-25","activity":"28","popularity":"43642735","timestamp":1527199200},{"date_published":"2018-05-26","activity":"29","popularity":"44701298.25","timestamp":1527285600},{"date_published":"2018-05-27","activity":"21","popularity":"16299949","timestamp":1527372000},{"date_published":"2018-05-28","activity":"48","popularity":"56246297.75","timestamp":1527458400},{"date_published":"2018-05-29","activity":"46","popularity":"75530572.5","timestamp":1527544800},{"date_published":"2018-05-30","activity":"30","popularity":"38223101.75","timestamp":1527631200},{"date_published":"2018-05-31","activity":"31","popularity":"22033348.75","timestamp":1527717600},{"date_published":"2018-06-01","activity":"40","popularity":"27638363.75","timestamp":1527804000},{"date_published":"2018-06-02","activity":"21","popularity":"35237769.75","timestamp":1527890400},{"date_published":"2018-06-03","activity":"12","popularity":"126290122.5","timestamp":1527976800},{"date_published":"2018-06-04","activity":"34","popularity":"67322274.25","timestamp":1528063200},{"date_published":"2018-06-05","activity":"41","popularity":"26495160.25","timestamp":1528149600},{"date_published":"2018-06-06","activity":"42","popularity":"177660093","timestamp":1528236000}],"sinistra":[{"date_published":"2018-02-01","activity":"25","popularity":"209","timestamp":1517439600},{"date_published":"2018-02-02","activity":"27","popularity":"783.5","timestamp":1517526000},{"date_published":"2018-02-03","activity":"34","popularity":"1279","timestamp":1517612400},{"date_published":"2018-02-04","activity":"55","popularity":"1747","timestamp":1517698800},{"date_published":"2018-02-05","activity":"33","popularity":"798.5","timestamp":1517785200},{"date_published":"2018-02-06","activity":"47","popularity":"15903216.5","timestamp":1517871600},{"date_published":"2018-02-07","activity":"38","popularity":"44158634.75","timestamp":1517958000},{"date_published":"2018-02-08","activity":"28","popularity":"27449183.75","timestamp":1518044400},{"date_published":"2018-02-09","activity":"16","popularity":"4040454.75","timestamp":1518130800},{"date_published":"2018-02-10","activity":"32","popularity":"337547741","timestamp":1518217200},{"date_published":"2018-02-11","activity":"22","popularity":"19711104","timestamp":1518303600},{"date_published":"2018-02-12","activity":"24","popularity":"73720607","timestamp":1518390000},{"date_published":"2018-02-13","activity":"19","popularity":"35532813.75","timestamp":1518476400},{"date_published":"2018-02-14","activity":"23","popularity":"20857494","timestamp":1518562800},{"date_published":"2018-02-15","activity":"34","popularity":"118940851","timestamp":1518649200},{"date_published":"2018-02-16","activity":"16","popularity":"36759782.25","timestamp":1518735600},{"date_published":"2018-02-17","activity":"22","popularity":"15808923.25","timestamp":1518822000},{"date_published":"2018-02-18","activity":"42","popularity":"132770731","timestamp":1518908400},{"date_published":"2018-02-19","activity":"38","popularity":"50863519.5","timestamp":1518994800},{"date_published":"2018-02-20","activity":"28","popularity":"73593385.25","timestamp":1519081200},{"date_published":"2018-02-21","activity":"35","popularity":"117581393.75","timestamp":1519167600},{"date_published":"2018-02-22","activity":"24","popularity":"85951033.25","timestamp":1519254000},{"date_published":"2018-02-23","activity":"32","popularity":"76349551","timestamp":1519340400},{"date_published":"2018-02-24","activity":"29","popularity":"33235027.5","timestamp":1519426800},{"date_published":"2018-02-25","activity":"27","popularity":"98714194.25","timestamp":1519513200},{"date_published":"2018-02-26","activity":"30","popularity":"57613740.75","timestamp":1519599600},{"date_published":"2018-02-27","activity":"25","popularity":"139708965.25","timestamp":1519686000},{"date_published":"2018-02-28","activity":"23","popularity":"51209835","timestamp":1519772400},{"date_published":"2018-03-01","activity":"18","popularity":"54318334","timestamp":1519858800},{"date_published":"2018-03-02","activity":"21","popularity":"46811226.25","timestamp":1519945200},{"date_published":"2018-03-03","activity":"21","popularity":"37737624.5","timestamp":1520031600},{"date_published":"2018-03-04","activity":"22","popularity":"3609677.25","timestamp":1520118000},{"date_published":"2018-03-05","activity":"58","popularity":"971534359.75","timestamp":1520204400},{"date_published":"2018-03-06","activity":"36","popularity":"44896463.5","timestamp":1520290800},{"date_published":"2018-03-07","activity":"17","popularity":"18170738.25","timestamp":1520377200},{"date_published":"2018-03-08","activity":"7","popularity":"20547041.25","timestamp":1520463600},{"date_published":"2018-03-09","activity":"14","popularity":"15176579.75","timestamp":1520550000},{"date_published":"2018-03-10","activity":"6","popularity":"8741573.25","timestamp":1520636400},{"date_published":"2018-03-11","activity":"6","popularity":"3802198.25","timestamp":1520722800},{"date_published":"2018-03-12","activity":"7","popularity":"6180782.25","timestamp":1520809200},{"date_published":"2018-03-13","activity":"7","popularity":"8046155.5","timestamp":1520895600},{"date_published":"2018-03-14","activity":"4","popularity":"52924683.75","timestamp":1520982000},{"date_published":"2018-03-15","activity":"13","popularity":"44107202.25","timestamp":1521068400},{"date_published":"2018-03-16","activity":"4","popularity":"5373648.5","timestamp":1521154800},{"date_published":"2018-03-17","activity":"11","popularity":"14798380.25","timestamp":1521241200},{"date_published":"2018-03-18","activity":"3","popularity":"67541.25","timestamp":1521327600},{"date_published":"2018-03-19","activity":"5","popularity":"33777958.75","timestamp":1521414000},{"date_published":"2018-03-20","activity":"10","popularity":"13228894.75","timestamp":1521500400},{"date_published":"2018-03-21","activity":"13","popularity":"14596953.25","timestamp":1521586800},{"date_published":"2018-03-22","activity":"11","popularity":"71035165","timestamp":1521673200},{"date_published":"2018-03-23","activity":"13","popularity":"50373947.75","timestamp":1521759600},{"date_published":"2018-03-24","activity":"15","popularity":"21653620.25","timestamp":1521846000},{"date_published":"2018-03-25","activity":"8","popularity":"3650296.5","timestamp":1521932400},{"date_published":"2018-03-26","activity":"11","popularity":"10957091.25","timestamp":1522015200},{"date_published":"2018-03-27","activity":"10","popularity":"86419468.75","timestamp":1522101600},{"date_published":"2018-03-28","activity":"4","popularity":"108422.75","timestamp":1522188000},{"date_published":"2018-03-29","activity":"8","popularity":"5055945.25","timestamp":1522274400},{"date_published":"2018-03-30","activity":"2","popularity":"7351973","timestamp":1522360800},{"date_published":"2018-03-31","activity":"3","popularity":"390589.5","timestamp":1522447200},{"date_published":"2018-04-01","activity":"4","popularity":"12081820.25","timestamp":1522533600},{"date_published":"2018-04-02","activity":"4","popularity":"2120011.75","timestamp":1522620000},{"date_published":"2018-04-03","activity":"3","popularity":"670065.75","timestamp":1522706400},{"date_published":"2018-04-04","activity":"9","popularity":"18275696","timestamp":1522792800},{"date_published":"2018-04-05","activity":"6","popularity":"1091497.25","timestamp":1522879200},{"date_published":"2018-04-06","activity":"2","popularity":"12192846","timestamp":1522965600},{"date_published":"2018-04-07","activity":"2","popularity":"333190.25","timestamp":1523052000},{"date_published":"2018-04-08","activity":"3","popularity":"2014502.25","timestamp":1523138400},{"date_published":"2018-04-09","activity":"7","popularity":"16410707","timestamp":1523224800},{"date_published":"2018-04-10","activity":"11","popularity":"9521477","timestamp":1523311200},{"date_published":"2018-04-11","activity":"3","popularity":"410196.25","timestamp":1523397600},{"date_published":"2018-04-12","activity":"3","popularity":"953713.25","timestamp":1523484000},{"date_published":"2018-04-13","activity":"5","popularity":"9148501.5","timestamp":1523570400},{"date_published":"2018-04-14","activity":"4","popularity":"990890","timestamp":1523656800},{"date_published":"2018-04-15","activity":"1","popularity":"68801","timestamp":1523743200},{"date_published":"2018-04-16","activity":"2","popularity":"980386.25","timestamp":1523829600},{"date_published":"2018-04-17","activity":"2","popularity":"1347.5","timestamp":1523916000},{"date_published":"2018-04-18","activity":"4","popularity":"3981089","timestamp":1524002400},{"date_published":"2018-04-19","activity":"4","popularity":"303536322","timestamp":1524088800},{"date_published":"2018-04-20","activity":"3","popularity":"6609.5","timestamp":1524175200},{"date_published":"2018-04-21","activity":"2","popularity":"1025533","timestamp":1524261600},{"date_published":"2018-04-22","activity":"4","popularity":"10969362.5","timestamp":1524348000},{"date_published":"2018-04-23","activity":"4","popularity":"4764800.75","timestamp":1524434400},{"date_published":"2018-04-24","activity":"5","popularity":"8719191.5","timestamp":1524520800},{"date_published":"2018-04-25","activity":"6","popularity":"13951673.75","timestamp":1524607200},{"date_published":"2018-04-26","activity":"5","popularity":"37520895.5","timestamp":1524693600},{"date_published":"2018-04-27","activity":"6","popularity":"979890.25","timestamp":1524780000},{"date_published":"2018-04-28","activity":"4","popularity":"165671.5","timestamp":1524866400},{"date_published":"2018-04-30","activity":"1","popularity":"87272","timestamp":1525039200},{"date_published":"2018-05-01","activity":"4","popularity":"4253133.5","timestamp":1525125600},{"date_published":"2018-05-02","activity":"4","popularity":"14541.25","timestamp":1525212000},{"date_published":"2018-05-03","activity":"5","popularity":"12394309.75","timestamp":1525298400},{"date_published":"2018-05-04","activity":"8","popularity":"41503276.5","timestamp":1525384800},{"date_published":"2018-05-05","activity":"3","popularity":"1129240.5","timestamp":1525471200},{"date_published":"2018-05-06","activity":"1","popularity":"54053.5","timestamp":1525557600},{"date_published":"2018-05-07","activity":"1","popularity":"3220.25","timestamp":1525644000},{"date_published":"2018-05-08","activity":"4","popularity":"9134063","timestamp":1525730400},{"date_published":"2018-05-09","activity":"5","popularity":"9336108.5","timestamp":1525816800},{"date_published":"2018-05-10","activity":"4","popularity":"21245109.75","timestamp":1525903200},{"date_published":"2018-05-11","activity":"4","popularity":"19131654.25","timestamp":1525989600},{"date_published":"2018-05-12","activity":"3","popularity":"5709058.5","timestamp":1526076000},{"date_published":"2018-05-13","activity":"1","popularity":"1657.75","timestamp":1526162400},{"date_published":"2018-05-14","activity":"3","popularity":"51847.75","timestamp":1526248800},{"date_published":"2018-05-15","activity":"5","popularity":"46497.5","timestamp":1526335200},{"date_published":"2018-05-16","activity":"4","popularity":"24779978.25","timestamp":1526421600},{"date_published":"2018-05-18","activity":"1","popularity":"584217.5","timestamp":1526594400},{"date_published":"2018-05-19","activity":"3","popularity":"1851215.75","timestamp":1526680800},{"date_published":"2018-05-20","activity":"1","popularity":"0","timestamp":1526767200},{"date_published":"2018-05-21","activity":"1","popularity":"4904","timestamp":1526853600},{"date_published":"2018-05-22","activity":"5","popularity":"678820.5","timestamp":1526940000},{"date_published":"2018-05-23","activity":"1","popularity":"9098275","timestamp":1527026400},{"date_published":"2018-05-24","activity":"7","popularity":"747206977","timestamp":1527112800},{"date_published":"2018-05-25","activity":"9","popularity":"564455.5","timestamp":1527199200},{"date_published":"2018-05-26","activity":"5","popularity":"9700960.25","timestamp":1527285600},{"date_published":"2018-05-27","activity":"3","popularity":"3038820.75","timestamp":1527372000},{"date_published":"2018-05-28","activity":"3","popularity":"6749363","timestamp":1527458400},{"date_published":"2018-05-29","activity":"5","popularity":"1134102.75","timestamp":1527544800},{"date_published":"2018-05-30","activity":"4","popularity":"5278415","timestamp":1527631200},{"date_published":"2018-05-31","activity":"1","popularity":"5065","timestamp":1527717600},{"date_published":"2018-06-01","activity":"5","popularity":"23359.25","timestamp":1527804000},{"date_published":"2018-06-02","activity":"9","popularity":"6144966.25","timestamp":1527890400},{"date_published":"2018-06-03","activity":"3","popularity":"12517947.25","timestamp":1527976800},{"date_published":"2018-06-04","activity":"3","popularity":"15585132.75","timestamp":1528063200},{"date_published":"2018-06-05","activity":"2","popularity":"30256993.5","timestamp":1528149600},{"date_published":"2018-06-06","activity":"7","popularity":"832973.5","timestamp":1528236000}]},"articles":[{"id":"360406","title":"Governo Conte, si vota la fiducia alla Camera. LIVE  | Sky TG24","source":"tg24.sky.it","description":"Leggi su Sky Tg24 l’articolo Governo Conte, si vota la fiducia alla Camera. LIVE  | Sky TG24","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly90ZzI0LnNreS5pdC9wb2xpdGljYS8yMDE4LzA2LzA2L2dvdmVybm8tZmlkdWNpYS1j\nYW1lcmEtbGl2ZS5odG1sP3NvY2lhbD10d2l0dGVyX3NreXRnMjRfcGhvdG9fbnVsbA==","tags":["articolo uno-mdp","giuseppe conte"],"date_published":"2018-06-06 19:44:17","date_published_short":"06-06-2018","date_published_timestamp":"1528236000","popularity":"89095100","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"29","query":"m5s"},{"id":"11","query":"lega"}],"popularity_logs":"40","tweets":{"number":"2","sentiment_average":"-1.0000","sentiment_negative":"2","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"360068","title":"Caro Di Maio, ti scrivo di Sacko","source":"www.huffingtonpost.it","description":"Caro Luigi Di Maio,voglio scriverti di Soumayla Sacko. Un ragazzo del Mali, di 29 anni, bracciante nei campi in Calabria e rappresentante sindacale. È stato barbaramente ucciso con un colpo di...","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaHVmZmluZ3RvbnBvc3QuaXQvbmljb2xhLWZyYXRvaWFubmkvY2Fyby1kaS1t\nYWlvLXRpLXNjcml2by1kaS1zYWNrb19hXzIzNDUxMTQxLw==","tags":["caro di maio","luigi di maio"],"date_published":"2018-06-05 12:00:24","date_published_short":"05-06-2018","date_published_timestamp":"1528149600","popularity":"28577300","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"4","name":"Sinistra","slug":"sinistra"}],"topics":[{"id":"34","query":"\"di maio\""},{"id":"35","query":"dimaio"},{"id":"8","query":"matteosalvini"},{"id":"93","query":"leu"}],"popularity_logs":"8","tweets":{"number":"46","sentiment_average":"-1.0000","sentiment_negative":"46","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"359872","title":"Fontana insiste sulle famiglie gay: «La rivolta delle élite non ci spaventa»","source":"www.corriere.it","description":"Il neoministro della Famiglia scrive una lettera al quotidiano «Il Tempo»","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuY29ycmllcmUuaXQvcG9saXRpY2EvMThfZ2l1Z25vXzA0L2ZvbnRhbmEtaW5z\naXN0ZS1yaWxhbmNpYS1mYW1pZ2xpZS1nYXktbGEtcml2b2x0YS1lbGl0ZS1ub24tY2ktc3BhdmVu\ndGEtM2U0NzIwZjYtNjdmOC0xMWU4LWI1N2ItNDU5YTIzNDcyYmUwLnNodG1s","tags":["attilio fontana"],"date_published":"2018-06-04 15:44:25","date_published_short":"04-06-2018","date_published_timestamp":"1528063200","popularity":"27086800","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"98","query":"fontana"}],"popularity_logs":"8","tweets":{"number":"17","sentiment_average":"-0.9412","sentiment_negative":"16","sentiment_neutral":"1","sentiment_positive":"0"}},{"id":"359531","title":"Berlusconi, miracolo finito: il declino del centrodestra","source":"www.corriere.it","description":"FI e Pd dovranno ripensarsi. Ne avranno la capacità e l’animo i due sconfitti gemelli?","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuY29ycmllcmUuaXQvcG9saXRpY2EvMThfZ2l1Z25vXzAzL2Jlcmx1c2Nvbmkt\nbWlyYWNvbG8tZmluaXRvLWRlY2xpbm8tY2VudHJvZGVzdHJhLTllMjZkYmE4LTY2YjEtMTFlOC1h\nMWQ2LTM5Njg3MmJlNGU0Yy5zaHRtbA==","tags":["centrodestra fi","pd","silvio berlusconi"],"date_published":"2018-06-03 01:00:30","date_published_short":"03-06-2018","date_published_timestamp":"1527976800","popularity":"40441500","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"5","query":"berlusconi"},{"id":"11","query":"lega"},{"id":"96","query":"cav"},{"id":"69","query":"pd"},{"id":"65","query":"Renzi"}],"popularity_logs":"11","tweets":{"number":"58","sentiment_average":"-0.0862","sentiment_negative":"29","sentiment_neutral":"5","sentiment_positive":"24"}},{"id":"359523","title":"Di Maio: «Pensioni, quota 100 per superare la Fornero»","source":"www.corriere.it","description":"L'annuncio del ministro del Lavoro — Brunetta: «Propaganda, quella misura non è sostenibile. Si inizi dalla flat tax»","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuY29ycmllcmUuaXQvZWNvbm9taWEvMThfZ2l1Z25vXzAyL2RpLW1haW8tcXVv\ndGEtMTAwLXN1cGVyYXJlLWxlZ2dlLWZvcm5lcm8tNzRhYzM3ZjQtNjY5ZS0xMWU4LWExZDYtMzk2\nODcyYmU0ZTRjLnNodG1s","tags":["elsa fornero","luigi di maio","renato brunetta"],"date_published":"2018-06-02 22:43:00","date_published_short":"02-06-2018","date_published_timestamp":"1527890400","popularity":"25723200","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"34","query":"\"di maio\""}],"popularity_logs":"10","tweets":{"number":"6","sentiment_average":"-0.8333","sentiment_negative":"5","sentiment_neutral":"1","sentiment_positive":"0"}},{"id":"359179","title":"Quirinale, il governo M5s-Lega ha giurato: è ufficialmente in carica - Tgcom24","source":"www.tgcom24.mediaset.it","description":"Di Maio: \"E' ora di far ripartire il Paese, di mettere da parte la Fornero, di istituire il reddito di cittadinanza e il salario minimo orario\"","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy50Z2NvbTI0Lm1lZGlhc2V0Lml0L3BvbGl0aWNhL2FsLXZpYS1pbC1nb3Zlcm5v\nLW01cy1sZWdhLWFsbGUtMTYtaWwtZ2l1cmFtZW50by1jb250ZS1zb25vLWVtb3ppb25hdG9fMzE0\nMzQ5Ni0yMDE4MDJhLnNodG1s","tags":["elsa fornero","lega","luigi di maio","movimento 5 stelle","sergio mattarella"],"date_published":"2018-06-01 16:14:04","date_published_short":"01-06-2018","date_published_timestamp":"1527804000","popularity":"20994700","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"34","query":"\"di maio\""},{"id":"11","query":"lega"},{"id":"29","query":"m5s"},{"id":"7","query":"salvini"},{"id":"36","query":"\"luigi di maio\""}],"popularity_logs":"6","tweets":{"number":"6","sentiment_average":"-0.5000","sentiment_negative":"3","sentiment_neutral":"3","sentiment_positive":"0"}},{"id":"358849","title":"Milano, cancellata la scritta \"Basta euro\" dal muro della Lega di via Bellerio","source":"milano.repubblica.it","description":"Via i riferimenti alla Padania e alla battaglia contro la moneta europea. Tutto imbiancato di fresco. Dal quartier generale filtra che nulla ha a che fare con","url":"https://api.elezioni.io/click?u=aHR0cDovL21pbGFuby5yZXB1YmJsaWNhLml0L2Nyb25hY2EvMjAxOC8wNS8zMS9uZXdzL21pbGFu\nb19jYW5jZWxsYXRhX2xhX3Njcml0dGFfYmFzdGFfZXVyb19kYWxfbXVyb19kZWxsYV9sZWdhX2Rp\nX3ZpYV9iZWxsZXJpby0xOTc4MDY1OTQv","tags":["lega","milano","via bellerio via"],"date_published":"2018-05-31 11:38:08","date_published_short":"31-05-2018","date_published_timestamp":"1527717600","popularity":"19745400","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"11","query":"lega"}],"popularity_logs":"9","tweets":{"number":"12","sentiment_average":"-0.5000","sentiment_negative":"6","sentiment_neutral":"6","sentiment_positive":"0"}},{"id":"358724","title":"Blog | Il Pd vuole uscire dalla crisi creando il 'fronte repubblicano'. Ma è un rischio - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"Il Partito democratico pensa di uscire dalla sua crisi nascondendo il simbolo e andando alle elezioni sotto le insegne di un “fronte repubblicano” che difenda i valori dell’Unione europea, in una specie di secondo tempo del voto del 4 marzo che veda il ballottaggio definitivo tra sovranisti e anti-sovranisti. Io penso che sia una scelta …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wNS8zMC9pbC1wZC12dW9sZS11\nc2NpcmUtZGFsbGEtY3Jpc2ktY3JlYW5kby1pbC1mcm9udGUtcmVwdWJibGljYW5vLW1hLWUtdW4t\ncmlzY2hpby80MzkzMzY5Lw==","tags":["pd"],"date_published":"2018-05-30 19:05:02","date_published_short":"30-05-2018","date_published_timestamp":"1527631200","popularity":"21990000","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"69","query":"pd"}],"popularity_logs":"9","tweets":{"number":"15","sentiment_average":"-1.0000","sentiment_negative":"15","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"358337","title":"Oggi Cottarelli presenta la lista dei ministri. Spread a 260, è record dal 2013. Giù la Borsa","source":"www.lastampa.it","description":"L’incertezza politica pesa anche sull’euro, in calo su yen e dollaro. Renzi attacca: è colpa di Salvini e Di Maio, tengono in ostaggio l’Italia. Il leader leghista: nessuno ci vuole al governo","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5sYXN0YW1wYS5pdC8yMDE4LzA1LzI5L2l0YWxpYS9sby1zcHJlYWQtc2ZvbmRh\nLXF1b3RhLWlsLXJlY29yZC1kYWwtcmVuemktaXRhbGlhLW9zdGFnZ2lvLWRpLWxlZ2Ftcy1jb2xw\nYS1sb3JvLVdJYklYYURodHc0cEVEeE5GTDdieEovcGFnaW5hLmh0bWw=","tags":["renzi"],"date_published":"2018-05-29 08:57:24","date_published_short":"29-05-2018","date_published_timestamp":"1527544800","popularity":"41417600","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"65","query":"Renzi"}],"popularity_logs":"16","tweets":{"number":"20","sentiment_average":"-0.9000","sentiment_negative":"18","sentiment_neutral":"2","sentiment_positive":"0"}},{"id":"358017","title":"Editoriale | Una sfida irresponsabile e una sconfitta per l’Italia","source":"www.corriere.it","description":"L'editoriale di Luciano Fontana sul Corriere del 28 maggio 2018","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuY29ycmllcmUuaXQvb3BpbmlvbmkvMThfbWFnZ2lvXzI4L3NmaWRhLWlycmVz\ncG9uc2FiaWxlLWI3ODY5MTNlLTYxZjEtMTFlOC04M2MyLWMyZjI3OTcxYzMzNy5zaHRtbA==","tags":["attilio fontana","luciano"],"date_published":"2018-05-28 00:53:56","date_published_short":"28-05-2018","date_published_timestamp":"1527458400","popularity":"35180700","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"98","query":"fontana"},{"id":"11","query":"lega"},{"id":"30","query":"\"movimento cinque stelle\""},{"id":"35","query":"dimaio"}],"popularity_logs":"26","tweets":{"number":"17","sentiment_average":"-0.8235","sentiment_negative":"14","sentiment_neutral":"3","sentiment_positive":"0"}},{"id":"357977","title":"Di Maio: «Mattarella incomprensibile, c'è un problema di democrazia»","source":"www.corriere.it","description":"Il capo politico del Movimento 5 Stelle: «Diciamoci che è inutile votare, tanto il governo lo decidono le lobby»","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuY29ycmllcmUuaXQvY3JvbmFjaGUvMThfbWFnZ2lvXzI3L2RpLW1haW8tc2Nl\nbHRhLW1hdHRhcmVsbGEtaW5jb21wcmVuc2liaWxlLWMtcHJvYmxlbWEtZGVtb2NyYXppYS1jZjk3\nM2Q3Mi02MWQ5LTExZTgtODNjMi1jMmYyNzk3MWMzMzcuc2h0bWw=","tags":["luigi di maio","movimento 5 stelle","sergio mattarella"],"date_published":"2018-05-27 20:44:14","date_published_short":"27-05-2018","date_published_timestamp":"1527372000","popularity":"46632900","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"34","query":"\"di maio\""},{"id":"35","query":"dimaio"}],"popularity_logs":"29","tweets":{"number":"19","sentiment_average":"-0.8421","sentiment_negative":"16","sentiment_neutral":"3","sentiment_positive":"0"}},{"id":"357852","title":"Scontro su Savona, Salvini: 'Daremo lista ministri a Conte. O si parte o non tratto più'","source":"video.repubblica.it","description":"'Per il governo Conte ho detto 'o si parte o per noi basta'. Mi rifiuto di andare avanti ancora a trattare per settimane. I mutui non aspettano,...","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly92aWRlby5yZXB1YmJsaWNhLml0L3BvbGl0aWNhL3Njb250cm8tc3Utc2F2b25hLXNh\nbHZpbmktZGFyZW1vLWxpc3RhLW1pbmlzdHJpLWEtY29udGUtby1zaS1wYXJ0ZS1vLW5vbi10cmF0\ndG8tcGl1LzMwNTk4OS8zMDY2MTg/cmVmPXR3aHY=","tags":["giuseppe conte","matteo salvini","savona"],"date_published":"2018-05-26 22:39:35","date_published_short":"26-05-2018","date_published_timestamp":"1527285600","popularity":"21723300","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"7","query":"salvini"}],"popularity_logs":"36","tweets":{"number":"3","sentiment_average":"-1.0000","sentiment_negative":"3","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"357551","title":"Da Berlusconi tre milioni alla moglie di Dell’Utri","source":"www.lastampa.it","description":"Bankitalia: versamenti sospetti. Inviato il fascicolo alla procura","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5sYXN0YW1wYS5pdC8yMDE4LzA1LzI1L2l0YWxpYS9kYS1iZXJsdXNjb25pLXRy\nZS1taWxpb25pLWFsbGEtbW9nbGllLWRpLWRlbGx1dHJpLVZ4T3RGU2ZaaTZRd291VXp3MkRPZkwv\ncHJlbWl1bS5odG1s","tags":["silvio berlusconi"],"date_published":"2018-05-25 08:04:14","date_published_short":"25-05-2018","date_published_timestamp":"1527199200","popularity":"35380000","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"5","query":"berlusconi"}],"popularity_logs":"40","tweets":{"number":"40","sentiment_average":"0.6000","sentiment_negative":"7","sentiment_neutral":"2","sentiment_positive":"31"}},{"id":"357430","title":"Governo, al via le consultazioni di Conte. DIRETTA  | Sky TG24","source":"tg24.sky.it","description":"Leggi su Sky Tg24 l’articolo Governo, al via le consultazioni di Conte. DIRETTA  | Sky TG24","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly90ZzI0LnNreS5pdC9wb2xpdGljYS8yMDE4LzA1LzI0L2NvbnN1bHRhemlvbmktY29u\ndGUtZGlyZXR0YS5odG1sP3NvY2lhbD10d2l0dGVyX3NreXRnMjRfcGhvdG9fbnVsbA==","tags":["articolo uno-mdp","giuseppe conte"],"date_published":"2018-05-24 12:40:00","date_published_short":"24-05-2018","date_published_timestamp":"1527112800","popularity":"369792000","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"4","name":"Sinistra","slug":"sinistra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"5","query":"berlusconi"},{"id":"29","query":"m5s"},{"id":"11","query":"lega"},{"id":"7","query":"salvini"},{"id":"35","query":"dimaio"},{"id":"23","query":"grasso"},{"id":"93","query":"leu"},{"id":"9","query":"meloni"},{"id":"34","query":"\"di maio\""}],"popularity_logs":"39","tweets":{"number":"28","sentiment_average":"0.0357","sentiment_negative":"12","sentiment_neutral":"3","sentiment_positive":"13"}},{"id":"357352","title":"Governo, ultime notizie DIRETTA | Conte premier incaricato   | Sky TG24","source":"tg24.sky.it","description":"Leggi su Sky Tg24 l’articolo Governo, ultime notizie DIRETTA | Conte premier incaricato   | Sky TG24","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly90ZzI0LnNreS5pdC9wb2xpdGljYS8yMDE4LzA1LzIzL2dvdmVybm8tdWx0aW1lLW5v\ndGl6aWUtZGlyZXR0YS5odG1sP3NvY2lhbD10d2l0dGVyX3NreXRnMjRfcGhvdG9fbnVsbA==","tags":["articolo uno-mdp","giuseppe conte"],"date_published":"2018-05-23 20:42:24","date_published_short":"23-05-2018","date_published_timestamp":"1527026400","popularity":"371098000","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"34","query":"\"di maio\""},{"id":"29","query":"m5s"}],"popularity_logs":"38","tweets":{"number":"8","sentiment_average":"-1.0000","sentiment_negative":"8","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"356985","title":"Chi è Giuseppe Conte, il premier che «viene dalla periferia» | Video","source":"www.corriere.it","description":"L'annuncio di Di Maio: «Si è fatto da solo. È uno tosto»","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuY29ycmllcmUuaXQvcG9saXRpY2EvMThfbWFnZ2lvXzIxL2NoaS1naXVzZXBw\nZS1jb250ZS1wcmVtaWVyLWNoZS12aWVuZS1wZXJpZmVyaWEtMmQ0ZmUyMjgtNWQxOC0xMWU4LTlk\nZjYtYTFmN2MyNWY2ZGY5LnNodG1s","tags":["giuseppe conte","luigi di maio"],"date_published":"2018-05-22 07:27:52","date_published_short":"22-05-2018","date_published_timestamp":"1526940000","popularity":"40938000","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"66","query":"matteorenzi"}],"popularity_logs":"39","tweets":{"number":"1","sentiment_average":"0.0000","sentiment_negative":"0","sentiment_neutral":"1","sentiment_positive":"0"}},{"id":"356801","title":"Oggi si fa il governo? - Il Post","source":"www.ilpost.it","description":"Di Maio e Salvini dicono di aver raggiunto l'accordo e oggi dovrebbero essere ricevuti al Quirinale per presentare nomi e progetti: tutte le notizie, man mano che arrivano","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxwb3N0Lml0LzIwMTgvMDUvMjEvZ292ZXJuby1sZWdhLW1vdmltZW50by01\nLXN0ZWxsZS8=","tags":["luigi di maio","matteo salvini","sergio mattarella"],"date_published":"2018-05-21 09:00:39","date_published_short":"21-05-2018","date_published_timestamp":"1526853600","popularity":"115146000","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"31","query":"\"movimento 5 stelle\""},{"id":"11","query":"lega"}],"popularity_logs":"37","tweets":{"number":"19","sentiment_average":"-0.8421","sentiment_negative":"16","sentiment_neutral":"3","sentiment_positive":"0"}},{"id":"356677","title":"La storia dei tre milioni di eredità per Berlusconi - Il Post","source":"www.ilpost.it","description":"La state leggendo su molti siti e giornali ed è quasi sicuramente falsa: ma qualcosa racconta","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxwb3N0Lml0LzIwMTgvMDUvMjAvZXJlZGl0YS10cmUtbWlsaW9uaS1iZXJs\ndXNjb25pLWJ1ZmFsYS8=","tags":["silvio berlusconi"],"date_published":"2018-05-20 12:26:21","date_published_short":"20-05-2018","date_published_timestamp":"1526767200","popularity":"60976800","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"5","query":"berlusconi"}],"popularity_logs":"38","tweets":{"number":"49","sentiment_average":"0.4694","sentiment_negative":"11","sentiment_neutral":"4","sentiment_positive":"34"}},{"id":"356448","title":"Assemblea Pd, il partito spaccato prima dell'inizio: firme su due mozioni contrapposte","source":"www.repubblica.it","description":"Mille delegati all'Ergife di Roma. Documento della minoranza per proporre la candidatura del reggente Martina e raccolta di firme dei renziani per andare","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5yZXB1YmJsaWNhLml0L3BvbGl0aWNhLzIwMTgvMDUvMTkvbmV3cy9hc3NlbWJs\nZWFfcGRfaWxfcGFydGl0b19zcGFjY2F0b19wcmltYV9kZWxsX2luaXppb19maXJtZV9zdV9kdWVf\nbW96aW9uaV9jb250cmFwcG9zdGUtMTk2Nzk5Mzc2Lw==","tags":["pd"],"date_published":"2018-05-19 10:59:48","date_published_short":"19-05-2018","date_published_timestamp":"1526680800","popularity":"90618400","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"69","query":"pd"}],"popularity_logs":"38","tweets":{"number":"14","sentiment_average":"0.7857","sentiment_negative":"0","sentiment_neutral":"3","sentiment_positive":"11"}},{"id":"356174","title":"Il balzo della Lega: supera il 25 per cento. M5S perde un punto","source":"www.corriere.it","description":"Il partito di Salvini unico a crescere, FI scende al 12%. In calo anche Fratelli d’Italia (al 3,4) e il Pd (al 18)","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuY29ycmllcmUuaXQvcG9saXRpY2EvMThfbWFnZ2lvXzE4L2JhbHpvLWxlZ2Et\nc3VwZXJhLTI1LWNlbnRvLW01cy1wZXJkZS1wdW50by04MTM5YWIzOC01YTA5LTExZTgtODliZi1j\nZWJkNWRiNDRhMjQuc2h0bWw=","tags":["forza italia","fratelli d'italia","lega","matteo salvini","movimento 5 stelle","pd"],"date_published":"2018-05-18 01:10:30","date_published_short":"18-05-2018","date_published_timestamp":"1526594400","popularity":"119256000","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"29","query":"m5s"},{"id":"11","query":"lega"},{"id":"7","query":"salvini"}],"popularity_logs":"36","tweets":{"number":"16","sentiment_average":"-0.4375","sentiment_negative":"10","sentiment_neutral":"3","sentiment_positive":"3"}},{"id":"355952","title":"Governo M5S-Lega, l’ultima bozza: rivedere le sanzioni alla Russia e i trattati Ue","source":"www.corriere.it","description":"I temi: Fisco, giustizia, grandi opere, gioco d’azzardo, vaccini, migranti, sicurezza stradale, lavoro, reddito di cittadinanza","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuY29ycmllcmUuaXQvcG9saXRpY2EvY2FyZHMvZ292ZXJuby1tNXMtbGVnYS1w\naWFuby1sZWFkZXItc2FsdmluaS1tYWlvLTM5LXBhZ2luZS9jb21pdGF0by1jb25jaWxpYXppb25l\nLW1zLWxlZ2FfcHJpbmNpcGFsZS5zaHRtbA==","tags":["lega","movimento 5 stelle","russia"],"date_published":"2018-05-17 01:02:21","date_published_short":"17-05-2018","date_published_timestamp":"1526508000","popularity":"131808000","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"29","query":"m5s"},{"id":"7","query":"salvini"},{"id":"11","query":"lega"},{"id":"34","query":"\"di maio\""}],"popularity_logs":"37","tweets":{"number":"8","sentiment_average":"0.2500","sentiment_negative":"3","sentiment_neutral":"0","sentiment_positive":"5"}},{"id":"355722","title":"Contratto  di governo: taglio del debito e fuori dall’euro  «Bozza vecchia e superata»Allarme Ue, scatta il panico","source":"www.corriere.it","description":"L’Huffington Post svela la bozza. M a Lega e Cinque stelle replicano: «Bozza vecchia, l’Euro non è in discussione»","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuY29ycmllcmUuaXQvcG9saXRpY2EvMThfbWFnZ2lvXzE1L2NvbnRyYXR0by1t\nNXMtbGVnYS1ib3p6YS1hbmNoZS1jb21pdGF0by1jb25jaWxpYXJlLWIxMjNhYWU2LTU4NzAtMTFl\nOC05ZjJiLTdhZmI0MThmYjBjMC5zaHRtbA==","tags":["lega","movimento 5 stelle"],"date_published":"2018-05-16 01:01:31","date_published_short":"16-05-2018","date_published_timestamp":"1526421600","popularity":"67482700","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"29","query":"m5s"},{"id":"11","query":"lega"}],"popularity_logs":"38","tweets":{"number":"2","sentiment_average":"-0.5000","sentiment_negative":"1","sentiment_neutral":"1","sentiment_positive":"0"}},{"id":"355615","title":"Intervista a Giulio Sapelli: \"Stupito dai 5 stelle, forse vogliono decidere tutto...\"","source":"www.corriere.it","description":"\"Salvini è stato mio studente, ma non c'entra con la richiesta che mi è stata fatta\"","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuY29ycmllcmUuaXQvcG9saXRpY2EvMThfbWFnZ2lvXzE1L2dpdWxpby1zYXBl\nbGxpLXNvbm8tc3R1cGl0by01LXN0ZWxsZS12b2dsaW9uby1kZWNpZGVyZS10dXR0by1zYWx2aW5p\nLXN0YXRvLW1pby1zdHVkZW50ZS1tYS1ub24tYy1lbnRyYS03Y2NkY2Y5Mi01ODA3LTExZTgtOWYy\nYi03YWZiNDE4ZmIwYzAuc2h0bWw=","tags":["giulio sapelli","matteo salvini","movimento 5 stelle"],"date_published":"2018-05-15 14:10:35","date_published_short":"15-05-2018","date_published_timestamp":"1526335200","popularity":"123565000","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"7","query":"salvini"}],"popularity_logs":"37","tweets":{"number":"5","sentiment_average":"-0.8000","sentiment_negative":"4","sentiment_neutral":"1","sentiment_positive":"0"}},{"id":"355353","title":"Il governo Di Maio-Salvini si fa oggi? - Il Post","source":"www.ilpost.it","description":"Per Lega e M5S è – in teoria – il giorno in cui chiudere le trattative e andare al Quirinale: tutte le notizie man mano che arrivano","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxwb3N0Lml0LzIwMTgvMDUvMTQvZ292ZXJuby1zYWx2aW5pLWRpLW1haW8v","tags":["lega","luigi di maio","movimento 5 stelle","salvini","sergio mattarella"],"date_published":"2018-05-14 09:30:53","date_published_short":"14-05-2018","date_published_timestamp":"1526248800","popularity":"99476500","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"7","query":"salvini"},{"id":"34","query":"\"di maio\""}],"popularity_logs":"37","tweets":{"number":"4","sentiment_average":"-0.7500","sentiment_negative":"3","sentiment_neutral":"1","sentiment_positive":"0"}},{"id":"355204","title":"Governo, M5S: «Con la Lega si può chiudere già oggi»","source":"www.corriere.it","description":"Il portavoce Rocco Casalino: «Il programma è all’incirca sui venti punti, 15 li abbiamo affrontati, adesso vanno un po’ rivisti»","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuY29ycmllcmUuaXQvcG9saXRpY2EvMThfbWFnZ2lvXzEzL2dvdmVybm8tbTVz\nLWNvbi1sZWdhLXNpLXB1by1jaGl1ZGVyZS1vZ2dpLW1hLW5vbi1kZXR0by0yOGVhZWNmYy01Njg2\nLTExZTgtOGRjZS05ZTQ2NjAwMjU5MmUuc2h0bWw=","tags":["casalino","lega","movimento 5 stelle"],"date_published":"2018-05-13 10:43:45","date_published_short":"13-05-2018","date_published_timestamp":"1526162400","popularity":"43813100","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"29","query":"m5s"},{"id":"11","query":"lega"},{"id":"34","query":"\"di maio\""}],"popularity_logs":"39","tweets":{"number":"12","sentiment_average":"-1.0000","sentiment_negative":"12","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"354958","title":"Berlusconi si può di nuovo candidare, sì del giudice alla riabilitazione","source":"www.lastampa.it","description":"Ieri pomeriggio il Tribunale di Sorveglianza di Milano, in camera di consiglio, ha concesso la “riabilitazione” a Silvio Berlusconi cancellando di fatto tutti gli effetti della condanna subita nell’ag","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5sYXN0YW1wYS5pdC8yMDE4LzA1LzEyL2l0YWxpYS9iZXJsdXNjb25pLXNpLXB1\nLWRpLW51b3ZvLWNhbmRpZGFyZS1zLWRlbC1naXVkaWNlLWFsbGEtcmlhYmlsaXRhemlvbmUtM2V4\nU250cDFheFpQRElQMGJqS3I4Sy9wYWdpbmEuaHRtbA==","tags":["berlusconi","milano","silvio"],"date_published":"2018-05-12 08:09:44","date_published_short":"12-05-2018","date_published_timestamp":"1526076000","popularity":"32573600","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"5","query":"berlusconi"}],"popularity_logs":"40","tweets":{"number":"5","sentiment_average":"0.2000","sentiment_negative":"1","sentiment_neutral":"2","sentiment_positive":"2"}},{"id":"354786","title":"«Fatture false», chiesto il rinvio a giudizio  per i genitori di Matteo Renzi","source":"www.corriere.it","description":"Chiesto il processo per Tiziano Renzi e Laura Bovoli: avrebbero  emesso fatture false con le loro aziende di marketing","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuY29ycmllcmUuaXQvcG9saXRpY2EvMThfbWFnZ2lvXzExL2ZhdHR1cmUtZmFs\nc2UtY2hpZXN0by1wcm9jZXNzby1nZW5pdG9yaS1tYXR0ZW8tcmVuemktYzU4MjdlZmEtNTUwOS0x\nMWU4LWJmOTctNWY4ZDQyNzFlZTViLnNodG1s","tags":["bovoli","matteo renzi"],"date_published":"2018-05-11 13:10:57","date_published_short":"11-05-2018","date_published_timestamp":"1525989600","popularity":"65355400","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"65","query":"Renzi"},{"id":"66","query":"matteorenzi"}],"popularity_logs":"40","tweets":{"number":"18","sentiment_average":"-0.6667","sentiment_negative":"14","sentiment_neutral":"2","sentiment_positive":"2"}},{"id":"354582","title":"Le aziende di Silvio Berlusconi non si toccano: così il M5S ha perso l'anima","source":"espresso.repubblica.it","description":"Per dieci anni Grillo e i suoi hanno attaccato il centrosinistra perché non faceva una legge sul conflitto d'interessi. Avevano ragione, s'intende. Ma ora i pentastellati si stanno comportando allo stesso modo","url":"https://api.elezioni.io/click?u=aHR0cDovL2VzcHJlc3NvLnJlcHViYmxpY2EuaXQvYXR0dWFsaXRhLzIwMTgvMDUvMTAvbmV3cy9s\nZS1hemllbmRlLWRpLWJlcmx1c2Nvbmktbm9uLXNpLXRvY2Nhbm8tY29zaS1pbC1tNXMtaGEtcGVy\nc28tbC1hbmltYS0xLjMyMTcyNQ==","tags":["centrosinistra","m5s","silvio berlusconi"],"date_published":"2018-05-10 14:33:27","date_published_short":"10-05-2018","date_published_timestamp":"1525903200","popularity":"58233200","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"5","query":"berlusconi"},{"id":"29","query":"m5s"},{"id":"7","query":"salvini"}],"popularity_logs":"39","tweets":{"number":"69","sentiment_average":"-0.6232","sentiment_negative":"43","sentiment_neutral":"26","sentiment_positive":"0"}},{"id":"354340","title":"Il segnale di Di Maio a Berlusconi: “Nessun veto contro di lui”","source":"www.lastampa.it","description":"I leghisti avevano chiesto ai grillini «una dichiarazione per riconoscere la dignità di Forza Italia». L’ex Cavaliere non è più «il male assoluto»","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5sYXN0YW1wYS5pdC8yMDE4LzA1LzA5L2l0YWxpYS9pbC1zZWduYWxlLWRpLWRp\nLW1haW8tYS1iZXJsdXNjb25pLW5lc3N1bi12ZXRvLWNvbnRyby1kaS1sdWktM0lFYktFWkpoMlY0\nRmZpNGlpRnh6Sy9wYWdpbmEuaHRtbA==","tags":["forza italia","luigi di maio","movimento 5 stelle","silvio berlusconi"],"date_published":"2018-05-09 12:28:31","date_published_short":"09-05-2018","date_published_timestamp":"1525816800","popularity":"25079500","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"34","query":"\"di maio\""},{"id":"5","query":"berlusconi"},{"id":"35","query":"dimaio"},{"id":"29","query":"m5s"},{"id":"7","query":"salvini"},{"id":"11","query":"lega"},{"id":"16","query":"\"forza Italia\""}],"popularity_logs":"40","tweets":{"number":"32","sentiment_average":"-0.5000","sentiment_negative":"21","sentiment_neutral":"6","sentiment_positive":"5"}},{"id":"354116","title":"Torino, compra mezza pagina sul giornale per esprimere solidarietà a Mattarella","source":"torino.repubblica.it","description":"L'iniziativa dell'ex manager Fiat Callieri: \"E' l'ultimo padre della patria, si impegna per portarci fuori dalla palude\"","url":"https://api.elezioni.io/click?u=aHR0cDovL3Rvcmluby5yZXB1YmJsaWNhLml0L2Nyb25hY2EvMjAxOC8wNS8wOC9uZXdzL2NvbXBy\nYV9tZXp6YV9wYWdpbmFfc3VsX2dpb3JuYWxlX3Blcl9lc3ByaW1lcmVfc29saWRhcmlldGFfYV9t\nYXR0YXJlbGxhLTE5NTgwODA4MC8=","tags":["sergio mattarella","torino"],"date_published":"2018-05-08 11:18:39","date_published_short":"08-05-2018","date_published_timestamp":"1525730400","popularity":"127620000","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"97","query":"cavaliere"}],"popularity_logs":"39","tweets":{"number":"1","sentiment_average":"-1.0000","sentiment_negative":"1","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"353905","title":"Comincia il terzo giro di consultazioni - Il Post","source":"www.ilpost.it","description":"Per i partiti – soprattutto centrodestra e M5S – è probabilmente l'ultima possibilità per trovare un accordo: notizie e aggiornamenti man mano che arrivano","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxwb3N0Lml0LzIwMTgvMDUvMDcvdGVyem8tZ2lyby1jb25zdWx0YXppb25p\nLw==","tags":["centro destra","movimento 5 stelle"],"date_published":"2018-05-07 10:42:51","date_published_short":"07-05-2018","date_published_timestamp":"1525644000","popularity":"150767000","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"29","query":"m5s"},{"id":"7","query":"salvini"},{"id":"67","query":"gentiloni"}],"popularity_logs":"40","tweets":{"number":"4","sentiment_average":"-1.0000","sentiment_negative":"4","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"353812","title":"L’ipotesi del Colle, premier donna e una squadra di super competenti","source":"www.lastampa.it","description":"Sono stati valutati tre nomi su tutti, quelli di Gianotti, Reichlin, Cartabia. Severino poco amata in Fi, firmò la legge che fece decadere Berlusconi","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5sYXN0YW1wYS5pdC8yMDE4LzA1LzA2L2l0YWxpYS9saXBvdGVzaS1kZWwtY29s\nbGUtcHJlbWllci1kb25uYS1lLXVuYS1zcXVhZHJhLWRpLXN1cGVyLWNvbXBldGVudGktaWg2QW41\nSnl6Z3JJd3h0czNTb2xNTC9wYWdpbmEuaHRtbA==","tags":["fabiola gianotti","forza italia","silvio berlusconi"],"date_published":"2018-05-06 17:30:01","date_published_short":"06-05-2018","date_published_timestamp":"1525557600","popularity":"28601200","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"27","query":"grillo"},{"id":"15","query":"forzaitalia"}],"popularity_logs":"38","tweets":{"number":"1","sentiment_average":"0.0000","sentiment_negative":"0","sentiment_neutral":"1","sentiment_positive":"0"}},{"id":"353589","title":"Blog | Di come il Pd persegue indefesso la strada per la sua auto-rottamazione - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"di Marco Gigante L’onorevole Maurizio Martina ha dichiarato nel corso della Direzione nazionale del Partito Democratico che è da ritenersi esclusa la possibilità di un accordo con il Movimento 5 stelle o, in generale, con qualsiasi altra forza politica italiana. La notizia di per sé non stupisce più di tanto, e anzi si può dire …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wNS8wNS9kaS1jb21lLWlsLXBk\nLXBlcnNlZ3VlLWluZGVmZXNzby1sYS1zdHJhZGEtcGVyLWxhLXN1YS1hdXRvLXJvdHRhbWF6aW9u\nZS80MzM0NTEzLw==","tags":["martina","pd"],"date_published":"2018-05-05 10:26:43","date_published_short":"05-05-2018","date_published_timestamp":"1525471200","popularity":"19396000","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"69","query":"pd"}],"popularity_logs":"37","tweets":{"number":"5","sentiment_average":"-1.0000","sentiment_negative":"5","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"353497","title":"a salvini torna duro e fa profferte amorose a di maio: insieme fino a natale. mai con renzi","source":"www.dagospia.com","description":"     1 - SALVINI, GOVERNO CON M5S FINO A DICEMBRE MA NO TECNICI       salvini     (ANSA) - \"Se di governo tecnico, di scopo o istituzionale, l'incarico va dato partendo da chi ha vinto le elezioni, escludo qualsiasi tecnico alla Monti. E ribadisco l'invito a M5S come fare insieme","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5kYWdvc3BpYS5jb20vcnVicmljYS0zL3BvbGl0aWNhL2Fycml2YW5vLWNsb3du\nLXNhbHZpbmktdG9ybmEtZHVyby1mYS1wcm9mZmVydGUtYW1vcm9zZS1tYWlvLTE3MzAzNi5odG0=","tags":["salvini"],"date_published":"2018-05-04 18:10:49","date_published_short":"04-05-2018","date_published_timestamp":"1525384800","popularity":"23575800","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"7","query":"salvini"},{"id":"34","query":"\"di maio\""},{"id":"65","query":"Renzi"}],"popularity_logs":"38","tweets":{"number":"2","sentiment_average":"-1.0000","sentiment_negative":"2","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"353137","title":"Il caffè di Gramellini - Da Catone a Catello. L'avvocato Vitiello espulso dal M5S","source":"www.corriere.it","description":"In principio Catello era Catone, della Censore Associati. Fustigatore di chiunque avesse le mani in Casta. Invece che...","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuY29ycmllcmUuaXQvY2FmZmUtZ3JhbWVsbGluaS8xOF9tYWdnaW9fMDIvY2Fm\nZmUtZ3JhbWVsbGluaS1kYS1jYXRvbmUtY2F0ZWxsby12aXRpZWxsby1jaW5xdWUtc3RlbGxlLXN0\naXBlbmRpby1jYXN0ZWxsYW1tYXJlLTM1NzQ4N2IyLTRlM2UtMTFlOC05OGEzLTNiNTY1Nzc1NWMx\nMS5zaHRtbA==","tags":["catello vitiello","movimento 5 stelle"],"date_published":"2018-05-03 09:00:59","date_published_short":"03-05-2018","date_published_timestamp":"1525298400","popularity":"21892200","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"29","query":"m5s"},{"id":"11","query":"lega"}],"popularity_logs":"36","tweets":{"number":"2","sentiment_average":"-1.0000","sentiment_negative":"2","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"352915","title":"Salvini: «Mai con il Pd. I M5s stiano con noi o elezioni subito» Sulla ruspa - Video","source":"www.corriere.it","description":"Il segretario della Lega: «Siamo la prima forza del Paese». Poi si è detto disponibile a un pre-incarico","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5jb3JyaWVyZS5pdC9wb2xpdGljYS8xOF9tYWdnaW9fMDEvc2FsdmluaS1tYWkt\naWwtcGQtY2lucXVlLXN0ZWxsZS1zdGlhbm8tbm9pLW8tZWxlemlvbmktc3ViaXRvLWNkMWFhZGI0\nLTRkN2UtMTFlOC1hMWNmLWQ2MGFiZGIxY2U4Ny5zaHRtbD9jbXBpZD10YmRfN2NhMDNiNTBpTQ==","tags":["lega","m5s","matteo salvini","pd"],"date_published":"2018-05-02 00:56:33","date_published_short":"02-05-2018","date_published_timestamp":"1525212000","popularity":"17382000","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"69","query":"pd"},{"id":"7","query":"salvini"},{"id":"29","query":"m5s"}],"popularity_logs":"37","tweets":{"number":"4","sentiment_average":"-1.0000","sentiment_negative":"4","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"352907","title":"Governo, Salvini: \"Un esecutivo istituzionale non mi piace. Chiederò un preincarico\"","source":"www.repubblica.it","description":"\"Ci proverò fino all'ultimo, ma partendo dal centrodestra che è la prima coalizione e ha vinto in Molise e Friuli\". Il leader del","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5yZXB1YmJsaWNhLml0L3BvbGl0aWNhLzIwMTgvMDUvMDEvbmV3cy9nb3Zlcm5v\nX3NhbHZpbmlfdW5fZXNlY3V0aXZvX2lzdGl0dXppb25hbGVfbm9uX21pX3BpYWNlX2NoaWVkZXJv\nX3VuX3ByZS1pbmNhcmljb18tMTk1Mjc3MDk3Lw==","tags":["centro destra","matteo salvini"],"date_published":"2018-05-01 22:14:42","date_published_short":"01-05-2018","date_published_timestamp":"1525125600","popularity":"23961200","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"7","query":"salvini"}],"popularity_logs":"38","tweets":{"number":"13","sentiment_average":"-0.8462","sentiment_negative":"12","sentiment_neutral":"0","sentiment_positive":"1"}},{"id":"352677","title":"Governo, Di Maio a Salvini: 'Chiediamo al Quirinale il voto a giugno' - Politica","source":"www.ansa.it","description":"Il leader M5s: 'Sapevo che non era facile, mai immaginato che fosse impossibile'\r\n\r\n(ANSA)","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5hbnNhLml0L3NpdG8vbm90aXppZS9wb2xpdGljYS8yMDE4LzA0LzMwL2dvdmVy\nbm8tZGktbWFpby1wYXJ0aXRpLXBlbnNhbm8tc29sby1sb3JvLWludGVyZXNzaS12ZXJnb2duYV8x\nY2U1OGIyNi03Y2E4LTRhODQtODE5ZC0yZDNhMjUzYTUzNTYuaHRtbA==","tags":["luigi di maio","matteo salvini","movimento 5 stelle","sergio mattarella"],"date_published":"2018-04-30 13:39:36","date_published_short":"30-04-2018","date_published_timestamp":"1525039200","popularity":"36664800","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"7","query":"salvini"},{"id":"34","query":"\"di maio\""},{"id":"11","query":"lega"},{"id":"35","query":"dimaio"},{"id":"29","query":"m5s"},{"id":"69","query":"pd"}],"popularity_logs":"41","tweets":{"number":"31","sentiment_average":"-0.0968","sentiment_negative":"14","sentiment_neutral":"6","sentiment_positive":"11"}},{"id":"352571","title":"Roma, primarie del centrosinistra nei Municipi III e VIII: sconfitti candidati del Pd. \"Il primo a perdere è stato Orfini\" - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"Con le vittorie di Amedeo Ciaccheri e Giovanni Caudo, Roma mette in crisi il modello di partito creato da Matteo Renzi e, soprattutto, sembra chiedere un importante passo indietro di Matteo Orfini. Le primarie del centrosinistra nei municipi romani al voto in estate (Montesacro e Garbatella) sanciscono il fallimento in città della classe dirigente voluta dai fedelissimi …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wNC8yOS9yb21hLXByaW1hcmll\nLWRlbC1jZW50cm9zaW5pc3RyYS1uZWktbXVuaWNpcGktaWlpLWUtdmlpaS1zY29uZml0dGktY2Fu\nZGlkYXRpLWRlbC1wZC1pbC1wcmltby1hLXBlcmRlcmUtZS1zdGF0by1vcmZpbmkvNDMyNDAyNS8=","tags":["centrosinistra","matteo renzi","pd","roma"],"date_published":"2018-04-29 19:36:08","date_published_short":"29-04-2018","date_published_timestamp":"1524952800","popularity":"7731410","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"69","query":"pd"}],"popularity_logs":"39","tweets":{"number":"7","sentiment_average":"-0.5714","sentiment_negative":"4","sentiment_neutral":"3","sentiment_positive":"0"}},{"id":"352335","title":"Il sondaggio di Pagnoncelli: la base 5 Stelle vuole l'intesa con la Lega (59%)","source":"www.corriere.it","description":"Solo il 16 per cento degli elettori M5S vuole l'intesa con il Pd","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuY29ycmllcmUuaXQvcG9saXRpY2EvMThfYXByaWxlXzI3L3NvbmRhZ2dpLTUt\nc3RlbGxlLXByZWZlcmlzY29uby1sZWdhLTYtZWxldHRvcmktMTAtdm9nbGlvbm8tbC1pbnRlc2Et\naWwtZ292ZXJuby02ZGIyOTY1Yy00YTRmLTExZTgtYTMwYS0xMzRiODhiNWFmZGEuc2h0bWw=","tags":["lega","m5s","movimento 5 stelle","pagnoncelli","pd"],"date_published":"2018-04-28 07:37:16","date_published_short":"28-04-2018","date_published_timestamp":"1524866400","popularity":"46511600","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"11","query":"lega"}],"popularity_logs":"37","tweets":{"number":"18","sentiment_average":"-0.8889","sentiment_negative":"16","sentiment_neutral":"2","sentiment_positive":"0"}},{"id":"352161","title":"Il Buongiorno di Feltri: Demogrillini","source":"www.lastampa.it","description":"Andare al governo coi grillini o non andare al governo coi grillini? Dentro il partito democratico ci sono i favorevoli e gli sfavorevoli, con tutte le sfumature comprese fra le due posizioni, e poi c","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5sYXN0YW1wYS5pdC8yMDE4LzA0LzI3L2N1bHR1cmEvZGVtb2dyaWxsaW5pLVp0\nd3Z0T2ozNnFtdkNORXNnZlBlek8vcGFnaW5hLmh0bWw=","tags":["movimento 5 stelle","pd","vittorio feltri"],"date_published":"2018-04-27 08:39:15","date_published_short":"27-04-2018","date_published_timestamp":"1524780000","popularity":"33139100","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"29","query":"m5s"},{"id":"69","query":"pd"},{"id":"66","query":"matteorenzi"}],"popularity_logs":"39","tweets":{"number":"2","sentiment_average":"-1.0000","sentiment_negative":"2","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"352107","title":"Governo M5s-Pd, la rivolta dei renziani: “Diremo no in direzione, non svenderemo nostri valori”","source":"www.fanpage.it","description":"La possibilità di confrontarsi con il M5s e trovare un accordo di governo verrà votata dalla direzione del Pd del 3 maggio, ma una grossa fetta di esponenti...","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuZmFucGFnZS5pdC9nb3Zlcm5vLW01cy1wZC1sYS1yaXZvbHRhLWRlaS1yZW56\naWFuaS1kaXJlbW8tbm8taW4tZGlyZXppb25lLW5vbi1zdmVuZGVyZW1vLW5vc3RyaS12YWxvcmkv","tags":["movimento 5 stelle","pd"],"date_published":"2018-04-26 19:40:59","date_published_short":"26-04-2018","date_published_timestamp":"1524693600","popularity":"27048500","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"29","query":"m5s"},{"id":"69","query":"pd"}],"popularity_logs":"39","tweets":{"number":"10","sentiment_average":"-1.0000","sentiment_negative":"10","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"351931","title":"Renzi rafforza il no al M5s, fondativo di un \"nuovo inizio\". I suoi: se la direzione boccia Martina, non può essere più reggente del Pd","source":"www.huffingtonpost.it","description":"Il pressing nel partito non smuove il segretario dimissionario. E Marcucci riunisce i senatori prima della direzione: 35 sono per il no","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaHVmZmluZ3RvbnBvc3QuaXQvMjAxOC8wNC8yNS9yZW56aS1yYWZmb3J6YS1p\nbC1uby1hbC1tNXMtZm9uZGF0aXZvLWRpLXVuLW51b3ZvLWluaXppby1pLXN1b2ktc2UtbGEtZGly\nZXppb25lLWJvY2NpYS1tYXJ0aW5hLW5vbi1wdW8tZXNzZXJlLXBpdS1yZWdnZW50ZS1kZWwtcGRf\nYV8yMzQxOTk3My8=","tags":["marcucci","martina","pd","renzi"],"date_published":"2018-04-25 21:07:29","date_published_short":"25-04-2018","date_published_timestamp":"1524607200","popularity":"56936400","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"65","query":"Renzi"},{"id":"29","query":"m5s"},{"id":"66","query":"matteorenzi"}],"popularity_logs":"39","tweets":{"number":"9","sentiment_average":"-1.0000","sentiment_negative":"9","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"351544","title":"In Edicola sul Fatto Quotidiano del 24 aprile: Ultimo giro. Fico chiama il Pd, renziani fuori di testa - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"Ultimo giro. Fico chiama il Pd, renziani fuori di testa. E Di Maio saluta Salvini. Mattarella lo incarica, Orfini e Marcucci lo sabotano, Martina li ferma","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wNC8yNC9pbi1lZGljb2xhLXN1\nbC1mYXR0by1xdW90aWRpYW5vLWRlbC0yNC1hcHJpbGUtdWx0aW1vLWdpcm8tZmljby1jaGlhbWEt\naWwtcGQtcmVuemlhbmktZnVvcmktZGktdGVzdGEvNDMxMjUwMi8=","tags":["pd"],"date_published":"2018-04-24 00:49:11","date_published_short":"24-04-2018","date_published_timestamp":"1524520800","popularity":"13802200","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"69","query":"pd"}],"popularity_logs":"35","tweets":{"number":"2","sentiment_average":"-1.0000","sentiment_negative":"2","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"351347","title":"Voto in Molise, lo spoglio: è testa a testa tra centrodestra e M5s dopo le prime sezioni scrutinate","source":"www.repubblica.it","description":"I risultati in tempo reale di un voto regionale che può avere importanti ripercussioni sul nuovo governo. M5s alla ricerca di una conferma, i partiti","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5yZXB1YmJsaWNhLml0L3BvbGl0aWNhLzIwMTgvMDQvMjMvbmV3cy9yaXN1bHRh\ndGlfbW9saXNlX2VsZXppb25pX201c19jZW50cm9kZXN0cmFfdG9tYV9ncmVjb19nb3Zlcm5vLTE5\nNDU3NTgwMi8/cmVmPXR3aHI=","tags":["centro destra","molise","movimento 5 stelle"],"date_published":"2018-04-23 00:45:07","date_published_short":"23-04-2018","date_published_timestamp":"1524434400","popularity":"495852000","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"29","query":"m5s"},{"id":"11","query":"lega"},{"id":"16","query":"\"forza Italia\""}],"popularity_logs":"36","tweets":{"number":"13","sentiment_average":"-0.0769","sentiment_negative":"1","sentiment_neutral":"12","sentiment_positive":"0"}},{"id":"351328","title":"Stato-Mafia: Pm Di Matteo: 'Dell'Utri tramite dopo il '92' - Cronaca","source":"www.ansa.it","description":"'Da Anm e Csm nessuna difesa. Silenzio assordante, chi speravamo ci difendesse ha taciuto'. La\r\nreplica dell'Anm, sempre difeso magistrati attaccati\r\n\r\n(ANSA)","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5hbnNhLml0L3NpdG8vbm90aXppZS9jcm9uYWNhLzIwMTgvMDQvMjIvc3RhdG8t\nbWFmaWEtcG0tZGktbWF0dGVvLWRlbGx1dHJpLXRyYW1pdGUtZG9wby1pbC05Ml9mNjRjOWQ4OC0w\nYzM2LTRlZTItYjFhZi01ZWIxMjFhODljMjQuaHRtbA==","tags":["marcello dell'utri","matteo"],"date_published":"2018-04-22 20:23:45","date_published_short":"22-04-2018","date_published_timestamp":"1524348000","popularity":"54057800","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"5","query":"berlusconi"}],"popularity_logs":"34","tweets":{"number":"2","sentiment_average":"0.0000","sentiment_negative":"1","sentiment_neutral":"0","sentiment_positive":"1"}},{"id":"351120","title":"Governo, Sala: \"Accordo con M5s? Auspico di sì. Il Pd parla troppo a sé stesso, bisogna guardare al futuro\" - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"“Auspico di sì. Su alcuni principi fondamentali bisogna intendersi. Tra reddito di cittadinanza e il nostro welfare solidale è chiaro che il modello giusto sia il nostro, però bisogna parlare con tutti”. Con queste parole il sindaco di Milano Giuseppe Sala ha risposto a chi gli ha chiesto se vede di buon occhio un possibile accordo …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wNC8yMS9nb3Zlcm5vLXNhbGEt\nYWNjb3Jkby1jb24tbTVzLWF1c3BpY28tZGktc2ktaWwtcGQtcGFybGEtdHJvcHBvLWEtc2Utc3Rl\nc3NvLWJpc29nbmEtZ3VhcmRhcmUtYWwtZnV0dXJvLzQzMDczMDMv","tags":["pd","sala"],"date_published":"2018-04-21 12:44:07","date_published_short":"21-04-2018","date_published_timestamp":"1524261600","popularity":"60745500","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"29","query":"m5s"},{"id":"69","query":"pd"}],"popularity_logs":"37","tweets":{"number":"2","sentiment_average":"-1.0000","sentiment_negative":"2","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"350865","title":"Regionali, il Molise diventa laboratorio nazionale: sfida tra M5s e centrodestra. L'uomo di Fi e Lega era con centrosinistra - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"Il piccolo Molise laboratorio d’Italia? A sentire il leader della Lega, Matteo Salvini, i circa 332mila elettori che domenica prossima saranno chiamati alle urne avranno un compito che va al di là del semplice rinnovo del Consiglio regionale. “Se vinciamo in Friuli (dove si vota il 29 aprile, nda) e in Molise nel giro di 15 …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wNC8yMC9yZWdpb25hbGktaWwt\nbW9saXNlLWRpdmVudGEtbGFib3JhdG9yaW8tbmF6aW9uYWxlLXNmaWRhLXRyYS1tNXMtZS1jZW50\ncm9kZXN0cmEtbHVvbW8tZGktZmktZS1sZWdhLWVyYS1jb24tY2VudHJvc2luaXN0cmEvNDMwMDg3\nOC8=","tags":["centrodestra","centrosinistra","fi","lega"],"date_published":"2018-04-20 08:24:07","date_published_short":"20-04-2018","date_published_timestamp":"1524175200","popularity":"47189500","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"11","query":"lega"},{"id":"29","query":"m5s"}],"popularity_logs":"39","tweets":{"number":"7","sentiment_average":"-0.2857","sentiment_negative":"2","sentiment_neutral":"5","sentiment_positive":"0"}},{"id":"350667","title":"M5S, Toninelli: \"Mai con Berlusconi. Spero in un patto con il Pd\"","source":"www.repubblica.it","description":"Il capogruppo al Senato del M5S: \"Se fallisce Casellati contratto di governo con il Pd\". Serracchiani a Circo Massimo: \"Alternativi a chi ha","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5yZXB1YmJsaWNhLml0L3BvbGl0aWNhLzIwMTgvMDQvMTkvbmV3cy9wZF9zZXJy\nYWNjaGlhbmlfY2lucXVlX3N0ZWxsZV9pcnJlc3BvbnNhYmlsaV9lX2lsX2NlbnRyb2Rlc3RyYV9u\nb25fc2lfc2Npb2dsaWVyYV8tMTk0MjY4MDM5Lw==","tags":["debora serracchiani","m5s","maria elisabetta alberti casellati","movimento 5 stelle","pd","silvio berlusconi","toninelli"],"date_published":"2018-04-19 09:28:33","date_published_short":"19-04-2018","date_published_timestamp":"1524088800","popularity":"151766000","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"4","name":"Sinistra","slug":"sinistra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"5","query":"berlusconi"},{"id":"29","query":"m5s"},{"id":"69","query":"pd"},{"id":"7","query":"salvini"},{"id":"65","query":"Renzi"},{"id":"25","query":"boldrini"},{"id":"23","query":"grasso"},{"id":"34","query":"\"di maio\""},{"id":"16","query":"\"forza Italia\""},{"id":"11","query":"lega"}],"popularity_logs":"40","tweets":{"number":"78","sentiment_average":"-0.6154","sentiment_negative":"59","sentiment_neutral":"8","sentiment_positive":"11"}},{"id":"350439","title":"Governo, Mattarella convoca Casellati: parte la missione esplorativa","source":"www.repubblica.it","description":"La presidente del Senato riceverà l'incarico al Quirinale. Poi via ai colloqui con le forze politiche a Palazzo Giustiniani per verificare","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5yZXB1YmJsaWNhLml0L3BvbGl0aWNhLzIwMTgvMDQvMTgvbmV3cy9nb3Zlcm5v\nX2VfaWxfZ2lvcm5vX2RlbF9tYW5kYXRvX2FfY2FzZWxsYXRpX3BhcnRlX2xhX21pc3Npb25lX2Vz\ncGxvcmF0aXZhLTE5NDE2NDkxMS8=","tags":["mattarella convoca casellati","sergio mattarella"],"date_published":"2018-04-18 09:35:59","date_published_short":"18-04-2018","date_published_timestamp":"1524002400","popularity":"96263100","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"5","query":"berlusconi"},{"id":"15","query":"forzaitalia"},{"id":"67","query":"gentiloni"},{"id":"29","query":"m5s"}],"popularity_logs":"40","tweets":{"number":"6","sentiment_average":"0.0000","sentiment_negative":"1","sentiment_neutral":"4","sentiment_positive":"1"}},{"id":"350262","title":"Differenze tra il programma M5S votato online e la realpolitik di Di Maio","source":"www.corriere.it","description":"Nato, Medio Oriente, Russia, euro, lavoro: il Movimento ha assunto posizioni più moderate, cambiando i testi scritti","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5jb3JyaWVyZS5pdC9wb2xpdGljYS9jYXJkcy9tNXMtZGlmZmVyZW56ZS1pbC1w\ncm9ncmFtbWEtdm90YXRvLW9ubGluZS1yZWFscG9saXRpay1hdHR1YWxlLWRpLW1haW8vcHJvc3Bl\ndHRpdmUtZGl2ZXJzZV9wcmluY2lwYWxlLnNodG1sP2NtcGlkPXRiZF84NjY1NzZjYlFs","tags":["luigi di maio","movimento 5 stelle","russia"],"date_published":"2018-04-17 13:11:48","date_published_short":"17-04-2018","date_published_timestamp":"1523916000","popularity":"42381400","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"29","query":"m5s"},{"id":"34","query":"\"di maio\""}],"popularity_logs":"39","tweets":{"number":"14","sentiment_average":"-1.0000","sentiment_negative":"14","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"350046","title":"Governo, Calenda: \"Il Pd non può restare immobile, si faccia promotore di un esecutivo di transizione con tutti\" - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"“Il Pd non può restare immobile, deve farsi promotore di una proposta per uscire dallo stallo. Deve mettere sul banco l’idea di un governo di transizione sostenuto da tutte le forze politiche e parallelamente la formazione di una commissione bicamerale sulle riforme istituzionali”. Tutto per sbloccare un’impasse potenzialmente deleteria per l’Italia in un momento di …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wNC8xNi9nb3Zlcm5vLWNhbGVu\nZGEtaWwtcGQtbm9uLXB1by1yZXN0YXJlLWltbW9iaWxlLXNpLWZhY2NpYS1wcm9tb3RvcmUtZGkt\ndW4tZXNlY3V0aXZvLWRpLXRyYW5zaXppb25lLWNvbi10dXR0aS80Mjk1NTA0Lw==","tags":["pd"],"date_published":"2018-04-16 11:34:10","date_published_short":"16-04-2018","date_published_timestamp":"1523829600","popularity":"29448300","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"69","query":"pd"}],"popularity_logs":"40","tweets":{"number":"4","sentiment_average":"-0.2500","sentiment_negative":"1","sentiment_neutral":"3","sentiment_positive":"0"}},{"id":"349948","title":"\"Non solo vitalizi, gli onorevoli hanno un altro privilegio\"","source":"www.huffingtonpost.it","description":"Il presidente dell'Inps spiega il meccanismo degli oneri figurativi (a carico della collettività): \"Ho scritto a Fico ma non ho ricevuto risposta\"","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaHVmZmluZ3RvbnBvc3QuaXQvMjAxOC8wNC8xNS90aXRvLWJvZXJpLWEtbWV6\nem9yYS1pbi1waXUtbm9uLXNvbG8tdml0YWxpemktZ2xpLW9ub3Jldm9saS1oYW5uby11bi1hbHRy\nby1wcml2aWxlZ2lvX2FfMjM0MTE2Mzgv","tags":["roberto fico"],"date_published":"2018-04-15 17:40:35","date_published_short":"15-04-2018","date_published_timestamp":"1523743200","popularity":"25037800","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"29","query":"m5s"},{"id":"27","query":"grillo"}],"popularity_logs":"40","tweets":{"number":"35","sentiment_average":"-1.0000","sentiment_negative":"35","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"349684","title":"Venticinque anni di monetine","source":"www.lastampa.it","description":"«Sono forze politiche che dimostrano di non avere la minima consapevolezza della richiesta di pulizia che viene dalla gente». Chi l’ha detta? Luigi Di Maio? Matteo Salvini? No, l’ha detta Massimo D’Al","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5sYXN0YW1wYS5pdC8yMDE4LzA0LzE0L2N1bHR1cmEvb3BpbmlvbmkvYnVvbmdp\nb3Juby92ZW50aWNpbnF1ZS1hbm5pLWRpLW1vbmV0aW5lLXV4d09KM0lCdWlaZHFycDZkUGVqd0sv\ncHJlbWl1bS5odG1s","tags":["luigi di maio","matteo salvini"],"date_published":"2018-04-14 03:10:04","date_published_short":"14-04-2018","date_published_timestamp":"1523656800","popularity":"6848790","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"7","query":"salvini"},{"id":"34","query":"\"di maio\""},{"id":"36","query":"\"luigi di maio\""}],"popularity_logs":"39","tweets":{"number":"1","sentiment_average":"-1.0000","sentiment_negative":"1","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"349524","title":"Governo, la carta di Mattarella: mandato esplorativo. Prima scelta Casellati. Lei: \"Se me lo chiede il presidente, ci sono\" - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"Mattarella ha rovesciato la clessidra. Il tempo concesso ai partiti sta per scadere. Dalle nebbie si definisce sempre di più la linea che porta a tre strade possibili, su cui concordano i quirinalisti dei principali giornali. La prima, quella più quotata: il mandato esplorativo alla presidente del Senato Maria Elisabetta Alberti Casellati. La seconda, in …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wNC8xMy9nb3Zlcm5vLWxhLWNh\ncnRhLWRpLW1hdHRhcmVsbGEtbWFuZGF0by1lc3Bsb3JhdGl2by1wcmltYS1zY2VsdGEtY2FzZWxs\nYXRpLWxlaS1zZS1tZS1sby1jaGllZGUtaWwtcHJlc2lkZW50ZS1jaS1zb25vLzQyOTAwOTMv","tags":["mattarella"],"date_published":"2018-04-13 11:37:42","date_published_short":"13-04-2018","date_published_timestamp":"1523570400","popularity":"19854400","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"69","query":"pd"}],"popularity_logs":"39","tweets":{"number":"1","sentiment_average":"-1.0000","sentiment_negative":"1","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"349404","title":"Siria, Gentiloni: \"L'Italia non parteciperà ad azioni militari\". Macron: \"Abbiamo prove su uso gas\"","source":"www.repubblica.it","description":"Trump avvisa Putin e Assad: \"Prenderò presto una decisione\". E il premier italiano, a colloquio con i ministri degli Esteri e della Difesa e","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5yZXB1YmJsaWNhLml0L2VzdGVyaS8yMDE4LzA0LzEyL25ld3Mvc2lyaWFfYmFu\nZGllcmFfZ292ZXJuYXRpdmFfYV9kb3VtYV9yZWdpbWVfcmlwcmVuZGVfY29udHJvbGxvX2RpX2do\nb3V0YV9lc3QtMTkzNjQ4NjAwLw==","tags":["donald trump","emmanuel macron","paolo gentiloni","siria","vladimir putin"],"date_published":"2018-04-12 18:58:07","date_published_short":"12-04-2018","date_published_timestamp":"1523484000","popularity":"158095000","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"67","query":"gentiloni"}],"popularity_logs":"40","tweets":{"number":"20","sentiment_average":"-0.8000","sentiment_negative":"18","sentiment_neutral":"0","sentiment_positive":"2"}},{"id":"349119","title":"\"Berlusconi è il male assoluto\". L'affondo di Di Battista","source":"www.huffingtonpost.it","description":"\"Non tollero che il mio Paese sia ancora governato da quei soggetti che l'hanno portato alla rovina\"","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaHVmZmluZ3RvbnBvc3QuaXQvMjAxOC8wNC8xMS9hbGVzc2FuZHJvLWRpLWJh\ndHRpc3RhLXNpbHZpby1iZXJsdXNjb25pLWUtaWwtbWFsZS1hc3NvbHV0b19hXzIzNDA4NTgxLw==","tags":["alessandro di battista","silvio berlusconi"],"date_published":"2018-04-11 14:57:09","date_published_short":"11-04-2018","date_published_timestamp":"1523397600","popularity":"14885800","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"5","query":"berlusconi"},{"id":"37","query":"\"di battista\""},{"id":"29","query":"m5s"},{"id":"38","query":"dibattista"},{"id":"39","query":"dibba"}],"popularity_logs":"40","tweets":{"number":"64","sentiment_average":"0.3750","sentiment_negative":"4","sentiment_neutral":"32","sentiment_positive":"28"}},{"id":"348878","title":"Blog | Il discorso di Giuseppe Provenzano, quel che dovrebbe essere il Pd","source":"www.ilfattoquotidiano.it","description":"Non ho mai votato Pd. Eppure sono di sinistra. Forse non l’ho mai votato proprio perché vengo dalla sinistra. Mi è sempre parso un partito nato morto: una fusione a freddo tra democristiani e quasi-comunisti nata male e finita peggio. L’ha spiegato più volte benissimo Massimo Cacciari, che poi però (chissà perché) lo vota sempre. …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wNC8xMC9pbC1kaXNjb3Jzby1k\naS1naXVzZXBwZS1wcm92ZW56YW5vLWEtc2luaXN0cmEtYW5uby16ZXJvLXF1ZWwtY2hlLWRvdnJl\nYmJlLWVzc2VyZS1pbC1wZC80MjgzNzc2Lw==","tags":["giuseppe provenzano","pd"],"date_published":"2018-04-10 14:06:01","date_published_short":"10-04-2018","date_published_timestamp":"1523311200","popularity":"45675200","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"69","query":"pd"}],"popularity_logs":"39","tweets":{"number":"21","sentiment_average":"-0.7143","sentiment_negative":"15","sentiment_neutral":"6","sentiment_positive":"0"}},{"id":"348612","title":"Nuovo governo, Orlando: ''Contratto di Di Maio poco credibile, meno slogan e più contenuti''","source":"video.repubblica.it","description":"'Non so se ci sono le condizioni' per un dialogo con il M5s sul governo, 'ho forti dubbi, partiamo da punti molto distanti tra loro'. Così Andrea...","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly92aWRlby5yZXB1YmJsaWNhLml0L3BvbGl0aWNhL251b3ZvLWdvdmVybm8tb3JsYW5k\nby0tY29udHJhdHRvLWRpLWRpLW1haW8tcG9jby1jcmVkaWJpbGUtbWVuby1zbG9nYW4tZS1waXUt\nY29udGVudXRpLzMwMTc0NS8zMDIzNzM/cmVmPXR3aHY=","tags":["andrea","andrea orlando","luigi di maio","movimento 5 stelle"],"date_published":"2018-04-09 09:54:11","date_published_short":"09-04-2018","date_published_timestamp":"1523224800","popularity":"17445600","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"69","query":"pd"},{"id":"34","query":"\"di maio\""}],"popularity_logs":"37","tweets":{"number":"3","sentiment_average":"-1.0000","sentiment_negative":"3","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"348415","title":"Renzi: «Niente alleanze con M5S. Fanno tranelli, vogliono solo dividerci»","source":"www.corriere.it","description":"L’ex segretario fa muro contro l’intesa con Di Maio. E intanto prepara il campo per la resa dei conti all’assemblea del 21 aprile","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5jb3JyaWVyZS5pdC9wb2xpdGljYS8xOF9hcHJpbGVfMDcvcmVuemktbmllbnRl\nLWFsbGVhbnplLXBkLWxvcm8tbTVzLWZhLXRyYW5lbGxpLXZ1b2xlLXNvbG8tZGl2aWRlcmNpLTll\nYWEwMTZlLTNhOWItMTFlOC1hOTRjLTdjMzBlMzEwOWM0ZC5zaHRtbD9jbXBpZD10YmRfNmQ0ZDk0\nNzVhYw==","tags":["luigi di maio","matteo renzi","movimento 5 stelle"],"date_published":"2018-04-08 00:48:02","date_published_short":"08-04-2018","date_published_timestamp":"1523138400","popularity":"101769000","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"69","query":"pd"},{"id":"65","query":"Renzi"},{"id":"29","query":"m5s"}],"popularity_logs":"36","tweets":{"number":"26","sentiment_average":"-1.0000","sentiment_negative":"26","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"348402","title":"\"Parlare con tutti\". Ma non con Iacoboni","source":"www.huffingtonpost.it","description":"In difficoltà per la trattativa sul governo, M5s torna in paranoia sul controllo della comunicazione","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaHVmZmluZ3RvbnBvc3QuaXQvbHVjaWEtYW5udW56aWF0YS9wYXJsYXJlLWNv\nbi10dXR0aS1tYS1ub24tY29uLWlhY29ib25pX2FfMjM0MDU1NDgv","tags":["comunicazione","iacoboni","movimento 5 stelle"],"date_published":"2018-04-07 21:10:16","date_published_short":"07-04-2018","date_published_timestamp":"1523052000","popularity":"31971500","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"29","query":"m5s"}],"popularity_logs":"37","tweets":{"number":"1","sentiment_average":"-1.0000","sentiment_negative":"1","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"348093","title":"Premier terzo, con la Lega. La via d’uscita di Casaleggio","source":"www.lastampa.it","description":"Dietro l’addio di Giannuli la presa d’atto dell’intesa. Il leghista Giorgetti, che tiene i contatti: opzione possibile, a patto sia un politico","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5sYXN0YW1wYS5pdC8yMDE4LzA0LzA2L2l0YWxpYS9wb2xpdGljYS9wcmVtaWVy\nLXRlcnpvLWNvbi1sYS1sZWdhLWxhLXZpYS1kdXNjaXRhLWRpLWNhc2FsZWdnaW8tbWhPTWZvSlhV\nRUVTSElhYUVGMERlTy9wYWdpbmEuaHRtbA==","tags":["casaleggio","giorgetti","lega","possibile"],"date_published":"2018-04-06 07:26:02","date_published_short":"06-04-2018","date_published_timestamp":"1522965600","popularity":"53327500","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"11","query":"lega"},{"id":"29","query":"m5s"}],"popularity_logs":"38","tweets":{"number":"44","sentiment_average":"-0.6136","sentiment_negative":"27","sentiment_neutral":"17","sentiment_positive":"0"}},{"id":"347867","title":"Consultazioni, è la giornata clou: apre il Pd chiude il M5S, ma si va verso la fumata nera","source":"www.repubblica.it","description":"Alle 10 Mattarella incontra Martina, alle 11 Berlusconi e alle 12 Salvini. L'ultima parola a Di Maio alle 16,30. Margini di manovra ristretti, verso le 18","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5yZXB1YmJsaWNhLml0L3BvbGl0aWNhLzIwMTgvMDQvMDUvbmV3cy9jb25zdWx0\nYXppb25pX2FwcmVfaWxfcGRfY2hpdWRlX2lsX201c19tYXR0YXJlbGxhX251b3ZvX2dvdmVybm8t\nMTkzMDExMTc2Lw==","tags":["luigi di maio","matteo salvini","movimento 5 stelle","pd","sergio mattarella","silvio berlusconi"],"date_published":"2018-04-05 06:47:36","date_published_short":"05-04-2018","date_published_timestamp":"1522879200","popularity":"165164000","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"29","query":"m5s"},{"id":"69","query":"pd"},{"id":"11","query":"lega"},{"id":"7","query":"salvini"},{"id":"5","query":"berlusconi"},{"id":"34","query":"\"di maio\""}],"popularity_logs":"36","tweets":{"number":"14","sentiment_average":"-0.0714","sentiment_negative":"7","sentiment_neutral":"1","sentiment_positive":"6"}},{"id":"347796","title":"Torino, Salizzoni in campo col Pd per la presidenza della Regione. Chiamparino: \"Risorsa importante\"","source":"torino.repubblica.it","description":"Prime reazioni all'intervista del re dei trapianti a Repubblica Torino. Il deputato Borghi: \"Investitura monarchica\"","url":"https://api.elezioni.io/click?u=aHR0cDovL3Rvcmluby5yZXB1YmJsaWNhLml0L2Nyb25hY2EvMjAxOC8wNC8wNC9uZXdzL3Rvcmlu\nb19zYWxpenpvbmlfaW5fY2FtcG9fY29sX3BkX3Blcl9sYV9wcmVzaWRlbnphX2RlbGxhX3JlZ2lv\nbmVfY2hpYW1wYXJpbm9fcmlzb3JzYV9pbXBvcnRhbnRlXy0xOTI5NDUxNTgv","tags":["claudio borghi","pd","torino"],"date_published":"2018-04-04 17:40:14","date_published_short":"04-04-2018","date_published_timestamp":"1522792800","popularity":"17416800","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"69","query":"pd"}],"popularity_logs":"37","tweets":{"number":"1","sentiment_average":"-1.0000","sentiment_negative":"1","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"347579","title":"Dj Fabo, il governo difende la legge contro l'aiuto al suicidio e si costituisce davanti alla Consulta","source":"milano.repubblica.it","description":"Inascoltato l'appello dell'associazione Coscioni che aveva raccolto 15mila firme, tra cui quella di Odifreddi, Saviano e di molti giuristi. La vice","url":"https://api.elezioni.io/click?u=aHR0cDovL21pbGFuby5yZXB1YmJsaWNhLml0L2Nyb25hY2EvMjAxOC8wNC8wMy9uZXdzL2RqX2Zh\nYm9fZ292ZXJub19zaV9jb3N0aXR1aXNjZV9jb25zdWx0YV9sZWdpdHRpbWl0YV9jb3N0aXR1emlv\nbmFsZV9yZWF0b19haXV0b19hbF9zdWljaWRpby0xOTI4NTk0MzAv","tags":["roberto saviano"],"date_published":"2018-04-03 15:04:52","date_published_short":"03-04-2018","date_published_timestamp":"1522706400","popularity":"98487000","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"69","query":"pd"},{"id":"67","query":"gentiloni"},{"id":"77","query":"Bonino"},{"id":"65","query":"Renzi"},{"id":"68","query":"paologentiloni"}],"popularity_logs":"38","tweets":{"number":"7","sentiment_average":"-0.1429","sentiment_negative":"3","sentiment_neutral":"2","sentiment_positive":"2"}},{"id":"347445","title":"'financial times': 'travaglio contro l'accordo di maio-salvini, cairo appoggia i 5 stelle'","source":"www.dagospia.com","description":"     DAGONEWS           financial times su travaglio e movimento cinque stelle     Mentre voi vi abboffate alle grigliate di Pasquetta o vi chiudete in casa a fare binge watching di Netflix, con le edicole chiuse, per il resto del mondo è un lunedì come gli altri, e il","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5kYWdvc3BpYS5jb20vcnVicmljYS0yL21lZGlhX2VfdHYvbWVudHJlLXZvaS12\naS1hYmJvZmZhdGUtZ3JpZ2xpYXRlLXBhc3F1ZXR0YS1naW9ybmFsaS1ub24tZXNjb25vLTE3MDYw\nNS5odG0=","tags":["movimento cinque stelle","netfl"],"date_published":"2018-04-02 16:22:35","date_published_short":"02-04-2018","date_published_timestamp":"1522620000","popularity":"30869600","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"7","query":"salvini"},{"id":"34","query":"\"di maio\""}],"popularity_logs":"35","tweets":{"number":"12","sentiment_average":"-1.0000","sentiment_negative":"12","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"347368","title":"Grillo posta un video sul suo bolg in preda all'influenza: \"Buona Pasqua autoimmune\" - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"“Guardate una banale influenza, un virus di terz’ordine come ha ridotto l’Elevato. Volevo farvi gli auguri. Ho provato di tutto, ho provato le medicine tradizionali, tachipirina, vitamina, aspirina, tutto ciò che finiva per una l’ho ingurgitato, poi cose tradizionali latte col miele, il cognac col miele, le calze di lana, adesso i fumenti, sto facendo …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wNC8wMS9ncmlsbG8tcG9zdGEt\ndW4tdmlkZW8tc3VsLXN1by1ib2xnLWluLXByZWRhLWFsbGluZmx1ZW56YS1idW9uYS1wYXNxdWEt\nYXV0b2ltbXVuZS80MjY1NTI1Lw==","tags":["grillo"],"date_published":"2018-04-01 13:39:56","date_published_short":"01-04-2018","date_published_timestamp":"1522533600","popularity":"18866000","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"27","query":"grillo"}],"popularity_logs":"39","tweets":{"number":"27","sentiment_average":"-1.0000","sentiment_negative":"27","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"347232","title":"La ricetta Di Maio per abolire Equitalia","source":"www.adnkronos.com","description":"Abolire il sistema Equitalia di nome e di fatto attraverso il fisco digitale. Lo spiega il leader M5S, Luigi Di Maio, in un post sul Blog delle Stelle. \"Insieme alla riduzione della pressione fiscale, attraverso il dimezzamento dell’Irap e la riforma degli scaglioni Irpef, una delle nostre priorità -sottolinea- sarà semplificare il quadro fiscale investendo nella digitalizzazione e nell’accorpamento delle banche dati della Pa e tramite l'abolizione di meccanismi inefficienti come lo spesometro\".","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5hZG5rcm9ub3MuY29tL2ZhdHRpL3BvbGl0aWNhLzIwMTgvMDMvMzEvcmljZXR0\nYS1tYWlvLXBlci1hYm9saXJlLWVxdWl0YWxpYV95V2tocnNXZXB2SkI0aGRkdFlLSXpNLmh0bWw=","tags":["luigi di maio"],"date_published":"2018-03-31 12:28:49","date_published_short":"31-03-2018","date_published_timestamp":"1522447200","popularity":"35646200","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"34","query":"\"di maio\""},{"id":"29","query":"m5s"},{"id":"35","query":"dimaio"},{"id":"36","query":"\"luigi di maio\""}],"popularity_logs":"38","tweets":{"number":"51","sentiment_average":"-0.1961","sentiment_negative":"10","sentiment_neutral":"41","sentiment_positive":"0"}},{"id":"347009","title":"Silvio Berlusconi chiede ai giudici la riabilitazione - Politica","source":"www.ansa.it","description":"Lo riporta il Corriere delle Sera. Decadrebbe incandidabilità\r\n\r\n(ANSA)","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5hbnNhLml0L3NpdG8vbm90aXppZS9wb2xpdGljYS8yMDE4LzAzLzMwL3NpbHZp\nby1iZXJsdXNjb25pLWNoaWVkZS1haS1naXVkaWNpLWxhLXJpYWJpbGl0YXppb25lXzgzYzUwNWQ3\nLTdmOGUtNDNlNC04NzhkLTJmNDlkMmRiZjk3ZS5odG1s","tags":["silvio berlusconi"],"date_published":"2018-03-30 11:07:51","date_published_short":"30-03-2018","date_published_timestamp":"1522360800","popularity":"23089800","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"5","query":"berlusconi"},{"id":"6","query":"silvioberlusconi"}],"popularity_logs":"37","tweets":{"number":"17","sentiment_average":"0.1765","sentiment_negative":"6","sentiment_neutral":"2","sentiment_positive":"9"}},{"id":"346784","title":"Lega, schiaffo ai 5Stelle sul reddito di cittadinanza. Bernini vede i capigruppo M5S: \"Confronto a oltranza sui programmi\"","source":"www.repubblica.it","description":"I presidenti di deputati e senatori, Grillo e Toninelli, hanno avviato un giro di consultazioni informali. Confronto disertato da Pd e Fdi. Con i forzisti","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5yZXB1YmJsaWNhLml0L3BvbGl0aWNhLzIwMTgvMDMvMjkvbmV3cy9tNXNfaW5j\nb250cm9fY2FwaWdydXBwby0xOTI1MDU0MjUv","tags":["grillo","lega","pd","toninelli"],"date_published":"2018-03-29 12:43:50","date_published_short":"29-03-2018","date_published_timestamp":"1522274400","popularity":"145301000","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"29","query":"m5s"},{"id":"11","query":"lega"},{"id":"15","query":"forzaitalia"},{"id":"5","query":"berlusconi"},{"id":"34","query":"\"di maio\""},{"id":"69","query":"pd"},{"id":"7","query":"salvini"},{"id":"65","query":"Renzi"},{"id":"35","query":"dimaio"}],"popularity_logs":"40","tweets":{"number":"38","sentiment_average":"-1.0000","sentiment_negative":"38","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"346560","title":"Blog | La finissima strategia politica renziana: il rosicamento","source":"www.ilfattoquotidiano.it","description":"Dopo giorni e giorni di attente analisi e osservazioni, ho finalmente compreso la finissima strategia politica di Matteo Renzi e dunque del Pd: il rosicamento. Chi ancora fa appelli per un accordo tra M5S e Pd, e sapete che io non li ho mai fatti, spera l’impossibile. E non è il caso. A oggi il …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wMy8yOC9wZC1sYS1maW5pc3Np\nbWEtc3RyYXRlZ2lhLXBvbGl0aWNhLXJlbnppYW5hLWlsLXJvc2ljYW1lbnRvLzQyNTcxNTMv","tags":["matteo renzi","pd"],"date_published":"2018-03-28 10:42:39","date_published_short":"28-03-2018","date_published_timestamp":"1522188000","popularity":"31102900","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"69","query":"pd"},{"id":"65","query":"Renzi"}],"popularity_logs":"40","tweets":{"number":"55","sentiment_average":"-1.0000","sentiment_negative":"55","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"346392","title":"Il monito dell’Europa: \"Ricordatevi il debito\"","source":"www.huffingtonpost.it","description":"Il commissario Moscovici: \"Servono politiche di bilancio responsabili\". L'appello di Confindustria e l'auspicio del Fmi: \"L'Italia dia una prova di realtà\"","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaHVmZmluZ3RvbnBvc3QuaXQvMjAxOC8wMy8yNy9pbC1tb25pdG8tZGVsbC1l\ndXJvcGEtcmljb3JkYXRldmktaWwtZGViaXRvX2FfMjMzOTYyNjkv","tags":["fondo monetario internazionale"],"date_published":"2018-03-27 15:28:47","date_published_short":"27-03-2018","date_published_timestamp":"1522101600","popularity":"41076900","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"4","name":"Sinistra","slug":"sinistra"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"11","query":"lega"},{"id":"23","query":"grasso"},{"id":"66","query":"matteorenzi"}],"popularity_logs":"40","tweets":{"number":"4","sentiment_average":"-1.0000","sentiment_negative":"4","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"346100","title":"Rubygate, la procura insiste: processate Berlusconi per corruzione giudiziaria","source":"www.lastampa.it","description":"Il leader di Forza Italia è imputato con  4 persone. L’accusa:  aver versato denaro alle ospiti delle cene  di Arcore per non rivelare i  rapporti sessuali","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5sYXN0YW1wYS5pdC8yMDE4LzAzLzI2L2VkaXppb25pL21pbGFuby9ydWJ5Z2F0\nZS1sYS1wcm9jdXJhLWluc2lzdGUtcHJvY2Vzc2F0ZS1iZXJsdXNjb25pLXBlci1jb3JydXppb25l\nLWdpdWRpemlhcmlhLXJBdGY0NWRHUE92OVpiUjlrQWZjSkwvcGFnaW5hLmh0bWw=","tags":["forza italia","silvio berlusconi"],"date_published":"2018-03-26 12:02:43","date_published_short":"26-03-2018","date_published_timestamp":"1522015200","popularity":"38171300","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"5","query":"berlusconi"}],"popularity_logs":"36","tweets":{"number":"20","sentiment_average":"0.0000","sentiment_negative":"3","sentiment_neutral":"14","sentiment_positive":"3"}},{"id":"345941","title":"Governo, Salvini insiste: \"Il prossimo premier? Non potrà che essere del centrodestra. Via la legge Fornero\" - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"Galvanizzato dal successo nella partita per l’elezione dei presidenti delle Camere, Matteo Salvini rilancia subito sul governo: “Nel rispetto di tutti, il prossimo premier non potrà che essere indicato dal centrodestra“. Perché, spiega il leader della Lega, è “la coalizione che ha preso più voti e che anche ieri ha dimostrato compattezza, intelligenza e rispetto degli …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wMy8yNS9nb3Zlcm5vLXNhbHZp\nbmktaW5zaXN0ZS1pbC1wcm9zc2ltby1wcmVtaWVyLWRldmUtaW5kaWNhcmxvLWlsLWNlbnRyb2Rl\nc3RyYS80MjUwNjY5Lw==","tags":["centrodestra","salvini"],"date_published":"2018-03-25 14:42:01","date_published_short":"25-03-2018","date_published_timestamp":"1521932400","popularity":"20552800","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"7","query":"salvini"}],"popularity_logs":"38","tweets":{"number":"5","sentiment_average":"0.4000","sentiment_negative":"1","sentiment_neutral":"1","sentiment_positive":"3"}},{"id":"345712","title":"Roberto Fico (M5s) nuovo presidente della Camera | Al Senato eletta Maria Elisabetta Casellati - Tgcom24","source":"www.tgcom24.mediaset.it","description":"Regge la convergenza tra M5s e centrodestra sulle cariche istituzionali. \"L'accordo non influenza la formazione del governo\" si legge in una nota del centrodestra.","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy50Z2NvbTI0Lm1lZGlhc2V0Lml0L3BvbGl0aWNhL3RvdG8tcHJlc2lkZW56ZS1j\nYXNlbGxhdGktYWwtc2VuYXRvLXJvYmVydG8tZmljby1hbGxhLWNhbWVyYV8zMTMwMjE5LTIwMTgw\nMmEuc2h0bWw=","tags":["centrodestra","m5s"],"date_published":"2018-03-24 13:08:34","date_published_short":"24-03-2018","date_published_timestamp":"1521846000","popularity":"100262000","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"16","query":"\"forza Italia\""},{"id":"29","query":"m5s"}],"popularity_logs":"36","tweets":{"number":"3","sentiment_average":"-1.0000","sentiment_negative":"3","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"345430","title":"DIRETTA - Insediamento del nuovo Parlamento   | Sky TG24","source":"tg24.sky.it","description":"Leggi su Sky Tg24 l’articolo DIRETTA - Insediamento del nuovo Parlamento   | Sky TG24","url":"https://api.elezioni.io/click?u=aHR0cDovL3RnMjQuc2t5Lml0L3BvbGl0aWNhLzIwMTgvMDMvMjMvaW5zZWRpYW1lbnRvLXBhcmxh\nbWVudG8tZGlyZXR0YS5odG1sP3NvY2lhbD10d2l0dGVyX3NreXRnMjRfcGhvdG9fbnVsbA==","tags":["articolo uno-mdp"],"date_published":"2018-03-23 10:13:16","date_published_short":"23-03-2018","date_published_timestamp":"1521759600","popularity":"257575000","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"29","query":"m5s"},{"id":"35","query":"dimaio"},{"id":"15","query":"forzaitalia"},{"id":"7","query":"salvini"},{"id":"16","query":"\"forza Italia\""},{"id":"69","query":"pd"},{"id":"5","query":"berlusconi"},{"id":"11","query":"lega"}],"popularity_logs":"38","tweets":{"number":"12","sentiment_average":"-0.3333","sentiment_negative":"6","sentiment_neutral":"4","sentiment_positive":"2"}},{"id":"345338","title":"Pd verso l’astensione sul condannato Romani, M5s contrario. Berlusconi vuole incontrare Di Maio. Che rifiuta - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"“Di presidenze si parla con Berlusconi”, dicono Romani e Brunetta. “I Cinque stelle devono parlare anche con me, non solo con Salvini“, fa filtrare l’ex Cavaliere. Il rebus per le presidenze delle Camere, che a 12 ore dalla convocazione del nuovo Parlamento sembra lontano dalla risoluzione, passa da Forza Italia, anzi dall’ex premier in persona. …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wMy8yMi9wZC12ZXJzby1sYXN0\nZW5zaW9uZS1zdWwtY29uZGFubmF0by1yb21hbmktbTVzLWNvbnRyYXJpby1iZXJsdXNjb25pLXZ1\nb2xlLWluY29udHJhcmUtZGktbWFpby1jaGUtcmlmaXV0YS80MjQ0MDAxLw==","tags":["pd","salvini"],"date_published":"2018-03-22 21:40:55","date_published_short":"22-03-2018","date_published_timestamp":"1521673200","popularity":"31964600","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"29","query":"m5s"},{"id":"69","query":"pd"},{"id":"34","query":"\"di maio\""},{"id":"5","query":"berlusconi"}],"popularity_logs":"38","tweets":{"number":"5","sentiment_average":"-0.8000","sentiment_negative":"4","sentiment_neutral":"1","sentiment_positive":"0"}},{"id":"344987","title":"Centrodestra, vertice a Palazzo Grazioli. Tajani: \"Presidenza del Senato a Forza Italia, è partito di garanzia\"","source":"www.repubblica.it","description":"Fico in pole per la Camera. Il presidente del Parlamento europeo a Circo Massimo su Radio Capital: \"Governo di centrodestra con maggioranze variabili\"","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5yZXB1YmJsaWNhLml0L3BvbGl0aWNhLzIwMTgvMDMvMjEvbmV3cy9jZW50cm9k\nZXN0cmFfdGFqYW5pX3ZlcnRpY2VfYmVybHVzY29uaV9zYWx2aW5pX21lbG9uaS0xOTE4MjQzNDUv","tags":["centrodestra","italia"],"date_published":"2018-03-21 10:28:29","date_published_short":"21-03-2018","date_published_timestamp":"1521586800","popularity":"89951800","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"16","query":"\"forza Italia\""},{"id":"29","query":"m5s"}],"popularity_logs":"33","tweets":{"number":"5","sentiment_average":"0.0000","sentiment_negative":"2","sentiment_neutral":"1","sentiment_positive":"2"}},{"id":"344896","title":"Di Maio, Pizzarotti: “Bravo ad aver scalato M5s, ma incapace concretamente di prendere decisioni difficili” - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"“Luigi Di Maio? E’ sicuramente una persona capace, non sarebbe stato facile per nessuno scalare il M5S, che di fatto aveva un garante, cioè Beppe Grillo, il quale poteva avere il diktat su tutto. Però non credo che negli anni abbia dimostrato capacità concrete nel prendere decisioni difficili. Una cosa è parlare, una cosa è …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wMy8yMC9kaS1tYWlvLXBpenph\ncm90dGktYnJhdm8tcGVyLWF2ZXItc2NhbGF0by1tNXMtbWEtaW5jYXBhY2UtY29uY3JldGFtZW50\nZS1uZWwtcHJlbmRlcmUtZGVjaXNpb25pLWRpZmZpY2lsaS80MjQwMDgyLw==","tags":["di maio","maio"],"date_published":"2018-03-20 18:58:23","date_published_short":"20-03-2018","date_published_timestamp":"1521500400","popularity":"10480600","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"34","query":"\"di maio\""},{"id":"29","query":"m5s"},{"id":"36","query":"\"luigi di maio\""}],"popularity_logs":"35","tweets":{"number":"4","sentiment_average":"-1.0000","sentiment_negative":"4","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"344553","title":"Elezioni in Russia, Putin trionfa con oltre il 76 per cento. Discorso alla folla: \"Successo è nostro destino\"","source":"www.repubblica.it","description":"Il presidente ha parlato per la prima volta del caso Skripal: pensare che la Russia sia colpevole dell'avvelenamento \"è una sciocchezza\"","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5yZXB1YmJsaWNhLml0L2VzdGVyaS8yMDE4LzAzLzE3L25ld3MvbGFfcnVzc2lh\nX2FsX3ZvdG9fbmVsX3NlZ25vX2RpX3B1dGluX2VfZGVsbGFfY3JpbWVhX2FubmVzc2EtMTkxNTQw\nMzkzLw==","tags":["vladimir putin"],"date_published":"2018-03-19 12:24:52","date_published_short":"19-03-2018","date_published_timestamp":"1521414000","popularity":"128945000","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"11","query":"lega"}],"popularity_logs":"35","tweets":{"number":"1","sentiment_average":"-1.0000","sentiment_negative":"1","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"344321","title":"False fatture per 140mila euro Altra grana sulla famiglia Renzi","source":"www.ilgiornale.it","description":"Dopo il caso Consip, i genitori dell&#039;ex premier indagati dai pm di Firenze: sospetti di trucchi fiscali nelle aziende","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5pbGdpb3JuYWxlLml0L25ld3MvcG9saXRpY2EvZmFsc2UtZmF0dHVyZS0xNDBt\naWxhLWV1cm8tYWx0cmEtZ3JhbmEtc3VsbGEtZmFtaWdsaWEtcmVuemktMTUwNjQwMy5odG1s","tags":["matteo renzi"],"date_published":"2018-03-18 08:05:33","date_published_short":"18-03-2018","date_published_timestamp":"1521327600","popularity":"9830530","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"65","query":"Renzi"},{"id":"29","query":"m5s"},{"id":"69","query":"pd"}],"popularity_logs":"35","tweets":{"number":"42","sentiment_average":"-0.3333","sentiment_negative":"27","sentiment_neutral":"2","sentiment_positive":"13"}},{"id":"344216","title":"Pd, da Martina a Cuperlo e Orlando: \"Lega-M5s? Pericolosi\". Ma aprono a esecutivo di scopo: \"Se lo chiede il Colle\" - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"Un governo con la Lega e il Movimento 5 stelle? Per tutti o quasi sarebbe pericoloso. Al contrario, però, se a chiederlo dovesse essere il Quirinale sarebbero pronti a sostenere un governo a larghe, anzi larghissime intese. E cioè anche con il Movimento 5 stelle e la Lega. Dà un indirizzo tutt’altro che netto l’assemblea di Sinistra Dem …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wMy8xNy9wZC1kYS1tYXJ0aW5h\nLWEtY3VwZXJsby1lLW9ybGFuZG8tbGVnYS1tNXMtcGVyaWNvbG9zaS1tYS1hcHJvbm8tYS1lc2Vj\ndXRpdm8tZGktc2NvcG8tc2UtbG8tY2hpZWRlLWlsLWNvbGxlLzQyMzMwNDMv","tags":["lega","movimento 5 stelle","pd"],"date_published":"2018-03-17 16:05:32","date_published_short":"17-03-2018","date_published_timestamp":"1521241200","popularity":"16591300","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"29","query":"m5s"},{"id":"69","query":"pd"},{"id":"11","query":"lega"},{"id":"31","query":"\"movimento 5 stelle\""}],"popularity_logs":"37","tweets":{"number":"8","sentiment_average":"-0.6250","sentiment_negative":"5","sentiment_neutral":"3","sentiment_positive":"0"}},{"id":"343888","title":"Moro: Gentiloni, 40 anni fa più grave attacco a Repubblica  - Politica","source":"www.ansa.it","description":"Lo statista democristiano fu rapito il 16 marzo 1978 e ucciso dalle Brigate Rosse il 9 maggio\r\n\r\n(ANSA)","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5hbnNhLml0L3NpdG8vbm90aXppZS9wb2xpdGljYS8yMDEzLzA1LzA5L2FsZG8t\nbW9yby1pLTU1LWdpb3JuaS1waXUtbHVuZ2hpLWRlbGxhLXJlcHViYmxpY2FfM2FlZjgzZDYtZGY4\nYi00OGE4LWIzYjMtOGFmYTgzMTcxYWI5Lmh0bWw=","tags":["moro","paolo gentiloni"],"date_published":"2018-03-16 09:11:06","date_published_short":"16-03-2018","date_published_timestamp":"1521154800","popularity":"79955400","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"67","query":"gentiloni"}],"popularity_logs":"37","tweets":{"number":"5","sentiment_average":"1.0000","sentiment_negative":"0","sentiment_neutral":"0","sentiment_positive":"5"}},{"id":"343629","title":"Camere, Salvini chiama Di Maio per presidenze. M5s: \"Abbiamo il 32%, Montecitorio spetta a noi\" - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"Matteo Salvini nella serata del 14 marzo ha telefonato a Luigi Di Maio, Maurizio Martina e Pietro Grasso per parlare della presidenza delle Camere. “A nome della coalizione più votata dagli italiani”, ha dichiarato, “ho ritenuto mio dovere telefonare ai principali leader, per aprire un dialogo sulle presidenze delle Camere per garantire agli italiani che si …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wMy8xNS9jYW1lcmUtc2Fsdmlu\naS1jaGlhbWEtZGktbWFpby1wZXItcHJlc2lkZW56ZS1tNXMtYWJiaWFtby1pbC0zMi1tb250ZWNp\ndG9yaW8tc3BldHRhLWEtbm9pLzQyMjc0OTkv","tags":["luigi di maio"],"date_published":"2018-03-15 09:06:17","date_published_short":"15-03-2018","date_published_timestamp":"1521068400","popularity":"16193600","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"4","name":"Sinistra","slug":"sinistra"}],"topics":[{"id":"29","query":"m5s"},{"id":"34","query":"\"di maio\""},{"id":"7","query":"salvini"},{"id":"23","query":"grasso"},{"id":"93","query":"leu"}],"popularity_logs":"37","tweets":{"number":"7","sentiment_average":"-0.2857","sentiment_negative":"2","sentiment_neutral":"5","sentiment_positive":"0"}},{"id":"343523","title":"Foreste e boschi, un decreto che fa discutere","source":"www.lastampa.it","description":"Il Consiglio dei Ministri potrebbe approvare un decreto legislativo con il nuovo Testo Unico in materia di foreste. Una norma che ha sollevato molte polemiche","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5sYXN0YW1wYS5pdC8yMDE4LzAzLzEzL3NjaWVuemEvYW1iaWVudGUvc3Rvcmll\nLWl0YWxpYW5lL2ZvcmVzdGUtZS1ib3NjaGktdW4tZGVjcmV0by1jaGUtZmEtZGlzY3V0ZXJlLTlF\nam56SGZBRDFvdGVZa2NoSUtlRE8vcGFnaW5hLmh0bWw=","tags":["maria elena boschi"],"date_published":"2018-03-14 14:24:14","date_published_short":"14-03-2018","date_published_timestamp":"1520982000","popularity":"60831600","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"68","query":"paologentiloni"}],"popularity_logs":"37","tweets":{"number":"4","sentiment_average":"-0.2500","sentiment_negative":"1","sentiment_neutral":"3","sentiment_positive":"0"}},{"id":"343212","title":"\"Salvini, un'alleanza col M5s la farebbe?\". Lui non esclude e ammette: \"Il centrodestra non è autosufficiente\" - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"“Nel simbolo c’è Salvini Premier e quindi l’accordo della Lega è che se il premier sarà della Lega sarà Matteo Salvini e se il premier sarà di centrodestra sarà Matteo Salvini. Non fatemi fare il toto-nomi: abbiamo tante persone in gamba, ma prima parlo con gli alleati”. Così Matteo Salvini, leader della Lega, a margine …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wMy8xMy9zYWx2aW5pLXVuYWxs\nZWFuemEtY29sLW01cy1sYS1mYXJlYmJlLWx1aS1ub24tZXNjbHVkZS1lLWFtbWV0dGUtaWwtY2Vu\ndHJvZGVzdHJhLW5vbi1lLWF1dG9zdWZmaWNpZW50ZS80MjIyNTE4Lw==","tags":["centrodestra","lega","salvini"],"date_published":"2018-03-13 13:13:21","date_published_short":"13-03-2018","date_published_timestamp":"1520895600","popularity":"22176900","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"29","query":"m5s"},{"id":"69","query":"pd"},{"id":"65","query":"Renzi"},{"id":"7","query":"salvini"},{"id":"34","query":"\"di maio\""}],"popularity_logs":"39","tweets":{"number":"16","sentiment_average":"-1.0000","sentiment_negative":"16","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"342863","title":"Berlusconi: “Rischio democratico con nuove elezioni, anche il Pd si faccia carico del governo”","source":"www.lastampa.it","description":"No al partito unico con il Carroccio: «Siamo alleati ma abbiamo valori diversi. I presidenti delle Camere a M5S e Lega? Nessun automatismo, siano di garanzia»","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5sYXN0YW1wYS5pdC8yMDE4LzAzLzEyL2l0YWxpYS9zcGVjaWFsaS9lbGV6aW9u\naS8yMDE4L3BvbGl0aWNoZS9iZXJsdXNjb25pLXJpc2NoaW8tZGVtb2NyYXRpY28tY29uLW51b3Zl\nLWVsZXppb25pLWFuY2hlLWlsLXBkLXNpLWZhY2NpYS1jYXJpY28tZGVsLWdvdmVybm8tWkt0Y0dq\nbFFyT3NPc1JtNWV2cktYUC9wYWdpbmEuaHRtbA==","tags":["lega","m5s","pd","silvio berlusconi"],"date_published":"2018-03-12 08:02:54","date_published_short":"12-03-2018","date_published_timestamp":"1520809200","popularity":"37019400","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"5","query":"berlusconi"},{"id":"69","query":"pd"}],"popularity_logs":"35","tweets":{"number":"18","sentiment_average":"-0.6667","sentiment_negative":"14","sentiment_neutral":"2","sentiment_positive":"2"}},{"id":"342756","title":"Blog | Lega e M5S, una sfida fra i due poli del populismo - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"Da qualche giorno molti giornali denunciano – e forse auspicano – un’intesa tra Movimento 5 Stelle e Lega: avrebbero i numeri per formare una maggioranza e un governo. Eppure i due leader, Luigi Di Maio e Matteo Salvini, non sembrano averne alcuna voglia. La “Terza repubblica”, come l’ha chiamata Di Maio, è stata inaugurata da …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wMy8xMS9sZWdhLWUtbTVzLXVu\nYS1zZmlkYS1mcmEtaS1kdWUtcG9saS1kZWwtcG9wdWxpc21vLzQyMTgxMzQv","tags":["lega","luigi","m5s","movimento 5 stelle"],"date_published":"2018-03-11 15:06:52","date_published_short":"11-03-2018","date_published_timestamp":"1520722800","popularity":"16531300","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"11","query":"lega"},{"id":"29","query":"m5s"}],"popularity_logs":"37","tweets":{"number":"12","sentiment_average":"-1.0000","sentiment_negative":"12","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"342436","title":"Il primo vero scontro sarà sulla manovra.  Lega: tasse giù. M5S: nostro programma","source":"www.corriere.it","description":"Il governo Gentiloni pensa a un testo leggero per lasciare le scelte economiche all’esecutivo che verrà","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5jb3JyaWVyZS5pdC9lbGV6aW9uaS0yMDE4L25vdGl6aWUvcHJpbW8tdmVyby1z\nY29udHJvLW1hbm92cmEtbGVnYS10YXNzZS1naXUtbTVzLWluY2lkZXJlLXN1Yml0by1hZTA5OTA0\nNC0yM2Q5LTExZTgtYTc5Zi00NTU2NTA3M2EwNjYuc2h0bWw=","tags":["lega","movimento 5 stelle","paolo gentiloni"],"date_published":"2018-03-10 08:42:48","date_published_short":"10-03-2018","date_published_timestamp":"1520636400","popularity":"26894400","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"29","query":"m5s"},{"id":"11","query":"lega"}],"popularity_logs":"36","tweets":{"number":"4","sentiment_average":"-1.0000","sentiment_negative":"4","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"342377","title":"Rifiuti Napoli, Passariello: \"Meloni ha visto i video di Fanpage e mi ha detto 'vai avanti'\". Ma lei smentisce: \"E' falso\" - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"Luciano Passariello dice di avere l’appoggio di Giorgia Meloni nonostante l’inchiesta della Procura di Napoli su presunti illeciti nell’aggiudicazione delle gare d’appalto della società partecipata Sma Campania in cui il consigliere della Regione Campania risulta indagato, ma la leader di Fratelli d’Italia smentisce. “Giorgia Meloni? Ha visto i video e mi ha detto: ‘vai avanti'”, …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wMy8wOS9yaWZpdXRpLW5hcG9s\naS1wYXNzYXJpZWxsby1tZWxvbmktaGEtdmlzdG8tdmlkZW8tZGktZmFucGFnZS1lLW1pLWhhLWRl\ndHRvLXZhaS1hdmFudGktbWEtbGVpLXNtZW50aXNjZS1lLWZhbHNvLzQyMTU2MjQv","tags":["napoli"],"date_published":"2018-03-09 19:42:01","date_published_short":"09-03-2018","date_published_timestamp":"1520550000","popularity":"64409300","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"9","query":"meloni"}],"popularity_logs":"36","tweets":{"number":"7","sentiment_average":"-0.8571","sentiment_negative":"6","sentiment_neutral":"1","sentiment_positive":"0"}},{"id":"341968","title":"Crisi Pd, Orlando: \"Accordo con il M5s? Una trovata mediatica di Renzi per non discutere di una disfatta storica\" - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"L’accordo con i Cinque Stelle? Una trovata mediatica di Renzi per non discutere di cosa fare dopo una “disfatta storica”. La presidenza delle Camere? Evitare assi sia con M5s che con il centrodestra, separando il piano istituzionale da quello di governo. Anche perché l’intesa con Luigi Di Maio, seppur richiesta dal presidente della Repubblica, manca …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wMy8wOC9jcmlzaS1wZC1vcmxh\nbmRvLWFjY29yZG8tY29uLWlsLW01cy11bmEtdHJvdmF0YS1tZWRpYXRpY2EtZGktcmVuemktcGVy\nLW5vbi1kaXNjdXRlcmUtZGktdW5hLWRpc2ZhdHRhLXN0b3JpY2EvNDIxMTU2My8=","tags":["de","m5s","orlando","pd"],"date_published":"2018-03-08 10:40:22","date_published_short":"08-03-2018","date_published_timestamp":"1520463600","popularity":"42947900","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"29","query":"m5s"},{"id":"69","query":"pd"},{"id":"65","query":"Renzi"}],"popularity_logs":"34","tweets":{"number":"3","sentiment_average":"-1.0000","sentiment_negative":"3","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"341607","title":"Il tweet di Matteo Salvini contro i suoi nemici","source":"www.corriere.it","description":"Il leader della Lega ha «brindato» alla salute di intellettuali e giornalisti che lo criticano apertamente","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5jb3JyaWVyZS5pdC9lbGV6aW9uaS0yMDE4L25vdGl6aWUvdHdlZXQtbWF0dGVv\nLXNhbHZpbmktY29udHJvLXN1b2ktbmVtaWNpLThiNzg3MmY0LTIxZDktMTFlOC1hNjY1LWEzNTM3\nM2ZhZmI5Ny5zaHRtbA==","tags":["lega","matteo salvini"],"date_published":"2018-03-07 09:09:30","date_published_short":"07-03-2018","date_published_timestamp":"1520377200","popularity":"56588900","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"7","query":"salvini"},{"id":"34","query":"\"di maio\""},{"id":"8","query":"matteosalvini"}],"popularity_logs":"35","tweets":{"number":"23","sentiment_average":"-0.4348","sentiment_negative":"15","sentiment_neutral":"3","sentiment_positive":"5"}},{"id":"341282","title":"LIVE Elezioni 2018, cosa succede ora  | Sky TG24","source":"tg24.sky.it","description":"Leggi su Sky Tg24 l’articolo LIVE Elezioni 2018, cosa succede ora  | Sky TG24","url":"https://api.elezioni.io/click?u=aHR0cDovL3RnMjQuc2t5Lml0L3BvbGl0aWNhLzIwMTgvMDMvMDYvZWxlemlvbmktbGl2ZS5odG1s\nP3NvY2lhbD10d2l0dGVyX3NreXRnMjRfcGhvdG9fbnVsbA==","tags":["articolo uno-mdp"],"date_published":"2018-03-06 11:42:36","date_published_short":"06-03-2018","date_published_timestamp":"1520290800","popularity":"307182000","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"69","query":"pd"},{"id":"35","query":"dimaio"}],"popularity_logs":"35","tweets":{"number":"8","sentiment_average":"-0.5000","sentiment_negative":"6","sentiment_neutral":"0","sentiment_positive":"2"}},{"id":"340648","title":"LIVE Elezioni 2018: risultati in tempo reale | Sky TG24  | Sky TG24","source":"tg24.sky.it","description":"Leggi su Sky Tg24 l’articolo LIVE Elezioni 2018: risultati in tempo reale | Sky TG24  | Sky TG24","url":"https://api.elezioni.io/click?u=aHR0cDovL3RnMjQuc2t5Lml0L3BvbGl0aWNhLzIwMTgvMDMvMDQvZWxlemlvbmktcmlzdWx0YXRp\nLTIwMTgtbGl2ZS5odG1sP3NvY2lhbD1mYWNlYm9va19za3l0ZzI0X2xpbmtfbnVsbA==","tags":["articolo uno-mdp"],"date_published":"2018-03-05 00:47:53","date_published_short":"05-03-2018","date_published_timestamp":"1520204400","popularity":"375625000","collections":[{"id":"1","name":"Destra","slug":"destra"},{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"4","name":"Sinistra","slug":"sinistra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"2","query":"casapound"},{"id":"69","query":"pd"},{"id":"38","query":"dibattista"},{"id":"29","query":"m5s"},{"id":"7","query":"salvini"},{"id":"23","query":"grasso"},{"id":"22","query":"liberieuguali"},{"id":"11","query":"lega"},{"id":"5","query":"berlusconi"},{"id":"98","query":"fontana"},{"id":"65","query":"Renzi"}],"popularity_logs":"30","tweets":{"number":"31","sentiment_average":"0.4516","sentiment_negative":"3","sentiment_neutral":"11","sentiment_positive":"17"}},{"id":"340512","title":"Lugi Di Maio in coda per votare","source":"video.repubblica.it","description":"E' arrivato poco prima di mezzogiorno nella sezione elettorale di Pomuigliano d'Arco Luigi Di Maio, dove ha votatovideo Riccardo SianoLE FOTOLEGGI...","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly92aWRlby5yZXB1YmJsaWNhLml0L2VkaXppb25lL25hcG9saS9sdWdpLWRpLW1haW8t\naW4tY29kYS1wZXItdm90YXJlLzI5ODc1NS8yOTkzNzk/cmVmPXR3aHI=","tags":["luigi di maio","riccardo"],"date_published":"2018-03-04 12:14:15","date_published_short":"04-03-2018","date_published_timestamp":"1520118000","popularity":"17050600","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"34","query":"\"di maio\""}],"popularity_logs":"34","tweets":{"number":"1","sentiment_average":"0.0000","sentiment_negative":"0","sentiment_neutral":"1","sentiment_positive":"0"}},{"id":"340301","title":"Gli italiani","source":"www.lastampa.it","description":"Egregio Luigi Di Maio, poiché c’è la sensazione (solo sensazione, non sondaggi segreti) che il Movimento sia abbondantemente sottostimato, e lei sia l’unico fra i pretendenti a Palazzo Chigi con qualc","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5sYXN0YW1wYS5pdC8yMDE4LzAzLzAzL2N1bHR1cmEvb3BpbmlvbmkvYnVvbmdp\nb3Juby9nbGktaXRhbGlhbmktSG5xVE9pMHJsY1J4U21CcFhualkzTS9wcmVtaXVtLmh0bWw=","tags":["luigi di maio","movimento 5 stelle"],"date_published":"2018-03-03 02:41:15","date_published_short":"03-03-2018","date_published_timestamp":"1520031600","popularity":"29596400","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"34","query":"\"di maio\""},{"id":"36","query":"\"luigi di maio\""}],"popularity_logs":"35","tweets":{"number":"1","sentiment_average":"-1.0000","sentiment_negative":"1","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"340085","title":"Verdini: 'voto Berlusconi al Senato e Renzi alla Camera'","source":"www.la7.it","description":"Verdini:","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5sYTcuaXQvcGlhenphcHVsaXRhL3ZpZGVvL3ZlcmRpbmktdm90by1iZXJsdXNj\nb25pLWFsLXNlbmF0by1lLXJlbnppLWFsbGEtY2FtZXJhLTAyLTAzLTIwMTgtMjM1NDQx","tags":["denis verdini","matteo renzi","silvio berlusconi"],"date_published":"2018-03-02 10:31:14","date_published_short":"02-03-2018","date_published_timestamp":"1519945200","popularity":"19220500","collections":[{"id":"4","name":"Sinistra","slug":"sinistra"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"91","query":"civati"},{"id":"65","query":"Renzi"},{"id":"5","query":"berlusconi"},{"id":"93","query":"leu"},{"id":"29","query":"m5s"}],"popularity_logs":"34","tweets":{"number":"33","sentiment_average":"-0.3030","sentiment_negative":"21","sentiment_neutral":"1","sentiment_positive":"11"}},{"id":"339766","title":"M5s, restituzioni con il boomerang: così 10 parlamentari si sono ripresi una parte dei versamenti","source":"www.repubblica.it","description":"Nel 2014 quattro deputati e sei senatori hanno detratto dai propri 730 i soldi restituiti e versati al fondo di ammotamento dei titoli di Stato, riprendendosi 22.359 euro. Tra questi anche Barbara Lezzi e Vito Crimi. Il record di Petrocelli, con oltre 7.100 euro di sconto fiscale, che però si difende: \"Un errore di cui non ero a conoscenza\". Caso fa mea culpa: \"Non una cosa correttissima, mi dispiace\"","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5yZXB1YmJsaWNhLml0L2Vjb25vbWlhLzIwMTgvMDMvMDEvbmV3cy9tNXNfcmVz\ndGl0dXppb25pX3N0aXBlbmRpX2RldHJhemlvbmktMTkwMDE0MTY2Lw==","tags":["m5s"],"date_published":"2018-03-01 10:12:24","date_published_short":"01-03-2018","date_published_timestamp":"1519858800","popularity":"50865400","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"29","query":"m5s"},{"id":"35","query":"dimaio"}],"popularity_logs":"35","tweets":{"number":"37","sentiment_average":"-0.9730","sentiment_negative":"36","sentiment_neutral":"1","sentiment_positive":"0"}},{"id":"339415","title":"Un bambino e i vermi","source":"www.lastampa.it","description":"Gabriella Nobile è una mamma di Milano di due bambini adottivi, africani, che oggi hanno sette e dodici anni. Gabriella ha scritto una lettera a Matteo Salvini per ringraziarlo dei «momenti di terrore","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5sYXN0YW1wYS5pdC8yMDE4LzAyLzI4L2N1bHR1cmEvb3BpbmlvbmkvYnVvbmdp\nb3Juby91bi1iYW1iaW5vLWUtaS12ZXJtaS10VzRYODhIa3ZpUFYwcUdjNGRDcXBJL3ByZW1pdW0u\naHRtbA==","tags":["matteo salvini","milano"],"date_published":"2018-02-28 03:58:24","date_published_short":"28-02-2018","date_published_timestamp":"1519772400","popularity":"39382600","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"7","query":"salvini"}],"popularity_logs":"36","tweets":{"number":"1","sentiment_average":"-1.0000","sentiment_negative":"1","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"339284","title":"\"Sapete chi è suo marito?\". Meloni devastante, demolisce la Guerritore: ora capite perché... / Video","source":"www.liberoquotidiano.it","description":"...","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5saWJlcm9xdW90aWRpYW5vLml0L25ld3Mvc2ZvZ2xpby8xMzMxMzQxMi9naW9y\nZ2lhLW1lbG9uaS1tb25pY2EtZ3VlcnJpdG9yZS1vdHRvLWUtbWV6em8taW1taWdyYXRpLW1hcml0\nby1yb2JlcnRvLXphY2NhcmlhLmh0bWw=","tags":["giorgia meloni"],"date_published":"2018-02-27 15:15:18","date_published_short":"27-02-2018","date_published_timestamp":"1519686000","popularity":"72479000","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"9","query":"meloni"},{"id":"18","query":"\"fratelli d'Italia\""},{"id":"10","query":"giorgiameloni"}],"popularity_logs":"37","tweets":{"number":"31","sentiment_average":"-0.9355","sentiment_negative":"29","sentiment_neutral":"2","sentiment_positive":"0"}},{"id":"339083","title":"B.COME BASTA!, dal 24 febbraio in edicola con il Fatto Quotidiano","source":"shop.ilfattoquotidiano.it","description":"B.COME BASTA! di Marco Travaglio Tutto ciò che ha fatto, anzi ci ha fatto Silvio Berlusconi nei suoi primi 81 anni è raccolto in questo libro esplosivo. 14€ da sabato 24 febbraio in edicola con Il Fatto Quotidiano. Da martedì 27 febbraio in libreria SCOPRI LA COLLANA DI LIBRI PAPER FIRST (clicca qui)  ","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly9zaG9wLmlsZmF0dG9xdW90aWRpYW5vLml0L2ItY29tZS1iYXN0YS1kYWwtMjQtZmVi\nYnJhaW8taW4tZWRpY29sYS1jb24taWwtZmF0dG8tcXVvdGlkaWFuby8=","tags":["silvio berlusconi","marco travaglio"],"date_published":"2018-02-26 19:44:02","date_published_short":"26-02-2018","date_published_timestamp":"1519599600","popularity":"105116000","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"5","query":"berlusconi"}],"popularity_logs":"38","tweets":{"number":"1","sentiment_average":"-1.0000","sentiment_negative":"1","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"338757","title":"Il patto del 5 marzo","source":"www.huffingtonpost.it","description":"Civati, Fratoianni e Speranza all'Huffpost: \"Costruiremo il nuovo soggetto politico della Sinistra in Italia\" con un progetto \"largo e partecipato\"","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5odWZmaW5ndG9ucG9zdC5pdC8yMDE4LzAyLzI1L2lsLXBhdHRvLWRlbC01LW1h\ncnpvX2FfMjMzNzA0MjMvP3V0bV9ocF9yZWY9aXQtaG9tZXBhZ2U=","tags":["beppe civati","nicola fratoianni","alessandro speranza"],"date_published":"2018-02-25 14:13:55","date_published_short":"25-02-2018","date_published_timestamp":"1519513200","popularity":"19602700","collections":[{"id":"4","name":"Sinistra","slug":"sinistra"}],"topics":[{"id":"22","query":"liberieuguali"},{"id":"91","query":"civati"},{"id":"93","query":"leu"},{"id":"21","query":"\"liberi e uguali\""}],"popularity_logs":"37","tweets":{"number":"24","sentiment_average":"-0.4583","sentiment_negative":"11","sentiment_neutral":"13","sentiment_positive":"0"}},{"id":"338555","title":"Cortei ad alta tensione da Roma a Palermo: sgomberi e contusi a Milano","source":"www.repubblica.it","description":"Studenti fatti sgomberare dalla polizia a piazza Cairoli. Al via nella Capitale il corteo dell'Anpi. Preoccupazione nel capoluogo siciliano per il comizio del leader di Forza Nuova Fiore","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5yZXB1YmJsaWNhLml0L2Nyb25hY2EvMjAxOC8wMi8yNC9uZXdzL2NvcnRlaV9v\nZ2dpX2Ffcm9tYV9taWxhbm9fZV9wYWxlcm1vX2NpdHRhX2JsaW5kYXRlLTE4OTYxNDE5OC8=","tags":["forza nuova fiore"],"date_published":"2018-02-24 16:31:25","date_published_short":"24-02-2018","date_published_timestamp":"1519426800","popularity":"88471500","collections":[{"id":"1","name":"Destra","slug":"destra"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"2","query":"casapound"},{"id":"65","query":"Renzi"},{"id":"67","query":"gentiloni"},{"id":"7","query":"salvini"}],"popularity_logs":"36","tweets":{"number":"7","sentiment_average":"-1.0000","sentiment_negative":"7","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"338166","title":"Segui la programmazione di La7 in diretta Streaming dal tuo pc","source":"www.la7.it","description":"Segui la programmazione di La7 in diretta Streaming dal tuo pc, tutti i programmi della giornata e i Tg di Enrico Mentana.","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5sYTcuaXQvZGlyZXR0ZS10dg==","tags":["enrico mentana"],"date_published":"2018-02-23 09:46:10","date_published_short":"23-02-2018","date_published_timestamp":"1519340400","popularity":"61886200","collections":[{"id":"1","name":"Destra","slug":"destra"},{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"16","query":"\"forza Italia\""},{"id":"5","query":"berlusconi"},{"id":"15","query":"forzaitalia"},{"id":"31","query":"\"movimento 5 stelle\""},{"id":"69","query":"pd"},{"id":"11","query":"lega"},{"id":"7","query":"salvini"},{"id":"34","query":"\"di maio\""},{"id":"36","query":"\"luigi di maio\""},{"id":"29","query":"m5s"},{"id":"62","query":"\"di Stefano\""}],"popularity_logs":"37","tweets":{"number":"14","sentiment_average":"-0.7857","sentiment_negative":"11","sentiment_neutral":"3","sentiment_positive":"0"}},{"id":"337920","title":"Torino, esposto di Mattiello (Pd) ai pm: \"Sciogliere Casapound e Forza Nuova, tentano di riorganizzare Partito fascista\" - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"Simone Di Stefano, il leader di CasaPound, è atteso stasera a Torino. Ad attenderlo ci saranno molti antifascisti dei centri sociali, ma anche dell’Anpi e di molti partiti e movimenti di centrosinistra e sinistra. È già molto teso il clima intorno alla presentazione dei candidati locali della formazione di estrema destra e stamattina la Digos …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wMi8yMi90b3Jpbm8tZXNwb3N0\nby1kaS1tYXR0aWVsbG8tcGQtYWktcG0tc2Npb2dsaWVyZS1jYXNhcG91bmQtZS1mb3J6YS1udW92\nYS10ZW50YW5vLWRpLXJpb3JnYW5penphcmUtcGFydGl0by1mYXNjaXN0YS80MTgwNDM2Lw==","tags":["casa pound italia","casapound","davide mattiello","forza nuova","pd","torino"],"date_published":"2018-02-22 14:02:41","date_published_short":"22-02-2018","date_published_timestamp":"1519254000","popularity":"48420800","collections":[{"id":"1","name":"Destra","slug":"destra"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"2","query":"casapound"},{"id":"69","query":"pd"},{"id":"3","query":"\"forza nuova\""}],"popularity_logs":"38","tweets":{"number":"2","sentiment_average":"-1.0000","sentiment_negative":"2","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"337401","title":"Dirigente di Forza Nuova legato mani e piedi e pestato in strada - Sicilia","source":"www.ansa.it","description":"Almeno sei persone hanno accerchiato a Palermo Massimo Ursino, legandolo mani e piedi con nastro\r\nadesivo da imballaggio e pestandolo a sangue.\r\n\r\n© ANSA","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5hbnNhLml0L3NpY2lsaWEvbm90aXppZS8yMDE4LzAyLzIwL21pbGl0YW50ZS1m\nbi1sZWdhdG8tZS1wZXN0YXRvLWluLXN0cmFkYV9lOTVjYjU5YS0zNjNmLTQ2OWEtYjY3ZS00Yjkx\nZTlkZTgxNGEuaHRtbA==","tags":["forza nuova","massimo ursino","palermo"],"date_published":"2018-02-21 00:34:46","date_published_short":"21-02-2018","date_published_timestamp":"1519167600","popularity":"45400000","collections":[{"id":"4","name":"Sinistra","slug":"sinistra"},{"id":"1","name":"Destra","slug":"destra"}],"topics":[{"id":"25","query":"boldrini"},{"id":"2","query":"casapound"},{"id":"3","query":"\"forza nuova\""}],"popularity_logs":"37","tweets":{"number":"14","sentiment_average":"-0.6429","sentiment_negative":"11","sentiment_neutral":"1","sentiment_positive":"2"}},{"id":"337083","title":"Renzi: “Noi siamo il partito dell’onestà, nessuno può venire a farci la morale”","source":"www.fanpage.it","description":"Durante un comizio elettorale tenutosi a Bologna, Matteo Renzi attacca il Movimento 5 Stelle in relazione allo scandalo rimborsopoli: “Noi possiamo...","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuZmFucGFnZS5pdC9yZW56aS1ub2ktc2lhbW8taWwtcGFydGl0by1kZWxsLW9u\nZXN0YS1uZXNzdW5vLXB1by12ZW5pcmUtYS1mYXJjaS1sYS1tb3JhbGUv","tags":["matteo renzi","movimento 5 stelle"],"date_published":"2018-02-20 07:35:33","date_published_short":"20-02-2018","date_published_timestamp":"1519081200","popularity":"66677400","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"65","query":"Renzi"}],"popularity_logs":"37","tweets":{"number":"9","sentiment_average":"-0.1111","sentiment_negative":"3","sentiment_neutral":"4","sentiment_positive":"2"}},{"id":"337019","title":"Canone Rai, si amplia la soglia di esenzione: altri 235mila over 75 esclusi","source":"www.repubblica.it","description":"Il premier Gentiloni annuncia il decreto che aumenta la soglia di reddito (8mila euro) entro la quale non si deve pagare il balzello sulla televisione","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5yZXB1YmJsaWNhLml0L2Vjb25vbWlhLzIwMTgvMDIvMTkvbmV3cy9jYW5vbmVf\ncmFpX3NpX2FtcGxpYV9sYV9zb2dsaWFfZGlfZXNlbnppb25lX2FsdHJpXzIzNW1pbGFfb3Zlcl83\nNV9lc2NsdXNpLTE4OTIyMjQ1OC8=","tags":["paolo gentiloni"],"date_published":"2018-02-19 19:27:59","date_published_short":"19-02-2018","date_published_timestamp":"1518994800","popularity":"49386600","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"67","query":"gentiloni"}],"popularity_logs":"39","tweets":{"number":"4","sentiment_average":"0.5000","sentiment_negative":"1","sentiment_neutral":"0","sentiment_positive":"3"}},{"id":"336735","title":"Boldrini: «I gruppi che si ispirano al fascismo vanno sciolti»","source":"www.corriere.it","description":"La presidente della Camera ad una manifestazione nel quartiere Niguarda a Milano","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5jb3JyaWVyZS5pdC92aWRlby1hcnRpY29saS8yMDE4LzAyLzE4L2JvbGRyaW5p\nLWdydXBwaS1jaGUtc2ktaXNwaXJhbm8tZmFzY2lzbW8tdmFubm8tc2Npb2x0aS9iYTNlNjYwNi0x\nNGNlLTExZTgtODFmZS04Yjk0YjRlMzFmZmQuc2h0bWw/Y21waWQ9dGJkXzMzMzgzYjUxUFU=","tags":["laura boldrini","milano"],"date_published":"2018-02-18 19:59:47","date_published_short":"18-02-2018","date_published_timestamp":"1518908400","popularity":"45894200","collections":[{"id":"4","name":"Sinistra","slug":"sinistra"},{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"25","query":"boldrini"},{"id":"93","query":"leu"},{"id":"5","query":"berlusconi"}],"popularity_logs":"40","tweets":{"number":"30","sentiment_average":"-1.0000","sentiment_negative":"30","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"336244","title":"CONTENT DA USARE PER RIVARA E VASSALLO","source":"www.repubblica.it","description":"Il meccanismo del Rosatellum sembra favorire Berlusconi. Calcolando anche i collegi con lieve vantaggio la sua coalizione può arrivare a 312 seggi, ma","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5yZXB1YmJsaWNhLml0L3BvbGl0aWNhLzIwMTgvMDIvMTcvbmV3cy9jYW1lcmFf\nc2VuYXRvX2NlbnRyb2Rlc3RyYV9jZW50cm9zaW5pc3RyYV9tNXNfdmFzc2FsbG9fc3RpbWVfY29s\nbGVnaV9zaWN1cmktMTg5MDQwNzY3Lw==","tags":["gianni vassallo","rivara","silvio berlusconi"],"date_published":"2018-02-17 07:22:24","date_published_short":"17-02-2018","date_published_timestamp":"1518822000","popularity":"197406000","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"5","query":"berlusconi"},{"id":"29","query":"m5s"},{"id":"7","query":"salvini"},{"id":"9","query":"meloni"}],"popularity_logs":"41","tweets":{"number":"6","sentiment_average":"0.0000","sentiment_negative":"2","sentiment_neutral":"2","sentiment_positive":"2"}},{"id":"336113","title":"Il papà di Bea Naso: «Aveva paura di addormentarsi. Temeva di non svegliarsi»","source":"torino.corriere.it","description":"«Ma non chiamatela più bambina di pietra. Non fa onore al suo ricordo»","url":"https://api.elezioni.io/click?u=aHR0cDovL3Rvcmluby5jb3JyaWVyZS5pdC9jcm9uYWNhLzE4X2ZlYmJyYWlvXzE2L2JlYS1uYXNv\nLXBhcGEtYXZldmEtcGF1cmEtYWRkb3JtZW50YXJzaS1jcmVkZXZhLW5vbi1zdmVnbGlhcnNpLXBp\ndS1iMjJmZDMyOC0xMmY4LTExZTgtYmJmNy03NWY1MGE5MTY0MTkuc2h0bWw=","tags":["potere al popolo"],"date_published":"2018-02-16 15:38:48","date_published_short":"16-02-2018","date_published_timestamp":"1518735600","popularity":"119990000","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"7","query":"salvini"}],"popularity_logs":"39","tweets":{"number":"1","sentiment_average":"-1.0000","sentiment_negative":"1","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"335800","title":"Elezioni, politica e affari: perquisizioni in corso","source":"napoli.repubblica.it","description":"Esplode uno scandalo su voto di scambio e traffico di rifiuti, nel cuore della campagna elettorale napoletana. Coinvolti  alcuni esponenti del centrodestra","url":"https://api.elezioni.io/click?u=aHR0cDovL25hcG9saS5yZXB1YmJsaWNhLml0L2Nyb25hY2EvMjAxOC8wMi8xNS9uZXdzL3BvbGl0\naWNhX2VfYWZmYXJpX3BlcnF1aXNpemlvbmlfaW5fY29yc28tMTg4OTI5NjkwLw==","tags":["centro destra","esplode"],"date_published":"2018-02-15 15:40:42","date_published_short":"15-02-2018","date_published_timestamp":"1518649200","popularity":"52339800","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"18","query":"\"fratelli d'Italia\""},{"id":"10","query":"giorgiameloni"}],"popularity_logs":"38","tweets":{"number":"36","sentiment_average":"0.6944","sentiment_negative":"5","sentiment_neutral":"1","sentiment_positive":"30"}},{"id":"335497","title":"Matteo Renzi News, ma davvero questa pagina Facebook dovrebbe aiutare il Pd?","source":"espresso.repubblica.it","description":"Il sogno di un concerto di Laura Pausini realizzato con il bonus di Renzi, Matteo e Totti capitani, le mani che vanno rimboccate, le esultanze per lo share di un'intervista. La pagina Facebook Matteo Renzi news, che si definisce non ufficiale ma è gestita anche da collaboratori del segretario del Pd, è da mesi uno dei punti di riferimento della propaganda dem sui social network. Diventata famosa per un azzardato paragone tra Renzi e Francesco Totti, durante la campagna elettorale questo spazio digitale produce a tambur battente foto e messaggi da condividere tra i 90 mila fan che la seguono e gli altri sostenitori democratici.\r\nFrasi dette dai leader dem, slogan, numeri e foto condivise in gran numero: secondo i dati dell'Espresso in questo periodo la pagina viaggia sopra i dieci post al giorno, con un tasso di engagement molto alto rispetto alla media delle pagine politiche. Numeri di tutto rispetto, ma spesso ottenuti con una comunicazione sopra le righe, che sfocia nel ridicolo e attira l'ironia del web, facendo storcere il naso a molti elettori del centrosinistra che non apprezzano il tentativo di imitare la comunicazione grillina.\r\nPiccola curosità finale: il post che ha totalizzato il maggior coinvolgimento della pagina nell'ultimo anno? Gli auguri a Maria Elena Boschi","url":"https://api.elezioni.io/click?u=aHR0cDovL2VzcHJlc3NvLnJlcHViYmxpY2EuaXQvZm90by8yMDE4LzAyLzE0L2dhbGxlcmlhL21h\ndHRlby1yZW56aS1uZXdzLW1hLWRhdnZlcm8tcXVlc3RhLXBhZ2luYS1mYWNlYm9vay1kb3ZyZWJi\nZS1haXV0YXJlLWlsLXBkLTEuMzE4Mjk1P3JlZj10d2hlJnR3aXR0ZXJfY2FyZD0yMDE4MDIxNDEy\nMzgyNA==","tags":["laura pausini","maria elena boschi","matteo renzi","pd"],"date_published":"2018-02-14 13:09:21","date_published_short":"14-02-2018","date_published_timestamp":"1518562800","popularity":"44101800","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"69","query":"pd"},{"id":"65","query":"Renzi"}],"popularity_logs":"36","tweets":{"number":"21","sentiment_average":"-1.0000","sentiment_negative":"21","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"335176","title":"M5s, Di Maio: \"Controllo sui rimborsi? Lo facciamo ora, mele marce non resteranno nel nostro gruppo parlamentare\" - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"“Mancato controllo sulle restituzioni? Lo faremo adesso”. Così il capo politico e candidato premier del Movimento 5 stelle Luigi Di Maio ha risposto alle domande del Fatto.it sui mancati controlli a campione, già promessi in passato, e sulle sue responsabilità in quanto leader. “Le mele marce con noi non restano, stiamo facendo tutte le verifiche”, ha …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wMi8xMy9tNXMtZGktbWFpby1j\nb250cm9sbG8tc3VpLXJpbWJvcnNpLWxvLWZhY2NpYW1vLW9yYS1tZWxlLW1hcmNlLW5vbi1yZXN0\nZXJhbm5vLW5lbC1ub3N0cm8tZ3J1cHBvLXBhcmxhbWVudGFyZS80MTU2OTcyLw==","tags":["luigi di maio","movimento 5 stelle"],"date_published":"2018-02-13 12:13:25","date_published_short":"13-02-2018","date_published_timestamp":"1518476400","popularity":"47502600","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"34","query":"\"di maio\""},{"id":"29","query":"m5s"},{"id":"35","query":"dimaio"}],"popularity_logs":"37","tweets":{"number":"2","sentiment_average":"-0.5000","sentiment_negative":"1","sentiment_neutral":"1","sentiment_positive":"0"}},{"id":"334785","title":"Pd all’angolo nei sondaggi. Renzi adesso teme il crollo al 20 per cento","source":"www.lastampa.it","description":"Voci su un ritorno di Veltroni in caso di disfatta. Gentiloni si spende per gli alleati. Il partito firmerà un’anagrafe antifascista e manifesterà con l’Anpi","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5sYXN0YW1wYS5pdC8yMDE4LzAyLzEyL2l0YWxpYS9wb2xpdGljYS9wZC1hbGxh\nbmdvbG8tbmVpLXNvbmRhZ2dpLXJlbnppLWFkZXNzby10ZW1lLWlsLWNyb2xsby1hbC1wZXItY2Vu\ndG8tckpMTjh6NWd4blIycWtWaWNjTXZ5SC9wYWdpbmEuaHRtbA==","tags":["matteo renzi","paolo gentiloni","pd","walter veltroni"],"date_published":"2018-02-12 07:24:32","date_published_short":"12-02-2018","date_published_timestamp":"1518390000","popularity":"107418000","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"69","query":"pd"},{"id":"65","query":"Renzi"},{"id":"66","query":"matteorenzi"}],"popularity_logs":"37","tweets":{"number":"43","sentiment_average":"-0.9535","sentiment_negative":"41","sentiment_neutral":"2","sentiment_positive":"0"}},{"id":"334753","title":"Massoneria, braccio di ferro tra M5S e candidato","source":"napoli.repubblica.it","description":"Vitiello: \"La mia iscrizione appartiene al passato, non rinuncio alla candidatura\". Linea dura del Movimento: \"Lo diffidiamo dall'utilizzo","url":"https://api.elezioni.io/click?u=aHR0cDovL25hcG9saS5yZXB1YmJsaWNhLml0L2Nyb25hY2EvMjAxOC8wMi8xMS9uZXdzL3ZpdGll\nbGxvX201c19tYXNzb25lcmlhX2NhbmRpZGF0dXJhLTE4ODYzMTQ2NS8=","tags":["movimento 5 stelle"],"date_published":"2018-02-11 21:15:22","date_published_short":"11-02-2018","date_published_timestamp":"1518303600","popularity":"59157800","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"34","query":"\"di maio\""},{"id":"29","query":"m5s"},{"id":"38","query":"dibattista"}],"popularity_logs":"32","tweets":{"number":"14","sentiment_average":"-0.5714","sentiment_negative":"8","sentiment_neutral":"6","sentiment_positive":"0"}},{"id":"334442","title":"Macerata, città blindata per il corteo antirazzismo. Sindaco: \"In strada con il cuore\"","source":"www.repubblica.it","description":"Attese migliaia di persone per la manifestazione dei centri sociali. Minniti: \"Fascismo in Italia è morto per sempre, non consentiremo a nessuno di","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5yZXB1YmJsaWNhLml0L2Nyb25hY2EvMjAxOC8wMi8xMC9uZXdzL21hY2VyYXRh\nX2NpdHRhX2JsaW5kYXRhX3Blcl9pbF9jb3J0ZW9fYW50aXJhenppc21vX3NpbmRhY29faW5fc3Ry\nYWRhX2Nvbl9pbF9jdW9yZV8tMTg4NDk4NTM3Lw==","tags":["antagonisti","macerata","marco minniti"],"date_published":"2018-02-10 12:17:13","date_published_short":"10-02-2018","date_published_timestamp":"1518217200","popularity":"65709000","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"4","name":"Sinistra","slug":"sinistra"}],"topics":[{"id":"93","query":"leu"},{"id":"91","query":"civati"},{"id":"24","query":"pietrograsso"},{"id":"26","query":"lauraboldrini"},{"id":"7","query":"salvini"},{"id":"9","query":"meloni"}],"popularity_logs":"17","tweets":{"number":"8","sentiment_average":"-0.8750","sentiment_negative":"7","sentiment_neutral":"1","sentiment_positive":"0"}},{"id":"334258","title":"Di Battista e i rincoglioniti, il povero Razzi: Palazzo, tutto il peggio della settimana","source":"espresso.repubblica.it","description":"E poi le reazioni all'attentato di Macerata, il concorso di Salvini, la grillina no-vax. Anche negli ultimi sette giorni la politica non ci ha risparmiato uscite discutibili: leggetele tutte e votate la vostra preferita","url":"https://api.elezioni.io/click?u=aHR0cDovL2VzcHJlc3NvLnJlcHViYmxpY2EuaXQvcGFsYXp6by8yMDE4LzAyLzA5L25ld3MvZGkt\nYmF0dGlzdGEtZS1pLXJpbmNvZ2xpb25pdGktaWwtcG92ZXJvLXJhenppLXBhbGF6em8tdHV0dG8t\naWwtcGVnZ2lvLWRlbGxhLXNldHRpbWFuYS0xLjMxODE0OT9yZWY9dHdoZSZ0d2l0dGVyX2NhcmQ9\nMjAxODAyMDkxNTI2MDY=","tags":["di battista","macerata","salvini"],"date_published":"2018-02-09 15:32:41","date_published_short":"09-02-2018","date_published_timestamp":"1518130800","popularity":"37452400","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"},{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"37","query":"\"di battista\""},{"id":"7","query":"salvini"}],"popularity_logs":"11","tweets":{"number":"16","sentiment_average":"-1.0000","sentiment_negative":"16","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"333828","title":"Elezioni, Di Battista: \"Nei prossimi giorni comunicheremo squadra di Governo, io non ne farò parte\" - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"“Quando Luigi Di Maio nei prossimi giorni comunicherà la squadra di Governo io non ne farò parte”. Lo ha detto Alessandro Di Battista, a margine di un comizio elettorale organizzato ad Aosta a sostegno dei candidati alle elezioni politiche del Movimento 5 Stelle. “Berlusconi? Lancia certi messaggi, parla di Ponte dello stretto, sta parlando direttamente …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wMi8wOC9lbGV6aW9uaS1kaS1i\nYXR0aXN0YS1uZWktcHJvc3NpbWktZ2lvcm5pLWNvbXVuaWNoZXJlbW8tc3F1YWRyYS1kaS1nb3Zl\ncm5vLWlvLW5vbi1uZS1mYXJvLXBhcnRlLzQxNDUwNzAv","tags":["alessandro di battista","movimento 5 stelle"],"date_published":"2018-02-08 09:17:36","date_published_short":"08-02-2018","date_published_timestamp":"1518044400","popularity":"10512000","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"37","query":"\"di battista\""},{"id":"38","query":"dibattista"}],"popularity_logs":"4","tweets":{"number":"6","sentiment_average":"0.5000","sentiment_negative":"1","sentiment_neutral":"1","sentiment_positive":"4"}},{"id":"333540","title":"Nuove minacce omofobe contro Cerno su Twitter","source":"www.repubblica.it","description":"A tre anni di distanza da un simile episodio, l'ex condirettore di Repubblica ora candidato con il Pd ha ricevuto un tweet con la foto di un patibolo","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5yZXB1YmJsaWNhLml0L3BvbGl0aWNhLzIwMTgvMDIvMDcvbmV3cy9udW92ZV9t\naW5hY2NlX29tb2ZvYmVfY29udHJvX2Nlcm5vX3N1X3R3aXR0ZXItMTg4MjMyMjcwLw==","tags":["pd","tommaso cerno"],"date_published":"2018-02-07 10:38:49","date_published_short":"07-02-2018","date_published_timestamp":"1517958000","popularity":"20418100","collections":[{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"29","query":"m5s"}],"popularity_logs":"0","tweets":{"number":"1","sentiment_average":"-1.0000","sentiment_negative":"1","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"333306","title":"Renzi e Berlusconi: \"Senza maggioranza si torna al voto\". Ma uno esclude solo Lega e M5s, l'altro rifiuta il patto anti-inciucio - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"Come in Spagna. In caso di maxi-pareggio alle elezioni, si deve tornare al voto. Presumibilmente a giugno. Non c’è alternativa. Lo giura Silvio Berlusconi. Lo riprende Matteo Renzi. Lo ribadisce Giorgia Meloni. Lo ripete Renato Brunetta. Nessun tentativo di alleanze spurie: né governi di scopo (come ha adombrato con molte condizioni Luigi Di Maio) né governi del …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wMi8wNi9yZW56aS1lLWJlcmx1\nc2Nvbmktc2VuemEtbWFnZ2lvcmFuemEtc2ktdG9ybmEtYWwtdm90by1tYS11bm8tZXNjbHVkZS1z\nb2xvLWxlZ2EtZS1tNXMtbGFsdHJvLXJpZml1dGEtaWwtcGF0dG8tYW50aS1pbmNpdWNpby80MTM5\nODY4Lw==","tags":["giorgia meloni","lega","luigi di maio","matteo renzi","movimento 5 stelle","renato brunetta","silvio berlusconi"],"date_published":"2018-02-06 13:55:50","date_published_short":"06-02-2018","date_published_timestamp":"1517871600","popularity":"6052210","collections":[{"id":"1","name":"Destra","slug":"destra"},{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"65","query":"Renzi"},{"id":"11","query":"lega"},{"id":"29","query":"m5s"},{"id":"69","query":"pd"},{"id":"5","query":"berlusconi"},{"id":"2","query":"casapound"},{"id":"4","query":"forzanuova"}],"popularity_logs":"0","tweets":{"number":"3","sentiment_average":"-0.6667","sentiment_negative":"2","sentiment_neutral":"1","sentiment_positive":"0"}},{"id":"333127","title":"Sanremo 2018, Anzaldi (Pd): \"Scanzi in giuria? Viola la par condicio\". Il giornalista: \"Scelto da Baglioni. Polemica inutile\" - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"Attacca la scelta di includere il giornalista Andrea Scanzi nella giuria di qualità del Festival di Sanremo. Il motivo? La presenza della firma del Fatto Quotidiano porrebbe addirittura problemi di conflitto d’interessi e violerebbe la par condicio. Almeno secondo Michele Anzaldi, deputato del Pd e componente uscente della commissione Vigilanza.  “La scelta di far rappresentare il …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wMi8wNS9zYW5yZW1vLTIwMTgt\nYW56YWxkaS1wZC1zY2FuemktaW4tZ2l1cmlhLXZpb2xhLWxhLXBhci1jb25kaWNpby1pbC1naW9y\nbmFsaXN0YS1zY2VsdG8tZGEtYmFnbGlvbmktcG9sZW1pY2EtaW51dGlsZS80MTM4NTA4Lw==","tags":["andrea scanzi","michele anzaldi","pd"],"date_published":"2018-02-05 22:41:37","date_published_short":"05-02-2018","date_published_timestamp":"1517785200","popularity":"1218620","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"69","query":"pd"}],"popularity_logs":"0","tweets":{"number":"1","sentiment_average":"-1.0000","sentiment_negative":"1","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"332821","title":"Mafia Capitale, da Buzzi 5mila euro alla fondazione di Renzi e 15mila al Pd - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"Per partecipare alla cena con Renzi “ho versato 15mila euro al Pd e 5mila alla Leopolda”. Salvatore Buzzi, sodale di Massimo Carminati nel Mondo di mezzo, fa il conto di quanto gli è costato sedersi a tavola a poca distanza dal premier. Lo dice lui stesso nel corso di una telefonata intercettata due giorni dopo …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxNS8wNi8xMS9tYWZpYS1jYXBpdGFs\nZS1kYS1idXp6aS01bWlsYS1ldXJvLWFsbGEtZm9uZGF6aW9uZS1yZW56aS1lLTE1bWlsYS1hbC1w\nZC8xNzY5NzUxLw==","tags":["pd"],"date_published":"2018-02-04 19:47:40","date_published_short":"04-02-2018","date_published_timestamp":"1517698800","popularity":"2206","collections":[{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"}],"topics":[{"id":"66","query":"matteorenzi"},{"id":"69","query":"pd"},{"id":"65","query":"Renzi"}],"popularity_logs":"0","tweets":{"number":"47","sentiment_average":"-0.8085","sentiment_negative":"39","sentiment_neutral":"7","sentiment_positive":"1"}},{"id":"332492","title":"Macerata, Forza Nuova: \"Pieno sostegno a Luca Traini\". Salvini: \"Immigrazione incontrollata porta a scontro sociale\" - Il Fatto Quotidiano","source":"www.ilfattoquotidiano.it","description":"“Sarà politicamente scorretto, sarà sconveniente, in campagna elettorale nessuno farà un passo avanti, ma oggi noi ci schieriamo con Luca Traini“. Il messaggio che arriva da Forza Nuova è chiarissimo: pieno sostegno all’autore della sparatoria di Macerata, dove il 28enne ha sparato in strada ad alcuni immigrati, ferendone sei. Un sostegno non solo verbale, come …","url":"https://api.elezioni.io/click?u=aHR0cHM6Ly93d3cuaWxmYXR0b3F1b3RpZGlhbm8uaXQvMjAxOC8wMi8wMy9tYWNlcmF0YS1mb3J6\nYS1udW92YS1kaWZlbmRlLWxhdXRvcmUtZGVsbGEtc3BhcmF0b3JpYS1waWVuby1zb3N0ZWduby1h\nLWx1Y2EtdHJhaW5pLzQxMzQ5MzMv","tags":["forza nuova","matteo salvini","lega","luca traini","macerata"],"date_published":"2018-02-03 15:33:36","date_published_short":"03-02-2018","date_published_timestamp":"1517612400","popularity":"15685","collections":[{"id":"1","name":"Destra","slug":"destra"},{"id":"3","name":"Centro Sinistra","slug":"centro-sinistra"},{"id":"2","name":"Centro Destra","slug":"centro-destra"}],"topics":[{"id":"3","query":"\"forza nuova\""},{"id":"4","query":"forzanuova"},{"id":"68","query":"paologentiloni"},{"id":"66","query":"matteorenzi"},{"id":"7","query":"salvini"}],"popularity_logs":"0","tweets":{"number":"118","sentiment_average":"-0.7034","sentiment_negative":"96","sentiment_neutral":"9","sentiment_positive":"13"}},{"id":"332257","title":"\"M5S e Lega cavalcano fanatismo e minacce dei no-vax\"","source":"www.huffingtonpost.it","description":"\"Ho ricevuto minacce di tutti i tipi. L'ultima è uno spettacolo in cui mi si paragona a Mengele, con i gemelli in gabbia\"","url":"https://api.elezioni.io/click?u=aHR0cDovL3d3dy5odWZmaW5ndG9ucG9zdC5pdC8yMDE4LzAyLzAyL201cy1lLWxlZ2EtY2F2YWxj\nYW5vLWZhbmF0aXNtby1lLW1pbmFjY2UtZGVpLW5vLXZheC1pbnRlcnZpc3RhLWFsbGEtbWluaXN0\ncmEtYmVhdHJpY2UtbG9yZW56aW5fYV8yMzM1MTE5NC8/dXRtX2hwX3JlZj1pdC1ob21lcGFnZQ==","tags":["lega","movimento 5 stelle"],"date_published":"2018-02-02 15:51:01","date_published_short":"02-02-2018","date_published_timestamp":"1517526000","popularity":"3547.5","collections":[{"id":"2","name":"Centro Destra","slug":"centro-destra"},{"id":"5","name":"Movimento 5 Stelle","slug":"m5s"}],"topics":[{"id":"11","query":"lega"},{"id":"29","query":"m5s"},{"id":"31","query":"\"movimento 5 stelle\""}],"popularity_logs":"0","tweets":{"number":"42","sentiment_average":"-1.0000","sentiment_negative":"42","sentiment_neutral":"0","sentiment_positive":"0"}},{"id":"331909","title":"Casapound candida i violenti a processo: 'Portate mazze e bombe, lo dice Iannone'","source":"espresso.repubblica.it","description":"Emmanuela Florino e Giuseppe Savuto, esponenti neofascisti che oggi corrono in Campania, sono accusati di associazione sovversiva. Dalle intercettazioni emerge come organizzavano le azioni di guerriglia: «Napoli deve avere caschi, bombe a mano, picconi». Ma nonostante gli arresti, non sono mai stati allontanati. Anzi","url":"https://api.elezioni.io/click?u=aHR0cDovL2VzcHJlc3NvLnJlcHViYmxpY2EuaXQvYXR0dWFsaXRhLzIwMTgvMDIvMDEvbmV3cy9t\nYXp6ZS1lLWJvbWJlLWxvLWhhLWRldHRvLWlhbm5vbmUtYS1wcm9jZXNzby1pLXZpb2xlbnRpLWRp\nLWNhc2Fwb3VuZC1vZ2dpLWNhbmRpZGF0aS0xLjMxNzgxNj9yZWY9dHdoZSZ0d2l0dGVyX2NhcmQ9\nMjAxODAyMDExMzQyNDA=","tags":["casapound"],"date_published":"2018-02-01 13:44:18","date_published_short":"01-02-2018","date_published_timestamp":"1517439600","popularity":"1503","collections":[{"id":"1","name":"Destra","slug":"destra"}],"topics":[{"id":"2","query":"casapound"}],"popularity_logs":"0","tweets":{"number":"36","sentiment_average":"-1.0000","sentiment_negative":"36","sentiment_neutral":"0","sentiment_positive":"0"}}]}},"generated":1532614564,"message":"OK"}

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.55c2569a.js